export interface KomponenTeknik {
  id: string | number;
  lat: number;
  lng: number;
  namakomponen?: string | null;
  kategori: string;
  keterangan: string | null;
}

export interface PipaFeature {
  type: "Feature";
  properties: {
    id: number;
    jenis_pipa: string;
    keterangan: string;
    panjang?: number;
    total_panjang_jenis?: number;
  };
  geometry: {
    type: "LineString";
    coordinates: [number, number][]; // [lng, lat] dari backend
  };
}


export interface PipaGeoJSON {
  type: "FeatureCollection";
  features: PipaFeature[];
}

export const KOMPONEN_DATA: KomponenTeknik[] = [
    {
        "id": "1242",
        "lat": 0.45593,
        "lng": 121.94139,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "11",
        "lat": 0.515107659483833,
        "lng": 121.94808706778,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA TALUDUYUNU"
    },
    {
        "id": "15",
        "lat": 0.515040277380226,
        "lng": 121.948144823869,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": "BAK RESERVOAR TALUDUYUNU"
    },
    {
        "id": "16",
        "lat": 0.484090298803651,
        "lng": 121.935894699801,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 300"
    },
    {
        "id": "1628",
        "lat": 0.561951,
        "lng": 121.552702,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x50"
    },
    {
        "id": "1240",
        "lat": 0.455601,
        "lng": 121.941852,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1239",
        "lat": 0.455815,
        "lng": 121.940961,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "120",
        "lat": 0.456142433386988,
        "lng": 121.94759476243,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "121",
        "lat": 0.45697473657277,
        "lng": 121.945265173555,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "Testek Pencucian"
    },
    {
        "id": "1238",
        "lat": 0.480855,
        "lng": 121.440859,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": ""
    },
    {
        "id": "1237",
        "lat": 0.480855,
        "lng": 121.440859,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": ""
    },
    {
        "id": "1236",
        "lat": 0.456899,
        "lng": 121.940937,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1235",
        "lat": 0.456899,
        "lng": 121.940937,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1234",
        "lat": 0.457108,
        "lng": 121.940637,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1232",
        "lat": 0.45622,
        "lng": 121.937161,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1231",
        "lat": 0.45324,
        "lng": 121.95758,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "20"
    },
    {
        "id": "1230",
        "lat": 0.45206,
        "lng": 121.957172,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1229",
        "lat": 0.455885,
        "lng": 121.954495,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1228",
        "lat": 0.450979,
        "lng": 121.9525,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "50"
    },
    {
        "id": "1227",
        "lat": 0.450336,
        "lng": 121.950156,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1225",
        "lat": 0.450864,
        "lng": 121.948073,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "100"
    },
    {
        "id": "1223",
        "lat": 0.4516,
        "lng": 121.947995,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1222",
        "lat": 0.4516,
        "lng": 121.947995,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "154",
        "lat": 0.46844412719506,
        "lng": 121.94235832352,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "1221",
        "lat": 0.45148,
        "lng": 121.947956,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1220",
        "lat": 0.451728,
        "lng": 121.947932,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "100"
    },
    {
        "id": "1219",
        "lat": 0.467144,
        "lng": 121.938174,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x50"
    },
    {
        "id": "1218",
        "lat": 0.480421,
        "lng": 121.439935,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100 x 75"
    },
    {
        "id": "162",
        "lat": 0.466728147569797,
        "lng": 121.936463927206,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran"
    },
    {
        "id": "1217",
        "lat": 0.463057,
        "lng": 121.944732,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "50"
    },
    {
        "id": "1216",
        "lat": 0.464772,
        "lng": 121.944605,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "50"
    },
    {
        "id": "1215",
        "lat": 0.464772,
        "lng": 121.944605,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "50"
    },
    {
        "id": "168",
        "lat": 0.466617396189772,
        "lng": 121.947101854195,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "1568",
        "lat": 0.466067,
        "lng": 121.934709,
        "namakomponen": null,
        "kategori": "Tempat  Cuci Pipa",
        "keterangan": ""
    },
    {
        "id": "1214",
        "lat": 0.48313,
        "lng": 121.440999,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150 x 75"
    },
    {
        "id": "1213",
        "lat": 0.483017,
        "lng": 121.441391,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "Testek 6 inchi"
    },
    {
        "id": "1212",
        "lat": 0.483017,
        "lng": 121.441391,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "Testek 6 inchi"
    },
    {
        "id": "1210",
        "lat": 0.507455,
        "lng": 121.369645,
        "namakomponen": null,
        "kategori": "SPL",
        "keterangan": "Persatuan"
    },
    {
        "id": "1207",
        "lat": 0.528502,
        "lng": 121.863376,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x75"
    },
    {
        "id": "1206",
        "lat": 0.506912,
        "lng": 121.862111,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "100"
    },
    {
        "id": "1205",
        "lat": 0.502049,
        "lng": 121.871392,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "1204",
        "lat": 0.499096,
        "lng": 121.891564,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "75"
    },
    {
        "id": "1203",
        "lat": 0.501186,
        "lng": 121.869106,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "190",
        "lat": 0.478168593879328,
        "lng": 121.932920583804,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "191",
        "lat": 0.478976306836064,
        "lng": 121.933533137044,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 100"
    },
    {
        "id": "1593",
        "lat": 0.458261,
        "lng": 121.927721,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x50"
    },
    {
        "id": "1201",
        "lat": 0.502674,
        "lng": 121.882166,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x50"
    },
    {
        "id": "1200",
        "lat": 0.501223,
        "lng": 121.868589,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "75"
    },
    {
        "id": "1199",
        "lat": 0.530732,
        "lng": 121.836602,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "75"
    },
    {
        "id": "1198",
        "lat": 0.533665,
        "lng": 121.841458,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "150"
    },
    {
        "id": "1197",
        "lat": 0.533697,
        "lng": 121.841374,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "150"
    },
    {
        "id": "1277",
        "lat": 0.482058,
        "lng": 121.939729,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "300"
    },
    {
        "id": "226",
        "lat": 0.478077220480818,
        "lng": 121.932837432158,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 300"
    },
    {
        "id": "1590",
        "lat": 0.526225,
        "lng": 121.95196,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": ""
    },
    {
        "id": "229",
        "lat": 0.526535777573588,
        "lng": 121.951791649963,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA HULAWA.36"
    },
    {
        "id": "230",
        "lat": 0.526300796169828,
        "lng": 121.952152691267,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA HULAWA 20"
    },
    {
        "id": "247",
        "lat": 0.485375576177799,
        "lng": 121.935772904689,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 200 x 150 RPR 150"
    },
    {
        "id": "249",
        "lat": 0.485316525862925,
        "lng": 121.935790811787,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "H .Y X150"
    },
    {
        "id": "250",
        "lat": 0.491490169372709,
        "lng": 121.933873945068,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": "Sumur Pompa PDAM"
    },
    {
        "id": "252",
        "lat": 0.491505131393515,
        "lng": 121.93342601957,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "253",
        "lat": 0.500654348666671,
        "lng": 121.935668455841,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "255",
        "lat": 0.510614717075484,
        "lng": 121.945042840599,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "257",
        "lat": 0.513269227739945,
        "lng": 121.948005481839,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "258",
        "lat": 0.514046285213901,
        "lng": 121.951868327116,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 25"
    },
    {
        "id": "260",
        "lat": 0.514165976377158,
        "lng": 121.951976797232,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 25"
    },
    {
        "id": "1196",
        "lat": 0.529085,
        "lng": 121.83398,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": ""
    },
    {
        "id": "1195",
        "lat": 0.520269,
        "lng": 121.814672,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "50"
    },
    {
        "id": "1194",
        "lat": 0.520218,
        "lng": 121.813886,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x50"
    },
    {
        "id": "1589",
        "lat": 0.521654,
        "lng": 121.955494,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1193",
        "lat": 0.496559,
        "lng": 121.830783,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "50"
    },
    {
        "id": "266",
        "lat": 0.491221741433165,
        "lng": 121.932605530529,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "1192",
        "lat": 0.497314,
        "lng": 121.830083,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x50"
    },
    {
        "id": "270",
        "lat": 0.498047202720424,
        "lng": 121.934201992649,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 200 x 50"
    },
    {
        "id": "271",
        "lat": 0.47721694024491,
        "lng": 121.934927352079,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 50"
    },
    {
        "id": "1191",
        "lat": 0.54351,
        "lng": 121.571235,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "50"
    },
    {
        "id": "273",
        "lat": 0.480683360382513,
        "lng": 121.925878597444,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 100 x 25"
    },
    {
        "id": "274",
        "lat": 0.478965553333115,
        "lng": 121.933517240562,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "275",
        "lat": 0.486050360460457,
        "lng": 121.935689343481,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": "Sumur Pompa PDAM"
    },
    {
        "id": "276",
        "lat": 0.467640508448349,
        "lng": 121.931324727708,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "1190",
        "lat": 0.541505,
        "lng": 121.57132,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "75"
    },
    {
        "id": "1511",
        "lat": 0.540592,
        "lng": 121.571633,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1645",
        "lat": 0.466951,
        "lng": 121.937846,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "283",
        "lat": 0.456563360522423,
        "lng": 121.937806032898,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "288",
        "lat": 0.475226624012431,
        "lng": 121.940388453576,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "289",
        "lat": 0.468750660618868,
        "lng": 121.937359046374,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100 + Reduser 150 x 100"
    },
    {
        "id": "291",
        "lat": 0.458669314584394,
        "lng": 121.947879822515,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1224",
        "lat": 0.450864,
        "lng": 121.948073,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "100"
    },
    {
        "id": "1188",
        "lat": 0.539012,
        "lng": 121.573474,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x50"
    },
    {
        "id": "295",
        "lat": 0.446355522039936,
        "lng": 121.938968454374,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "296",
        "lat": 0.446864651232335,
        "lng": 121.938117460562,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 50"
    },
    {
        "id": "1209",
        "lat": 0.481535,
        "lng": 121.346747,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": "75x50"
    },
    {
        "id": "1186",
        "lat": 0.550881,
        "lng": 121.571838,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "75"
    },
    {
        "id": "1185",
        "lat": 0.550881,
        "lng": 121.571838,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "75"
    },
    {
        "id": "300",
        "lat": 0.448969143336732,
        "lng": 121.939532014232,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "1184",
        "lat": 0.550881,
        "lng": 121.571838,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "75"
    },
    {
        "id": "302",
        "lat": 0.458812231070096,
        "lng": 121.937125638121,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1183",
        "lat": 0.510783,
        "lng": 121.475558,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": ""
    },
    {
        "id": "1641",
        "lat": 0.471116,
        "lng": 121.955323,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "306",
        "lat": 0.469528075739467,
        "lng": 121.946641405941,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1627",
        "lat": 0.451607,
        "lng": 121.937004,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1181",
        "lat": 0.563572,
        "lng": 121.567853,
        "namakomponen": null,
        "kategori": "KTR Pdam",
        "keterangan": ""
    },
    {
        "id": "309",
        "lat": 0.447405399154056,
        "lng": 121.938555051251,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 40"
    },
    {
        "id": "1179",
        "lat": 0.530618,
        "lng": 121.837468,
        "namakomponen": null,
        "kategori": "KTR PDAM",
        "keterangan": ""
    },
    {
        "id": "1182",
        "lat": 0.510582,
        "lng": 121.474735,
        "namakomponen": null,
        "kategori": "KTR Pdam",
        "keterangan": ""
    },
    {
        "id": "1283",
        "lat": 0.571719,
        "lng": 122.085721,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "INTAKE DENGILO"
    },
    {
        "id": "1177",
        "lat": 0.541952,
        "lng": 121.82497,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": ""
    },
    {
        "id": "1176",
        "lat": 0.541645,
        "lng": 121.824977,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": ""
    },
    {
        "id": "1175",
        "lat": 0.541805,
        "lng": 121.825111,
        "namakomponen": null,
        "kategori": "KTR PDAM",
        "keterangan": ""
    },
    {
        "id": "1893",
        "lat": 0.4602,
        "lng": 121.960344,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100MM"
    },
    {
        "id": "1173",
        "lat": 0.529718,
        "lng": 121.415588,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150X100"
    },
    {
        "id": "318",
        "lat": 0.462528268578149,
        "lng": 121.947447921486,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1172",
        "lat": 0.528034,
        "lng": 121.415341,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1171",
        "lat": 0.528034,
        "lng": 121.415341,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "321",
        "lat": 0.466221597113184,
        "lng": 121.943504673897,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 75"
    },
    {
        "id": "322",
        "lat": 0.464171644201832,
        "lng": 121.943795252641,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "1170",
        "lat": 0.531778,
        "lng": 121.413453,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "150"
    },
    {
        "id": "1169",
        "lat": 0.531853,
        "lng": 121.413361,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "200X150"
    },
    {
        "id": "326",
        "lat": 0.529920793284447,
        "lng": 121.938908018344,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stopkran 75"
    },
    {
        "id": "1168",
        "lat": 0.511195,
        "lng": 122.072268,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": "IKK PAGUAT"
    },
    {
        "id": "1167",
        "lat": 0.499105,
        "lng": 122.073772,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "PAGUAT"
    },
    {
        "id": "329",
        "lat": 0.527485247955356,
        "lng": 121.921073866103,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "330",
        "lat": 0.524628199659183,
        "lng": 121.92953844447,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "1166",
        "lat": 0.499105,
        "lng": 122.073772,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "PAGUAT"
    },
    {
        "id": "1165",
        "lat": 0.633387,
        "lng": 121.814387,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1164",
        "lat": 0.635835,
        "lng": 121.813665,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 20 TALUDITY"
    },
    {
        "id": "341",
        "lat": 0.474231645456143,
        "lng": 121.942488040151,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1163",
        "lat": 0.635846,
        "lng": 121.813827,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": "IKK TALUDITY"
    },
    {
        "id": "1162",
        "lat": 0.634574,
        "lng": 121.813969,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": "TALUDITY"
    },
    {
        "id": "1226",
        "lat": 0.450914,
        "lng": 121.947991,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "100"
    },
    {
        "id": "1161",
        "lat": 0.654091,
        "lng": 121.826711,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "TALUDITY"
    },
    {
        "id": "1160",
        "lat": 0.524091,
        "lng": 121.790214,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1159",
        "lat": 0.52492,
        "lng": 121.797518,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150X100"
    },
    {
        "id": "1158",
        "lat": 0.520041,
        "lng": 121.813751,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1157",
        "lat": 0.520041,
        "lng": 121.813751,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1156",
        "lat": 0.531327,
        "lng": 121.82102,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100X50"
    },
    {
        "id": "1250",
        "lat": 0.466336,
        "lng": 121.946997,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "150"
    },
    {
        "id": "1901",
        "lat": 0.465524,
        "lng": 121.962802,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100 x 50"
    },
    {
        "id": "366",
        "lat": 0.491599382260516,
        "lng": 121.933448147548,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "1155",
        "lat": 0.532584,
        "lng": 121.81618,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "370",
        "lat": 0.521590101304328,
        "lng": 121.955042013116,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "1154",
        "lat": 0.529769,
        "lng": 121.815121,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1153",
        "lat": 0.529372,
        "lng": 121.814813,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "374",
        "lat": 0.467172156126206,
        "lng": 121.950134511795,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 50"
    },
    {
        "id": "376",
        "lat": 0.485368095480095,
        "lng": 121.935772904689,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1152",
        "lat": 0.528632,
        "lng": 121.814236,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1151",
        "lat": 0.527647,
        "lng": 121.813636,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "150X50"
    },
    {
        "id": "1760",
        "lat": 0.527284,
        "lng": 121.804352,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x50"
    },
    {
        "id": "393",
        "lat": 0.521575139908921,
        "lng": 121.954984037709,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 200 x100"
    },
    {
        "id": "394",
        "lat": 0.515011399335823,
        "lng": 121.948987100164,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK Y"
    },
    {
        "id": "1591",
        "lat": 0.508053,
        "lng": 121.94201,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "200x150"
    },
    {
        "id": "396",
        "lat": 0.496963373616429,
        "lng": 121.935566029027,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "397",
        "lat": 0.53845029521314,
        "lng": 121.970496000976,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "398",
        "lat": 0.538816406067658,
        "lng": 121.970212121186,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 350 H"
    },
    {
        "id": "399",
        "lat": 0.551570983188623,
        "lng": 121.968635550509,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 250 x 200"
    },
    {
        "id": "400",
        "lat": 0.478082831004096,
        "lng": 121.932857302761,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 150 x 100"
    },
    {
        "id": "401",
        "lat": 0.478072545044754,
        "lng": 121.932852159782,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "402",
        "lat": 0.487657086667525,
        "lng": 121.934977394102,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x150"
    },
    {
        "id": "403",
        "lat": 0.46996440382127,
        "lng": 121.942595534766,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "404",
        "lat": 0.469971884518973,
        "lng": 121.94243656994,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "405",
        "lat": 0.467456499916153,
        "lng": 121.936786772999,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "406",
        "lat": 0.466508321482228,
        "lng": 121.94697922362,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "407",
        "lat": 0.4663689934875,
        "lng": 121.947084888475,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 300 x 150"
    },
    {
        "id": "408",
        "lat": 0.466589674069754,
        "lng": 121.946965197312,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "411",
        "lat": 0.468644995763807,
        "lng": 121.962169715395,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 150 x 100"
    },
    {
        "id": "412",
        "lat": 0.469844946429869,
        "lng": 121.961744952031,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "1900",
        "lat": 0.465482,
        "lng": 121.962679,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x50"
    },
    {
        "id": "414",
        "lat": 0.462522979780662,
        "lng": 121.947351388331,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 300 x 100"
    },
    {
        "id": "1148",
        "lat": 0.569391,
        "lng": 121.569927,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": "IKK LEMITO"
    },
    {
        "id": "1774",
        "lat": 0.507104,
        "lng": 121.369502,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1616",
        "lat": 0.450003,
        "lng": 121.948605,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "419",
        "lat": 0.464301983203288,
        "lng": 121.935996624305,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1696",
        "lat": 0.566752,
        "lng": 121.649466,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x75"
    },
    {
        "id": "1513",
        "lat": 0.564227,
        "lng": 121.567571,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x75"
    },
    {
        "id": "422",
        "lat": 0.451646720268332,
        "lng": 121.93919361546,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 50"
    },
    {
        "id": "423",
        "lat": 0.458883854119745,
        "lng": 121.959628382124,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 100 x 75"
    },
    {
        "id": "424",
        "lat": 0.45858065209089,
        "lng": 121.947651551327,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 300 x 100"
    },
    {
        "id": "1269",
        "lat": 0.456366,
        "lng": 121.937103,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1268",
        "lat": 0.456472,
        "lng": 121.937064,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "427",
        "lat": 0.456549642664376,
        "lng": 121.937744302306,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "1579",
        "lat": 0.459633,
        "lng": 121.947593,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "429",
        "lat": 0.473341003747216,
        "lng": 121.947169046325,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "1567",
        "lat": 0.456982,
        "lng": 121.945284,
        "namakomponen": null,
        "kategori": "Tempat  Cuci Pipa",
        "keterangan": ""
    },
    {
        "id": "431",
        "lat": 0.478672871035424,
        "lng": 121.94747949528,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 50"
    },
    {
        "id": "432",
        "lat": 0.473425161596381,
        "lng": 121.947053095511,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "433",
        "lat": 0.475164423812457,
        "lng": 121.940285869351,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "434",
        "lat": 0.475126085236727,
        "lng": 121.940412106125,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 50"
    },
    {
        "id": "1471",
        "lat": 0.477326,
        "lng": 122.07875,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "436",
        "lat": 0.4750952273587,
        "lng": 121.940544888509,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "437",
        "lat": 0.483112665122484,
        "lng": 121.94296676439,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1469",
        "lat": 0.478148,
        "lng": 122.076507,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "439",
        "lat": 0.483309968524416,
        "lng": 121.943030350321,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1467",
        "lat": 0.478349,
        "lng": 122.077437,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "441",
        "lat": 0.466697209099248,
        "lng": 121.946955846441,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 50"
    },
    {
        "id": "442",
        "lat": 0.473951966350176,
        "lng": 121.943475573133,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "443",
        "lat": 0.467122226594008,
        "lng": 121.937862211912,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "445",
        "lat": 0.466508157428077,
        "lng": 121.936244653485,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "446",
        "lat": 0.449973370364809,
        "lng": 121.939366131642,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "447",
        "lat": 0.536679603659607,
        "lng": 121.972363568648,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "448",
        "lat": 0.534143647138103,
        "lng": 121.979107417628,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "449",
        "lat": 0.530025523052296,
        "lng": 121.938997786716,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": "Tee Y 75 x 50"
    },
    {
        "id": "450",
        "lat": 0.53262132515543,
        "lng": 121.941933960565,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "451",
        "lat": 0.532763458411798,
        "lng": 121.94204617103,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 50"
    },
    {
        "id": "452",
        "lat": 0.525585728965238,
        "lng": 121.924451570032,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "453",
        "lat": 0.525473518499685,
        "lng": 121.924356191136,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "454",
        "lat": 0.525454816755426,
        "lng": 121.924350580613,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1141",
        "lat": 0.561962,
        "lng": 121.552611,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "456",
        "lat": 0.532466100678082,
        "lng": 121.966163940427,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": "Tee Y 100 x 50"
    },
    {
        "id": "457",
        "lat": 0.537440764650946,
        "lng": 121.970375573234,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "1140",
        "lat": 0.562614,
        "lng": 121.562342,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1604",
        "lat": 0.538986,
        "lng": 121.970216,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "350"
    },
    {
        "id": "1607",
        "lat": 0.487645,
        "lng": 121.943149,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1139",
        "lat": 0.553021,
        "lng": 121.571787,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X100"
    },
    {
        "id": "1608",
        "lat": 0.486053,
        "lng": 121.943755,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1602",
        "lat": 0.534843,
        "lng": 121.969401,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "300x50"
    },
    {
        "id": "1138",
        "lat": 0.552948,
        "lng": 121.571695,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X100"
    },
    {
        "id": "1609",
        "lat": 0.483533,
        "lng": 121.941689,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1137",
        "lat": 0.550911,
        "lng": 121.571999,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "467",
        "lat": 0.533636829868689,
        "lng": 121.956974838385,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "468",
        "lat": 0.52153960659483,
        "lng": 121.956601738587,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "469",
        "lat": 0.52148911188533,
        "lng": 121.956556854401,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "470",
        "lat": 0.517898376987625,
        "lng": 121.957095464636,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "1606",
        "lat": 0.499567,
        "lng": 121.947271,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1136",
        "lat": 0.548745,
        "lng": 121.570383,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "473",
        "lat": 0.503037970999515,
        "lng": 121.949480114374,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1135",
        "lat": 0.548745,
        "lng": 121.570383,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "475",
        "lat": 0.521947304619674,
        "lng": 121.957136608473,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "476",
        "lat": 0.523078760147337,
        "lng": 121.958505576153,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "1134",
        "lat": 0.548745,
        "lng": 121.570383,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1202",
        "lat": 0.499126,
        "lng": 121.891519,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "479",
        "lat": 0.517703878847333,
        "lng": 121.94652897913,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "1131",
        "lat": 0.529084,
        "lng": 121.833713,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "PATILANGGIO"
    },
    {
        "id": "481",
        "lat": 0.513397802231725,
        "lng": 121.948048495851,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 200 x 50"
    },
    {
        "id": "482",
        "lat": 0.513500661825149,
        "lng": 121.947900752071,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1130",
        "lat": 0.530665,
        "lng": 121.837278,
        "namakomponen": null,
        "kategori": "Pompa",
        "keterangan": "RUMAH PUMPA PATILANGGIO"
    },
    {
        "id": "1129",
        "lat": 0.530753,
        "lng": 121.837362,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": "PATILANGGIO"
    },
    {
        "id": "1126",
        "lat": 0.541334,
        "lng": 121.824987,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "JEMBATAN RANDANGAN"
    },
    {
        "id": "487",
        "lat": 0.5114598339829,
        "lng": 121.946010940814,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "488",
        "lat": 0.504316702763225,
        "lng": 121.938750923692,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "489",
        "lat": 0.500365959288539,
        "lng": 121.935508041238,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 100 x 50"
    },
    {
        "id": "1125",
        "lat": 0.536632,
        "lng": 121.816497,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100"
    },
    {
        "id": "491",
        "lat": 0.500435155742297,
        "lng": 121.935458481616,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 50"
    },
    {
        "id": "492",
        "lat": 0.495806474038226,
        "lng": 121.935677292023,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1029",
        "lat": 0.495777,
        "lng": 121.935791,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "testek dm50"
    },
    {
        "id": "1031",
        "lat": 0.46802,
        "lng": 121.925691,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1032",
        "lat": 0.468396,
        "lng": 121.923223,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": ""
    },
    {
        "id": "1055",
        "lat": 0.571111,
        "lng": 121.569402,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 20 IKK LEMITO"
    },
    {
        "id": "497",
        "lat": 0.49389515577497,
        "lng": 121.932694363814,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "498",
        "lat": 0.494240202956546,
        "lng": 121.932717740995,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "499",
        "lat": 0.48867269369068,
        "lng": 121.934341987484,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 75"
    },
    {
        "id": "500",
        "lat": 0.488511858690054,
        "lng": 121.933631321202,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "501",
        "lat": 0.488343542991724,
        "lng": 121.932872030385,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 75"
    },
    {
        "id": "503",
        "lat": 0.488384686829094,
        "lng": 121.93280657428,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1124",
        "lat": 0.527173,
        "lng": 121.813255,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "75"
    },
    {
        "id": "1123",
        "lat": 0.527218,
        "lng": 121.813259,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150X75"
    },
    {
        "id": "506",
        "lat": 0.49194456384877,
        "lng": 121.933315261724,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 50"
    },
    {
        "id": "1122",
        "lat": 0.5271,
        "lng": 121.81315,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "150"
    },
    {
        "id": "508",
        "lat": 0.485016035144465,
        "lng": 121.935840464742,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 50"
    },
    {
        "id": "509",
        "lat": 0.484103390024632,
        "lng": 121.935719838492,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 300"
    },
    {
        "id": "510",
        "lat": 0.484075337408244,
        "lng": 121.935718903405,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 300"
    },
    {
        "id": "511",
        "lat": 0.482895257345509,
        "lng": 121.937760198791,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 300 x 50"
    },
    {
        "id": "512",
        "lat": 0.483339423771657,
        "lng": 121.937361851638,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "513",
        "lat": 0.483020559032044,
        "lng": 121.937318837626,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1121",
        "lat": 0.492198,
        "lng": 121.811814,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "515",
        "lat": 0.482604445222284,
        "lng": 121.938650401817,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "516",
        "lat": 0.483191679992012,
        "lng": 121.93783407068,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1120",
        "lat": 0.491729,
        "lng": 121.811796,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "518",
        "lat": 0.482956973101564,
        "lng": 121.937777497904,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 50"
    },
    {
        "id": "1119",
        "lat": 0.491208,
        "lng": 121.811753,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "520",
        "lat": 0.484797224736637,
        "lng": 121.937444606856,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "521",
        "lat": 0.484847719446136,
        "lng": 121.937453957728,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 75"
    },
    {
        "id": "522",
        "lat": 0.484872031713672,
        "lng": 121.937465178775,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": "Meter Induk Pamsimas"
    },
    {
        "id": "523",
        "lat": 0.478077688024425,
        "lng": 121.933005747856,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "524",
        "lat": 0.478043089797546,
        "lng": 121.933087100444,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "525",
        "lat": 0.476901348310542,
        "lng": 121.935340660627,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x100"
    },
    {
        "id": "526",
        "lat": 0.476850853601043,
        "lng": 121.935323829057,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "527",
        "lat": 0.476758279966962,
        "lng": 121.935292971179,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "1118",
        "lat": 0.490701,
        "lng": 121.81172,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1761",
        "lat": 0.518625,
        "lng": 121.82896,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1116",
        "lat": 0.522388,
        "lng": 121.83056,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100X50"
    },
    {
        "id": "534",
        "lat": 0.472667974725744,
        "lng": 121.93352869538,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "535",
        "lat": 0.472372487166454,
        "lng": 121.933476330496,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "536",
        "lat": 0.475689241510764,
        "lng": 121.938223768276,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 50"
    },
    {
        "id": "537",
        "lat": 0.475306323297064,
        "lng": 121.939991083109,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "538",
        "lat": 0.474666723643411,
        "lng": 121.941843490878,
        "namakomponen": null,
        "kategori": "Pompa",
        "keterangan": "Pompa PDAM"
    },
    {
        "id": "539",
        "lat": 0.476672485715175,
        "lng": 121.940737282705,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "540",
        "lat": 0.476723915511887,
        "lng": 121.940772816019,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": "Tee Y 50"
    },
    {
        "id": "541",
        "lat": 0.479934069913922,
        "lng": 121.942282981868,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "542",
        "lat": 0.479399667571725,
        "lng": 121.946565681303,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 300 x 150"
    },
    {
        "id": "543",
        "lat": 0.479362264083207,
        "lng": 121.946736802263,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": "Tee Y 150 x 50"
    },
    {
        "id": "544",
        "lat": 0.479380965827466,
        "lng": 121.94664048828,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "545",
        "lat": 0.479394057048448,
        "lng": 121.946647968978,
        "namakomponen": null,
        "kategori": "Pompa",
        "keterangan": "Pompa Booster"
    },
    {
        "id": "546",
        "lat": 0.477993296403458,
        "lng": 121.952520316675,
        "namakomponen": "",
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "547",
        "lat": 0.478273822567341,
        "lng": 121.95359566697,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "548",
        "lat": 0.478079324427049,
        "lng": 121.953711617784,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "549",
        "lat": 0.47814945596802,
        "lng": 121.953769593192,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "550",
        "lat": 0.482751020142914,
        "lng": 121.955384488808,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "1763",
        "lat": 0.490198,
        "lng": 121.809624,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1585",
        "lat": 0.466905,
        "lng": 121.958472,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "554",
        "lat": 0.46171903854939,
        "lng": 121.961983866814,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 75"
    },
    {
        "id": "1114",
        "lat": 0.496394,
        "lng": 121.829903,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "556",
        "lat": 0.461695661369066,
        "lng": 121.962082050971,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x100"
    },
    {
        "id": "1113",
        "lat": 0.505429,
        "lng": 121.827655,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "558",
        "lat": 0.46170314206677,
        "lng": 121.961964229982,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "559",
        "lat": 0.465752537242422,
        "lng": 121.962734274302,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "1112",
        "lat": 0.497232,
        "lng": 121.830069,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "561",
        "lat": 0.466178937011524,
        "lng": 121.963002644332,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1128",
        "lat": 0.530791,
        "lng": 121.837492,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 20 PATILANGGIO"
    },
    {
        "id": "1127",
        "lat": 0.541684,
        "lng": 121.824643,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": ""
    },
    {
        "id": "1586",
        "lat": 0.479622,
        "lng": 121.946212,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1109",
        "lat": 0.540811,
        "lng": 121.573253,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x50"
    },
    {
        "id": "566",
        "lat": 0.471076923832923,
        "lng": 121.957462953911,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "567",
        "lat": 0.473818599541273,
        "lng": 121.95609772658,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "568",
        "lat": 0.473366017330208,
        "lng": 121.956385733442,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1564",
        "lat": 0.467501,
        "lng": 121.954356,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "570",
        "lat": 0.485319704716871,
        "lng": 121.92327148997,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "572",
        "lat": 0.485340276635556,
        "lng": 121.923299542586,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 75"
    },
    {
        "id": "573",
        "lat": 0.485358978379815,
        "lng": 121.923325725028,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": "Meter 75"
    },
    {
        "id": "1510",
        "lat": 0.563264,
        "lng": 122.09356,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR DM150"
    },
    {
        "id": "575",
        "lat": 0.486555890012383,
        "lng": 121.922441132524,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "576",
        "lat": 0.481751411912279,
        "lng": 121.925152885442,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 100 x75"
    },
    {
        "id": "577",
        "lat": 0.480921054467185,
        "lng": 121.923972805379,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "578",
        "lat": 0.48120532097992,
        "lng": 121.923789528286,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "579",
        "lat": 0.481235243770734,
        "lng": 121.923864335263,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "580",
        "lat": 0.481452184004137,
        "lng": 121.923639914332,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "581",
        "lat": 0.481489587492655,
        "lng": 121.923684798518,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "582",
        "lat": 0.48166912423754,
        "lng": 121.923445416191,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1107",
        "lat": 0.543536,
        "lng": 121.572931,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x50"
    },
    {
        "id": "1106",
        "lat": 0.547381,
        "lng": 121.572474,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x75"
    },
    {
        "id": "1493",
        "lat": 0.498358,
        "lng": 122.071683,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150X75"
    },
    {
        "id": "1508",
        "lat": 0.543539,
        "lng": 121.572993,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x50"
    },
    {
        "id": "1102",
        "lat": 0.541641,
        "lng": 121.571344,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Dop 50"
    },
    {
        "id": "1630",
        "lat": 0.536329,
        "lng": 121.572852,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "589",
        "lat": 0.483129730464158,
        "lng": 121.924390789363,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "590",
        "lat": 0.48233303615873,
        "lng": 121.922831063892,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "591",
        "lat": 0.480821935222613,
        "lng": 121.920440980976,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "1629",
        "lat": 0.540637,
        "lng": 121.571402,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "593",
        "lat": 0.486640047861548,
        "lng": 121.922389702728,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "594",
        "lat": 0.486591423326475,
        "lng": 121.922329857146,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "595",
        "lat": 0.486524097047143,
        "lng": 121.922359779937,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 100"
    },
    {
        "id": "596",
        "lat": 0.482058120518125,
        "lng": 121.915915158865,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "597",
        "lat": 0.485929381579711,
        "lng": 121.913158521762,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1099",
        "lat": 0.545343,
        "lng": 121.57274,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "599",
        "lat": 0.487487236876475,
        "lng": 121.914703285837,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1098",
        "lat": 0.53548,
        "lng": 121.572308,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x50"
    },
    {
        "id": "601",
        "lat": 0.481826218889315,
        "lng": 121.916696891775,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "602",
        "lat": 0.481695306679503,
        "lng": 121.916788530322,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "603",
        "lat": 0.481659773365411,
        "lng": 121.91681284259,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "604",
        "lat": 0.477848357885453,
        "lng": 121.919481581496,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "605",
        "lat": 0.476021197471362,
        "lng": 121.917848919222,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "606",
        "lat": 0.478572115388272,
        "lng": 121.918888736203,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "607",
        "lat": 0.498844806164887,
        "lng": 121.892489354007,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1840",
        "lat": 0.504896,
        "lng": 121.907062,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "610",
        "lat": 0.500606510474073,
        "lng": 121.898180294785,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "611",
        "lat": 0.500642043788165,
        "lng": 121.898206477227,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": "Meter Induk"
    },
    {
        "id": "1097",
        "lat": 0.56341,
        "lng": 121.567753,
        "namakomponen": null,
        "kategori": "manhole",
        "keterangan": "80x80"
    },
    {
        "id": "613",
        "lat": 0.497642284009041,
        "lng": 121.906137886967,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1095",
        "lat": 0.563392,
        "lng": 121.567765,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "100"
    },
    {
        "id": "615",
        "lat": 0.497709610288374,
        "lng": 121.906171550107,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": "Meter Induk"
    },
    {
        "id": "616",
        "lat": 0.497659115578875,
        "lng": 121.90604998877,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 75"
    },
    {
        "id": "617",
        "lat": 0.479005060767857,
        "lng": 121.933559319487,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 100"
    },
    {
        "id": "618",
        "lat": 0.478963916930488,
        "lng": 121.933626645766,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "619",
        "lat": 0.478938669575738,
        "lng": 121.933614489633,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "620",
        "lat": 0.480651749349851,
        "lng": 121.934737529375,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 150 x 75"
    },
    {
        "id": "621",
        "lat": 0.480672321268536,
        "lng": 121.934698255713,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": "Meter Induk"
    },
    {
        "id": "622",
        "lat": 0.480679801966239,
        "lng": 121.934681424143,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran"
    },
    {
        "id": "1093",
        "lat": 0.562171,
        "lng": 121.556854,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "624",
        "lat": 0.464036355106335,
        "lng": 121.947213700109,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "625",
        "lat": 0.46249936882858,
        "lng": 121.948956465535,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "626",
        "lat": 0.462580721416106,
        "lng": 121.948960673428,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "627",
        "lat": 0.46460526391642,
        "lng": 121.949789456545,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1092",
        "lat": 0.47711,
        "lng": 122.018425,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "GATE VALVE DM150MM"
    },
    {
        "id": "1096",
        "lat": 0.56341,
        "lng": 121.567753,
        "namakomponen": null,
        "kategori": "manhole",
        "keterangan": "80x80"
    },
    {
        "id": "630",
        "lat": 0.464095545096355,
        "lng": 121.950159296539,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1860",
        "lat": 0.462007,
        "lng": 121.953889,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "632",
        "lat": 0.463812802843124,
        "lng": 121.950178401326,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1856",
        "lat": 0.463682,
        "lng": 121.950327,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "634",
        "lat": 0.463581330992581,
        "lng": 121.951105397174,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "635",
        "lat": 0.463875007098235,
        "lng": 121.951082519822,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1863",
        "lat": 0.458296,
        "lng": 121.952569,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "637",
        "lat": 0.464186560448956,
        "lng": 121.951778968597,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "638",
        "lat": 0.464514016090529,
        "lng": 121.951755951895,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "639",
        "lat": 0.464138807979181,
        "lng": 121.951780330419,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "1861",
        "lat": 0.460053,
        "lng": 121.949624,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "641",
        "lat": 0.463785719670725,
        "lng": 121.951124123187,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "642",
        "lat": 0.463805274174742,
        "lng": 121.951798246937,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "643",
        "lat": 0.463431882671518,
        "lng": 121.95181120262,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "644",
        "lat": 0.463404188901849,
        "lng": 121.95114060694,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "645",
        "lat": 0.463847437470974,
        "lng": 121.951797374104,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "646",
        "lat": 0.463820232690628,
        "lng": 121.951132367598,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "647",
        "lat": 0.463474534957074,
        "lng": 121.95181591896,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "648",
        "lat": 0.463454980453057,
        "lng": 121.95114179521,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "649",
        "lat": 0.463128844826902,
        "lng": 121.951823635109,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "1859",
        "lat": 0.461391,
        "lng": 121.951006,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1858",
        "lat": 0.461558,
        "lng": 121.950045,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1458",
        "lat": 0.478979,
        "lng": 122.075363,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "654",
        "lat": 0.461878975397631,
        "lng": 121.95108819133,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "655",
        "lat": 0.461818822107462,
        "lng": 121.951076558198,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "656",
        "lat": 0.462034936391526,
        "lng": 121.952130537993,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "657",
        "lat": 0.462005517219689,
        "lng": 121.952679411429,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "658",
        "lat": 0.461661824853871,
        "lng": 121.952098413545,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "659",
        "lat": 0.461655670680268,
        "lng": 121.952639619604,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "660",
        "lat": 0.461990103918157,
        "lng": 121.95340446608,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "661",
        "lat": 0.461671731317206,
        "lng": 121.953370368573,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "662",
        "lat": 0.462006866369864,
        "lng": 121.953853555921,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1089",
        "lat": 0.563268,
        "lng": 121.567461,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "100"
    },
    {
        "id": "664",
        "lat": 0.462018451370928,
        "lng": 121.951861646426,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "665",
        "lat": 0.461653496200765,
        "lng": 121.95185837615,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "666",
        "lat": 0.462444598625422,
        "lng": 121.949587069421,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "667",
        "lat": 0.461860685801831,
        "lng": 121.951313661657,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "1088",
        "lat": 0.563418,
        "lng": 121.567967,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x150"
    },
    {
        "id": "669",
        "lat": 0.461675365649501,
        "lng": 121.951307699248,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1087",
        "lat": 0.563418,
        "lng": 121.567967,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x150"
    },
    {
        "id": "671",
        "lat": 0.462496335695491,
        "lng": 121.948991539782,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "672",
        "lat": 0.463976819976755,
        "lng": 121.948902845861,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "673",
        "lat": 0.464279052128341,
        "lng": 121.949090418248,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "674",
        "lat": 0.464377434629394,
        "lng": 121.949474639725,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 25"
    },
    {
        "id": "675",
        "lat": 0.464318420837801,
        "lng": 121.949089789909,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1862",
        "lat": 0.46005,
        "lng": 121.950398,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "677",
        "lat": 0.462522700898831,
        "lng": 121.948987121142,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1857",
        "lat": 0.461621,
        "lng": 121.950998,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "679",
        "lat": 0.463010729200064,
        "lng": 121.951117302669,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "680",
        "lat": 0.462757435253422,
        "lng": 121.951102855313,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "681",
        "lat": 0.46251592646099,
        "lng": 121.949935642182,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "682",
        "lat": 0.462443125321304,
        "lng": 121.950133497911,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "683",
        "lat": 0.462520884761579,
        "lng": 121.950121062887,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1490",
        "lat": 0.480814,
        "lng": 122.076264,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150X50"
    },
    {
        "id": "685",
        "lat": 0.461647682808251,
        "lng": 121.950053843318,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "686",
        "lat": 0.461613285699526,
        "lng": 121.950610192211,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 40"
    },
    {
        "id": "687",
        "lat": 0.461685409729665,
        "lng": 121.95005054264,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1084",
        "lat": 0.545457,
        "lng": 121.576452,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x75"
    },
    {
        "id": "689",
        "lat": 0.461585736975788,
        "lng": 121.951019511129,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 40"
    },
    {
        "id": "690",
        "lat": 0.461722199840098,
        "lng": 121.95103432396,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 40"
    },
    {
        "id": "691",
        "lat": 0.4620984293183,
        "lng": 121.951045759788,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "692",
        "lat": 0.46195825659916,
        "lng": 121.950103407013,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "693",
        "lat": 0.462519222546573,
        "lng": 121.950171878592,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "694",
        "lat": 0.467311337749112,
        "lng": 121.951950493106,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 75"
    },
    {
        "id": "1489",
        "lat": 0.480703,
        "lng": 122.076288,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "696",
        "lat": 0.462897897767746,
        "lng": 121.948976102182,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "697",
        "lat": 0.464102410628268,
        "lng": 121.948628546916,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "698",
        "lat": 0.464267672557153,
        "lng": 121.948875974258,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "699",
        "lat": 0.464014500857841,
        "lng": 121.948862924195,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1082",
        "lat": 0.545595,
        "lng": 121.578438,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x75"
    },
    {
        "id": "701",
        "lat": 0.464058792240778,
        "lng": 121.947824212173,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50 x 25"
    },
    {
        "id": "702",
        "lat": 0.464080552265672,
        "lng": 121.948072930396,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50 x 25"
    },
    {
        "id": "703",
        "lat": 0.464095639992884,
        "lng": 121.94834194421,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50 x 25"
    },
    {
        "id": "1081",
        "lat": 0.545325,
        "lng": 121.574479,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x100"
    },
    {
        "id": "1080",
        "lat": 0.540729,
        "lng": 121.580624,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x50"
    },
    {
        "id": "1079",
        "lat": 0.545526,
        "lng": 121.578465,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x50"
    },
    {
        "id": "707",
        "lat": 0.464095867385702,
        "lng": 121.948312356554,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "708",
        "lat": 0.46413546348799,
        "lng": 121.94828214056,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "1078",
        "lat": 0.545526,
        "lng": 121.578465,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x50"
    },
    {
        "id": "710",
        "lat": 0.464798591668066,
        "lng": 121.948280443907,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1077",
        "lat": 0.5453,
        "lng": 121.574085,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "100 Giv"
    },
    {
        "id": "1076",
        "lat": 0.545258,
        "lng": 121.572819,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x100"
    },
    {
        "id": "713",
        "lat": 0.464112375028929,
        "lng": 121.948587599402,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1075",
        "lat": 0.538869,
        "lng": 121.57137,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "4x2"
    },
    {
        "id": "715",
        "lat": 0.465277956928051,
        "lng": 121.947074115586,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 50"
    },
    {
        "id": "716",
        "lat": 0.46471870229778,
        "lng": 121.943723455452,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "717",
        "lat": 0.465243942099323,
        "lng": 121.942372297453,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "718",
        "lat": 0.462878029225031,
        "lng": 121.943976012741,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1074",
        "lat": 0.539288,
        "lng": 121.571424,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "4x2"
    },
    {
        "id": "1565",
        "lat": 0.457955,
        "lng": 121.942769,
        "namakomponen": null,
        "kategori": "Tempat  Cuci Pipa",
        "keterangan": ""
    },
    {
        "id": "722",
        "lat": 0.460569031045715,
        "lng": 121.943140336277,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 100 x 75"
    },
    {
        "id": "723",
        "lat": 0.460370588784653,
        "lng": 121.9424170957,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "724",
        "lat": 0.45882543504906,
        "lng": 121.937163906605,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "725",
        "lat": 0.458813422664763,
        "lng": 121.937167421533,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "726",
        "lat": 0.457619254455889,
        "lng": 121.94132936898,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "1514",
        "lat": 0.477091,
        "lng": 122.018429,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR PEMBUANGAN"
    },
    {
        "id": "728",
        "lat": 0.457612321750154,
        "lng": 121.941284919877,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "729",
        "lat": 0.456608011944984,
        "lng": 121.941171443224,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "730",
        "lat": 0.456055481853906,
        "lng": 121.941695683504,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1072",
        "lat": 0.540578,
        "lng": 121.571432,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "4x2"
    },
    {
        "id": "732",
        "lat": 0.457039720493953,
        "lng": 121.941374439677,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "733",
        "lat": 0.45735344769633,
        "lng": 121.941355440036,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1071",
        "lat": 0.536667,
        "lng": 121.57299,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "4x4"
    },
    {
        "id": "1070",
        "lat": 0.533427,
        "lng": 121.570807,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100"
    },
    {
        "id": "1233",
        "lat": 0.457255,
        "lng": 121.941133,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": ""
    },
    {
        "id": "737",
        "lat": 0.457582883777155,
        "lng": 121.941290311343,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "739",
        "lat": 0.467294297997247,
        "lng": 121.936725694662,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "1507",
        "lat": 0.544955,
        "lng": 121.572847,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "150"
    },
    {
        "id": "741",
        "lat": 0.467140942154624,
        "lng": 121.937810590916,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1509",
        "lat": 0.543161,
        "lng": 121.573033,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x100"
    },
    {
        "id": "743",
        "lat": 0.46193277456722,
        "lng": 121.937618571762,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "744",
        "lat": 0.461885463896867,
        "lng": 121.93793880436,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "745",
        "lat": 0.461833821363577,
        "lng": 121.938281943764,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "746",
        "lat": 0.461930896835437,
        "lng": 121.937629295957,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "747",
        "lat": 0.461883586165075,
        "lng": 121.937949528555,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "748",
        "lat": 0.461835642544266,
        "lng": 121.938271224517,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "749",
        "lat": 0.461842559970224,
        "lng": 121.938197403911,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "750",
        "lat": 0.46235353800173,
        "lng": 121.937681022931,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "751",
        "lat": 0.462313851321332,
        "lng": 121.937999884521,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "752",
        "lat": 0.462228228779283,
        "lng": 121.938308685092,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "753",
        "lat": 0.461796043273907,
        "lng": 121.938583038516,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "754",
        "lat": 0.461191962814568,
        "lng": 121.938244467866,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "755",
        "lat": 0.461561305588496,
        "lng": 121.937927740855,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "756",
        "lat": 0.461593202643396,
        "lng": 121.937584216973,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "Stop Kran 50"
    },
    {
        "id": "757",
        "lat": 0.473265373736468,
        "lng": 121.948787191707,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "758",
        "lat": 0.470078897458631,
        "lng": 121.953822157888,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "759",
        "lat": 0.470382179797909,
        "lng": 121.953812519986,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": "Meter Induk 50"
    },
    {
        "id": "1642",
        "lat": 0.472939,
        "lng": 121.955908,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1640",
        "lat": 0.470393,
        "lng": 121.954607,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1278",
        "lat": 0.470003,
        "lng": 121.950962,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": ""
    },
    {
        "id": "1852",
        "lat": 0.456017,
        "lng": 121.937159,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": ""
    },
    {
        "id": "765",
        "lat": 0.451620504311105,
        "lng": 121.939052294217,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "766",
        "lat": 0.449957555803685,
        "lng": 121.939273883992,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 25 "
    },
    {
        "id": "767",
        "lat": 0.449467846592984,
        "lng": 121.939454006889,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 50 x 25"
    },
    {
        "id": "768",
        "lat": 0.44913962072929,
        "lng": 121.93962915375,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "769",
        "lat": 0.447850824703907,
        "lng": 121.93996155502,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "770",
        "lat": 0.447683044352135,
        "lng": 121.940007209648,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "771",
        "lat": 0.447766306189534,
        "lng": 121.939945013625,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "772",
        "lat": 0.450181810940325,
        "lng": 121.939407030977,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 50 x 25"
    },
    {
        "id": "773",
        "lat": 0.44959161662688,
        "lng": 121.942123988787,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1066",
        "lat": 0.564023,
        "lng": 121.568023,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 5 LITER IKK LEMITLO Tdk terpakai"
    },
    {
        "id": "775",
        "lat": 0.447947833349572,
        "lng": 121.939815084976,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "776",
        "lat": 0.44771626522415,
        "lng": 121.939984591358,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1065",
        "lat": 0.564023,
        "lng": 121.568023,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 5 LITER IKK LEMITLO Tdk terpakai"
    },
    {
        "id": "1580",
        "lat": 0.461628,
        "lng": 121.962063,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "779",
        "lat": 0.448839902189192,
        "lng": 121.942623963971,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "780",
        "lat": 0.448873960874629,
        "lng": 121.943834670431,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "781",
        "lat": 0.448838661797996,
        "lng": 121.943833534734,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "782",
        "lat": 0.44887741515519,
        "lng": 121.9434154916,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1267",
        "lat": 0.448834,
        "lng": 121.94237,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x100"
    },
    {
        "id": "784",
        "lat": 0.447881300480444,
        "lng": 121.941323777919,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 40"
    },
    {
        "id": "785",
        "lat": 0.448248318275383,
        "lng": 121.942194875425,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 40"
    },
    {
        "id": "1890",
        "lat": 0.44655,
        "lng": 121.940246,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "787",
        "lat": 0.445782546445155,
        "lng": 121.939583361315,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 25"
    },
    {
        "id": "1064",
        "lat": 0.563861,
        "lng": 121.567922,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 20 IKK lemito Lama"
    },
    {
        "id": "789",
        "lat": 0.44737260614193,
        "lng": 121.94013557154,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "790",
        "lat": 0.446172478081954,
        "lng": 121.938045514849,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 75"
    },
    {
        "id": "791",
        "lat": 0.445937020212702,
        "lng": 121.937752133276,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "792",
        "lat": 0.447126595096019,
        "lng": 121.940164134661,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "793",
        "lat": 0.447010900977805,
        "lng": 121.940016561857,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 25"
    },
    {
        "id": "794",
        "lat": 0.446478148993416,
        "lng": 121.938417232894,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "795",
        "lat": 0.446946438001222,
        "lng": 121.938056649493,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50 x 40"
    },
    {
        "id": "796",
        "lat": 0.447153963622601,
        "lng": 121.937918110325,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 40"
    },
    {
        "id": "797",
        "lat": 0.450077229294912,
        "lng": 121.948027970096,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "798",
        "lat": 0.449928701310826,
        "lng": 121.949211003171,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 50 x 40"
    },
    {
        "id": "799",
        "lat": 0.461623181788478,
        "lng": 121.928833656841,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1067",
        "lat": 0.563976,
        "lng": 121.567926,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": "IKKLemito Lama"
    },
    {
        "id": "801",
        "lat": 0.476290173136838,
        "lng": 121.93220491982,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "802",
        "lat": 0.470840745063887,
        "lng": 121.938234086206,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "803",
        "lat": 0.471152717096313,
        "lng": 121.938435238346,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 50"
    },
    {
        "id": "805",
        "lat": 0.47002638903452,
        "lng": 121.942605330437,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "806",
        "lat": 0.471744514535148,
        "lng": 121.942802787128,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 75"
    },
    {
        "id": "807",
        "lat": 0.471759324831252,
        "lng": 121.942891602668,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "808",
        "lat": 0.473835204942438,
        "lng": 121.943492828376,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "809",
        "lat": 0.474361174426272,
        "lng": 121.942487971744,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "1086",
        "lat": 0.563303,
        "lng": 121.567564,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x100"
    },
    {
        "id": "1614",
        "lat": 0.456293,
        "lng": 121.947475,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "812",
        "lat": 0.456209327959424,
        "lng": 121.947665367575,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1272",
        "lat": 0.465359,
        "lng": 121.962927,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": ""
    },
    {
        "id": "814",
        "lat": 0.459194558484195,
        "lng": 121.952013948558,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 75"
    },
    {
        "id": "815",
        "lat": 0.457493516416718,
        "lng": 121.951831893124,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1061",
        "lat": 0.563693,
        "lng": 121.567594,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x150"
    },
    {
        "id": "1060",
        "lat": 0.57061,
        "lng": 121.569805,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "200x150"
    },
    {
        "id": "1059",
        "lat": 0.57061,
        "lng": 121.569805,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "200x150"
    },
    {
        "id": "828",
        "lat": 0.458906980020132,
        "lng": 121.952015172606,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "1058",
        "lat": 0.57061,
        "lng": 121.569805,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "200x150"
    },
    {
        "id": "1057",
        "lat": 0.571085,
        "lng": 121.569423,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": "IKK Lemito"
    },
    {
        "id": "831",
        "lat": 0.451382927576989,
        "lng": 121.953723801425,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "1056",
        "lat": 0.571837,
        "lng": 121.570249,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": "INETEK UNIT LEMITO"
    },
    {
        "id": "833",
        "lat": 0.466343838785377,
        "lng": 121.94247589948,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1686",
        "lat": 0.467732,
        "lng": 121.942383,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1684",
        "lat": 0.468987,
        "lng": 121.942392,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "150x50"
    },
    {
        "id": "1688",
        "lat": 0.467311,
        "lng": 121.944682,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1054",
        "lat": 0.509364,
        "lng": 121.469823,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm150 X dm100mm"
    },
    {
        "id": "1687",
        "lat": 0.467899,
        "lng": 121.942386,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1053",
        "lat": 0.510777,
        "lng": 121.475252,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "ipa 10 l\/d"
    },
    {
        "id": "840",
        "lat": 0.468581002410112,
        "lng": 121.941428339896,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 150 x 100"
    },
    {
        "id": "1685",
        "lat": 0.469971,
        "lng": 121.942541,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1683",
        "lat": 0.469123,
        "lng": 121.939328,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "844",
        "lat": 0.468766191293314,
        "lng": 121.940294194987,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "845",
        "lat": 0.469042050957879,
        "lng": 121.940357355689,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 75"
    },
    {
        "id": "846",
        "lat": 0.468748794800578,
        "lng": 121.940312612846,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "847",
        "lat": 0.468177389221646,
        "lng": 121.938802552942,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "848",
        "lat": 0.471112789722944,
        "lng": 121.938413387743,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150 x 50"
    },
    {
        "id": "1052",
        "lat": 0.510656,
        "lng": 121.475261,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": ""
    },
    {
        "id": "1051",
        "lat": 0.502114,
        "lng": 122.091637,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1050",
        "lat": 0.500785,
        "lng": 122.076693,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "REDUSER 100X75"
    },
    {
        "id": "852",
        "lat": 0.469530460196034,
        "lng": 121.946612333561,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "853",
        "lat": 0.469518768797286,
        "lng": 121.946780451209,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 75"
    },
    {
        "id": "854",
        "lat": 0.469535925221398,
        "lng": 121.946779406082,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 75"
    },
    {
        "id": "1049",
        "lat": 0.49906,
        "lng": 122.076149,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1048",
        "lat": 0.49906,
        "lng": 122.076149,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1047",
        "lat": 0.500104,
        "lng": 122.068396,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 250X150"
    },
    {
        "id": "858",
        "lat": 0.460544287503404,
        "lng": 121.947364274207,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 150 x 100"
    },
    {
        "id": "1273",
        "lat": 0.445406,
        "lng": 121.936212,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "75"
    },
    {
        "id": "1284",
        "lat": 0.472202,
        "lng": 121.436308,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50mm X dm500"
    },
    {
        "id": "863",
        "lat": 0.445870171475188,
        "lng": 121.936484479135,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "864",
        "lat": 0.445862258335129,
        "lng": 121.936571058752,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "865",
        "lat": 0.445867779101317,
        "lng": 121.936441040792,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 75 x 50"
    },
    {
        "id": "866",
        "lat": 0.445909397033789,
        "lng": 121.936787988867,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1282",
        "lat": 0.473417,
        "lng": 121.437201,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "testek dm50mm X dm50mm"
    },
    {
        "id": "1275",
        "lat": 0.475805,
        "lng": 121.938077,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1276",
        "lat": 0.482069,
        "lng": 121.939809,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1279",
        "lat": 0.46884,
        "lng": 121.951901,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": ""
    },
    {
        "id": "1046",
        "lat": 0.499842,
        "lng": 121.451734,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": ""
    },
    {
        "id": "1045",
        "lat": 0.500313,
        "lng": 121.451706,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "testek dm150 X dm150mm"
    },
    {
        "id": "1044",
        "lat": 0.500313,
        "lng": 121.451706,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "gate valve dm150"
    },
    {
        "id": "1043",
        "lat": 0.500299,
        "lng": 121.451738,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "gate valve dm150"
    },
    {
        "id": "1042",
        "lat": 0.500251,
        "lng": 121.451907,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "gate valve"
    },
    {
        "id": "1041",
        "lat": 0.500222,
        "lng": 121.451968,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm150 X dm200mm"
    },
    {
        "id": "1280",
        "lat": 0.468926,
        "lng": 121.950787,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": ""
    },
    {
        "id": "1040",
        "lat": 0.512003,
        "lng": 121.474352,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "pipa pelintas galvanis dm250mm"
    },
    {
        "id": "1035",
        "lat": 0.566724,
        "lng": 122.094066,
        "namakomponen": null,
        "kategori": "OVER SHOCK 300X250",
        "keterangan": ""
    },
    {
        "id": "1025",
        "lat": 0.464072,
        "lng": 121.963259,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "50"
    },
    {
        "id": "1024",
        "lat": 0.464072,
        "lng": 121.963259,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x50"
    },
    {
        "id": "1281",
        "lat": 0.473972,
        "lng": 121.436981,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm50 X dm75mm"
    },
    {
        "id": "886",
        "lat": 0.467687877074286,
        "lng": 121.931286791762,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150"
    },
    {
        "id": "887",
        "lat": 0.467657760366027,
        "lng": 121.931348914153,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100"
    },
    {
        "id": "1023",
        "lat": 0.464072,
        "lng": 121.963259,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x50"
    },
    {
        "id": "889",
        "lat": 0.467657249048985,
        "lng": 121.931387326579,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 150 x 75"
    },
    {
        "id": "890",
        "lat": 0.467744747105168,
        "lng": 121.931264920415,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 75"
    },
    {
        "id": "1022",
        "lat": 0.464072,
        "lng": 121.963259,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x50"
    },
    {
        "id": "894",
        "lat": 0.467668095491368,
        "lng": 121.931390601603,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 75"
    },
    {
        "id": "1020",
        "lat": 0.4641,
        "lng": 121.963314,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x100"
    },
    {
        "id": "1021",
        "lat": 0.4641,
        "lng": 121.963314,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x100"
    },
    {
        "id": "897",
        "lat": 0.467992842383711,
        "lng": 121.928395557865,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75 x 50"
    },
    {
        "id": "1247",
        "lat": 0.470026,
        "lng": 121.928502,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1018",
        "lat": 0.464135,
        "lng": 121.963359,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x150"
    },
    {
        "id": "900",
        "lat": 0.470461712518187,
        "lng": 121.931179279516,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 25"
    },
    {
        "id": "1017",
        "lat": 0.462575,
        "lng": 121.963102,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150 X 100"
    },
    {
        "id": "902",
        "lat": 0.456940717173483,
        "lng": 121.951641097799,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "904",
        "lat": 0.457242457961133,
        "lng": 121.951646026648,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "905",
        "lat": 0.457490918229126,
        "lng": 121.951653504956,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "906",
        "lat": 0.457227786380584,
        "lng": 121.951647310245,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "907",
        "lat": 0.456929752759227,
        "lng": 121.951644521041,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50"
    },
    {
        "id": "1016",
        "lat": 0.605712,
        "lng": 122.101541,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": "INTAKE SAMBATI\nSUNGAI RANDANGAN"
    },
    {
        "id": "1015",
        "lat": 0.563097,
        "lng": 122.09346,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 10 L\/D"
    },
    {
        "id": "1841",
        "lat": 0.497783,
        "lng": 121.906212,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1014",
        "lat": 0.511299,
        "lng": 122.072133,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "IPA 10 L\/D"
    },
    {
        "id": "1248",
        "lat": 0.470442,
        "lng": 121.930488,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "913",
        "lat": 0.470456256203592,
        "lng": 121.930626065348,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 25 x 25"
    },
    {
        "id": "1676",
        "lat": 0.512294,
        "lng": 122.071684,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": "Ipa 20 Hungaria Paguat"
    },
    {
        "id": "915",
        "lat": 0.469994757939105,
        "lng": 121.931305668058,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 100 x 50"
    },
    {
        "id": "1012",
        "lat": 0.464862,
        "lng": 121.935947,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75 x 50"
    },
    {
        "id": "918",
        "lat": 0.468975163220142,
        "lng": 121.930482494398,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 25"
    },
    {
        "id": "919",
        "lat": 0.469117626969351,
        "lng": 121.931161352857,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 25"
    },
    {
        "id": "920",
        "lat": 0.474517222312975,
        "lng": 121.924128074406,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "Beugel 100 x 25"
    },
    {
        "id": "1011",
        "lat": 0.464839,
        "lng": 121.936037,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "testek 100 x 75"
    },
    {
        "id": "922",
        "lat": 0.463259495519025,
        "lng": 121.929412995188,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 100 x 50"
    },
    {
        "id": "1597",
        "lat": 0.462902,
        "lng": 121.932899,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "50x25"
    },
    {
        "id": "1681",
        "lat": 0.476726,
        "lng": 121.940653,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": ""
    },
    {
        "id": "925",
        "lat": 0.465161833807737,
        "lng": 121.932955204235,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50 x 50"
    },
    {
        "id": "926",
        "lat": 0.464515416191173,
        "lng": 121.930217604989,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reduser 150 x 75"
    },
    {
        "id": "1594",
        "lat": 0.464294,
        "lng": 121.929097,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "50x25"
    },
    {
        "id": "928",
        "lat": 0.46406879473507,
        "lng": 121.929731499541,
        "namakomponen": "",
        "kategori": "Testek",
        "keterangan": "TESTEK 50 d"
    },
    {
        "id": "1037",
        "lat": 0.511933,
        "lng": 122.072373,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1891",
        "lat": 0.576915,
        "lng": 121.972059,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "INTAKE AIR TERANG"
    },
    {
        "id": "937",
        "lat": 0.569488,
        "lng": 121.570116,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "INTAKE LEMITO"
    },
    {
        "id": "1260",
        "lat": 0.445858,
        "lng": 121.939639,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x50"
    },
    {
        "id": "1261",
        "lat": 0.446247,
        "lng": 121.939329,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1039",
        "lat": 0.594467,
        "lng": 121.449839,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "intake kilo 13"
    },
    {
        "id": "941",
        "lat": 0.510889,
        "lng": 121.47532,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "INTAKE POPAYATO INDUK"
    },
    {
        "id": "1773",
        "lat": 0.507104,
        "lng": 121.369502,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1776",
        "lat": 0.512333,
        "lng": 121.372895,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": ""
    },
    {
        "id": "944",
        "lat": 0.5501,
        "lng": 121.394703,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "INTAKE POPBAR BUTUNGALE"
    },
    {
        "id": "1709",
        "lat": 0.57976,
        "lng": 121.639735,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "200x150"
    },
    {
        "id": "1739",
        "lat": 0.530276,
        "lng": 121.69356,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1740",
        "lat": 0.530391,
        "lng": 121.694231,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "947",
        "lat": 0.557443,
        "lng": 121.679236,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "INTAKE WANGGARASI ATAS 1"
    },
    {
        "id": "948",
        "lat": 0.557277,
        "lng": 121.679498,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "INTAKE WANGGARASI ATAS 2"
    },
    {
        "id": "1738",
        "lat": 0.530786,
        "lng": 121.690204,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": ""
    },
    {
        "id": "1208",
        "lat": 0.648397,
        "lng": 121.798261,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": ""
    },
    {
        "id": "1009",
        "lat": 0.474046,
        "lng": 121.931861,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "Reducer 100 X 75"
    },
    {
        "id": "1689",
        "lat": 0.473013,
        "lng": 121.92944,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "1010",
        "lat": 0.476756,
        "lng": 121.932469,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100 x 75"
    },
    {
        "id": "978",
        "lat": 0.483098,
        "lng": 121.965264,
        "namakomponen": "",
        "kategori": "Beugel",
        "keterangan": null
    },
    {
        "id": "980",
        "lat": 0.481957,
        "lng": 121.963988,
        "namakomponen": "",
        "kategori": "Meter Induk",
        "keterangan": null
    },
    {
        "id": "997",
        "lat": 0.475814,
        "lng": 121.93801,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "TITIK 3"
    },
    {
        "id": "996",
        "lat": 0.473482,
        "lng": 121.936712,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "TITIK 2"
    },
    {
        "id": "995",
        "lat": 0.472243,
        "lng": 121.935641,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "TITIK 1"
    },
    {
        "id": "1646",
        "lat": 0.461984,
        "lng": 121.937224,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1647",
        "lat": 0.449996,
        "lng": 121.930065,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1648",
        "lat": 0.562405,
        "lng": 122.095663,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm150 X dm100"
    },
    {
        "id": "1243",
        "lat": 0.445234,
        "lng": 121.938874,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1592",
        "lat": 0.458294,
        "lng": 121.927707,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1245",
        "lat": 0.461768,
        "lng": 121.930723,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "50x25"
    },
    {
        "id": "1246",
        "lat": 0.504872,
        "lng": 121.453447,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1249",
        "lat": 0.50499,
        "lng": 121.453487,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1251",
        "lat": 0.508929,
        "lng": 121.469095,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1252",
        "lat": 0.466624,
        "lng": 121.948085,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "150x50"
    },
    {
        "id": "1253",
        "lat": 0.504486,
        "lng": 121.469233,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1255",
        "lat": 0.510427,
        "lng": 121.474696,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": ""
    },
    {
        "id": "1256",
        "lat": 0.511292,
        "lng": 121.462593,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1257",
        "lat": 0.511975,
        "lng": 121.474472,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1258",
        "lat": 0.525345,
        "lng": 121.490999,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1259",
        "lat": 0.525405,
        "lng": 121.491038,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1262",
        "lat": 0.446409,
        "lng": 121.938998,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "50"
    },
    {
        "id": "1263",
        "lat": 0.445693,
        "lng": 121.937234,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "100"
    },
    {
        "id": "1264",
        "lat": 0.517092,
        "lng": 121.483076,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1265",
        "lat": 0.504787,
        "lng": 121.453308,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1811",
        "lat": 0.557594,
        "lng": 121.553276,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1270",
        "lat": 0.456372,
        "lng": 121.937122,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1271",
        "lat": 0.458632,
        "lng": 121.947486,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1285",
        "lat": 0.472338,
        "lng": 121.436121,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50mm X dm50mm"
    },
    {
        "id": "1286",
        "lat": 0.47224,
        "lng": 121.436843,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1287",
        "lat": 0.472462,
        "lng": 121.43651,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1288",
        "lat": 0.471644,
        "lng": 121.435748,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1289",
        "lat": 0.471362,
        "lng": 121.435628,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1290",
        "lat": 0.471559,
        "lng": 121.435917,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X Dm50"
    },
    {
        "id": "1291",
        "lat": 0.471127,
        "lng": 121.435719,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1292",
        "lat": 0.650242,
        "lng": 121.827729,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm100 X dm100"
    },
    {
        "id": "1293",
        "lat": 0.639787,
        "lng": 121.823876,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm200 X dm100"
    },
    {
        "id": "1294",
        "lat": 0.642311,
        "lng": 121.827018,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1295",
        "lat": 0.652111,
        "lng": 121.827857,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1296",
        "lat": 0.653148,
        "lng": 121.82931,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1297",
        "lat": 0.65206,
        "lng": 121.828441,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1298",
        "lat": 0.650223,
        "lng": 121.827827,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm100"
    },
    {
        "id": "1299",
        "lat": 0.664172,
        "lng": 121.836504,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X Dm50"
    },
    {
        "id": "1300",
        "lat": 0.658084,
        "lng": 121.829275,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm75 X dm50"
    },
    {
        "id": "1301",
        "lat": 0.656388,
        "lng": 121.828696,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm75 X dm100"
    },
    {
        "id": "1302",
        "lat": 0.656035,
        "lng": 121.828657,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm100"
    },
    {
        "id": "1304",
        "lat": 0.654026,
        "lng": 121.827232,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm100"
    },
    {
        "id": "1305",
        "lat": 0.653106,
        "lng": 121.82465,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm40"
    },
    {
        "id": "1306",
        "lat": 0.653168,
        "lng": 121.824653,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1307",
        "lat": 0.654017,
        "lng": 121.82642,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm75 X dm50"
    },
    {
        "id": "1308",
        "lat": 0.653975,
        "lng": 121.827824,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm100 X dm100"
    },
    {
        "id": "1309",
        "lat": 0.654084,
        "lng": 121.824618,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1310",
        "lat": 0.654077,
        "lng": 121.824666,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1311",
        "lat": 0.654077,
        "lng": 121.824666,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1312",
        "lat": 0.65412,
        "lng": 121.821883,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1313",
        "lat": 0.654197,
        "lng": 121.821814,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1314",
        "lat": 0.654307,
        "lng": 121.817121,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1315",
        "lat": 0.653243,
        "lng": 121.818485,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1316",
        "lat": 0.652213,
        "lng": 121.81905,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1317",
        "lat": 0.652173,
        "lng": 121.821747,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1318",
        "lat": 0.652259,
        "lng": 121.821763,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "Dm50 X dm50"
    },
    {
        "id": "1319",
        "lat": 0.653159,
        "lng": 121.821787,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1320",
        "lat": 0.651221,
        "lng": 121.821706,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1321",
        "lat": 0.651217,
        "lng": 121.821788,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1322",
        "lat": 0.651242,
        "lng": 121.819164,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1323",
        "lat": 0.650336,
        "lng": 121.819181,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1324",
        "lat": 0.652186,
        "lng": 121.824042,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1325",
        "lat": 0.65214,
        "lng": 121.824598,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1326",
        "lat": 0.651977,
        "lng": 121.825628,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1327",
        "lat": 0.653096,
        "lng": 121.825224,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm40"
    },
    {
        "id": "1328",
        "lat": 0.656239,
        "lng": 121.821851,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1329",
        "lat": 0.655082,
        "lng": 121.823361,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1330",
        "lat": 0.655043,
        "lng": 121.824634,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm40"
    },
    {
        "id": "1331",
        "lat": 0.654969,
        "lng": 121.825833,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm40"
    },
    {
        "id": "1333",
        "lat": 0.633521,
        "lng": 121.809084,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm50 X dm75"
    },
    {
        "id": "1334",
        "lat": 0.507521,
        "lng": 122.114157,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "testek 50x50"
    },
    {
        "id": "1335",
        "lat": 0.507447,
        "lng": 122.114165,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "testek 50x50"
    },
    {
        "id": "1336",
        "lat": 0.499153,
        "lng": 122.073558,
        "namakomponen": null,
        "kategori": "manhole",
        "keterangan": ""
    },
    {
        "id": "1337",
        "lat": 0.499134,
        "lng": 122.073558,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 150"
    },
    {
        "id": "1338",
        "lat": 0.499143,
        "lng": 122.073539,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 150X100"
    },
    {
        "id": "1339",
        "lat": 0.499074,
        "lng": 122.073539,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X50"
    },
    {
        "id": "1679",
        "lat": 0.477749,
        "lng": 121.948301,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1341",
        "lat": 0.499889,
        "lng": 122.071577,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "REDUSER 150X100"
    },
    {
        "id": "1342",
        "lat": 0.484309,
        "lng": 122.082396,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1343",
        "lat": 0.486465,
        "lng": 122.111799,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1344",
        "lat": 0.486446,
        "lng": 122.111805,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1345",
        "lat": 0.633447,
        "lng": 121.810838,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm75 X dm75"
    },
    {
        "id": "1346",
        "lat": 0.486551,
        "lng": 122.112013,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1347",
        "lat": 0.634548,
        "lng": 121.81383,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm200 X dm75"
    },
    {
        "id": "1348",
        "lat": 0.487235,
        "lng": 122.111916,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1349",
        "lat": 0.634485,
        "lng": 121.813408,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1350",
        "lat": 0.633502,
        "lng": 121.813833,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm75 X dm75"
    },
    {
        "id": "1351",
        "lat": 0.633427,
        "lng": 121.814189,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm75 X dm50"
    },
    {
        "id": "1352",
        "lat": 0.633399,
        "lng": 121.814763,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1353",
        "lat": 0.633399,
        "lng": 121.814763,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1354",
        "lat": 0.63378,
        "lng": 121.820668,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1355",
        "lat": 0.635827,
        "lng": 121.821469,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1356",
        "lat": 0.633385,
        "lng": 121.821887,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1357",
        "lat": 0.633385,
        "lng": 121.821887,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1358",
        "lat": 0.633007,
        "lng": 121.819331,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1359",
        "lat": 0.633007,
        "lng": 121.819331,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1360",
        "lat": 0.632306,
        "lng": 121.819315,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1361",
        "lat": 0.632255,
        "lng": 121.820042,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1362",
        "lat": 0.485847,
        "lng": 122.110582,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1363",
        "lat": 0.63238,
        "lng": 121.817731,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1364",
        "lat": 0.632327,
        "lng": 121.816933,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1365",
        "lat": 0.632327,
        "lng": 121.816933,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1366",
        "lat": 0.632409,
        "lng": 121.814668,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1367",
        "lat": 0.632358,
        "lng": 121.814593,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1368",
        "lat": 0.632358,
        "lng": 121.814593,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1369",
        "lat": 0.632396,
        "lng": 121.813147,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1370",
        "lat": 0.632396,
        "lng": 121.813147,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1371",
        "lat": 0.632361,
        "lng": 121.814664,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1372",
        "lat": 0.6315,
        "lng": 121.812804,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1373",
        "lat": 0.631425,
        "lng": 121.814629,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1374",
        "lat": 0.631375,
        "lng": 121.814628,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1375",
        "lat": 0.631355,
        "lng": 121.81646,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1376",
        "lat": 0.630447,
        "lng": 121.814601,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1377",
        "lat": 0.6304,
        "lng": 121.814596,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1378",
        "lat": 0.630442,
        "lng": 121.81364,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1379",
        "lat": 0.630371,
        "lng": 121.816857,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1380",
        "lat": 0.63017,
        "lng": 121.816933,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1381",
        "lat": 0.63017,
        "lng": 121.816933,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1382",
        "lat": 0.630427,
        "lng": 121.817726,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1383",
        "lat": 0.632437,
        "lng": 121.810803,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm75"
    },
    {
        "id": "1384",
        "lat": 0.633569,
        "lng": 121.808054,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1385",
        "lat": 0.633569,
        "lng": 121.808054,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1386",
        "lat": 0.633526,
        "lng": 121.809023,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm50 X dm50"
    },
    {
        "id": "1387",
        "lat": 0.488419,
        "lng": 122.081104,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1388",
        "lat": 0.488642,
        "lng": 122.080993,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1389",
        "lat": 0.488642,
        "lng": 122.081095,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1390",
        "lat": 0.487288,
        "lng": 122.08162,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "50X40"
    },
    {
        "id": "1391",
        "lat": 0.492304,
        "lng": 122.08414,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1392",
        "lat": 0.491652,
        "lng": 122.080372,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1393",
        "lat": 0.491654,
        "lng": 122.080354,
        "namakomponen": null,
        "kategori": "manhole",
        "keterangan": ""
    },
    {
        "id": "1394",
        "lat": 0.487429,
        "lng": 122.074741,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1395",
        "lat": 0.484278,
        "lng": 122.082398,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "STOP KRAN 75"
    },
    {
        "id": "1396",
        "lat": 0.479969,
        "lng": 122.082927,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1397",
        "lat": 0.479422,
        "lng": 122.08353,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1398",
        "lat": 0.47873,
        "lng": 122.078092,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "PIPA 75 GIV"
    },
    {
        "id": "1399",
        "lat": 0.478492,
        "lng": 122.077884,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 75"
    },
    {
        "id": "1400",
        "lat": 0.478934,
        "lng": 122.080608,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 75"
    },
    {
        "id": "1401",
        "lat": 0.480685,
        "lng": 122.082862,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1402",
        "lat": 0.480914,
        "lng": 122.083467,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1403",
        "lat": 0.505564,
        "lng": 122.071161,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1404",
        "lat": 0.494908,
        "lng": 122.072408,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1405",
        "lat": 0.487503,
        "lng": 122.074828,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1406",
        "lat": 0.487935,
        "lng": 122.076084,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1407",
        "lat": 0.487879,
        "lng": 122.076108,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1408",
        "lat": 0.477536,
        "lng": 122.078282,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "TESTEK 50X50"
    },
    {
        "id": "1409",
        "lat": 0.478407,
        "lng": 122.07666,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1410",
        "lat": 0.478518,
        "lng": 122.076542,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1411",
        "lat": 0.478042,
        "lng": 122.077254,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1412",
        "lat": 0.479286,
        "lng": 122.078667,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1413",
        "lat": 0.479302,
        "lng": 122.078746,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1415",
        "lat": 0.477927,
        "lng": 122.077455,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1416",
        "lat": 0.478427,
        "lng": 122.077826,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1417",
        "lat": 0.480853,
        "lng": 122.085394,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1418",
        "lat": 0.480936,
        "lng": 122.083471,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1419",
        "lat": 0.47811,
        "lng": 122.079196,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1420",
        "lat": 0.478503,
        "lng": 122.081569,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1421",
        "lat": 0.477523,
        "lng": 122.081095,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1422",
        "lat": 0.478287,
        "lng": 122.081799,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1423",
        "lat": 0.47899,
        "lng": 122.08239,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1424",
        "lat": 0.478513,
        "lng": 122.082,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1425",
        "lat": 0.478495,
        "lng": 122.082019,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "50X75"
    },
    {
        "id": "1426",
        "lat": 0.47814,
        "lng": 122.082217,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1427",
        "lat": 0.478916,
        "lng": 122.083199,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1428",
        "lat": 0.480926,
        "lng": 122.083515,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1429",
        "lat": 0.479193,
        "lng": 122.079459,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1430",
        "lat": 0.478775,
        "lng": 122.079339,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1431",
        "lat": 0.484197,
        "lng": 122.082491,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1434",
        "lat": 0.481246,
        "lng": 122.084254,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1433",
        "lat": 0.541352,
        "lng": 121.571359,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": ""
    },
    {
        "id": "1435",
        "lat": 0.481011,
        "lng": 122.084468,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1436",
        "lat": 0.481272,
        "lng": 122.084309,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1437",
        "lat": 0.487864,
        "lng": 122.103742,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1438",
        "lat": 0.48971,
        "lng": 122.104093,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1439",
        "lat": 0.486135,
        "lng": 122.08922,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1440",
        "lat": 0.485516,
        "lng": 122.089434,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1441",
        "lat": 0.485943,
        "lng": 122.089281,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 75"
    },
    {
        "id": "1442",
        "lat": 0.485939,
        "lng": 122.089257,
        "namakomponen": null,
        "kategori": "manhole",
        "keterangan": ""
    },
    {
        "id": "1443",
        "lat": 0.485819,
        "lng": 122.08933,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50 HDPE"
    },
    {
        "id": "1444",
        "lat": 0.486303,
        "lng": 122.091047,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1445",
        "lat": 0.486303,
        "lng": 122.091047,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1446",
        "lat": 0.486303,
        "lng": 122.091047,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1447",
        "lat": 0.485572,
        "lng": 122.089414,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1448",
        "lat": 0.486053,
        "lng": 122.091097,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1449",
        "lat": 0.486162,
        "lng": 122.08929,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1450",
        "lat": 0.486552,
        "lng": 122.090972,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1451",
        "lat": 0.487004,
        "lng": 122.106978,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1452",
        "lat": 0.486791,
        "lng": 122.091262,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1453",
        "lat": 0.479595,
        "lng": 122.07657,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1454",
        "lat": 0.479305,
        "lng": 122.075682,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1455",
        "lat": 0.479848,
        "lng": 122.075533,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1456",
        "lat": 0.479856,
        "lng": 122.075996,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1457",
        "lat": 0.480121,
        "lng": 122.075313,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1459",
        "lat": 0.478963,
        "lng": 122.075551,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1460",
        "lat": 0.479089,
        "lng": 122.075556,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1461",
        "lat": 0.562158,
        "lng": 121.555498,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1462",
        "lat": 0.479129,
        "lng": 122.075565,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X40"
    },
    {
        "id": "1463",
        "lat": 0.478295,
        "lng": 122.075707,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1464",
        "lat": 0.480648,
        "lng": 122.076374,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1465",
        "lat": 0.480531,
        "lng": 122.077083,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1466",
        "lat": 0.478212,
        "lng": 122.077668,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1468",
        "lat": 0.479258,
        "lng": 122.077845,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1470",
        "lat": 0.477778,
        "lng": 122.076413,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1472",
        "lat": 0.477453,
        "lng": 122.079149,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1474",
        "lat": 0.48416,
        "lng": 122.075395,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1475",
        "lat": 0.484141,
        "lng": 122.075253,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1476",
        "lat": 0.483902,
        "lng": 122.074991,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1477",
        "lat": 0.484132,
        "lng": 122.075083,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1478",
        "lat": 0.487093,
        "lng": 122.074731,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1479",
        "lat": 0.48694,
        "lng": 122.075646,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1480",
        "lat": 0.547403,
        "lng": 121.572344,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1481",
        "lat": 0.487531,
        "lng": 122.074543,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1482",
        "lat": 0.550847,
        "lng": 121.572005,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x100"
    },
    {
        "id": "1483",
        "lat": 0.486818,
        "lng": 122.070308,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1484",
        "lat": 0.48742,
        "lng": 122.074393,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1492",
        "lat": 0.489366,
        "lng": 122.069406,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1486",
        "lat": 0.486999,
        "lng": 122.072764,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1487",
        "lat": 0.487311,
        "lng": 122.072627,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1488",
        "lat": 0.4992,
        "lng": 122.071578,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150X150"
    },
    {
        "id": "1491",
        "lat": 0.480787,
        "lng": 122.076273,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1494",
        "lat": 0.498341,
        "lng": 122.07168,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1495",
        "lat": 0.490971,
        "lng": 122.073645,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150X75"
    },
    {
        "id": "1496",
        "lat": 0.540611,
        "lng": 121.580088,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1497",
        "lat": 0.490652,
        "lng": 122.072422,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1498",
        "lat": 0.489808,
        "lng": 122.069416,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1499",
        "lat": 0.490955,
        "lng": 122.073563,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "RPR 75"
    },
    {
        "id": "1500",
        "lat": 0.49095,
        "lng": 122.073544,
        "namakomponen": null,
        "kategori": "manhole",
        "keterangan": ""
    },
    {
        "id": "1501",
        "lat": 0.491082,
        "lng": 122.073625,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1504",
        "lat": 0.546911,
        "lng": 121.582219,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1503",
        "lat": 0.489571,
        "lng": 122.067953,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1505",
        "lat": 0.5469,
        "lng": 121.582169,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1506",
        "lat": 0.545222,
        "lng": 121.573083,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "75"
    },
    {
        "id": "1512",
        "lat": 0.540581,
        "lng": 121.571585,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1515",
        "lat": 0.477074,
        "lng": 122.018429,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150X100"
    },
    {
        "id": "1516",
        "lat": 0.476657,
        "lng": 122.018525,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1517",
        "lat": 0.475974,
        "lng": 122.018696,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1518",
        "lat": 0.469855,
        "lng": 122.019209,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X50"
    },
    {
        "id": "1519",
        "lat": 0.477237,
        "lng": 122.01848,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50X40"
    },
    {
        "id": "1520",
        "lat": 0.563255,
        "lng": 122.093587,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm200 X dm150"
    },
    {
        "id": "1523",
        "lat": 0.499302,
        "lng": 122.071641,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100X100"
    },
    {
        "id": "1522",
        "lat": 0.497955,
        "lng": 122.071817,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1524",
        "lat": 0.483896,
        "lng": 122.056495,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1525",
        "lat": 0.480339,
        "lng": 122.039681,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1663",
        "lat": 0.547473,
        "lng": 122.092424,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm150 dan dm50"
    },
    {
        "id": "1528",
        "lat": 0.473497,
        "lng": 122.00394,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X75"
    },
    {
        "id": "1529",
        "lat": 0.47339,
        "lng": 122.003881,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "100MM"
    },
    {
        "id": "1530",
        "lat": 0.473253,
        "lng": 122.003356,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100X75"
    },
    {
        "id": "1531",
        "lat": 0.460325,
        "lng": 121.997662,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1535",
        "lat": 0.460343,
        "lng": 121.999167,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1533",
        "lat": 0.466793,
        "lng": 122.001778,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "40X50"
    },
    {
        "id": "1534",
        "lat": 0.475184,
        "lng": 122.006199,
        "namakomponen": null,
        "kategori": "Tee Y",
        "keterangan": "75X40"
    },
    {
        "id": "1536",
        "lat": 0.462058,
        "lng": 121.999676,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X40"
    },
    {
        "id": "1537",
        "lat": 0.462679,
        "lng": 122.000223,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X40"
    },
    {
        "id": "1538",
        "lat": 0.462098,
        "lng": 122.000838,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1539",
        "lat": 0.461087,
        "lng": 122.000632,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1540",
        "lat": 0.473553,
        "lng": 122.002043,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75X50"
    },
    {
        "id": "1541",
        "lat": 0.475565,
        "lng": 122.002093,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1542",
        "lat": 0.654025,
        "lng": 121.827199,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm100 X dm75"
    },
    {
        "id": "1543",
        "lat": 0.66254,
        "lng": 121.834295,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1544",
        "lat": 0.66254,
        "lng": 121.834295,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1545",
        "lat": 0.66254,
        "lng": 121.834295,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1546",
        "lat": 0.662536,
        "lng": 121.834297,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1547",
        "lat": 0.662536,
        "lng": 121.834297,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1548",
        "lat": 0.662536,
        "lng": 121.834297,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1549",
        "lat": 0.662536,
        "lng": 121.834297,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1550",
        "lat": 0.662536,
        "lng": 121.834297,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1551",
        "lat": 0.66344,
        "lng": 121.835286,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1552",
        "lat": 0.66344,
        "lng": 121.835286,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1553",
        "lat": 0.66344,
        "lng": 121.835286,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1554",
        "lat": 0.66344,
        "lng": 121.835286,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1555",
        "lat": 0.66344,
        "lng": 121.835286,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1556",
        "lat": 0.66344,
        "lng": 121.835286,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1557",
        "lat": 0.664187,
        "lng": 121.836165,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1558",
        "lat": 0.664187,
        "lng": 121.836165,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1559",
        "lat": 0.664154,
        "lng": 121.838433,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1560",
        "lat": 0.664154,
        "lng": 121.838433,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1561",
        "lat": 0.664894,
        "lng": 121.836513,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm50"
    },
    {
        "id": "1563",
        "lat": 0.467541,
        "lng": 121.954454,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1569",
        "lat": 0.46432,
        "lng": 121.934486,
        "namakomponen": null,
        "kategori": "Tempat  Cuci Pipa",
        "keterangan": ""
    },
    {
        "id": "1570",
        "lat": 0.459308,
        "lng": 121.936973,
        "namakomponen": null,
        "kategori": "Tempat  Cuci Pipa",
        "keterangan": ""
    },
    {
        "id": "1571",
        "lat": 0.458773,
        "lng": 121.937103,
        "namakomponen": null,
        "kategori": "Tempat  Cuci Pipa",
        "keterangan": ""
    },
    {
        "id": "1572",
        "lat": 0.463102,
        "lng": 121.944716,
        "namakomponen": null,
        "kategori": "Tempat  Cuci Pipa",
        "keterangan": ""
    },
    {
        "id": "1573",
        "lat": 0.455657,
        "lng": 121.950898,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": ""
    },
    {
        "id": "1574",
        "lat": 0.455988,
        "lng": 121.950595,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1575",
        "lat": 0.448885,
        "lng": 121.94415,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1576",
        "lat": 0.448849,
        "lng": 121.943873,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1577",
        "lat": 0.45009,
        "lng": 121.941774,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1578",
        "lat": 0.450083,
        "lng": 121.941922,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1581",
        "lat": 0.449967,
        "lng": 121.948525,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "50"
    },
    {
        "id": "1582",
        "lat": 0.479863,
        "lng": 121.951697,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1583",
        "lat": 0.48018,
        "lng": 121.952308,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1584",
        "lat": 0.474548,
        "lng": 121.955474,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1587",
        "lat": 0.477486,
        "lng": 121.935068,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": ""
    },
    {
        "id": "1588",
        "lat": 0.482803,
        "lng": 121.937295,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1595",
        "lat": 0.464374,
        "lng": 121.928745,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1596",
        "lat": 0.465291,
        "lng": 121.933351,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1598",
        "lat": 0.485994,
        "lng": 121.935642,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x50"
    },
    {
        "id": "1599",
        "lat": 0.497637,
        "lng": 121.933903,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x50"
    },
    {
        "id": "1600",
        "lat": 0.514961,
        "lng": 121.949074,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "200x200"
    },
    {
        "id": "1601",
        "lat": 0.519832,
        "lng": 121.951676,
        "namakomponen": null,
        "kategori": "Beugel",
        "keterangan": "200x50"
    },
    {
        "id": "1603",
        "lat": 0.534534,
        "lng": 121.969204,
        "namakomponen": null,
        "kategori": "SPL",
        "keterangan": ""
    },
    {
        "id": "1610",
        "lat": 0.481001,
        "lng": 121.942568,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1611",
        "lat": 0.47099,
        "lng": 121.940187,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1612",
        "lat": 0.471954,
        "lng": 121.940648,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1613",
        "lat": 0.459484,
        "lng": 121.945039,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1615",
        "lat": 0.456365,
        "lng": 121.947905,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1617",
        "lat": 0.448203,
        "lng": 121.942599,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1618",
        "lat": 0.444851,
        "lng": 121.935853,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1619",
        "lat": 0.44539,
        "lng": 121.936046,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1620",
        "lat": 0.445371,
        "lng": 121.936206,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1621",
        "lat": 0.44562,
        "lng": 121.937118,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1622",
        "lat": 0.445767,
        "lng": 121.937424,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1623",
        "lat": 0.44684,
        "lng": 121.940373,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1624",
        "lat": 0.449182,
        "lng": 121.942953,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1625",
        "lat": 0.45168,
        "lng": 121.936168,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1626",
        "lat": 0.451536,
        "lng": 121.936228,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1631",
        "lat": 0.532347,
        "lng": 121.57063,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1632",
        "lat": 0.571847,
        "lng": 121.57051,
        "namakomponen": null,
        "kategori": "Sumber Air & Pompa",
        "keterangan": ""
    },
    {
        "id": "1633",
        "lat": 0.472522,
        "lng": 121.939076,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x75"
    },
    {
        "id": "1634",
        "lat": 0.470069,
        "lng": 121.940851,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1635",
        "lat": 0.46941,
        "lng": 121.947967,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1636",
        "lat": 0.469434,
        "lng": 121.948866,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1637",
        "lat": 0.469422,
        "lng": 121.948792,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1638",
        "lat": 0.469911,
        "lng": 121.950913,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x50"
    },
    {
        "id": "1639",
        "lat": 0.469878,
        "lng": 121.951418,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1649",
        "lat": 0.562405,
        "lng": 122.095663,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm150 X dm100"
    },
    {
        "id": "1650",
        "lat": 0.552938,
        "lng": 122.094885,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm200 X dm150"
    },
    {
        "id": "1651",
        "lat": 0.476948,
        "lng": 122.01766,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "250x200"
    },
    {
        "id": "1653",
        "lat": 0.477086,
        "lng": 122.014652,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "200mm"
    },
    {
        "id": "1654",
        "lat": 0.563334,
        "lng": 122.093764,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm150"
    },
    {
        "id": "1655",
        "lat": 0.563334,
        "lng": 122.093764,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm150"
    },
    {
        "id": "1656",
        "lat": 0.477052,
        "lng": 122.014489,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x100"
    },
    {
        "id": "1657",
        "lat": 0.477041,
        "lng": 122.014458,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x75"
    },
    {
        "id": "1658",
        "lat": 0.535234,
        "lng": 122.091795,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm150 dan dm50"
    },
    {
        "id": "1659",
        "lat": 0.532372,
        "lng": 122.091912,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm150"
    },
    {
        "id": "1660",
        "lat": 0.466941,
        "lng": 122.0047,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1661",
        "lat": 0.468217,
        "lng": 122.004437,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": "1 \"inc"
    },
    {
        "id": "1662",
        "lat": 0.472785,
        "lng": 121.999405,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1664",
        "lat": 0.526596,
        "lng": 122.090047,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm150"
    },
    {
        "id": "1665",
        "lat": 0.526596,
        "lng": 122.090047,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "dm150"
    },
    {
        "id": "1666",
        "lat": 0.528644,
        "lng": 122.092908,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm100 X dm75"
    },
    {
        "id": "1667",
        "lat": 0.528394,
        "lng": 122.093586,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm100 x dm50"
    },
    {
        "id": "1668",
        "lat": 0.527438,
        "lng": 122.095792,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm50 X dm40"
    },
    {
        "id": "1669",
        "lat": 0.528818,
        "lng": 122.096509,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm40"
    },
    {
        "id": "1670",
        "lat": 0.529052,
        "lng": 122.092375,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm75"
    },
    {
        "id": "1671",
        "lat": 0.529072,
        "lng": 122.092136,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "dm150 x dm100"
    },
    {
        "id": "1672",
        "lat": 0.528876,
        "lng": 122.091692,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm150 X dm150"
    },
    {
        "id": "1673",
        "lat": 0.529314,
        "lng": 122.091343,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "dm150 X dm40"
    },
    {
        "id": "1674",
        "lat": 0.53036,
        "lng": 122.09043,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm40"
    },
    {
        "id": "1675",
        "lat": 0.53036,
        "lng": 122.09043,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "dm40"
    },
    {
        "id": "1677",
        "lat": 0.512202,
        "lng": 122.071791,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": ""
    },
    {
        "id": "1678",
        "lat": 0.511363,
        "lng": 122.072144,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": "200"
    },
    {
        "id": "1680",
        "lat": 0.477016,
        "lng": 121.947805,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1682",
        "lat": 0.468404,
        "lng": 121.938357,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1690",
        "lat": 0.480721,
        "lng": 121.925989,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1691",
        "lat": 0.538555,
        "lng": 122.090136,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1694",
        "lat": 0.56748,
        "lng": 121.649651,
        "namakomponen": null,
        "kategori": "SPL",
        "keterangan": "Yipilo"
    },
    {
        "id": "1693",
        "lat": 0.5512,
        "lng": 121.649364,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1695",
        "lat": 0.56943,
        "lng": 121.649123,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "Yipilo"
    },
    {
        "id": "1697",
        "lat": 0.555701,
        "lng": 121.637035,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1698",
        "lat": 0.555052,
        "lng": 121.636804,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": ""
    },
    {
        "id": "1699",
        "lat": 0.550967,
        "lng": 121.64972,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x75"
    },
    {
        "id": "1702",
        "lat": 0.548686,
        "lng": 121.653273,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x75"
    },
    {
        "id": "1703",
        "lat": 0.549104,
        "lng": 121.651826,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1704",
        "lat": 0.547254,
        "lng": 121.658833,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1705",
        "lat": 0.547254,
        "lng": 121.658833,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1706",
        "lat": 0.557107,
        "lng": 121.638667,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1707",
        "lat": 0.550935,
        "lng": 121.637877,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1708",
        "lat": 0.581128,
        "lng": 121.640604,
        "namakomponen": null,
        "kategori": "Intake",
        "keterangan": "Suka Damai"
    },
    {
        "id": "1902",
        "lat": 0.465468,
        "lng": 121.962705,
        "namakomponen": null,
        "kategori": "Stop Kran",
        "keterangan": "50"
    },
    {
        "id": "1711",
        "lat": 0.541836,
        "lng": 121.824198,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "pelintas"
    },
    {
        "id": "1712",
        "lat": 0.541836,
        "lng": 121.824198,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": "pelintas"
    },
    {
        "id": "1713",
        "lat": 0.555977,
        "lng": 121.627062,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1714",
        "lat": 0.555737,
        "lng": 121.636789,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x75"
    },
    {
        "id": "1715",
        "lat": 0.554538,
        "lng": 121.638257,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x50"
    },
    {
        "id": "1716",
        "lat": 0.554444,
        "lng": 121.63823,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x50"
    },
    {
        "id": "1717",
        "lat": 0.552026,
        "lng": 121.642559,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1718",
        "lat": 0.552956,
        "lng": 121.641955,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x75"
    },
    {
        "id": "1719",
        "lat": 0.55066,
        "lng": 121.650026,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "75x100"
    },
    {
        "id": "1720",
        "lat": 0.545803,
        "lng": 121.649466,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1721",
        "lat": 0.54606,
        "lng": 121.649393,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1722",
        "lat": 0.546403,
        "lng": 121.649339,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1723",
        "lat": 0.546672,
        "lng": 121.649278,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1724",
        "lat": 0.546945,
        "lng": 121.649817,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1725",
        "lat": 0.546948,
        "lng": 121.650463,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1726",
        "lat": 0.546677,
        "lng": 121.650404,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1727",
        "lat": 0.546379,
        "lng": 121.650463,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1728",
        "lat": 0.563888,
        "lng": 121.634477,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "1729",
        "lat": 0.575035,
        "lng": 121.636419,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "100x75"
    },
    {
        "id": "1730",
        "lat": 0.577953,
        "lng": 121.638908,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x100"
    },
    {
        "id": "1731",
        "lat": 0.529511,
        "lng": 121.813308,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1732",
        "lat": 0.544795,
        "lng": 122.089632,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x75"
    },
    {
        "id": "1733",
        "lat": 0.544734,
        "lng": 122.089778,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "1734",
        "lat": 0.477268,
        "lng": 122.018374,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1735",
        "lat": 0.529495,
        "lng": 121.693328,
        "namakomponen": null,
        "kategori": "Reservoar",
        "keterangan": ""
    },
    {
        "id": "1736",
        "lat": 0.529629,
        "lng": 121.693275,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": ""
    },
    {
        "id": "1737",
        "lat": 0.529629,
        "lng": 121.693275,
        "namakomponen": null,
        "kategori": "IPA",
        "keterangan": ""
    },
    {
        "id": "1741",
        "lat": 0.530328,
        "lng": 121.693478,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "50x1\""
    },
    {
        "id": "1742",
        "lat": 0.514628,
        "lng": 121.689093,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1743",
        "lat": 0.516516,
        "lng": 121.687174,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1744",
        "lat": 0.523879,
        "lng": 121.686705,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1745",
        "lat": 0.523879,
        "lng": 121.686705,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1746",
        "lat": 0.523879,
        "lng": 121.686705,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1747",
        "lat": 0.523217,
        "lng": 121.687477,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1748",
        "lat": 0.522015,
        "lng": 121.688189,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1749",
        "lat": 0.526756,
        "lng": 121.692,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1750",
        "lat": 0.529814,
        "lng": 121.691131,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1751",
        "lat": 0.529379,
        "lng": 121.693315,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1752",
        "lat": 0.52917,
        "lng": 121.693428,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "150x100"
    },
    {
        "id": "1753",
        "lat": 0.52501,
        "lng": 121.786239,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1754",
        "lat": 0.524227,
        "lng": 121.782638,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1755",
        "lat": 0.52421,
        "lng": 121.782612,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1756",
        "lat": 0.527459,
        "lng": 121.802575,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1757",
        "lat": 0.526814,
        "lng": 121.801098,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1758",
        "lat": 0.52746,
        "lng": 121.802553,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1759",
        "lat": 0.529419,
        "lng": 121.804376,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1762",
        "lat": 0.485968,
        "lng": 121.82723,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1764",
        "lat": 0.49021,
        "lng": 121.811773,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1765",
        "lat": 0.490196,
        "lng": 121.811705,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1766",
        "lat": 0.490196,
        "lng": 121.811705,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1767",
        "lat": 0.490263,
        "lng": 121.811699,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1768",
        "lat": 0.519417,
        "lng": 121.809864,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1769",
        "lat": 0.489794,
        "lng": 121.809154,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1770",
        "lat": 0.493208,
        "lng": 121.810538,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1771",
        "lat": 0.534715,
        "lng": 121.833637,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1772",
        "lat": 0.534736,
        "lng": 121.833597,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1775",
        "lat": 0.50739,
        "lng": 121.369626,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1777",
        "lat": 0.493199,
        "lng": 121.415653,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1778",
        "lat": 0.480732,
        "lng": 121.441215,
        "namakomponen": null,
        "kategori": "RPR",
        "keterangan": ""
    },
    {
        "id": "1779",
        "lat": 0.480633,
        "lng": 121.441801,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1780",
        "lat": 0.481261,
        "lng": 121.440143,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1781",
        "lat": 0.482239,
        "lng": 121.441345,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1782",
        "lat": 0.48508,
        "lng": 121.443123,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "200x150"
    },
    {
        "id": "1784",
        "lat": 0.482849,
        "lng": 121.439272,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1785",
        "lat": 0.504059,
        "lng": 121.459961,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1786",
        "lat": 0.491018,
        "lng": 121.454874,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1787",
        "lat": 0.495877,
        "lng": 121.471272,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1788",
        "lat": 0.495955,
        "lng": 121.471335,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1789",
        "lat": 0.484317,
        "lng": 121.476684,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1790",
        "lat": 0.484442,
        "lng": 121.477285,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1791",
        "lat": 0.495534,
        "lng": 121.4678,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1792",
        "lat": 0.507531,
        "lng": 121.47344,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1793",
        "lat": 0.507531,
        "lng": 121.47344,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1794",
        "lat": 0.507362,
        "lng": 121.473258,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1795",
        "lat": 0.507433,
        "lng": 121.472518,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1796",
        "lat": 0.508444,
        "lng": 121.472656,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1797",
        "lat": 0.510184,
        "lng": 121.47127,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "150x50"
    },
    {
        "id": "1798",
        "lat": 0.510297,
        "lng": 121.471309,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": "100x75"
    },
    {
        "id": "1799",
        "lat": 0.512659,
        "lng": 121.470391,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1800",
        "lat": 0.527648,
        "lng": 121.484067,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1801",
        "lat": 0.551293,
        "lng": 121.4757,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1802",
        "lat": 0.539136,
        "lng": 121.484542,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1803",
        "lat": 0.521669,
        "lng": 121.488056,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1804",
        "lat": 0.505706,
        "lng": 121.492138,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1805",
        "lat": 0.495898,
        "lng": 121.493132,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1806",
        "lat": 0.515997,
        "lng": 121.459364,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1807",
        "lat": 0.515968,
        "lng": 121.459284,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1808",
        "lat": 0.516604,
        "lng": 121.447037,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1809",
        "lat": 0.506553,
        "lng": 121.43988,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1810",
        "lat": 0.506923,
        "lng": 121.450153,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1812",
        "lat": 0.564106,
        "lng": 121.547922,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1813",
        "lat": 0.562904,
        "lng": 121.55153,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1814",
        "lat": 0.540188,
        "lng": 121.56864,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1815",
        "lat": 0.540389,
        "lng": 121.570306,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1816",
        "lat": 0.539802,
        "lng": 121.569501,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1817",
        "lat": 0.541677,
        "lng": 121.572242,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1818",
        "lat": 0.543611,
        "lng": 121.574244,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1819",
        "lat": 0.547684,
        "lng": 121.576998,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1820",
        "lat": 0.550641,
        "lng": 121.576358,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1821",
        "lat": 0.541074,
        "lng": 121.581981,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1822",
        "lat": 0.541074,
        "lng": 121.581981,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1823",
        "lat": 0.541074,
        "lng": 121.581981,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1824",
        "lat": 0.540495,
        "lng": 121.579658,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1825",
        "lat": 0.5405,
        "lng": 121.580704,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1826",
        "lat": 0.538913,
        "lng": 121.581364,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1827",
        "lat": 0.538913,
        "lng": 121.581364,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1828",
        "lat": 0.537058,
        "lng": 121.571778,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1829",
        "lat": 0.535946,
        "lng": 121.571129,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1830",
        "lat": 0.534011,
        "lng": 121.570865,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1831",
        "lat": 0.533414,
        "lng": 121.696466,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1832",
        "lat": 0.51381,
        "lng": 121.772445,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1833",
        "lat": 0.512386,
        "lng": 121.769795,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1834",
        "lat": 0.523469,
        "lng": 121.779616,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1835",
        "lat": 0.519767,
        "lng": 121.778458,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1836",
        "lat": 0.528029,
        "lng": 121.814552,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1837",
        "lat": 0.530346,
        "lng": 121.813838,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1838",
        "lat": 0.53171,
        "lng": 121.814022,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1839",
        "lat": 0.530128,
        "lng": 121.818933,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1842",
        "lat": 0.494109,
        "lng": 121.915075,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1843",
        "lat": 0.48372,
        "lng": 121.918314,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1844",
        "lat": 0.481823,
        "lng": 121.916977,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1845",
        "lat": 0.484562,
        "lng": 121.911261,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1846",
        "lat": 0.487912,
        "lng": 121.915161,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1847",
        "lat": 0.487664,
        "lng": 121.914452,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1848",
        "lat": 0.486893,
        "lng": 121.914151,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": ""
    },
    {
        "id": "1849",
        "lat": 0.46196,
        "lng": 121.932755,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1850",
        "lat": 0.467287,
        "lng": 121.934071,
        "namakomponen": null,
        "kategori": "pipa pelintas",
        "keterangan": ""
    },
    {
        "id": "1851",
        "lat": 0.465174,
        "lng": 121.934694,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1853",
        "lat": 0.450273,
        "lng": 121.940339,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1855",
        "lat": 0.463316,
        "lng": 121.950205,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1864",
        "lat": 0.46012,
        "lng": 121.955081,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1865",
        "lat": 0.458829,
        "lng": 121.943593,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1866",
        "lat": 0.456429,
        "lng": 121.94939,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1867",
        "lat": 0.457217,
        "lng": 121.948381,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1868",
        "lat": 0.457988,
        "lng": 121.949523,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1869",
        "lat": 0.458763,
        "lng": 121.949567,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1870",
        "lat": 0.458932,
        "lng": 121.949535,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1871",
        "lat": 0.462444,
        "lng": 121.947941,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1872",
        "lat": 0.462855,
        "lng": 121.948661,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1873",
        "lat": 0.464457,
        "lng": 121.94755,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1874",
        "lat": 0.464457,
        "lng": 121.94755,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1875",
        "lat": 0.464457,
        "lng": 121.94755,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1876",
        "lat": 0.464754,
        "lng": 121.947551,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1877",
        "lat": 0.464084,
        "lng": 121.947355,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1878",
        "lat": 0.464215,
        "lng": 121.947275,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1879",
        "lat": 0.459094,
        "lng": 121.947585,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1880",
        "lat": 0.459402,
        "lng": 121.947608,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1881",
        "lat": 0.462446,
        "lng": 121.947214,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1882",
        "lat": 0.461047,
        "lng": 121.944966,
        "namakomponen": null,
        "kategori": "Testek",
        "keterangan": ""
    },
    {
        "id": "1883",
        "lat": 0.447118,
        "lng": 121.937741,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1884",
        "lat": 0.448194,
        "lng": 121.938616,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1885",
        "lat": 0.447912,
        "lng": 121.939713,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1886",
        "lat": 0.447931,
        "lng": 121.939736,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1887",
        "lat": 0.446062,
        "lng": 121.938908,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1888",
        "lat": 0.44541,
        "lng": 121.939252,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1889",
        "lat": 0.44541,
        "lng": 121.939252,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1892",
        "lat": 0.464459,
        "lng": 121.951769,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75X50"
    },
    {
        "id": "1895",
        "lat": 0.56336,
        "lng": 121.567671,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": "150"
    },
    {
        "id": "1896",
        "lat": 0.560251,
        "lng": 121.552941,
        "namakomponen": null,
        "kategori": "Meter Induk",
        "keterangan": ""
    },
    {
        "id": "1897",
        "lat": 0.563703,
        "lng": 121.56783,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    },
    {
        "id": "1898",
        "lat": 0.545154,
        "lng": 121.572844,
        "namakomponen": null,
        "kategori": "Reduser",
        "keterangan": "75x50"
    },
    {
        "id": "1899",
        "lat": 0.510215,
        "lng": 121.474826,
        "namakomponen": null,
        "kategori": "Dop",
        "keterangan": ""
    }
];

export const PIPA_DATA: PipaGeoJSON =  {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": {
                "id": 3,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002300321174789721,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.929310829357,
                        0.479492311934773
                    ],
                    [
                        121.929189633441,
                        0.479540095039401
                    ],
                    [
                        121.929100821883,
                        0.479572188243627
                    ],
                    [
                        121.927159443522,
                        0.48030650511697
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 4,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0014528123562523416,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92716196127,
                        0.48030337514286
                    ],
                    [
                        121.9270467636,
                        0.48035082198259
                    ],
                    [
                        121.92697629333,
                        0.48037264225517
                    ],
                    [
                        121.92685961723,
                        0.48041957926305
                    ],
                    [
                        121.9267308712,
                        0.48046517521325
                    ],
                    [
                        121.92634999752,
                        0.48061671469263
                    ],
                    [
                        121.92593425512,
                        0.48080714483009
                    ],
                    [
                        121.92583782792,
                        0.48088655459032
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 5,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.007978995151361681,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.922428774731,
                        0.486562937782988
                    ],
                    [
                        121.922148071063,
                        0.486405594511263
                    ],
                    [
                        121.921984878562,
                        0.48630949261612
                    ],
                    [
                        121.921694428374,
                        0.486131802288394
                    ],
                    [
                        121.920889536578,
                        0.48556968228653
                    ],
                    [
                        121.920339642457,
                        0.485181238392032
                    ],
                    [
                        121.916375221774,
                        0.482314334414471
                    ],
                    [
                        121.916696891775,
                        0.481831829412592
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 10,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003792187376549306,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.915774209257,
                        0.47289485641207
                    ],
                    [
                        121.916065493193,
                        0.473283838491958
                    ],
                    [
                        121.916425437837,
                        0.473786305751973
                    ],
                    [
                        121.916767730068,
                        0.474346086482641
                    ],
                    [
                        121.917087481692,
                        0.474855890583567
                    ],
                    [
                        121.917264382432,
                        0.475176841474584
                    ],
                    [
                        121.917424047811,
                        0.475370052224791
                    ],
                    [
                        121.917884169723,
                        0.476040441664907
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 11,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002397465779111144,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.917883204014,
                        0.476050282638739
                    ],
                    [
                        121.917902456505,
                        0.476071016993851
                    ],
                    [
                        121.917921785562,
                        0.476091834391172
                    ],
                    [
                        121.917941191736,
                        0.476112734100557
                    ],
                    [
                        121.917965814427,
                        0.476133376816356
                    ],
                    [
                        121.917990531296,
                        0.476154098707219
                    ],
                    [
                        121.918011601162,
                        0.476182660352529
                    ],
                    [
                        121.918026188254,
                        0.476204273227318
                    ],
                    [
                        121.919483154047,
                        0.477834341418475
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 12,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00341211900110321,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92407647524,
                        0.4746014530504
                    ],
                    [
                        121.92409783379,
                        0.47459151133381
                    ],
                    [
                        121.92412383604,
                        0.47455550927357
                    ],
                    [
                        121.92520201206,
                        0.47429496755093
                    ],
                    [
                        121.92627779536,
                        0.47403881257992
                    ],
                    [
                        121.92736655474,
                        0.47373976928573
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 14,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0005726147606183401,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92588710854,
                        0.480755385176697
                    ],
                    [
                        121.92588093597,
                        0.480741729135128
                    ],
                    [
                        121.925621611047,
                        0.480248069206445
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 18,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002613805279693848,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.928392766091,
                        0.467988294716967
                    ],
                    [
                        121.928324333163,
                        0.467984745912752
                    ],
                    [
                        121.928267668808,
                        0.467983138965699
                    ],
                    [
                        121.925780009275,
                        0.467914974002242
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 20,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0008447854363757477,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933670594865,
                        0.479034983558671
                    ],
                    [
                        121.933623840505,
                        0.47895830640721
                    ],
                    [
                        121.93356493001,
                        0.478861057337064
                    ],
                    [
                        121.933186907342,
                        0.478343046044607
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 22,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0011624850683721799,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93010775168,
                        0.46438712796608
                    ],
                    [
                        121.93008534584,
                        0.46436009013609
                    ],
                    [
                        121.93006822607,
                        0.46433866380434
                    ],
                    [
                        121.93004517259,
                        0.46431938478512
                    ],
                    [
                        121.93002240234,
                        0.46430203860387
                    ],
                    [
                        121.92999464689,
                        0.46427542417715
                    ],
                    [
                        121.92996523808,
                        0.46424967330757
                    ],
                    [
                        121.92994300251,
                        0.46423258537445
                    ],
                    [
                        121.92991370062,
                        0.46420692559991
                    ],
                    [
                        121.92988355742,
                        0.46419004320311
                    ],
                    [
                        121.92985786589,
                        0.46416548624178
                    ],
                    [
                        121.92982545811,
                        0.46413862117293
                    ],
                    [
                        121.92979850121,
                        0.46411624748414
                    ],
                    [
                        121.92973837671,
                        0.46406759028692
                    ],
                    [
                        121.92963166938,
                        0.46409913589813
                    ],
                    [
                        121.92954120844,
                        0.4641426586752
                    ],
                    [
                        121.9293922258,
                        0.46421092872727
                    ],
                    [
                        121.92910617414,
                        0.4642894393887
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 24,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.01296025243451319,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92631531639,
                        0.45385509737226
                    ],
                    [
                        121.9263093082,
                        0.45377627699641
                    ],
                    [
                        121.92641780362,
                        0.45372425181621
                    ],
                    [
                        121.92753612397,
                        0.45368732415473
                    ],
                    [
                        121.92794778955,
                        0.45370376787641
                    ],
                    [
                        121.92809608878,
                        0.45376911168837
                    ],
                    [
                        121.92824977924,
                        0.45382295192497
                    ],
                    [
                        121.92840094865,
                        0.45382330686063
                    ],
                    [
                        121.92915950416,
                        0.45360344648458
                    ],
                    [
                        121.92987769241,
                        0.45340536818526
                    ],
                    [
                        121.93017590036,
                        0.45331271209433
                    ],
                    [
                        121.93024756918,
                        0.45321070363893
                    ],
                    [
                        121.93024290195,
                        0.45298261337378
                    ],
                    [
                        121.93005880074,
                        0.45029171128943
                    ],
                    [
                        121.93005892069,
                        0.45006843616787
                    ],
                    [
                        121.93022991308,
                        0.4499226767177
                    ],
                    [
                        121.93034016849,
                        0.44982810485581
                    ],
                    [
                        121.93049572178,
                        0.44967878518555
                    ],
                    [
                        121.9309592478,
                        0.44927309451043
                    ],
                    [
                        121.93122208269,
                        0.44908062859075
                    ],
                    [
                        121.93141796445,
                        0.44901299908803
                    ],
                    [
                        121.93155860601,
                        0.44896003159743
                    ],
                    [
                        121.93170041443,
                        0.44891783844606
                    ],
                    [
                        121.93180862815,
                        0.44890078164763
                    ],
                    [
                        121.9319175259,
                        0.44888255008648
                    ],
                    [
                        121.9319845543,
                        0.44886142616504
                    ],
                    [
                        121.93217539347,
                        0.44883079210501
                    ],
                    [
                        121.93242128495,
                        0.44872579915174
                    ],
                    [
                        121.93284063483,
                        0.44853694153564
                    ],
                    [
                        121.93307040635,
                        0.44820758523613
                    ],
                    [
                        121.93329557835,
                        0.44766017264432
                    ],
                    [
                        121.9338441174,
                        0.44696287269098
                    ],
                    [
                        121.93410962074,
                        0.44652829845336
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2074,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0010619864018977748,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94064564859,
                        0.47195409918121
                    ],
                    [
                        121.9405221462,
                        0.47167642103511
                    ],
                    [
                        121.94036188798,
                        0.47133972190252
                    ],
                    [
                        121.94019514473,
                        0.47099249386438
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2085,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00015965885437011371,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0146510005,
                        0.47708302773001
                    ],
                    [
                        122.01449409127,
                        0.47705352445359
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2086,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 2.7647521173345164e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01445922256,
                        0.47704547810546
                    ],
                    [
                        122.01448604465,
                        0.47705218339557
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2088,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0012965314184900782,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10719391704,
                        0.53741829324868
                    ],
                    [
                        122.10717245936,
                        0.53750546120642
                    ],
                    [
                        122.10696190596,
                        0.53771198220902
                    ],
                    [
                        122.10682108998,
                        0.53787156661534
                    ],
                    [
                        122.10672989488,
                        0.53797214502055
                    ],
                    [
                        122.10665211082,
                        0.53804187938051
                    ],
                    [
                        122.10654616356,
                        0.53815184510038
                    ],
                    [
                        122.10651263595,
                        0.53818537123409
                    ],
                    [
                        122.10641607642,
                        0.53807004133335
                    ],
                    [
                        122.10639730096,
                        0.53803517415362
                    ],
                    [
                        122.10637047887,
                        0.53798689651984
                    ],
                    [
                        122.10637047887,
                        0.53797348606595
                    ],
                    [
                        122.10637047887,
                        0.53797348606595
                    ],
                    [
                        122.10637047887,
                        0.53797348606595
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2087,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008720228235383452,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10974872112,
                        0.53818268914341
                    ],
                    [
                        122.11012288928,
                        0.53824705931964
                    ],
                    [
                        122.1106056869,
                        0.53834361458272
                    ],
                    [
                        122.1106056869,
                        0.53834361458272
                    ],
                    [
                        122.1106056869,
                        0.53834361458272
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 26,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006176096530286574,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92975843153,
                        0.46408829056006
                    ],
                    [
                        121.92964940569,
                        0.46398261295799
                    ],
                    [
                        121.92956123427,
                        0.46387498165041
                    ],
                    [
                        121.92951989624,
                        0.46375272319904
                    ],
                    [
                        121.92947062779,
                        0.46361657288909
                    ],
                    [
                        121.92943392732,
                        0.46354465109495
                    ],
                    [
                        121.92939161521,
                        0.46343091967953
                    ],
                    [
                        121.92935320653,
                        0.4632985264478
                    ],
                    [
                        121.92772291314,
                        0.45828563458101
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 29,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013793307013520268,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92941542303,
                        0.46326393189384
                    ],
                    [
                        121.92966629036,
                        0.46320263333691
                    ],
                    [
                        121.93075687012,
                        0.46294289762356
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 33,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001293929285538574,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93469569087,
                        0.46517174095155
                    ],
                    [
                        121.93473858325,
                        0.46516229754575
                    ],
                    [
                        121.93595230579,
                        0.46486329633004
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 36,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0062218347576959675,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93625607633,
                        0.46650634081995
                    ],
                    [
                        121.93640291691,
                        0.46682133344948
                    ],
                    [
                        121.93649679422,
                        0.46679585554091
                    ],
                    [
                        121.9362528382,
                        0.46623434092884
                    ],
                    [
                        121.93614797734,
                        0.46578241072986
                    ],
                    [
                        121.93606208041,
                        0.46499301265365
                    ],
                    [
                        121.93604150849,
                        0.46486023026942
                    ],
                    [
                        121.9356877672,
                        0.46110440844206
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 40,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.010688964711347285,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93785820526,
                        0.46709348330591
                    ],
                    [
                        121.93743524165,
                        0.46361491509888
                    ],
                    [
                        121.93715987655,
                        0.46157710538239
                    ],
                    [
                        121.93707748577,
                        0.46098667082977
                    ],
                    [
                        121.93699854835,
                        0.46034601995179
                    ],
                    [
                        121.93698073179,
                        0.46009428798486
                    ],
                    [
                        121.93698552624,
                        0.45981955546799
                    ],
                    [
                        121.93698456284,
                        0.45964713351397
                    ],
                    [
                        121.93698801625,
                        0.45939905365849
                    ],
                    [
                        121.93699874508,
                        0.45925230375287
                    ],
                    [
                        121.93701253606,
                        0.45911321614369
                    ],
                    [
                        121.93702326262,
                        0.45902125856703
                    ],
                    [
                        121.93704950587,
                        0.45889577673293
                    ],
                    [
                        121.93708647346,
                        0.45875687271276
                    ],
                    [
                        121.93715199983,
                        0.45849038652701
                    ],
                    [
                        121.93720871956,
                        0.45825551085169
                    ],
                    [
                        121.93727673807,
                        0.45800990435349
                    ],
                    [
                        121.9377628506,
                        0.45657311030552
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 41,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.005517798305323374,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93713238009,
                        0.45881563689352
                    ],
                    [
                        121.93924909942,
                        0.45941921611433
                    ],
                    [
                        121.93939267143,
                        0.45945947298589
                    ],
                    [
                        121.93957735145,
                        0.45952828996584
                    ],
                    [
                        121.9397628665,
                        0.45958248650515
                    ],
                    [
                        121.93988595643,
                        0.4596315473067
                    ],
                    [
                        121.94008495282,
                        0.45968735550723
                    ],
                    [
                        121.94023186757,
                        0.45973257913025
                    ],
                    [
                        121.94030746895,
                        0.45976546264128
                    ],
                    [
                        121.94242596845,
                        0.4603657330951
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 42,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0016789937180450203,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94315378183,
                        0.46057051768004
                    ],
                    [
                        121.94383652292,
                        0.46076749677664
                    ],
                    [
                        121.94476892134,
                        0.46102911033954
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 43,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0021467717786264775,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94722898302,
                        0.46244047750248
                    ],
                    [
                        121.94697968511,
                        0.46243607737745
                    ],
                    [
                        121.94508583095,
                        0.46231956062666
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 44,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.001601798182089361,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94508353767,
                        0.46231916184041
                    ],
                    [
                        121.9449737281,
                        0.46228178956326
                    ],
                    [
                        121.94495062079,
                        0.46221400447872
                    ],
                    [
                        121.94496519864,
                        0.46200760181492
                    ],
                    [
                        121.94502088129,
                        0.46105625935105
                    ],
                    [
                        121.94476788195,
                        0.46103056871172
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 50,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006741646730234347,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941218618846,
                        0.47660866601285
                    ],
                    [
                        121.941220021477,
                        0.476609133556457
                    ],
                    [
                        121.941917596538,
                        0.478634532459694
                    ],
                    [
                        121.941999884212,
                        0.478967423507502
                    ],
                    [
                        121.942358957702,
                        0.480618787525561
                    ],
                    [
                        121.942740473285,
                        0.48207939375218
                    ],
                    [
                        121.942964894216,
                        0.483110794948058
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 57,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0009819858941439896,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93709976101,
                        0.46820115700642
                    ],
                    [
                        121.936999231014,
                        0.46795328670781
                    ],
                    [
                        121.936910812952,
                        0.467740313832309
                    ],
                    [
                        121.93678794424,
                        0.467446902855846
                    ],
                    [
                        121.936723187069,
                        0.467294262284708
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 60,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004364472765585322,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938163692137,
                        0.46715685490561
                    ],
                    [
                        121.938309908614,
                        0.467138298359012
                    ],
                    [
                        121.942451411115,
                        0.466343471300818
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 61,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012769936247903342,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942449991156,
                        0.466344315447565
                    ],
                    [
                        121.942647104315,
                        0.466340907147831
                    ],
                    [
                        121.942803633004,
                        0.46634024072759
                    ],
                    [
                        121.943114134399,
                        0.466336354035264
                    ],
                    [
                        121.943726742119,
                        0.466321197960736
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 73,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0019568418450631384,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94631630779,
                        0.47351099149221
                    ],
                    [
                        121.94680441613,
                        0.47344823806908
                    ],
                    [
                        121.94712800614,
                        0.47341553429444
                    ],
                    [
                        121.94716171336,
                        0.47342791162814
                    ],
                    [
                        121.94826134798,
                        0.47333479859896
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2068,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribus",
                "panjang": 0.0018064848981450671,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94201146985,
                        0.50804677380033
                    ],
                    [
                        121.94181565539,
                        0.50787253098558
                    ],
                    [
                        121.94161447615,
                        0.50767684289571
                    ],
                    [
                        121.94123270654,
                        0.50732933860095
                    ],
                    [
                        121.94098949667,
                        0.50708081906363
                    ],
                    [
                        121.94086878912,
                        0.50697091204153
                    ],
                    [
                        121.94086878912,
                        0.50697091204153
                    ],
                    [
                        121.940714246,
                        0.50679189128519
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 75,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.005185894719565319,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95064813365,
                        0.47328380651207
                    ],
                    [
                        121.95072180274,
                        0.47327506555923
                    ],
                    [
                        121.95075409167,
                        0.47326681263483
                    ],
                    [
                        121.95080061946,
                        0.47325055893595
                    ],
                    [
                        121.95084126535,
                        0.47324235603757
                    ],
                    [
                        121.95087646393,
                        0.47323423274774
                    ],
                    [
                        121.95091851086,
                        0.4732183072394
                    ],
                    [
                        121.95095846631,
                        0.47320639514995
                    ],
                    [
                        121.95098439708,
                        0.47320042666932
                    ],
                    [
                        121.95101325646,
                        0.47319981240301
                    ],
                    [
                        121.95106041125,
                        0.47319037749243
                    ],
                    [
                        121.95109665036,
                        0.4731870284458
                    ],
                    [
                        121.95112403759,
                        0.47318140753702
                    ],
                    [
                        121.95116380935,
                        0.47318168076957
                    ],
                    [
                        121.95120158586,
                        0.47317807477527
                    ],
                    [
                        121.9512337924,
                        0.47317058708361
                    ],
                    [
                        121.9512695051,
                        0.4731650683775
                    ],
                    [
                        121.95132428822,
                        0.47316160478224
                    ],
                    [
                        121.95135662188,
                        0.47315852640028
                    ],
                    [
                        121.95138819813,
                        0.47315875944802
                    ],
                    [
                        121.95141761221,
                        0.47315077469022
                    ],
                    [
                        121.95145980221,
                        0.47314535156807
                    ],
                    [
                        121.9515020214,
                        0.47315133051427
                    ],
                    [
                        121.95152508221,
                        0.47315529555827
                    ],
                    [
                        121.95156203704,
                        0.473159362844
                    ],
                    [
                        121.95159663735,
                        0.47315959300693
                    ],
                    [
                        121.9516428151,
                        0.47316565405783
                    ],
                    [
                        121.9516844861,
                        0.47316971589068
                    ],
                    [
                        121.95171556322,
                        0.47316971266838
                    ],
                    [
                        121.95175373785,
                        0.47317885299801
                    ],
                    [
                        121.9517878801,
                        0.47318129858033
                    ],
                    [
                        121.9518180353,
                        0.47318784897058
                    ],
                    [
                        121.95183380076,
                        0.47318784581243
                    ],
                    [
                        121.9518978081,
                        0.47319686494283
                    ],
                    [
                        121.95192705154,
                        0.4731949068997
                    ],
                    [
                        121.95197051926,
                        0.47320586857268
                    ],
                    [
                        121.95202055842,
                        0.47321059600222
                    ],
                    [
                        121.9520553706,
                        0.47321849421334
                    ],
                    [
                        121.95209867733,
                        0.4732244391478
                    ],
                    [
                        121.95213686007,
                        0.47323040458414
                    ],
                    [
                        121.95216320524,
                        0.47323040163984
                    ],
                    [
                        121.9521880173,
                        0.47323297527672
                    ],
                    [
                        121.95223319296,
                        0.473246407452
                    ],
                    [
                        121.95226219984,
                        0.473251109566
                    ],
                    [
                        121.95232908584,
                        0.47325445904372
                    ],
                    [
                        121.9523655061,
                        0.47326661712529
                    ],
                    [
                        121.95239683295,
                        0.473278858675
                    ],
                    [
                        121.9524221752,
                        0.47328295607257
                    ],
                    [
                        121.95245718464,
                        0.47329324346024
                    ],
                    [
                        121.95250340523,
                        0.47330566519925
                    ],
                    [
                        121.95253582247,
                        0.47332026771056
                    ],
                    [
                        121.95256227016,
                        0.47333322121266
                    ],
                    [
                        121.95261780271,
                        0.47334986380581
                    ],
                    [
                        121.95266217105,
                        0.4733650719879
                    ],
                    [
                        121.9527067512,
                        0.47337970761735
                    ],
                    [
                        121.95274236643,
                        0.47339831318595
                    ],
                    [
                        121.95277806379,
                        0.4734169617414
                    ],
                    [
                        121.95280662565,
                        0.47342911206404
                    ],
                    [
                        121.95284788416,
                        0.47344514123674
                    ],
                    [
                        121.95554549391,
                        0.47457358761977
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 76,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0075986540322186555,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9470621228,
                        0.46662754112062
                    ],
                    [
                        121.94754985564,
                        0.46669496092277
                    ],
                    [
                        121.94809718725,
                        0.4667531609557
                    ],
                    [
                        121.95273504851,
                        0.4674996674906
                    ],
                    [
                        121.95297982691,
                        0.46753769580345
                    ],
                    [
                        121.95305498242,
                        0.46754649283171
                    ],
                    [
                        121.95315518971,
                        0.46755266123461
                    ],
                    [
                        121.95329804421,
                        0.46756435415531
                    ],
                    [
                        121.95351020692,
                        0.46756961148787
                    ],
                    [
                        121.95368855688,
                        0.46759365997947
                    ],
                    [
                        121.95458756073,
                        0.46759162001843
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 79,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.002465326688971537,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9355459499,
                        0.46739253572869
                    ],
                    [
                        121.93607568741,
                        0.46737778406991
                    ],
                    [
                        121.93670332432,
                        0.46727049927804
                    ],
                    [
                        121.93685621048,
                        0.46723294960049
                    ],
                    [
                        121.93783655689,
                        0.46707202240873
                    ],
                    [
                        121.93798273728,
                        0.46705056544956
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 81,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0011148110641201361,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94243118167,
                        0.46621776717082
                    ],
                    [
                        121.94325447427,
                        0.46619496914891
                    ],
                    [
                        121.94354562773,
                        0.46620033338938
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 89,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.009359172758483742,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9596302523,
                        0.45888478920696
                    ],
                    [
                        121.95956762729,
                        0.45874396128618
                    ],
                    [
                        121.95911535327,
                        0.45820445971125
                    ],
                    [
                        121.9586973846,
                        0.45776729140731
                    ],
                    [
                        121.95820871282,
                        0.45728819874887
                    ],
                    [
                        121.9572378337,
                        0.45653859771266
                    ],
                    [
                        121.95642729684,
                        0.45601102123707
                    ],
                    [
                        121.95587211991,
                        0.45566591560217
                    ],
                    [
                        121.95576367153,
                        0.45548066555719
                    ],
                    [
                        121.95570983066,
                        0.45533658380517
                    ],
                    [
                        121.95568175014,
                        0.45514916154049
                    ],
                    [
                        121.95570677519,
                        0.45503868129439
                    ],
                    [
                        121.9557347484,
                        0.4549631936388
                    ],
                    [
                        121.9559018187,
                        0.45468253357284
                    ],
                    [
                        121.95675552562,
                        0.45395759438507
                    ],
                    [
                        121.95712339715,
                        0.45365840123885
                    ],
                    [
                        121.95731667067,
                        0.45345048391099
                    ],
                    [
                        121.95735632479,
                        0.4533458785081
                    ],
                    [
                        121.9573113017,
                        0.4529245912727
                    ],
                    [
                        121.95724562562,
                        0.45241225882921
                    ],
                    [
                        121.95718582352,
                        0.45206133756053
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 96,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0019161795938658335,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94964364269,
                        0.45666667201672
                    ],
                    [
                        121.94963157864,
                        0.45643070415894
                    ],
                    [
                        121.94953679457,
                        0.45642806405611
                    ],
                    [
                        121.94795304541,
                        0.45636305784443
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1860,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0008766589725552722,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95198777198,
                        0.45933547665333
                    ],
                    [
                        121.95183352237,
                        0.45930062002154
                    ],
                    [
                        121.95167927276,
                        0.45925503827205
                    ],
                    [
                        121.95140854192,
                        0.45917987478886
                    ],
                    [
                        121.95126239177,
                        0.45914231692711
                    ],
                    [
                        121.95114165584,
                        0.45911818686695
                    ],
                    [
                        121.95114433883,
                        0.45911818686695
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 97,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003015959491306469,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.947907718844,
                        0.456352178327795
                    ],
                    [
                        121.947893964714,
                        0.45633279658295
                    ],
                    [
                        121.947869908238,
                        0.456296059981811
                    ],
                    [
                        121.947852206816,
                        0.456269748861252
                    ],
                    [
                        121.947836634983,
                        0.456250913570381
                    ],
                    [
                        121.947811581444,
                        0.456233185543357
                    ],
                    [
                        121.947783333986,
                        0.456221231627886
                    ],
                    [
                        121.947754315785,
                        0.456219162264482
                    ],
                    [
                        121.947721581808,
                        0.456219068872793
                    ],
                    [
                        121.947695395241,
                        0.456218994165973
                    ],
                    [
                        121.947667035377,
                        0.45621767393823
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 100,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0036589659885734463,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94795653715,
                        0.45147681917924
                    ],
                    [
                        121.94800481691,
                        0.45007540834237
                    ],
                    [
                        121.94800079433,
                        0.45001774262752
                    ],
                    [
                        121.94799006599,
                        0.4499815339226
                    ],
                    [
                        121.94798067369,
                        0.44994800650037
                    ],
                    [
                        121.94795384748,
                        0.44989035259298
                    ],
                    [
                        121.94793775265,
                        0.44985683107455
                    ],
                    [
                        121.9479109284,
                        0.44982062658615
                    ],
                    [
                        121.94788142037,
                        0.44978442251931
                    ],
                    [
                        121.94778381141,
                        0.44974941582198
                    ],
                    [
                        121.94769943592,
                        0.44971899864379
                    ],
                    [
                        121.94753031585,
                        0.44965026149424
                    ],
                    [
                        121.94722826561,
                        0.44953559022526
                    ],
                    [
                        121.94694262362,
                        0.44941723860913
                    ],
                    [
                        121.94607410431,
                        0.44909728682373
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 101,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.0029474625488446465,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93999848949,
                        0.48180907310567
                    ],
                    [
                        121.94067069589,
                        0.48119106604472
                    ],
                    [
                        121.94260722845,
                        0.48056786639785
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 102,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.003565363762360049,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9426168151,
                        0.4805671002971
                    ],
                    [
                        121.94309226126,
                        0.48045024554116
                    ],
                    [
                        121.94342301113,
                        0.48035714554327
                    ],
                    [
                        121.94606833085,
                        0.47967376553374
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 103,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.003064715285696216,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94605495333,
                        0.47967677814503
                    ],
                    [
                        121.94631110429,
                        0.4795821940864
                    ],
                    [
                        121.94661604467,
                        0.47934927061973
                    ],
                    [
                        121.94685870404,
                        0.47915649149899
                    ],
                    [
                        121.94764544959,
                        0.47862363590332
                    ],
                    [
                        121.94817920923,
                        0.47811235523643
                    ],
                    [
                        121.94835087065,
                        0.47804091100661
                    ],
                    [
                        121.94856151788,
                        0.47796848805927
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 104,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.008636713075764569,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94857269147,
                        0.47796371777054
                    ],
                    [
                        121.94799023339,
                        0.47722688735697
                    ],
                    [
                        121.94744884339,
                        0.47662347849656
                    ],
                    [
                        121.9472292401,
                        0.47638204094676
                    ],
                    [
                        121.94710602165,
                        0.47618702134141
                    ],
                    [
                        121.94712385384,
                        0.47606019087976
                    ],
                    [
                        121.94717117249,
                        0.4759373767475
                    ],
                    [
                        121.94730991643,
                        0.47572664298535
                    ],
                    [
                        121.94736214183,
                        0.47555295254943
                    ],
                    [
                        121.94733221904,
                        0.47506296684985
                    ],
                    [
                        121.94704051763,
                        0.47227919010007
                    ],
                    [
                        121.94698289037,
                        0.47119578053144
                    ],
                    [
                        121.94680643004,
                        0.46994667876369
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 105,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.01853261117307106,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94680489674,
                        0.46994974353963
                    ],
                    [
                        121.94679799988,
                        0.46947912043906
                    ],
                    [
                        121.94684073329,
                        0.46879796634793
                    ],
                    [
                        121.94686294862,
                        0.46811977280624
                    ],
                    [
                        121.94708605902,
                        0.46653408676296
                    ],
                    [
                        121.94762069345,
                        0.45905754656949
                    ],
                    [
                        121.94806341581,
                        0.45146649521051
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 106,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013439028569205164,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94800591171,
                        0.45005829033757
                    ],
                    [
                        121.94817607104,
                        0.45004898173949
                    ],
                    [
                        121.9482752055,
                        0.44997705494609
                    ],
                    [
                        121.94857708815,
                        0.44996852224168
                    ],
                    [
                        121.94860159329,
                        0.44986083739482
                    ],
                    [
                        121.94878132487,
                        0.44990372948615
                    ],
                    [
                        121.94896373708,
                        0.44995734249129
                    ],
                    [
                        121.94922387836,
                        0.45000028940704
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2067,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0014477369029664484,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95239855202,
                        0.47905600198372
                    ],
                    [
                        121.95207510441,
                        0.47900792334239
                    ],
                    [
                        121.95186447055,
                        0.47899007988593
                    ],
                    [
                        121.95178643146,
                        0.47905214834131
                    ],
                    [
                        121.95178698151,
                        0.47944313393192
                    ],
                    [
                        121.95170059499,
                        0.47948373625218
                    ],
                    [
                        121.95170327738,
                        0.47960704707884
                    ],
                    [
                        121.9516979126,
                        0.47975716460397
                    ],
                    [
                        121.9516949013,
                        0.47980671602047
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 111,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0010054093582747346,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942866463138,
                        0.448849362876437
                    ],
                    [
                        121.942922622524,
                        0.448858223736806
                    ],
                    [
                        121.943676156491,
                        0.44888332451444
                    ],
                    [
                        121.943870370229,
                        0.448871016953884
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 112,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0007625729669367385,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94405393344,
                        0.44883895646571
                    ],
                    [
                        121.94421488543,
                        0.44882823048923
                    ],
                    [
                        121.9445113098,
                        0.44878935061669
                    ],
                    [
                        121.94463460813,
                        0.448790665111
                    ],
                    [
                        121.94473654051,
                        0.44878262590023
                    ],
                    [
                        121.94481299369,
                        0.44878932868668
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 119,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0018993516477764003,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94326156673,
                        0.44884011974585
                    ],
                    [
                        121.94269348827,
                        0.44881268128226
                    ],
                    [
                        121.94236411294,
                        0.44879350253996
                    ],
                    [
                        121.94216611239,
                        0.4487557833352
                    ],
                    [
                        121.94199819937,
                        0.44871137758056
                    ],
                    [
                        121.94178686142,
                        0.44864308778388
                    ],
                    [
                        121.94140336585,
                        0.44851815132247
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2064,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribus",
                "panjang": 0.00255189626210804,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94739191939,
                        0.46164064928684
                    ],
                    [
                        121.94742410433,
                        0.46111502618428
                    ],
                    [
                        121.94744422443,
                        0.46080526413613
                    ],
                    [
                        121.94746300264,
                        0.46056655570249
                    ],
                    [
                        121.94747641015,
                        0.46030771460749
                    ],
                    [
                        121.94749786625,
                        0.46003816129557
                    ],
                    [
                        121.94753407921,
                        0.4595835591472
                    ],
                    [
                        121.94755285311,
                        0.45925902455122
                    ],
                    [
                        121.94758102062,
                        0.45909673621588
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 122,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.003338624387131632,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93990454628,
                        0.44767088537165
                    ],
                    [
                        121.93986295711,
                        0.44764138649599
                    ],
                    [
                        121.93804588159,
                        0.4461682862018
                    ],
                    [
                        121.93720366358,
                        0.44573213596654
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 124,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0005060122028538519,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93810612061,
                        0.44687026928767
                    ],
                    [
                        121.938185256,
                        0.44677507906694
                    ],
                    [
                        121.93841413675,
                        0.44646896050218
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 126,
                "jenis_pipa": "Pipa 75",
                "keterangan": "PE",
                "panjang": 0.0008517521367089517,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938317544626,
                        0.445811996678078
                    ],
                    [
                        121.9383266429,
                        0.445811996475963
                    ],
                    [
                        121.938338014454,
                        0.445814398775201
                    ],
                    [
                        121.938344850223,
                        0.445821623105894
                    ],
                    [
                        121.93895686107,
                        0.446369002489813
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 127,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0015517393521192367,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940132899201,
                        0.447370964353883
                    ],
                    [
                        121.94007729714,
                        0.447335649350575
                    ],
                    [
                        121.940057402069,
                        0.447324934704275
                    ],
                    [
                        121.940033409372,
                        0.447315499192471
                    ],
                    [
                        121.940012791127,
                        0.447300347110669
                    ],
                    [
                        121.938954045971,
                        0.446366251621051
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 128,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012553914785109184,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93970871085,
                        0.4479109488637
                    ],
                    [
                        121.93911989623,
                        0.44764147155717
                    ],
                    [
                        121.93855538905,
                        0.44741607587463
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 131,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000526984318333619,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93779348133,
                        0.44595168906261
                    ],
                    [
                        121.93798364999,
                        0.44546021337397
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 135,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0008837904625219255,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94199128996,
                        0.44874239357734
                    ],
                    [
                        121.94211737048,
                        0.44877322833511
                    ],
                    [
                        121.94227027702,
                        0.44880942565926
                    ],
                    [
                        121.94237084218,
                        0.44882954624873
                    ],
                    [
                        121.94252774218,
                        0.44884430427165
                    ],
                    [
                        121.94286435666,
                        0.44885235697775
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 139,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00027280523969351914,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943408052435,
                        0.449145546019143
                    ],
                    [
                        121.943405541772,
                        0.449134069159968
                    ],
                    [
                        121.9434030814,
                        0.449125495962962
                    ],
                    [
                        121.943402887747,
                        0.44911127229299
                    ],
                    [
                        121.943402695193,
                        0.449097129446899
                    ],
                    [
                        121.943402503732,
                        0.449083066737656
                    ],
                    [
                        121.943402351341,
                        0.449071873801093
                    ],
                    [
                        121.94340216182,
                        0.449057953631645
                    ],
                    [
                        121.943401973365,
                        0.449044111716306
                    ],
                    [
                        121.943404081004,
                        0.449030347317196
                    ],
                    [
                        121.943403926705,
                        0.44901939130984
                    ],
                    [
                        121.943406057886,
                        0.449008484111697
                    ],
                    [
                        121.943408179574,
                        0.448997625529199
                    ],
                    [
                        121.943410291832,
                        0.448986815185044
                    ],
                    [
                        121.94341012513,
                        0.448976052888802
                    ],
                    [
                        121.943409917789,
                        0.448962666933918
                    ],
                    [
                        121.943412011065,
                        0.448952011246995
                    ],
                    [
                        121.943411884024,
                        0.448944050360199
                    ],
                    [
                        121.943413921628,
                        0.448930840424996
                    ],
                    [
                        121.94341361983,
                        0.448912468030558
                    ],
                    [
                        121.943413405672,
                        0.448899430814457
                    ],
                    [
                        121.943415736095,
                        0.448874620568419
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 140,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004429255434541286,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943403354382,
                        0.449145546187078
                    ],
                    [
                        121.943398765887,
                        0.449154188731055
                    ],
                    [
                        121.942967546113,
                        0.449194933851497
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 142,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007325962156467072,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94177414434,
                        0.45007538960244
                    ],
                    [
                        121.94176356229,
                        0.45008472013571
                    ],
                    [
                        121.94174873587,
                        0.45009096256037
                    ],
                    [
                        121.94173943923,
                        0.45009096300153
                    ],
                    [
                        121.94172781847,
                        0.450090963555
                    ],
                    [
                        121.94171852182,
                        0.45009096399939
                    ],
                    [
                        121.94170874628,
                        0.45009409182081
                    ],
                    [
                        121.94169711742,
                        0.4500940923812
                    ],
                    [
                        121.94168316274,
                        0.45009409305665
                    ],
                    [
                        121.94166404612,
                        0.45009722569986
                    ],
                    [
                        121.94165473649,
                        0.45009722615574
                    ],
                    [
                        121.94164309949,
                        0.45009722672762
                    ],
                    [
                        121.94163378985,
                        0.45009722718674
                    ],
                    [
                        121.94162448021,
                        0.4500972276473
                    ],
                    [
                        121.9416128432,
                        0.45009722822504
                    ],
                    [
                        121.94160353355,
                        0.45009722868884
                    ],
                    [
                        121.94159422389,
                        0.4500972291541
                    ],
                    [
                        121.94158258687,
                        0.45009722973769
                    ],
                    [
                        121.94158196305,
                        0.45008784768098
                    ],
                    [
                        121.94157727519,
                        0.45007539911416
                    ],
                    [
                        121.94157954239,
                        0.45006301905669
                    ],
                    [
                        121.94157892962,
                        0.45005377895805
                    ],
                    [
                        121.94157694501,
                        0.44956282510569
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 145,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.000774872931825617,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942131735319,
                        0.449588487918162
                    ],
                    [
                        121.942121552775,
                        0.449588488245569
                    ],
                    [
                        121.942111370228,
                        0.449588488574089
                    ],
                    [
                        121.942103299825,
                        0.44958609077141
                    ],
                    [
                        121.94209523924,
                        0.449583695882992
                    ],
                    [
                        121.941364098498,
                        0.449485691336985
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 146,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0013842534399465323,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941360131934,
                        0.449485691434892
                    ],
                    [
                        121.941351577703,
                        0.449481145458299
                    ],
                    [
                        121.941345634879,
                        0.449481145605643
                    ],
                    [
                        121.941208121707,
                        0.449462895070776
                    ],
                    [
                        121.94061624359,
                        0.449341391636211
                    ],
                    [
                        121.940006320409,
                        0.449201843137106
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 147,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0005139415781995253,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940002000281,
                        0.449202095507378
                    ],
                    [
                        121.939642227397,
                        0.44907777617093
                    ],
                    [
                        121.939572750489,
                        0.449057298617445
                    ],
                    [
                        121.939530637316,
                        0.449048850779816
                    ],
                    [
                        121.939518574383,
                        0.449035611049328
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 151,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0019861505626271956,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93963368983,
                        0.44914500118381
                    ],
                    [
                        121.94024241001,
                        0.44931342178618
                    ],
                    [
                        121.94109516007,
                        0.44947443264277
                    ],
                    [
                        121.94110340203,
                        0.44947679292171
                    ],
                    [
                        121.94157390071,
                        0.44956210123878
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 153,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.009261903842573329,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93801267234,
                        0.45441483855722
                    ],
                    [
                        121.93803235496,
                        0.45438021971769
                    ],
                    [
                        121.93840073353,
                        0.45370323718817
                    ],
                    [
                        121.93854789158,
                        0.45337860025939
                    ],
                    [
                        121.93858327743,
                        0.45332819255202
                    ],
                    [
                        121.93896982187,
                        0.4524666072035
                    ],
                    [
                        121.93913720824,
                        0.45164772233767
                    ],
                    [
                        121.93926710022,
                        0.45089609072414
                    ],
                    [
                        121.93936930532,
                        0.45029114946456
                    ],
                    [
                        121.9393885691,
                        0.45016752383722
                    ],
                    [
                        121.93950665179,
                        0.44963859508438
                    ],
                    [
                        121.93963205095,
                        0.44894557176875
                    ],
                    [
                        121.93982797732,
                        0.44815452762515
                    ],
                    [
                        121.93994246353,
                        0.4477632671081
                    ],
                    [
                        121.94108256366,
                        0.44840503303963
                    ],
                    [
                        121.94132338053,
                        0.44852271850768
                    ],
                    [
                        121.94199520878,
                        0.44874166443629
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 156,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0009554654333395625,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93939492106,
                        0.45018001126581
                    ],
                    [
                        121.94006949663,
                        0.45026990637766
                    ],
                    [
                        121.94034442306,
                        0.45026986472513
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 175,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.008869885508582732,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89949840307,
                        0.50003118328897
                    ],
                    [
                        121.90080195665,
                        0.49951890531921
                    ],
                    [
                        121.90201297402,
                        0.49909269870541
                    ],
                    [
                        121.90778642893,
                        0.49687299202005
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2124,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0020890495404598686,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64913324856,
                        0.56937606404451
                    ],
                    [
                        121.6491466596,
                        0.56886646947235
                    ],
                    [
                        121.64915470623,
                        0.56838905977972
                    ],
                    [
                        121.64918689274,
                        0.56803502560014
                    ],
                    [
                        121.64932904981,
                        0.56789555758406
                    ],
                    [
                        121.64945511364,
                        0.56782850565204
                    ],
                    [
                        121.64961336397,
                        0.56773195086858
                    ],
                    [
                        121.64964018606,
                        0.56757639038073
                    ],
                    [
                        121.64964018606,
                        0.56757639038073
                    ],
                    [
                        121.64964018606,
                        0.56757639038073
                    ],
                    [
                        121.64964258671,
                        0.56751530217133
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 178,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005603071985178991,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914231444763,
                        0.494485840038533
                    ],
                    [
                        121.914705238206,
                        0.494297202305793
                    ],
                    [
                        121.915168679794,
                        0.494019161645077
                    ],
                    [
                        121.916334425224,
                        0.493119175758707
                    ],
                    [
                        121.917704457632,
                        0.491961251474965
                    ],
                    [
                        121.918658823464,
                        0.491099122430997
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2063,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribus",
                "panjang": 0.00016615795551700184,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94723442794,
                        0.4625271797475
                    ],
                    [
                        121.94739569322,
                        0.46252281463867
                    ],
                    [
                        121.94739569322,
                        0.46252281463867
                    ],
                    [
                        121.94739837561,
                        0.46252683565371
                    ],
                    [
                        121.94739837561,
                        0.46252683565371
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 185,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0006716468466292937,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94262214736,
                        0.44882847934744
                    ],
                    [
                        121.94266568716,
                        0.44863838476022
                    ],
                    [
                        121.94265660801,
                        0.44852390054137
                    ],
                    [
                        121.94255990754,
                        0.44831245585651
                    ],
                    [
                        121.94258904979,
                        0.4481865049595
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 193,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0021187714174560075,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95741668982,
                        0.47104557965434
                    ],
                    [
                        121.95701072213,
                        0.47098638784805
                    ],
                    [
                        121.95667237019,
                        0.47094632664917
                    ],
                    [
                        121.95642961677,
                        0.47093828873129
                    ],
                    [
                        121.95609147773,
                        0.47102374706681
                    ],
                    [
                        121.95581483021,
                        0.47106838534187
                    ],
                    [
                        121.95532160419,
                        0.47111993784472
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 197,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00414052324257667,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95554261064,
                        0.4745699524307
                    ],
                    [
                        121.95604339913,
                        0.47373057960674
                    ],
                    [
                        121.95735988768,
                        0.47218220165839
                    ],
                    [
                        121.95748143199,
                        0.47202741328929
                    ],
                    [
                        121.9575261578,
                        0.47188202661123
                    ],
                    [
                        121.95753019457,
                        0.47172354248699
                    ],
                    [
                        121.9574061356,
                        0.47132491593384
                    ],
                    [
                        121.95740269577,
                        0.47111916302805
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 203,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.012608364893802624,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96311159654,
                        0.46256701480092
                    ],
                    [
                        121.96256786585,
                        0.46218385720918
                    ],
                    [
                        121.96202882225,
                        0.46179236135666
                    ],
                    [
                        121.96161295925,
                        0.46144797858541
                    ],
                    [
                        121.96060795115,
                        0.46033031078517
                    ],
                    [
                        121.9598467648,
                        0.45929252937649
                    ],
                    [
                        121.95970728993,
                        0.45914233049602
                    ],
                    [
                        121.95952892303,
                        0.45906855609031
                    ],
                    [
                        121.95926607048,
                        0.45903637145862
                    ],
                    [
                        121.9550845027,
                        0.45930995895759
                    ],
                    [
                        121.95433080295,
                        0.45934213388825
                    ],
                    [
                        121.95356100758,
                        0.45935151794425
                    ],
                    [
                        121.95278450945,
                        0.45935554618924
                    ],
                    [
                        121.95199190745,
                        0.45933409806302
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1575,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 6.21259948369203e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96336179972,
                        0.46413241839216
                    ],
                    [
                        121.96330949664,
                        0.46409889187943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1576,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020333005905434146,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96325585246,
                        0.46407072960862
                    ],
                    [
                        121.96299433708,
                        0.46392991825288
                    ],
                    [
                        121.96272745728,
                        0.46380519962118
                    ],
                    [
                        121.96246996522,
                        0.4636737756843
                    ],
                    [
                        121.96219235659,
                        0.46354503386623
                    ],
                    [
                        121.96196839213,
                        0.4634323847735
                    ],
                    [
                        121.9617216289,
                        0.463358626438
                    ],
                    [
                        121.9613917172,
                        0.46328352704107
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 204,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0016474973667926303,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95201191374,
                        0.4591936764665
                    ],
                    [
                        121.95202456159,
                        0.45892698755223
                    ],
                    [
                        121.95200800228,
                        0.45886875395561
                    ],
                    [
                        121.95199458535,
                        0.45835643768876
                    ],
                    [
                        121.95199591663,
                        0.45799169651598
                    ],
                    [
                        121.95190073749,
                        0.45780801893539
                    ],
                    [
                        121.95182293653,
                        0.45758536250982
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 213,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00202572426649753,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93904621605,
                        0.45162560449532
                    ],
                    [
                        121.93702057611,
                        0.45160712106087
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2076,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.0007874139817515523,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93700379828,
                        0.45161258741835
                    ],
                    [
                        121.93678920709,
                        0.45159114197218
                    ],
                    [
                        121.93663362848,
                        0.45159114197218
                    ],
                    [
                        121.93647804987,
                        0.45157505788751
                    ],
                    [
                        121.93630950894,
                        0.45156476407723
                    ],
                    [
                        121.93622346375,
                        0.45153541615488
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 215,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.014065939774442407,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93596210177,
                        0.46494995668009
                    ],
                    [
                        121.93591661704,
                        0.46412388510238
                    ],
                    [
                        121.93583597422,
                        0.46320274670167
                    ],
                    [
                        121.93572968711,
                        0.46222408903529
                    ],
                    [
                        121.9356331212,
                        0.46143152201875
                    ],
                    [
                        121.93560188883,
                        0.46044562849134
                    ],
                    [
                        121.93560764537,
                        0.46010923573378
                    ],
                    [
                        121.93566800686,
                        0.45979140420682
                    ],
                    [
                        121.93594022775,
                        0.45905918468582
                    ],
                    [
                        121.93597778973,
                        0.45896396932135
                    ],
                    [
                        121.9360756879,
                        0.45874135311216
                    ],
                    [
                        121.93627819959,
                        0.45823174971564
                    ],
                    [
                        121.93655983252,
                        0.4575129406526
                    ],
                    [
                        121.9369161192,
                        0.45665200591621
                    ],
                    [
                        121.93719228992,
                        0.45595304706784
                    ],
                    [
                        121.93765712651,
                        0.45490029017557
                    ],
                    [
                        121.93841218239,
                        0.45350040397944
                    ],
                    [
                        121.93885050124,
                        0.45259125773939
                    ],
                    [
                        121.93893070309,
                        0.45235046849141
                    ],
                    [
                        121.93907708401,
                        0.4516149509153
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 216,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020088745801682445,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93712542898,
                        0.44561843117286
                    ],
                    [
                        121.93656653244,
                        0.44535620018133
                    ],
                    [
                        121.93642571568,
                        0.44532402012792
                    ],
                    [
                        121.93622185778,
                        0.445314630993
                    ],
                    [
                        121.93608104142,
                        0.44536424572184
                    ],
                    [
                        121.93599365595,
                        0.44544282103378
                    ],
                    [
                        121.93570286861,
                        0.44552382516578
                    ],
                    [
                        121.93546148688,
                        0.44560157313675
                    ],
                    [
                        121.93526299438,
                        0.44569811329297
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 223,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005158358474936392,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9188086236,
                        0.478654785562676
                    ],
                    [
                        121.919074820679,
                        0.478255814931799
                    ],
                    [
                        121.919352933636,
                        0.47796101735125
                    ],
                    [
                        121.920206746381,
                        0.477271221824174
                    ],
                    [
                        121.920882315088,
                        0.476611493338379
                    ],
                    [
                        121.921601368967,
                        0.475908405124272
                    ],
                    [
                        121.921911847824,
                        0.475615086249548
                    ],
                    [
                        121.922129117365,
                        0.475440968092633
                    ],
                    [
                        121.922578703396,
                        0.475179024488907
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 224,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0016206927647528712,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.922573684555,
                        0.475178543240739
                    ],
                    [
                        121.923088892626,
                        0.474902277719357
                    ],
                    [
                        121.923217988655,
                        0.474834161344122
                    ],
                    [
                        121.923497102122,
                        0.474753047718666
                    ],
                    [
                        121.92388066421,
                        0.474649590828716
                    ],
                    [
                        121.924077136029,
                        0.474601830227916
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 225,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.001311017182411263,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.91321457005,
                        0.48598836487424
                    ],
                    [
                        121.91345932979,
                        0.48616818185091
                    ],
                    [
                        121.91358642793,
                        0.48625123753273
                    ],
                    [
                        121.91415399313,
                        0.48689132117188
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 226,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001067174133381732,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.917853050682,
                        0.482439813066862
                    ],
                    [
                        121.917751276841,
                        0.482373457414184
                    ],
                    [
                        121.917555468314,
                        0.482238530015927
                    ],
                    [
                        121.917402946791,
                        0.482126442055655
                    ],
                    [
                        121.91697783005,
                        0.481829410984502
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 241,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.005238953841602174,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942720836453,
                        0.471052845337137
                    ],
                    [
                        121.942571096116,
                        0.469967074373828
                    ],
                    [
                        121.943518060615,
                        0.469887005331057
                    ],
                    [
                        121.9440769596,
                        0.469855647303765
                    ],
                    [
                        121.946688411497,
                        0.469521172482335
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 245,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012477108741847161,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938434207795,
                        0.471148402968825
                    ],
                    [
                        121.939545467748,
                        0.470581054978256
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 246,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004548040906604661,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.946692844742,
                        0.469622563240022
                    ],
                    [
                        121.945787522868,
                        0.469712440560561
                    ],
                    [
                        121.944770180084,
                        0.469859238408221
                    ],
                    [
                        121.944205140565,
                        0.469904564719277
                    ],
                    [
                        121.94314378241,
                        0.469987103031976
                    ],
                    [
                        121.942335334471,
                        0.470039389703689
                    ],
                    [
                        121.942168041857,
                        0.470062158826463
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 252,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.012750624283399816,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95351982273,
                        0.4782685244892
                    ],
                    [
                        121.95369954625,
                        0.47825971200057
                    ],
                    [
                        121.95377826152,
                        0.47810963108062
                    ],
                    [
                        121.95432739932,
                        0.47699185012308
                    ],
                    [
                        121.95519082188,
                        0.47517238731314
                    ],
                    [
                        121.95546838046,
                        0.47470128154359
                    ],
                    [
                        121.95579871906,
                        0.47412753291993
                    ],
                    [
                        121.95603373871,
                        0.47375450360356
                    ],
                    [
                        121.9574705556,
                        0.47206633406037
                    ],
                    [
                        121.9575352996,
                        0.47192701365242
                    ],
                    [
                        121.9575443209,
                        0.47175458561186
                    ],
                    [
                        121.95742563747,
                        0.47137439161229
                    ],
                    [
                        121.95740422682,
                        0.4711325601485
                    ],
                    [
                        121.95775038381,
                        0.46976055425815
                    ],
                    [
                        121.95786011071,
                        0.46893215654199
                    ],
                    [
                        121.95834799117,
                        0.46693351053464
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 254,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0021970123238662627,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95230711679,
                        0.48015895838863
                    ],
                    [
                        121.95236095404,
                        0.47956172960635
                    ],
                    [
                        121.95244047495,
                        0.47850902910441
                    ],
                    [
                        121.95253774524,
                        0.47797617231068
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 260,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0014846102344660732,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95368035051,
                        0.47812942606737
                    ],
                    [
                        121.9543364092,
                        0.47679763984445
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 261,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.005109493353449027,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.953711353,
                        0.47807986692743
                    ],
                    [
                        121.95378268441,
                        0.47812420861327
                    ],
                    [
                        121.95371161778,
                        0.47822519803227
                    ],
                    [
                        121.95370039674,
                        0.47826634186964
                    ],
                    [
                        121.95372377392,
                        0.47833740849782
                    ],
                    [
                        121.95402368903,
                        0.47934941540326
                    ],
                    [
                        121.95433214307,
                        0.48053088702331
                    ],
                    [
                        121.95445686579,
                        0.48097209487444
                    ],
                    [
                        121.95461109281,
                        0.48154070312687
                    ],
                    [
                        121.95477470756,
                        0.4819993446544
                    ],
                    [
                        121.95486724377,
                        0.48218977475324
                    ],
                    [
                        121.9549306852,
                        0.4823276952116
                    ],
                    [
                        121.95516362786,
                        0.48257465810579
                    ],
                    [
                        121.95535942912,
                        0.48276106501782
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 262,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.007875838531882283,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95438045622,
                        0.46746897614173
                    ],
                    [
                        121.95463665406,
                        0.4674837278003
                    ],
                    [
                        121.95515702667,
                        0.46737107877049
                    ],
                    [
                        121.95575244933,
                        0.4671980820426
                    ],
                    [
                        121.95643767616,
                        0.46700631047104
                    ],
                    [
                        121.95664152478,
                        0.4669633965522
                    ],
                    [
                        121.95726916194,
                        0.46680649253427
                    ],
                    [
                        121.95756554604,
                        0.46674212165412
                    ],
                    [
                        121.95784315467,
                        0.46673541635406
                    ],
                    [
                        121.95813953876,
                        0.46675419119418
                    ],
                    [
                        121.95835143328,
                        0.46676626073423
                    ],
                    [
                        121.95849761367,
                        0.46675955543421
                    ],
                    [
                        121.95876583457,
                        0.4666938434936
                    ],
                    [
                        121.95921644568,
                        0.46653962158975
                    ],
                    [
                        121.95973277092,
                        0.46638137650228
                    ],
                    [
                        121.95992991328,
                        0.46636126060107
                    ],
                    [
                        121.96014617531,
                        0.46636164566219
                    ],
                    [
                        121.96041191732,
                        0.46641145942554
                    ],
                    [
                        121.96088887229,
                        0.46659383264832
                    ],
                    [
                        121.96134016511,
                        0.46678254940633
                    ],
                    [
                        121.96197836766,
                        0.46703504918122
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1826,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.013879001191818353,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46909639239,
                        0.50892503394666
                    ],
                    [
                        121.46919563413,
                        0.50878288247517
                    ],
                    [
                        121.46934047341,
                        0.5085991583989
                    ],
                    [
                        121.46951213479,
                        0.50838593117973
                    ],
                    [
                        121.46964758635,
                        0.50822634602367
                    ],
                    [
                        121.46981522441,
                        0.50799970827426
                    ],
                    [
                        121.47009015083,
                        0.50764567059062
                    ],
                    [
                        121.47016391158,
                        0.50753034012888
                    ],
                    [
                        121.47023230791,
                        0.50738416547095
                    ],
                    [
                        121.47024035454,
                        0.50727688131623
                    ],
                    [
                        121.47022023797,
                        0.50712266034071
                    ],
                    [
                        121.47018805146,
                        0.50692418464506
                    ],
                    [
                        121.47003918886,
                        0.50643872379629
                    ],
                    [
                        121.46994262934,
                        0.50616649021048
                    ],
                    [
                        121.46985143423,
                        0.50592241871005
                    ],
                    [
                        121.46977365017,
                        0.50565689036399
                    ],
                    [
                        121.46967306733,
                        0.50535381254157
                    ],
                    [
                        121.4695456624,
                        0.50497027156018
                    ],
                    [
                        121.46944776177,
                        0.50467658107313
                    ],
                    [
                        121.46935522556,
                        0.50439630109822
                    ],
                    [
                        121.46919697523,
                        0.50396314111328
                    ],
                    [
                        121.4690078795,
                        0.50349243162329
                    ],
                    [
                        121.46896630526,
                        0.50330468423889
                    ],
                    [
                        121.46886706352,
                        0.50304720210292
                    ],
                    [
                        121.46881207824,
                        0.50280581259122
                    ],
                    [
                        121.46872356534,
                        0.50256308201768
                    ],
                    [
                        121.4686524868,
                        0.50231096406434
                    ],
                    [
                        121.46862834692,
                        0.50201459135143
                    ],
                    [
                        121.46866053343,
                        0.50183757234908
                    ],
                    [
                        121.46869003773,
                        0.50168201019154
                    ],
                    [
                        121.46878257394,
                        0.50142855115109
                    ],
                    [
                        121.46886706352,
                        0.50126226055836
                    ],
                    [
                        121.46901860833,
                        0.50092297409399
                    ],
                    [
                        121.46913662553,
                        0.50067756134398
                    ],
                    [
                        121.46923989058,
                        0.5004670159719
                    ],
                    [
                        121.4693954587,
                        0.50013577578687
                    ],
                    [
                        121.4694866538,
                        0.49991852513011
                    ],
                    [
                        121.46960198879,
                        0.49964092705825
                    ],
                    [
                        121.46971732378,
                        0.49943038165293
                    ],
                    [
                        121.46983399987,
                        0.49917021725741
                    ],
                    [
                        121.46997481585,
                        0.49886177491951
                    ],
                    [
                        121.47008478642,
                        0.49862440841483
                    ],
                    [
                        121.47019207478,
                        0.49843397878342
                    ],
                    [
                        121.47028058767,
                        0.49824891336172
                    ],
                    [
                        121.47038117051,
                        0.49804909634259
                    ],
                    [
                        121.47048577666,
                        0.49783855088635
                    ],
                    [
                        121.47057428956,
                        0.49765482650183
                    ],
                    [
                        121.47064000368,
                        0.49745769157262
                    ],
                    [
                        121.47070840001,
                        0.49732090406726
                    ],
                    [
                        121.47077545524,
                        0.49716400074879
                    ],
                    [
                        121.47086128592,
                        0.49697357107522
                    ],
                    [
                        121.47098466754,
                        0.49668390339222
                    ],
                    [
                        121.47110804915,
                        0.49643044415916
                    ],
                    [
                        121.47119924426,
                        0.49624403762707
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 270,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.006677152987597204,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94691013703,
                        0.46718407651069
                    ],
                    [
                        121.94697830671,
                        0.46652678742114
                    ],
                    [
                        121.94702901674,
                        0.46604648603276
                    ],
                    [
                        121.94707880622,
                        0.46502527547399
                    ],
                    [
                        121.94711969015,
                        0.46402513355088
                    ],
                    [
                        121.94722831789,
                        0.46252448666312
                    ],
                    [
                        121.94724977655,
                        0.46213021477399
                    ],
                    [
                        121.94729001533,
                        0.46142347565265
                    ],
                    [
                        121.9473610838,
                        0.46052362365273
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 276,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008740138137128726,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94398596861,
                        0.46289298013753
                    ],
                    [
                        121.9447513094,
                        0.4629536261094
                    ],
                    [
                        121.9447325364,
                        0.46305822884549
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 280,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.003778144646234529,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.962251975225,
                        0.474462226732586
                    ],
                    [
                        121.962311912797,
                        0.473410243129889
                    ],
                    [
                        121.962266154044,
                        0.472574534973764
                    ],
                    [
                        121.962153940578,
                        0.472013826783485
                    ],
                    [
                        121.961987075583,
                        0.471479270154432
                    ],
                    [
                        121.96167453316,
                        0.470791259103121
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 281,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.006929238886136901,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.968266250254,
                        0.47586363527598
                    ],
                    [
                        121.967458334902,
                        0.476267592951972
                    ],
                    [
                        121.966369893386,
                        0.476593003302076
                    ],
                    [
                        121.964071682786,
                        0.475931195327068
                    ],
                    [
                        121.962633327589,
                        0.475309141761634
                    ],
                    [
                        121.962378707054,
                        0.474870269449292
                    ],
                    [
                        121.962251975225,
                        0.474465835745493
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 282,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0009763599748817752,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.961692878971,
                        0.470788552343431
                    ],
                    [
                        121.961673630902,
                        0.47068749998201
                    ],
                    [
                        121.961673630902,
                        0.470487801267774
                    ],
                    [
                        121.961805031382,
                        0.469826946000969
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 285,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.001476143915711666,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.939273124222,
                        0.449958193326712
                    ],
                    [
                        121.938863882895,
                        0.449896341560136
                    ],
                    [
                        121.938356210611,
                        0.449792790467509
                    ],
                    [
                        121.938103925957,
                        0.449752201362563
                    ],
                    [
                        121.937820190879,
                        0.449699431192404
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 287,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013109040058065934,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9357189034,
                        0.46104039900454
                    ],
                    [
                        121.9362014084,
                        0.46099925516717
                    ],
                    [
                        121.93700161051,
                        0.46079183414626
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 290,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002482950613956358,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93471856338,
                        0.46606302533905
                    ],
                    [
                        121.93483053892,
                        0.46602591097815
                    ],
                    [
                        121.93493123238,
                        0.46598897473801
                    ],
                    [
                        121.93516641855,
                        0.4659160286397
                    ],
                    [
                        121.93506661548,
                        0.46547723364673
                    ],
                    [
                        121.9347646469,
                        0.46554284393487
                    ],
                    [
                        121.93476684657,
                        0.46549514780575
                    ],
                    [
                        121.93448890822,
                        0.46432291875896
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 291,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0011169926540486159,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93469497673,
                        0.4660650940562
                    ],
                    [
                        121.93446167865,
                        0.46610202608821
                    ],
                    [
                        121.93437416235,
                        0.46563125488297
                    ],
                    [
                        121.9347654283,
                        0.46553918477237
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 292,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012281617023014852,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93302223605,
                        0.46425493956147
                    ],
                    [
                        121.93266125104,
                        0.46308102687751
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 293,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0023194653428901934,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93290186343,
                        0.46289511880029
                    ],
                    [
                        121.93283926441,
                        0.46302958564728
                    ],
                    [
                        121.93231082053,
                        0.46314777585799
                    ],
                    [
                        121.93173392872,
                        0.46323569477752
                    ],
                    [
                        121.9314399217,
                        0.46325664666694
                    ],
                    [
                        121.9310662067,
                        0.46307794023406
                    ],
                    [
                        121.93075586685,
                        0.46294633550594
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 294,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0009554339426199517,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93289979191,
                        0.46288475820281
                    ],
                    [
                        121.93290492368,
                        0.46271323034343
                    ],
                    [
                        121.9328910403,
                        0.46247241127918
                    ],
                    [
                        121.93281262347,
                        0.46216990011165
                    ],
                    [
                        121.93275957519,
                        0.46194599768885
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 295,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0044812917096080105,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931349673923,
                        0.467657122842999
                    ],
                    [
                        121.931250321358,
                        0.4672035062092
                    ],
                    [
                        121.931207666538,
                        0.466982944145246
                    ],
                    [
                        121.931009869078,
                        0.466025102697437
                    ],
                    [
                        121.930919670812,
                        0.465752509507128
                    ],
                    [
                        121.930635460288,
                        0.465128038915669
                    ],
                    [
                        121.93027253292,
                        0.464451466897126
                    ],
                    [
                        121.929927729276,
                        0.464139455513798
                    ],
                    [
                        121.929692679275,
                        0.463908824525675
                    ],
                    [
                        121.929607766233,
                        0.463793267608819
                    ],
                    [
                        121.929559715429,
                        0.463666568696368
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 302,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002471459753344685,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940007087401,
                        0.447684441645521
                    ],
                    [
                        121.939904141209,
                        0.447621931452388
                    ],
                    [
                        121.939804776423,
                        0.447554304362573
                    ],
                    [
                        121.939560794399,
                        0.44736135726755
                    ],
                    [
                        121.939382862996,
                        0.447203986712316
                    ],
                    [
                        121.93918858886,
                        0.447036062699501
                    ],
                    [
                        121.938995875435,
                        0.446885169579952
                    ],
                    [
                        121.938831047626,
                        0.446752412577856
                    ],
                    [
                        121.938663542464,
                        0.446606819802818
                    ],
                    [
                        121.938555169519,
                        0.446518354227417
                    ],
                    [
                        121.938127658945,
                        0.44616037283589
                    ],
                    [
                        121.93808895575,
                        0.446129337783993
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 303,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0008217897399833296,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937518478744,
                        0.464935504790063
                    ],
                    [
                        121.937475932275,
                        0.464528274308821
                    ],
                    [
                        121.937414216519,
                        0.464120576283977
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 305,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.005706362199272978,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93671003131,
                        0.46725842973886
                    ],
                    [
                        121.93627651527,
                        0.46735621035754
                    ],
                    [
                        121.93596437549,
                        0.46738448936936
                    ],
                    [
                        121.93552315309,
                        0.46738448936936
                    ],
                    [
                        121.93512081977,
                        0.46737510195015
                    ],
                    [
                        121.93390711921,
                        0.46724501913973
                    ],
                    [
                        121.93336799594,
                        0.46726245291859
                    ],
                    [
                        121.93316011813,
                        0.46729867003508
                    ],
                    [
                        121.93153735161,
                        0.46761616697605
                    ],
                    [
                        121.93137822856,
                        0.46764866033842
                    ],
                    [
                        121.93127607184,
                        0.46768165924544
                    ],
                    [
                        121.93123997543,
                        0.46788905250422
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 312,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.01576273844840435,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95195706383,
                        0.52611755057442
                    ],
                    [
                        121.95254471228,
                        0.52527989101819
                    ],
                    [
                        121.95271074772,
                        0.5251812407755
                    ],
                    [
                        121.95312577263,
                        0.52466608484198
                    ],
                    [
                        121.95314268397,
                        0.52449280983586
                    ],
                    [
                        121.95300767495,
                        0.52423117413394
                    ],
                    [
                        121.95328205824,
                        0.5241633851322
                    ],
                    [
                        121.95329752119,
                        0.52375208614257
                    ],
                    [
                        121.95329429248,
                        0.52333826431885
                    ],
                    [
                        121.95356637239,
                        0.52323269748221
                    ],
                    [
                        121.95351142734,
                        0.52287245092334
                    ],
                    [
                        121.95399409758,
                        0.52232441083633
                    ],
                    [
                        121.9542239562,
                        0.52209751908767
                    ],
                    [
                        121.95466205478,
                        0.52186080462831
                    ],
                    [
                        121.95497912554,
                        0.52156043916774
                    ],
                    [
                        121.95479627253,
                        0.52142544585068
                    ],
                    [
                        121.95437536022,
                        0.52122297694825
                    ],
                    [
                        121.95320519959,
                        0.52065460048237
                    ],
                    [
                        121.95292691358,
                        0.52049407227732
                    ],
                    [
                        121.95252718631,
                        0.52030940621018
                    ],
                    [
                        121.95198524147,
                        0.52014176229137
                    ],
                    [
                        121.9516236058,
                        0.51981458092176
                    ],
                    [
                        121.95129971796,
                        0.51958442724707
                    ],
                    [
                        121.95076552698,
                        0.51924749117912
                    ],
                    [
                        121.95047473987,
                        0.51900283353266
                    ],
                    [
                        121.95000305772,
                        0.51840089757
                    ],
                    [
                        121.94938206824,
                        0.51755147844447
                    ],
                    [
                        121.94923395513,
                        0.51711844698848
                    ],
                    [
                        121.94908764214,
                        0.51632977877293
                    ],
                    [
                        121.9490737343,
                        0.51496326926182
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 315,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.03141067216748061,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94505940695,
                        0.51074234598139
                    ],
                    [
                        121.94356575608,
                        0.50945877246256
                    ],
                    [
                        121.94356218207,
                        0.50945410490305
                    ],
                    [
                        121.94217594266,
                        0.50820505483914
                    ],
                    [
                        121.94125014473,
                        0.50731064189436
                    ],
                    [
                        121.94101738934,
                        0.50710854899162
                    ],
                    [
                        121.94080090822,
                        0.50690061890763
                    ],
                    [
                        121.94061452819,
                        0.50667396451781
                    ],
                    [
                        121.94038409967,
                        0.50638898373624
                    ],
                    [
                        121.94012900489,
                        0.50608971184632
                    ],
                    [
                        121.93992706495,
                        0.50583299422311
                    ],
                    [
                        121.9395198114,
                        0.50528861791512
                    ],
                    [
                        121.93924843091,
                        0.50496484801325
                    ],
                    [
                        121.93870897965,
                        0.50434419255046
                    ],
                    [
                        121.93844969714,
                        0.50407634181263
                    ],
                    [
                        121.93807706523,
                        0.50372354332336
                    ],
                    [
                        121.93796292316,
                        0.50359205239515
                    ],
                    [
                        121.93754913848,
                        0.50320509218245
                    ],
                    [
                        121.93726768118,
                        0.50291654686079
                    ],
                    [
                        121.93711393697,
                        0.50275187130497
                    ],
                    [
                        121.93677033372,
                        0.50230716548929
                    ],
                    [
                        121.93605756908,
                        0.50130019070436
                    ],
                    [
                        121.93496808933,
                        0.49969456919866
                    ],
                    [
                        121.93469390717,
                        0.49923339528626
                    ],
                    [
                        121.93455770461,
                        0.49896888547806
                    ],
                    [
                        121.93443175585,
                        0.49876508997995
                    ],
                    [
                        121.93420994493,
                        0.49833705012251
                    ],
                    [
                        121.93412691742,
                        0.49815073768104
                    ],
                    [
                        121.93382044705,
                        0.4974698615809
                    ],
                    [
                        121.93376547325,
                        0.4973619609265
                    ],
                    [
                        121.9336448131,
                        0.49640806116079
                    ],
                    [
                        121.93356635115,
                        0.49561871196989
                    ],
                    [
                        121.93344430376,
                        0.49415230475849
                    ],
                    [
                        121.93342186166,
                        0.49386990842019
                    ],
                    [
                        121.93332087225,
                        0.49261689155484
                    ],
                    [
                        121.93330030033,
                        0.49225501280343
                    ],
                    [
                        121.93330684594,
                        0.49133582207314
                    ],
                    [
                        121.93355550655,
                        0.49040274900974
                    ],
                    [
                        121.93391724948,
                        0.48954508120703
                    ],
                    [
                        121.93407665648,
                        0.4891608092158
                    ],
                    [
                        121.9343007364,
                        0.48871296152282
                    ],
                    [
                        121.93493161507,
                        0.4874531267862
                    ],
                    [
                        121.93500987352,
                        0.48728034883057
                    ],
                    [
                        121.93511530499,
                        0.48700056874729
                    ],
                    [
                        121.93547232845,
                        0.48612870486126
                    ],
                    [
                        121.93552890374,
                        0.48590889134185
                    ],
                    [
                        121.93566652495,
                        0.48534146245318
                    ],
                    [
                        121.93570464332,
                        0.48506699739753
                    ],
                    [
                        121.93571679946,
                        0.48498564481
                    ],
                    [
                        121.93574111172,
                        0.48478273088479
                    ],
                    [
                        121.93572077358,
                        0.4841080654607
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 318,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.006657747294437024,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933532669501,
                        0.478974436661638
                    ],
                    [
                        121.933449914282,
                        0.478917863885255
                    ],
                    [
                        121.933325547683,
                        0.478745807838073
                    ],
                    [
                        121.932826957503,
                        0.478071844448029
                    ],
                    [
                        121.932542767496,
                        0.47732690757988
                    ],
                    [
                        121.932288813798,
                        0.476650918057773
                    ],
                    [
                        121.932214107966,
                        0.476305705375686
                    ],
                    [
                        121.932140522349,
                        0.475977244227285
                    ],
                    [
                        121.931930828621,
                        0.475190489942154
                    ],
                    [
                        121.931809534557,
                        0.474380140538425
                    ],
                    [
                        121.931746233872,
                        0.474081740808694
                    ],
                    [
                        121.931663834307,
                        0.473600938471267
                    ],
                    [
                        121.93152042969,
                        0.472741637746652
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 319,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00487207036234566,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931519894275,
                        0.4727296904818
                    ],
                    [
                        121.931407232167,
                        0.472185322046869
                    ],
                    [
                        121.931328384533,
                        0.471702523612054
                    ],
                    [
                        121.931260509779,
                        0.471081089753939
                    ],
                    [
                        121.931163750304,
                        0.470301251171663
                    ],
                    [
                        121.931153651279,
                        0.469982162188565
                    ],
                    [
                        121.931149430578,
                        0.469748770804945
                    ],
                    [
                        121.93115594389,
                        0.469609949770439
                    ],
                    [
                        121.931174639419,
                        0.468862161715421
                    ],
                    [
                        121.931173194826,
                        0.468596820010109
                    ],
                    [
                        121.931195969239,
                        0.468389482620407
                    ],
                    [
                        121.931219408602,
                        0.468080476184841
                    ],
                    [
                        121.931239975428,
                        0.467889052504224
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 328,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0018202372103739764,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.925156413336,
                        0.481759278046164
                    ],
                    [
                        121.924969267329,
                        0.481643639009453
                    ],
                    [
                        121.924817383752,
                        0.481543230214011
                    ],
                    [
                        121.924571261196,
                        0.481493327841507
                    ],
                    [
                        121.923718461657,
                        0.480696633536079
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 329,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001112312083230419,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923957843984,
                        0.480950977257999
                    ],
                    [
                        121.923321984679,
                        0.481863622377832
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 331,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.003190620026314045,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935497324325,
                        0.48163417194847
                    ],
                    [
                        121.935305319366,
                        0.48131369659758
                    ],
                    [
                        121.934699318122,
                        0.480399613710873
                    ],
                    [
                        121.934474055947,
                        0.480063065262282
                    ],
                    [
                        121.933994414341,
                        0.479404917756211
                    ],
                    [
                        121.933691166784,
                        0.479048074779653
                    ],
                    [
                        121.933690231697,
                        0.47904713969244
                    ],
                    [
                        121.93367246504,
                        0.479035918645884
                    ],
                    [
                        121.933682750999,
                        0.479036853733097
                    ],
                    [
                        121.933682750999,
                        0.479036853733097
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 333,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0023479450671324083,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933184235003,
                        0.47834140425656
                    ],
                    [
                        121.933067164852,
                        0.478188815985573
                    ],
                    [
                        121.933048929889,
                        0.478160060851837
                    ],
                    [
                        121.933055241992,
                        0.478134812441727
                    ],
                    [
                        121.933073964218,
                        0.478121341019262
                    ],
                    [
                        121.933645963103,
                        0.477893640038873
                    ],
                    [
                        121.934017556747,
                        0.477743425635457
                    ],
                    [
                        121.934300830224,
                        0.477582854142939
                    ],
                    [
                        121.934932040476,
                        0.477215349506897
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 336,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.006550978544192451,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93300050803,
                        0.47807522324392
                    ],
                    [
                        121.93356712728,
                        0.4778604253075
                    ],
                    [
                        121.93394142679,
                        0.47769949192005
                    ],
                    [
                        121.93433123398,
                        0.47751242780416
                    ],
                    [
                        121.93480432034,
                        0.47719701766043
                    ],
                    [
                        121.93705420794,
                        0.47598449529821
                    ],
                    [
                        121.93897487708,
                        0.4755001201219
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 337,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.008265519349199195,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93492688454,
                        0.47721740778852
                    ],
                    [
                        121.93565718765,
                        0.47678212469085
                    ],
                    [
                        121.93663902922,
                        0.47623977410734
                    ],
                    [
                        121.93700558341,
                        0.47606958823458
                    ],
                    [
                        121.93736448884,
                        0.47599408853488
                    ],
                    [
                        121.93742483854,
                        0.47591228398251
                    ],
                    [
                        121.93824901563,
                        0.47569485203404
                    ],
                    [
                        121.93847250148,
                        0.475721034476
                    ],
                    [
                        121.93933208039,
                        0.47549637977305
                    ],
                    [
                        121.94056452534,
                        0.47515413785311
                    ],
                    [
                        121.94257683302,
                        0.47432565058244
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 338,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003720172627266942,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93584046474,
                        0.48501977549332
                    ],
                    [
                        121.93605927515,
                        0.485040347412
                    ],
                    [
                        121.9362528382,
                        0.48505811406905
                    ],
                    [
                        121.93646144292,
                        0.48504710217264
                    ],
                    [
                        121.93668249727,
                        0.48499720213706
                    ],
                    [
                        121.937008984,
                        0.48493351756586
                    ],
                    [
                        121.9373374985,
                        0.48482901033402
                    ],
                    [
                        121.93745150704,
                        0.48478670202036
                    ],
                    [
                        121.9375567459,
                        0.48470682139845
                    ],
                    [
                        121.93762861959,
                        0.48460381603195
                    ],
                    [
                        121.93765880454,
                        0.48438714181982
                    ],
                    [
                        121.93739036814,
                        0.48352806047478
                    ],
                    [
                        121.93736075089,
                        0.48334272106423
                    ],
                    [
                        121.93784491312,
                        0.48319125706715
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 343,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.013776979774595025,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9450428406,
                        0.51061231057178
                    ],
                    [
                        121.94417611943,
                        0.50990203274647
                    ],
                    [
                        121.94320129753,
                        0.50901686084993
                    ],
                    [
                        121.94241052879,
                        0.50830530144988
                    ],
                    [
                        121.94158459607,
                        0.50754726522946
                    ],
                    [
                        121.94083320199,
                        0.50682974963828
                    ],
                    [
                        121.94056017988,
                        0.50650649520778
                    ],
                    [
                        121.94007570269,
                        0.5059115702861
                    ],
                    [
                        121.93940232394,
                        0.50504712865203
                    ],
                    [
                        121.93855740148,
                        0.5040883895881
                    ],
                    [
                        121.93841476141,
                        0.50394648315315
                    ],
                    [
                        121.93818725639,
                        0.50371746116405
                    ],
                    [
                        121.93794752073,
                        0.50347509862466
                    ],
                    [
                        121.93753995897,
                        0.50309168900305
                    ],
                    [
                        121.93720774061,
                        0.5027563600979
                    ],
                    [
                        121.93702626235,
                        0.50253204047211
                    ],
                    [
                        121.93623782708,
                        0.50140912333575
                    ],
                    [
                        121.93582900464,
                        0.50084248897289
                    ],
                    [
                        121.93565683361,
                        0.5006017434702
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 348,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.008156356848827963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93354454045,
                        0.5012487480492
                    ],
                    [
                        121.93454967146,
                        0.50045324128809
                    ],
                    [
                        121.93468201156,
                        0.50027269474422
                    ],
                    [
                        121.93471210592,
                        0.5001951809541
                    ],
                    [
                        121.93468775153,
                        0.50006901991479
                    ],
                    [
                        121.93461184507,
                        0.49992128769744
                    ],
                    [
                        121.93354107877,
                        0.49846523521323
                    ],
                    [
                        121.9331721163,
                        0.49798691874639
                    ],
                    [
                        121.93299876457,
                        0.49772551841076
                    ],
                    [
                        121.93283118006,
                        0.49751906190226
                    ],
                    [
                        121.93273270239,
                        0.49718385750289
                    ],
                    [
                        121.9327102603,
                        0.4942514240031
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 349,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008233779903435967,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93314743581,
                        0.49796082229702
                    ],
                    [
                        121.93390408379,
                        0.49763611450631
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 353,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004200117941259994,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93200237741,
                        0.50282529127323
                    ],
                    [
                        121.93349164724,
                        0.5017796495774
                    ],
                    [
                        121.93420382735,
                        0.50129173007313
                    ],
                    [
                        121.93471505641,
                        0.50093628260828
                    ],
                    [
                        121.93545661144,
                        0.50043609082951
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 355,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.011961014524785986,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94504765361,
                        0.51060990406808
                    ],
                    [
                        121.9461823201,
                        0.51162063562218
                    ],
                    [
                        121.94739279146,
                        0.51273244033169
                    ],
                    [
                        121.94843119781,
                        0.51368661904884
                    ],
                    [
                        121.94861048233,
                        0.51386831007821
                    ],
                    [
                        121.94883188068,
                        0.51416912304074
                    ],
                    [
                        121.94907132779,
                        0.51460109045493
                    ],
                    [
                        121.94908215706,
                        0.51485497659531
                    ],
                    [
                        121.94908573553,
                        0.51510900103243
                    ],
                    [
                        121.94910582255,
                        0.5164324257644
                    ],
                    [
                        121.949228078,
                        0.51711137704731
                    ],
                    [
                        121.94933288096,
                        0.51742766243865
                    ],
                    [
                        121.94944322479,
                        0.51770315409264
                    ],
                    [
                        121.9495859921,
                        0.51789549744064
                    ],
                    [
                        121.95018657898,
                        0.51864246366671
                    ],
                    [
                        121.95049826953,
                        0.51901028920603
                    ],
                    [
                        121.95111017965,
                        0.51945559633932
                    ],
                    [
                        121.95166920571,
                        0.51983656457894
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 356,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0040960862409625725,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.947974623961,
                        0.513267357565519
                    ],
                    [
                        121.947973962106,
                        0.513267887404999
                    ],
                    [
                        121.950333538984,
                        0.513432732908465
                    ],
                    [
                        121.951031425057,
                        0.513541025574976
                    ],
                    [
                        121.951395172986,
                        0.513586222305133
                    ],
                    [
                        121.951589671126,
                        0.513724615212649
                    ],
                    [
                        121.95187019729,
                        0.514035064167346
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 359,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0249194947100249,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95177372137,
                        0.52614591573052
                    ],
                    [
                        121.94470970561,
                        0.52638814730989
                    ],
                    [
                        121.93899404204,
                        0.53002242469286
                    ],
                    [
                        121.93706813142,
                        0.52890493773551
                    ],
                    [
                        121.93277592801,
                        0.52662755602901
                    ],
                    [
                        121.9312977354,
                        0.52561280158829
                    ],
                    [
                        121.9310570261,
                        0.52497979245125
                    ],
                    [
                        121.92958332866,
                        0.52459827686837
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 360,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004550867478509294,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941313062655,
                        0.532860707481944
                    ],
                    [
                        121.941911518472,
                        0.532613844457726
                    ],
                    [
                        121.941015583373,
                        0.531588041359094
                    ],
                    [
                        121.94070095809,
                        0.531311941621004
                    ],
                    [
                        121.938986571344,
                        0.530059861413385
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 363,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.015949597735010503,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.930480452087,
                        0.524735310068933
                    ],
                    [
                        121.929756301157,
                        0.524514660483815
                    ],
                    [
                        121.928290594467,
                        0.523991292437414
                    ],
                    [
                        121.927420865875,
                        0.523884545186495
                    ],
                    [
                        121.926842812068,
                        0.523942642519245
                    ],
                    [
                        121.926253950306,
                        0.524304540641633
                    ],
                    [
                        121.923329465376,
                        0.526146781293004
                    ],
                    [
                        121.922678644676,
                        0.526595623155218
                    ],
                    [
                        121.922132553744,
                        0.526842486179435
                    ],
                    [
                        121.921219908624,
                        0.527242703506575
                    ],
                    [
                        121.920714961529,
                        0.527444682344571
                    ],
                    [
                        121.920135207457,
                        0.527583075252087
                    ],
                    [
                        121.919301109663,
                        0.527755131299268
                    ],
                    [
                        121.917890998146,
                        0.528119815312317
                    ],
                    [
                        121.91618165872,
                        0.529500004038623
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 375,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003954343293183803,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93953076133,
                        0.470588216265261
                    ],
                    [
                        121.939791711889,
                        0.471146082164611
                    ],
                    [
                        121.940452977499,
                        0.470894177907975
                    ],
                    [
                        121.940220356651,
                        0.470302182832552
                    ],
                    [
                        121.940557347585,
                        0.47021621065035
                    ],
                    [
                        121.940950332356,
                        0.470145287658715
                    ],
                    [
                        121.942195300312,
                        0.470063306366672
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2121,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0006031977246629152,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93932250142,
                        0.46912652594633
                    ],
                    [
                        121.93958669901,
                        0.46901253588332
                    ],
                    [
                        121.93974226713,
                        0.46894950608298
                    ],
                    [
                        121.93988308311,
                        0.46890525111645
                    ],
                    [
                        121.93988308311,
                        0.46890525111645
                    ],
                    [
                        121.93988308311,
                        0.46890525111645
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 385,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004950360670452235,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93878874183,
                        0.46815291664258
                    ],
                    [
                        121.93835958838,
                        0.46839967163043
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 386,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0048919914778930654,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93568645183,
                        0.46110706549294
                    ],
                    [
                        121.93567470084,
                        0.46075696829553
                    ],
                    [
                        121.93567738403,
                        0.4604847328782
                    ],
                    [
                        121.93570152318,
                        0.46002877205742
                    ],
                    [
                        121.93581283534,
                        0.45961840729379
                    ],
                    [
                        121.93594694039,
                        0.45925364154735
                    ],
                    [
                        121.93622187197,
                        0.45857506148148
                    ],
                    [
                        121.9364404725,
                        0.45799572286706
                    ],
                    [
                        121.93670064677,
                        0.45729837076908
                    ],
                    [
                        121.93706005458,
                        0.4564696017032
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 392,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0042824668319920225,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.916790431179,
                        0.481704115537695
                    ],
                    [
                        121.913913456954,
                        0.479582128485242
                    ],
                    [
                        121.913913962529,
                        0.479577239170295
                    ],
                    [
                        121.913349255422,
                        0.479159094879717
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 397,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0059366141902491175,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.946007200465,
                        0.511457963808474
                    ],
                    [
                        121.946439210757,
                        0.511052135958057
                    ],
                    [
                        121.946891792968,
                        0.510704283514842
                    ],
                    [
                        121.94731071204,
                        0.510502304676846
                    ],
                    [
                        121.947806308263,
                        0.510195596071
                    ],
                    [
                        121.948185292333,
                        0.509951942921911
                    ],
                    [
                        121.948573079777,
                        0.509726182290103
                    ],
                    [
                        121.94866284815,
                        0.509703740196992
                    ],
                    [
                        121.948722693731,
                        0.509765455953046
                    ],
                    [
                        121.948750746348,
                        0.509834652406804
                    ],
                    [
                        121.948881658557,
                        0.510088996128725
                    ],
                    [
                        121.949371644257,
                        0.510960497411188
                    ],
                    [
                        121.949405307397,
                        0.511113851714111
                    ],
                    [
                        121.949506296816,
                        0.511802075902837
                    ],
                    [
                        121.94952499856,
                        0.512235956369643
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 398,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006351548483555481,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924047612356,
                        0.481377377027102
                    ],
                    [
                        121.923509002122,
                        0.481040745630442
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 399,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000656939863513826,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923883037007,
                        0.481594317260504
                    ],
                    [
                        121.923314503981,
                        0.481265166561548
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 400,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.006755589459794199,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94724291821,
                        0.46656536180222
                    ],
                    [
                        121.94758658409,
                        0.46658752177875
                    ],
                    [
                        121.94820101115,
                        0.46665056325081
                    ],
                    [
                        121.94907019666,
                        0.4667894509039
                    ],
                    [
                        121.94961680844,
                        0.46689692402455
                    ],
                    [
                        121.9501609214,
                        0.46698313605437
                    ],
                    [
                        121.95075889302,
                        0.46708448094738
                    ],
                    [
                        121.95248735996,
                        0.46735825241696
                    ],
                    [
                        121.95313800567,
                        0.46744331327786
                    ],
                    [
                        121.95363707767,
                        0.46746687897314
                    ],
                    [
                        121.95393000625,
                        0.467475115229
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 401,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00043108127605211583,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9539280213,
                        0.46747588232339
                    ],
                    [
                        121.95435877294,
                        0.46749273732868
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 403,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Belum berfungsi",
                "panjang": 0.008013560031367072,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93781778452,
                        0.46707067411203
                    ],
                    [
                        121.93768165158,
                        0.46613527654635
                    ],
                    [
                        121.93755663799,
                        0.46507919724712
                    ],
                    [
                        121.93744882269,
                        0.46413086296901
                    ],
                    [
                        121.9374061309,
                        0.46368309939047
                    ],
                    [
                        121.93723052107,
                        0.46243901324415
                    ],
                    [
                        121.93702117222,
                        0.46086291212508
                    ],
                    [
                        121.9369393646,
                        0.46014544438786
                    ],
                    [
                        121.93695411405,
                        0.45931264529774
                    ],
                    [
                        121.93695277614,
                        0.45919329083081
                    ],
                    [
                        121.93696350424,
                        0.45911416820557
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 406,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000773850794983528,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89235031605,
                        0.49873707031481
                    ],
                    [
                        121.89200565219,
                        0.4989315030161
                    ],
                    [
                        121.89167976379,
                        0.49912327591811
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 407,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0018321132405918674,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.917846851675,
                        0.482451746154596
                    ],
                    [
                        121.918295450286,
                        0.48277661579813
                    ],
                    [
                        121.918680214722,
                        0.483052058056159
                    ],
                    [
                        121.91871647316,
                        0.483080318338262
                    ],
                    [
                        121.918313168148,
                        0.483723384004913
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 408,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007806536752240242,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.913890182941,
                        0.479512886746775
                    ],
                    [
                        121.914110252683,
                        0.478763894444213
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 409,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.030996854482996595,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96863818119,
                        0.55157180261296
                    ],
                    [
                        121.96723917522,
                        0.55387621746432
                    ],
                    [
                        121.9677773915,
                        0.5563227618037
                    ],
                    [
                        121.96682921941,
                        0.55761268149606
                    ],
                    [
                        121.96681478039,
                        0.55873531547224
                    ],
                    [
                        121.96971702385,
                        0.56183248573448
                    ],
                    [
                        121.97151468212,
                        0.56326555868799
                    ],
                    [
                        121.97144970652,
                        0.56418243659779
                    ],
                    [
                        121.97064112127,
                        0.56670565572753
                    ],
                    [
                        121.97044619447,
                        0.56729043612669
                    ],
                    [
                        121.97115370656,
                        0.56758643608183
                    ],
                    [
                        121.9716374138,
                        0.56804126528118
                    ],
                    [
                        121.97169516989,
                        0.56891482612437
                    ],
                    [
                        121.97144970652,
                        0.56971619185656
                    ],
                    [
                        121.97030360913,
                        0.57080453315479
                    ],
                    [
                        121.97030360913,
                        0.57101389897671
                    ],
                    [
                        121.97182512109,
                        0.57193258176451
                    ],
                    [
                        121.97199838936,
                        0.57292887429642
                    ],
                    [
                        121.97113752365,
                        0.5761824288963
                    ],
                    [
                        121.97175979614,
                        0.57694413768862
                    ],
                    [
                        121.97202935815,
                        0.57691061177561
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 416,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00035943789337027434,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93343103128,
                        0.49146317765847
                    ],
                    [
                        121.93366974519,
                        0.49147792926534
                    ],
                    [
                        121.9337891057,
                        0.49146317765847
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 417,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006399907822721601,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93490892649,
                        0.4772292030522
                    ],
                    [
                        121.93499609828,
                        0.47741426905199
                    ],
                    [
                        121.9351402504,
                        0.47771330648086
                    ],
                    [
                        121.93517588408,
                        0.47781042932652
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 421,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.005516549837123855,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93341054857,
                        0.472060428642388
                    ],
                    [
                        121.933607503543,
                        0.473076476666646
                    ],
                    [
                        121.933759268107,
                        0.473611805962968
                    ],
                    [
                        121.933834365294,
                        0.4737413282947
                    ],
                    [
                        121.934004623098,
                        0.474166082998193
                    ],
                    [
                        121.93407447063,
                        0.47434653590955
                    ],
                    [
                        121.934123645839,
                        0.474519746472088
                    ],
                    [
                        121.934179679511,
                        0.474674194658328
                    ],
                    [
                        121.934545681445,
                        0.474576921839915
                    ],
                    [
                        121.934640075641,
                        0.474574183150325
                    ],
                    [
                        121.934704625798,
                        0.474599264119055
                    ],
                    [
                        121.93480484267,
                        0.474883802037902
                    ],
                    [
                        121.935293204951,
                        0.476757111107946
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 427,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0027452538834415604,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943476970426,
                        0.473952088597507
                    ],
                    [
                        121.943675481734,
                        0.474708650123208
                    ],
                    [
                        121.943841655769,
                        0.474804851808605
                    ],
                    [
                        121.943888304195,
                        0.475180259184831
                    ],
                    [
                        121.94396719071,
                        0.475572476075725
                    ],
                    [
                        121.943999705874,
                        0.475737521496849
                    ],
                    [
                        121.944139525661,
                        0.476550066178407
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 428,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0022084588503692116,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94396372368,
                        0.47556981294283
                    ],
                    [
                        121.94330198308,
                        0.47565787514238
                    ],
                    [
                        121.94277277441,
                        0.47576669059605
                    ],
                    [
                        121.94179510935,
                        0.4759797165235
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 429,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0033745798822066306,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94396399351,
                        0.47556292884184
                    ],
                    [
                        121.94410638103,
                        0.47555592520016
                    ],
                    [
                        121.9446765706,
                        0.47549943555803
                    ],
                    [
                        121.94482960857,
                        0.47550039313097
                    ],
                    [
                        121.94533773734,
                        0.4755992472551
                    ],
                    [
                        121.94546436669,
                        0.47562568572336
                    ],
                    [
                        121.94554620304,
                        0.4756398609961
                    ],
                    [
                        121.94588126691,
                        0.4756344350103
                    ],
                    [
                        121.94621348525,
                        0.47559578635354
                    ],
                    [
                        121.94658248112,
                        0.47553601659148
                    ],
                    [
                        121.94730193462,
                        0.47539808473206
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 431,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0015619413617959344,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94238723615,
                        0.46789552243965
                    ],
                    [
                        121.9423648275,
                        0.46715732694865
                    ],
                    [
                        121.94240394584,
                        0.46695705865977
                    ],
                    [
                        121.94246650734,
                        0.46675696574005
                    ],
                    [
                        121.94247411276,
                        0.46634732873694
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 432,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0023619576590355245,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94238960743,
                        0.46772645963222
                    ],
                    [
                        121.94272488356,
                        0.46769695631609
                    ],
                    [
                        121.94299712777,
                        0.46764867816214
                    ],
                    [
                        121.94335386157,
                        0.46771707221348
                    ],
                    [
                        121.94358604638,
                        0.46767071341885
                    ],
                    [
                        121.94467793574,
                        0.46731330809596
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 433,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.005124642296491311,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94215436205,
                        0.46629115459239
                    ],
                    [
                        121.94244267934,
                        0.46623617017696
                    ],
                    [
                        121.94297318011,
                        0.46622467484709
                    ],
                    [
                        121.94355044739,
                        0.4662185427245
                    ],
                    [
                        121.94374395982,
                        0.46622084065306
                    ],
                    [
                        121.94399822435,
                        0.46622390775254
                    ],
                    [
                        121.94426644082,
                        0.46622735684455
                    ],
                    [
                        121.94454194388,
                        0.46622946504012
                    ],
                    [
                        121.94495827855,
                        0.4662371285388
                    ],
                    [
                        121.94516057297,
                        0.46625571057865
                    ],
                    [
                        121.94557689653,
                        0.46628942532074
                    ],
                    [
                        121.94621372457,
                        0.46635283013076
                    ],
                    [
                        121.94642156669,
                        0.46639344446774
                    ],
                    [
                        121.94709536656,
                        0.46655207304083
                    ],
                    [
                        121.94724525593,
                        0.46656489425862
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 441,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0018796381607524505,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94213082601,
                        0.44959281953546
                    ],
                    [
                        121.94216965765,
                        0.45008896489253
                    ],
                    [
                        121.94219111925,
                        0.45023644640976
                    ],
                    [
                        121.94230647663,
                        0.45056893474009
                    ],
                    [
                        121.94204896688,
                        0.45066814894399
                    ],
                    [
                        121.94197654371,
                        0.45045363536929
                    ],
                    [
                        121.94194435641,
                        0.45030614120453
                    ],
                    [
                        121.94192651728,
                        0.45007916829204
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 442,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.008102805245531284,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94695346681,
                        0.48843179337054
                    ],
                    [
                        121.94659702728,
                        0.48788657076661
                    ],
                    [
                        121.94483647928,
                        0.48830585849014
                    ],
                    [
                        121.94437162595,
                        0.48792779365472
                    ],
                    [
                        121.94400866935,
                        0.48728527416231
                    ],
                    [
                        121.94371960754,
                        0.48580527285347
                    ],
                    [
                        121.94296769948,
                        0.48311173003527
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 449,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0037931649743103476,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94296302404,
                        0.48311640547133
                    ],
                    [
                        121.9421824873,
                        0.48331999664724
                    ],
                    [
                        121.94202048181,
                        0.4833965155639
                    ],
                    [
                        121.94228543031,
                        0.48428107851453
                    ],
                    [
                        121.94281761798,
                        0.48410713037344
                    ],
                    [
                        121.94301211612,
                        0.48505717898179
                    ],
                    [
                        121.94266426368,
                        0.48512450526113
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 460,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0025888116912298562,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.950184483522,
                        0.467111287396243
                    ],
                    [
                        121.950106498848,
                        0.468272223899862
                    ],
                    [
                        121.950048057131,
                        0.469454151311942
                    ],
                    [
                        121.950289917599,
                        0.46945776608111
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 461,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0002805990048882702,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.950286485558,
                        0.469453146340221
                    ],
                    [
                        121.950424742973,
                        0.469501076315647
                    ],
                    [
                        121.950557458983,
                        0.469521440348974
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 462,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002768485060825885,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94413709782,
                        0.47654562980358
                    ],
                    [
                        121.94413365906,
                        0.47672977546309
                    ],
                    [
                        121.94414398671,
                        0.4773905551506
                    ],
                    [
                        121.94382501837,
                        0.47743615360593
                    ],
                    [
                        121.94363675594,
                        0.47751701537206
                    ],
                    [
                        121.94391638514,
                        0.47888507205119
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 465,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.006141367500573231,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931867990157,
                        0.474037796113052
                    ],
                    [
                        121.931777328616,
                        0.473582149718803
                    ],
                    [
                        121.931686827232,
                        0.473104561193342
                    ],
                    [
                        121.931653495949,
                        0.472895136410709
                    ],
                    [
                        121.931589706842,
                        0.4725357065043
                    ],
                    [
                        121.931478566802,
                        0.47177318122744
                    ],
                    [
                        121.931391711198,
                        0.471124439636765
                    ],
                    [
                        121.931331067008,
                        0.470598235790274
                    ],
                    [
                        121.931300953424,
                        0.470284547322606
                    ],
                    [
                        121.931291926843,
                        0.469978424120588
                    ],
                    [
                        121.931293188567,
                        0.469704651442746
                    ],
                    [
                        121.931293325401,
                        0.468847080591798
                    ],
                    [
                        121.931291275673,
                        0.4685800931769
                    ],
                    [
                        121.931308599301,
                        0.46835697989675
                    ],
                    [
                        121.931345052398,
                        0.467943301184375
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 467,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0008726436739465903,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931182074103,
                        0.470461957012848
                    ],
                    [
                        121.930973911127,
                        0.470456159581457
                    ],
                    [
                        121.930879228494,
                        0.470456845723084
                    ],
                    [
                        121.930700254009,
                        0.470454069712662
                    ],
                    [
                        121.930617904333,
                        0.470457650506934
                    ],
                    [
                        121.930580480688,
                        0.470703624391335
                    ],
                    [
                        121.930535582887,
                        0.470742648404852
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 470,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0009370446401713254,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93116542249,
                        0.469119391004731
                    ],
                    [
                        121.930917542897,
                        0.469120232168669
                    ],
                    [
                        121.930723249442,
                        0.469120129557638
                    ],
                    [
                        121.930490144674,
                        0.468984280464441
                    ],
                    [
                        121.930265949394,
                        0.469004089600963
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 471,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0002947661287668996,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.930494968694,
                        0.469283196103485
                    ],
                    [
                        121.930478477338,
                        0.468988891659337
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 474,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.03462344293571905,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.97150177535,
                        0.47074167631253
                    ],
                    [
                        121.97153827722,
                        0.4706894773212
                    ],
                    [
                        121.97159723818,
                        0.47053580483794
                    ],
                    [
                        121.97165634975,
                        0.47018422199245
                    ],
                    [
                        121.9716792283,
                        0.46999273941786
                    ],
                    [
                        121.97175907823,
                        0.46984405868297
                    ],
                    [
                        121.97192383556,
                        0.46975037766081
                    ],
                    [
                        121.97241548089,
                        0.46974866918711
                    ],
                    [
                        121.97260186213,
                        0.46968101960305
                    ],
                    [
                        121.97273477912,
                        0.46952079744402
                    ],
                    [
                        121.97277769446,
                        0.46930622792422
                    ],
                    [
                        121.97273612022,
                        0.4689897378705
                    ],
                    [
                        121.97272726294,
                        0.46859018552861
                    ],
                    [
                        121.97285681963,
                        0.46844258554048
                    ],
                    [
                        121.97312772274,
                        0.46831250274985
                    ],
                    [
                        121.97342276573,
                        0.46819985373333
                    ],
                    [
                        121.97370037436,
                        0.46816900935944
                    ],
                    [
                        121.97381034493,
                        0.4682119232709
                    ],
                    [
                        121.97389717025,
                        0.46829931903487
                    ],
                    [
                        121.97396094942,
                        0.46858710365363
                    ],
                    [
                        121.97392903728,
                        0.46965000108622
                    ],
                    [
                        121.97392117975,
                        0.47003879569307
                    ],
                    [
                        121.9739600605,
                        0.47020218878477
                    ],
                    [
                        121.97419469665,
                        0.47062511217272
                    ],
                    [
                        121.97463512421,
                        0.47139291622463
                    ],
                    [
                        121.97483808781,
                        0.47169479358351
                    ],
                    [
                        121.97496771812,
                        0.47182741936544
                    ],
                    [
                        121.97528958321,
                        0.47188106172661
                    ],
                    [
                        121.97647511959,
                        0.47179523394852
                    ],
                    [
                        121.97757482529,
                        0.47174159158668
                    ],
                    [
                        121.97845837954,
                        0.47174878087983
                    ],
                    [
                        121.97888421819,
                        0.47173309227456
                    ],
                    [
                        121.97982209429,
                        0.47170823069052
                    ],
                    [
                        121.98056280613,
                        0.47168258498818
                    ],
                    [
                        121.98093295097,
                        0.47163430686175
                    ],
                    [
                        121.98257967079,
                        0.47092173996653
                    ],
                    [
                        121.98332747984,
                        0.47071646833413
                    ],
                    [
                        121.98409032921,
                        0.47057591952961
                    ],
                    [
                        121.98449412918,
                        0.47048393917202
                    ],
                    [
                        121.98523367781,
                        0.47030652281065
                    ],
                    [
                        121.98527670008,
                        0.47028529101643
                    ],
                    [
                        121.98534031328,
                        0.47026401366423
                    ],
                    [
                        121.98539637977,
                        0.47026041697652
                    ],
                    [
                        121.98566738725,
                        0.4702295863759
                    ],
                    [
                        121.98592716646,
                        0.47020677809234
                    ],
                    [
                        121.98611784792,
                        0.47017782000908
                    ],
                    [
                        121.98639752003,
                        0.47010949106553
                    ],
                    [
                        121.98656905919,
                        0.47004443791194
                    ],
                    [
                        121.98684152342,
                        0.46994417911654
                    ],
                    [
                        121.98699888071,
                        0.46988396740868
                    ],
                    [
                        121.98726712335,
                        0.4697807873775
                    ],
                    [
                        121.98733676726,
                        0.4697566767456
                    ],
                    [
                        121.98738213231,
                        0.46975640675358
                    ],
                    [
                        121.98744552343,
                        0.46975951003207
                    ],
                    [
                        121.98755061389,
                        0.4697996568049
                    ],
                    [
                        121.98796592435,
                        0.4700036469507
                    ],
                    [
                        121.98849617506,
                        0.47017159011896
                    ],
                    [
                        121.98884903731,
                        0.47021672957832
                    ],
                    [
                        121.98942550166,
                        0.47024002876419
                    ],
                    [
                        121.98993752477,
                        0.47026910658403
                    ],
                    [
                        121.99014804373,
                        0.47032694295739
                    ],
                    [
                        121.99024388355,
                        0.47039592395896
                    ],
                    [
                        121.99035940827,
                        0.47047153177272
                    ],
                    [
                        121.99049686634,
                        0.47061141831177
                    ],
                    [
                        121.99061261671,
                        0.47075818822627
                    ],
                    [
                        121.99068398867,
                        0.4709092459029
                    ],
                    [
                        121.99080041597,
                        0.4712414821369
                    ],
                    [
                        121.99093538152,
                        0.47162181903515
                    ],
                    [
                        121.99111512665,
                        0.4719519545077
                    ],
                    [
                        121.99126641919,
                        0.47216827481036
                    ],
                    [
                        121.99141020655,
                        0.4723185241197
                    ],
                    [
                        121.99170213078,
                        0.47254492953198
                    ],
                    [
                        121.99217314941,
                        0.47282460203783
                    ],
                    [
                        121.9926389056,
                        0.47310964438969
                    ],
                    [
                        121.99307799877,
                        0.4733706727239
                    ],
                    [
                        121.99340514058,
                        0.47352964321888
                    ],
                    [
                        121.99363186955,
                        0.47358957071359
                    ],
                    [
                        121.9938826561,
                        0.47363382565037
                    ],
                    [
                        121.99416697025,
                        0.47365260047194
                    ],
                    [
                        121.99458003044,
                        0.47367539846949
                    ],
                    [
                        121.99493542314,
                        0.47367808058684
                    ],
                    [
                        121.99510708451,
                        0.47364589517853
                    ],
                    [
                        121.99539139867,
                        0.47353861048301
                    ],
                    [
                        121.99558451772,
                        0.47344875954925
                    ],
                    [
                        121.99605926871,
                        0.473196640505
                    ],
                    [
                        121.99651256204,
                        0.47297402474554
                    ],
                    [
                        121.99699133635,
                        0.47274872686123
                    ],
                    [
                        121.99717909098,
                        0.47267765074145
                    ],
                    [
                        121.99728906155,
                        0.47265619379949
                    ],
                    [
                        121.99739634991,
                        0.47264546532848
                    ],
                    [
                        121.99768334627,
                        0.47264680638735
                    ],
                    [
                        121.99859932065,
                        0.47271922356631
                    ],
                    [
                        121.99888363481,
                        0.47274068050807
                    ],
                    [
                        121.99920704677,
                        0.47280209040313
                    ],
                    [
                        121.99930608273,
                        0.47280907450953
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 476,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016086298121601298,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932215671845,
                        0.476286217165253
                    ],
                    [
                        121.931365117364,
                        0.476431039126519
                    ],
                    [
                        121.930623713014,
                        0.476512206818372
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 481,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.006113482818291317,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93571122873,
                        0.48191141782287
                    ],
                    [
                        121.93519377717,
                        0.48106226626607
                    ],
                    [
                        121.93448309901,
                        0.48000685765145
                    ],
                    [
                        121.93398195504,
                        0.47933335786863
                    ],
                    [
                        121.93374634976,
                        0.47902714964382
                    ],
                    [
                        121.93354743717,
                        0.47875393294206
                    ],
                    [
                        121.93333017849,
                        0.47847925313167
                    ],
                    [
                        121.93299791809,
                        0.47807484865337
                    ],
                    [
                        121.93293561632,
                        0.47797950386707
                    ],
                    [
                        121.93274111818,
                        0.4774764269465
                    ],
                    [
                        121.93256158143,
                        0.4770572741033
                    ],
                    [
                        121.93247742358,
                        0.47676926724171
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 482,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00523884830676824,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932717740995,
                        0.494225241561139
                    ],
                    [
                        121.932680888047,
                        0.492711735537051
                    ],
                    [
                        121.932607322832,
                        0.491240640948431
                    ],
                    [
                        121.932594911653,
                        0.490254665715308
                    ],
                    [
                        121.932494328006,
                        0.489261141965132
                    ],
                    [
                        121.932511603535,
                        0.488994395575263
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 486,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.007913605344242595,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.922377331767,
                        0.486635187569085
                    ],
                    [
                        121.922338224552,
                        0.486604321729427
                    ],
                    [
                        121.922290112949,
                        0.486570734313381
                    ],
                    [
                        121.922237852734,
                        0.486534668372114
                    ],
                    [
                        121.922185154951,
                        0.486507701598341
                    ],
                    [
                        121.922045707569,
                        0.486424213179632
                    ],
                    [
                        121.921716142252,
                        0.486215949911304
                    ],
                    [
                        121.921388304877,
                        0.485990202011292
                    ],
                    [
                        121.921169153741,
                        0.485833996521152
                    ],
                    [
                        121.920570109976,
                        0.485415071901598
                    ],
                    [
                        121.915924129828,
                        0.482058109638137
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 487,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005034172186467787,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.91315396972,
                        0.48594298321382
                    ],
                    [
                        121.91320747227,
                        0.48586351311253
                    ],
                    [
                        121.9132503659,
                        0.48579983317588
                    ],
                    [
                        121.91330723745,
                        0.48570279116037
                    ],
                    [
                        121.91344375211,
                        0.48548605641895
                    ],
                    [
                        121.91359892976,
                        0.48522690774015
                    ],
                    [
                        121.91393136978,
                        0.48472571979037
                    ],
                    [
                        121.91422482588,
                        0.48420577034237
                    ],
                    [
                        121.91438143299,
                        0.48394168064618
                    ],
                    [
                        121.91475831556,
                        0.48328715049692
                    ],
                    [
                        121.91528672045,
                        0.48239551014013
                    ],
                    [
                        121.91561427621,
                        0.48197417986204
                    ],
                    [
                        121.91572972465,
                        0.48194281836952
                    ],
                    [
                        121.91593552863,
                        0.48206700170337
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 488,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002427798297929118,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.91321821538,
                        0.485991265791549
                    ],
                    [
                        121.913154198,
                        0.485942968606417
                    ],
                    [
                        121.912086749048,
                        0.485147638892676
                    ],
                    [
                        121.911258424545,
                        0.484558543725536
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 489,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.003825457968385467,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.916700632124,
                        0.481828089063741
                    ],
                    [
                        121.91849685084,
                        0.47914005127771
                    ],
                    [
                        121.918819039554,
                        0.478642795588738
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 497,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002898209667423844,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93127587438,
                        0.46769963843574
                    ],
                    [
                        121.92839212399,
                        0.46798878020798
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 499,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002041629433602581,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92850525777,
                        0.47002637684904
                    ],
                    [
                        121.92849536427,
                        0.46997416639924
                    ],
                    [
                        121.92848623147,
                        0.46967507792537
                    ],
                    [
                        121.92848554597,
                        0.46965178526358
                    ],
                    [
                        121.92848012076,
                        0.46956261170495
                    ],
                    [
                        121.92839635243,
                        0.46802462609286
                    ],
                    [
                        121.92839585506,
                        0.46798827387717
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 501,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00334894504232238,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931306510954,
                        0.467679746359553
                    ],
                    [
                        121.931211966098,
                        0.467239574240727
                    ],
                    [
                        121.931158516775,
                        0.466981460075437
                    ],
                    [
                        121.930997348544,
                        0.466264773350377
                    ],
                    [
                        121.930970431961,
                        0.466154003329077
                    ],
                    [
                        121.930921454483,
                        0.465941336036114
                    ],
                    [
                        121.930894154056,
                        0.465867140137503
                    ],
                    [
                        121.930607684207,
                        0.465198626464182
                    ],
                    [
                        121.930386173299,
                        0.464737138337536
                    ],
                    [
                        121.93032935489,
                        0.464646280063789
                    ],
                    [
                        121.930241350426,
                        0.464533685517063
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 502,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi ",
                "panjang": 0.0003652656843223893,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92909861448,
                        0.46429016805127
                    ],
                    [
                        121.92874175424,
                        0.46436807690345
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2072,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0019443226339524954,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94375667555,
                        0.48606622813074
                    ],
                    [
                        121.94337810861,
                        0.48617283561506
                    ],
                    [
                        121.94317136408,
                        0.48631800982264
                    ],
                    [
                        121.94321047067,
                        0.48672923214403
                    ],
                    [
                        121.94318670634,
                        0.48709115134477
                    ],
                    [
                        121.94314518562,
                        0.48761213057873
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2073,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.00033478776979255134,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94202758967,
                        0.48339494210372
                    ],
                    [
                        121.94193054732,
                        0.48338328469037
                    ],
                    [
                        121.94182017445,
                        0.48339623061499
                    ],
                    [
                        121.94171983301,
                        0.48347230293132
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 503,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.010340213446044431,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92956062373,
                        0.46367228011724
                    ],
                    [
                        121.92950288984,
                        0.46354736869485
                    ],
                    [
                        121.92890074442,
                        0.461584402973
                    ],
                    [
                        121.92792847753,
                        0.45863943169195
                    ],
                    [
                        121.92631379621,
                        0.4538565914911
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 505,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.003485998648054699,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93411228232,
                        0.44652691099918
                    ],
                    [
                        121.93425445295,
                        0.44639819291377
                    ],
                    [
                        121.93454682906,
                        0.44619303503102
                    ],
                    [
                        121.93468025747,
                        0.44610837020594
                    ],
                    [
                        121.93551821707,
                        0.44562675117866
                    ],
                    [
                        121.93601818087,
                        0.44547887887741
                    ],
                    [
                        121.9362103343,
                        0.44536570494804
                    ],
                    [
                        121.93643061526,
                        0.44536779118909
                    ],
                    [
                        121.93719953416,
                        0.44572500500064
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2075,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0005834812139438968,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93605705775,
                        0.44538439659566
                    ],
                    [
                        121.93603827296,
                        0.44526097487036
                    ],
                    [
                        121.93603424765,
                        0.44520597170952
                    ],
                    [
                        121.93597520974,
                        0.44510133154871
                    ],
                    [
                        121.93588799464,
                        0.44490949125005
                    ],
                    [
                        121.93585445038,
                        0.44484509730251
                    ],
                    [
                        121.93585445038,
                        0.44484509730251
                    ],
                    [
                        121.93585445038,
                        0.44484509730251
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2077,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 3.5733119656475725e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57134758426,
                        0.54133416662075
                    ],
                    [
                        121.57137709055,
                        0.54134488919828
                    ],
                    [
                        121.57137977294,
                        0.54134622952049
                    ],
                    [
                        121.57137977294,
                        0.54134488919828
                    ],
                    [
                        121.57137977294,
                        0.54134488919828
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2082,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0020314425563458644,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09403634071,
                        0.56330712113908
                    ],
                    [
                        122.09408327937,
                        0.56336746792493
                    ],
                    [
                        122.09416911006,
                        0.56336478584557
                    ],
                    [
                        122.09417715669,
                        0.56346938693962
                    ],
                    [
                        122.0941825211,
                        0.56357935219032
                    ],
                    [
                        122.09419861436,
                        0.56377112085425
                    ],
                    [
                        122.09420800209,
                        0.56390388377173
                    ],
                    [
                        122.09421336651,
                        0.56414929400515
                    ],
                    [
                        122.09420531988,
                        0.56435313200539
                    ],
                    [
                        122.0941825211,
                        0.5645864728653
                    ],
                    [
                        122.09416911006,
                        0.56481579059783
                    ],
                    [
                        122.09414362907,
                        0.56512422963897
                    ],
                    [
                        122.09413021803,
                        0.56522883070139
                    ],
                    [
                        122.09413021803,
                        0.56522883070139
                    ],
                    [
                        122.09413021803,
                        0.56522883070139
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2083,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.007145635352932937,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10349112749,
                        0.55980566545191
                    ],
                    [
                        122.1038505435,
                        0.55952941110324
                    ],
                    [
                        122.10399538279,
                        0.55937250935574
                    ],
                    [
                        122.10413083434,
                        0.55924645153846
                    ],
                    [
                        122.10428774357,
                        0.55907077521413
                    ],
                    [
                        122.10441246629,
                        0.55888437055891
                    ],
                    [
                        122.10454657674,
                        0.55870333006075
                    ],
                    [
                        122.10474506021,
                        0.55843512190509
                    ],
                    [
                        122.10488721728,
                        0.55816959581892
                    ],
                    [
                        122.10494488478,
                        0.55806365358928
                    ],
                    [
                        122.10511520505,
                        0.55775655521662
                    ],
                    [
                        122.10533380508,
                        0.55743202329449
                    ],
                    [
                        122.1055161953,
                        0.55715710987537
                    ],
                    [
                        122.10568383336,
                        0.5569184045547
                    ],
                    [
                        122.10589438677,
                        0.55663142174066
                    ],
                    [
                        122.10615456104,
                        0.556263976435
                    ],
                    [
                        122.10635572672,
                        0.55596760629956
                    ],
                    [
                        122.10659578443,
                        0.55562027657436
                    ],
                    [
                        122.10683315992,
                        0.55531854224052
                    ],
                    [
                        122.1070356667,
                        0.55508654205337
                    ],
                    [
                        122.10714429617,
                        0.55495511997799
                    ],
                    [
                        122.10731998086,
                        0.55471641456832
                    ],
                    [
                        122.10740983486,
                        0.55453269185881
                    ],
                    [
                        122.10749298334,
                        0.55445088831478
                    ],
                    [
                        122.10756540298,
                        0.55434628706012
                    ],
                    [
                        122.10760831833,
                        0.55426046038825
                    ],
                    [
                        122.10764452815,
                        0.55417329267336
                    ],
                    [
                        122.10765391588,
                        0.55406869141379
                    ],
                    [
                        122.10765391588,
                        0.55406869141379
                    ],
                    [
                        122.10765391588,
                        0.55406869141379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 507,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0038264048316126774,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93124731635,
                        0.468118074119315
                    ],
                    [
                        121.931255870116,
                        0.467932682768426
                    ],
                    [
                        121.931280425995,
                        0.467796848242607
                    ],
                    [
                        121.931294136065,
                        0.467720608343049
                    ],
                    [
                        121.931165626756,
                        0.467093313220877
                    ],
                    [
                        121.930881124897,
                        0.465919503802171
                    ],
                    [
                        121.930790456011,
                        0.465732756745042
                    ],
                    [
                        121.930599108524,
                        0.465216180041541
                    ],
                    [
                        121.930561660301,
                        0.465145320291771
                    ],
                    [
                        121.930374471125,
                        0.464750194416414
                    ],
                    [
                        121.930191999556,
                        0.464510360028777
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 510,
                "jenis_pipa": "Pipa 50",
                "keterangan": "+ Reduser 2\" x 1\"",
                "panjang": 0.0004531321865126081,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92890210688,
                        0.46159110827793
                    ],
                    [
                        121.9293462415,
                        0.46150125719127
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 513,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 9.310769516787361e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93595096469,
                        0.46486329633004
                    ],
                    [
                        121.9360421598,
                        0.46484452148487
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 517,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001432331773823495,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935992883956,
                        0.46430572355214
                    ],
                    [
                        121.93607031705,
                        0.46428909082171
                    ],
                    [
                        121.936664548004,
                        0.46420782194114
                    ],
                    [
                        121.937012054477,
                        0.464170148613672
                    ],
                    [
                        121.937362728922,
                        0.464123163547004
                    ],
                    [
                        121.937412346345,
                        0.464116835935125
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 518,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00552191166657117,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93672310562,
                        0.46728849172018
                    ],
                    [
                        121.93693486824,
                        0.46724194321325
                    ],
                    [
                        121.93739906029,
                        0.46716608716589
                    ],
                    [
                        121.93770244039,
                        0.46711513314839
                    ],
                    [
                        121.93785781182,
                        0.46709999721559
                    ],
                    [
                        121.93822614388,
                        0.46702641132392
                    ],
                    [
                        121.93878274262,
                        0.46691301272437
                    ],
                    [
                        121.9391349635,
                        0.46684594385019
                    ],
                    [
                        121.94014466107,
                        0.46665822313833
                    ],
                    [
                        121.94081319293,
                        0.46652643537721
                    ],
                    [
                        121.94215263649,
                        0.46628847247219
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2060,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribus",
                "panjang": 0.00010536499039258809,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94699950667,
                        0.46634246383441
                    ],
                    [
                        121.94710191338,
                        0.4663672559087
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 525,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.008162394031148133,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94495356519,
                        0.4584757757465
                    ],
                    [
                        121.94485051302,
                        0.45845291408299
                    ],
                    [
                        121.94466680288,
                        0.45839938241586
                    ],
                    [
                        121.94447100163,
                        0.45835378632179
                    ],
                    [
                        121.94431811596,
                        0.45831623659703
                    ],
                    [
                        121.94417447981,
                        0.45827360473827
                    ],
                    [
                        121.94273934066,
                        0.45793522658174
                    ],
                    [
                        121.94193054739,
                        0.45781951242397
                    ],
                    [
                        121.94151118417,
                        0.45776639372811
                    ],
                    [
                        121.94128319621,
                        0.45772482334551
                    ],
                    [
                        121.94100156407,
                        0.45765106242058
                    ],
                    [
                        121.94080844522,
                        0.45758267248954
                    ],
                    [
                        121.94041147828,
                        0.45742174634424
                    ],
                    [
                        121.94006815572,
                        0.4572903184941
                    ],
                    [
                        121.93988040247,
                        0.45722192096846
                    ],
                    [
                        121.93977713938,
                        0.45718571272132
                    ],
                    [
                        121.93972483513,
                        0.45716157824768
                    ],
                    [
                        121.93967191136,
                        0.45714314746598
                    ],
                    [
                        121.93963502573,
                        0.45713241934586
                    ],
                    [
                        121.93961352149,
                        0.45712403020361
                    ],
                    [
                        121.93958154749,
                        0.45711157185712
                    ],
                    [
                        121.93955500297,
                        0.45710300377041
                    ],
                    [
                        121.93952283987,
                        0.45709339991852
                    ],
                    [
                        121.93949812698,
                        0.45708696674124
                    ],
                    [
                        121.93946326952,
                        0.45707185958293
                    ],
                    [
                        121.93865936596,
                        0.45686542493523
                    ],
                    [
                        121.93792412053,
                        0.45670590650333
                    ],
                    [
                        121.93706273718,
                        0.45646960128146
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 526,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0043845078069418885,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94495691063,
                        0.45847159009019
                    ],
                    [
                        121.94502836458,
                        0.45848140114986
                    ],
                    [
                        121.94508984098,
                        0.45817343709262
                    ],
                    [
                        121.94524689865,
                        0.45718765325662
                    ],
                    [
                        121.9452890511,
                        0.45685176512132
                    ],
                    [
                        121.94535038595,
                        0.45649798320327
                    ],
                    [
                        121.94537626648,
                        0.45638830652758
                    ],
                    [
                        121.94539642349,
                        0.45631048437033
                    ],
                    [
                        121.94551180603,
                        0.45624236715451
                    ],
                    [
                        121.94559838773,
                        0.45621833494568
                    ],
                    [
                        121.94576200252,
                        0.45621447236588
                    ],
                    [
                        121.94596928354,
                        0.45625373228627
                    ],
                    [
                        121.94687200787,
                        0.45627464977298
                    ],
                    [
                        121.947480011,
                        0.45628012084604
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2084,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00015495308390209463,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10765525699,
                        0.55406466828838
                    ],
                    [
                        122.10764721036,
                        0.55399627515607
                    ],
                    [
                        122.10764050484,
                        0.55391044847914
                    ],
                    [
                        122.10764050484,
                        0.55391044847914
                    ],
                    [
                        122.10764050484,
                        0.55391044847914
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 535,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.007101820084604832,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94050654993,
                        0.47510177296919
                    ],
                    [
                        121.93971163618,
                        0.47384054297968
                    ],
                    [
                        121.93962617221,
                        0.47368805311189
                    ],
                    [
                        121.93949625059,
                        0.47341641276111
                    ],
                    [
                        121.93735156568,
                        0.46875066061887
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 536,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0005867677359108354,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937345955153,
                        0.468737569397887
                    ],
                    [
                        121.937321896664,
                        0.468694134702225
                    ],
                    [
                        121.93719971109,
                        0.468425702601916
                    ],
                    [
                        121.937100587579,
                        0.468204734270011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 538,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0014302034232205568,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.936793339981,
                        0.467458063738965
                    ],
                    [
                        121.936808764993,
                        0.467421378379478
                    ],
                    [
                        121.936821795002,
                        0.467404031182406
                    ],
                    [
                        121.936841619703,
                        0.467394909979517
                    ],
                    [
                        121.936862523502,
                        0.46738716929404
                    ],
                    [
                        121.936901424953,
                        0.467382320272184
                    ],
                    [
                        121.938166892286,
                        0.467156856114485
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 540,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004364472765585322,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938163692137,
                        0.46715685490561
                    ],
                    [
                        121.938309908614,
                        0.467138298359012
                    ],
                    [
                        121.942451411115,
                        0.466343471300818
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 542,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0032945993130178725,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943725314411,
                        0.466321236070711
                    ],
                    [
                        121.943792328556,
                        0.46632024449336
                    ],
                    [
                        121.943853697356,
                        0.466320498494351
                    ],
                    [
                        121.943893805278,
                        0.466322371462984
                    ],
                    [
                        121.94398462878,
                        0.46632623527336
                    ],
                    [
                        121.94407946867,
                        0.466330269976027
                    ],
                    [
                        121.944262750445,
                        0.466332400497338
                    ],
                    [
                        121.944488677935,
                        0.466342364194173
                    ],
                    [
                        121.944665464969,
                        0.466343894127467
                    ],
                    [
                        121.945157667088,
                        0.466371944505054
                    ],
                    [
                        121.945266278088,
                        0.466371200362491
                    ],
                    [
                        121.945384207638,
                        0.46637716987741
                    ],
                    [
                        121.945498842718,
                        0.466380994336504
                    ],
                    [
                        121.94554561043,
                        0.466383163803188
                    ],
                    [
                        121.945621066594,
                        0.466393480626842
                    ],
                    [
                        121.946856727196,
                        0.46660557055238
                    ],
                    [
                        121.946896000859,
                        0.466629882819916
                    ],
                    [
                        121.946927793825,
                        0.466650454738601
                    ],
                    [
                        121.946931534173,
                        0.46666915648286
                    ],
                    [
                        121.946957716615,
                        0.466699079273674
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 544,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.007091698192770389,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94041304121,
                        0.47512795541115
                    ],
                    [
                        121.93958113443,
                        0.47376283421308
                    ],
                    [
                        121.93729199763,
                        0.46876947590677
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 546,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0016250867989370406,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93897551069,
                        0.47550345184908
                    ],
                    [
                        121.93912636121,
                        0.47546832715666
                    ],
                    [
                        121.94054769377,
                        0.47509242209706
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 547,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0024279376932663825,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940527121851,
                        0.475103643143611
                    ],
                    [
                        121.942757892001,
                        0.474145235098838
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 549,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.003737060845848888,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94345543686,
                        0.47386101674666
                    ],
                    [
                        121.94400140045,
                        0.47381617463657
                    ],
                    [
                        121.9444920032,
                        0.47375326757427
                    ],
                    [
                        121.94531857967,
                        0.47358957071359
                    ],
                    [
                        121.94715408493,
                        0.47334287392164
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 552,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0038376511035109226,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94259179442,
                        0.47431629971031
                    ],
                    [
                        121.9434726563,
                        0.4739531191489
                    ],
                    [
                        121.944265464,
                        0.47384993755178
                    ],
                    [
                        121.94632416668,
                        0.47351755224753
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 554,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0023887688003991197,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94825961793,
                        0.47333208800197
                    ],
                    [
                        121.94865785429,
                        0.47329854747104
                    ],
                    [
                        121.9489394396,
                        0.47330123071353
                    ],
                    [
                        121.95064686228,
                        0.47328259237444
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 557,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0030696099426033973,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954588137501,
                        0.4675940458574
                    ],
                    [
                        121.954719498433,
                        0.467586919390803
                    ],
                    [
                        121.954841774511,
                        0.467568401451014
                    ],
                    [
                        121.954930736231,
                        0.467550714430295
                    ],
                    [
                        121.955073525496,
                        0.467510162556621
                    ],
                    [
                        121.955185525505,
                        0.467483328333484
                    ],
                    [
                        121.957564173546,
                        0.46685562481269
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 558,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0009258400035153625,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95755952443,
                        0.46685637692347
                    ],
                    [
                        121.95768454223,
                        0.46683658307043
                    ],
                    [
                        121.95782157629,
                        0.46684083869523
                    ],
                    [
                        121.95799622836,
                        0.4668498600947
                    ],
                    [
                        121.95848158749,
                        0.4668930830347
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 560,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.004529216352482245,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93798273704,
                        0.4670519065095
                    ],
                    [
                        121.93806052208,
                        0.46703447273013
                    ],
                    [
                        121.93816781044,
                        0.46701301577084
                    ],
                    [
                        121.93957036175,
                        0.46674212165412
                    ],
                    [
                        121.94146100785,
                        0.46638942286274
                    ],
                    [
                        121.94243386388,
                        0.46621508505059
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 562,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0034531902956622226,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94354967265,
                        0.46619899232926
                    ],
                    [
                        121.94393053454,
                        0.4662030155096
                    ],
                    [
                        121.94497402382,
                        0.46622179035115
                    ],
                    [
                        121.94574236428,
                        0.46627811487549
                    ],
                    [
                        121.94623857319,
                        0.46633443939938
                    ],
                    [
                        121.94659803535,
                        0.46640819770379
                    ],
                    [
                        121.94688096201,
                        0.46644574738574
                    ],
                    [
                        121.9469869127,
                        0.46645647586626
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 563,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0013402959709526742,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95304337895,
                        0.46741131056706
                    ],
                    [
                        121.95327803394,
                        0.46743544964488
                    ],
                    [
                        121.95438179806,
                        0.46747299932135
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 576,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0021001922320411314,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94956719129,
                        0.45876281093993
                    ],
                    [
                        121.94964363975,
                        0.45666401055769
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 578,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012236023971366101,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94961010899,
                        0.45727156893279
                    ],
                    [
                        121.94838713411,
                        0.45723238642161
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 579,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007433244208833621,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94952698958,
                        0.45799572371053
                    ],
                    [
                        121.94955113457,
                        0.45725279153722
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 592,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0001843731356986216,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9438688455,
                        0.44886577140685
                    ],
                    [
                        121.9440512585,
                        0.44883895815263
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1855,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00022877778273404478,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.48413956165,
                        0.52744627072244
                    ],
                    [
                        121.48406177759,
                        0.52765413310973
                    ],
                    [
                        121.48405507207,
                        0.52765279206208
                    ],
                    [
                        121.48405507207,
                        0.52765279206208
                    ],
                    [
                        121.48405507207,
                        0.52765279206208
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 593,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0013041167304648623,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94481530338,
                        0.44879021297881
                    ],
                    [
                        121.9450798027,
                        0.44884756105243
                    ],
                    [
                        121.94549828768,
                        0.44894220990892
                    ],
                    [
                        121.94608046786,
                        0.44910464767844
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 594,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0007794198011705001,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94249287051,
                        0.44954568965167
                    ],
                    [
                        121.94249286933,
                        0.44912190691161
                    ],
                    [
                        121.94247678237,
                        0.4491031265428
                    ],
                    [
                        121.9424499589,
                        0.44908435334338
                    ],
                    [
                        121.94242313485,
                        0.44906558183082
                    ],
                    [
                        121.94241106451,
                        0.44905485248081
                    ],
                    [
                        121.94239899477,
                        0.44904546503759
                    ],
                    [
                        121.94236814681,
                        0.44902132927164
                    ],
                    [
                        121.94236680649,
                        0.4489449084831
                    ],
                    [
                        121.94236010136,
                        0.44886714578695
                    ],
                    [
                        121.94237083216,
                        0.4488282629625
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1856,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.027855756631858478,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4840349555,
                        0.52775739377695
                    ],
                    [
                        121.48398131132,
                        0.52793575310722
                    ],
                    [
                        121.48392364383,
                        0.52805510634039
                    ],
                    [
                        121.48386865854,
                        0.52823882985217
                    ],
                    [
                        121.48381903768,
                        0.52843998697562
                    ],
                    [
                        121.48379087448,
                        0.52856604543633
                    ],
                    [
                        121.48372516036,
                        0.52871221960565
                    ],
                    [
                        121.48370236158,
                        0.52881682130268
                    ],
                    [
                        121.48362725973,
                        0.52913867266712
                    ],
                    [
                        121.48357361555,
                        0.52940151793569
                    ],
                    [
                        121.48352265358,
                        0.52966704528751
                    ],
                    [
                        121.48344621062,
                        0.52996341671224
                    ],
                    [
                        121.48339658976,
                        0.53020748728666
                    ],
                    [
                        121.48334830999,
                        0.53041400853442
                    ],
                    [
                        121.48330405355,
                        0.53060577825831
                    ],
                    [
                        121.48327723145,
                        0.53084850776045
                    ],
                    [
                        121.48323431611,
                        0.53106441631512
                    ],
                    [
                        121.48320347071,
                        0.53122936508163
                    ],
                    [
                        121.48315519094,
                        0.53146941246565
                    ],
                    [
                        121.48312836885,
                        0.53160217609861
                    ],
                    [
                        121.4830827713,
                        0.53180467415957
                    ],
                    [
                        121.48300096393,
                        0.53213457164862
                    ],
                    [
                        121.48295938969,
                        0.53230354352642
                    ],
                    [
                        121.48290708661,
                        0.53253956772893
                    ],
                    [
                        121.48286014795,
                        0.532779615062
                    ],
                    [
                        121.48279309273,
                        0.53300491087445
                    ],
                    [
                        121.48273944855,
                        0.53323825295725
                    ],
                    [
                        121.48266032338,
                        0.53354803467419
                    ],
                    [
                        121.4826066792,
                        0.53373309906908
                    ],
                    [
                        121.48256912827,
                        0.53388195520874
                    ],
                    [
                        121.4825463295,
                        0.53398789786451
                    ],
                    [
                        121.48250073195,
                        0.53422660409487
                    ],
                    [
                        121.48246318102,
                        0.53460746120725
                    ],
                    [
                        121.48244708776,
                        0.53497490783555
                    ],
                    [
                        121.48243099451,
                        0.53533162607408
                    ],
                    [
                        121.48241221905,
                        0.53568834429184
                    ],
                    [
                        121.48240953684,
                        0.53600483111429
                    ],
                    [
                        121.48237735033,
                        0.53621939844225
                    ],
                    [
                        121.48229688406,
                        0.53647419713441
                    ],
                    [
                        121.48220837116,
                        0.53670753908532
                    ],
                    [
                        121.48206084967,
                        0.53705889304055
                    ],
                    [
                        121.4819213748,
                        0.5373941544294
                    ],
                    [
                        121.48173093796,
                        0.53780719643515
                    ],
                    [
                        121.48158609867,
                        0.53811563687576
                    ],
                    [
                        121.4815056324,
                        0.53829265486072
                    ],
                    [
                        121.48138493299,
                        0.53853940719483
                    ],
                    [
                        121.48126423359,
                        0.53879956997105
                    ],
                    [
                        121.48116230965,
                        0.53904632228464
                    ],
                    [
                        121.48103892803,
                        0.5392984387686
                    ],
                    [
                        121.48088335991,
                        0.53962297167411
                    ],
                    [
                        121.48075461388,
                        0.53992604784294
                    ],
                    [
                        121.48062586784,
                        0.54022375981708
                    ],
                    [
                        121.48057222366,
                        0.54042759863782
                    ],
                    [
                        121.48051589727,
                        0.54065825834777
                    ],
                    [
                        121.48047298193,
                        0.54110884938378
                    ],
                    [
                        121.4804649353,
                        0.54151116278052
                    ],
                    [
                        121.48043274879,
                        0.54208781193593
                    ],
                    [
                        121.48043274879,
                        0.5424525760245
                    ],
                    [
                        121.48039519787,
                        0.5428682997751
                    ],
                    [
                        121.48036032915,
                        0.5431391907198
                    ],
                    [
                        121.48030668497,
                        0.54339935329881
                    ],
                    [
                        121.48025035858,
                        0.54363269498387
                    ],
                    [
                        121.48017525673,
                        0.54391431424692
                    ],
                    [
                        121.48011893034,
                        0.54412351711954
                    ],
                    [
                        121.48003846407,
                        0.544431957239
                    ],
                    [
                        121.48000225425,
                        0.54471625855255
                    ],
                    [
                        121.47994458675,
                        0.54504079116766
                    ],
                    [
                        121.4798694849,
                        0.54543237595266
                    ],
                    [
                        121.47979706526,
                        0.54585346367251
                    ],
                    [
                        121.47974610329,
                        0.5462933259726
                    ],
                    [
                        121.47966295481,
                        0.54688070301821
                    ],
                    [
                        121.47958248854,
                        0.54741175618808
                    ],
                    [
                        121.47954493761,
                        0.54774701700341
                    ],
                    [
                        121.4795127511,
                        0.5481546941296
                    ],
                    [
                        121.47948592901,
                        0.54849800116172
                    ],
                    [
                        121.4794510603,
                        0.54890567823676
                    ],
                    [
                        121.47941082716,
                        0.54932408362699
                    ],
                    [
                        121.47938534617,
                        0.54962045409402
                    ],
                    [
                        121.47934243083,
                        0.54994364540101
                    ],
                    [
                        121.47932365537,
                        0.55029902171425
                    ],
                    [
                        121.47930085659,
                        0.55054443251443
                    ],
                    [
                        121.47928208113,
                        0.55080057164481
                    ],
                    [
                        121.47924989462,
                        0.55099234072476
                    ],
                    [
                        121.47923380136,
                        0.55110498829332
                    ],
                    [
                        121.47919088602,
                        0.55118276875608
                    ],
                    [
                        121.47910773754,
                        0.55125250296322
                    ],
                    [
                        121.47896826267,
                        0.5512551850481
                    ],
                    [
                        121.47883683443,
                        0.55127395964217
                    ],
                    [
                        121.47866249084,
                        0.55127932381189
                    ],
                    [
                        121.47839426994,
                        0.55128468798162
                    ],
                    [
                        121.47822529078,
                        0.55128468798162
                    ],
                    [
                        121.47810459137,
                        0.5511613120768
                    ],
                    [
                        121.47805631161,
                        0.55115997103434
                    ],
                    [
                        121.47796109319,
                        0.55118410979854
                    ],
                    [
                        121.47789001465,
                        0.5511988612655
                    ],
                    [
                        121.47778943181,
                        0.55123372836908
                    ],
                    [
                        121.47770762444,
                        0.55126457234513
                    ],
                    [
                        121.47767946124,
                        0.55127798276945
                    ],
                    [
                        121.47759094834,
                        0.55131687299985
                    ],
                    [
                        121.47750645876,
                        0.5513718557389
                    ],
                    [
                        121.4774300158,
                        0.55141879222308
                    ],
                    [
                        121.47738307714,
                        0.55143086160465
                    ],
                    [
                        121.4773093164,
                        0.55148852642744
                    ],
                    [
                        121.4772208035,
                        0.5515300987412
                    ],
                    [
                        121.47711217403,
                        0.55156764792755
                    ],
                    [
                        121.47697404027,
                        0.55161056128312
                    ],
                    [
                        121.47685199976,
                        0.55163335900312
                    ],
                    [
                        121.47673398256,
                        0.55164274629958
                    ],
                    [
                        121.47660255432,
                        0.55164140525722
                    ],
                    [
                        121.47655025125,
                        0.55162665379137
                    ],
                    [
                        121.47645369172,
                        0.55161592545254
                    ],
                    [
                        121.47633031011,
                        0.55158776356301
                    ],
                    [
                        121.47620424628,
                        0.55154082708018
                    ],
                    [
                        121.47603526711,
                        0.55146438766448
                    ],
                    [
                        121.47595345974,
                        0.55142683847746
                    ],
                    [
                        121.47570133209,
                        0.55129943944832
                    ],
                    [
                        121.47570133209,
                        0.55129943944832
                    ],
                    [
                        121.47570133209,
                        0.55129943944832
                    ],
                    [
                        121.47570133209,
                        0.55129943944832
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1853,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0134700885319137,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.48308008909,
                        0.51708800986133
                    ],
                    [
                        121.48302912712,
                        0.51720468120089
                    ],
                    [
                        121.48314848542,
                        0.5172636873948
                    ],
                    [
                        121.48323968053,
                        0.51730660099001
                    ],
                    [
                        121.48334696889,
                        0.51737901768129
                    ],
                    [
                        121.48354411125,
                        0.51750775846373
                    ],
                    [
                        121.48366883397,
                        0.51761504244711
                    ],
                    [
                        121.48380964994,
                        0.51773573692624
                    ],
                    [
                        121.48399204016,
                        0.51790202709373
                    ],
                    [
                        121.48422002792,
                        0.51809647930016
                    ],
                    [
                        121.48438096046,
                        0.5182399716142
                    ],
                    [
                        121.48452714086,
                        0.51837407657764
                    ],
                    [
                        121.48464784026,
                        0.51848136054636
                    ],
                    [
                        121.48478999734,
                        0.51860205500899
                    ],
                    [
                        121.48494020104,
                        0.51873213681613
                    ],
                    [
                        121.485016644,
                        0.51881125873876
                    ],
                    [
                        121.48517355323,
                        0.5189373173931
                    ],
                    [
                        121.48526743054,
                        0.51901912141212
                    ],
                    [
                        121.48536801338,
                        0.51910763067742
                    ],
                    [
                        121.48544043303,
                        0.51918138839757
                    ],
                    [
                        121.48550480604,
                        0.51926319241342
                    ],
                    [
                        121.48567512631,
                        0.51942277729381
                    ],
                    [
                        121.48587763309,
                        0.51961857050287
                    ],
                    [
                        121.48597151041,
                        0.51968964611836
                    ],
                    [
                        121.48606538773,
                        0.51977010907832
                    ],
                    [
                        121.48614853621,
                        0.51985593623449
                    ],
                    [
                        121.48627728224,
                        0.51998199486801
                    ],
                    [
                        121.48649722338,
                        0.52021667848751
                    ],
                    [
                        121.48662596941,
                        0.5203360318678
                    ],
                    [
                        121.48680970073,
                        0.52052109665523
                    ],
                    [
                        121.48699611425,
                        0.52067799940554
                    ],
                    [
                        121.48716375232,
                        0.52087245152657
                    ],
                    [
                        121.48722544312,
                        0.5209287755881
                    ],
                    [
                        121.48730054498,
                        0.52101728482662
                    ],
                    [
                        121.48758083582,
                        0.52131097456372
                    ],
                    [
                        121.48748025298,
                        0.52136998071929
                    ],
                    [
                        121.4873971045,
                        0.52143032792329
                    ],
                    [
                        121.48735150695,
                        0.52147190044125
                    ],
                    [
                        121.48725897074,
                        0.52154968128057
                    ],
                    [
                        121.48716777563,
                        0.52163953155931
                    ],
                    [
                        121.48699477315,
                        0.52176424910824
                    ],
                    [
                        121.48687005043,
                        0.52186616882382
                    ],
                    [
                        121.4867721498,
                        0.52195601909801
                    ],
                    [
                        121.48668497801,
                        0.52203514098021
                    ],
                    [
                        121.48658573627,
                        0.52209817027547
                    ],
                    [
                        121.4865642786,
                        0.52212633230082
                    ],
                    [
                        121.48644626141,
                        0.5222497087913
                    ],
                    [
                        121.48640066385,
                        0.52230469179172
                    ],
                    [
                        121.48627325892,
                        0.52252328273983
                    ],
                    [
                        121.48619011045,
                        0.52269896012207
                    ],
                    [
                        121.48610159755,
                        0.52288670693734
                    ],
                    [
                        121.48603990674,
                        0.52307311269838
                    ],
                    [
                        121.4859674871,
                        0.52320453546182
                    ],
                    [
                        121.48582533002,
                        0.52353845655248
                    ],
                    [
                        121.48573547602,
                        0.52376643479694
                    ],
                    [
                        121.48551285267,
                        0.52424518908331
                    ],
                    [
                        121.48539081216,
                        0.52455228915249
                    ],
                    [
                        121.48526340723,
                        0.52482720404879
                    ],
                    [
                        121.48512125015,
                        0.5250618874873
                    ],
                    [
                        121.48500993848,
                        0.52526706785775
                    ],
                    [
                        121.48492008448,
                        0.52544006306681
                    ],
                    [
                        121.48487046361,
                        0.5255594163478
                    ],
                    [
                        121.48480340838,
                        0.52569352115517
                    ],
                    [
                        121.48473098874,
                        0.52585981111231
                    ],
                    [
                        121.48467063904,
                        0.52598184648126
                    ],
                    [
                        121.48461699486,
                        0.5260904713681
                    ],
                    [
                        121.48457542062,
                        0.52620580149281
                    ],
                    [
                        121.48452043533,
                        0.52636002200506
                    ],
                    [
                        121.48444935679,
                        0.5265061962262
                    ],
                    [
                        121.48437827826,
                        0.52671003550134
                    ],
                    [
                        121.48431926966,
                        0.526885712766
                    ],
                    [
                        121.48425489664,
                        0.52710564460182
                    ],
                    [
                        121.48421868682,
                        0.52724377251912
                    ],
                    [
                        121.48414626718,
                        0.52743688338866
                    ],
                    [
                        121.48413687944,
                        0.52745431700853
                    ],
                    [
                        121.48413687944,
                        0.52745431700853
                    ],
                    [
                        121.48413687944,
                        0.52745431700853
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 601,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007541962068906764,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938091228787,
                        0.446130200399131
                    ],
                    [
                        121.938076548764,
                        0.446122441315928
                    ],
                    [
                        121.938070537912,
                        0.446116433924651
                    ],
                    [
                        121.938060312021,
                        0.446107945194917
                    ],
                    [
                        121.938052246793,
                        0.446099636547936
                    ],
                    [
                        121.93804112144,
                        0.446091937509116
                    ],
                    [
                        121.938030028827,
                        0.44608426113056
                    ],
                    [
                        121.938017568172,
                        0.446077396017166
                    ],
                    [
                        121.938005075972,
                        0.44606897597806
                    ],
                    [
                        121.937993850047,
                        0.446065168887723
                    ],
                    [
                        121.937982883472,
                        0.446057570963125
                    ],
                    [
                        121.937971948952,
                        0.446049995328403
                    ],
                    [
                        121.937431958045,
                        0.445767511570944
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 605,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00044899995377870136,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938050801003,
                        0.446171423351737
                    ],
                    [
                        121.938063559618,
                        0.446156597869088
                    ],
                    [
                        121.938074429066,
                        0.44614205453557
                    ],
                    [
                        121.938319819196,
                        0.445811996627499
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 609,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009744489187970038,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93861710677,
                        0.44819521102199
                    ],
                    [
                        121.93834483643,
                        0.44808258572783
                    ],
                    [
                        121.93791836677,
                        0.44792701814329
                    ],
                    [
                        121.93780338342,
                        0.44788593633294
                    ],
                    [
                        121.93770915231,
                        0.44784253831017
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 610,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00017752537331886832,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94015915672,
                        0.44711911963977
                    ],
                    [
                        121.94008693079,
                        0.44707946763354
                    ],
                    [
                        121.94001451115,
                        0.44701778081267
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 617,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000614459072068615,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94326644166,
                        0.44883926820652
                    ],
                    [
                        121.94388089652,
                        0.44884154334847
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 618,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00127019647416197,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94288714522,
                        0.44886441937851
                    ],
                    [
                        121.9433980642,
                        0.44888453701569
                    ],
                    [
                        121.94415587919,
                        0.44884431650184
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 619,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0002610077004000771,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943408052435,
                        0.449145546019143
                    ],
                    [
                        121.943405541772,
                        0.449134069159968
                    ],
                    [
                        121.9434030814,
                        0.449125495962962
                    ],
                    [
                        121.943402887747,
                        0.44911127229299
                    ],
                    [
                        121.943402695193,
                        0.449097129446899
                    ],
                    [
                        121.943402503732,
                        0.449083066737656
                    ],
                    [
                        121.943402351341,
                        0.449071873801093
                    ],
                    [
                        121.94340216182,
                        0.449057953631645
                    ],
                    [
                        121.943401973365,
                        0.449044111716306
                    ],
                    [
                        121.943404081004,
                        0.449030347317196
                    ],
                    [
                        121.943403926705,
                        0.44901939130984
                    ],
                    [
                        121.943406057886,
                        0.449008484111697
                    ],
                    [
                        121.943408179574,
                        0.448997625529199
                    ],
                    [
                        121.943410291832,
                        0.448986815185044
                    ],
                    [
                        121.94341012513,
                        0.448976052888802
                    ],
                    [
                        121.943409917789,
                        0.448962666933918
                    ],
                    [
                        121.943412011065,
                        0.448952011246995
                    ],
                    [
                        121.943411884024,
                        0.448944050360199
                    ],
                    [
                        121.943413921628,
                        0.448930840424996
                    ],
                    [
                        121.94341361983,
                        0.448912468030558
                    ],
                    [
                        121.943413405672,
                        0.448899430814457
                    ],
                    [
                        121.94341542028,
                        0.448886464473568
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 620,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004429255434541286,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943403354382,
                        0.449145546187078
                    ],
                    [
                        121.943398765887,
                        0.449154188731055
                    ],
                    [
                        121.942967546113,
                        0.449194933851497
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 624,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00036630396533881144,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94249019184,
                        0.44954837346506
                    ],
                    [
                        121.94244056469,
                        0.44958457205056
                    ],
                    [
                        121.94213575248,
                        0.44959088878373
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1854,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005010289265215767,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45180150867,
                        0.50028060955405
                    ],
                    [
                        121.4518417418,
                        0.5003074306217
                    ],
                    [
                        121.45188331604,
                        0.50029133798112
                    ],
                    [
                        121.45193830132,
                        0.50024976532612
                    ],
                    [
                        121.45197987556,
                        0.50023769584559
                    ],
                    [
                        121.45199865103,
                        0.50025647059308
                    ],
                    [
                        121.45204827189,
                        0.50028865587436
                    ],
                    [
                        121.45205765963,
                        0.50032352326222
                    ],
                    [
                        121.45208314061,
                        0.50039996330422
                    ],
                    [
                        121.45210191607,
                        0.50059843919859
                    ],
                    [
                        121.45210325718,
                        0.5007070645166
                    ],
                    [
                        121.45210593939,
                        0.50091492777446
                    ],
                    [
                        121.45212337375,
                        0.50113754261105
                    ],
                    [
                        121.45214349031,
                        0.50133199532357
                    ],
                    [
                        121.45215690136,
                        0.50148085222373
                    ],
                    [
                        121.45219311118,
                        0.50165653018263
                    ],
                    [
                        121.45223736763,
                        0.50191803553255
                    ],
                    [
                        121.4522574842,
                        0.50206286926033
                    ],
                    [
                        121.45228430629,
                        0.50222781877972
                    ],
                    [
                        121.45233526826,
                        0.50238874513609
                    ],
                    [
                        121.45239695907,
                        0.50254833043557
                    ],
                    [
                        121.4524666965,
                        0.50270389257248
                    ],
                    [
                        121.45253375173,
                        0.50285543154714
                    ],
                    [
                        121.45259276032,
                        0.5029989242013
                    ],
                    [
                        121.45266115665,
                        0.50316521474983
                    ],
                    [
                        121.45277112722,
                        0.50343744846129
                    ],
                    [
                        121.45281806588,
                        0.50355948425927
                    ],
                    [
                        121.45285829902,
                        0.50366274531734
                    ],
                    [
                        121.4529414475,
                        0.50383305900692
                    ],
                    [
                        121.45299240947,
                        0.50396448216591
                    ],
                    [
                        121.4530916512,
                        0.50423403373882
                    ],
                    [
                        121.45313858986,
                        0.50437752636264
                    ],
                    [
                        121.4531815052,
                        0.50448346951277
                    ],
                    [
                        121.45330622792,
                        0.50479057053314
                    ],
                    [
                        121.45330622792,
                        0.50479057053314
                    ],
                    [
                        121.45330622792,
                        0.50479057053314
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 628,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0014182730494741015,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93952232756,
                        0.44903608223338
                    ],
                    [
                        121.93953573802,
                        0.44897573311847
                    ],
                    [
                        121.93964168704,
                        0.44855061434271
                    ],
                    [
                        121.93974092642,
                        0.44816705881049
                    ],
                    [
                        121.9397757973,
                        0.44803431039392
                    ],
                    [
                        121.93979457198,
                        0.44796457719996
                    ],
                    [
                        121.93990186328,
                        0.44767088627625
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 635,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.001995449072390159,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93801492428,
                        0.45441106415134
                    ],
                    [
                        121.93793044353,
                        0.45458674331441
                    ],
                    [
                        121.93787947395,
                        0.45467525342547
                    ],
                    [
                        121.937593505,
                        0.45522189633592
                    ],
                    [
                        121.93716080788,
                        0.45621301126772
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 657,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.006882846376961665,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.90778374672,
                        0.49687567412821
                    ],
                    [
                        121.90970152617,
                        0.49618369018749
                    ],
                    [
                        121.91070199013,
                        0.49577332758381
                    ],
                    [
                        121.91423644828,
                        0.49448280983766
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 659,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00592207667575507,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.91865859087,
                        0.49109967172378
                    ],
                    [
                        121.91930432925,
                        0.49040308386934
                    ],
                    [
                        121.91952981635,
                        0.49012870059846
                    ],
                    [
                        121.92016080022,
                        0.48939527026493
                    ],
                    [
                        121.92079105442,
                        0.48866284113108
                    ],
                    [
                        121.92099899054,
                        0.48840155692805
                    ],
                    [
                        121.9218718908,
                        0.48733745409202
                    ],
                    [
                        121.92244273653,
                        0.48654943278756
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 660,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.014260158958836214,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.922416188339,
                        0.486582217653718
                    ],
                    [
                        121.923385530739,
                        0.484899117291688
                    ],
                    [
                        121.923786284443,
                        0.484241191281497
                    ],
                    [
                        121.924546315334,
                        0.482856708039816
                    ],
                    [
                        121.924742343009,
                        0.482514332244278
                    ],
                    [
                        121.925260348496,
                        0.48156929503306
                    ],
                    [
                        121.925646021659,
                        0.481011311222904
                    ],
                    [
                        121.925862202692,
                        0.480768333569989
                    ],
                    [
                        121.926155189214,
                        0.480626817736052
                    ],
                    [
                        121.928198813573,
                        0.479824860060026
                    ],
                    [
                        121.930673392683,
                        0.478896565488259
                    ],
                    [
                        121.932077567445,
                        0.478390686375665
                    ],
                    [
                        121.932855198815,
                        0.478083298547702
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 661,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.007350997074985977,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93284210759,
                        0.47807581785
                    ],
                    [
                        121.93207102156,
                        0.47838507561786
                    ],
                    [
                        121.93154201548,
                        0.4785694949341
                    ],
                    [
                        121.93013520428,
                        0.47911005736462
                    ],
                    [
                        121.92902801929,
                        0.47952794272138
                    ],
                    [
                        121.92844472812,
                        0.47975807826741
                    ],
                    [
                        121.9274101183,
                        0.48013294356403
                    ],
                    [
                        121.92647031637,
                        0.48049483744227
                    ],
                    [
                        121.92611396313,
                        0.48065560535495
                    ],
                    [
                        121.92598387599,
                        0.48071729399125
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 668,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.009928570203629064,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94726816111,
                        0.47541071715446
                    ],
                    [
                        121.94707866307,
                        0.47345317234812
                    ],
                    [
                        121.94791354743,
                        0.47334950995334
                    ],
                    [
                        121.94791227407,
                        0.47330926862864
                    ],
                    [
                        121.94869667612,
                        0.47325294866091
                    ],
                    [
                        121.95064949284,
                        0.47324038623761
                    ],
                    [
                        121.95099145149,
                        0.47314034922332
                    ],
                    [
                        121.95110276661,
                        0.47077199513783
                    ],
                    [
                        121.95116349304,
                        0.46989228193621
                    ],
                    [
                        121.95189329533,
                        0.4698359464143
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 672,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0011850970320329136,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.946780542894,
                        0.469517720827247
                    ],
                    [
                        121.947686508489,
                        0.469417964843094
                    ],
                    [
                        121.947959967925,
                        0.469407596867738
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 674,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0015822158194063263,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95609024588,
                        0.47380363814587
                    ],
                    [
                        121.95652412635,
                        0.4741963747753
                    ],
                    [
                        121.95685642355,
                        0.47443206676979
                    ],
                    [
                        121.95673929148,
                        0.4745728905723
                    ],
                    [
                        121.95656901054,
                        0.47473498500996
                    ],
                    [
                        121.95646802112,
                        0.47487337791747
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 678,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00440932985598118,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95740116245,
                        0.47111418302368
                    ],
                    [
                        121.95753544718,
                        0.47058289997108
                    ],
                    [
                        121.95775795428,
                        0.46972038156273
                    ],
                    [
                        121.9578293547,
                        0.46903262985144
                    ],
                    [
                        121.95790772887,
                        0.46861684938932
                    ],
                    [
                        121.95814280208,
                        0.46775749523441
                    ],
                    [
                        121.95834800008,
                        0.4668949126462
                    ],
                    [
                        121.95842581094,
                        0.46688490504004
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 682,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0017519993980723353,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96254908567,
                        0.46606086566662
                    ],
                    [
                        121.96314851794,
                        0.46622943172102
                    ],
                    [
                        121.96346644759,
                        0.46631545974461
                    ],
                    [
                        121.96376006498,
                        0.46641083864033
                    ],
                    [
                        121.96423695945,
                        0.46652865962917
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 694,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.005681731149297919,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93715125322,
                        0.45601904679602
                    ],
                    [
                        121.93660676479,
                        0.45586887239224
                    ],
                    [
                        121.93612128496,
                        0.4557937818421
                    ],
                    [
                        121.93555667996,
                        0.45558053288693
                    ],
                    [
                        121.93557679653,
                        0.45547326130544
                    ],
                    [
                        121.93578870445,
                        0.45512814503756
                    ],
                    [
                        121.93583813314,
                        0.45486261936162
                    ],
                    [
                        121.93585231298,
                        0.45459364026178
                    ],
                    [
                        121.93580977777,
                        0.4542419052882
                    ],
                    [
                        121.93575038473,
                        0.45395951363855
                    ],
                    [
                        121.93579904869,
                        0.45364875874241
                    ],
                    [
                        121.93582969753,
                        0.45335946746165
                    ],
                    [
                        121.93589886276,
                        0.45289144716944
                    ],
                    [
                        121.93616153152,
                        0.45196621324494
                    ],
                    [
                        121.9361705169,
                        0.45168101231535
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 699,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.008949654118968708,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92772116962,
                        0.45826082119792
                    ],
                    [
                        121.9262981236,
                        0.4541218160804
                    ],
                    [
                        121.92620311961,
                        0.45383392556884
                    ],
                    [
                        121.92622747413,
                        0.45369339439421
                    ],
                    [
                        121.92651559712,
                        0.45360282406994
                    ],
                    [
                        121.92751592694,
                        0.45360235967021
                    ],
                    [
                        121.92789444026,
                        0.45361643639707
                    ],
                    [
                        121.92830660382,
                        0.45375779585844
                    ],
                    [
                        121.93008819091,
                        0.45328754844989
                    ],
                    [
                        121.93019942355,
                        0.45316218016066
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 700,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0031004018727522143,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93018914707,
                        0.45316942799085
                    ],
                    [
                        121.93007968959,
                        0.45196823543245
                    ],
                    [
                        121.9299507558,
                        0.45035068490154
                    ],
                    [
                        121.92992779599,
                        0.4500801057562
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 701,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016260847042012946,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92993074656,
                        0.45007809496856
                    ],
                    [
                        121.93066835354,
                        0.44942635175795
                    ],
                    [
                        121.93119363787,
                        0.44905760713179
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 702,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006055218253425327,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9311947644,
                        0.44905511343588
                    ],
                    [
                        121.93141669035,
                        0.44895696580435
                    ],
                    [
                        121.93184752017,
                        0.44884828955993
                    ],
                    [
                        121.93207326826,
                        0.4487979383364
                    ],
                    [
                        121.93217575668,
                        0.44877459798318
                    ],
                    [
                        121.93230452157,
                        0.4487289780358
                    ],
                    [
                        121.93236353881,
                        0.44870214277248
                    ],
                    [
                        121.93281688438,
                        0.44849550984214
                    ],
                    [
                        121.93292678935,
                        0.44836147487692
                    ],
                    [
                        121.93294958714,
                        0.44829855177257
                    ],
                    [
                        121.93255534681,
                        0.44769491630824
                    ],
                    [
                        121.9326210462,
                        0.4476305410394
                    ],
                    [
                        121.93288121497,
                        0.44743477907101
                    ],
                    [
                        121.93309847233,
                        0.44726448423303
                    ],
                    [
                        121.93359733983,
                        0.44687559347811
                    ],
                    [
                        121.93438187988,
                        0.44625199671458
                    ],
                    [
                        121.93526433666,
                        0.44569677307249
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 706,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001067174133381732,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.917853050682,
                        0.482439813066862
                    ],
                    [
                        121.917751276841,
                        0.482373457414184
                    ],
                    [
                        121.917555468314,
                        0.482238530015927
                    ],
                    [
                        121.917402946791,
                        0.482126442055655
                    ],
                    [
                        121.91697783005,
                        0.481829410984502
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 709,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.001872057909135989,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92946404219,
                        0.47301291545102
                    ],
                    [
                        121.92904004299,
                        0.47310746571583
                    ],
                    [
                        121.92832320874,
                        0.47333099423334
                    ],
                    [
                        121.92768790688,
                        0.47359184089213
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2123,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.002086683496629118,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93149983883,
                        0.47270178980108
                    ],
                    [
                        121.93068444729,
                        0.47284125992174
                    ],
                    [
                        121.92969202995,
                        0.47299145851009
                    ],
                    [
                        121.92969739437,
                        0.47299145851009
                    ],
                    [
                        121.92969739437,
                        0.47299145851009
                    ],
                    [
                        121.92944794893,
                        0.47301291545102
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 713,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.007165046888172636,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94068491782,
                        0.47672204533746
                    ],
                    [
                        121.9405619903,
                        0.47646978132802
                    ],
                    [
                        121.94109564278,
                        0.47620349296303
                    ],
                    [
                        121.94176613668,
                        0.47596248037534
                    ],
                    [
                        121.94389702678,
                        0.47555249161062
                    ],
                    [
                        121.94482468227,
                        0.47548734753959
                    ],
                    [
                        121.94549869902,
                        0.47562605818217
                    ],
                    [
                        121.94622574761,
                        0.47558312698899
                    ],
                    [
                        121.9472704631,
                        0.47540880548636
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 714,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0018989691911460663,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94748888912,
                        0.47863531970459
                    ],
                    [
                        121.9477057457,
                        0.47846297628999
                    ],
                    [
                        121.94784296755,
                        0.47834410398732
                    ],
                    [
                        121.94798295204,
                        0.47817998223407
                    ],
                    [
                        121.94820844525,
                        0.47801331436832
                    ],
                    [
                        121.94840593294,
                        0.47792035960085
                    ],
                    [
                        121.947967972,
                        0.47734129450967
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 717,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0037358156960611085,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938223768276,
                        0.475685501161912
                    ],
                    [
                        121.938655077251,
                        0.475548744656973
                    ],
                    [
                        121.938572789576,
                        0.47526821849309
                    ],
                    [
                        121.938901940275,
                        0.475170969422943
                    ],
                    [
                        121.938905647073,
                        0.47516862522501
                    ],
                    [
                        121.938812068709,
                        0.474571441088988
                    ],
                    [
                        121.938757182888,
                        0.474183958286741
                    ],
                    [
                        121.938714484123,
                        0.473974460492961
                    ],
                    [
                        121.938677242922,
                        0.473843746306405
                    ],
                    [
                        121.938612987174,
                        0.473615089452966
                    ],
                    [
                        121.938585182282,
                        0.47353879067317
                    ],
                    [
                        121.93843408349,
                        0.473270127101504
                    ],
                    [
                        121.938262946086,
                        0.472908789312981
                    ],
                    [
                        121.938188154786,
                        0.472798054762593
                    ],
                    [
                        121.938130916306,
                        0.472673087296722
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 718,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0036888718753276596,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94276198029,
                        0.474147984011982
                    ],
                    [
                        121.943494103422,
                        0.473836724483155
                    ],
                    [
                        121.943047937117,
                        0.472309248707958
                    ],
                    [
                        121.942840527616,
                        0.471675613420958
                    ],
                    [
                        121.942724576801,
                        0.471050975162711
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 719,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.003859990729799574,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93907049216,
                        0.47251934597525
                    ],
                    [
                        121.94104681292,
                        0.47181323892897
                    ],
                    [
                        121.94280685676,
                        0.47174627857052
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 722,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.001841215698404207,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942440310289,
                        0.469962533646844
                    ],
                    [
                        121.94242751897,
                        0.469814453915512
                    ],
                    [
                        121.942396571284,
                        0.469091028607589
                    ],
                    [
                        121.942373923952,
                        0.468655995479521
                    ],
                    [
                        121.942349950531,
                        0.468123659685068
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 724,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0009345448227303383,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942362934715,
                        0.468455794531469
                    ],
                    [
                        121.941438540264,
                        0.468593158735845
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 729,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.004409801315875256,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94797193851,
                        0.47735742310891
                    ],
                    [
                        121.94734765161,
                        0.47664948154139
                    ],
                    [
                        121.94722385507,
                        0.47651587295562
                    ],
                    [
                        121.94709464758,
                        0.47632294301425
                    ],
                    [
                        121.9471016519,
                        0.47612435855166
                    ],
                    [
                        121.94715989828,
                        0.47593199510525
                    ],
                    [
                        121.94729366455,
                        0.4757275920582
                    ],
                    [
                        121.94735095656,
                        0.47559904334535
                    ],
                    [
                        121.94736513653,
                        0.47532585880724
                    ],
                    [
                        121.94728178233,
                        0.47422619086631
                    ],
                    [
                        121.94716904633,
                        0.47334287392164
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 730,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0037581631558481427,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943461684441,
                        0.47367619346204
                    ],
                    [
                        121.94301563431,
                        0.472160189047471
                    ],
                    [
                        121.942859568798,
                        0.471674858889617
                    ],
                    [
                        121.942740337739,
                        0.471042096544119
                    ],
                    [
                        121.94260101631,
                        0.470027419585912
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 731,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002371784859988277,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942884982943,
                        0.47175452171444
                    ],
                    [
                        121.94364131961,
                        0.471751701155218
                    ],
                    [
                        121.944635439481,
                        0.471975796745283
                    ],
                    [
                        121.945231690209,
                        0.471963472049253
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 733,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.010337839260879061,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95351675376,
                        0.47826622594069
                    ],
                    [
                        121.95335850343,
                        0.47822484607325
                    ],
                    [
                        121.95314526558,
                        0.47818001309961
                    ],
                    [
                        121.95276355357,
                        0.47804610898772
                    ],
                    [
                        121.95261418819,
                        0.47800567558313
                    ],
                    [
                        121.9522695154,
                        0.47786870014898
                    ],
                    [
                        121.95164859295,
                        0.47763420255251
                    ],
                    [
                        121.95139712693,
                        0.4775828691055
                    ],
                    [
                        121.95095157167,
                        0.4776010619528
                    ],
                    [
                        121.95042129462,
                        0.47770930573303
                    ],
                    [
                        121.95004020409,
                        0.47780432638449
                    ],
                    [
                        121.94923594594,
                        0.47790912414393
                    ],
                    [
                        121.94878838361,
                        0.47796337361264
                    ],
                    [
                        121.94857518372,
                        0.4779745946592
                    ],
                    [
                        121.94847976639,
                        0.47798307524959
                    ],
                    [
                        121.94840409016,
                        0.47787061773889
                    ],
                    [
                        121.94803605294,
                        0.47741676375711
                    ],
                    [
                        121.94772788951,
                        0.47707617519738
                    ],
                    [
                        121.94724112896,
                        0.4764950937939
                    ],
                    [
                        121.94704611235,
                        0.47621135492904
                    ],
                    [
                        121.947059501,
                        0.47604677967368
                    ],
                    [
                        121.9473021023,
                        0.47560460046173
                    ],
                    [
                        121.947304979,
                        0.47540630348739
                    ],
                    [
                        121.94704561481,
                        0.47341768089868
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 736,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004658923766181206,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95512205362,
                        0.48261755184533
                    ],
                    [
                        121.95494502783,
                        0.48243382332434
                    ],
                    [
                        121.95482298732,
                        0.48225412317593
                    ],
                    [
                        121.95469290018,
                        0.48198993791643
                    ],
                    [
                        121.95426911116,
                        0.48049464797952
                    ],
                    [
                        121.95407733321,
                        0.47973026086764
                    ],
                    [
                        121.95393919945,
                        0.47919010847229
                    ],
                    [
                        121.9536870718,
                        0.47836643798257
                    ],
                    [
                        121.9536302652,
                        0.47830748570701
                    ],
                    [
                        121.95359005645,
                        0.47827943309062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 738,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0025278154241404035,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95433272346,
                        0.47680342441565
                    ],
                    [
                        121.95515412745,
                        0.47514636660362
                    ],
                    [
                        121.95547208194,
                        0.47454715435426
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 739,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.005863773668495234,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95367654859,
                        0.47813154441646
                    ],
                    [
                        121.95362465467,
                        0.47817937875883
                    ],
                    [
                        121.9535788354,
                        0.47820182085194
                    ],
                    [
                        121.95345293737,
                        0.47818901701898
                    ],
                    [
                        121.95312957466,
                        0.47810173219228
                    ],
                    [
                        121.95269441305,
                        0.47795517100685
                    ],
                    [
                        121.95238371276,
                        0.47784820017183
                    ],
                    [
                        121.95199644863,
                        0.47768966339188
                    ],
                    [
                        121.95170719921,
                        0.47758696726377
                    ],
                    [
                        121.95156903863,
                        0.47754152485444
                    ],
                    [
                        121.95132549392,
                        0.47751729802806
                    ],
                    [
                        121.95096806054,
                        0.47753822204505
                    ],
                    [
                        121.9503291563,
                        0.47766869042901
                    ],
                    [
                        121.9496265874,
                        0.47781141594672
                    ],
                    [
                        121.94917176937,
                        0.47785303332152
                    ],
                    [
                        121.94876954557,
                        0.47790547421665
                    ],
                    [
                        121.94854413941,
                        0.4779150553742
                    ],
                    [
                        121.94818928761,
                        0.47747884220877
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 743,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.01067967366335416,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94749202053,
                        0.45866970364811
                    ],
                    [
                        121.94656640357,
                        0.45862676453538
                    ],
                    [
                        121.94579127209,
                        0.4584990456653
                    ],
                    [
                        121.94551912851,
                        0.4584549182238
                    ],
                    [
                        121.94500486672,
                        0.45834459677956
                    ],
                    [
                        121.94393766442,
                        0.45809759956011
                    ],
                    [
                        121.94316817226,
                        0.45792045174889
                    ],
                    [
                        121.94282067869,
                        0.45784558680096
                    ],
                    [
                        121.94232007788,
                        0.4577669535206
                    ],
                    [
                        121.94134353203,
                        0.45762717294831
                    ],
                    [
                        121.94107398391,
                        0.45755719948587
                    ],
                    [
                        121.94071725031,
                        0.45743650519311
                    ],
                    [
                        121.94035365033,
                        0.45729717270303
                    ],
                    [
                        121.94003186435,
                        0.45717291013116
                    ],
                    [
                        121.93957470304,
                        0.45700327284091
                    ],
                    [
                        121.93883836053,
                        0.45681290258837
                    ],
                    [
                        121.93831262537,
                        0.45669489757635
                    ],
                    [
                        121.93811148405,
                        0.45664661006953
                    ],
                    [
                        121.93774402161,
                        0.45656882889984
                    ],
                    [
                        121.93752008977,
                        0.45651114341538
                    ],
                    [
                        121.93710296914,
                        0.45636500097924
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 744,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002321462104918727,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94940086801,
                        0.45641596302071
                    ],
                    [
                        121.94949198956,
                        0.45551209595632
                    ],
                    [
                        121.95052914617,
                        0.45566089559093
                    ],
                    [
                        121.95089414121,
                        0.45564759668318
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 746,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.005165781680088837,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94793389376,
                        0.46244402301407
                    ],
                    [
                        121.94893672811,
                        0.46245226010214
                    ],
                    [
                        121.94894365574,
                        0.46249467487893
                    ],
                    [
                        121.94893336857,
                        0.46244871292208
                    ],
                    [
                        121.94949535187,
                        0.4624251086643
                    ],
                    [
                        121.94952807562,
                        0.46238725118416
                    ],
                    [
                        121.94951999183,
                        0.46228540863067
                    ],
                    [
                        121.94952224491,
                        0.46215023355653
                    ],
                    [
                        121.94953737258,
                        0.46061611545402
                    ],
                    [
                        121.9495408058,
                        0.45983201510893
                    ],
                    [
                        121.94955067632,
                        0.45938447406412
                    ],
                    [
                        121.94954230778,
                        0.45917893712669
                    ],
                    [
                        121.949536407,
                        0.45892770231969
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 747,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.007330768027186102,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94735138833,
                        0.46252297978066
                    ],
                    [
                        121.94843145632,
                        0.46250982649265
                    ],
                    [
                        121.94950510969,
                        0.4624782152662
                    ],
                    [
                        121.94961549305,
                        0.46245877513543
                    ],
                    [
                        121.94962085079,
                        0.46242390710166
                    ],
                    [
                        121.94962177257,
                        0.46236703926937
                    ],
                    [
                        121.949623522,
                        0.46213828194495
                    ],
                    [
                        121.94961815562,
                        0.46076500878252
                    ],
                    [
                        121.94962485879,
                        0.45978872434565
                    ],
                    [
                        121.94964363543,
                        0.45894787794046
                    ],
                    [
                        121.9496664346,
                        0.45889424181309
                    ],
                    [
                        121.94971703773,
                        0.45890078522196
                    ],
                    [
                        121.94979518848,
                        0.45890227144703
                    ],
                    [
                        121.94990112985,
                        0.45891299812978
                    ],
                    [
                        121.95065081709,
                        0.45899078738483
                    ],
                    [
                        121.95113897324,
                        0.45912086718065
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 752,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0014264787240141179,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.947202766256,
                        0.464032582540917
                    ],
                    [
                        121.947295232115,
                        0.464037856277983
                    ],
                    [
                        121.947506345663,
                        0.464054918331558
                    ],
                    [
                        121.947727676682,
                        0.464051754468333
                    ],
                    [
                        121.948151144465,
                        0.464087395110101
                    ],
                    [
                        121.948626171644,
                        0.464113466728023
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 754,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002249434743672187,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94727965003,
                        0.46421014155952
                    ],
                    [
                        121.94725561739,
                        0.46482971877047
                    ],
                    [
                        121.94716839191,
                        0.46595137960609
                    ],
                    [
                        121.94714248178,
                        0.46629120968491
                    ],
                    [
                        121.94711387618,
                        0.46645221624945
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 755,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0024721290469187336,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94707715467,
                        0.46527540683594
                    ],
                    [
                        121.94661335841,
                        0.46526580567124
                    ],
                    [
                        121.94606803014,
                        0.46525470333489
                    ],
                    [
                        121.94541385235,
                        0.46520028617082
                    ],
                    [
                        121.94483048299,
                        0.46520556751126
                    ],
                    [
                        121.94460779428,
                        0.46519453823295
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 757,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002041722617727298,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94352551853,
                        0.46619496914891
                    ],
                    [
                        121.94372167432,
                        0.46475515417314
                    ],
                    [
                        121.94374317401,
                        0.46465425198196
                    ],
                    [
                        121.94379664993,
                        0.46417176644916
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 768,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0013194698814991757,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.939455672497,
                        0.449471780797229
                    ],
                    [
                        121.939029316476,
                        0.449381411393911
                    ],
                    [
                        121.938520019505,
                        0.449248150398193
                    ],
                    [
                        121.938315420536,
                        0.449204906512282
                    ],
                    [
                        121.938251416098,
                        0.44915825345493
                    ],
                    [
                        121.938214507996,
                        0.449100099492594
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 771,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0014888671285547734,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93700333388,
                        0.46078321547049
                    ],
                    [
                        121.93692976535,
                        0.4601735932848
                    ],
                    [
                        121.93693014975,
                        0.45977186324523
                    ],
                    [
                        121.9369368575,
                        0.4594791283015
                    ],
                    [
                        121.93693800643,
                        0.45929885206676
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 774,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016570730747040008,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93335865366,
                        0.4652902862164
                    ],
                    [
                        121.9330981233,
                        0.46543862938195
                    ],
                    [
                        121.93290996891,
                        0.46500943002706
                    ],
                    [
                        121.9331313651,
                        0.46485370862584
                    ],
                    [
                        121.93302264801,
                        0.46424538273024
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2070,
                "jenis_pipa": "Pipa 200",
                "keterangan": "Distribus",
                "panjang": 0.0011441637581920273,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9481188256,
                        0.5149426751224
                    ],
                    [
                        121.9485158193,
                        0.51524826987311
                    ],
                    [
                        121.94857214949,
                        0.51522950528357
                    ],
                    [
                        121.94870626898,
                        0.51513568233508
                    ],
                    [
                        121.94890744822,
                        0.51505258200812
                    ],
                    [
                        121.94908540695,
                        0.51495605125682
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 778,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0002009116385938808,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.930241228179,
                        0.464535082810449
                    ],
                    [
                        121.930185309523,
                        0.464466127078839
                    ],
                    [
                        121.930107610655,
                        0.464385278357034
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 779,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0067975550183839335,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93018741465,
                        0.46450643892965
                    ],
                    [
                        121.93006960836,
                        0.46435878044696
                    ],
                    [
                        121.92998515421,
                        0.46429162502472
                    ],
                    [
                        121.92987158834,
                        0.46420565791143
                    ],
                    [
                        121.92976076448,
                        0.46410444281824
                    ],
                    [
                        121.92961205597,
                        0.46395344962339
                    ],
                    [
                        121.92952882834,
                        0.46382648911444
                    ],
                    [
                        121.92948400854,
                        0.46367895304854
                    ],
                    [
                        121.92944263859,
                        0.46355635860621
                    ],
                    [
                        121.9294078525,
                        0.46346375989582
                    ],
                    [
                        121.92934409328,
                        0.46326165517298
                    ],
                    [
                        121.92917807868,
                        0.46274195731424
                    ],
                    [
                        121.9290168761,
                        0.46229684572227
                    ],
                    [
                        121.92881886247,
                        0.46165823528664
                    ],
                    [
                        121.92864494913,
                        0.46098270026134
                    ],
                    [
                        121.92854916762,
                        0.46067840216148
                    ],
                    [
                        121.92847857196,
                        0.46044486010472
                    ],
                    [
                        121.928365785,
                        0.46012580132705
                    ],
                    [
                        121.92792566118,
                        0.45887471646914
                    ],
                    [
                        121.92773061095,
                        0.45826800429987
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 783,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0011804546068570113,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94412896065,
                        0.44880406604486
                    ],
                    [
                        121.94383378253,
                        0.44883454363519
                    ],
                    [
                        121.94295017144,
                        0.44882150872492
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 789,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0012899924308496452,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93426250896,
                        0.46726379397849
                    ],
                    [
                        121.93478286168,
                        0.46734828075233
                    ],
                    [
                        121.9350484016,
                        0.46736303241114
                    ],
                    [
                        121.93554455332,
                        0.46738985360891
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 790,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002812345715116526,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931344563408,
                        0.467948890357916
                    ],
                    [
                        121.931349522976,
                        0.467876108854531
                    ],
                    [
                        121.931376699889,
                        0.467839062844357
                    ],
                    [
                        121.931398165381,
                        0.467802925138245
                    ],
                    [
                        121.931416836286,
                        0.467766542937471
                    ],
                    [
                        121.931413355601,
                        0.467665510245158
                    ],
                    [
                        121.931620036417,
                        0.467620584981796
                    ],
                    [
                        121.931904851287,
                        0.467560003613662
                    ],
                    [
                        121.932195867494,
                        0.467502025627047
                    ],
                    [
                        121.932675871524,
                        0.46741414708514
                    ],
                    [
                        121.932982661632,
                        0.467346755744507
                    ],
                    [
                        121.933214045491,
                        0.46730388113139
                    ],
                    [
                        121.93342854767,
                        0.467283197212583
                    ],
                    [
                        121.933885549384,
                        0.467273900079285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 796,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.0210196735074657,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95196364519,
                        0.52611362896401
                    ],
                    [
                        121.95262947236,
                        0.5249226980124
                    ],
                    [
                        121.95293563982,
                        0.52415044704854
                    ],
                    [
                        121.95308916268,
                        0.5239172101636
                    ],
                    [
                        121.95321923419,
                        0.523714705545
                    ],
                    [
                        121.95327826959,
                        0.52304784936636
                    ],
                    [
                        121.95353938934,
                        0.52277501712068
                    ],
                    [
                        121.95379838347,
                        0.52242002198615
                    ],
                    [
                        121.95438876902,
                        0.52192232196578
                    ],
                    [
                        121.95446491241,
                        0.52183398365064
                    ],
                    [
                        121.95480344745,
                        0.52155409508041
                    ],
                    [
                        121.95476970974,
                        0.52146918936556
                    ],
                    [
                        121.95375448015,
                        0.52099354430893
                    ],
                    [
                        121.9532820493,
                        0.52075138543869
                    ],
                    [
                        121.95285113902,
                        0.52051957043659
                    ],
                    [
                        121.9525508009,
                        0.52038258353175
                    ],
                    [
                        121.95192856772,
                        0.52016207148271
                    ],
                    [
                        121.95166274377,
                        0.51991303837901
                    ],
                    [
                        121.95146106183,
                        0.51975823189236
                    ],
                    [
                        121.95052201152,
                        0.51911837648234
                    ],
                    [
                        121.95028715507,
                        0.51885245094154
                    ],
                    [
                        121.9500455909,
                        0.51854649167346
                    ],
                    [
                        121.94938706389,
                        0.51770472498052
                    ],
                    [
                        121.94927345663,
                        0.51740510947618
                    ],
                    [
                        121.94918581556,
                        0.51713649932831
                    ],
                    [
                        121.94907099009,
                        0.5165343514765
                    ],
                    [
                        121.94903057591,
                        0.51563200370688
                    ],
                    [
                        121.94902680747,
                        0.51493318796556
                    ],
                    [
                        121.9489951194,
                        0.51451933172151
                    ],
                    [
                        121.94881083369,
                        0.51419938143656
                    ],
                    [
                        121.94867881981,
                        0.51400895620068
                    ],
                    [
                        121.94857631694,
                        0.51389688266243
                    ],
                    [
                        121.94823835641,
                        0.51356028385125
                    ],
                    [
                        121.9478327796,
                        0.51319589918853
                    ],
                    [
                        121.94725110903,
                        0.51265641785858
                    ],
                    [
                        121.94695012495,
                        0.51238073799369
                    ],
                    [
                        121.94663850296,
                        0.51211802985573
                    ],
                    [
                        121.94601627135,
                        0.51156528603708
                    ],
                    [
                        121.94506822906,
                        0.51075153967017
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 807,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0038505093659360577,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932911304048,
                        0.478155534034905
                    ],
                    [
                        121.932251789884,
                        0.478399265336544
                    ],
                    [
                        121.931294632334,
                        0.478754532154868
                    ],
                    [
                        121.930140871327,
                        0.479179556228141
                    ],
                    [
                        121.929301450828,
                        0.479495414159362
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 808,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.006683013317358581,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92584386233,
                        0.48088594062777
                    ],
                    [
                        121.92568208203,
                        0.48108680161077
                    ],
                    [
                        121.92545644788,
                        0.48138634053355
                    ],
                    [
                        121.92534635965,
                        0.48155264548102
                    ],
                    [
                        121.92514587073,
                        0.48190256809186
                    ],
                    [
                        121.92441233312,
                        0.48322129165458
                    ],
                    [
                        121.92390873094,
                        0.48414301173525
                    ],
                    [
                        121.92319437861,
                        0.48537612547455
                    ],
                    [
                        121.92283630371,
                        0.48602787884658
                    ],
                    [
                        121.92245543003,
                        0.48663806610977
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 809,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.027232069191684496,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92245811224,
                        0.48663806759734
                    ],
                    [
                        121.9219712913,
                        0.48733943620059
                    ],
                    [
                        121.92047193646,
                        0.48916497538935
                    ],
                    [
                        121.91952779889,
                        0.49025755779405
                    ],
                    [
                        121.91878885031,
                        0.49109842403021
                    ],
                    [
                        121.91794931889,
                        0.49189390106176
                    ],
                    [
                        121.91728278995,
                        0.49241802077269
                    ],
                    [
                        121.91643387079,
                        0.4931207216441
                    ],
                    [
                        121.9157525897,
                        0.49367055410488
                    ],
                    [
                        121.91526710987,
                        0.49403667170455
                    ],
                    [
                        121.91470518708,
                        0.49439607582943
                    ],
                    [
                        121.91392198205,
                        0.49470050488151
                    ],
                    [
                        121.91168099642,
                        0.49551584515282
                    ],
                    [
                        121.90997108817,
                        0.49619309616179
                    ],
                    [
                        121.9073304534,
                        0.49717475372603
                    ],
                    [
                        121.90433710814,
                        0.4982851374338
                    ],
                    [
                        121.9019177556,
                        0.49920910781203
                    ],
                    [
                        121.899535954,
                        0.50006738206237
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 810,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0004811511235705909,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.925156413336,
                        0.481759278046164
                    ],
                    [
                        121.924969267329,
                        0.481643639009453
                    ],
                    [
                        121.924817383752,
                        0.481543230214011
                    ],
                    [
                        121.924746435171,
                        0.481578174372027
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 812,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0048989165327971256,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93577225146,
                        0.48536626101321
                    ],
                    [
                        121.93582807485,
                        0.48497963851903
                    ],
                    [
                        121.93585578291,
                        0.48472121426007
                    ],
                    [
                        121.93585656083,
                        0.48444645049588
                    ],
                    [
                        121.93585150844,
                        0.48386635006291
                    ],
                    [
                        121.93579142689,
                        0.48314262601405
                    ],
                    [
                        121.93573011164,
                        0.4823109954902
                    ],
                    [
                        121.93568880548,
                        0.48190973954731
                    ],
                    [
                        121.93558752537,
                        0.48175111754241
                    ],
                    [
                        121.93490887277,
                        0.48071114776882
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 814,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.005924843373377457,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93496363508,
                        0.48766257571986
                    ],
                    [
                        121.93553565567,
                        0.48628114250373
                    ],
                    [
                        121.93579095398,
                        0.48538285950505
                    ],
                    [
                        121.93586998,
                        0.48478278471674
                    ],
                    [
                        121.93587922899,
                        0.48459636085654
                    ],
                    [
                        121.93587945697,
                        0.48407632596233
                    ],
                    [
                        121.93570768829,
                        0.48189923036388
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 823,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005674400144252701,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93790139696,
                        0.483442283365081
                    ],
                    [
                        121.937761133878,
                        0.48289245208387
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 824,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.012889862015492658,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9327265451,
                        0.47778191915413
                    ],
                    [
                        121.93284250076,
                        0.47807741906504
                    ],
                    [
                        121.93402739325,
                        0.47965560903799
                    ],
                    [
                        121.93426367824,
                        0.4799813824545
                    ],
                    [
                        121.93528364796,
                        0.48149764350862
                    ],
                    [
                        121.93557166687,
                        0.4819764281744
                    ],
                    [
                        121.93568762253,
                        0.48355866187461
                    ],
                    [
                        121.93571890341,
                        0.48410432511184
                    ],
                    [
                        121.93598353309,
                        0.48408281810595
                    ],
                    [
                        121.93650531175,
                        0.48403793391973
                    ],
                    [
                        121.93687186594,
                        0.48397995851252
                    ],
                    [
                        121.93749368484,
                        0.48390328075666
                    ],
                    [
                        121.93737925976,
                        0.48355032273677
                    ],
                    [
                        121.93734203968,
                        0.48331122840041
                    ],
                    [
                        121.93731042184,
                        0.483002792375
                    ],
                    [
                        121.93774430231,
                        0.48290086786879
                    ],
                    [
                        121.93898235778,
                        0.48246044179149
                    ],
                    [
                        121.93965936092,
                        0.48211632969713
                    ],
                    [
                        121.93999615608,
                        0.4818205823821
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 826,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.013774039578226472,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93569221198,
                        0.50062096085142
                    ],
                    [
                        121.93555573069,
                        0.50044918205049
                    ],
                    [
                        121.93533740118,
                        0.50008555098089
                    ],
                    [
                        121.93518256545,
                        0.49982483977576
                    ],
                    [
                        121.93491412999,
                        0.4993567991099
                    ],
                    [
                        121.93480421306,
                        0.49917020410845
                    ],
                    [
                        121.93465655746,
                        0.49890528948072
                    ],
                    [
                        121.93441866463,
                        0.49846025154853
                    ],
                    [
                        121.93426155362,
                        0.4981509831925
                    ],
                    [
                        121.93412545326,
                        0.49783365131298
                    ],
                    [
                        121.93388192457,
                        0.49731570479988
                    ],
                    [
                        121.93381085794,
                        0.49690333133898
                    ],
                    [
                        121.93379683164,
                        0.49676587351867
                    ],
                    [
                        121.93370198609,
                        0.49589475434412
                    ],
                    [
                        121.93365990226,
                        0.49548589940364
                    ],
                    [
                        121.93363804225,
                        0.49517728157221
                    ],
                    [
                        121.93360698221,
                        0.49477339144849
                    ],
                    [
                        121.93355664263,
                        0.49418380361858
                    ],
                    [
                        121.93353500722,
                        0.4937558277802
                    ],
                    [
                        121.93341818628,
                        0.49218075303932
                    ],
                    [
                        121.93341625114,
                        0.49159110088224
                    ],
                    [
                        121.93342227906,
                        0.49149203962531
                    ],
                    [
                        121.93342227906,
                        0.49142471053168
                    ],
                    [
                        121.93347277588,
                        0.49117129130429
                    ],
                    [
                        121.93369159544,
                        0.49051763802033
                    ],
                    [
                        121.93395997669,
                        0.48979385026385
                    ],
                    [
                        121.93412829942,
                        0.48937491368129
                    ],
                    [
                        121.93427417912,
                        0.4891317808432
                    ],
                    [
                        121.9344013563,
                        0.48882318916408
                    ],
                    [
                        121.93482403339,
                        0.48803955332437
                    ],
                    [
                        121.93497178334,
                        0.48766176229903
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 827,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006845613813579801,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933277858235,
                        0.491345172945273
                    ],
                    [
                        121.932817525284,
                        0.491255912732341
                    ],
                    [
                        121.932604595442,
                        0.491221741433164
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 828,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0020579185554812874,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932512766687,
                        0.48900249703115
                    ],
                    [
                        121.932520086311,
                        0.48893264012961
                    ],
                    [
                        121.932540213773,
                        0.488869449822739
                    ],
                    [
                        121.932639587316,
                        0.488683203502957
                    ],
                    [
                        121.933120763583,
                        0.487857297640994
                    ],
                    [
                        121.93355464405,
                        0.487240140080451
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 832,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004177513539220366,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937763467719,
                        0.497350519899205
                    ],
                    [
                        121.937247991984,
                        0.497004979206133
                    ],
                    [
                        121.937133719946,
                        0.496920492568445
                    ],
                    [
                        121.937080847025,
                        0.496917286504828
                    ],
                    [
                        121.936443659879,
                        0.496881007267697
                    ],
                    [
                        121.935919097729,
                        0.496907185717368
                    ],
                    [
                        121.935513511239,
                        0.496972875581506
                    ],
                    [
                        121.935309395229,
                        0.497112840733797
                    ],
                    [
                        121.93517575545,
                        0.497247706845198
                    ],
                    [
                        121.935108612086,
                        0.497422807264609
                    ],
                    [
                        121.935089894952,
                        0.497562383383399
                    ],
                    [
                        121.935029456775,
                        0.497635171546551
                    ],
                    [
                        121.934745260859,
                        0.497800836904112
                    ],
                    [
                        121.934414968226,
                        0.497956056392778
                    ],
                    [
                        121.934200187771,
                        0.498047202720424
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 833,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0024416676364796075,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935566736811,
                        0.496962545701306
                    ],
                    [
                        121.935578132749,
                        0.496851436557965
                    ],
                    [
                        121.935620251231,
                        0.496756921987496
                    ],
                    [
                        121.935625155318,
                        0.496702665465012
                    ],
                    [
                        121.935580603355,
                        0.496659107462509
                    ],
                    [
                        121.935402566825,
                        0.496590418210902
                    ],
                    [
                        121.935159971385,
                        0.496501635677785
                    ],
                    [
                        121.935104715576,
                        0.496467623299578
                    ],
                    [
                        121.9350785638,
                        0.496438818735781
                    ],
                    [
                        121.935084144045,
                        0.496400190447943
                    ],
                    [
                        121.935121665184,
                        0.496364546762465
                    ],
                    [
                        121.935540941929,
                        0.495889274643001
                    ],
                    [
                        121.935684772721,
                        0.495821435433633
                    ],
                    [
                        121.935512716674,
                        0.495170614733425
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 834,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003819535063973321,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935494736355,
                        0.500497324300231
                    ],
                    [
                        121.934894697387,
                        0.500903730449221
                    ],
                    [
                        121.934032717726,
                        0.501495241759925
                    ],
                    [
                        121.932363342941,
                        0.502684040489426
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 839,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001991994260989709,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951976797232,
                        0.514154755330603
                    ],
                    [
                        121.952193737466,
                        0.514111741318807
                    ],
                    [
                        121.952358312815,
                        0.514057506260457
                    ],
                    [
                        121.952584603921,
                        0.51407433783029
                    ],
                    [
                        121.952722308247,
                        0.513989152590461
                    ],
                    [
                        121.953350013821,
                        0.513828233666605
                    ],
                    [
                        121.953616940204,
                        0.513814383585092
                    ],
                    [
                        121.953904947065,
                        0.513758278352315
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 845,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00015948103627228062,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924459050729,
                        0.525600690360645
                    ],
                    [
                        121.92435806131,
                        0.525477258848537
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 851,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0025132277744908983,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95498590788,
                        0.52157139956007
                    ],
                    [
                        121.95531685579,
                        0.52163432761885
                    ],
                    [
                        121.95568926042,
                        0.52169971243642
                    ],
                    [
                        121.9559261732,
                        0.52171094806238
                    ],
                    [
                        121.95630064051,
                        0.52133575758241
                    ],
                    [
                        121.95641037649,
                        0.5214262156853
                    ],
                    [
                        121.95660734911,
                        0.5215377364204
                    ],
                    [
                        121.95713660847,
                        0.52193608357312
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 859,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0022989667150944285,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94239228964,
                        0.46898705575133
                    ],
                    [
                        121.94195374846,
                        0.46903399283651
                    ],
                    [
                        121.94193765521,
                        0.46924453918606
                    ],
                    [
                        121.94192692637,
                        0.4694363106964
                    ],
                    [
                        121.94163188338,
                        0.46944167493438
                    ],
                    [
                        121.9415473938,
                        0.46935718818577
                    ],
                    [
                        121.94151252508,
                        0.46934645970968
                    ],
                    [
                        121.94125905633,
                        0.46935316500724
                    ],
                    [
                        121.94123089314,
                        0.46926599613852
                    ],
                    [
                        121.94117456675,
                        0.46918016832827
                    ],
                    [
                        121.94062698327,
                        0.4692754306225
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 863,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0011678784424510435,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94029066692,
                        0.46877433055897
                    ],
                    [
                        121.94042623043,
                        0.46926197295995
                    ],
                    [
                        121.93978786469,
                        0.4694363106964
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 864,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0006486108871202597,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94035381079,
                        0.46900180740671
                    ],
                    [
                        121.93972617388,
                        0.46916541667326
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 865,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0024296826317232742,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94031522406,
                        0.46875113523532
                    ],
                    [
                        121.94027836871,
                        0.46859303205898
                    ],
                    [
                        121.94020360708,
                        0.46814889346336
                    ],
                    [
                        121.94011509418,
                        0.46773584705097
                    ],
                    [
                        121.93985626101,
                        0.46780424110145
                    ],
                    [
                        121.93947941065,
                        0.46791420800477
                    ],
                    [
                        121.93893894553,
                        0.46807915835648
                    ],
                    [
                        121.93878605962,
                        0.46815157558283
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 866,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00042293864073959564,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.939004605621,
                        0.468555511632635
                    ],
                    [
                        121.938922617562,
                        0.468382195947293
                    ],
                    [
                        121.93880485854,
                        0.468183222889848
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 874,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0042824668319920225,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.916790431179,
                        0.481704115537695
                    ],
                    [
                        121.913913456954,
                        0.479582128485242
                    ],
                    [
                        121.913913962529,
                        0.479577239170295
                    ],
                    [
                        121.913349255422,
                        0.479159094879717
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 875,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.003638161172193331,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.916820318219,
                        0.481667125510542
                    ],
                    [
                        121.913894587002,
                        0.479504646941681
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 884,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distrbusi",
                "panjang": 0.00010915161146644258,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94805845643,
                        0.45151973319104
                    ],
                    [
                        121.94794983335,
                        0.45150900468812
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 887,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0015703316088921961,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94497282952,
                        0.4610516597911
                    ],
                    [
                        121.94503768529,
                        0.45948266804766
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 889,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0018321132405918674,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.917846851675,
                        0.482451746154596
                    ],
                    [
                        121.918295450286,
                        0.48277661579813
                    ],
                    [
                        121.918680214722,
                        0.483052058056159
                    ],
                    [
                        121.91871647316,
                        0.483080318338262
                    ],
                    [
                        121.918313168148,
                        0.483723384004913
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 890,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007806536752240242,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.913890182941,
                        0.479512886746775
                    ],
                    [
                        121.914110252683,
                        0.478763894444213
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 906,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0010293458739997724,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938131503755,
                        0.472676595259719
                    ],
                    [
                        121.938116000549,
                        0.47255835127535
                    ],
                    [
                        121.938117867,
                        0.472442724195122
                    ],
                    [
                        121.9381292189,
                        0.472345158152785
                    ],
                    [
                        121.938142098913,
                        0.472274517587954
                    ],
                    [
                        121.938149206347,
                        0.472261361091882
                    ],
                    [
                        121.938133704185,
                        0.472226627463911
                    ],
                    [
                        121.938088745939,
                        0.472143638064139
                    ],
                    [
                        121.938069987055,
                        0.472118426880529
                    ],
                    [
                        121.937683904132,
                        0.472340950291333
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 907,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0021161785955916734,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938237957886,
                        0.470831575934441
                    ],
                    [
                        121.937660250322,
                        0.471144041203084
                    ],
                    [
                        121.937590196249,
                        0.471179465551318
                    ],
                    [
                        121.937578639376,
                        0.471169702783432
                    ],
                    [
                        121.937448450199,
                        0.470923857700197
                    ],
                    [
                        121.937388811751,
                        0.47083015262039
                    ],
                    [
                        121.936965853705,
                        0.471029690677896
                    ],
                    [
                        121.937077588405,
                        0.471361895596304
                    ],
                    [
                        121.937110163956,
                        0.471449713110881
                    ],
                    [
                        121.937048491005,
                        0.471469173017755
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 914,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0011488955301969697,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94358604638,
                        0.46767071341885
                    ],
                    [
                        121.94467793574,
                        0.46731330809596
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 916,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.006045117865350129,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94708576866,
                        0.46656989117671
                    ],
                    [
                        121.94728375163,
                        0.46657446311876
                    ],
                    [
                        121.94740315912,
                        0.46652199823979
                    ],
                    [
                        121.94759309292,
                        0.46657180703083
                    ],
                    [
                        121.94801822108,
                        0.46661069777194
                    ],
                    [
                        121.94839507071,
                        0.46666165805307
                    ],
                    [
                        121.94913670298,
                        0.46678101239428
                    ],
                    [
                        121.94972544909,
                        0.46689500249354
                    ],
                    [
                        121.9503879525,
                        0.46700094623119
                    ],
                    [
                        121.95134416223,
                        0.46716589660436
                    ],
                    [
                        121.95304739023,
                        0.46741265162693
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 920,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001093991326354725,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93797801733,
                        0.4454656844961
                    ],
                    [
                        121.9380521536,
                        0.44543457279763
                    ],
                    [
                        121.93814758659,
                        0.44543210448402
                    ],
                    [
                        121.93838201159,
                        0.44543231581334
                    ],
                    [
                        121.93854117391,
                        0.44551895540571
                    ],
                    [
                        121.93858618141,
                        0.44545773764629
                    ],
                    [
                        121.93863950372,
                        0.44539539508079
                    ],
                    [
                        121.93865119816,
                        0.44529729577411
                    ],
                    [
                        121.93865897656,
                        0.44523953069233
                    ],
                    [
                        121.9386987805,
                        0.44521711158539
                    ],
                    [
                        121.93875285386,
                        0.44522580173378
                    ],
                    [
                        121.93883728981,
                        0.44524650560159
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 922,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0010605054132103633,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93770915211,
                        0.44784119766835
                    ],
                    [
                        121.93769306082,
                        0.44778756271769
                    ],
                    [
                        121.93776071023,
                        0.44758511730935
                    ],
                    [
                        121.93783119085,
                        0.44737450627621
                    ],
                    [
                        121.93795154289,
                        0.44711585151566
                    ],
                    [
                        121.93810175463,
                        0.44687519993286
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 923,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00018287393851057035,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9379129998,
                        0.44718272419407
                    ],
                    [
                        121.93774132625,
                        0.44711970777068
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 930,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.004982307796226526,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93907574526,
                        0.45160958983
                    ],
                    [
                        121.93908915159,
                        0.45152912651096
                    ],
                    [
                        121.93911865206,
                        0.45130650419241
                    ],
                    [
                        121.93916023052,
                        0.45107852123366
                    ],
                    [
                        121.93920180005,
                        0.45086663554657
                    ],
                    [
                        121.93926617798,
                        0.45050186640548
                    ],
                    [
                        121.93930908645,
                        0.45024438410408
                    ],
                    [
                        121.93936184619,
                        0.44999668984455
                    ],
                    [
                        121.93943920573,
                        0.4495676877021
                    ],
                    [
                        121.93952756298,
                        0.44906822959057
                    ],
                    [
                        121.93961779289,
                        0.44867782954836
                    ],
                    [
                        121.93969939723,
                        0.44836268744998
                    ],
                    [
                        121.93975808377,
                        0.44813827320627
                    ],
                    [
                        121.93978369908,
                        0.44801689486029
                    ],
                    [
                        121.93984648797,
                        0.44784638959633
                    ],
                    [
                        121.93990976585,
                        0.44767029515882
                    ],
                    [
                        121.94006413123,
                        0.44734634562693
                    ],
                    [
                        121.94018483457,
                        0.44713445335287
                    ],
                    [
                        121.94038255057,
                        0.44684940377987
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 931,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.008824207858504003,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94736376601,
                        0.46051557728561
                    ],
                    [
                        121.94755241563,
                        0.45774994918866
                    ],
                    [
                        121.94766309756,
                        0.45626224912224
                    ],
                    [
                        121.94762797219,
                        0.45621881594537
                    ],
                    [
                        121.94767490545,
                        0.45567300369332
                    ],
                    [
                        121.94769904361,
                        0.45538065215065
                    ],
                    [
                        121.94787070548,
                        0.45301770025651
                    ],
                    [
                        121.94792971825,
                        0.45172491580645
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 934,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0010256433792307407,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942832579374,
                        0.484402617932733
                    ],
                    [
                        121.942638081234,
                        0.484447502118954
                    ],
                    [
                        121.942495947978,
                        0.484477424909768
                    ],
                    [
                        121.942638081234,
                        0.485143207005385
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 936,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009053266955141051,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942570754955,
                        0.483231888742127
                    ],
                    [
                        121.942828839026,
                        0.484099649675739
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 939,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006414986886292893,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948042596612,
                        0.467408166275051
                    ],
                    [
                        121.94809119639,
                        0.466768511189015
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 941,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006512941811173449,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948904349266,
                        0.467557415098332
                    ],
                    [
                        121.948959742248,
                        0.466908480796647
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 951,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0010177981944009293,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.930624265753,
                        0.470457385010412
                    ],
                    [
                        121.930214120498,
                        0.470393490714421
                    ],
                    [
                        121.930042339134,
                        0.470347278965906
                    ],
                    [
                        121.929969371661,
                        0.47033403547302
                    ],
                    [
                        121.929999933493,
                        0.469984712126599
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 952,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0004868212482341728,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93049133659,
                        0.47043942312621
                    ],
                    [
                        121.93049536947,
                        0.46995261858267
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 966,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0023808632059877767,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.946687612584,
                        0.469522966370713
                    ],
                    [
                        121.946711034667,
                        0.469520791571515
                    ],
                    [
                        121.946710397144,
                        0.469520031801157
                    ],
                    [
                        121.946756672864,
                        0.468359794163857
                    ],
                    [
                        121.946840168026,
                        0.467790229280974
                    ],
                    [
                        121.946910249415,
                        0.46717466969442
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 967,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006679266428173754,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932943080166,
                        0.465144276051245
                    ],
                    [
                        121.932309032682,
                        0.465354299355238
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 975,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.003230549874745083,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948082254773,
                        0.515076374935729
                    ],
                    [
                        121.94795711658,
                        0.515297773276152
                    ],
                    [
                        121.947860856432,
                        0.515625057779384
                    ],
                    [
                        121.947831978388,
                        0.515846456119806
                    ],
                    [
                        121.94771646621,
                        0.516154488593437
                    ],
                    [
                        121.947643603087,
                        0.516671542564243
                    ],
                    [
                        121.946521498432,
                        0.517756243731258
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 976,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.03600784195243974,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9490785473,
                        0.51495845625442
                    ],
                    [
                        121.949033238,
                        0.5144915603567
                    ],
                    [
                        121.9488669768,
                        0.51419248562391
                    ],
                    [
                        121.94866139882,
                        0.51389286054385
                    ],
                    [
                        121.94830718183,
                        0.51355299498066
                    ],
                    [
                        121.94784153028,
                        0.51315760170467
                    ],
                    [
                        121.94703845243,
                        0.51239069943423
                    ],
                    [
                        121.94517007479,
                        0.51073354448053
                    ],
                    [
                        121.94470816694,
                        0.51036877472135
                    ],
                    [
                        121.94411024451,
                        0.50983963107503
                    ],
                    [
                        121.94404055416,
                        0.50981235028806
                    ],
                    [
                        121.94231278896,
                        0.50823590009416
                    ],
                    [
                        121.9416495323,
                        0.50763020899071
                    ],
                    [
                        121.94086981406,
                        0.50686805297537
                    ],
                    [
                        121.94060988133,
                        0.50657802683407
                    ],
                    [
                        121.94015071168,
                        0.50602261949213
                    ],
                    [
                        121.93978920579,
                        0.50552412618688
                    ],
                    [
                        121.9393709667,
                        0.5050087762338
                    ],
                    [
                        121.93905081602,
                        0.50462638953939
                    ],
                    [
                        121.93883719369,
                        0.50438749237751
                    ],
                    [
                        121.93832721189,
                        0.50384608289929
                    ],
                    [
                        121.9377875112,
                        0.50334146438579
                    ],
                    [
                        121.93718470034,
                        0.50274840156394
                    ],
                    [
                        121.93668857217,
                        0.5020548229422
                    ],
                    [
                        121.9362163223,
                        0.50141340907588
                    ],
                    [
                        121.93579327769,
                        0.50078559063003
                    ],
                    [
                        121.93553866005,
                        0.50041011843327
                    ],
                    [
                        121.93543112584,
                        0.5002327213942
                    ],
                    [
                        121.93507388238,
                        0.49963024248089
                    ],
                    [
                        121.93493218124,
                        0.49939550111136
                    ],
                    [
                        121.93464282462,
                        0.49886624937868
                    ],
                    [
                        121.93388861428,
                        0.49729978012966
                    ],
                    [
                        121.93379892115,
                        0.49670158240217
                    ],
                    [
                        121.93374538425,
                        0.49618838838818
                    ],
                    [
                        121.93370203971,
                        0.49575606454992
                    ],
                    [
                        121.93365840023,
                        0.49525076719295
                    ],
                    [
                        121.93361433156,
                        0.49468003041645
                    ],
                    [
                        121.93356221616,
                        0.49372787750963
                    ],
                    [
                        121.93351425826,
                        0.49325657995116
                    ],
                    [
                        121.93349939885,
                        0.49283189529446
                    ],
                    [
                        121.93347482975,
                        0.49250472578792
                    ],
                    [
                        121.93343494535,
                        0.49206326477142
                    ],
                    [
                        121.93340409501,
                        0.49158736053339
                    ],
                    [
                        121.93344647886,
                        0.49144670805544
                    ],
                    [
                        121.93351854977,
                        0.49108874700128
                    ],
                    [
                        121.93390889168,
                        0.48988620613652
                    ],
                    [
                        121.93404104411,
                        0.48953983711622
                    ],
                    [
                        121.93416909277,
                        0.48924507203768
                    ],
                    [
                        121.93435808123,
                        0.48887330136063
                    ],
                    [
                        121.9346171021,
                        0.48837981485589
                    ],
                    [
                        121.93481016755,
                        0.48804501570697
                    ],
                    [
                        121.93520128727,
                        0.48703501201997
                    ],
                    [
                        121.93562046747,
                        0.48602610559158
                    ],
                    [
                        121.93575822112,
                        0.48554240760609
                    ],
                    [
                        121.93577103451,
                        0.48537277091616
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 977,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.011048798023806301,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94813661577,
                        0.51491220003731
                    ],
                    [
                        121.9484949589,
                        0.51522183827768
                    ],
                    [
                        121.94902429268,
                        0.51499222066001
                    ],
                    [
                        121.94899070992,
                        0.51458304167718
                    ],
                    [
                        121.94880661239,
                        0.5142401148999
                    ],
                    [
                        121.94858652895,
                        0.51396041915271
                    ],
                    [
                        121.94806532742,
                        0.51340715310385
                    ],
                    [
                        121.94784905609,
                        0.51323324934352
                    ],
                    [
                        121.94757561158,
                        0.51297520694919
                    ],
                    [
                        121.94658149559,
                        0.51204374994255
                    ],
                    [
                        121.94500053451,
                        0.51067166013217
                    ],
                    [
                        121.94408805604,
                        0.50994363611821
                    ],
                    [
                        121.94381190677,
                        0.50969104625505
                    ],
                    [
                        121.94270657673,
                        0.50867793281623
                    ],
                    [
                        121.94201576119,
                        0.50805178801783
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 978,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.04260513537568579,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94071505067,
                        0.5067974508254
                    ],
                    [
                        121.94004554487,
                        0.50597118458775
                    ],
                    [
                        121.93993789422,
                        0.50582487227312
                    ],
                    [
                        121.93951013819,
                        0.50528340894057
                    ],
                    [
                        121.93927279676,
                        0.50497116508546
                    ],
                    [
                        121.93870335782,
                        0.50431554323362
                    ],
                    [
                        121.93847413834,
                        0.50410031155893
                    ],
                    [
                        121.93831169934,
                        0.50394057987583
                    ],
                    [
                        121.93756899214,
                        0.50320779949911
                    ],
                    [
                        121.93747423605,
                        0.50310898244092
                    ],
                    [
                        121.93712860196,
                        0.50277508005251
                    ],
                    [
                        121.93663948008,
                        0.50211268990902
                    ],
                    [
                        121.93609350456,
                        0.5013614095351
                    ],
                    [
                        121.93576411436,
                        0.50088401936356
                    ],
                    [
                        121.93549969977,
                        0.50050048283634
                    ],
                    [
                        121.9353264315,
                        0.50022975117006
                    ],
                    [
                        121.93498440716,
                        0.49974198295132
                    ],
                    [
                        121.93477867321,
                        0.49941404050573
                    ],
                    [
                        121.93467768379,
                        0.4992382441097
                    ],
                    [
                        121.93408577358,
                        0.49801982547123
                    ],
                    [
                        121.93391184736,
                        0.49764579058605
                    ],
                    [
                        121.93377812989,
                        0.49736152407332
                    ],
                    [
                        121.93362103524,
                        0.49607951950437
                    ],
                    [
                        121.93356867036,
                        0.49551005139169
                    ],
                    [
                        121.93343214762,
                        0.49383811545494
                    ],
                    [
                        121.93333489855,
                        0.49261315120599
                    ],
                    [
                        121.93331245646,
                        0.49199318838381
                    ],
                    [
                        121.93332324571,
                        0.49184032599656
                    ],
                    [
                        121.93333326215,
                        0.491357329079
                    ],
                    [
                        121.93347071997,
                        0.4908009521873
                    ],
                    [
                        121.93358760587,
                        0.49038764363918
                    ],
                    [
                        121.93381857241,
                        0.48980882465437
                    ],
                    [
                        121.93409068279,
                        0.48917951096006
                    ],
                    [
                        121.93500987352,
                        0.48731307688302
                    ],
                    [
                        121.93527824355,
                        0.48662859304314
                    ],
                    [
                        121.93547274169,
                        0.48615356873897
                    ],
                    [
                        121.93566162931,
                        0.48542046036402
                    ],
                    [
                        121.93573082576,
                        0.48498938515885
                    ],
                    [
                        121.93575887838,
                        0.48478647123364
                    ],
                    [
                        121.93572593055,
                        0.48387655162147
                    ],
                    [
                        121.9355923696,
                        0.48195796654645
                    ],
                    [
                        121.93534899247,
                        0.48154610766084
                    ],
                    [
                        121.93414092363,
                        0.47976765985295
                    ],
                    [
                        121.93285566636,
                        0.47808236346045
                    ],
                    [
                        121.93230589549,
                        0.47663270067101
                    ],
                    [
                        121.93223196319,
                        0.47629821705815
                    ],
                    [
                        121.93194474898,
                        0.47517621994089
                    ],
                    [
                        121.93176652946,
                        0.47407506851101
                    ],
                    [
                        121.93166904068,
                        0.47349669576817
                    ],
                    [
                        121.93134455792,
                        0.47167859480442
                    ],
                    [
                        121.93118142613,
                        0.47030842956051
                    ],
                    [
                        121.9311653069,
                        0.46971214410951
                    ],
                    [
                        121.93120897777,
                        0.46855569493497
                    ],
                    [
                        121.93124918652,
                        0.46811807411931
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 979,
                "jenis_pipa": "Pipa 350",
                "keterangan": "",
                "panjang": 0.07521612922199473,
                "total_panjang_jenis": 0.07521612922199473
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.97202801704,
                        0.57690122451994
                    ],
                    [
                        121.97170078754,
                        0.57694413768862
                    ],
                    [
                        121.97123807936,
                        0.57624713702893
                    ],
                    [
                        121.97175979614,
                        0.574412260183
                    ],
                    [
                        121.97194785278,
                        0.57290721576312
                    ],
                    [
                        121.97173126745,
                        0.57202643540882
                    ],
                    [
                        121.97017365793,
                        0.57109331359863
                    ],
                    [
                        121.97013575549,
                        0.57076302096618
                    ],
                    [
                        121.97134863336,
                        0.56968731381216
                    ],
                    [
                        121.9715724382,
                        0.56881375296896
                    ],
                    [
                        121.97155799918,
                        0.56811346039218
                    ],
                    [
                        121.97104541389,
                        0.56765863119283
                    ],
                    [
                        121.97037399936,
                        0.56742038732651
                    ],
                    [
                        121.97137029189,
                        0.56413190002009
                    ],
                    [
                        121.97143526749,
                        0.56325833917689
                    ],
                    [
                        121.9704028774,
                        0.56242448564475
                    ],
                    [
                        121.96817204847,
                        0.55939229098241
                    ],
                    [
                        121.96725517056,
                        0.55863424231683
                    ],
                    [
                        121.9671468779,
                        0.55775707171808
                    ],
                    [
                        121.96822980456,
                        0.55642868167553
                    ],
                    [
                        121.9674067803,
                        0.55390185279025
                    ],
                    [
                        121.96939936536,
                        0.5507252679059
                    ],
                    [
                        121.97208502349,
                        0.55089853617231
                    ],
                    [
                        121.97232326736,
                        0.55068917035039
                    ],
                    [
                        121.97232326736,
                        0.55029931675095
                    ],
                    [
                        121.97178180402,
                        0.54892760964179
                    ],
                    [
                        121.97199838936,
                        0.54466087858122
                    ],
                    [
                        121.96951487754,
                        0.54160702538558
                    ],
                    [
                        121.96964482874,
                        0.53987434272139
                    ],
                    [
                        121.9704998753,
                        0.53849249117377
                    ],
                    [
                        121.97026245292,
                        0.53751384855257
                    ],
                    [
                        121.96999360175,
                        0.53663862496057
                    ],
                    [
                        121.96937623772,
                        0.53464265043752
                    ],
                    [
                        121.96921700831,
                        0.53406575572992
                    ],
                    [
                        121.96903456449,
                        0.53392924782123
                    ],
                    [
                        121.9682545513,
                        0.53398237350634
                    ],
                    [
                        121.96757513239,
                        0.53338841912666
                    ],
                    [
                        121.96631387558,
                        0.53272890697845
                    ],
                    [
                        121.96409464127,
                        0.53349432618696
                    ],
                    [
                        121.96006054507,
                        0.53402386148845
                    ],
                    [
                        121.95873715722,
                        0.53367413942255
                    ],
                    [
                        121.95720112949,
                        0.53370789649687
                    ],
                    [
                        121.95707021728,
                        0.53368171405491
                    ],
                    [
                        121.95691966824,
                        0.53356482815329
                    ],
                    [
                        121.95642126676,
                        0.53292896884849
                    ],
                    [
                        121.95590229335,
                        0.53230900602631
                    ],
                    [
                        121.95541043748,
                        0.53112051017866
                    ],
                    [
                        121.9541218873,
                        0.53092788221279
                    ],
                    [
                        121.95331137695,
                        0.53001624204765
                    ],
                    [
                        121.95241116694,
                        0.52843245010048
                    ],
                    [
                        121.95234377154,
                        0.52752742613066
                    ],
                    [
                        121.9520549341,
                        0.52696419312817
                    ],
                    [
                        121.95182157275,
                        0.52649089338737
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2194,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005355771323824732,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93470105529,
                        0.49588061192709
                    ],
                    [
                        121.9345857203,
                        0.49535760073714
                    ],
                    [
                        121.9345857203,
                        0.49535760073714
                    ],
                    [
                        121.9345857203,
                        0.49535760073714
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 981,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.08706990342529544,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.97202801704,
                        0.57689317830077
                    ],
                    [
                        121.97173431516,
                        0.57695620701725
                    ],
                    [
                        121.97119938507,
                        0.57610662090619
                    ],
                    [
                        121.97196409668,
                        0.57359848395078
                    ],
                    [
                        121.97207960886,
                        0.57290541088511
                    ],
                    [
                        121.9719622918,
                        0.57193258176451
                    ],
                    [
                        121.9716374138,
                        0.57157160620947
                    ],
                    [
                        121.9717186333,
                        0.57115106968762
                    ],
                    [
                        121.9720435113,
                        0.56956999675656
                    ],
                    [
                        121.97212292593,
                        0.56793116773669
                    ],
                    [
                        121.97174751135,
                        0.56732472880422
                    ],
                    [
                        121.97083063344,
                        0.56698541178249
                    ],
                    [
                        121.97172585281,
                        0.56499282671868
                    ],
                    [
                        121.97213014544,
                        0.56343341232092
                    ],
                    [
                        121.97159409674,
                        0.56224760762278
                    ],
                    [
                        121.97098043829,
                        0.56182887597893
                    ],
                    [
                        121.96993360918,
                        0.56105638829115
                    ],
                    [
                        121.96955819461,
                        0.55984351042621
                    ],
                    [
                        121.96906004834,
                        0.55962692509319
                    ],
                    [
                        121.97115551144,
                        0.55445956002268
                    ],
                    [
                        121.97329248672,
                        0.55108082882752
                    ],
                    [
                        121.97395668174,
                        0.54435224448162
                    ],
                    [
                        121.97271492584,
                        0.54218639115139
                    ],
                    [
                        121.97155980406,
                        0.54071361088684
                    ],
                    [
                        121.97074219443,
                        0.53880585507847
                    ],
                    [
                        121.97052969868,
                        0.53849001036076
                    ],
                    [
                        121.97018670422,
                        0.53711201508757
                    ],
                    [
                        121.96999414593,
                        0.53660654957252
                    ],
                    [
                        121.96935604829,
                        0.53471600203986
                    ],
                    [
                        121.96929371514,
                        0.53427900122462
                    ],
                    [
                        121.96917556052,
                        0.53402292897418
                    ],
                    [
                        121.96901931958,
                        0.53392758234272
                    ],
                    [
                        121.96878343567,
                        0.53396128004373
                    ],
                    [
                        121.96824424359,
                        0.53401570946308
                    ],
                    [
                        121.9676017071,
                        0.5332432217753
                    ],
                    [
                        121.96640326825,
                        0.53256458773182
                    ],
                    [
                        121.96420853688,
                        0.53323600226419
                    ],
                    [
                        121.96235439512,
                        0.53345542294938
                    ],
                    [
                        121.96120984837,
                        0.53356015271723
                    ],
                    [
                        121.96008619604,
                        0.53374858755235
                    ],
                    [
                        121.95872892795,
                        0.53354644124153
                    ],
                    [
                        121.95804738342,
                        0.5335657632405
                    ],
                    [
                        121.95720112949,
                        0.53363308951984
                    ],
                    [
                        121.95703842432,
                        0.53357511411263
                    ],
                    [
                        121.95679623673,
                        0.53335910896644
                    ],
                    [
                        121.95660267367,
                        0.53310195998289
                    ],
                    [
                        121.95595278806,
                        0.53226786218894
                    ],
                    [
                        121.95589166009,
                        0.53206644146586
                    ],
                    [
                        121.95547292845,
                        0.53107014893395
                    ],
                    [
                        121.95413456365,
                        0.53086831248732
                    ],
                    [
                        121.95339321423,
                        0.52990070707278
                    ],
                    [
                        121.95315546538,
                        0.52946741746957
                    ],
                    [
                        121.95252670192,
                        0.52836024074118
                    ],
                    [
                        121.95250744609,
                        0.52746003072865
                    ],
                    [
                        121.95226024601,
                        0.52705610076191
                    ],
                    [
                        121.95217361187,
                        0.52691171053989
                    ],
                    [
                        121.95269316365,
                        0.52605482061611
                    ],
                    [
                        121.95241838694,
                        0.52565194866519
                    ],
                    [
                        121.95268430109,
                        0.52531324607791
                    ],
                    [
                        121.95247451889,
                        0.52519227711495
                    ],
                    [
                        121.95294594846,
                        0.5241792100903
                    ],
                    [
                        121.95318765336,
                        0.52377190146153
                    ],
                    [
                        121.95327919045,
                        0.52315729240239
                    ],
                    [
                        121.95354585566,
                        0.52272702456331
                    ],
                    [
                        121.95415543453,
                        0.52207281317341
                    ],
                    [
                        121.95481120544,
                        0.52150631873735
                    ],
                    [
                        121.95246773094,
                        0.52041600772956
                    ],
                    [
                        121.95190449794,
                        0.52019576918371
                    ],
                    [
                        121.95145569741,
                        0.51978083904812
                    ],
                    [
                        121.95050966002,
                        0.51913290194223
                    ],
                    [
                        121.94999767989,
                        0.51852562778464
                    ],
                    [
                        121.94937981072,
                        0.51774916719579
                    ],
                    [
                        121.94915452484,
                        0.5171196504778
                    ],
                    [
                        121.94904974026,
                        0.51648607616155
                    ],
                    [
                        121.94900836049,
                        0.51503889789742
                    ],
                    [
                        121.94808556371,
                        0.51509878550136
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 989,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.04510526808361479,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96863631102,
                        0.55157180261296
                    ],
                    [
                        121.96945371242,
                        0.55010187580975
                    ],
                    [
                        121.97193784545,
                        0.55072772327798
                    ],
                    [
                        121.9722170697,
                        0.55058329693916
                    ],
                    [
                        121.97218818443,
                        0.55032332952928
                    ],
                    [
                        121.97161047908,
                        0.54896572194434
                    ],
                    [
                        121.97157196539,
                        0.54893683667657
                    ],
                    [
                        121.97187044649,
                        0.54473884442812
                    ],
                    [
                        121.96934779977,
                        0.54161923550954
                    ],
                    [
                        121.96954999665,
                        0.53990537628884
                    ],
                    [
                        121.97047674515,
                        0.53839493470436
                    ],
                    [
                        121.97027696592,
                        0.53755249217927
                    ],
                    [
                        121.97016985537,
                        0.53710479415165
                    ],
                    [
                        121.96991952959,
                        0.53651027042679
                    ],
                    [
                        121.96927927327,
                        0.53462079219194
                    ],
                    [
                        121.9692311337,
                        0.53429344309648
                    ],
                    [
                        121.96900006375,
                        0.53399979170202
                    ],
                    [
                        121.9686679007,
                        0.53403830336031
                    ],
                    [
                        121.96827797016,
                        0.53406718710403
                    ],
                    [
                        121.96758476031,
                        0.53329213998094
                    ],
                    [
                        121.96634757328,
                        0.53260855804629
                    ],
                    [
                        121.9640599942,
                        0.53336565457693
                    ],
                    [
                        121.9614342693,
                        0.53369480527589
                    ],
                    [
                        121.96009905673,
                        0.53386018694072
                    ],
                    [
                        121.95863561371,
                        0.53360986116183
                    ],
                    [
                        121.95709639972,
                        0.5336592719618
                    ],
                    [
                        121.95689255071,
                        0.53349189135068
                    ],
                    [
                        121.95679904199,
                        0.53338622649562
                    ],
                    [
                        121.95643155272,
                        0.5329149425403
                    ],
                    [
                        121.95592660562,
                        0.53229965515418
                    ],
                    [
                        121.95542951816,
                        0.53110073308793
                    ],
                    [
                        121.95412012178,
                        0.53090817479648
                    ],
                    [
                        121.95336433048,
                        0.52997291643207
                    ],
                    [
                        121.95246412047,
                        0.52840838031405
                    ],
                    [
                        121.9524159809,
                        0.52746965864323
                    ],
                    [
                        121.95210788763,
                        0.5269545652136
                    ],
                    [
                        121.95214652492,
                        0.52615467706081
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 991,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.02881698144412712,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94806238526,
                        0.45146218108302
                    ],
                    [
                        121.94807440267,
                        0.45103712203413
                    ],
                    [
                        121.94809745551,
                        0.45072685382824
                    ],
                    [
                        121.94810011088,
                        0.45040747928583
                    ],
                    [
                        121.94811049098,
                        0.45029132827971
                    ],
                    [
                        121.94811934228,
                        0.4501778596434
                    ],
                    [
                        121.94812009337,
                        0.45008201297041
                    ],
                    [
                        121.94814777371,
                        0.45002956688765
                    ],
                    [
                        121.94816429618,
                        0.44996175984396
                    ],
                    [
                        121.94821992516,
                        0.4499295960902
                    ],
                    [
                        121.94833225614,
                        0.44993103816819
                    ],
                    [
                        121.94878021174,
                        0.45002347091967
                    ],
                    [
                        121.94924541413,
                        0.45015059557948
                    ],
                    [
                        121.94967638261,
                        0.45025971454318
                    ],
                    [
                        121.95058403751,
                        0.45052563851173
                    ],
                    [
                        121.9518799962,
                        0.45093714252058
                    ],
                    [
                        121.95278624287,
                        0.45122718826944
                    ],
                    [
                        121.95396543142,
                        0.45143914672376
                    ],
                    [
                        121.95528430045,
                        0.45161239816317
                    ],
                    [
                        121.95625809322,
                        0.45178790025215
                    ],
                    [
                        121.95678463426,
                        0.45194044028128
                    ],
                    [
                        121.95696817332,
                        0.45204523701303
                    ],
                    [
                        121.9570540086,
                        0.45221153091166
                    ],
                    [
                        121.95710574607,
                        0.45245502866104
                    ],
                    [
                        121.95715767146,
                        0.45277439234122
                    ],
                    [
                        121.95720116346,
                        0.45308398396773
                    ],
                    [
                        121.95722683886,
                        0.45328571984442
                    ],
                    [
                        121.95717204132,
                        0.45341924952206
                    ],
                    [
                        121.9568064856,
                        0.45372041195776
                    ],
                    [
                        121.95654899,
                        0.45393497773054
                    ],
                    [
                        121.95598457606,
                        0.45440856943807
                    ],
                    [
                        121.95577210487,
                        0.45457811808475
                    ],
                    [
                        121.95567161273,
                        0.45468009482793
                    ],
                    [
                        121.95554774702,
                        0.45493216175523
                    ],
                    [
                        121.95552687045,
                        0.45512432028892
                    ],
                    [
                        121.95555930795,
                        0.45536224235011
                    ],
                    [
                        121.95566933154,
                        0.45563895565936
                    ],
                    [
                        121.95595445438,
                        0.45588633130008
                    ],
                    [
                        121.95659008022,
                        0.45627430798292
                    ],
                    [
                        121.95723678765,
                        0.45674520927684
                    ],
                    [
                        121.95775133079,
                        0.45712584326113
                    ],
                    [
                        121.95844034851,
                        0.45773613125428
                    ],
                    [
                        121.9589934736,
                        0.4582896477692
                    ],
                    [
                        121.95940232274,
                        0.45879373343692
                    ],
                    [
                        121.95960208698,
                        0.45885802231317
                    ],
                    [
                        121.95977048054,
                        0.45905094999541
                    ],
                    [
                        121.9601517655,
                        0.459543108591
                    ],
                    [
                        121.96033586116,
                        0.45981745141319
                    ],
                    [
                        121.96055561676,
                        0.46009754021725
                    ],
                    [
                        121.96082005572,
                        0.46041325735512
                    ],
                    [
                        121.96103782653,
                        0.46065792269474
                    ],
                    [
                        121.96155442801,
                        0.46119889628714
                    ],
                    [
                        121.96170687754,
                        0.46135106341809
                    ],
                    [
                        121.96211457253,
                        0.4616782772415
                    ],
                    [
                        121.96251958609,
                        0.46199208550153
                    ],
                    [
                        121.96276903152,
                        0.46217178766129
                    ],
                    [
                        121.9632126704,
                        0.46249567528028
                    ],
                    [
                        121.96335409123,
                        0.46269116877749
                    ],
                    [
                        121.9634744525,
                        0.46307298051329
                    ],
                    [
                        121.96357101202,
                        0.46354503386623
                    ],
                    [
                        121.96357369423,
                        0.4636469544724
                    ],
                    [
                        121.9635656476,
                        0.46396076264533
                    ],
                    [
                        121.96334857762,
                        0.46452596466586
                    ],
                    [
                        121.96312911488,
                        0.46493082935399
                    ],
                    [
                        121.96298324127,
                        0.46520761516903
                    ],
                    [
                        121.96272585852,
                        0.46576749863783
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 996,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.03736764015952357,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.889714015159,
                        0.494376959461441
                    ],
                    [
                        121.889272653995,
                        0.49348956169636
                    ],
                    [
                        121.889063194459,
                        0.492509590297196
                    ],
                    [
                        121.888741524458,
                        0.49055712819657
                    ],
                    [
                        121.888479700038,
                        0.489315332377781
                    ],
                    [
                        121.888490921085,
                        0.487801426180019
                    ],
                    [
                        121.888483440387,
                        0.486372612918641
                    ],
                    [
                        121.889575622252,
                        0.485183181983777
                    ],
                    [
                        121.890391018301,
                        0.484360305236386
                    ],
                    [
                        121.890648999049,
                        0.483279502216782
                    ],
                    [
                        121.890692116384,
                        0.482383530868223
                    ],
                    [
                        121.890499385095,
                        0.481906417357231
                    ],
                    [
                        121.889697183589,
                        0.480468472256114
                    ],
                    [
                        121.889263303123,
                        0.479645595508724
                    ],
                    [
                        121.889278264518,
                        0.478949890622293
                    ],
                    [
                        121.889285745216,
                        0.477999842013942
                    ],
                    [
                        121.889330629402,
                        0.477326579220623
                    ],
                    [
                        121.889300706611,
                        0.476825372474485
                    ],
                    [
                        121.88924086103,
                        0.476391492007679
                    ],
                    [
                        121.888829422656,
                        0.475875323866134
                    ],
                    [
                        121.888324475561,
                        0.474502615837532
                    ],
                    [
                        121.888122496723,
                        0.473870496881582
                    ],
                    [
                        121.888118756374,
                        0.47272969048179
                    ],
                    [
                        121.887984103815,
                        0.471626287570517
                    ],
                    [
                        121.887482897069,
                        0.471012870358826
                    ],
                    [
                        121.886379494158,
                        0.470195604134712
                    ],
                    [
                        121.886207438111,
                        0.470031028785234
                    ],
                    [
                        121.886214918808,
                        0.469784165761017
                    ],
                    [
                        121.88643933974,
                        0.468901443431998
                    ],
                    [
                        121.886611395787,
                        0.468288026220307
                    ],
                    [
                        121.886734827299,
                        0.467910250986278
                    ],
                    [
                        121.88673108695,
                        0.467775598427614
                    ],
                    [
                        121.886446820437,
                        0.466896616447446
                    ],
                    [
                        121.88637201346,
                        0.466900356796298
                    ],
                    [
                        121.886398195902,
                        0.467038749703814
                    ],
                    [
                        121.886517887065,
                        0.467233247844106
                    ],
                    [
                        121.88666750102,
                        0.467771858078762
                    ],
                    [
                        121.886641318578,
                        0.467973836916758
                    ],
                    [
                        121.886121410087,
                        0.469829049947238
                    ],
                    [
                        121.885478070085,
                        0.469808478028554
                    ],
                    [
                        121.88520128427,
                        0.467143479471664
                    ],
                    [
                        121.884303600545,
                        0.467218286448699
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 997,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.009737254790379297,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89164623618,
                        0.49915143581272
                    ],
                    [
                        121.89234226942,
                        0.49874375252581
                    ],
                    [
                        121.8925729394,
                        0.49915413874608
                    ],
                    [
                        121.89267620444,
                        0.49939952700795
                    ],
                    [
                        121.89275532961,
                        0.49962483739122
                    ],
                    [
                        121.8930490315,
                        0.5009350264661
                    ],
                    [
                        121.8965925167,
                        0.50075331916651
                    ],
                    [
                        121.89789304954,
                        0.50066366044378
                    ],
                    [
                        121.89812605973,
                        0.50061960169506
                    ],
                    [
                        121.89954668283,
                        0.50007006416923
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 998,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0023807976860262723,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940674865631,
                        0.476747526463968
                    ],
                    [
                        121.941255554791,
                        0.476471675736153
                    ],
                    [
                        121.940540213072,
                        0.47523642552785
                    ],
                    [
                        121.940506549933,
                        0.475204632562614
                    ],
                    [
                        121.940461665747,
                        0.475207437824253
                    ],
                    [
                        121.940404625427,
                        0.475217723783595
                    ],
                    [
                        121.940335428973,
                        0.475233620266215
                    ],
                    [
                        121.940284934264,
                        0.47515881328918
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 999,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0015608373128537954,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93999412214,
                        0.475313102679311
                    ],
                    [
                        121.940671125282,
                        0.476719473847579
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1000,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.001482964312634536,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940491588538,
                        0.475235490440641
                    ],
                    [
                        121.94053460255,
                        0.475263543057029
                    ],
                    [
                        121.941244099974,
                        0.476506975278484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1003,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.005177196897934823,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942490804998,
                        0.474359313722108
                    ],
                    [
                        121.942460882207,
                        0.474250843605406
                    ],
                    [
                        121.943427208159,
                        0.473844951792461
                    ],
                    [
                        121.943339891257,
                        0.473523331086323
                    ],
                    [
                        121.942788848398,
                        0.471678527576774
                    ],
                    [
                        121.942512341386,
                        0.470091468956061
                    ],
                    [
                        121.942438440114,
                        0.46996440382127
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1004,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.001582680341838205,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942438440114,
                        0.469971884518973
                    ],
                    [
                        121.940860012899,
                        0.470087835333379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1005,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00014587360499263013,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942442180463,
                        0.469971884518973
                    ],
                    [
                        121.942588054068,
                        0.469971884518973
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1009,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.001582680341838205,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942438440114,
                        0.469971884518973
                    ],
                    [
                        121.940860012899,
                        0.470087835333379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1010,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00012344027401284776,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942442180463,
                        0.469971884518973
                    ],
                    [
                        121.942565506942,
                        0.469966585384504
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1014,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.001582680341838205,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942438440114,
                        0.469971884518973
                    ],
                    [
                        121.940860012899,
                        0.470087835333379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1015,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00014587360499263013,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942442180463,
                        0.469971884518973
                    ],
                    [
                        121.942588054068,
                        0.469971884518973
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1019,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.001582680341838205,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942438440114,
                        0.469971884518973
                    ],
                    [
                        121.940860012899,
                        0.470087835333379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1020,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00014587360499263013,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942442180463,
                        0.469971884518973
                    ],
                    [
                        121.942588054068,
                        0.469971884518973
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1021,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.006814214567099154,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.955362981802,
                        0.482764111363896
                    ],
                    [
                        121.9555752466,
                        0.482982921771724
                    ],
                    [
                        121.955822109624,
                        0.483218563749386
                    ],
                    [
                        121.956113856834,
                        0.483577637239157
                    ],
                    [
                        121.956510333813,
                        0.483779616077152
                    ],
                    [
                        121.956940473931,
                        0.483932970380075
                    ],
                    [
                        121.957621217422,
                        0.484277082474438
                    ],
                    [
                        121.958626669945,
                        0.484480697715016
                    ],
                    [
                        121.9609501279,
                        0.485167285501161
                    ],
                    [
                        121.961211952319,
                        0.485257053873603
                    ],
                    [
                        121.961376527669,
                        0.485526358990931
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1022,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.016752953005434355,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.961361566273,
                        0.485526358990931
                    ],
                    [
                        121.962648246278,
                        0.48944624458759
                    ],
                    [
                        121.964593227681,
                        0.493635435301577
                    ],
                    [
                        121.966402855207,
                        0.497403602997906
                    ],
                    [
                        121.966858008911,
                        0.498493213372818
                    ],
                    [
                        121.967280668331,
                        0.498257571395156
                    ],
                    [
                        121.96760981903,
                        0.498145360929603
                    ],
                    [
                        121.967961411822,
                        0.498029410115198
                    ],
                    [
                        121.968208274847,
                        0.497950862789311
                    ],
                    [
                        121.968387811592,
                        0.497924680347349
                    ],
                    [
                        121.968597271127,
                        0.498085515347975
                    ],
                    [
                        121.968737534209,
                        0.498222038081065
                    ],
                    [
                        121.968928292001,
                        0.498367911686284
                    ],
                    [
                        121.969139621711,
                        0.498425887093486
                    ],
                    [
                        121.969225649734,
                        0.498429627442338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1024,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.001582680341838205,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942438440114,
                        0.469971884518973
                    ],
                    [
                        121.940860012899,
                        0.470087835333379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1025,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00014587360499263013,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942442180463,
                        0.469971884518973
                    ],
                    [
                        121.942588054068,
                        0.469971884518973
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1029,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.001582680341838205,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942438440114,
                        0.469971884518973
                    ],
                    [
                        121.940860012899,
                        0.470087835333379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1030,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00014587360499263013,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942442180463,
                        0.469971884518973
                    ],
                    [
                        121.942588054068,
                        0.469971884518973
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1031,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.002260373204787673,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94661360452,
                        0.46953239352889
                    ],
                    [
                        121.94683461784,
                        0.46952311272129
                    ],
                    [
                        121.94727396369,
                        0.46947445820768
                    ],
                    [
                        121.94787279369,
                        0.46939759267423
                    ],
                    [
                        121.94833922977,
                        0.46939276280653
                    ],
                    [
                        121.9486540675,
                        0.46942194303292
                    ],
                    [
                        121.94886472823,
                        0.46942780065371
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1032,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0011652451613867914,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96191467036,
                        0.469779490324963
                    ],
                    [
                        121.962164104872,
                        0.468641255414956
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1033,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0030654063165984962,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9613513231,
                        0.46693638688166
                    ],
                    [
                        121.96123887147,
                        0.46688279039709
                    ],
                    [
                        121.96112038493,
                        0.46683145325707
                    ],
                    [
                        121.96034334899,
                        0.46651842979842
                    ],
                    [
                        121.96016948819,
                        0.46649178812841
                    ],
                    [
                        121.95995442868,
                        0.46648888262623
                    ],
                    [
                        121.95970733025,
                        0.46652441628855
                    ],
                    [
                        121.95933453096,
                        0.46664951965138
                    ],
                    [
                        121.95899152901,
                        0.46675855842828
                    ],
                    [
                        121.95860133471,
                        0.46686924423988
                    ],
                    [
                        121.95842754095,
                        0.46688644557482
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1585,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004002988199402702,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96135282516,
                        0.46693523429284
                    ],
                    [
                        121.962018013,
                        0.46725708867893
                    ],
                    [
                        121.96212530136,
                        0.46745020130352
                    ],
                    [
                        121.96208238602,
                        0.46820119479307
                    ],
                    [
                        121.9618088007,
                        0.46980510204763
                    ],
                    [
                        121.96135282516,
                        0.46981583052302
                    ],
                    [
                        121.9611452488,
                        0.46980816927843
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1034,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.015625065332549724,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9620454252,
                        0.46160774466174
                    ],
                    [
                        121.96200967134,
                        0.46162538026981
                    ],
                    [
                        121.96162037551,
                        0.46130885160111
                    ],
                    [
                        121.96062996984,
                        0.46009180193732
                    ],
                    [
                        121.95964007383,
                        0.45887581444394
                    ],
                    [
                        121.9594560923,
                        0.45889484139444
                    ],
                    [
                        121.95509858589,
                        0.45919313421537
                    ],
                    [
                        121.95352747919,
                        0.45922278363909
                    ],
                    [
                        121.95196241003,
                        0.45920133213866
                    ],
                    [
                        121.95129990578,
                        0.4590162707189
                    ],
                    [
                        121.95083051999,
                        0.45889557940283
                    ],
                    [
                        121.95035036332,
                        0.45880171521922
                    ],
                    [
                        121.95001782362,
                        0.45877757358161
                    ],
                    [
                        121.94956724963,
                        0.45876415748395
                    ],
                    [
                        121.94841528132,
                        0.45874801245114
                    ],
                    [
                        121.94776477138,
                        0.45864209600269
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1035,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0025135353124442154,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93141315022,
                        0.46765176438732
                    ],
                    [
                        121.93317733636,
                        0.46728210615094
                    ],
                    [
                        121.93388834596,
                        0.46727585714343
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2192,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0019850768667230216,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93567201495,
                        0.49577332758381
                    ],
                    [
                        121.93554192781,
                        0.49581087710415
                    ],
                    [
                        121.9355070591,
                        0.49563922215226
                    ],
                    [
                        121.93441271782,
                        0.495969121509
                    ],
                    [
                        121.93429201841,
                        0.49545147454351
                    ],
                    [
                        121.93429201841,
                        0.49545147454351
                    ],
                    [
                        121.93429201841,
                        0.49545147454351
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1037,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00458890366617358,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9395813285,
                        0.44913532597927
                    ],
                    [
                        121.93966581867,
                        0.44872362290738
                    ],
                    [
                        121.93977042404,
                        0.44832398094877
                    ],
                    [
                        121.93984016226,
                        0.44805711100384
                    ],
                    [
                        121.93994074765,
                        0.44777682957026
                    ],
                    [
                        121.9412094225,
                        0.4484782078832
                    ],
                    [
                        121.94154871428,
                        0.44860024971453
                    ],
                    [
                        121.94201678116,
                        0.44875311280628
                    ],
                    [
                        121.94234934915,
                        0.44882553233672
                    ],
                    [
                        121.94288714542,
                        0.44886039787536
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1038,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020280423590002183,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93995279533,
                        0.44781415462027
                    ],
                    [
                        121.93995684346,
                        0.44780634055949
                    ],
                    [
                        121.93995598295,
                        0.44781795347206
                    ],
                    [
                        121.9399608652,
                        0.44776878318893
                    ],
                    [
                        121.93998738595,
                        0.44771650971881
                    ],
                    [
                        121.94011509104,
                        0.44735171494222
                    ],
                    [
                        121.94019958063,
                        0.44719614987258
                    ],
                    [
                        121.94082634976,
                        0.44762704047846
                    ],
                    [
                        121.94133877755,
                        0.44788886489809
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1039,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0007593676047185776,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9431580554,
                        0.4605665376106
                    ],
                    [
                        121.94242581627,
                        0.46036537843087
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1040,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013456941420672787,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937235539144,
                        0.461986813882998
                    ],
                    [
                        121.938567103336,
                        0.461792315742706
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1041,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004337238307457267,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937679781288,
                        0.462364014954463
                    ],
                    [
                        121.937620545455,
                        0.461934355231605
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1042,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00043368443236040533,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937990230243,
                        0.462311650070538
                    ],
                    [
                        121.937937773808,
                        0.461881149769378
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1043,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004074027162880973,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938300081754,
                        0.462236356724905
                    ],
                    [
                        121.938271014859,
                        0.46182999224706
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1044,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.006754681942854808,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9471634358,
                        0.47334100374722
                    ],
                    [
                        121.94697484374,
                        0.47152702213518
                    ],
                    [
                        121.94682734015,
                        0.47042418426884
                    ],
                    [
                        121.9467786726,
                        0.46954430898171
                    ],
                    [
                        121.94678433018,
                        0.46941526900091
                    ],
                    [
                        121.94678986551,
                        0.46928762631348
                    ],
                    [
                        121.94685261995,
                        0.46815540666627
                    ],
                    [
                        121.94705665161,
                        0.46662276731225
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1045,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0038301002792959574,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94251831993,
                        0.48054018859261
                    ],
                    [
                        121.94259838384,
                        0.48056488648682
                    ],
                    [
                        121.94355343126,
                        0.48031497666516
                    ],
                    [
                        121.94490905999,
                        0.47996564067312
                    ],
                    [
                        121.94519816193,
                        0.4798850914343
                    ],
                    [
                        121.94577031732,
                        0.47976588389077
                    ],
                    [
                        121.94605511433,
                        0.47969495254507
                    ],
                    [
                        121.94621981528,
                        0.47961954762951
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1046,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0017500760798132029,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940543018335,
                        0.4750952273587
                    ],
                    [
                        121.941319140721,
                        0.476458584515172
                    ],
                    [
                        121.941218151302,
                        0.476609133556457
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1047,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0068249957002896825,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941244099974,
                        0.476510715627335
                    ],
                    [
                        121.94182969834,
                        0.478343720336468
                    ],
                    [
                        121.942016715782,
                        0.478929084931771
                    ],
                    [
                        121.942381399795,
                        0.480618787525561
                    ],
                    [
                        121.942768525901,
                        0.482083134101032
                    ],
                    [
                        121.942980790699,
                        0.483104249337567
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1048,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0023605893930330095,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943035960844,
                        0.483309968524416
                    ],
                    [
                        121.943067753809,
                        0.48328285099524
                    ],
                    [
                        121.942832111832,
                        0.482085939362672
                    ],
                    [
                        121.942550650581,
                        0.481023680288767
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1049,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0014285354548048256,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93994398307,
                        0.44776199206205
                    ],
                    [
                        121.94017506152,
                        0.44724084945952
                    ],
                    [
                        121.94033963687,
                        0.44700520748186
                    ],
                    [
                        121.94045932803,
                        0.44678826724845
                    ],
                    [
                        121.94024117981,
                        0.446549701914
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1050,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0010116458767519144,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9402398389,
                        0.4465483621154
                    ],
                    [
                        121.93958220852,
                        0.44577962961105
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1051,
                "jenis_pipa": "Pipa 100",
                "keterangan": "test",
                "panjang": 0.028260753847954678,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.952062925,
                        0.52621383675399
                    ],
                    [
                        121.95227228479,
                        0.52695750190663
                    ],
                    [
                        121.95244434084,
                        0.52725672981477
                    ],
                    [
                        121.9525565513,
                        0.52744374725736
                    ],
                    [
                        121.95258273375,
                        0.52789632946842
                    ],
                    [
                        121.95257525305,
                        0.52834891167949
                    ],
                    [
                        121.95310638259,
                        0.52930270063669
                    ],
                    [
                        121.95320363166,
                        0.52946727598617
                    ],
                    [
                        121.95348041747,
                        0.52990115645298
                    ],
                    [
                        121.95416116096,
                        0.53082876296822
                    ],
                    [
                        121.95483255358,
                        0.5309503243059
                    ],
                    [
                        121.95548524446,
                        0.53103541724228
                    ],
                    [
                        121.95599019155,
                        0.53225477096796
                    ],
                    [
                        121.9564689562,
                        0.53289437062161
                    ],
                    [
                        121.95681587356,
                        0.53336378440251
                    ],
                    [
                        121.9568710437,
                        0.5333413423094
                    ],
                    [
                        121.95695052612,
                        0.5334208247225
                    ],
                    [
                        121.95710014007,
                        0.53355267201952
                    ],
                    [
                        121.95999797534,
                        0.53344046155397
                    ],
                    [
                        121.96418716606,
                        0.53302902318027
                    ],
                    [
                        121.96647625956,
                        0.53240064457318
                    ],
                    [
                        121.96747867305,
                        0.53293925480783
                    ],
                    [
                        121.96834643398,
                        0.53380701574144
                    ],
                    [
                        121.96930396329,
                        0.53388182271848
                    ],
                    [
                        121.96948350003,
                        0.53459996969802
                    ],
                    [
                        121.96967425782,
                        0.53541162539886
                    ],
                    [
                        121.97037370306,
                        0.53745011552307
                    ],
                    [
                        121.97214662842,
                        0.53691898598612
                    ],
                    [
                        121.97230372307,
                        0.53670204575272
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1052,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0076388206468041495,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.972356087951,
                        0.536672122961904
                    ],
                    [
                        121.972625393068,
                        0.53620083900658
                    ],
                    [
                        121.972984466558,
                        0.535916572493845
                    ],
                    [
                        121.973807343305,
                        0.53542284644541
                    ],
                    [
                        121.974323511447,
                        0.535011408071715
                    ],
                    [
                        121.974675104239,
                        0.534644853884241
                    ],
                    [
                        121.975535384475,
                        0.534397990860023
                    ],
                    [
                        121.976350780524,
                        0.534240896208249
                    ],
                    [
                        121.976889390759,
                        0.534136166440399
                    ],
                    [
                        121.977315790528,
                        0.534255857603656
                    ],
                    [
                        121.978250877741,
                        0.534248376905952
                    ],
                    [
                        121.979103677279,
                        0.534151127835806
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1053,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.016173951383270692,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.979109287803,
                        0.534139906789251
                    ],
                    [
                        121.980222041586,
                        0.533975331439773
                    ],
                    [
                        121.981179570892,
                        0.533601296554596
                    ],
                    [
                        121.982047331826,
                        0.53342175980971
                    ],
                    [
                        121.982885169968,
                        0.532673690039355
                    ],
                    [
                        121.983348973226,
                        0.532239809572549
                    ],
                    [
                        121.984112004392,
                        0.532239809572549
                    ],
                    [
                        121.984904958348,
                        0.532239809572549
                    ],
                    [
                        121.985802642073,
                        0.532045311432256
                    ],
                    [
                        121.986176676958,
                        0.531895697478185
                    ],
                    [
                        121.987238936032,
                        0.531416932825158
                    ],
                    [
                        121.988136619756,
                        0.530908245381316
                    ],
                    [
                        121.988660268596,
                        0.53036963514666
                    ],
                    [
                        121.989243763016,
                        0.529711333748748
                    ],
                    [
                        121.989797334646,
                        0.529247530491127
                    ],
                    [
                        121.990231215113,
                        0.528723881651878
                    ],
                    [
                        121.990769825348,
                        0.529112877932463
                    ],
                    [
                        121.991278512792,
                        0.529546758399269
                    ],
                    [
                        121.991667509072,
                        0.529950716075261
                    ],
                    [
                        121.992011621167,
                        0.530145214215554
                    ],
                    [
                        121.992969150473,
                        0.530354673751253
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1054,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002372853548443537,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94194892196,
                        0.532651247946244
                    ],
                    [
                        121.94194892196,
                        0.532658728643948
                    ],
                    [
                        121.94221074638,
                        0.532980398645201
                    ],
                    [
                        121.942420205915,
                        0.533466643995932
                    ],
                    [
                        121.942592261963,
                        0.533960370044366
                    ],
                    [
                        121.942696991731,
                        0.534349366324951
                    ],
                    [
                        121.942779279405,
                        0.534611190744575
                    ],
                    [
                        121.942869047778,
                        0.534813169582571
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1055,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.013988778773625664,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.929523483075,
                        0.524605757566072
                    ],
                    [
                        121.928730529118,
                        0.52441125942578
                    ],
                    [
                        121.92771315423,
                        0.524216761285487
                    ],
                    [
                        121.927069814228,
                        0.524112031517638
                    ],
                    [
                        121.92584110963,
                        0.524658122449997
                    ],
                    [
                        121.92418039474,
                        0.525765265710123
                    ],
                    [
                        121.923105044445,
                        0.526460970596554
                    ],
                    [
                        121.922491627233,
                        0.526782640597807
                    ],
                    [
                        121.922024083627,
                        0.526969658040396
                    ],
                    [
                        121.920789768506,
                        0.52752697001931
                    ],
                    [
                        121.919349734198,
                        0.527833678625156
                    ],
                    [
                        121.918553039892,
                        0.528024436416597
                    ],
                    [
                        121.917932141983,
                        0.528237636301148
                    ],
                    [
                        121.917333686167,
                        0.528649074674843
                    ],
                    [
                        121.916854921514,
                        0.529071734095094
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1056,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001427395060572987,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.966148979031,
                        0.532428697189564
                    ],
                    [
                        121.966687589266,
                        0.531890086954909
                    ],
                    [
                        121.966724992754,
                        0.531575897651359
                    ],
                    [
                        121.966964375081,
                        0.531321553929438
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1057,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0009404578919672367,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.970405496025,
                        0.53747068744176
                    ],
                    [
                        121.970599994165,
                        0.538390813259297
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1059,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi ",
                "panjang": 0.0030061220067015134,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96941201157,
                        0.53484244688726
                    ],
                    [
                        121.96984901727,
                        0.53612511132462
                    ],
                    [
                        121.97002296519,
                        0.53665259035834
                    ],
                    [
                        121.9702088356,
                        0.53714364971436
                    ],
                    [
                        121.9703433551,
                        0.53769814280007
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2071,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0017631523842852978,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96844459795,
                        0.53394805817007
                    ],
                    [
                        121.96872356714,
                        0.53389978650417
                    ],
                    [
                        121.96897034757,
                        0.53385687835638
                    ],
                    [
                        121.96914202091,
                        0.53393196761481
                    ],
                    [
                        121.9692841879,
                        0.5340258291866
                    ],
                    [
                        121.96939684853,
                        0.5344522288803
                    ],
                    [
                        121.96945653659,
                        0.53482043270859
                    ],
                    [
                        121.96940288867,
                        0.53484188677916
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1061,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.016600531221876515,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96843455212,
                        0.53395307480836
                    ],
                    [
                        121.96827679351,
                        0.53392970132317
                    ],
                    [
                        121.96711617694,
                        0.53276477852971
                    ],
                    [
                        121.96579378318,
                        0.53266853262586
                    ],
                    [
                        121.96419633332,
                        0.53310019133254
                    ],
                    [
                        121.96017130762,
                        0.53366171408485
                    ],
                    [
                        121.95944175124,
                        0.53399862623461
                    ],
                    [
                        121.95874132812,
                        0.53344732151587
                    ],
                    [
                        121.95709265937,
                        0.53374529998539
                    ],
                    [
                        121.95677098937,
                        0.53344420190282
                    ],
                    [
                        121.95639975975,
                        0.53294206006947
                    ],
                    [
                        121.95588172143,
                        0.53231461654959
                    ],
                    [
                        121.95547963393,
                        0.53143656965663
                    ],
                    [
                        121.95535620242,
                        0.53117006980094
                    ],
                    [
                        121.954129368,
                        0.53096715587573
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1062,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009734846226528658,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.956969227862,
                        0.533642440391967
                    ],
                    [
                        121.956243600185,
                        0.53429139091775
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1063,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.004872356212668952,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.956571815797,
                        0.521504073280738
                    ],
                    [
                        121.957095464636,
                        0.52102530862771
                    ],
                    [
                        121.95835222185,
                        0.520367007229797
                    ],
                    [
                        121.957185233008,
                        0.517883415592217
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1064,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006773593094726301,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95710967706,
                        0.51775791668612
                    ],
                    [
                        121.95672343962,
                        0.51418716429135
                    ],
                    [
                        121.95572490572,
                        0.51116588429076
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1065,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.017586752610367858,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95585366882,
                        0.51126299812457
                    ],
                    [
                        121.95531505858,
                        0.50961724462979
                    ],
                    [
                        121.95447722044,
                        0.50788172276257
                    ],
                    [
                        121.95432760648,
                        0.50719349857384
                    ],
                    [
                        121.9536393823,
                        0.5068942706657
                    ],
                    [
                        121.95328030881,
                        0.50641550601267
                    ],
                    [
                        121.95310077206,
                        0.50608635531371
                    ],
                    [
                        121.95247239345,
                        0.50587689577801
                    ],
                    [
                        121.95157470973,
                        0.5060564325229
                    ],
                    [
                        121.95027480577,
                        0.50641896240566
                    ],
                    [
                        121.94964651171,
                        0.50624966055628
                    ],
                    [
                        121.9493026055,
                        0.50596988366465
                    ],
                    [
                        121.94891540852,
                        0.50518979600613
                    ],
                    [
                        121.94887156782,
                        0.50482198415744
                    ],
                    [
                        121.94906598775,
                        0.50418039778655
                    ],
                    [
                        121.94934417306,
                        0.50381471600768
                    ],
                    [
                        121.9496645092,
                        0.50346110983378
                    ],
                    [
                        121.94947637402,
                        0.50295942367363
                    ],
                    [
                        121.94925943379,
                        0.50255546599764
                    ],
                    [
                        121.94907241635,
                        0.5023796696016
                    ],
                    [
                        121.9484103746,
                        0.50171762785484
                    ],
                    [
                        121.94812610809,
                        0.50108924924774
                    ],
                    [
                        121.94767726623,
                        0.50019530587216
                    ],
                    [
                        121.94746406634,
                        0.49977264645191
                    ],
                    [
                        121.94737109311,
                        0.49965240024344
                    ],
                    [
                        121.94728600687,
                        0.49955749407795
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1066,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003040900444085079,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.949483854722,
                        0.503037970999515
                    ],
                    [
                        121.949547440653,
                        0.502985606115591
                    ],
                    [
                        121.949326760071,
                        0.502596609835006
                    ],
                    [
                        121.949012570767,
                        0.502237536345235
                    ],
                    [
                        121.948717083208,
                        0.501942048785945
                    ],
                    [
                        121.948432816695,
                        0.501669003319765
                    ],
                    [
                        121.947931609949,
                        0.500554379361935
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1067,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0017595548782400145,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.957140348822,
                        0.521939823921971
                    ],
                    [
                        121.958501835804,
                        0.5230544478798
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1068,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0014185984950585973,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.958513056851,
                        0.523075019798485
                    ],
                    [
                        121.957757506383,
                        0.524275671779905
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1069,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005238892347418418,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.958509316502,
                        0.523082500496188
                    ],
                    [
                        121.958797323363,
                        0.522644879680531
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1070,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0051116871819188595,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94657599926,
                        0.51771594157047
                    ],
                    [
                        121.94633448099,
                        0.51804425059284
                    ],
                    [
                        121.94605021448,
                        0.51852301524587
                    ],
                    [
                        121.9456462568,
                        0.51895689571268
                    ],
                    [
                        121.9453171061,
                        0.51927856571393
                    ],
                    [
                        121.94503283959,
                        0.51945810245882
                    ],
                    [
                        121.94459521877,
                        0.51962641815715
                    ],
                    [
                        121.94433900488,
                        0.51969374443648
                    ],
                    [
                        121.94401159283,
                        0.51973806029262
                    ],
                    [
                        121.94368650902,
                        0.51977021582056
                    ],
                    [
                        121.94314513202,
                        0.51990859666403
                    ],
                    [
                        121.94270821278,
                        0.52002289513543
                    ],
                    [
                        121.94235474981,
                        0.52007151967051
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1071,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004353773873792967,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94790262224,
                        0.51350066182515
                    ],
                    [
                        121.94631579808,
                        0.51197974122396
                    ],
                    [
                        121.94469261916,
                        0.51056106405086
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1072,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001597712787263561,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948049430938,
                        0.513389386446808
                    ],
                    [
                        121.94790449242,
                        0.513498791650723
                    ],
                    [
                        121.947559445238,
                        0.513851319530003
                    ],
                    [
                        121.947428533028,
                        0.513997193135222
                    ],
                    [
                        121.947349985703,
                        0.51420291232207
                    ],
                    [
                        121.947338764656,
                        0.514333824531882
                    ],
                    [
                        121.947368687447,
                        0.51470785941706
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1073,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0024113758596696873,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951873937639,
                        0.514046285213902
                    ],
                    [
                        121.951971186709,
                        0.514162236028307
                    ],
                    [
                        121.952797803805,
                        0.515041218008474
                    ],
                    [
                        121.95291375462,
                        0.51526563893958
                    ],
                    [
                        121.953156877295,
                        0.516028670105342
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1074,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020399447311110685,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938749053518,
                        0.504320443112077
                    ],
                    [
                        121.939388653172,
                        0.503879081947568
                    ],
                    [
                        121.940488315734,
                        0.503258184038173
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1075,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020042686456312317,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935536093854,
                        0.500365024201325
                    ],
                    [
                        121.937196808744,
                        0.499242919545793
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1076,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007623578012402291,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935669811326,
                        0.49581395473593
                    ],
                    [
                        121.935789502489,
                        0.495776551247412
                    ],
                    [
                        121.935647369233,
                        0.495155653338018
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1077,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006361806824019008,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93591609597,
                        0.49574918860632
                    ],
                    [
                        121.93578950249,
                        0.4951257305472
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1078,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0010574145476408216,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932701844512,
                        0.493906376821525
                    ],
                    [
                        121.931650806485,
                        0.49402232763593
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1079,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0007964884519074749,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933627580853,
                        0.488511858690054
                    ],
                    [
                        121.933347054689,
                        0.488433311364167
                    ],
                    [
                        121.933070268874,
                        0.488414609619908
                    ],
                    [
                        121.93287016021,
                        0.488343542991724
                    ],
                    [
                        121.932868290036,
                        0.488347283340576
                    ],
                    [
                        121.932860809338,
                        0.488341672817299
                    ],
                    [
                        121.932860809338,
                        0.488343542991724
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1082,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0015890432824933077,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932800963757,
                        0.488384686829094
                    ],
                    [
                        121.932982370676,
                        0.488433311364167
                    ],
                    [
                        121.933113282886,
                        0.488466974503833
                    ],
                    [
                        121.933231103875,
                        0.488485676248092
                    ],
                    [
                        121.933399419573,
                        0.488493156945795
                    ],
                    [
                        121.933629451027,
                        0.48851372886448
                    ],
                    [
                        121.933844521086,
                        0.488509988515628
                    ],
                    [
                        121.933926808761,
                        0.488521209562184
                    ],
                    [
                        121.934048370099,
                        0.488543651655294
                    ],
                    [
                        121.934130657773,
                        0.488569834097257
                    ],
                    [
                        121.934345727832,
                        0.488674563865106
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1083,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.00548858537755752,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.932868290036,
                        0.488343542991725
                    ],
                    [
                        121.9331488162,
                        0.487870388861975
                    ],
                    [
                        121.933578956318,
                        0.487256971650284
                    ],
                    [
                        121.933612619457,
                        0.487096136649658
                    ],
                    [
                        121.933586437015,
                        0.48682683153233
                    ],
                    [
                        121.933519110736,
                        0.48659492990352
                    ],
                    [
                        121.933455524806,
                        0.486460277344856
                    ],
                    [
                        121.932329679801,
                        0.485491526992247
                    ],
                    [
                        121.930878424447,
                        0.484298355708531
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1084,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004033127075883689,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93563086981,
                        0.48598675311731
                    ],
                    [
                        121.93553924561,
                        0.48573955174532
                    ],
                    [
                        121.93563334293,
                        0.48536622530571
                    ],
                    [
                        121.93572685165,
                        0.484765899315
                    ],
                    [
                        121.93569786394,
                        0.48407066197218
                    ],
                    [
                        121.93553235351,
                        0.48199617099026
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2069,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0038530726280912244,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94909513562,
                        0.51499385864135
                    ],
                    [
                        121.94895162776,
                        0.51503272814962
                    ],
                    [
                        121.94883762619,
                        0.5150729379855
                    ],
                    [
                        121.94872633753,
                        0.51511670456214
                    ],
                    [
                        121.94865927778,
                        0.51515691439751
                    ],
                    [
                        121.94856137869,
                        0.51524802995909
                    ],
                    [
                        121.94841228245,
                        0.51538845739757
                    ],
                    [
                        121.94787633421,
                        0.51593330879958
                    ],
                    [
                        121.94781310821,
                        0.51609876311923
                    ],
                    [
                        121.94772017605,
                        0.5163979125314
                    ],
                    [
                        121.94765650035,
                        0.51665029311929
                    ],
                    [
                        121.94757477331,
                        0.51678945123447
                    ],
                    [
                        121.94739029112,
                        0.51698233475402
                    ],
                    [
                        121.94692884377,
                        0.51743156409378
                    ],
                    [
                        121.94657004476,
                        0.51771935307441
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1085,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005333014388758777,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937359981463,
                        0.483337553597231
                    ],
                    [
                        121.937318837626,
                        0.483017753770405
                    ],
                    [
                        121.937294525359,
                        0.482808294234705
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1086,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0025276137821037686,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937327253411,
                        0.48302897481696
                    ],
                    [
                        121.937734483892,
                        0.482926115223536
                    ],
                    [
                        121.938194079257,
                        0.482766215310123
                    ],
                    [
                        121.93900854022,
                        0.482475403186898
                    ],
                    [
                        121.939679932839,
                        0.482127550743683
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1087,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006753151261532545,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93879721051,
                        0.48326087644577
                    ],
                    [
                        121.938757936847,
                        0.48302897481696
                    ],
                    [
                        121.938726143882,
                        0.48286065911863
                    ],
                    [
                        121.938711182486,
                        0.48279707318815
                    ],
                    [
                        121.938651336905,
                        0.482602575047858
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1089,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 4.618990105766204e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935338790453,
                        0.476891997438413
                    ],
                    [
                        121.935321958883,
                        0.476848983426617
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1090,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 9.762597104580137e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.935324764144,
                        0.47684991851383
                    ],
                    [
                        121.935296711528,
                        0.476756409792536
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1091,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004882695574841806,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933532435729,
                        0.472667974725744
                    ],
                    [
                        121.934014940731,
                        0.472593167748708
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1092,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007049441349592297,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933483811194,
                        0.47236500646875
                    ],
                    [
                        121.934175775732,
                        0.472230353910086
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1093,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000802529305546287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933416484915,
                        0.47206951890946
                    ],
                    [
                        121.934201958174,
                        0.471904943559982
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1094,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003368791383668901,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941833204918,
                        0.474671399079475
                    ],
                    [
                        121.940488549506,
                        0.475261439110843
                    ],
                    [
                        121.941023419392,
                        0.476217098242471
                    ],
                    [
                        121.941158071951,
                        0.476462091092262
                    ],
                    [
                        121.94068865817,
                        0.476698668157137
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1095,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00011726491294320376,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.940716710786,
                        0.476749162866636
                    ],
                    [
                        121.940770945844,
                        0.476720175163035
                    ],
                    [
                        121.940739152879,
                        0.476674355889601
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1096,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.004210630972676434,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94077001076,
                        0.47672298042467
                    ],
                    [
                        121.94133013487,
                        0.47646211784058
                    ],
                    [
                        121.94142669439,
                        0.47663913751239
                    ],
                    [
                        121.94150447845,
                        0.47690198489547
                    ],
                    [
                        121.94161847234,
                        0.47741158693609
                    ],
                    [
                        121.94173011931,
                        0.47782003424512
                    ],
                    [
                        121.94198797345,
                        0.47871656378943
                    ],
                    [
                        121.94205415697,
                        0.47898486123754
                    ],
                    [
                        121.9423105493,
                        0.47991221179687
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1098,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00017669189823132478,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.946565681303,
                        0.479399667571725
                    ],
                    [
                        121.94673773735,
                        0.479359458821568
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1099,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00014111453230172008,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.961982931726,
                        0.461721843811028
                    ],
                    [
                        121.962026880826,
                        0.461657322793335
                    ],
                    [
                        121.962078310622,
                        0.46169379119464
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1100,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.007989707134331834,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9621655345,
                        0.46864106532311
                    ],
                    [
                        121.96223392945,
                        0.46827897077453
                    ],
                    [
                        121.96229244559,
                        0.46788313345711
                    ],
                    [
                        121.96231862804,
                        0.46762504938634
                    ],
                    [
                        121.96230769609,
                        0.46740595054484
                    ],
                    [
                        121.96223259031,
                        0.46719674646516
                    ],
                    [
                        121.96209445321,
                        0.46705057810146
                    ],
                    [
                        121.96254774771,
                        0.46604210516347
                    ],
                    [
                        121.96276634932,
                        0.46562233645703
                    ],
                    [
                        121.96297318909,
                        0.46514893844647
                    ],
                    [
                        121.96321631176,
                        0.46465147204918
                    ],
                    [
                        121.96353798176,
                        0.46398194960471
                    ],
                    [
                        121.96355357766,
                        0.46346725235002
                    ],
                    [
                        121.96335096432,
                        0.46278129762329
                    ],
                    [
                        121.96327241699,
                        0.46261111175054
                    ],
                    [
                        121.96321257141,
                        0.46253256442465
                    ],
                    [
                        121.96307043816,
                        0.46241100308697
                    ],
                    [
                        121.96207924571,
                        0.46169379119464
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1101,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006820080713753076,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96300077416,
                        0.4661770668371
                    ],
                    [
                        121.9630924127,
                        0.4659601266037
                    ],
                    [
                        121.96266441909,
                        0.4658328862827
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1102,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 1.0561208788016658e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.958355494656,
                        0.466873005495332
                    ],
                    [
                        121.958354559569,
                        0.466883525226477
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1103,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006361672589453375,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.956385733442,
                        0.473354796283653
                    ],
                    [
                        121.955906968789,
                        0.472935877212254
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1104,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1105,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1106,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1107,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1108,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0028354068129255346,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92283093929,
                        0.4823413141943
                    ],
                    [
                        121.92175758377,
                        0.48169717685393
                    ],
                    [
                        121.92097959121,
                        0.4812109315032
                    ],
                    [
                        121.92043350028,
                        0.48082941592032
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1110,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006243806362183577,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914510657872,
                        0.487249724724387
                    ],
                    [
                        121.91494079799,
                        0.487702306935452
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1111,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1112,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1115,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1116,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1117,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1118,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1119,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1120,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1121,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1122,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1123,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1125,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1126,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1127,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1128,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2130,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.010631795005447715,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64670825005,
                        0.55206383358228
                    ],
                    [
                        121.64635553956,
                        0.5521885505106
                    ],
                    [
                        121.64617180824,
                        0.5522529205371
                    ],
                    [
                        121.64607256651,
                        0.55229583388772
                    ],
                    [
                        121.64585262537,
                        0.55249028500378
                    ],
                    [
                        121.64562195539,
                        0.55270351070307
                    ],
                    [
                        121.64549052715,
                        0.55279738365001
                    ],
                    [
                        121.6453269124,
                        0.55286845888029
                    ],
                    [
                        121.64512842894,
                        0.5529060080582
                    ],
                    [
                        121.64483070374,
                        0.552923441605
                    ],
                    [
                        121.64442166686,
                        0.55295562661436
                    ],
                    [
                        121.64370954037,
                        0.55293148785736
                    ],
                    [
                        121.64327502251,
                        0.552901984932
                    ],
                    [
                        121.64286196232,
                        0.552901984932
                    ],
                    [
                        121.64233893156,
                        0.55291807743676
                    ],
                    [
                        121.64182394743,
                        0.55297708328716
                    ],
                    [
                        121.64142161608,
                        0.55306022789355
                    ],
                    [
                        121.64099782705,
                        0.55317287542295
                    ],
                    [
                        121.64032995701,
                        0.55338476005574
                    ],
                    [
                        121.639790833,
                        0.55354568508826
                    ],
                    [
                        121.63948506117,
                        0.55365296844085
                    ],
                    [
                        121.63913905621,
                        0.55381657554981
                    ],
                    [
                        121.63871258497,
                        0.55408478391538
                    ],
                    [
                        121.6384229064,
                        0.55427521184756
                    ],
                    [
                        121.63822442293,
                        0.55445491143992
                    ],
                    [
                        121.63813322783,
                        0.55458365144304
                    ],
                    [
                        121.63783818483,
                        0.55491354768824
                    ],
                    [
                        121.63762629032,
                        0.55515761725619
                    ],
                    [
                        121.63743853569,
                        0.55533731682174
                    ],
                    [
                        121.63728296757,
                        0.55545801055674
                    ],
                    [
                        121.63713946939,
                        0.55555992970882
                    ],
                    [
                        121.63713946939,
                        0.55555992970882
                    ],
                    [
                        121.63713946939,
                        0.55555992970882
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2126,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.01809407999800928,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64964929223,
                        0.56746702477719
                    ],
                    [
                        121.64956346154,
                        0.56724441234343
                    ],
                    [
                        121.64954066277,
                        0.56713712923977
                    ],
                    [
                        121.649492383,
                        0.56693329133732
                    ],
                    [
                        121.64944812655,
                        0.56676834355575
                    ],
                    [
                        121.64942666888,
                        0.56667849394917
                    ],
                    [
                        121.6494011879,
                        0.56655377732878
                    ],
                    [
                        121.64937838912,
                        0.56639419369233
                    ],
                    [
                        121.64934083819,
                        0.5662091303101
                    ],
                    [
                        121.64931535721,
                        0.56608441367961
                    ],
                    [
                        121.64927244186,
                        0.56595701496828
                    ],
                    [
                        121.64923489094,
                        0.56583229833236
                    ],
                    [
                        121.64918661118,
                        0.56568076091093
                    ],
                    [
                        121.64914235473,
                        0.56553324660307
                    ],
                    [
                        121.64909541607,
                        0.56539377852675
                    ],
                    [
                        121.64908871055,
                        0.56535086527182
                    ],
                    [
                        121.64908602834,
                        0.56527979019265
                    ],
                    [
                        121.64909407496,
                        0.56511618340333
                    ],
                    [
                        121.64909809828,
                        0.56493246101966
                    ],
                    [
                        121.64911150932,
                        0.56467632250426
                    ],
                    [
                        121.64911955595,
                        0.56447248451536
                    ],
                    [
                        121.64912223816,
                        0.56433033433465
                    ],
                    [
                        121.64912894368,
                        0.56414392984717
                    ],
                    [
                        121.649132967,
                        0.56403932876523
                    ],
                    [
                        121.64918258786,
                        0.56381135204168
                    ],
                    [
                        121.64921343327,
                        0.56370406887457
                    ],
                    [
                        121.64924830198,
                        0.56356996491289
                    ],
                    [
                        121.64927512407,
                        0.56341038119449
                    ],
                    [
                        121.64930060506,
                        0.56326957202757
                    ],
                    [
                        121.64933949709,
                        0.56315156053266
                    ],
                    [
                        121.64937973022,
                        0.56304025423413
                    ],
                    [
                        121.64942130446,
                        0.56295442768924
                    ],
                    [
                        121.64952456951,
                        0.56270767636565
                    ],
                    [
                        121.64958357811,
                        0.56254004638444
                    ],
                    [
                        121.64962783456,
                        0.56244483255296
                    ],
                    [
                        121.64966672659,
                        0.56236839327868
                    ],
                    [
                        121.64968416095,
                        0.56230670544256
                    ],
                    [
                        121.6496989131,
                        0.56223697136617
                    ],
                    [
                        121.64970695972,
                        0.56218735288823
                    ],
                    [
                        121.64972037077,
                        0.56210689049067
                    ],
                    [
                        121.64973378181,
                        0.5620009483322
                    ],
                    [
                        121.64973646402,
                        0.56190841657196
                    ],
                    [
                        121.64974048734,
                        0.56180783857003
                    ],
                    [
                        121.64974316955,
                        0.56170726056638
                    ],
                    [
                        121.64974987507,
                        0.56156645135835
                    ],
                    [
                        121.64974719286,
                        0.56148732999236
                    ],
                    [
                        121.64974182844,
                        0.56138004678251
                    ],
                    [
                        121.64974719286,
                        0.56124057860678
                    ],
                    [
                        121.64973914623,
                        0.56112659019145
                    ],
                    [
                        121.6497606039,
                        0.56104076361844
                    ],
                    [
                        121.64977803826,
                        0.56096164224532
                    ],
                    [
                        121.64983838797,
                        0.5608463127843
                    ],
                    [
                        121.64987057447,
                        0.56073902956272
                    ],
                    [
                        121.64991617203,
                        0.56067197754821
                    ],
                    [
                        121.64996579289,
                        0.56058480992822
                    ],
                    [
                        121.65005162358,
                        0.56045472901597
                    ],
                    [
                        121.65013879538,
                        0.56033001226235
                    ],
                    [
                        121.65023267269,
                        0.56021736486968
                    ],
                    [
                        121.65031313896,
                        0.56013287932377
                    ],
                    [
                        121.65041908622,
                        0.5600443706553
                    ],
                    [
                        121.65055453777,
                        0.5599598851069
                    ],
                    [
                        121.6506229341,
                        0.55992904117623
                    ],
                    [
                        121.65072754025,
                        0.55987674059776
                    ],
                    [
                        121.650801301,
                        0.5598271220998
                    ],
                    [
                        121.65087372065,
                        0.55977482152042
                    ],
                    [
                        121.65093943477,
                        0.55970776949489
                    ],
                    [
                        121.65100112557,
                        0.55961121457677
                    ],
                    [
                        121.65104806423,
                        0.55953745734659
                    ],
                    [
                        121.65110841393,
                        0.55937250935574
                    ],
                    [
                        121.65114060044,
                        0.55928668275704
                    ],
                    [
                        121.65119424462,
                        0.5591726943037
                    ],
                    [
                        121.65126264095,
                        0.55904127231945
                    ],
                    [
                        121.65129616857,
                        0.55895008155315
                    ],
                    [
                        121.651365906,
                        0.55879854395308
                    ],
                    [
                        121.65140748024,
                        0.55867382716422
                    ],
                    [
                        121.65147989988,
                        0.5584860814556
                    ],
                    [
                        121.65153622627,
                        0.5583653877826
                    ],
                    [
                        121.6516046226,
                        0.55822860161689
                    ],
                    [
                        121.65165826678,
                        0.55811059002037
                    ],
                    [
                        121.65172800422,
                        0.55797246280782
                    ],
                    [
                        121.65181517601,
                        0.55783031246915
                    ],
                    [
                        121.65185138583,
                        0.55774716792988
                    ],
                    [
                        121.65189027786,
                        0.55764122569263
                    ],
                    [
                        121.65191173553,
                        0.55744945682793
                    ],
                    [
                        121.65194660425,
                        0.55721745672456
                    ],
                    [
                        121.65199354291,
                        0.55700423118797
                    ],
                    [
                        121.65207132697,
                        0.55663142174066
                    ],
                    [
                        121.65209680796,
                        0.55647854303963
                    ],
                    [
                        121.65211290121,
                        0.5562961614262
                    ],
                    [
                        121.65210485458,
                        0.55619021916286
                    ],
                    [
                        121.65206328034,
                        0.55605879711205
                    ],
                    [
                        121.65205255151,
                        0.55595956005132
                    ],
                    [
                        121.65204316378,
                        0.55582545591256
                    ],
                    [
                        121.65200293064,
                        0.55571817259936
                    ],
                    [
                        121.6519318521,
                        0.55555992970882
                    ],
                    [
                        121.65183529258,
                        0.55539632264804
                    ],
                    [
                        121.65174677968,
                        0.55524344391505
                    ],
                    [
                        121.65171325207,
                        0.55517505079635
                    ],
                    [
                        121.65158048272,
                        0.55495511997799
                    ],
                    [
                        121.65149196982,
                        0.55478346665066
                    ],
                    [
                        121.6513954103,
                        0.55458633352641
                    ],
                    [
                        121.65131226182,
                        0.55442004435527
                    ],
                    [
                        121.65120899677,
                        0.55420413663415
                    ],
                    [
                        121.6511271894,
                        0.55398286473789
                    ],
                    [
                        121.65108561516,
                        0.5538407143032
                    ],
                    [
                        121.65101855993,
                        0.55360066780671
                    ],
                    [
                        121.6509783268,
                        0.55350143070475
                    ],
                    [
                        121.6509206593,
                        0.55335257504871
                    ],
                    [
                        121.65085360408,
                        0.55314203145678
                    ],
                    [
                        121.65082007647,
                        0.55301329142235
                    ],
                    [
                        121.6507717967,
                        0.55288857451134
                    ],
                    [
                        121.65068998933,
                        0.5527249673768
                    ],
                    [
                        121.6505625844,
                        0.55248357979299
                    ],
                    [
                        121.65045529604,
                        0.55227840033906
                    ],
                    [
                        121.65036678314,
                        0.55210540589201
                    ],
                    [
                        121.6503238678,
                        0.55202494335677
                    ],
                    [
                        121.65028765798,
                        0.55194716290503
                    ],
                    [
                        121.6502058506,
                        0.55177550949065
                    ],
                    [
                        121.650146842,
                        0.55166688506181
                    ],
                    [
                        121.65009185672,
                        0.55157703522411
                    ],
                    [
                        121.65006235242,
                        0.55150864206317
                    ],
                    [
                        121.65003955364,
                        0.55145500036776
                    ],
                    [
                        121.65001004934,
                        0.55138392512059
                    ],
                    [
                        121.64998456836,
                        0.55131821404227
                    ],
                    [
                        121.64994433522,
                        0.55124177462371
                    ],
                    [
                        121.64981156588,
                        0.55104866450931
                    ],
                    [
                        121.64977535605,
                        0.55099770489475
                    ],
                    [
                        121.64974182844,
                        0.55095613257727
                    ],
                    [
                        121.64971634746,
                        0.55096686091729
                    ],
                    [
                        121.64969757199,
                        0.55097893029979
                    ],
                    [
                        121.64964392781,
                        0.55102050261709
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1132,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1133,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1136,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1137,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1138,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1139,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1140,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1141,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1142,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1143,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1144,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1146,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1147,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1148,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1149,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1151,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002348340206389875,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92042633891,
                        0.480854081835
                    ],
                    [
                        121.9200052321,
                        0.48049736058968
                    ],
                    [
                        121.9193862026,
                        0.47993921289359
                    ],
                    [
                        121.9187204205,
                        0.47924350800716
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1153,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1154,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1157,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1158,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1159,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1160,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1161,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1162,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1163,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1164,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1165,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1167,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1168,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1169,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1170,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1174,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1175,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1178,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1179,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1180,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1181,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1182,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1183,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1184,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1185,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1186,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1188,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1189,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1190,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1191,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2180,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0006081307636055194,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95229500532,
                        0.45891053661199
                    ],
                    [
                        121.95229098201,
                        0.45876159622381
                    ],
                    [
                        121.95230036974,
                        0.45857374347757
                    ],
                    [
                        121.95229902864,
                        0.45835905461867
                    ],
                    [
                        121.95229902864,
                        0.45830269879214
                    ],
                    [
                        121.95229902864,
                        0.45830269879214
                    ],
                    [
                        121.95229902864,
                        0.45830269879214
                    ],
                    [
                        121.95229902864,
                        0.45830269879214
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1195,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1196,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1199,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1200,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1201,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1202,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1203,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1204,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1205,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1206,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1207,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1209,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1210,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1211,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1212,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1216,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1217,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1220,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1221,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1222,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1223,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1224,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1225,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1226,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1227,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1228,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1230,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1231,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1232,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1233,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2183,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0003108180676247477,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94986223664,
                        0.46367109356312
                    ],
                    [
                        121.95017108182,
                        0.46367796169299
                    ],
                    [
                        121.95017242331,
                        0.46367930230128
                    ],
                    [
                        121.95017242331,
                        0.46367930230128
                    ],
                    [
                        121.95017242331,
                        0.46367930230128
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1237,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1238,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2178,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00983392635367322,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.90614894032,
                        0.49766209035794
                    ],
                    [
                        121.90625488758,
                        0.49785933461825
                    ],
                    [
                        121.90638765693,
                        0.49813842852747
                    ],
                    [
                        121.9067363441,
                        0.4988603156032
                    ],
                    [
                        121.90702870488,
                        0.4994869349895
                    ],
                    [
                        121.90732777119,
                        0.5001229468965
                    ],
                    [
                        121.90765097737,
                        0.50078311108924
                    ],
                    [
                        121.90797686577,
                        0.50145669318485
                    ],
                    [
                        121.90833359957,
                        0.50219468145704
                    ],
                    [
                        121.90858975053,
                        0.50271664038471
                    ],
                    [
                        121.9089089334,
                        0.50337004773048
                    ],
                    [
                        121.90918922424,
                        0.50393360225346
                    ],
                    [
                        121.90932735801,
                        0.50427307674021
                    ],
                    [
                        121.90936759114,
                        0.50433345757592
                    ],
                    [
                        121.90922543406,
                        0.50441262355965
                    ],
                    [
                        121.90902158618,
                        0.50449849852399
                    ],
                    [
                        121.90880030394,
                        0.50457900630202
                    ],
                    [
                        121.90868228674,
                        0.50460986761668
                    ],
                    [
                        121.9085817039,
                        0.50465012150512
                    ],
                    [
                        121.90851733088,
                        0.50466085587534
                    ],
                    [
                        121.90838187933,
                        0.50464207072746
                    ],
                    [
                        121.9081954658,
                        0.50462060198696
                    ],
                    [
                        121.90799564123,
                        0.50462462737581
                    ],
                    [
                        121.90776899457,
                        0.50462999456094
                    ],
                    [
                        121.90760806203,
                        0.50466085587534
                    ],
                    [
                        121.90745517612,
                        0.50474270544762
                    ],
                    [
                        121.90734788775,
                        0.50478295933526
                    ],
                    [
                        121.90706223249,
                        0.50489567021928
                    ],
                    [
                        121.90706223249,
                        0.50489567021928
                    ],
                    [
                        121.90706223249,
                        0.50489567021928
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1241,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1242,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1243,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1244,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1245,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1246,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1247,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1248,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1249,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1251,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1252,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1253,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1254,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2125,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.020597699387340983,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64947092533,
                        0.566752251089
                    ],
                    [
                        121.64934754372,
                        0.56610318822631
                    ],
                    [
                        121.64911687374,
                        0.56534147799727
                    ],
                    [
                        121.64915978909,
                        0.56403798772571
                    ],
                    [
                        121.64932608604,
                        0.56328164138487
                    ],
                    [
                        121.64954066277,
                        0.56273583820202
                    ],
                    [
                        121.64968550205,
                        0.56238314471764
                    ],
                    [
                        121.64972707629,
                        0.56223026616647
                    ],
                    [
                        121.64976328611,
                        0.56194730673223
                    ],
                    [
                        121.64977401495,
                        0.56113061331203
                    ],
                    [
                        121.64980620146,
                        0.56097505264762
                    ],
                    [
                        121.64985850453,
                        0.56085301798558
                    ],
                    [
                        121.64991617203,
                        0.56072830124044
                    ],
                    [
                        121.65011867881,
                        0.56041583884577
                    ],
                    [
                        121.65028363466,
                        0.56021065966767
                    ],
                    [
                        121.65048345923,
                        0.56006180418103
                    ],
                    [
                        121.65089249611,
                        0.5598043244114
                    ],
                    [
                        121.65100514889,
                        0.5596729024413
                    ],
                    [
                        121.65117010474,
                        0.55932557293473
                    ],
                    [
                        121.65143698454,
                        0.55869796589776
                    ],
                    [
                        121.65155231953,
                        0.55840561900722
                    ],
                    [
                        121.65179371834,
                        0.55794027782578
                    ],
                    [
                        121.6519023478,
                        0.5577149829466
                    ],
                    [
                        121.6519318521,
                        0.55754332969954
                    ],
                    [
                        121.65197074413,
                        0.5572979191892
                    ],
                    [
                        121.65204852819,
                        0.55690365310198
                    ],
                    [
                        121.65212631226,
                        0.55650134074091
                    ],
                    [
                        121.6521383822,
                        0.55630957183914
                    ],
                    [
                        121.65208876133,
                        0.55603331732634
                    ],
                    [
                        121.65206059814,
                        0.55579595300163
                    ],
                    [
                        121.65191709995,
                        0.55548080826196
                    ],
                    [
                        121.65155902505,
                        0.55485856498198
                    ],
                    [
                        121.651276052,
                        0.55426582455528
                    ],
                    [
                        121.65117412806,
                        0.55402443703419
                    ],
                    [
                        121.65109500289,
                        0.5537776853358
                    ],
                    [
                        121.65106549859,
                        0.55365296844085
                    ],
                    [
                        121.65101721883,
                        0.55351886424982
                    ],
                    [
                        121.6509501636,
                        0.55333916462907
                    ],
                    [
                        121.6508884728,
                        0.5531621470869
                    ],
                    [
                        121.65088042617,
                        0.5531339852047
                    ],
                    [
                        121.65087103844,
                        0.55307363831383
                    ],
                    [
                        121.65085360408,
                        0.55301463246438
                    ],
                    [
                        121.65082544088,
                        0.55293819306765
                    ],
                    [
                        121.65079459548,
                        0.55288052825892
                    ],
                    [
                        121.65074765682,
                        0.55277995010284
                    ],
                    [
                        121.65063500404,
                        0.55255599606917
                    ],
                    [
                        121.65055721998,
                        0.55241786872681
                    ],
                    [
                        121.65042310953,
                        0.55214966028593
                    ],
                    [
                        121.65035605431,
                        0.55202360231452
                    ],
                    [
                        121.65028765798,
                        0.55187608766374
                    ],
                    [
                        121.65022596717,
                        0.55174600655956
                    ],
                    [
                        121.65016025305,
                        0.55162799483373
                    ],
                    [
                        121.65011331439,
                        0.55154485020729
                    ],
                    [
                        121.65009856224,
                        0.55150998310554
                    ],
                    [
                        121.65006905794,
                        0.55142817951987
                    ],
                    [
                        121.65003418922,
                        0.55135576322996
                    ],
                    [
                        121.65000066161,
                        0.55127664172703
                    ],
                    [
                        121.64983302355,
                        0.55101379740465
                    ],
                    [
                        121.64971768856,
                        0.55085823647371
                    ],
                    [
                        121.64959833026,
                        0.55096820195979
                    ],
                    [
                        121.64944544435,
                        0.55111839871801
                    ],
                    [
                        121.6491651535,
                        0.55124982087833
                    ],
                    [
                        121.64871990681,
                        0.55141074596868
                    ],
                    [
                        121.6479729116,
                        0.55167493131587
                    ],
                    [
                        121.64670825005,
                        0.55206517462454
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1258,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1259,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2179,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00983392635367322,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.90614894032,
                        0.49766209035794
                    ],
                    [
                        121.90625488758,
                        0.49785933461825
                    ],
                    [
                        121.90638765693,
                        0.49813842852747
                    ],
                    [
                        121.9067363441,
                        0.4988603156032
                    ],
                    [
                        121.90702870488,
                        0.4994869349895
                    ],
                    [
                        121.90732777119,
                        0.5001229468965
                    ],
                    [
                        121.90765097737,
                        0.50078311108924
                    ],
                    [
                        121.90797686577,
                        0.50145669318485
                    ],
                    [
                        121.90833359957,
                        0.50219468145704
                    ],
                    [
                        121.90858975053,
                        0.50271664038471
                    ],
                    [
                        121.9089089334,
                        0.50337004773048
                    ],
                    [
                        121.90918922424,
                        0.50393360225346
                    ],
                    [
                        121.90932735801,
                        0.50427307674021
                    ],
                    [
                        121.90936759114,
                        0.50433345757592
                    ],
                    [
                        121.90922543406,
                        0.50441262355965
                    ],
                    [
                        121.90902158618,
                        0.50449849852399
                    ],
                    [
                        121.90880030394,
                        0.50457900630202
                    ],
                    [
                        121.90868228674,
                        0.50460986761668
                    ],
                    [
                        121.9085817039,
                        0.50465012150512
                    ],
                    [
                        121.90851733088,
                        0.50466085587534
                    ],
                    [
                        121.90838187933,
                        0.50464207072746
                    ],
                    [
                        121.9081954658,
                        0.50462060198696
                    ],
                    [
                        121.90799564123,
                        0.50462462737581
                    ],
                    [
                        121.90776899457,
                        0.50462999456094
                    ],
                    [
                        121.90760806203,
                        0.50466085587534
                    ],
                    [
                        121.90745517612,
                        0.50474270544762
                    ],
                    [
                        121.90734788775,
                        0.50478295933526
                    ],
                    [
                        121.90706223249,
                        0.50489567021928
                    ],
                    [
                        121.90706223249,
                        0.50489567021928
                    ],
                    [
                        121.90706223249,
                        0.50489567021928
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1262,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1263,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1264,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1265,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1266,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1267,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1268,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1269,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1270,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1272,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1273,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1274,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1275,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1279,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1280,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2193,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005460587360649569,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93464338779,
                        0.49590072774127
                    ],
                    [
                        121.93452805281,
                        0.49536698811784
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1283,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1284,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1285,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1286,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1287,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1288,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1289,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1290,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1291,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1294,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1295,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1296,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1297,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1300,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005199850518086101,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.91451877356,
                        0.48725628998455
                    ],
                    [
                        121.91414996982,
                        0.48688972722667
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1301,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1302,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2195,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005409987171501538,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93490624428,
                        0.49582026448421
                    ],
                    [
                        121.93478554487,
                        0.4952972532895
                    ],
                    [
                        121.93478688598,
                        0.49529323012629
                    ],
                    [
                        121.93478688598,
                        0.49529323012629
                    ],
                    [
                        121.93478688598,
                        0.49529323012629
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2196,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005312295177190161,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93496793509,
                        0.49580283077839
                    ],
                    [
                        121.93484857678,
                        0.49528518379991
                    ],
                    [
                        121.93484857678,
                        0.49528518379991
                    ],
                    [
                        121.93484857678,
                        0.49528518379991
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2197,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000520772139829507,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93516775966,
                        0.49574114228048
                    ],
                    [
                        121.9350604713,
                        0.49523154162366
                    ],
                    [
                        121.9350604713,
                        0.49523154162366
                    ],
                    [
                        121.9350604713,
                        0.49523154162366
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1305,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1306,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1307,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1308,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1309,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1310,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1311,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1312,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1313,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1316,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1317,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1318,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1319,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1323,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1324,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2198,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000509777692465418,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93522408605,
                        0.49572370857446
                    ],
                    [
                        121.93513289094,
                        0.49522215424276
                    ],
                    [
                        121.93513289094,
                        0.49522215424276
                    ],
                    [
                        121.93513289094,
                        0.49522215424276
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2199,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004899172887663162,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93546280265,
                        0.4956512916412
                    ],
                    [
                        121.93535283208,
                        0.49517387628371
                    ],
                    [
                        121.93535283208,
                        0.49517387628371
                    ],
                    [
                        121.93535283208,
                        0.49517387628371
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2200,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00011070785945736817,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96269643595,
                        0.46548437375744
                    ],
                    [
                        121.96279570674,
                        0.4655179207691
                    ],
                    [
                        121.96279436524,
                        0.46551657888864
                    ],
                    [
                        121.96279034075,
                        0.46551657888864
                    ],
                    [
                        121.96279034075,
                        0.46551657888864
                    ],
                    [
                        121.96279034075,
                        0.46551657888864
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1327,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1328,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1329,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1330,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1331,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1332,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1333,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1334,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1335,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1338,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.0007220423521051396,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931346903141,
                        0.482342387030854
                    ],
                    [
                        121.931331941746,
                        0.483064274359246
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1339,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.996235361408997e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.954358464364,
                        0.467530138034228
                    ],
                    [
                        121.954362204713,
                        0.467589983615856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1340,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "Pipa 75",
                "panjang": 0.0052982103075993135,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923252788225,
                        0.485312224019168
                    ],
                    [
                        121.923542665261,
                        0.485489890589627
                    ],
                    [
                        121.923834412472,
                        0.485703090474178
                    ],
                    [
                        121.924195356136,
                        0.485955564021673
                    ],
                    [
                        121.924479622649,
                        0.486090216580337
                    ],
                    [
                        121.924984569744,
                        0.486368872569794
                    ],
                    [
                        121.924651678696,
                        0.486900002106746
                    ],
                    [
                        121.924333749044,
                        0.487326401875848
                    ],
                    [
                        121.923937272065,
                        0.487547082458103
                    ],
                    [
                        121.922572044734,
                        0.486615735594011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1341,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029791590988431963,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.923456637238,
                        0.481699047028354
                    ],
                    [
                        121.923688538867,
                        0.481886064470943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1342,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0017395067007299815,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.924383308666,
                        0.483125990115306
                    ],
                    [
                        121.923661421337,
                        0.482793099067498
                    ],
                    [
                        121.923313568894,
                        0.482624783369168
                    ],
                    [
                        121.922831063892,
                        0.482344257205285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1345,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00029422834012856486,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.91515445709,
                        0.48791108825689
                    ],
                    [
                        121.91494658589,
                        0.48770285790285
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1346,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032316700600612953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.914703285837,
                        0.487468535132216
                    ],
                    [
                        121.914445201767,
                        0.487663033272508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1347,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0005760622971484688,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.918873774807,
                        0.478572115388272
                    ],
                    [
                        121.919330097367,
                        0.478923708180338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1348,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.005273093500007145,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89238384366,
                        0.49879874837167
                    ],
                    [
                        121.89248748383,
                        0.49874849218195
                    ],
                    [
                        121.89248748383,
                        0.49872792026327
                    ],
                    [
                        121.89247252244,
                        0.49869612729803
                    ],
                    [
                        121.89221256819,
                        0.49831648188957
                    ],
                    [
                        121.88994965714,
                        0.49475847504432
                    ],
                    [
                        121.88972149586,
                        0.49439940155455
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1349,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.019103286181028772,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89949689758,
                        0.50003330201254
                    ],
                    [
                        121.89813728077,
                        0.50056723681113
                    ],
                    [
                        121.89785675461,
                        0.50062147186948
                    ],
                    [
                        121.89324080944,
                        0.50086263562278
                    ],
                    [
                        121.89313620329,
                        0.50085599506617
                    ],
                    [
                        121.89302220941,
                        0.50078622905671
                    ],
                    [
                        121.89276605844,
                        0.49965032930865
                    ],
                    [
                        121.89249247313,
                        0.49897037944012
                    ],
                    [
                        121.88970653446,
                        0.49454153481092
                    ],
                    [
                        121.88916044353,
                        0.49343439155079
                    ],
                    [
                        121.88881633143,
                        0.49164650479965
                    ],
                    [
                        121.88836374922,
                        0.48937985339547
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1350,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000865759473579107,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885440666596,
                        0.469793516633147
                    ],
                    [
                        121.88458038636,
                        0.469890765703293
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1351,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008954991964935295,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885365859619,
                        0.469254906398491
                    ],
                    [
                        121.884475656592,
                        0.469352155468637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1352,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008933406478435616,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885343417526,
                        0.46876866104776
                    ],
                    [
                        121.884453214499,
                        0.468843468024796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1353,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008635265880451915,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885291052642,
                        0.468230050813104
                    ],
                    [
                        121.884430772406,
                        0.46830485779014
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1354,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008623593091702287,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885216245665,
                        0.467706401973856
                    ],
                    [
                        121.884355965429,
                        0.467766247555484
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1355,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021603256763754117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.885964315435,
                        0.469875804307886
                    ],
                    [
                        121.887370686604,
                        0.47104279314964
                    ],
                    [
                        121.887886854745,
                        0.47163376826822
                    ],
                    [
                        121.888051430095,
                        0.472868083389306
                    ],
                    [
                        121.888014026606,
                        0.473915381067804
                    ],
                    [
                        121.888941633121,
                        0.476219435960497
                    ],
                    [
                        121.889195976843,
                        0.476787968985967
                    ],
                    [
                        121.889181015448,
                        0.478104571781792
                    ],
                    [
                        121.889166054053,
                        0.478987294110811
                    ],
                    [
                        121.889136131262,
                        0.479682998997241
                    ],
                    [
                        121.889382994286,
                        0.480199167138786
                    ],
                    [
                        121.890430291964,
                        0.482106745053192
                    ],
                    [
                        121.890587386616,
                        0.482518183426887
                    ],
                    [
                        121.890295639406,
                        0.484261185991815
                    ],
                    [
                        121.890018853591,
                        0.484515529713735
                    ],
                    [
                        121.888380580794,
                        0.486340819953402
                    ],
                    [
                        121.888395542189,
                        0.487440482515824
                    ],
                    [
                        121.888343177305,
                        0.489250811360083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1356,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.0010178285788759157,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.898197126355,
                        0.500604640299647
                    ],
                    [
                        121.898552459496,
                        0.50155842925685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1357,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.017363422377213764,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.906137886968,
                        0.497636673485765
                    ],
                    [
                        121.907574180927,
                        0.500593419253093
                    ],
                    [
                        121.909347106282,
                        0.504318806709461
                    ],
                    [
                        121.908643920698,
                        0.5046105539199
                    ],
                    [
                        121.907925773719,
                        0.504640476710714
                    ],
                    [
                        121.907312356507,
                        0.504797571362488
                    ],
                    [
                        121.90495593673,
                        0.505695255086914
                    ],
                    [
                        121.906190251851,
                        0.509368277659358
                    ],
                    [
                        121.906280020224,
                        0.510221077197563
                    ],
                    [
                        121.906440855225,
                        0.510479161268336
                    ],
                    [
                        121.906669016504,
                        0.510639996268962
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1358,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 7.832436971550339e-5,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.933560254574,
                        0.479005060767857
                    ],
                    [
                        121.933625710679,
                        0.478962046756062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1361,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.0007220423521051396,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931346903141,
                        0.482342387030854
                    ],
                    [
                        121.931331941746,
                        0.483064274359246
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1362,
                "jenis_pipa": "Pipa Pamsimas",
                "keterangan": "",
                "panjang": 0.0037307646728809776,
                "total_panjang_jenis": 0.2956134583708241
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.934683294317,
                        0.480653619524277
                    ],
                    [
                        121.933635996639,
                        0.481371766503818
                    ],
                    [
                        121.933000137334,
                        0.481693436505071
                    ],
                    [
                        121.931945358958,
                        0.482179681855802
                    ],
                    [
                        121.931369345234,
                        0.482291892321355
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1363,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 7.574206424798557e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948959270797,
                        0.46249936882858
                    ],
                    [
                        121.948959270797,
                        0.462575110892828
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1364,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.003826551711365432,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948955062905,
                        0.462584929308564
                    ],
                    [
                        121.948941036596,
                        0.46290753439703
                    ],
                    [
                        121.948924205027,
                        0.463206294761565
                    ],
                    [
                        121.948900360303,
                        0.463555549835599
                    ],
                    [
                        121.94887791821,
                        0.463816439168011
                    ],
                    [
                        121.948852670855,
                        0.464304554693167
                    ],
                    [
                        121.949081393006,
                        0.464313814235171
                    ],
                    [
                        121.949066654919,
                        0.464611018411583
                    ],
                    [
                        121.949788059251,
                        0.464605141669089
                    ],
                    [
                        121.949846983732,
                        0.464044285459361
                    ],
                    [
                        121.95013835424,
                        0.464061329143867
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1365,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 6.465808623708566e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.949788059251,
                        0.464605141669087
                    ],
                    [
                        121.949852701489,
                        0.464606573166148
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1366,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0010451271931293101,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94986363534,
                        0.46461034573157
                    ],
                    [
                        121.95011168129,
                        0.46461117426274
                    ],
                    [
                        121.95013179629,
                        0.46414449245967
                    ],
                    [
                        121.9501613053,
                        0.46381584985831
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1367,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009467916556328725,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95011972871,
                        0.46446232198268
                    ],
                    [
                        121.95106521916,
                        0.46451194302809
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1368,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0019309275236867492,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95012509077,
                        0.46442208745548
                    ],
                    [
                        121.95103436041,
                        0.46447841289878
                    ],
                    [
                        121.95109739311,
                        0.4634604475415
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1369,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0009338782783129292,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95013716346,
                        0.46409889142712
                    ],
                    [
                        121.9510694932,
                        0.46415264916725
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1370,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0009120595437376969,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.950174873256,
                        0.463820942108776
                    ],
                    [
                        121.951085314408,
                        0.463875251592897
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2181,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0003734837934395823,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94984636055,
                        0.46403987345693
                    ],
                    [
                        121.94986224175,
                        0.46381324598458
                    ],
                    [
                        121.94986224175,
                        0.46381324598458
                    ],
                    [
                        121.94986760302,
                        0.46366704369583
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2185,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0008999361902517701,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95202947527,
                        0.45829880415308
                    ],
                    [
                        121.95202679345,
                        0.45865821317717
                    ],
                    [
                        121.9520472289,
                        0.45919834389604
                    ],
                    [
                        121.9520472289,
                        0.45919834389604
                    ],
                    [
                        121.9520472289,
                        0.45919834389604
                    ],
                    [
                        121.9520472289,
                        0.45919834389604
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2182,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0005159074541651973,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95033070271,
                        0.46367797300042
                    ],
                    [
                        121.95017374753,
                        0.46367663239213
                    ],
                    [
                        121.95020057748,
                        0.46331868996827
                    ],
                    [
                        121.95020057748,
                        0.46331868996827
                    ],
                    [
                        121.95020057748,
                        0.46331868996827
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2187,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.004994132323280714,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94706146338,
                        0.46661511490256
                    ],
                    [
                        121.9471017083,
                        0.46620086709964
                    ],
                    [
                        121.94713122124,
                        0.46577723501707
                    ],
                    [
                        121.94715805118,
                        0.46537103081272
                    ],
                    [
                        121.94718085664,
                        0.46509218434867
                    ],
                    [
                        121.94719776633,
                        0.4647884448078
                    ],
                    [
                        121.94721654729,
                        0.46456322264603
                    ],
                    [
                        121.94723935275,
                        0.46403100119951
                    ],
                    [
                        121.94726886569,
                        0.4636489278442
                    ],
                    [
                        121.94729840022,
                        0.46323681244773
                    ],
                    [
                        121.94731718865,
                        0.46290690653861
                    ],
                    [
                        121.94734536009,
                        0.46244841843703
                    ],
                    [
                        121.94736952314,
                        0.46204598348563
                    ],
                    [
                        121.94739501002,
                        0.46163560300782
                    ],
                    [
                        121.94739367951,
                        0.46163826613328
                    ],
                    [
                        121.94739367951,
                        0.46163826613328
                    ],
                    [
                        121.94739367951,
                        0.46163826613328
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1376,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0017300143683203753,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95177386841,
                        0.46418048228609
                    ],
                    [
                        121.95107726947,
                        0.46417130733752
                    ],
                    [
                        121.95105983275,
                        0.46451594766522
                    ],
                    [
                        121.95174805712,
                        0.464507693433
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2186,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0008073740668787438,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95507691829,
                        0.45931540612028
                    ],
                    [
                        121.95507691829,
                        0.45957548428428
                    ],
                    [
                        121.95508630877,
                        0.45971088579891
                    ],
                    [
                        121.95508496727,
                        0.46012245276323
                    ],
                    [
                        121.95508496727,
                        0.46012245276323
                    ],
                    [
                        121.95508496727,
                        0.46012245276323
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1381,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006717767029697166,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951797618599,
                        0.463844642884203
                    ],
                    [
                        121.95112604494,
                        0.463828127461619
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1382,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000677050927584142,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951815674465,
                        0.463477329543845
                    ],
                    [
                        121.951139000623,
                        0.463454735958395
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1383,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006658464459963774,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951820840523,
                        0.463128600332241
                    ],
                    [
                        121.951155345027,
                        0.463106984725437
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1385,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0028955922229076756,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951076401747,
                        0.461884983885913
                    ],
                    [
                        121.951308491798,
                        0.461871497406919
                    ],
                    [
                        121.951314990543,
                        0.46199033701929
                    ],
                    [
                        121.951882972569,
                        0.462016093200734
                    ],
                    [
                        121.95228649329,
                        0.462038724791554
                    ],
                    [
                        121.952398660604,
                        0.462011930455334
                    ],
                    [
                        121.95385470872,
                        0.462009783203967
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1386,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0033252971053951167,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951087858792,
                        0.461818402792723
                    ],
                    [
                        121.951309975868,
                        0.461822347643758
                    ],
                    [
                        121.951310322973,
                        0.461625259601792
                    ],
                    [
                        121.952103880471,
                        0.461663711136578
                    ],
                    [
                        121.95386127207,
                        0.461661176239688
                    ],
                    [
                        121.953852822437,
                        0.462015250130174
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1387,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00037452081487705444,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.952126223865,
                        0.46203596694292
                    ],
                    [
                        121.952102605425,
                        0.461662191595862
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1388,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003389610535040457,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.952685856334,
                        0.461996225155312
                    ],
                    [
                        121.952642047448,
                        0.461660107055086
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1389,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003344296637339457,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.953413758145,
                        0.461996548823014
                    ],
                    [
                        121.953365268389,
                        0.461665653154338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1390,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 3.226050896890064e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.953856839497,
                        0.462001521690983
                    ],
                    [
                        121.953888977245,
                        0.462004333379593
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1391,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00036471098571937415,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951858974086,
                        0.462016809582881
                    ],
                    [
                        121.951858498397,
                        0.46165209890738
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1392,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.002293332767360147,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94962085197,
                        0.46245608668162
                    ],
                    [
                        121.95004731652,
                        0.46245742321947
                    ],
                    [
                        121.95019375635,
                        0.46246247713772
                    ],
                    [
                        121.95108068674,
                        0.46239927462827
                    ],
                    [
                        121.95104318088,
                        0.46186236559525
                    ],
                    [
                        121.95133612149,
                        0.46186334365294
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1393,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0009784721606109304,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95133209818,
                        0.46185931820866
                    ],
                    [
                        121.95133209543,
                        0.46164742967304
                    ],
                    [
                        121.95209831758,
                        0.46167096838455
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1394,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0008700127372314283,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95133209818,
                        0.46187138685246
                    ],
                    [
                        121.95133209621,
                        0.46195587821375
                    ],
                    [
                        121.9518173997,
                        0.46196494868434
                    ],
                    [
                        121.95182293653,
                        0.46166486663179
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1395,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020571239000298667,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94898837845,
                        0.46250028308099
                    ],
                    [
                        121.94897332746,
                        0.4629298108143
                    ],
                    [
                        121.94895289506,
                        0.46319554105224
                    ],
                    [
                        121.94891541897,
                        0.46375264179839
                    ],
                    [
                        121.94890771738,
                        0.46384067128169
                    ],
                    [
                        121.94889968453,
                        0.46398076736225
                    ],
                    [
                        121.94947332144,
                        0.46399294583669
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1396,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0011797096159543673,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.949475631004,
                        0.463995956433264
                    ],
                    [
                        121.949471826769,
                        0.464296933175093
                    ],
                    [
                        121.948879968509,
                        0.46427049608241
                    ],
                    [
                        121.948896523204,
                        0.463984714747745
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1397,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0009424320411431731,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.949090540495,
                        0.464277654834955
                    ],
                    [
                        121.949077549342,
                        0.464603171621073
                    ],
                    [
                        121.949479812118,
                        0.464591901428642
                    ],
                    [
                        121.949477434312,
                        0.464377679124055
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1398,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00043581729230316785,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.949090034404,
                        0.46431562625103
                    ],
                    [
                        121.94947369595,
                        0.464323848491414
                    ],
                    [
                        121.949473364679,
                        0.464375915088677
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1399,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020846799322716976,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948990160224,
                        0.462520150806713
                    ],
                    [
                        121.950208476542,
                        0.462515508570444
                    ],
                    [
                        121.951072683498,
                        0.462454541983865
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1400,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006868384607827661,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951077783682,
                        0.46246062014673
                    ],
                    [
                        121.95112276627,
                        0.463105190445038
                    ],
                    [
                        121.951163410026,
                        0.463107338324247
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1401,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00038866036925024023,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951114752577,
                        0.46300769011863
                    ],
                    [
                        121.950726340487,
                        0.463021580077755
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1402,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016796299509230673,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951102855313,
                        0.462757435253422
                    ],
                    [
                        121.950190057258,
                        0.462794438828694
                    ],
                    [
                        121.950224188968,
                        0.46304804694458
                    ],
                    [
                        121.950733571448,
                        0.463019396727637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1403,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009852730001827397,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94993309209,
                        0.462512887379557
                    ],
                    [
                        121.949886133908,
                        0.461697777613611
                    ],
                    [
                        121.950054612273,
                        0.461687173765044
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1404,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016993510177082274,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95013884259,
                        0.462446408897399
                    ],
                    [
                        121.950081405342,
                        0.461686701877557
                    ],
                    [
                        121.950192594678,
                        0.461671085888423
                    ],
                    [
                        121.951016332699,
                        0.461622066603819
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1405,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009638717335390096,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9501182683,
                        0.462520640266917
                    ],
                    [
                        121.950044655132,
                        0.461559583650368
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1406,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005641436259330415,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.950052323777,
                        0.461648957854302
                    ],
                    [
                        121.95061553689,
                        0.461616569275621
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1407,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0006228295968353696,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.950611222762,
                        0.461617599827011
                    ],
                    [
                        121.951025100303,
                        0.461586225965111
                    ],
                    [
                        121.951008016078,
                        0.46137916494753
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1408,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0001305275911352298,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951023580762,
                        0.461587501011165
                    ],
                    [
                        121.951031896115,
                        0.46171776346528
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2184,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0021018605905080887,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95177012137,
                        0.46445016740685
                    ],
                    [
                        121.95178890233,
                        0.46408150015637
                    ],
                    [
                        121.95181304928,
                        0.46375305113522
                    ],
                    [
                        121.95182378125,
                        0.46353855380705
                    ],
                    [
                        121.95183451323,
                        0.4630974936556
                    ],
                    [
                        121.95183585473,
                        0.46307202209587
                    ],
                    [
                        121.95169097303,
                        0.46307202209587
                    ],
                    [
                        121.95112217821,
                        0.46305727540335
                    ],
                    [
                        121.95113022719,
                        0.46305727540335
                    ],
                    [
                        121.95113022719,
                        0.46305727540335
                    ],
                    [
                        121.95113022719,
                        0.46305727540335
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1410,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0021612460159170944,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951043834232,
                        0.461718103920896
                    ],
                    [
                        121.951039643619,
                        0.461830376381074
                    ],
                    [
                        121.950142129015,
                        0.461917996687476
                    ],
                    [
                        121.950172121418,
                        0.462186730535942
                    ],
                    [
                        121.951044362494,
                        0.462098307070969
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1411,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003051513740316442,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.950101887472,
                        0.461959531645214
                    ],
                    [
                        121.951067222745,
                        0.461837013207847
                    ],
                    [
                        121.95110591688,
                        0.46242471379208
                    ],
                    [
                        121.951123733722,
                        0.462727810068869
                    ],
                    [
                        121.950192404111,
                        0.462767416308993
                    ],
                    [
                        121.950169450747,
                        0.462514786171754
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1412,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002870785038753315,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95195302328,
                        0.46725710586623
                    ],
                    [
                        121.95197179128,
                        0.46667104728244
                    ],
                    [
                        121.95185914793,
                        0.46661205421006
                    ],
                    [
                        121.95184975156,
                        0.46641222812078
                    ],
                    [
                        121.95185645904,
                        0.46606217751088
                    ],
                    [
                        121.951840365,
                        0.46555123674543
                    ],
                    [
                        121.95183635779,
                        0.46513552886554
                    ],
                    [
                        121.95182965541,
                        0.46479893312118
                    ],
                    [
                        121.95176795478,
                        0.46446099539573
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1413,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001525114974675197,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94896772504,
                        0.46291472765909
                    ],
                    [
                        121.94868340185,
                        0.46289192962655
                    ],
                    [
                        121.94863646359,
                        0.46372606212143
                    ],
                    [
                        121.94862610197,
                        0.46413035649598
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1414,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00039378096343132006,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948629018803,
                        0.464129203697262
                    ],
                    [
                        121.948624025032,
                        0.464266749685713
                    ],
                    [
                        121.948880166138,
                        0.464268039299146
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1415,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0016537262963812604,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94886699383,
                        0.46401626489322
                    ],
                    [
                        121.94865065785,
                        0.46399452197016
                    ],
                    [
                        121.94864335848,
                        0.46412623429041
                    ],
                    [
                        121.94863988298,
                        0.46414986603064
                    ],
                    [
                        121.94824916474,
                        0.46413398646605
                    ],
                    [
                        121.94793404024,
                        0.46411486457692
                    ],
                    [
                        121.94736103786,
                        0.46408548398808
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1416,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0002976883590523596,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.947818745247,
                        0.464056905958071
                    ],
                    [
                        121.947830688747,
                        0.463759457286998
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1417,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.00032289080265105526,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948069769067,
                        0.464084499651169
                    ],
                    [
                        121.948084246825,
                        0.463935111506232
                    ],
                    [
                        121.948089502193,
                        0.463762388688478
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1418,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.00032195769874364356,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948339027376,
                        0.46409679279161
                    ],
                    [
                        121.948351810773,
                        0.463934584511541
                    ],
                    [
                        121.948350254494,
                        0.463775345638319
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1419,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008700988776982016,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948315094965,
                        0.464096753975964
                    ],
                    [
                        121.948302507291,
                        0.464578592801201
                    ],
                    [
                        121.948282693328,
                        0.464805067431871
                    ],
                    [
                        121.948263101888,
                        0.4649646250863
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1420,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007323076273877539,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948280443907,
                        0.464798591668062
                    ],
                    [
                        121.947549834286,
                        0.464748751495207
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1421,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016194197240838159,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.948283161216,
                        0.464139890717664
                    ],
                    [
                        121.948261490502,
                        0.464564615334165
                    ],
                    [
                        121.948253754716,
                        0.464717409302528
                    ],
                    [
                        121.948239248694,
                        0.464786653590014
                    ],
                    [
                        121.947545579938,
                        0.464733005380833
                    ],
                    [
                        121.947554829839,
                        0.464458495878911
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1422,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012626271220618009,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94858607986,
                        0.46411365007498
                    ],
                    [
                        121.9486083055,
                        0.46370730581742
                    ],
                    [
                        121.94862037347,
                        0.46351553505557
                    ],
                    [
                        121.94865792715,
                        0.46285307323953
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1423,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002379517754154858,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943731053156,
                        0.464712327067506
                    ],
                    [
                        121.942733840464,
                        0.464684217784789
                    ],
                    [
                        121.942693004786,
                        0.464700356966924
                    ],
                    [
                        121.942629399436,
                        0.465266435608202
                    ],
                    [
                        121.942598519633,
                        0.465297525702841
                    ],
                    [
                        121.942541649919,
                        0.465303814156692
                    ],
                    [
                        121.942372541948,
                        0.465241147512551
                    ],
                    [
                        121.942083127397,
                        0.465201747133874
                    ],
                    [
                        121.941970365948,
                        0.46520314569449
                    ],
                    [
                        121.941966277946,
                        0.465121124699474
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1424,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00038437989569778733,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.942375825524,
                        0.46523580283367
                    ],
                    [
                        121.942393463343,
                        0.464969828101068
                    ],
                    [
                        121.942276090699,
                        0.464959559325275
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1425,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0014776567563917296,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94379574163,
                        0.464166055028289
                    ],
                    [
                        121.944002594252,
                        0.46270294823708
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1426,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 1.1829176667503206e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937163967729,
                        0.458824736402367
                    ],
                    [
                        121.937167421533,
                        0.458813422664763
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1427,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.002093756622192895,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941330346959,
                        0.457608076108804
                    ],
                    [
                        121.94145064847,
                        0.457134253034658
                    ],
                    [
                        121.941392519545,
                        0.456994000503089
                    ],
                    [
                        121.941576186981,
                        0.456407450183119
                    ],
                    [
                        121.94184832047,
                        0.455614397430693
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1428,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0014332689536644084,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94128540887,
                        0.45760673257661
                    ],
                    [
                        121.94141591075,
                        0.4571450658282
                    ],
                    [
                        121.94135572072,
                        0.45699618504165
                    ],
                    [
                        121.94144214008,
                        0.45671651607353
                    ],
                    [
                        121.94096784888,
                        0.45655759596209
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1429,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007074392098355293,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941171687718,
                        0.456605217358212
                    ],
                    [
                        121.941386932971,
                        0.455931318466187
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1430,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007705257642788421,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941695194514,
                        0.456061071027449
                    ],
                    [
                        121.940966696035,
                        0.455810073179801
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1431,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00046470918181529323,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941377112017,
                        0.457041362282
                    ],
                    [
                        121.940936718838,
                        0.456893009757378
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1432,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0002480119426525663,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941355440036,
                        0.45735344769633
                    ],
                    [
                        121.941120117714,
                        0.457275132126608
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1433,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007514881777564762,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941337747109,
                        0.457378651550019
                    ],
                    [
                        121.940628810737,
                        0.457129365165005
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1434,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0005494032047632107,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93672373086,
                        0.46729260423068
                    ],
                    [
                        121.93649813533,
                        0.46679165459424
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1435,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009414260758621537,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937810407545,
                        0.467143038094703
                    ],
                    [
                        121.937667953051,
                        0.466212452379439
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1436,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003354751627492771,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937630693251,
                        0.461931019082764
                    ],
                    [
                        121.937583723036,
                        0.461598848368033
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1437,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00032342606300123046,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.937948253509,
                        0.461882066624362
                    ],
                    [
                        121.937915863861,
                        0.461560266486186
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1438,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006403326827729755,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93828015839,
                        0.461830088208017
                    ],
                    [
                        121.938259895735,
                        0.461659356818463
                    ],
                    [
                        121.938250179287,
                        0.461191054510506
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1439,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0015999605246488427,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93625807762,
                        0.46650878092754
                    ],
                    [
                        121.93612989681,
                        0.46614612035925
                    ],
                    [
                        121.9360585259,
                        0.46577098318971
                    ],
                    [
                        121.93603724979,
                        0.46556355543014
                    ],
                    [
                        121.93603110069,
                        0.46547290618015
                    ],
                    [
                        121.93598346808,
                        0.46505174629376
                    ],
                    [
                        121.93596481301,
                        0.46494310704983
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1440,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001763883207247431,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94877856345,
                        0.47326743483925
                    ],
                    [
                        121.94882348206,
                        0.47288275984345
                    ],
                    [
                        121.94884160752,
                        0.47261210418659
                    ],
                    [
                        121.94890544418,
                        0.47195105468384
                    ],
                    [
                        121.949104464,
                        0.47155728372258
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1441,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003189001412811341,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95189042976,
                        0.46983996880495
                    ],
                    [
                        121.95344792522,
                        0.46981806218285
                    ],
                    [
                        121.95348579276,
                        0.46990022252703
                    ],
                    [
                        121.95354937151,
                        0.47007474358384
                    ],
                    [
                        121.95361644159,
                        0.47008061145573
                    ],
                    [
                        121.95459635854,
                        0.47007273606482
                    ],
                    [
                        121.95460689515,
                        0.47038042439282
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1442,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00015841089375332834,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95366478709,
                        0.47035221555526
                    ],
                    [
                        121.95382157112,
                        0.47037486018371
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1869,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.00018143323491638734,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95115356445,
                        0.47002725334614
                    ],
                    [
                        121.95097412466,
                        0.47000043207667
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1444,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013912982097057161,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95141761453,
                        0.46987382981402
                    ],
                    [
                        121.95141293419,
                        0.46957456328522
                    ],
                    [
                        121.95145343528,
                        0.46921751694794
                    ],
                    [
                        121.95150766982,
                        0.46908403283363
                    ],
                    [
                        121.95188350092,
                        0.46906124384295
                    ],
                    [
                        121.95189819922,
                        0.46884969744651
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1445,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0025923590611988093,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93913473815,
                        0.451687353817
                    ],
                    [
                        121.93929433096,
                        0.45071909963882
                    ],
                    [
                        121.9393372465,
                        0.45043478752698
                    ],
                    [
                        121.93938418771,
                        0.45018402095975
                    ],
                    [
                        121.93951695529,
                        0.44948131861645
                    ],
                    [
                        121.93958132831,
                        0.44913398280732
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1446,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 9.086423984243865e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.939365371871,
                        0.449974007887836
                    ],
                    [
                        121.939316134698,
                        0.449965476227433
                    ],
                    [
                        121.939275979932,
                        0.449957739174681
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1447,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016224780195947244,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93999221535,
                        0.44771763623116
                    ],
                    [
                        121.94031223655,
                        0.44790690893809
                    ],
                    [
                        121.94068847677,
                        0.44814502411848
                    ],
                    [
                        121.94114762387,
                        0.44839914191455
                    ],
                    [
                        121.94140309093,
                        0.44851530614144
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1448,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009482690741587955,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94264970128,
                        0.44881144688949
                    ],
                    [
                        121.94267036765,
                        0.44855736432593
                    ],
                    [
                        121.94254455871,
                        0.44853654758038
                    ],
                    [
                        121.94256614372,
                        0.4483565920524
                    ],
                    [
                        121.94237601747,
                        0.44830218184447
                    ],
                    [
                        121.94219791451,
                        0.44824576818327
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1449,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 4.036677925597772e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.943835246831,
                        0.448875419291682
                    ],
                    [
                        121.943833141706,
                        0.448835107440866
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1450,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0009424034091440535,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.941324808471,
                        0.447885614607931
                    ],
                    [
                        121.941490074201,
                        0.447976104872455
                    ],
                    [
                        121.941669679608,
                        0.44806362573013
                    ],
                    [
                        121.941847835148,
                        0.448135531865901
                    ],
                    [
                        121.94209840545,
                        0.448216589449648
                    ],
                    [
                        121.94219158769,
                        0.448245861668932
                    ],
                    [
                        121.942190805792,
                        0.448246554240004
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1451,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0005028986100325959,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93958311682,
                        0.445785341031921
                    ],
                    [
                        121.939457428823,
                        0.445644809802013
                    ],
                    [
                        121.939348263852,
                        0.445508540126847
                    ],
                    [
                        121.939246854302,
                        0.445412372645127
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1452,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.001475494272419835,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9400158554,
                        0.44702045998793
                    ],
                    [
                        121.93970204606,
                        0.4467595142174
                    ],
                    [
                        121.93934569825,
                        0.44645518802658
                    ],
                    [
                        121.93902009088,
                        0.44615355127704
                    ],
                    [
                        121.9389021583,
                        0.44605312224058
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1453,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0009531014029375917,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93805543557,
                        0.44694421981381
                    ],
                    [
                        121.93797334857,
                        0.44705801567541
                    ],
                    [
                        121.93791257373,
                        0.44716896710785
                    ],
                    [
                        121.93823620677,
                        0.44728733756174
                    ],
                    [
                        121.93855270665,
                        0.44741607671812
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1454,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0018879879240594575,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94919705155,
                        0.45000296815949
                    ],
                    [
                        121.94944381753,
                        0.45006465706385
                    ],
                    [
                        121.94972812815,
                        0.45014780044721
                    ],
                    [
                        121.94990246584,
                        0.45020412931524
                    ],
                    [
                        121.94996147837,
                        0.45021485697663
                    ],
                    [
                        121.95001781105,
                        0.45023633001205
                    ],
                    [
                        121.95034375712,
                        0.45030658619115
                    ],
                    [
                        121.95042165591,
                        0.4502852416793
                    ],
                    [
                        121.95050060985,
                        0.450308750793
                    ],
                    [
                        121.95065886214,
                        0.45037311591671
                    ],
                    [
                        121.95080639464,
                        0.45042406703532
                    ],
                    [
                        121.95100757917,
                        0.45048574328422
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1460,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005001031999809677,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95115273901,
                        0.45725210045912
                    ],
                    [
                        121.95165127594,
                        0.45721255124849
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1461,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00010836487955154232,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95182427764,
                        0.4575987715794
                    ],
                    [
                        121.95183074032,
                        0.45749059958262
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1462,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00027076224836790824,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.952026106459,
                        0.45891075258555
                    ],
                    [
                        121.952296831735,
                        0.458906278205363
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1463,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005257040629273747,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95203484165,
                        0.4582988027962
                    ],
                    [
                        121.95256054401,
                        0.45829746470978
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1464,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0048325984014624965,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.953725320966,
                        0.451381652530938
                    ],
                    [
                        121.953727986341,
                        0.452316790178883
                    ],
                    [
                        121.953777978536,
                        0.452678793044037
                    ],
                    [
                        121.953928766354,
                        0.453111793819682
                    ],
                    [
                        121.954234814146,
                        0.45363699751093
                    ],
                    [
                        121.954438180592,
                        0.45388744979907
                    ],
                    [
                        121.954655600964,
                        0.454041638526358
                    ],
                    [
                        121.95468274494,
                        0.454181996203419
                    ],
                    [
                        121.954645928857,
                        0.4544096853507
                    ],
                    [
                        121.954426699481,
                        0.454919908994689
                    ],
                    [
                        121.954489679116,
                        0.455712826552951
                    ],
                    [
                        121.954490449338,
                        0.455864956711913
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2122,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0008433342921293157,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94804370403,
                        0.46741265162693
                    ],
                    [
                        121.94803699851,
                        0.46765001922197
                    ],
                    [
                        121.94801688194,
                        0.46794102920043
                    ],
                    [
                        121.94814428687,
                        0.46794639343954
                    ],
                    [
                        121.94830387831,
                        0.46795443979822
                    ],
                    [
                        121.9483307004,
                        0.46795309873844
                    ],
                    [
                        121.9483307004,
                        0.46795309873844
                    ],
                    [
                        121.9483307004,
                        0.46795309873844
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1467,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0015881129816026221,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94143742323,
                        0.46859144316391
                    ],
                    [
                        121.94036722183,
                        0.46875907561893
                    ],
                    [
                        121.93988475509,
                        0.46890777651261
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2119,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0006244396492323776,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94181159139,
                        0.46854584713544
                    ],
                    [
                        121.94186255336,
                        0.46886636038806
                    ],
                    [
                        121.94184914231,
                        0.46888111204368
                    ],
                    [
                        121.94157555699,
                        0.46892268489118
                    ],
                    [
                        121.9415768981,
                        0.46892402595077
                    ],
                    [
                        121.9415782392,
                        0.46892402595077
                    ],
                    [
                        121.9415782392,
                        0.46892402595077
                    ],
                    [
                        121.9415782392,
                        0.46892402595077
                    ],
                    [
                        121.9415782392,
                        0.46892402595077
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1469,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002009251966957439,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.938412234944,
                        0.471109872888842
                    ],
                    [
                        121.939518055524,
                        0.470532079126345
                    ],
                    [
                        121.939476274804,
                        0.47038199296833
                    ],
                    [
                        121.940025267954,
                        0.470125898098767
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1470,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012519631673631698,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94002152294,
                        0.47012827246198
                    ],
                    [
                        121.94009324096,
                        0.47030632158954
                    ],
                    [
                        121.94029888631,
                        0.47020885815824
                    ],
                    [
                        121.94083090418,
                        0.47011460482675
                    ],
                    [
                        121.94112108642,
                        0.47008085696005
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1471,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008168023608318043,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94797289374,
                        0.46940353487786
                    ],
                    [
                        121.94833200552,
                        0.46939579429777
                    ],
                    [
                        121.9486359358,
                        0.469408527427
                    ],
                    [
                        121.94878866076,
                        0.46942301189635
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1472,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0013283066759747022,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94681181908,
                        0.46960457703518
                    ],
                    [
                        121.94699812527,
                        0.46956858472822
                    ],
                    [
                        121.9476584851,
                        0.46946999501795
                    ],
                    [
                        121.94812819362,
                        0.46943684539423
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1474,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0018527815815568515,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93620910048,
                        0.44537230091676
                    ],
                    [
                        121.93623395974,
                        0.44561245600193
                    ],
                    [
                        121.93625272538,
                        0.44586719151399
                    ],
                    [
                        121.93611323362,
                        0.44622387401681
                    ],
                    [
                        121.93605690802,
                        0.44639285733627
                    ],
                    [
                        121.93590401778,
                        0.44655644771905
                    ],
                    [
                        121.93573235798,
                        0.44710092043509
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1475,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001489192131108347,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93644091855,
                        0.4458691763947
                    ],
                    [
                        121.93643545162,
                        0.44586729011199
                    ],
                    [
                        121.93668127011,
                        0.44585782069307
                    ],
                    [
                        121.9367971981,
                        0.44591543270192
                    ],
                    [
                        121.93657457632,
                        0.44652159861696
                    ],
                    [
                        121.93640290669,
                        0.44695073564071
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1476,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007967803747967343,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93676501198,
                        0.44588861479788
                    ],
                    [
                        121.93649143098,
                        0.44663695456169
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1477,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007372246747321358,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93653970485,
                        0.44586178761566
                    ],
                    [
                        121.9362929432,
                        0.44655648820521
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1478,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007069001519381346,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93648222611,
                        0.44587983028155
                    ],
                    [
                        121.93625271477,
                        0.44654843507485
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1861,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0005257597147365554,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93598717451,
                        0.44647063397579
                    ],
                    [
                        121.93646595059,
                        0.44668788208938
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1480,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009047390496776959,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93578466321,
                        0.44668653343447
                    ],
                    [
                        121.93488076015,
                        0.44664764891155
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1481,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008524942795352519,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93574577531,
                        0.44694402062236
                    ],
                    [
                        121.93489416844,
                        0.44690513314869
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1482,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008550030974150962,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93574041207,
                        0.44697353541054
                    ],
                    [
                        121.93488612025,
                        0.44693866733256
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1483,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008951026053963155,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9357793039,
                        0.44671471137724
                    ],
                    [
                        121.93488478012,
                        0.44668252626899
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1484,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008848306108896604,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93577661521,
                        0.44643978993026
                    ],
                    [
                        121.93489282538,
                        0.44639688601018
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1485,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005018253460306513,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93578332054,
                        0.44638345934635
                    ],
                    [
                        121.93528157358,
                        0.44637458995788
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1487,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00019747553428283612,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93624466618,
                        0.44588860214596
                    ],
                    [
                        121.93644104079,
                        0.44586777910132
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1862,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 7.006198345038426e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93579136913,
                        0.44668787407649
                    ],
                    [
                        121.93586110971,
                        0.44669457728661
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1489,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000617918635154677,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93577796201,
                        0.4463781857633
                    ],
                    [
                        121.93577817093,
                        0.44674152198598
                    ],
                    [
                        121.93574745011,
                        0.44693172870651
                    ],
                    [
                        121.9357371807,
                        0.44699278174982
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1490,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00010314821592664459,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931289739158,
                        0.467686374952215
                    ],
                    [
                        121.931388178034,
                        0.467655563555918
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1491,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 2.151335754714944e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.931387645339,
                        0.467657628934161
                    ],
                    [
                        121.93139285922,
                        0.467678500924912
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1492,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0009633222811261396,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93139355787,
                        0.46767856204857
                    ],
                    [
                        121.93142822366,
                        0.46771685161224
                    ],
                    [
                        121.93146904223,
                        0.46773309467264
                    ],
                    [
                        121.93170901259,
                        0.46767952253832
                    ],
                    [
                        121.93232058669,
                        0.46756687351162
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1819,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.003556844248809268,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45342558622,
                        0.5048562821033
                    ],
                    [
                        121.45339205861,
                        0.50490858314848
                    ],
                    [
                        121.45332098007,
                        0.50500245681824
                    ],
                    [
                        121.45317748189,
                        0.50512583363928
                    ],
                    [
                        121.45311579108,
                        0.50518215932699
                    ],
                    [
                        121.45298033953,
                        0.50529346518585
                    ],
                    [
                        121.45289584994,
                        0.50536990516966
                    ],
                    [
                        121.45281001925,
                        0.50545170936187
                    ],
                    [
                        121.45269870758,
                        0.50552010302995
                    ],
                    [
                        121.45254582167,
                        0.50563543352748
                    ],
                    [
                        121.4523781836,
                        0.50570785035044
                    ],
                    [
                        121.45226821303,
                        0.50575478717971
                    ],
                    [
                        121.45207375288,
                        0.50583122715808
                    ],
                    [
                        121.4518404007,
                        0.50589023345656
                    ],
                    [
                        121.45167946815,
                        0.5059197366056
                    ],
                    [
                        121.45145818591,
                        0.50596533238111
                    ],
                    [
                        121.45123690367,
                        0.50598678921655
                    ],
                    [
                        121.450920403,
                        0.50602299762618
                    ],
                    [
                        121.45060658455,
                        0.50604579551361
                    ],
                    [
                        121.45039603114,
                        0.5060565239312
                    ],
                    [
                        121.45022973418,
                        0.5060645702444
                    ],
                    [
                        121.45022973418,
                        0.5060645702444
                    ],
                    [
                        121.45022973418,
                        0.5060645702444
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1494,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006378562930861633,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951827476533,
                        0.457489946900553
                    ],
                    [
                        121.951189787556,
                        0.457504555776283
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1496,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005424790757106222,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95164054632,
                        0.45691751595772
                    ],
                    [
                        121.95109873028,
                        0.45694432876034
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1497,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 3.0985127394162164e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951836890845,
                        0.457494994512025
                    ],
                    [
                        121.951867875794,
                        0.457494889366533
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1498,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006378562930861633,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951827476533,
                        0.457489946900553
                    ],
                    [
                        121.951189787556,
                        0.457504555776283
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1499,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000649823887590817,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951650588122,
                        0.45749207102785
                    ],
                    [
                        121.951642668645,
                        0.456842295399831
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1501,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 3.0985127394162164e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951836890845,
                        0.457494994512025
                    ],
                    [
                        121.951867875794,
                        0.457494889366533
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1502,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006378562930861633,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951827476533,
                        0.457489946900553
                    ],
                    [
                        121.951189787556,
                        0.457504555776283
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1505,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 3.0985127394162164e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951836890845,
                        0.457494994512025
                    ],
                    [
                        121.951867875794,
                        0.457494889366533
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1506,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006378562930861633,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951827476533,
                        0.457489946900553
                    ],
                    [
                        121.951189787556,
                        0.457504555776283
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1509,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 3.0985127394162164e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951836890845,
                        0.457494994512025
                    ],
                    [
                        121.951867875794,
                        0.457494889366533
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1510,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006378562930861633,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951827476533,
                        0.457489946900553
                    ],
                    [
                        121.951189787556,
                        0.457504555776283
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1513,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 3.0985127394162164e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.951836890845,
                        0.457494994512025
                    ],
                    [
                        121.951867875794,
                        0.457494889366533
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1514,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005927820648920301,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95165127594,
                        0.45721254787466
                    ],
                    [
                        121.95224137764,
                        0.45715624014769
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1515,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005890292235820736,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95164515856,
                        0.45693051252959
                    ],
                    [
                        121.95222796463,
                        0.45684511632941
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1516,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0015414041504351389,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89303562045,
                        0.50080226368046
                    ],
                    [
                        121.89324251371,
                        0.50232971971385
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1517,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008289185271490424,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93129752879,
                        0.46999122986835
                    ],
                    [
                        121.93159371614,
                        0.46995261858267
                    ],
                    [
                        121.9316741807,
                        0.46992713845411
                    ],
                    [
                        121.9317463032,
                        0.46991503747261
                    ],
                    [
                        121.93176537384,
                        0.47015511854843
                    ],
                    [
                        121.93189679128,
                        0.47014439007358
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1518,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0010509574787483725,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92409157753,
                        0.47456317925731
                    ],
                    [
                        121.92402308073,
                        0.47410394381637
                    ],
                    [
                        121.92394440665,
                        0.47352260136057
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2081,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008157941536299658,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09414899349,
                        0.56513898107097
                    ],
                    [
                        122.09414362907,
                        0.56525699252556
                    ],
                    [
                        122.09412887692,
                        0.56534013695804
                    ],
                    [
                        122.094091326,
                        0.56541255307569
                    ],
                    [
                        122.09404036403,
                        0.56546217152613
                    ],
                    [
                        122.09398135543,
                        0.56549837958432
                    ],
                    [
                        122.09387406707,
                        0.56553995179897
                    ],
                    [
                        122.09375873208,
                        0.56561907310993
                    ],
                    [
                        122.09366351366,
                        0.56569685338065
                    ],
                    [
                        122.09365546703,
                        0.56570758169377
                    ],
                    [
                        122.09365546703,
                        0.56570758169377
                    ],
                    [
                        122.09365546703,
                        0.56570758169377
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1573,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0028965454488302737,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96280261054,
                        0.46522290917595
                    ],
                    [
                        121.96296471205,
                        0.46495891864798
                    ],
                    [
                        121.96307542252,
                        0.46476272562922
                    ],
                    [
                        121.96317178986,
                        0.46460620326844
                    ],
                    [
                        121.96324630157,
                        0.46444642419365
                    ],
                    [
                        121.96332810671,
                        0.46428071146961
                    ],
                    [
                        121.96335835538,
                        0.46418299599282
                    ],
                    [
                        121.96340511067,
                        0.46404199395495
                    ],
                    [
                        121.963439025,
                        0.46388202749721
                    ],
                    [
                        121.96345205153,
                        0.46366037610497
                    ],
                    [
                        121.96344112824,
                        0.46345385592074
                    ],
                    [
                        121.96340970175,
                        0.46330767715963
                    ],
                    [
                        121.96335337304,
                        0.46310862530266
                    ],
                    [
                        121.96331256561,
                        0.46292949957714
                    ],
                    [
                        121.96327137345,
                        0.4627913672107
                    ],
                    [
                        121.9632016339,
                        0.46267392480104
                    ],
                    [
                        121.96315623064,
                        0.46261319026536
                    ],
                    [
                        121.96310335107,
                        0.46255763189638
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1571,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0027759373929919623,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93246543407,
                        0.47675715062439
                    ],
                    [
                        121.93236082792,
                        0.4764701641894
                    ],
                    [
                        121.93227767944,
                        0.47601956864117
                    ],
                    [
                        121.93221598864,
                        0.47577013180719
                    ],
                    [
                        121.9321462512,
                        0.4754295029978
                    ],
                    [
                        121.93206846714,
                        0.47504596030256
                    ],
                    [
                        121.93198800087,
                        0.47465705335206
                    ],
                    [
                        121.9319075346,
                        0.47426278214547
                    ],
                    [
                        121.93186193705,
                        0.4740508948891
                    ],
                    [
                        121.93186193705,
                        0.4740508948891
                    ],
                    [
                        121.93186193705,
                        0.4740508948891
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1572,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA HDPE",
                "panjang": 0.000670539162953241,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.92746504544,
                        0.45359313894245
                    ],
                    [
                        121.92738130689,
                        0.45292784906255
                    ],
                    [
                        121.92738130689,
                        0.45292784906255
                    ],
                    [
                        121.92738130689,
                        0.45292784906255
                    ],
                    [
                        121.92738130689,
                        0.45292784906255
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1574,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0020007150246970267,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9619682178,
                        0.46703044722834
                    ],
                    [
                        121.96208623056,
                        0.46676376747776
                    ],
                    [
                        121.96217053244,
                        0.46657946911759
                    ],
                    [
                        121.96226843965,
                        0.46636950150208
                    ],
                    [
                        121.96236576362,
                        0.46616143949554
                    ],
                    [
                        121.96246673305,
                        0.46594208531587
                    ],
                    [
                        121.96253305069,
                        0.4658032102479
                    ],
                    [
                        121.96267871718,
                        0.46548906522193
                    ],
                    [
                        121.96280674996,
                        0.4652139964802
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1577,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 5.956927809886521e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96330547333,
                        0.46410291506097
                    ],
                    [
                        121.96325451136,
                        0.46407207066913
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1578,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012847183329926365,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96309089661,
                        0.46595894256492
                    ],
                    [
                        121.9638043642,
                        0.4661493731049
                    ],
                    [
                        121.96432471275,
                        0.46631566455814
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1579,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00034541616196392266,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96288838983,
                        0.4653460780457
                    ],
                    [
                        121.96321964264,
                        0.46544397544512
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1583,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004943144874206503,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96322098374,
                        0.46545738604768
                    ],
                    [
                        121.96339800954,
                        0.46550298209617
                    ],
                    [
                        121.96369707584,
                        0.46559015101159
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1581,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0011487911500006219,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96315661073,
                        0.46565452190229
                    ],
                    [
                        121.96337923408,
                        0.46573766763524
                    ],
                    [
                        121.96369305253,
                        0.46582349548758
                    ],
                    [
                        121.96393176913,
                        0.46590530015836
                    ],
                    [
                        121.96425363421,
                        0.46599246906882
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1582,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001549398792616867,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96322366595,
                        0.46544263438486
                    ],
                    [
                        121.96315661073,
                        0.46565452190229
                    ],
                    [
                        121.96337923408,
                        0.46573766763524
                    ],
                    [
                        121.96369305253,
                        0.46582349548758
                    ],
                    [
                        121.96393176913,
                        0.46590530015836
                    ],
                    [
                        121.96408733726,
                        0.46594821408365
                    ],
                    [
                        121.96441859007,
                        0.46603806511385
                    ],
                    [
                        121.96441590786,
                        0.46603135981313
                    ],
                    [
                        121.96441590786,
                        0.46603135981313
                    ],
                    [
                        121.96441590786,
                        0.46603135981313
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1584,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009850412802512448,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96319416165,
                        0.46555260132509
                    ],
                    [
                        121.96368768811,
                        0.46570414113014
                    ],
                    [
                        121.96397200227,
                        0.46580337958479
                    ],
                    [
                        121.9641289115,
                        0.46586238623283
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1634,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.0011020680076662677,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56945258379,
                        0.57119645228556
                    ],
                    [
                        121.5698710084,
                        0.57142979286922
                    ],
                    [
                        121.57003194094,
                        0.57149952683492
                    ],
                    [
                        121.57010704279,
                        0.57166045136791
                    ],
                    [
                        121.57017409801,
                        0.57179723721741
                    ],
                    [
                        121.57023310661,
                        0.57185892495238
                    ],
                    [
                        121.57023578882,
                        0.57182674004725
                    ],
                    [
                        121.57023578882,
                        0.57182674004725
                    ],
                    [
                        121.57023578882,
                        0.57182674004725
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1588,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00012533792808075496,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93579807878,
                        0.4957706454752
                    ],
                    [
                        121.93591475487,
                        0.49574918860632
                    ],
                    [
                        121.93591475487,
                        0.49574248333479
                    ],
                    [
                        121.93591475487,
                        0.49574248333479
                    ],
                    [
                        121.93591475487,
                        0.49574248333479
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1593,
                "jenis_pipa": "Pipa 3\/4",
                "keterangan": "",
                "panjang": 0.00041267712660546425,
                "total_panjang_jenis": 0.0018000769254979533
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93215168004,
                        0.47547050720663
                    ],
                    [
                        121.932521725,
                        0.47536325413284
                    ],
                    [
                        121.93253781391,
                        0.47534448484473
                    ],
                    [
                        121.93253781391,
                        0.47534180351786
                    ],
                    [
                        121.93253781391,
                        0.47534180351786
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1594,
                "jenis_pipa": "Pipa 3\/4",
                "keterangan": "",
                "panjang": 0.00047455234411728555,
                "total_panjang_jenis": 0.0018000769254979533
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93214499623,
                        0.47539770619655
                    ],
                    [
                        121.93244130035,
                        0.47528240914091
                    ],
                    [
                        121.93249761154,
                        0.47513627682346
                    ],
                    [
                        121.93249761154,
                        0.47513627682346
                    ],
                    [
                        121.93249761154,
                        0.47513627682346
                    ],
                    [
                        121.93249761154,
                        0.47513627682346
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1595,
                "jenis_pipa": "Pipa 3\/4",
                "keterangan": "",
                "panjang": 0.0009128474547752034,
                "total_panjang_jenis": 0.0018000769254979533
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93218886834,
                        0.47555040992296
                    ],
                    [
                        121.9325964541,
                        0.47540561827461
                    ],
                    [
                        121.93262863192,
                        0.47522328804643
                    ],
                    [
                        121.93278147658,
                        0.47497392463833
                    ],
                    [
                        121.93278147658,
                        0.47497124331132
                    ],
                    [
                        121.93278147658,
                        0.47497124331132
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1596,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.017850283909496063,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10156127805,
                        0.60572002562882
                    ],
                    [
                        122.10170075291,
                        0.60561944841049
                    ],
                    [
                        122.10180401796,
                        0.605557761049
                    ],
                    [
                        122.1018750965,
                        0.6054826633906
                    ],
                    [
                        122.1019059419,
                        0.6054062247015
                    ],
                    [
                        122.10191532964,
                        0.60529626026969
                    ],
                    [
                        122.1019032597,
                        0.60518763686533
                    ],
                    [
                        122.10177853704,
                        0.60509778752895
                    ],
                    [
                        122.10177585483,
                        0.60497977691241
                    ],
                    [
                        122.10175171494,
                        0.60491138439481
                    ],
                    [
                        122.101559937,
                        0.60480678407213
                    ],
                    [
                        122.10136413574,
                        0.60470620683687
                    ],
                    [
                        122.10133731365,
                        0.60466195285277
                    ],
                    [
                        122.10133999586,
                        0.6046069706296
                    ],
                    [
                        122.10137888789,
                        0.60455869355513
                    ],
                    [
                        122.10155457258,
                        0.60445543425554
                    ],
                    [
                        122.1017087996,
                        0.60440715717971
                    ],
                    [
                        122.10189655423,
                        0.60436156216329
                    ],
                    [
                        122.10196763277,
                        0.60428110036863
                    ],
                    [
                        122.10200116038,
                        0.60423818741099
                    ],
                    [
                        122.10202395916,
                        0.60412554089559
                    ],
                    [
                        122.10202932358,
                        0.60389890682777
                    ],
                    [
                        122.10199981928,
                        0.60361594948723
                    ],
                    [
                        122.10193142295,
                        0.60336517685558
                    ],
                    [
                        122.10181340575,
                        0.60311172215195
                    ],
                    [
                        122.10173293948,
                        0.60293336513122
                    ],
                    [
                        122.10159748793,
                        0.60264236155852
                    ],
                    [
                        122.10149556398,
                        0.60244254803648
                    ],
                    [
                        122.10145264864,
                        0.60236208621344
                    ],
                    [
                        122.10143655539,
                        0.60226284996341
                    ],
                    [
                        122.1014110744,
                        0.60217702401597
                    ],
                    [
                        122.10139632225,
                        0.60188199731135
                    ],
                    [
                        122.10138827562,
                        0.60163122459987
                    ],
                    [
                        122.10139364004,
                        0.60142068279578
                    ],
                    [
                        122.10141912103,
                        0.60127987457832
                    ],
                    [
                        122.10146069527,
                        0.60097277854859
                    ],
                    [
                        122.10147812963,
                        0.60081319588877
                    ],
                    [
                        122.10158273578,
                        0.60043368416644
                    ],
                    [
                        122.10164710879,
                        0.60022850643986
                    ],
                    [
                        122.10171014071,
                        0.6000756289131
                    ],
                    [
                        122.10179463029,
                        0.59992409241304
                    ],
                    [
                        122.10189655423,
                        0.5997202556984
                    ],
                    [
                        122.10189923644,
                        0.59952312413163
                    ],
                    [
                        122.10193544626,
                        0.59930051296605
                    ],
                    [
                        122.10190996528,
                        0.59901487332468
                    ],
                    [
                        122.10201188922,
                        0.59880567245114
                    ],
                    [
                        122.10212051868,
                        0.59863670250897
                    ],
                    [
                        122.10227072239,
                        0.59835776798989
                    ],
                    [
                        122.10230827332,
                        0.59813247471414
                    ],
                    [
                        122.10205614567,
                        0.59761751862053
                    ],
                    [
                        122.10191130638,
                        0.5972152091388
                    ],
                    [
                        122.10193812847,
                        0.5960941065611
                    ],
                    [
                        122.10190057755,
                        0.59587954144843
                    ],
                    [
                        122.10186302662,
                        0.59556305789199
                    ],
                    [
                        122.10176646709,
                        0.59518756890313
                    ],
                    [
                        122.10169672966,
                        0.59481207988874
                    ],
                    [
                        122.10167527199,
                        0.59475441550211
                    ],
                    [
                        122.10167258978,
                        0.59457471717716
                    ],
                    [
                        122.10169404745,
                        0.59430382864639
                    ],
                    [
                        122.10173562169,
                        0.59410803791787
                    ],
                    [
                        122.10177719593,
                        0.59389615479288
                    ],
                    [
                        122.10180401802,
                        0.59371913850501
                    ],
                    [
                        122.1018268168,
                        0.59355553253695
                    ],
                    [
                        122.10184827447,
                        0.59338522140112
                    ],
                    [
                        122.10184827447,
                        0.59318943064007
                    ],
                    [
                        122.10184693336,
                        0.59300168606817
                    ],
                    [
                        122.10182279348,
                        0.59283539801345
                    ],
                    [
                        122.10177183151,
                        0.59263156103633
                    ],
                    [
                        122.10167527199,
                        0.59240358546095
                    ],
                    [
                        122.10157468915,
                        0.59221718189528
                    ],
                    [
                        122.10147812963,
                        0.59201870902709
                    ],
                    [
                        122.10138559341,
                        0.59184437474513
                    ],
                    [
                        122.10128769279,
                        0.59162176326942
                    ],
                    [
                        122.1012313664,
                        0.59153191405682
                    ],
                    [
                        122.10112139583,
                        0.59132137186637
                    ],
                    [
                        122.10093230009,
                        0.59098745461799
                    ],
                    [
                        122.10080891848,
                        0.59076752517437
                    ],
                    [
                        122.10066273808,
                        0.59054625468875
                    ],
                    [
                        122.10054337978,
                        0.59037057932725
                    ],
                    [
                        122.10037171841,
                        0.59016540122624
                    ],
                    [
                        122.10031807423,
                        0.59006348268959
                    ],
                    [
                        122.10027113557,
                        0.58995754105085
                    ],
                    [
                        122.10023090243,
                        0.58983416597531
                    ],
                    [
                        122.10020944476,
                        0.58974968086766
                    ],
                    [
                        122.10020944476,
                        0.58974968086766
                    ],
                    [
                        122.10020944476,
                        0.58974968086766
                    ],
                    [
                        122.10020944476,
                        0.58974968086766
                    ],
                    [
                        122.1001906693,
                        0.58962094165356
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1597,
                "jenis_pipa": "Pipa 300",
                "keterangan": "",
                "panjang": 0.02976952575218761,
                "total_panjang_jenis": 0.2441077836981406
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10020944476,
                        0.5897188370979
                    ],
                    [
                        122.1001920104,
                        0.58962496475404
                    ],
                    [
                        122.10018664598,
                        0.58950158967115
                    ],
                    [
                        122.10017055273,
                        0.58929641153811
                    ],
                    [
                        122.10013434291,
                        0.58907916409488
                    ],
                    [
                        122.1001021564,
                        0.58893701452869
                    ],
                    [
                        122.10002169013,
                        0.58875195188046
                    ],
                    [
                        122.09998682141,
                        0.58868758226226
                    ],
                    [
                        122.0999532938,
                        0.58862053057583
                    ],
                    [
                        122.09991440177,
                        0.5885387275173
                    ],
                    [
                        122.09989562631,
                        0.5884797220317
                    ],
                    [
                        122.09986880422,
                        0.58837780346423
                    ],
                    [
                        122.09979906678,
                        0.58827052075959
                    ],
                    [
                        122.09969848394,
                        0.58818067149288
                    ],
                    [
                        122.09961935878,
                        0.58811227876651
                    ],
                    [
                        122.09956169128,
                        0.58801438329396
                    ],
                    [
                        122.09950402379,
                        0.5879003954128
                    ],
                    [
                        122.09947049618,
                        0.58773813030738
                    ],
                    [
                        122.09946647286,
                        0.58767376067747
                    ],
                    [
                        122.09946915507,
                        0.58752490590548
                    ],
                    [
                        122.09951877594,
                        0.58741225904835
                    ],
                    [
                        122.09961131215,
                        0.58726608633751
                    ],
                    [
                        122.09967970848,
                        0.58718294222505
                    ],
                    [
                        122.09973469377,
                        0.58708638777033
                    ],
                    [
                        122.09972262383,
                        0.58696435366544
                    ],
                    [
                        122.09972932935,
                        0.58686645817278
                    ],
                    [
                        122.09969714284,
                        0.58674174199471
                    ],
                    [
                        122.09967702627,
                        0.58653119962329
                    ],
                    [
                        122.09968373179,
                        0.58637027551241
                    ],
                    [
                        122.0996850729,
                        0.58622946691159
                    ],
                    [
                        122.09964752197,
                        0.58591298280539
                    ],
                    [
                        122.09954559803,
                        0.58530147109192
                    ],
                    [
                        122.09947049618,
                        0.58488575037147
                    ],
                    [
                        122.09940880537,
                        0.58453976342579
                    ],
                    [
                        122.0993578434,
                        0.5842581461287
                    ],
                    [
                        122.09933906794,
                        0.58408381160437
                    ],
                    [
                        122.09933906794,
                        0.58395775432957
                    ],
                    [
                        122.09934175014,
                        0.58355007971936
                    ],
                    [
                        122.09935247898,
                        0.58323627753217
                    ],
                    [
                        122.09940612316,
                        0.58280178216717
                    ],
                    [
                        122.09944367409,
                        0.58251211857188
                    ],
                    [
                        122.09940075874,
                        0.58228682465415
                    ],
                    [
                        122.09926664829,
                        0.58154657314679
                    ],
                    [
                        122.09919691086,
                        0.58082241396956
                    ],
                    [
                        122.09915399551,
                        0.58048447298842
                    ],
                    [
                        122.09925591946,
                        0.58018944513125
                    ],
                    [
                        122.09939539433,
                        0.57986223239894
                    ],
                    [
                        122.09960460663,
                        0.57934191047416
                    ],
                    [
                        122.09987819195,
                        0.57890741480964
                    ],
                    [
                        122.09995865822,
                        0.57854801713606
                    ],
                    [
                        122.10002303123,
                        0.57805987996086
                    ],
                    [
                        122.0999532938,
                        0.57756101445276
                    ],
                    [
                        122.09988892078,
                        0.57691195281214
                    ],
                    [
                        122.09977626801,
                        0.57641308720332
                    ],
                    [
                        122.09959924221,
                        0.57593031399189
                    ],
                    [
                        122.09922373295,
                        0.57497013159432
                    ],
                    [
                        122.09901452065,
                        0.57475556567334
                    ],
                    [
                        122.098762393,
                        0.57454636389263
                    ],
                    [
                        122.09868729115,
                        0.57439616773764
                    ],
                    [
                        122.09864974022,
                        0.57417623764644
                    ],
                    [
                        122.09860682487,
                        0.57365591520186
                    ],
                    [
                        122.09842443466,
                        0.57324823985141
                    ],
                    [
                        122.09837079048,
                        0.57301221726682
                    ],
                    [
                        122.09850490093,
                        0.57278155882248
                    ],
                    [
                        122.09888577461,
                        0.57225050795026
                    ],
                    [
                        122.0992398262,
                        0.57169800042495
                    ],
                    [
                        122.09917545319,
                        0.57132787399476
                    ],
                    [
                        122.09926664829,
                        0.57107039472491
                    ],
                    [
                        122.09939002991,
                        0.57097383999576
                    ],
                    [
                        122.09986209869,
                        0.57072708901386
                    ],
                    [
                        122.10008203983,
                        0.57061444182294
                    ],
                    [
                        122.10008203983,
                        0.57046424556497
                    ],
                    [
                        122.10000157356,
                        0.57017458134208
                    ],
                    [
                        122.09948658943,
                        0.56906956583952
                    ],
                    [
                        122.09913253784,
                        0.56818984460846
                    ],
                    [
                        122.09896087646,
                        0.56784117457127
                    ],
                    [
                        122.09884285927,
                        0.56767890889293
                    ],
                    [
                        122.09870204329,
                        0.56738522141398
                    ],
                    [
                        122.09857866168,
                        0.56715456274425
                    ],
                    [
                        122.09838151932,
                        0.56686758043303
                    ],
                    [
                        122.09829702973,
                        0.56680723368353
                    ],
                    [
                        122.09798589349,
                        0.56656182356244
                    ],
                    [
                        122.09782764316,
                        0.56644917629025
                    ],
                    [
                        122.09761977196,
                        0.56626277187078
                    ],
                    [
                        122.09749236703,
                        0.56614073731951
                    ],
                    [
                        122.09727913141,
                        0.56594494561653
                    ],
                    [
                        122.09718927741,
                        0.56586850638824
                    ],
                    [
                        122.09710747004,
                        0.56584436768434
                    ],
                    [
                        122.0970363915,
                        0.56584570872344
                    ],
                    [
                        122.09693178535,
                        0.56587252950554
                    ],
                    [
                        122.09668904543,
                        0.56598785886706
                    ],
                    [
                        122.09627464414,
                        0.56618499160763
                    ],
                    [
                        122.09579184651,
                        0.56633787005489
                    ],
                    [
                        122.09558263421,
                        0.56636737291267
                    ],
                    [
                        122.09542706609,
                        0.56635798563975
                    ],
                    [
                        122.09531039,
                        0.56632445966494
                    ],
                    [
                        122.09517762065,
                        0.56633787005489
                    ],
                    [
                        122.09443733096,
                        0.56659803161375
                    ],
                    [
                        122.09406852722,
                        0.56673079446659
                    ],
                    [
                        122.09406852722,
                        0.56673079446659
                    ],
                    [
                        122.09406852722,
                        0.56673079446659
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1612,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.1004424040846462,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46425792338,
                        0.57960186732669
                    ],
                    [
                        121.4642632878,
                        0.57931220356734
                    ],
                    [
                        121.46431424977,
                        0.57917541789805
                    ],
                    [
                        121.46443494917,
                        0.57893939555898
                    ],
                    [
                        121.46474340321,
                        0.57840298111544
                    ],
                    [
                        121.46492847563,
                        0.57793630050833
                    ],
                    [
                        121.46513500573,
                        0.57734356244058
                    ],
                    [
                        121.46510281922,
                        0.57711558624422
                    ],
                    [
                        121.46497139098,
                        0.57668913662884
                    ],
                    [
                        121.46484532715,
                        0.57636728784138
                    ],
                    [
                        121.46475413205,
                        0.57597034097845
                    ],
                    [
                        121.46449932219,
                        0.57530250463994
                    ],
                    [
                        121.464368999,
                        0.57471265248818
                    ],
                    [
                        121.46425634623,
                        0.57402872355614
                    ],
                    [
                        121.46402835846,
                        0.57340916433531
                    ],
                    [
                        121.46389424801,
                        0.57284324654689
                    ],
                    [
                        121.46369040012,
                        0.57231755983078
                    ],
                    [
                        121.46361529827,
                        0.5719983928725
                    ],
                    [
                        121.46358579397,
                        0.57178114476469
                    ],
                    [
                        121.46339535713,
                        0.57166849759444
                    ],
                    [
                        121.46325320005,
                        0.57148879853256
                    ],
                    [
                        121.4630869031,
                        0.5711830419069
                    ],
                    [
                        121.46297693253,
                        0.57090142394782
                    ],
                    [
                        121.46296083927,
                        0.57057152860677
                    ],
                    [
                        121.46310836077,
                        0.57036232667339
                    ],
                    [
                        121.46313250065,
                        0.57027918231313
                    ],
                    [
                        121.46309226751,
                        0.57005656998784
                    ],
                    [
                        121.4630278945,
                        0.56984200388303
                    ],
                    [
                        121.46289646626,
                        0.56955233962884
                    ],
                    [
                        121.46270602942,
                        0.5693029065094
                    ],
                    [
                        121.46247804165,
                        0.5690668837628
                    ],
                    [
                        121.46223396063,
                        0.56876649116225
                    ],
                    [
                        121.46198183298,
                        0.56858142785592
                    ],
                    [
                        121.46180212498,
                        0.56850901177791
                    ],
                    [
                        121.46161168814,
                        0.56850632970093
                    ],
                    [
                        121.46129250526,
                        0.568495601393
                    ],
                    [
                        121.46108329296,
                        0.5683856362355
                    ],
                    [
                        121.46090090275,
                        0.56828371730718
                    ],
                    [
                        121.46065950394,
                        0.56798868882035
                    ],
                    [
                        121.46042615175,
                        0.56780362548908
                    ],
                    [
                        121.46024107933,
                        0.5676212442293
                    ],
                    [
                        121.46001577377,
                        0.56735303648387
                    ],
                    [
                        121.45973414183,
                        0.56718942975306
                    ],
                    [
                        121.45936399698,
                        0.5669936380855
                    ],
                    [
                        121.45905286074,
                        0.5667415227778
                    ],
                    [
                        121.45898714662,
                        0.5666087599252
                    ],
                    [
                        121.45891606808,
                        0.56652695654985
                    ],
                    [
                        121.45884767175,
                        0.56648270226436
                    ],
                    [
                        121.45872563124,
                        0.56647733810851
                    ],
                    [
                        121.45850971341,
                        0.56639553473131
                    ],
                    [
                        121.45844131708,
                        0.56636066771772
                    ],
                    [
                        121.45828574896,
                        0.56628825161192
                    ],
                    [
                        121.45813420415,
                        0.56617828641248
                    ],
                    [
                        121.45799472928,
                        0.56605491082039
                    ],
                    [
                        121.45778417587,
                        0.56584570872344
                    ],
                    [
                        121.45749986172,
                        0.56560432167915
                    ],
                    [
                        121.45727723837,
                        0.56540584787965
                    ],
                    [
                        121.45707607269,
                        0.56528515434961
                    ],
                    [
                        121.4568990469,
                        0.56509204469631
                    ],
                    [
                        121.45678639412,
                        0.56495794076665
                    ],
                    [
                        121.45660668612,
                        0.56476751318119
                    ],
                    [
                        121.45646989346,
                        0.56455562895906
                    ],
                    [
                        121.45634114742,
                        0.56436788343933
                    ],
                    [
                        121.45625531673,
                        0.56424450780879
                    ],
                    [
                        121.4562150836,
                        0.56416672751862
                    ],
                    [
                        121.45618021488,
                        0.56411308593858
                    ],
                    [
                        121.456156075,
                        0.56408090099032
                    ],
                    [
                        121.45610243082,
                        0.56404335188379
                    ],
                    [
                        121.45601928234,
                        0.5640326235676
                    ],
                    [
                        121.45593076944,
                        0.56400580277703
                    ],
                    [
                        121.45584493876,
                        0.56400312069797
                    ],
                    [
                        121.4557081461,
                        0.56399775653985
                    ],
                    [
                        121.45554989576,
                        0.56397898198633
                    ],
                    [
                        121.455501616,
                        0.56392534040458
                    ],
                    [
                        121.45542919636,
                        0.56386365258492
                    ],
                    [
                        121.45537555218,
                        0.56379391852716
                    ],
                    [
                        121.45519584417,
                        0.56366786080523
                    ],
                    [
                        121.45498126745,
                        0.56347206901893
                    ],
                    [
                        121.45469963551,
                        0.56324409227318
                    ],
                    [
                        121.45455747843,
                        0.56312608077775
                    ],
                    [
                        121.45448237658,
                        0.56296783808698
                    ],
                    [
                        121.45443946123,
                        0.56282568786954
                    ],
                    [
                        121.45451188087,
                        0.56258430069995
                    ],
                    [
                        121.45455345511,
                        0.56234157248044
                    ],
                    [
                        121.45453602076,
                        0.5621363933699
                    ],
                    [
                        121.45451188087,
                        0.56190975761197
                    ],
                    [
                        121.45448639989,
                        0.56171128368656
                    ],
                    [
                        121.45445287228,
                        0.56158254383944
                    ],
                    [
                        121.4544609189,
                        0.56140016238451
                    ],
                    [
                        121.45452931523,
                        0.5612888560526
                    ],
                    [
                        121.45465537906,
                        0.56109842834731
                    ],
                    [
                        121.45476400852,
                        0.56090531855534
                    ],
                    [
                        121.45482301712,
                        0.56075512204608
                    ],
                    [
                        121.45498394966,
                        0.56054055559757
                    ],
                    [
                        121.45518779755,
                        0.56040645156326
                    ],
                    [
                        121.45534336567,
                        0.56036353827164
                    ],
                    [
                        121.45560622215,
                        0.56019724926363
                    ],
                    [
                        121.45572960377,
                        0.5600685093832
                    ],
                    [
                        121.45589590073,
                        0.55990758452871
                    ],
                    [
                        121.45605683327,
                        0.55985394290956
                    ],
                    [
                        121.45635724068,
                        0.55968228972499
                    ],
                    [
                        121.45684540272,
                        0.55944090242568
                    ],
                    [
                        121.45724236965,
                        0.55926388506655
                    ],
                    [
                        121.45751059055,
                        0.55915123765342
                    ],
                    [
                        121.45796120167,
                        0.55899567693648
                    ],
                    [
                        121.45838499069,
                        0.55885084454116
                    ],
                    [
                        121.45891070366,
                        0.55872746879416
                    ],
                    [
                        121.45931839943,
                        0.55858800055532
                    ],
                    [
                        121.45988702774,
                        0.55852899476097
                    ],
                    [
                        121.45995810628,
                        0.55853704100568
                    ],
                    [
                        121.46033629775,
                        0.55856252078055
                    ],
                    [
                        121.4605589211,
                        0.55857593118834
                    ],
                    [
                        121.46083787084,
                        0.55860677512612
                    ],
                    [
                        121.46106183529,
                        0.55860409304458
                    ],
                    [
                        121.46133810282,
                        0.55859470575918
                    ],
                    [
                        121.46157413721,
                        0.55857459014756
                    ],
                    [
                        121.46183565259,
                        0.55853704100568
                    ],
                    [
                        121.46204352379,
                        0.55851290227148
                    ],
                    [
                        121.46227017045,
                        0.55848474041481
                    ],
                    [
                        121.4624324441,
                        0.55847267104762
                    ],
                    [
                        121.46257862449,
                        0.55844048606833
                    ],
                    [
                        121.4626416564,
                        0.55844316814994
                    ],
                    [
                        121.4627301693,
                        0.55842975774185
                    ],
                    [
                        121.46283745766,
                        0.55840293692559
                    ],
                    [
                        121.46293535829,
                        0.55833588488439
                    ],
                    [
                        121.46307349205,
                        0.55819373455452
                    ],
                    [
                        121.46318480372,
                        0.55798319113511
                    ],
                    [
                        121.46327197552,
                        0.55781287893682
                    ],
                    [
                        121.46336987615,
                        0.55758221988876
                    ],
                    [
                        121.46340876818,
                        0.55743738745863
                    ],
                    [
                        121.46347045898,
                        0.55726841628563
                    ],
                    [
                        121.46352410316,
                        0.55712224280666
                    ],
                    [
                        121.46362870932,
                        0.55696802307721
                    ],
                    [
                        121.46374806762,
                        0.55681916750845
                    ],
                    [
                        121.4638620615,
                        0.5567092021309
                    ],
                    [
                        121.46399348974,
                        0.55657778009164
                    ],
                    [
                        121.4641302824,
                        0.556428924513
                    ],
                    [
                        121.46425098181,
                        0.55631761808689
                    ],
                    [
                        121.46442130208,
                        0.55618083187363
                    ],
                    [
                        121.46457955241,
                        0.55601856587142
                    ],
                    [
                        121.46467611194,
                        0.55591798776862
                    ],
                    [
                        121.46481692791,
                        0.55580399925007
                    ],
                    [
                        121.46493896842,
                        0.55569269281218
                    ],
                    [
                        121.46508380771,
                        0.55558943262094
                    ],
                    [
                        121.46522462368,
                        0.55549287763528
                    ],
                    [
                        121.4654096961,
                        0.55540839202155
                    ],
                    [
                        121.46556124091,
                        0.55534133994629
                    ],
                    [
                        121.46569669247,
                        0.55527562891179
                    ],
                    [
                        121.46592199802,
                        0.55518309704566
                    ],
                    [
                        121.46609768271,
                        0.55513213746659
                    ],
                    [
                        121.46635919809,
                        0.55506642642977
                    ],
                    [
                        121.46658048034,
                        0.55501144372494
                    ],
                    [
                        121.46684870124,
                        0.5549537789364
                    ],
                    [
                        121.46702438593,
                        0.55492964018753
                    ],
                    [
                        121.46726712584,
                        0.55488270373114
                    ],
                    [
                        121.46744683385,
                        0.55484649560737
                    ],
                    [
                        121.46760508418,
                        0.55480894644175
                    ],
                    [
                        121.46783307195,
                        0.55474055331805
                    ],
                    [
                        121.46802082658,
                        0.55468825269351
                    ],
                    [
                        121.46816566586,
                        0.55464668040188
                    ],
                    [
                        121.46831989288,
                        0.55458901560978
                    ],
                    [
                        121.46842449903,
                        0.55456085373435
                    ],
                    [
                        121.46859884262,
                        0.55448709644097
                    ],
                    [
                        121.46881073713,
                        0.55440931602149
                    ],
                    [
                        121.46899715066,
                        0.55432348935052
                    ],
                    [
                        121.4691889286,
                        0.55423632163657
                    ],
                    [
                        121.4694263041,
                        0.55415183600487
                    ],
                    [
                        121.4696328342,
                        0.55406869141379
                    ],
                    [
                        121.46980583668,
                        0.55400298036517
                    ],
                    [
                        121.47000834346,
                        0.55393458723216
                    ],
                    [
                        121.47019207478,
                        0.55386887618206
                    ],
                    [
                        121.47048845887,
                        0.55377098012646
                    ],
                    [
                        121.4706158638,
                        0.55374281824715
                    ],
                    [
                        121.47082775831,
                        0.55367442511115
                    ],
                    [
                        121.47101819515,
                        0.55361407822576
                    ],
                    [
                        121.47129714489,
                        0.55353495675289
                    ],
                    [
                        121.47149294615,
                        0.55348533820159
                    ],
                    [
                        121.47164583206,
                        0.55345449423704
                    ],
                    [
                        121.47179201245,
                        0.5534169450626
                    ],
                    [
                        121.47200524807,
                        0.55337269067813
                    ],
                    [
                        121.47225469351,
                        0.55333111837728
                    ],
                    [
                        121.47240489721,
                        0.553296251286
                    ],
                    [
                        121.47257387638,
                        0.55325736106857
                    ],
                    [
                        121.47280991077,
                        0.55321310668291
                    ],
                    [
                        121.47300973535,
                        0.55317287542295
                    ],
                    [
                        121.47313311696,
                        0.55315812396088
                    ],
                    [
                        121.47327527404,
                        0.55311789270053
                    ],
                    [
                        121.47337853909,
                        0.55307497935586
                    ],
                    [
                        121.47348985076,
                        0.55294623931997
                    ],
                    [
                        121.47353947163,
                        0.55284297908085
                    ],
                    [
                        121.47363737226,
                        0.55268473611351
                    ],
                    [
                        121.47376343608,
                        0.55247553354004
                    ],
                    [
                        121.4739471674,
                        0.55215770653933
                    ],
                    [
                        121.47404372692,
                        0.55199544042692
                    ],
                    [
                        121.47413894534,
                        0.55184658473315
                    ],
                    [
                        121.47425025702,
                        0.55167224923119
                    ],
                    [
                        121.47429853678,
                        0.55157569418174
                    ],
                    [
                        121.47435486317,
                        0.55146036453732
                    ],
                    [
                        121.47443935275,
                        0.55132223716952
                    ],
                    [
                        121.47454664111,
                        0.55120958960508
                    ],
                    [
                        121.47465929389,
                        0.55113315018512
                    ],
                    [
                        121.47479340434,
                        0.55108621369871
                    ],
                    [
                        121.47489398718,
                        0.55105805180668
                    ],
                    [
                        121.47502675653,
                        0.55105000555179
                    ],
                    [
                        121.47518500686,
                        0.55105671076421
                    ],
                    [
                        121.4753164351,
                        0.55110364725086
                    ],
                    [
                        121.47547870874,
                        0.5512015433504
                    ],
                    [
                        121.47562086582,
                        0.5512712775573
                    ],
                    [
                        121.47578850389,
                        0.55135576322996
                    ],
                    [
                        121.47593334317,
                        0.55141074596868
                    ],
                    [
                        121.4760620892,
                        0.55147243391881
                    ],
                    [
                        121.47616401315,
                        0.55151668831743
                    ],
                    [
                        121.47630885243,
                        0.55156496584282
                    ],
                    [
                        121.47642150521,
                        0.55160251502898
                    ],
                    [
                        121.47659316659,
                        0.55161458441018
                    ],
                    [
                        121.47672593594,
                        0.55161458441018
                    ],
                    [
                        121.4768640697,
                        0.55161056128312
                    ],
                    [
                        121.47708132863,
                        0.55158910460537
                    ],
                    [
                        121.47720605135,
                        0.55155423750389
                    ],
                    [
                        121.47732138634,
                        0.5514925495546
                    ],
                    [
                        121.47745013237,
                        0.55141611013828
                    ],
                    [
                        121.47755473852,
                        0.5513503990603
                    ],
                    [
                        121.47774249315,
                        0.55126054921784
                    ],
                    [
                        121.47789001465,
                        0.55120958960508
                    ],
                    [
                        121.4780536294,
                        0.55118947396834
                    ],
                    [
                        121.47822663188,
                        0.55119081501079
                    ],
                    [
                        121.47837817669,
                        0.55118545084099
                    ],
                    [
                        121.47856190801,
                        0.5511881329259
                    ],
                    [
                        121.47870004177,
                        0.55118545084099
                    ],
                    [
                        121.47890388966,
                        0.55118276875608
                    ],
                    [
                        121.47902593017,
                        0.55115728894943
                    ],
                    [
                        121.47909164429,
                        0.55110498829332
                    ],
                    [
                        121.47916138172,
                        0.55099234072476
                    ],
                    [
                        121.4791841805,
                        0.55084884917601
                    ],
                    [
                        121.47920429707,
                        0.55060343838837
                    ],
                    [
                        121.47921770811,
                        0.55032718360987
                    ],
                    [
                        121.47925794125,
                        0.54998655876827
                    ],
                    [
                        121.47930085659,
                        0.54957083551006
                    ],
                    [
                        121.47933572531,
                        0.54915779430874
                    ],
                    [
                        121.47938668728,
                        0.54879034854072
                    ],
                    [
                        121.47941082716,
                        0.54839339980245
                    ],
                    [
                        121.47943764925,
                        0.54801254355586
                    ],
                    [
                        121.47947788239,
                        0.54760754850651
                    ],
                    [
                        121.4795127511,
                        0.54724010264336
                    ],
                    [
                        121.47955298424,
                        0.54688338510505
                    ],
                    [
                        121.47962003946,
                        0.54654812424144
                    ],
                    [
                        121.47968709469,
                        0.54608680526254
                    ],
                    [
                        121.4797487855,
                        0.54555575197555
                    ],
                    [
                        121.47979438305,
                        0.54530095366465
                    ],
                    [
                        121.47988289595,
                        0.54476721822054
                    ],
                    [
                        121.47992581129,
                        0.5446223854788
                    ],
                    [
                        121.47997409105,
                        0.5443488125127
                    ],
                    [
                        121.4800465107,
                        0.54405110074136
                    ],
                    [
                        121.48012697697,
                        0.54372388598477
                    ],
                    [
                        121.48017793894,
                        0.54353613980494
                    ],
                    [
                        121.48020476103,
                        0.54342349209424
                    ],
                    [
                        121.48023158312,
                        0.54327329514337
                    ],
                    [
                        121.48026376963,
                        0.54317673995869
                    ],
                    [
                        121.4803147316,
                        0.54283879680018
                    ],
                    [
                        121.48032009602,
                        0.54261886552818
                    ],
                    [
                        121.48034155369,
                        0.54222191638282
                    ],
                    [
                        121.48036837578,
                        0.5417337761819
                    ],
                    [
                        121.48038178682,
                        0.54141460756773
                    ],
                    [
                        121.48038715124,
                        0.54116785535031
                    ],
                    [
                        121.48039788008,
                        0.54093451357024
                    ],
                    [
                        121.48041397333,
                        0.54067166879575
                    ],
                    [
                        121.4804944396,
                        0.54033640758729
                    ],
                    [
                        121.48055076599,
                        0.54015134339228
                    ],
                    [
                        121.4807331562,
                        0.53972489109539
                    ],
                    [
                        121.48082435131,
                        0.53951032389068
                    ],
                    [
                        121.48106575012,
                        0.53902486556211
                    ],
                    [
                        121.48122131824,
                        0.53866546544861
                    ],
                    [
                        121.48135274649,
                        0.53836775339824
                    ],
                    [
                        121.48159682751,
                        0.537876930797
                    ],
                    [
                        121.48172289133,
                        0.53755507988951
                    ],
                    [
                        121.48192942142,
                        0.53715544832243
                    ],
                    [
                        121.48206621408,
                        0.53685505410714
                    ],
                    [
                        121.48219764233,
                        0.53653856732866
                    ],
                    [
                        121.48229956627,
                        0.53626231190693
                    ],
                    [
                        121.48232102394,
                        0.53592436836437
                    ],
                    [
                        121.4823397994,
                        0.53546573066965
                    ],
                    [
                        121.48235052824,
                        0.53516265427946
                    ],
                    [
                        121.48238003254,
                        0.53464769259098
                    ],
                    [
                        121.48240149021,
                        0.5342668354811
                    ],
                    [
                        121.48246586323,
                        0.53392620973606
                    ],
                    [
                        121.48254096508,
                        0.5336204511772
                    ],
                    [
                        121.48261338472,
                        0.53329323586053
                    ],
                    [
                        121.4826670289,
                        0.53310817145242
                    ],
                    [
                        121.48274213076,
                        0.53278900238767
                    ],
                    [
                        121.48279309273,
                        0.53255834238102
                    ],
                    [
                        121.48288697004,
                        0.53220967026154
                    ],
                    [
                        121.48298621178,
                        0.53184222346816
                    ],
                    [
                        121.48304522038,
                        0.53157669620968
                    ],
                    [
                        121.48310959339,
                        0.53118511053495
                    ],
                    [
                        121.48319274187,
                        0.53078547855363
                    ],
                    [
                        121.48323297501,
                        0.53049313030933
                    ],
                    [
                        121.48328125477,
                        0.53026783440522
                    ],
                    [
                        121.4833509922,
                        0.5299728040422
                    ],
                    [
                        121.4834100008,
                        0.52963486015457
                    ],
                    [
                        121.48350387812,
                        0.52928350577567
                    ],
                    [
                        121.48357629776,
                        0.52888923786114
                    ],
                    [
                        121.48371309042,
                        0.52847619525715
                    ],
                    [
                        121.48385792971,
                        0.52802292119909
                    ],
                    [
                        121.48397058249,
                        0.52762597110927
                    ],
                    [
                        121.48405373096,
                        0.52740335719645
                    ],
                    [
                        121.48424685001,
                        0.52677306474953
                    ],
                    [
                        121.48449346865,
                        0.52618606766927
                    ],
                    [
                        121.48461685026,
                        0.52582666680739
                    ],
                    [
                        121.48482069815,
                        0.52536266417152
                    ],
                    [
                        121.48509696567,
                        0.52483160908934
                    ],
                    [
                        121.4853410467,
                        0.52431128234894
                    ],
                    [
                        121.4854912504,
                        0.52395188137928
                    ],
                    [
                        121.48580789566,
                        0.5232648826482
                    ],
                    [
                        121.4860573411,
                        0.52268286753764
                    ],
                    [
                        121.48620377394,
                        0.52235925990534
                    ],
                    [
                        121.48630033346,
                        0.52223320131941
                    ],
                    [
                        121.48638616415,
                        0.5221205532192
                    ],
                    [
                        121.48671607586,
                        0.52180942988433
                    ],
                    [
                        121.4871452293,
                        0.52145807506525
                    ],
                    [
                        121.48730884405,
                        0.52135615534306
                    ],
                    [
                        121.48740808579,
                        0.52126764610931
                    ],
                    [
                        121.48748318764,
                        0.52119791156062
                    ],
                    [
                        121.48742954346,
                        0.52114426959956
                    ],
                    [
                        121.48695856333,
                        0.52062301639091
                    ],
                    [
                        121.48666620255,
                        0.52036821704861
                    ],
                    [
                        121.48633360863,
                        0.52002490844478
                    ],
                    [
                        121.48614183068,
                        0.51983045629762
                    ],
                    [
                        121.48588702083,
                        0.51959845476248
                    ],
                    [
                        121.48571267724,
                        0.51943484673837
                    ],
                    [
                        121.48546591401,
                        0.51919613994147
                    ],
                    [
                        121.4852540195,
                        0.51899632357086
                    ],
                    [
                        121.48500457406,
                        0.51877639145094
                    ],
                    [
                        121.48475378752,
                        0.51855645932338
                    ],
                    [
                        121.48445740342,
                        0.51830165989774
                    ],
                    [
                        121.48423343897,
                        0.51810184349889
                    ],
                    [
                        121.4840041101,
                        0.51790336814345
                    ],
                    [
                        121.48387402296,
                        0.51777730946852
                    ],
                    [
                        121.48367151618,
                        0.5176002908995
                    ],
                    [
                        121.48354947567,
                        0.51749568901548
                    ],
                    [
                        121.48335635662,
                        0.51736963033246
                    ],
                    [
                        121.48319274187,
                        0.51727307474376
                    ],
                    [
                        121.48304924369,
                        0.51719931700142
                    ],
                    [
                        121.48288562894,
                        0.51713628765727
                    ],
                    [
                        121.48280516267,
                        0.51706923516282
                    ],
                    [
                        121.48267239332,
                        0.51698743111862
                    ],
                    [
                        121.48243904114,
                        0.51680504832776
                    ],
                    [
                        121.48228481412,
                        0.51670983378045
                    ],
                    [
                        121.48205816746,
                        0.51656768248183
                    ],
                    [
                        121.48187041283,
                        0.5164577163807
                    ],
                    [
                        121.48167729378,
                        0.51633836292732
                    ],
                    [
                        121.48150160909,
                        0.51621632737155
                    ],
                    [
                        121.48127228022,
                        0.51609697391364
                    ],
                    [
                        121.4807613194,
                        0.51577378083101
                    ],
                    [
                        121.48047298193,
                        0.51559005695512
                    ],
                    [
                        121.48027583957,
                        0.51547606768639
                    ],
                    [
                        121.4799298346,
                        0.51526015859535
                    ],
                    [
                        121.47975683212,
                        0.51515823877342
                    ],
                    [
                        121.47954896092,
                        0.51502279269176
                    ],
                    [
                        121.47929012775,
                        0.51486052560006
                    ],
                    [
                        121.4790661633,
                        0.51472507951207
                    ],
                    [
                        121.47884622216,
                        0.51457219976576
                    ],
                    [
                        121.47847339511,
                        0.51435494959363
                    ],
                    [
                        121.47816762328,
                        0.51416317937381
                    ],
                    [
                        121.47790074348,
                        0.51399286595698
                    ],
                    [
                        121.47757083178,
                        0.51380243677687
                    ],
                    [
                        121.47741392255,
                        0.51372465584252
                    ],
                    [
                        121.47718325257,
                        0.51360932548985
                    ],
                    [
                        121.47706523538,
                        0.51353288560379
                    ],
                    [
                        121.47690162063,
                        0.51342828365295
                    ],
                    [
                        121.47675409913,
                        0.5133478206127
                    ],
                    [
                        121.47657841444,
                        0.51324992391234
                    ],
                    [
                        121.47645771503,
                        0.51316811981912
                    ],
                    [
                        121.47631958127,
                        0.5130809515219
                    ],
                    [
                        121.47608220577,
                        0.5129414822439
                    ],
                    [
                        121.4759118855,
                        0.5128543139436
                    ],
                    [
                        121.47574692965,
                        0.51275507618489
                    ],
                    [
                        121.47557392716,
                        0.51267461313616
                    ],
                    [
                        121.47540092468,
                        0.51257135222215
                    ],
                    [
                        121.47518634796,
                        0.51245199869608
                    ],
                    [
                        121.47498384118,
                        0.51233935042225
                    ],
                    [
                        121.47471427917,
                        0.51218378851702
                    ],
                    [
                        121.47458821535,
                        0.51210868966488
                    ],
                    [
                        121.47452116013,
                        0.51210332546112
                    ],
                    [
                        121.47418990731,
                        0.51190484991891
                    ],
                    [
                        121.47398471832,
                        0.51177476797237
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1608,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.012355480835191548,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44985690713,
                        0.59444866013974
                    ],
                    [
                        121.45024314523,
                        0.59415497405205
                    ],
                    [
                        121.45035579801,
                        0.59413217650121
                    ],
                    [
                        121.45050063729,
                        0.59411608411233
                    ],
                    [
                        121.45065352321,
                        0.59405439662116
                    ],
                    [
                        121.45088151097,
                        0.5940356221672
                    ],
                    [
                        121.45104780793,
                        0.59394979609111
                    ],
                    [
                        121.45127311349,
                        0.5938881085981
                    ],
                    [
                        121.45147830248,
                        0.59384117246164
                    ],
                    [
                        121.45167008042,
                        0.59379289529231
                    ],
                    [
                        121.45191952586,
                        0.59374193605756
                    ],
                    [
                        121.45211398602,
                        0.59368427165978
                    ],
                    [
                        121.45228028297,
                        0.5936440406842
                    ],
                    [
                        121.45241439343,
                        0.59362124313126
                    ],
                    [
                        121.45253241062,
                        0.59359308144809
                    ],
                    [
                        121.45259410143,
                        0.59353809911384
                    ],
                    [
                        121.45264774561,
                        0.59347104748597
                    ],
                    [
                        121.45280465484,
                        0.59347238851854
                    ],
                    [
                        121.45295485854,
                        0.59351932465812
                    ],
                    [
                        121.45325794816,
                        0.59365208687935
                    ],
                    [
                        121.45342692733,
                        0.5938264211044
                    ],
                    [
                        121.45364820957,
                        0.59400746048615
                    ],
                    [
                        121.45394459366,
                        0.59421934359648
                    ],
                    [
                        121.45426645874,
                        0.5944164753534
                    ],
                    [
                        121.45449578761,
                        0.59460958400642
                    ],
                    [
                        121.4546701312,
                        0.5947584385885
                    ],
                    [
                        121.45480290054,
                        0.59476514374976
                    ],
                    [
                        121.45497992634,
                        0.59475709755624
                    ],
                    [
                        121.45511269569,
                        0.59473698207241
                    ],
                    [
                        121.4552347362,
                        0.5946524970395
                    ],
                    [
                        121.45546272396,
                        0.59446072942031
                    ],
                    [
                        121.45573899149,
                        0.59431589792728
                    ],
                    [
                        121.45604744553,
                        0.59420191017546
                    ],
                    [
                        121.45620971917,
                        0.59407183003229
                    ],
                    [
                        121.45636394619,
                        0.59392163439923
                    ],
                    [
                        121.4564846456,
                        0.59380764663929
                    ],
                    [
                        121.4566630125,
                        0.59367086132424
                    ],
                    [
                        121.45677030086,
                        0.59359844556785
                    ],
                    [
                        121.45689904689,
                        0.59354078116857
                    ],
                    [
                        121.45704388618,
                        0.59347909367099
                    ],
                    [
                        121.45717799663,
                        0.59344959095452
                    ],
                    [
                        121.45734027027,
                        0.59345361405223
                    ],
                    [
                        121.45753204823,
                        0.59350859639768
                    ],
                    [
                        121.45765140653,
                        0.59355150943931
                    ],
                    [
                        121.45777478814,
                        0.59359308144809
                    ],
                    [
                        121.45789548755,
                        0.59367622546468
                    ],
                    [
                        121.45808592439,
                        0.59378216703241
                    ],
                    [
                        121.45824685693,
                        0.59387469827344
                    ],
                    [
                        121.45838096738,
                        0.59394040886395
                    ],
                    [
                        121.45849764347,
                        0.59394979609111
                    ],
                    [
                        121.45864114165,
                        0.59393236266925
                    ],
                    [
                        121.45877256989,
                        0.59385860588381
                    ],
                    [
                        121.45889729261,
                        0.59370438714744
                    ],
                    [
                        121.45901530981,
                        0.5934737295511
                    ],
                    [
                        121.45915746689,
                        0.59327525672795
                    ],
                    [
                        121.45936667919,
                        0.59300570916619
                    ],
                    [
                        121.45953431726,
                        0.5927898029008
                    ],
                    [
                        121.45966976881,
                        0.592555122168
                    ],
                    [
                        121.45999833941,
                        0.59236201344324
                    ],
                    [
                        121.46020486951,
                        0.59217560987618
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2115,
                "jenis_pipa": "Pipa 250",
                "keterangan": "TRANSMISI",
                "panjang": 0.0003055395099089968,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07236517351,
                        0.51189713154296
                    ],
                    [
                        122.07224985964,
                        0.5116194175486
                    ],
                    [
                        122.07225254135,
                        0.51162344238918
                    ],
                    [
                        122.07225254135,
                        0.51162344238918
                    ],
                    [
                        122.07225254135,
                        0.51162344238918
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2116,
                "jenis_pipa": "Pipa 200",
                "keterangan": "TRANSMISI",
                "panjang": 0.0003381657137408903,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07224586013,
                        0.51161222855449
                    ],
                    [
                        122.07214261399,
                        0.51135329713802
                    ],
                    [
                        122.07216406773,
                        0.51132512325268
                    ],
                    [
                        122.07215334086,
                        0.51130365743521
                    ],
                    [
                        122.07215334086,
                        0.51130365743521
                    ],
                    [
                        122.07215334086,
                        0.51130365743521
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2118,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0006215009827062084,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94819658995,
                        0.47749553879972
                    ],
                    [
                        121.94802224636,
                        0.47726072349328
                    ],
                    [
                        121.94780901074,
                        0.47701651556608
                    ],
                    [
                        121.94780901074,
                        0.47701651556608
                    ],
                    [
                        121.94780632854,
                        0.47702054097154
                    ],
                    [
                        121.94780632854,
                        0.47702054097154
                    ],
                    [
                        121.94780632854,
                        0.47702054097154
                    ],
                    [
                        121.94780632854,
                        0.47702054097154
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2120,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0006194738041369994,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94157153368,
                        0.46892670806995
                    ],
                    [
                        121.94095730782,
                        0.46900717164502
                    ],
                    [
                        121.94095730782,
                        0.46900717164502
                    ],
                    [
                        121.94095730782,
                        0.46900717164502
                    ],
                    [
                        121.94095730782,
                        0.46900717164502
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2152,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.007372123091332496,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.03600138426,
                        0.48003335473146
                    ],
                    [
                        122.03600138426,
                        0.47971686516847
                    ],
                    [
                        122.03597974388,
                        0.47948894756078
                    ],
                    [
                        122.03596901505,
                        0.47915904739653
                    ],
                    [
                        122.035955604,
                        0.47895386557904
                    ],
                    [
                        122.03594621627,
                        0.47875538904388
                    ],
                    [
                        122.03594353406,
                        0.4784925417317
                    ],
                    [
                        122.03593012301,
                        0.47819214479116
                    ],
                    [
                        122.03590866534,
                        0.47790918158961
                    ],
                    [
                        122.03588739038,
                        0.47752289474519
                    ],
                    [
                        122.03585386276,
                        0.47713398793442
                    ],
                    [
                        122.03582704067,
                        0.47666595867438
                    ],
                    [
                        122.03579217196,
                        0.47611880694896
                    ],
                    [
                        122.0357760787,
                        0.47578354238988
                    ],
                    [
                        122.03576534986,
                        0.47558506576323
                    ],
                    [
                        122.03578680754,
                        0.47546973474782
                    ],
                    [
                        122.03586190939,
                        0.47529539716272
                    ],
                    [
                        122.03597187996,
                        0.47502718548476
                    ],
                    [
                        122.03606307507,
                        0.47479652343338
                    ],
                    [
                        122.03612208366,
                        0.47461413948033
                    ],
                    [
                        122.03616768122,
                        0.47443443763955
                    ],
                    [
                        122.0362213254,
                        0.47416354381102
                    ],
                    [
                        122.03626692295,
                        0.47385778244728
                    ],
                    [
                        122.036280334,
                        0.47363516670905
                    ],
                    [
                        122.03626424074,
                        0.47359761706576
                    ],
                    [
                        122.03618645668,
                        0.47355470318745
                    ],
                    [
                        122.03583776951,
                        0.4734742396649
                    ],
                    [
                        122.03545689583,
                        0.47340986884621
                    ],
                    [
                        122.03546762466,
                        0.47341523308112
                    ],
                    [
                        122.03546762466,
                        0.47341523308112
                    ],
                    [
                        122.03546762466,
                        0.47341523308112
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2129,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.013919985222111856,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64964526892,
                        0.55102318470208
                    ],
                    [
                        121.64950847626,
                        0.55114656060975
                    ],
                    [
                        121.64942800999,
                        0.55120690752017
                    ],
                    [
                        121.64918795228,
                        0.55131284987257
                    ],
                    [
                        121.64892107248,
                        0.55141476909588
                    ],
                    [
                        121.64860859513,
                        0.55152741665645
                    ],
                    [
                        121.64823442698,
                        0.55164811046897
                    ],
                    [
                        121.64794072509,
                        0.55175002968654
                    ],
                    [
                        121.64775162935,
                        0.55180501242161
                    ],
                    [
                        121.64732784033,
                        0.55192302414393
                    ],
                    [
                        121.64701670408,
                        0.55201823814546
                    ],
                    [
                        121.646874547,
                        0.5520745619203
                    ],
                    [
                        121.64663985372,
                        0.55215368341262
                    ],
                    [
                        121.6464856267,
                        0.55220061989063
                    ],
                    [
                        121.64630055428,
                        0.55225560262152
                    ],
                    [
                        121.64616912603,
                        0.5523213136895
                    ],
                    [
                        121.64598673582,
                        0.55245273582325
                    ],
                    [
                        121.64586737752,
                        0.55257477065914
                    ],
                    [
                        121.64576679468,
                        0.55267534881869
                    ],
                    [
                        121.64563804865,
                        0.55279201948166
                    ],
                    [
                        121.64551466703,
                        0.55286711783821
                    ],
                    [
                        121.64537385106,
                        0.55292478264706
                    ],
                    [
                        121.64528131485,
                        0.5529516034882
                    ],
                    [
                        121.64517402649,
                        0.55297037807692
                    ],
                    [
                        121.64488166571,
                        0.55300256308602
                    ],
                    [
                        121.64461478591,
                        0.55301329142235
                    ],
                    [
                        121.64433717728,
                        0.55301597350642
                    ],
                    [
                        121.64399519563,
                        0.55300524517011
                    ],
                    [
                        121.64351776242,
                        0.55298244745536
                    ],
                    [
                        121.64318650961,
                        0.55297171911897
                    ],
                    [
                        121.64280965924,
                        0.55297976537126
                    ],
                    [
                        121.64265543222,
                        0.55298781162353
                    ],
                    [
                        121.64241403341,
                        0.55299451683376
                    ],
                    [
                        121.64224103093,
                        0.55299853995989
                    ],
                    [
                        121.642023772,
                        0.55302267871662
                    ],
                    [
                        121.64182931185,
                        0.55304949955732
                    ],
                    [
                        121.64166167378,
                        0.55307632039789
                    ],
                    [
                        121.64118289948,
                        0.55320103730496
                    ],
                    [
                        121.64089456201,
                        0.5532841819082
                    ],
                    [
                        121.64025217295,
                        0.55346924569836
                    ],
                    [
                        121.63988739252,
                        0.55358591634571
                    ],
                    [
                        121.63959905505,
                        0.5536797892787
                    ],
                    [
                        121.63941934705,
                        0.55375220554026
                    ],
                    [
                        121.63927718997,
                        0.55381523450796
                    ],
                    [
                        121.63903176785,
                        0.55395470285959
                    ],
                    [
                        121.63858652115,
                        0.55423766267831
                    ],
                    [
                        121.63847520947,
                        0.55430605580783
                    ],
                    [
                        121.63843095303,
                        0.55433958185142
                    ],
                    [
                        121.63834244013,
                        0.55443077268903
                    ],
                    [
                        121.63803800941,
                        0.55478748977559
                    ],
                    [
                        121.63790926337,
                        0.55494036852038
                    ],
                    [
                        121.63776442409,
                        0.55509727038592
                    ],
                    [
                        121.63772419095,
                        0.55514286579906
                    ],
                    [
                        121.63765847683,
                        0.55521125891812
                    ],
                    [
                        121.63757532835,
                        0.55529038036858
                    ],
                    [
                        121.63748413324,
                        0.55538291223304
                    ],
                    [
                        121.63739964366,
                        0.55546605680566
                    ],
                    [
                        121.63724675775,
                        0.55557199908198
                    ],
                    [
                        121.63711667061,
                        0.55565112052761
                    ],
                    [
                        121.63704022765,
                        0.55570073906078
                    ],
                    [
                        121.63704022765,
                        0.55570073906078
                    ],
                    [
                        121.63704022765,
                        0.55570073906078
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2128,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0007429455906392276,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64965197444,
                        0.567463001661
                    ],
                    [
                        121.6496399045,
                        0.56739594972398
                    ],
                    [
                        121.64958223701,
                        0.56724843545979
                    ],
                    [
                        121.6495500505,
                        0.56709421599774
                    ],
                    [
                        121.64951384068,
                        0.56692122198761
                    ],
                    [
                        121.64947092533,
                        0.56674420485561
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2131,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.010765856731849278,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64971768856,
                        0.55096820195979
                    ],
                    [
                        121.64977267385,
                        0.55090651400443
                    ],
                    [
                        121.65007710457,
                        0.55061953089934
                    ],
                    [
                        121.65025681257,
                        0.55044117223362
                    ],
                    [
                        121.65043115616,
                        0.55027354190381
                    ],
                    [
                        121.65060549974,
                        0.55010859365469
                    ],
                    [
                        121.65081337094,
                        0.54991950663182
                    ],
                    [
                        121.65112048388,
                        0.54967543684872
                    ],
                    [
                        121.65136188269,
                        0.54952255796852
                    ],
                    [
                        121.65152013302,
                        0.54940454619867
                    ],
                    [
                        121.65179640055,
                        0.54921948228218
                    ],
                    [
                        121.65230602026,
                        0.54895663786918
                    ],
                    [
                        121.65256887674,
                        0.54882789774433
                    ],
                    [
                        121.65278345346,
                        0.54873804786388
                    ],
                    [
                        121.6529712081,
                        0.54869781657368
                    ],
                    [
                        121.65326222777,
                        0.54868574718657
                    ],
                    [
                        121.65348619223,
                        0.54869245240164
                    ],
                    [
                        121.65381610394,
                        0.5487018397027
                    ],
                    [
                        121.65411919355,
                        0.54873402473487
                    ],
                    [
                        121.65497481823,
                        0.54883728504519
                    ],
                    [
                        121.65543347597,
                        0.54888958572117
                    ],
                    [
                        121.65605977178,
                        0.5489673662128
                    ],
                    [
                        121.65629714727,
                        0.54900357437236
                    ],
                    [
                        121.65659755468,
                        0.54902369001645
                    ],
                    [
                        121.65676116943,
                        0.54901564375882
                    ],
                    [
                        121.6569006443,
                        0.5489780945564
                    ],
                    [
                        121.65715545416,
                        0.54887885737741
                    ],
                    [
                        121.65732175112,
                        0.54878498436875
                    ],
                    [
                        121.65763556957,
                        0.54861064877733
                    ],
                    [
                        121.65777236223,
                        0.54853018619497
                    ],
                    [
                        121.65790915489,
                        0.54848727281726
                    ],
                    [
                        121.6580298543,
                        0.54845508778377
                    ],
                    [
                        121.65824979544,
                        0.54836389685464
                    ],
                    [
                        121.65845498443,
                        0.54822711045833
                    ],
                    [
                        121.65854483843,
                        0.54811714492177
                    ],
                    [
                        121.6586253047,
                        0.54796963017444
                    ],
                    [
                        121.65870040655,
                        0.54779529455929
                    ],
                    [
                        121.65876209736,
                        0.54758877390091
                    ],
                    [
                        121.65879160166,
                        0.54745735166006
                    ],
                    [
                        121.65881708264,
                        0.54735543236925
                    ],
                    [
                        121.65883183479,
                        0.54725083099004
                    ],
                    [
                        121.65883183479,
                        0.54725083099004
                    ],
                    [
                        121.65883183479,
                        0.54725083099004
                    ],
                    [
                        121.65883183479,
                        0.54725083099004
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2132,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.006263713799065186,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.65327295661,
                        0.54867233675641
                    ],
                    [
                        121.65326625109,
                        0.5486133308634
                    ],
                    [
                        121.65326625109,
                        0.54859187417487
                    ],
                    [
                        121.65324479342,
                        0.5484617929991
                    ],
                    [
                        121.65319785476,
                        0.54826600070858
                    ],
                    [
                        121.65317103267,
                        0.54817346873343
                    ],
                    [
                        121.65313482285,
                        0.5480903240589
                    ],
                    [
                        121.65311738849,
                        0.54801522564219
                    ],
                    [
                        121.65310800076,
                        0.54792805783591
                    ],
                    [
                        121.65310263634,
                        0.54785832358997
                    ],
                    [
                        121.65309861302,
                        0.54775908639242
                    ],
                    [
                        121.6530905664,
                        0.54763034624181
                    ],
                    [
                        121.65309593081,
                        0.54749087774218
                    ],
                    [
                        121.65308788419,
                        0.54737957114882
                    ],
                    [
                        121.65306642652,
                        0.54727094664004
                    ],
                    [
                        121.65306776762,
                        0.54718646090963
                    ],
                    [
                        121.65308386087,
                        0.5471153856117
                    ],
                    [
                        121.65310934186,
                        0.54702419466218
                    ],
                    [
                        121.65313884616,
                        0.54696116562273
                    ],
                    [
                        121.65320858359,
                        0.54684717693268
                    ],
                    [
                        121.65329039097,
                        0.54674525763152
                    ],
                    [
                        121.65337488055,
                        0.54667150024144
                    ],
                    [
                        121.65333196521,
                        0.54661517641566
                    ],
                    [
                        121.65326088667,
                        0.54655080632842
                    ],
                    [
                        121.65320321918,
                        0.54648241311
                    ],
                    [
                        121.65309727192,
                        0.54640597362963
                    ],
                    [
                        121.65300741792,
                        0.54636976545439
                    ],
                    [
                        121.65292158723,
                        0.54634964980137
                    ],
                    [
                        121.65281966329,
                        0.54632148788705
                    ],
                    [
                        121.65271773934,
                        0.54626650510156
                    ],
                    [
                        121.65257155895,
                        0.5461538574419
                    ],
                    [
                        121.6524964571,
                        0.54611496717796
                    ],
                    [
                        121.65236368775,
                        0.54608010004458
                    ],
                    [
                        121.65211156011,
                        0.54604791499816
                    ],
                    [
                        121.6517521441,
                        0.54600768368993
                    ],
                    [
                        121.65129616857,
                        0.5460157299516
                    ],
                    [
                        121.65089249611,
                        0.54601438890798
                    ],
                    [
                        121.65074363351,
                        0.5460318224749
                    ],
                    [
                        121.65064707398,
                        0.54604120978015
                    ],
                    [
                        121.650531739,
                        0.54604255082375
                    ],
                    [
                        121.65027961135,
                        0.54599695534102
                    ],
                    [
                        121.65010392666,
                        0.5459433135962
                    ],
                    [
                        121.64975658059,
                        0.54582664279953
                    ],
                    [
                        121.6494615376,
                        0.5458065271447
                    ],
                    [
                        121.6494615376,
                        0.5458065271447
                    ],
                    [
                        121.6494615376,
                        0.5458065271447
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2134,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0010272843079610586,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.65005028248,
                        0.54593392629079
                    ],
                    [
                        121.6499362886,
                        0.54647838997947
                    ],
                    [
                        121.64985850453,
                        0.54678951206514
                    ],
                    [
                        121.64983838797,
                        0.54686192841033
                    ],
                    [
                        121.64983838797,
                        0.54686192841033
                    ],
                    [
                        121.6498182714,
                        0.54693434475468
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2135,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00048789723815386717,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.65039494634,
                        0.54667954650221
                    ],
                    [
                        121.64992153645,
                        0.54656153467635
                    ],
                    [
                        121.64992153645,
                        0.54656153467635
                    ],
                    [
                        121.64992153645,
                        0.54656153467635
                    ],
                    [
                        121.64992153645,
                        0.54656153467635
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2136,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0005871024546008039,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64991885424,
                        0.54652532650203
                    ],
                    [
                        121.64934486151,
                        0.54640195049906
                    ],
                    [
                        121.64934486151,
                        0.54640195049906
                    ],
                    [
                        121.64934486151,
                        0.54640195049906
                    ],
                    [
                        121.64934486151,
                        0.54640195049906
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2138,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.001219955212295901,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64927914739,
                        0.54668088754567
                    ],
                    [
                        121.64982095361,
                        0.54680158145606
                    ],
                    [
                        121.65011867881,
                        0.54687399780113
                    ],
                    [
                        121.65046736598,
                        0.54695714249253
                    ],
                    [
                        121.65046736598,
                        0.54695714249253
                    ],
                    [
                        121.65046736598,
                        0.54695714249253
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2140,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0006141491666597128,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64998188615,
                        0.5462329790126
                    ],
                    [
                        121.6496117413,
                        0.54613910596251
                    ],
                    [
                        121.64939314127,
                        0.54607339482658
                    ],
                    [
                        121.64939716458,
                        0.54607339482658
                    ],
                    [
                        121.64939716458,
                        0.54607339482658
                    ],
                    [
                        121.64939716458,
                        0.54607339482658
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2139,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0004879490709186203,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.65045395494,
                        0.54638049380263
                    ],
                    [
                        121.64998322725,
                        0.54626918718867
                    ],
                    [
                        121.64998188615,
                        0.546265164058
                    ],
                    [
                        121.64998188615,
                        0.546265164058
                    ],
                    [
                        121.64998188615,
                        0.546265164058
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2142,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0026170328326565813,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63825929165,
                        0.55454342019236
                    ],
                    [
                        121.63828343153,
                        0.55461047227667
                    ],
                    [
                        121.63829550147,
                        0.55465606769357
                    ],
                    [
                        121.63825929165,
                        0.55472446081825
                    ],
                    [
                        121.63832902908,
                        0.55501278476653
                    ],
                    [
                        121.63838535547,
                        0.55521125891812
                    ],
                    [
                        121.6384524107,
                        0.55557334012345
                    ],
                    [
                        121.63850069046,
                        0.55576108592487
                    ],
                    [
                        121.63856774569,
                        0.55607488960822
                    ],
                    [
                        121.63860529661,
                        0.55634846203651
                    ],
                    [
                        121.63866698742,
                        0.55674272816085
                    ],
                    [
                        121.63867503405,
                        0.55692510976048
                    ],
                    [
                        121.638661623,
                        0.55710212719001
                    ],
                    [
                        121.638661623,
                        0.55710212719001
                    ],
                    [
                        121.638661623,
                        0.55710212719001
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2143,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0035528144339005002,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63822308183,
                        0.55444820623135
                    ],
                    [
                        121.63817614317,
                        0.55422961642774
                    ],
                    [
                        121.63810372353,
                        0.55393324619032
                    ],
                    [
                        121.63806080818,
                        0.55369319969758
                    ],
                    [
                        121.63801789284,
                        0.55346254048867
                    ],
                    [
                        121.63798570633,
                        0.55331904899953
                    ],
                    [
                        121.63793206215,
                        0.55304815851528
                    ],
                    [
                        121.63789048791,
                        0.55280408886045
                    ],
                    [
                        121.63783013821,
                        0.55237227329273
                    ],
                    [
                        121.63780197501,
                        0.55211345214548
                    ],
                    [
                        121.63779124618,
                        0.55192302414393
                    ],
                    [
                        121.63780063391,
                        0.55171918571299
                    ],
                    [
                        121.63782611489,
                        0.55135978635721
                    ],
                    [
                        121.63784489036,
                        0.55109560099602
                    ],
                    [
                        121.63787573576,
                        0.55094004006721
                    ],
                    [
                        121.63787573576,
                        0.55094004006721
                    ],
                    [
                        121.63787573576,
                        0.55094004006721
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2144,
                "jenis_pipa": "Pipa 200",
                "keterangan": "TRANSMISI",
                "panjang": 0.0016663733524514596,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64058208466,
                        0.58119253978286
                    ],
                    [
                        121.63974523544,
                        0.57977640610534
                    ],
                    [
                        121.63974523544,
                        0.57979786267886
                    ],
                    [
                        121.63974523544,
                        0.57979786267886
                    ],
                    [
                        121.63974523544,
                        0.57979786267886
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2145,
                "jenis_pipa": "Pipa 150",
                "keterangan": "TRANSMISI",
                "panjang": 0.002270796931703017,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63972377777,
                        0.57975494953175
                    ],
                    [
                        121.63889765739,
                        0.57887522994429
                    ],
                    [
                        121.63867235184,
                        0.5783066306261
                    ],
                    [
                        121.63886547089,
                        0.5779525970596
                    ],
                    [
                        121.63887619972,
                        0.57796332534982
                    ],
                    [
                        121.63884401321,
                        0.57797405364001
                    ],
                    [
                        121.63884401321,
                        0.57797405364001
                    ],
                    [
                        121.63884401321,
                        0.57797405364001
                    ],
                    [
                        121.63884401321,
                        0.57797405364001
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2146,
                "jenis_pipa": "Pipa 100",
                "keterangan": "TRANSMISI",
                "panjang": 0.004352083810585757,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63888692856,
                        0.57791504804367
                    ],
                    [
                        121.63888692856,
                        0.57714261108959
                    ],
                    [
                        121.63890302181,
                        0.57703532817101
                    ],
                    [
                        121.63878500462,
                        0.57699777914903
                    ],
                    [
                        121.63858115673,
                        0.57683149062013
                    ],
                    [
                        121.6385114193,
                        0.57672957184195
                    ],
                    [
                        121.63837194443,
                        0.57632726085761
                    ],
                    [
                        121.63828611374,
                        0.57610733084083
                    ],
                    [
                        121.63818955421,
                        0.57597322716791
                    ],
                    [
                        121.63779258728,
                        0.57582839519758
                    ],
                    [
                        121.637352705,
                        0.57571574810701
                    ],
                    [
                        121.63676798344,
                        0.57560310101423
                    ],
                    [
                        121.63646757603,
                        0.57537780682197
                    ],
                    [
                        121.63634955883,
                        0.57514178432531
                    ],
                    [
                        121.63635492325,
                        0.57516324091632
                    ],
                    [
                        121.63635492325,
                        0.57516324091632
                    ],
                    [
                        121.63635492325,
                        0.57516324091632
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2147,
                "jenis_pipa": "Pipa 75",
                "keterangan": "TRANSMISI",
                "panjang": 0.012785065752382247,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63634419441,
                        0.57513105602977
                    ],
                    [
                        121.636043787,
                        0.57485748448682
                    ],
                    [
                        121.63563072681,
                        0.5745141790026
                    ],
                    [
                        121.63560390472,
                        0.57433716210425
                    ],
                    [
                        121.6356253624,
                        0.57419769424108
                    ],
                    [
                        121.63570046425,
                        0.57400458488644
                    ],
                    [
                        121.63584530354,
                        0.57368273594759
                    ],
                    [
                        121.63605988026,
                        0.5734145284847
                    ],
                    [
                        121.63608670235,
                        0.57324287570186
                    ],
                    [
                        121.63600087166,
                        0.57306049461446
                    ],
                    [
                        121.63581311703,
                        0.57294248331951
                    ],
                    [
                        121.6356575489,
                        0.57277619467252
                    ],
                    [
                        121.63541615009,
                        0.57242752491313
                    ],
                    [
                        121.63531959057,
                        0.57203057777666
                    ],
                    [
                        121.63520693779,
                        0.57165508721689
                    ],
                    [
                        121.63520693779,
                        0.57151025513726
                    ],
                    [
                        121.63526058197,
                        0.57131714569209
                    ],
                    [
                        121.63533568382,
                        0.57113476454346
                    ],
                    [
                        121.63535714149,
                        0.57098993245073
                    ],
                    [
                        121.63529276848,
                        0.5708719211132
                    ],
                    [
                        121.63514256477,
                        0.57061980597493
                    ],
                    [
                        121.63480997086,
                        0.57007802659788
                    ],
                    [
                        121.63467854261,
                        0.5698768708756
                    ],
                    [
                        121.63463294506,
                        0.56977763405001
                    ],
                    [
                        121.63458198309,
                        0.56965425853475
                    ],
                    [
                        121.63453102112,
                        0.56956306793481
                    ],
                    [
                        121.63444519043,
                        0.56947455940996
                    ],
                    [
                        121.63433521986,
                        0.56939946126659
                    ],
                    [
                        121.63419306278,
                        0.56930827066262
                    ],
                    [
                        121.63408577442,
                        0.56917416683065
                    ],
                    [
                        121.63397580385,
                        0.56905615545592
                    ],
                    [
                        121.63388192654,
                        0.56886841008205
                    ],
                    [
                        121.63375586271,
                        0.56866189016375
                    ],
                    [
                        121.63371294737,
                        0.56852242216279
                    ],
                    [
                        121.63368612528,
                        0.56831322015504
                    ],
                    [
                        121.63367003202,
                        0.5680879256767
                    ],
                    [
                        121.63375586271,
                        0.5678063075664
                    ],
                    [
                        121.63381755352,
                        0.56763733669363
                    ],
                    [
                        121.63387656212,
                        0.56745763750605
                    ],
                    [
                        121.63398385048,
                        0.5671438344338
                    ],
                    [
                        121.63407236338,
                        0.5669936380855
                    ],
                    [
                        121.63408309221,
                        0.56686221627755
                    ],
                    [
                        121.63406431675,
                        0.566752251089
                    ],
                    [
                        121.63402140141,
                        0.56652427447196
                    ],
                    [
                        121.63398116827,
                        0.56627215914384
                    ],
                    [
                        121.63389801979,
                        0.5656472349322
                    ],
                    [
                        121.63396239281,
                        0.56556140842578
                    ],
                    [
                        121.63411259651,
                        0.56544339697737
                    ],
                    [
                        121.63415282965,
                        0.56539243748754
                    ],
                    [
                        121.63421988487,
                        0.56523419485839
                    ],
                    [
                        121.6342574358,
                        0.56495794076665
                    ],
                    [
                        121.63431107998,
                        0.56463877340159
                    ],
                    [
                        121.63439154625,
                        0.56435983720264
                    ],
                    [
                        121.63443177938,
                        0.56412917841264
                    ],
                    [
                        121.63447201252,
                        0.56392265832547
                    ],
                    [
                        121.63447737694,
                        0.56389047337615
                    ],
                    [
                        121.63447737694,
                        0.56389047337615
                    ],
                    [
                        121.63447737694,
                        0.56389047337615
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2148,
                "jenis_pipa": "Pipa 50",
                "keterangan": "TRANSMISI",
                "panjang": 0.009450750903689088,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63447737694,
                        0.56388779129705
                    ],
                    [
                        121.63454711437,
                        0.56365713248834
                    ],
                    [
                        121.63459137082,
                        0.56358471634884
                    ],
                    [
                        121.63469463587,
                        0.56337685520268
                    ],
                    [
                        121.63477912545,
                        0.5632467743526
                    ],
                    [
                        121.63486093283,
                        0.56310730622145
                    ],
                    [
                        121.63492128253,
                        0.56299868200161
                    ],
                    [
                        121.63505405188,
                        0.56275595379935
                    ],
                    [
                        121.63516134024,
                        0.56255613886285
                    ],
                    [
                        121.63520023227,
                        0.56245824295185
                    ],
                    [
                        121.63528606296,
                        0.56227586152426
                    ],
                    [
                        121.63538262248,
                        0.56208543385113
                    ],
                    [
                        121.63543090224,
                        0.56198217377227
                    ],
                    [
                        121.63559317589,
                        0.56176358424864
                    ],
                    [
                        121.63581043482,
                        0.56138541094306
                    ],
                    [
                        121.63595795631,
                        0.5610903821061
                    ],
                    [
                        121.63622349501,
                        0.56060760761357
                    ],
                    [
                        121.63641124964,
                        0.56026698336434
                    ],
                    [
                        121.6365775466,
                        0.55992367701435
                    ],
                    [
                        121.63661912084,
                        0.55978420880393
                    ],
                    [
                        121.63661241531,
                        0.55956964231989
                    ],
                    [
                        121.63660168648,
                        0.55911905267783
                    ],
                    [
                        121.63660168648,
                        0.55885352662256
                    ],
                    [
                        121.63661241531,
                        0.55852094851623
                    ],
                    [
                        121.63662582636,
                        0.5581749599824
                    ],
                    [
                        121.63664191961,
                        0.55788529514773
                    ],
                    [
                        121.636698246,
                        0.55733010417475
                    ],
                    [
                        121.63673847914,
                        0.55674809232563
                    ],
                    [
                        121.63678407669,
                        0.55633236954109
                    ],
                    [
                        121.63680285215,
                        0.55596224213407
                    ],
                    [
                        121.63680553436,
                        0.55584154840936
                    ],
                    [
                        121.6368752718,
                        0.55579058883598
                    ],
                    [
                        121.63696914911,
                        0.55574499342784
                    ],
                    [
                        121.63694769144,
                        0.55564575636184
                    ],
                    [
                        121.63683772087,
                        0.55532390640659
                    ],
                    [
                        121.63680285215,
                        0.55510129351063
                    ],
                    [
                        121.63680285215,
                        0.55510129351063
                    ],
                    [
                        121.63680285215,
                        0.55510129351063
                    ],
                    [
                        121.63680285215,
                        0.55510129351063
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2149,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.010308802122247102,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63712471724,
                        0.55555456554297
                    ],
                    [
                        121.63684040308,
                        0.55573158301362
                    ],
                    [
                        121.63655877113,
                        0.55587373340285
                    ],
                    [
                        121.63626104593,
                        0.55598369879598
                    ],
                    [
                        121.63598746061,
                        0.55605611502935
                    ],
                    [
                        121.63583725691,
                        0.55606952544283
                    ],
                    [
                        121.63558512926,
                        0.55604538669853
                    ],
                    [
                        121.63542151451,
                        0.55602124795413
                    ],
                    [
                        121.63524717093,
                        0.55599710920963
                    ],
                    [
                        121.63495749235,
                        0.55600783754053
                    ],
                    [
                        121.63449883461,
                        0.55608830002168
                    ],
                    [
                        121.63402944803,
                        0.55618485499759
                    ],
                    [
                        121.63352519274,
                        0.55630286663268
                    ],
                    [
                        121.63313627243,
                        0.55639405744
                    ],
                    [
                        121.63268834352,
                        0.5564611095033
                    ],
                    [
                        121.63234233856,
                        0.55650402282342
                    ],
                    [
                        121.63197219372,
                        0.55652279740086
                    ],
                    [
                        121.63156449795,
                        0.5565764390504
                    ],
                    [
                        121.63099855185,
                        0.55665153735893
                    ],
                    [
                        121.63069009781,
                        0.55667835818316
                    ],
                    [
                        121.63042724133,
                        0.55665690152378
                    ],
                    [
                        121.62969499826,
                        0.55655230030817
                    ],
                    [
                        121.62888228893,
                        0.55644501700817
                    ],
                    [
                        121.62819296122,
                        0.55631359496302
                    ],
                    [
                        121.62773966789,
                        0.55620631165869
                    ],
                    [
                        121.62717908621,
                        0.55605075086394
                    ],
                    [
                        121.62706375122,
                        0.55600515545781
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2150,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0008293944340375703,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.63677871227,
                        0.5557557217592
                    ],
                    [
                        121.63669288158,
                        0.55556261179175
                    ],
                    [
                        121.63661777973,
                        0.55537486598401
                    ],
                    [
                        121.63658693433,
                        0.55526221849651
                    ],
                    [
                        121.63661375642,
                        0.55518846121185
                    ],
                    [
                        121.63666605949,
                        0.55513481954971
                    ],
                    [
                        121.6367867589,
                        0.55505569809718
                    ],
                    [
                        121.6367881,
                        0.55505569809718
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2151,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0015102554418395234,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.64195403457,
                        0.5529516034882
                    ],
                    [
                        121.641933918,
                        0.55269278236619
                    ],
                    [
                        121.64191246033,
                        0.55234947557555
                    ],
                    [
                        121.64187893271,
                        0.5521831863417
                    ],
                    [
                        121.64188563824,
                        0.55214697820145
                    ],
                    [
                        121.6419057548,
                        0.55211345214548
                    ],
                    [
                        121.64195939898,
                        0.55209199546955
                    ],
                    [
                        121.64212837815,
                        0.55206517462454
                    ],
                    [
                        121.64242744446,
                        0.55203298961035
                    ],
                    [
                        121.6425588727,
                        0.55203030752582
                    ],
                    [
                        121.6425588727,
                        0.55203030752582
                    ],
                    [
                        121.6425588727,
                        0.55203030752582
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2153,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00359892900891699,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.036280334,
                        0.47362712035692
                    ],
                    [
                        122.03647211194,
                        0.47364723623722
                    ],
                    [
                        122.03672558069,
                        0.47369819646698
                    ],
                    [
                        122.03698977828,
                        0.4737558619897
                    ],
                    [
                        122.0372030139,
                        0.47379609374945
                    ],
                    [
                        122.03739345074,
                        0.47381218645329
                    ],
                    [
                        122.03754499555,
                        0.47384034868491
                    ],
                    [
                        122.03775957227,
                        0.47391813008593
                    ],
                    [
                        122.03802242875,
                        0.47402809689278
                    ],
                    [
                        122.03811898828,
                        0.47406564653375
                    ],
                    [
                        122.03811898828,
                        0.47406564653375
                    ],
                    [
                        122.03947484493,
                        0.47458463619336
                    ],
                    [
                        122.03952312469,
                        0.47466241758602
                    ],
                    [
                        122.03949898481,
                        0.47481529825181
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2154,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.003283909528429741,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69335584768,
                        0.52968817887906
                    ],
                    [
                        121.69303657134,
                        0.5300585342733
                    ],
                    [
                        121.69259924325,
                        0.53035911254801
                    ],
                    [
                        121.6925724133,
                        0.53037789868968
                    ],
                    [
                        121.6922853329,
                        0.53028665171524
                    ],
                    [
                        121.69184800481,
                        0.53013099510872
                    ],
                    [
                        121.69182654085,
                        0.53012026017017
                    ],
                    [
                        121.69167897616,
                        0.53044767578686
                    ],
                    [
                        121.69153141146,
                        0.5305738113067
                    ],
                    [
                        121.69126638683,
                        0.5307196926129
                    ],
                    [
                        121.69108871738,
                        0.53086365461913
                    ],
                    [
                        121.69103505749,
                        0.53094685038223
                    ],
                    [
                        121.69092711645,
                        0.53098263459942
                    ],
                    [
                        121.69078223475,
                        0.53098531833366
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2155,
                "jenis_pipa": "Pipa 150",
                "keterangan": "TRANSMISI",
                "panjang": 0.03192688386491349,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69077962676,
                        0.53098126074401
                    ],
                    [
                        121.69069937256,
                        0.53121500070622
                    ],
                    [
                        121.69064437117,
                        0.53142969943521
                    ],
                    [
                        121.69057193032,
                        0.53170880777173
                    ],
                    [
                        121.69051558744,
                        0.53189666914499
                    ],
                    [
                        121.69044314659,
                        0.53208050491183
                    ],
                    [
                        121.69029960638,
                        0.5324173134924
                    ],
                    [
                        121.6901453342,
                        0.53271118231855
                    ],
                    [
                        121.68993606064,
                        0.53300505113069
                    ],
                    [
                        121.6896167843,
                        0.53346799512138
                    ],
                    [
                        121.68944641415,
                        0.5337095311027
                    ],
                    [
                        121.68907481942,
                        0.53423285902967
                    ],
                    [
                        121.68895274318,
                        0.53438985739908
                    ],
                    [
                        121.68882127645,
                        0.53456430002705
                    ],
                    [
                        121.68859322192,
                        0.53479107543598
                    ],
                    [
                        121.68846309669,
                        0.53492526206455
                    ],
                    [
                        121.68834504494,
                        0.5351842422494
                    ],
                    [
                        121.68812772239,
                        0.53560693009235
                    ],
                    [
                        121.68791844882,
                        0.53597728513079
                    ],
                    [
                        121.68765819836,
                        0.53640936598067
                    ],
                    [
                        121.68748514522,
                        0.53667505543222
                    ],
                    [
                        121.6872074553,
                        0.53704406854021
                    ],
                    [
                        121.68700086473,
                        0.53732854408463
                    ],
                    [
                        121.68675000475,
                        0.53764656625776
                    ],
                    [
                        121.68663329449,
                        0.53776196670467
                    ],
                    [
                        121.68627109024,
                        0.53819807302503
                    ],
                    [
                        121.68604169422,
                        0.53849730903605
                    ],
                    [
                        121.68582571316,
                        0.53873750295354
                    ],
                    [
                        121.68573449135,
                        0.53890791986133
                    ],
                    [
                        121.68540582454,
                        0.53947418703249
                    ],
                    [
                        121.68507447472,
                        0.54008473570067
                    ],
                    [
                        121.68470556299,
                        0.54079324045189
                    ],
                    [
                        121.68448958194,
                        0.54128973047452
                    ],
                    [
                        121.68436616419,
                        0.54155139411872
                    ],
                    [
                        121.68424677094,
                        0.54173657146009
                    ],
                    [
                        121.68396773952,
                        0.54215523325455
                    ],
                    [
                        121.68366724414,
                        0.54264367197816
                    ],
                    [
                        121.68350089849,
                        0.54293083098955
                    ],
                    [
                        121.68342175015,
                        0.5430583081164
                    ],
                    [
                        121.68313332825,
                        0.54349709778514
                    ],
                    [
                        121.68293210367,
                        0.54378559862031
                    ],
                    [
                        121.68263697428,
                        0.54420962772976
                    ],
                    [
                        121.68236867484,
                        0.54458534970058
                    ],
                    [
                        121.68273414368,
                        0.54528099138738
                    ],
                    [
                        121.6832573276,
                        0.5458821464225
                    ],
                    [
                        121.68344170963,
                        0.54654568493664
                    ],
                    [
                        121.683747571,
                        0.54769432015608
                    ],
                    [
                        121.68355976139,
                        0.54903618345132
                    ],
                    [
                        121.6829748686,
                        0.55072693077448
                    ],
                    [
                        121.68138356544,
                        0.5508089418828
                    ],
                    [
                        121.68054677278,
                        0.55260124373313
                    ],
                    [
                        121.67908777674,
                        0.5535325748656
                    ],
                    [
                        121.67960286769,
                        0.55557239524285
                    ],
                    [
                        121.67953847582,
                        0.55656000534875
                    ],
                    [
                        121.67947408395,
                        0.55738659194074
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2156,
                "jenis_pipa": "Pipa 40",
                "keterangan": "Distribusi",
                "panjang": 0.004932829373264727,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69022500877,
                        0.53077837059462
                    ],
                    [
                        121.6905000157,
                        0.5308307034142
                    ],
                    [
                        121.69075490017,
                        0.53091121544347
                    ],
                    [
                        121.6907897791,
                        0.53091389917773
                    ],
                    [
                        121.69085417097,
                        0.53071664470431
                    ],
                    [
                        121.69092795331,
                        0.53046974113686
                    ],
                    [
                        121.69096685673,
                        0.53031945200403
                    ],
                    [
                        121.69106076154,
                        0.53004839480877
                    ],
                    [
                        121.69113051939,
                        0.52978941440819
                    ],
                    [
                        121.69120296024,
                        0.52948481050349
                    ],
                    [
                        121.69130491403,
                        0.5291238481477
                    ],
                    [
                        121.69138359386,
                        0.52876547928278
                    ],
                    [
                        121.69145335172,
                        0.52848234521057
                    ],
                    [
                        121.69152038967,
                        0.5282169646261
                    ],
                    [
                        121.6916008795,
                        0.52793785613227
                    ],
                    [
                        121.69170283329,
                        0.52759031236524
                    ],
                    [
                        121.6917913721,
                        0.52730315263576
                    ],
                    [
                        121.69188527691,
                        0.527017334761
                    ],
                    [
                        121.69196844974,
                        0.52681605455964
                    ],
                    [
                        121.69200869465,
                        0.52674359368557
                    ],
                    [
                        121.69200869465,
                        0.52674359368557
                    ],
                    [
                        121.69200869465,
                        0.52674359368557
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2157,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0026437518380087953,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69112707925,
                        0.52981700471084
                    ],
                    [
                        121.69149733249,
                        0.52992837970258
                    ],
                    [
                        121.69169721557,
                        0.53005585710033
                    ],
                    [
                        121.69190246465,
                        0.5301658902205
                    ],
                    [
                        121.69209295725,
                        0.53023969292192
                    ],
                    [
                        121.69225527841,
                        0.53029068387879
                    ],
                    [
                        121.69261211667,
                        0.53039534952575
                    ],
                    [
                        121.69287773312,
                        0.53048122902962
                    ],
                    [
                        121.69298102841,
                        0.53050135703817
                    ],
                    [
                        121.69307225022,
                        0.53052282691388
                    ],
                    [
                        121.69313932508,
                        0.53051880131218
                    ],
                    [
                        121.69323188839,
                        0.53048525463134
                    ],
                    [
                        121.6935645797,
                        0.53027592333869
                    ],
                    [
                        121.69356055521,
                        0.53027592333869
                    ],
                    [
                        121.69356055521,
                        0.53027592333869
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2158,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.0010442263487461937,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69348491338,
                        0.53033590710256
                    ],
                    [
                        121.69350503584,
                        0.53036274444789
                    ],
                    [
                        121.69363247807,
                        0.53028894174793
                    ],
                    [
                        121.69384309313,
                        0.53015878062036
                    ],
                    [
                        121.69397455986,
                        0.53006887551003
                    ],
                    [
                        121.69401748777,
                        0.53006082430605
                    ],
                    [
                        121.69405639119,
                        0.53006216617338
                    ],
                    [
                        121.69406980616,
                        0.53009168725457
                    ],
                    [
                        121.69422944433,
                        0.5303936073949
                    ],
                    [
                        121.69422944433,
                        0.5303936073949
                    ],
                    [
                        121.69422944433,
                        0.5303936073949
                    ],
                    [
                        121.69422944433,
                        0.5303936073949
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2159,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.00033396832252565345,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69328649589,
                        0.52946143363039
                    ],
                    [
                        121.69328649589,
                        0.52943862188354
                    ],
                    [
                        121.69331869182,
                        0.52938092158228
                    ],
                    [
                        121.69337369321,
                        0.52927491405069
                    ],
                    [
                        121.69343674357,
                        0.52916622278224
                    ],
                    [
                        121.69343674357,
                        0.52916622278224
                    ],
                    [
                        121.69343674357,
                        0.52916622278224
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2160,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.008385012318577736,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69343501487,
                        0.52915476851575
                    ],
                    [
                        121.69334808694,
                        0.52893163218238
                    ],
                    [
                        121.69326893861,
                        0.52877060807138
                    ],
                    [
                        121.69312947395,
                        0.52844628210671
                    ],
                    [
                        121.6929819772,
                        0.52812984821033
                    ],
                    [
                        121.69289075538,
                        0.52793125178055
                    ],
                    [
                        121.69281831454,
                        0.52779169752879
                    ],
                    [
                        121.69274721518,
                        0.52767763876302
                    ],
                    [
                        121.69264671285,
                        0.5275411119104
                    ],
                    [
                        121.69250719714,
                        0.52738545523501
                    ],
                    [
                        121.69232609502,
                        0.5271774657058
                    ],
                    [
                        121.69215706637,
                        0.52694934814964
                    ],
                    [
                        121.69202962413,
                        0.52676014475847
                    ],
                    [
                        121.69193303633,
                        0.52659643685509
                    ],
                    [
                        121.69173071727,
                        0.52624424486724
                    ],
                    [
                        121.69156303011,
                        0.52594903386642
                    ],
                    [
                        121.69143558788,
                        0.52575312110362
                    ],
                    [
                        121.69134302457,
                        0.52564845537851
                    ],
                    [
                        121.69124107078,
                        0.52553573844181
                    ],
                    [
                        121.69108009111,
                        0.52541094468811
                    ],
                    [
                        121.69089094001,
                        0.52530359522055
                    ],
                    [
                        121.6906065426,
                        0.52516672464675
                    ],
                    [
                        121.69025775332,
                        0.52501777725419
                    ],
                    [
                        121.68994920896,
                        0.52489298349014
                    ],
                    [
                        121.68951768512,
                        0.5247320240716
                    ],
                    [
                        121.68953390443,
                        0.52467844447695
                    ],
                    [
                        121.68904619205,
                        0.52449330763321
                    ],
                    [
                        121.68886459157,
                        0.52441421284905
                    ],
                    [
                        121.68884184895,
                        0.52409623920819
                    ],
                    [
                        121.68867425841,
                        0.52298658266334
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1607,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.06790722563785513,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09404706955,
                        0.56673615862221
                    ],
                    [
                        122.09395051003,
                        0.56676297940017
                    ],
                    [
                        122.09387138486,
                        0.56676432043907
                    ],
                    [
                        122.09378421307,
                        0.56672006615537
                    ],
                    [
                        122.0936742425,
                        0.56665837836543
                    ],
                    [
                        122.09357768297,
                        0.56659669057481
                    ],
                    [
                        122.0935253799,
                        0.56654707213406
                    ],
                    [
                        122.09347441792,
                        0.56648806642019
                    ],
                    [
                        122.09347978234,
                        0.56634725732783
                    ],
                    [
                        122.09352135658,
                        0.56614073731951
                    ],
                    [
                        122.09354281425,
                        0.56598785886706
                    ],
                    [
                        122.09359109402,
                        0.56583229833236
                    ],
                    [
                        122.09363669157,
                        0.56575049494607
                    ],
                    [
                        122.09369570017,
                        0.56568612506751
                    ],
                    [
                        122.09380567074,
                        0.56559627544417
                    ],
                    [
                        122.09393039346,
                        0.56553190556391
                    ],
                    [
                        122.09403634071,
                        0.56549435646674
                    ],
                    [
                        122.0941208303,
                        0.56540584787965
                    ],
                    [
                        122.0941516757,
                        0.56531868033042
                    ],
                    [
                        122.09417045116,
                        0.56505717767491
                    ],
                    [
                        122.09417849779,
                        0.56493246101966
                    ],
                    [
                        122.09419056773,
                        0.5647876287715
                    ],
                    [
                        122.09420397878,
                        0.56457574455012
                    ],
                    [
                        122.09421873093,
                        0.56437727071546
                    ],
                    [
                        122.09423616529,
                        0.56416136336064
                    ],
                    [
                        122.09421873093,
                        0.56385292426841
                    ],
                    [
                        122.09420531988,
                        0.56359410362624
                    ],
                    [
                        122.09418922663,
                        0.56340099391681
                    ],
                    [
                        122.09413021803,
                        0.56286323698392
                    ],
                    [
                        122.09408730268,
                        0.56261916773616
                    ],
                    [
                        122.0940309763,
                        0.56217662456861
                    ],
                    [
                        122.09398806095,
                        0.56186013913126
                    ],
                    [
                        122.09397733212,
                        0.56171798888685
                    ],
                    [
                        122.09401756525,
                        0.56151951495492
                    ],
                    [
                        122.09408730268,
                        0.56128080981165
                    ],
                    [
                        122.09417849779,
                        0.56103405841737
                    ],
                    [
                        122.09430187941,
                        0.56067197754821
                    ],
                    [
                        122.09440112114,
                        0.56041717988613
                    ],
                    [
                        122.0944494009,
                        0.56020261342525
                    ],
                    [
                        122.09444403648,
                        0.56008996603013
                    ],
                    [
                        122.09437429905,
                        0.55960719145516
                    ],
                    [
                        122.09433406591,
                        0.55940603537052
                    ],
                    [
                        122.09430992603,
                        0.55914855557211
                    ],
                    [
                        122.09428042173,
                        0.55899299485513
                    ],
                    [
                        122.09429383278,
                        0.55880122603452
                    ],
                    [
                        122.09433272481,
                        0.55869662485701
                    ],
                    [
                        122.09439575672,
                        0.55859202367764
                    ],
                    [
                        122.09448158741,
                        0.55848205833321
                    ],
                    [
                        122.09466800094,
                        0.55827419700582
                    ],
                    [
                        122.09483966231,
                        0.55809047440709
                    ],
                    [
                        122.09507972002,
                        0.55781019685492
                    ],
                    [
                        122.09516689181,
                        0.55770291357783
                    ],
                    [
                        122.09525004029,
                        0.55758892509379
                    ],
                    [
                        122.09533721209,
                        0.55738642789903
                    ],
                    [
                        122.09538683295,
                        0.55725366483378
                    ],
                    [
                        122.09552496672,
                        0.55688890164923
                    ],
                    [
                        122.09564566612,
                        0.55664215007042
                    ],
                    [
                        122.09573149681,
                        0.55641819618287
                    ],
                    [
                        122.09579452872,
                        0.55618217291495
                    ],
                    [
                        122.09580928087,
                        0.55604404565718
                    ],
                    [
                        122.09579050541,
                        0.55592469297553
                    ],
                    [
                        122.09575161338,
                        0.55576779113196
                    ],
                    [
                        122.09565639496,
                        0.55555188346003
                    ],
                    [
                        122.09559470415,
                        0.55543118972696
                    ],
                    [
                        122.09554642439,
                        0.55530244974229
                    ],
                    [
                        122.09550350904,
                        0.5552139410012
                    ],
                    [
                        122.09546595812,
                        0.55510799871846
                    ],
                    [
                        122.09543243051,
                        0.55497523560197
                    ],
                    [
                        122.09538146853,
                        0.5547418943597
                    ],
                    [
                        122.09532916546,
                        0.5544964837329
                    ],
                    [
                        122.09530502558,
                        0.55426582455528
                    ],
                    [
                        122.09525674582,
                        0.55393861035764
                    ],
                    [
                        122.09524065256,
                        0.55379645992191
                    ],
                    [
                        122.09520980716,
                        0.55363151177048
                    ],
                    [
                        122.09517762065,
                        0.55354702613019
                    ],
                    [
                        122.09512665868,
                        0.55343840173373
                    ],
                    [
                        122.09502875805,
                        0.55324797377467
                    ],
                    [
                        122.09492012858,
                        0.55309777707024
                    ],
                    [
                        122.09482759237,
                        0.55294623931997
                    ],
                    [
                        122.09464922547,
                        0.55264986901843
                    ],
                    [
                        122.09457948804,
                        0.55254526773202
                    ],
                    [
                        122.09447354078,
                        0.55236690912398
                    ],
                    [
                        122.0943595469,
                        0.55217111696164
                    ],
                    [
                        122.09423482418,
                        0.55197532479285
                    ],
                    [
                        122.09396257997,
                        0.55154350916493
                    ],
                    [
                        122.09375739098,
                        0.55121763585976
                    ],
                    [
                        122.0936447382,
                        0.55103927721193
                    ],
                    [
                        122.09355354309,
                        0.5508689648139
                    ],
                    [
                        122.09349453449,
                        0.55073754264516
                    ],
                    [
                        122.09341138601,
                        0.55053638625885
                    ],
                    [
                        122.09330275655,
                        0.55024269792262
                    ],
                    [
                        122.09321692586,
                        0.55000667440905
                    ],
                    [
                        122.09309890866,
                        0.54963922869324
                    ],
                    [
                        122.09301307797,
                        0.54938711264158
                    ],
                    [
                        122.09290981293,
                        0.54906392130446
                    ],
                    [
                        122.09285080433,
                        0.54889226780711
                    ],
                    [
                        122.0927529037,
                        0.54855968914196
                    ],
                    [
                        122.09268450737,
                        0.54835450955304
                    ],
                    [
                        122.09258794785,
                        0.54805545693698
                    ],
                    [
                        122.09251955152,
                        0.54786368776276
                    ],
                    [
                        122.09244981408,
                        0.5476410745878
                    ],
                    [
                        122.09233850241,
                        0.54737286593228
                    ],
                    [
                        122.09223791957,
                        0.54719987134312
                    ],
                    [
                        122.09209173918,
                        0.54698396336048
                    ],
                    [
                        122.09188118577,
                        0.5467184367625
                    ],
                    [
                        122.09176316857,
                        0.54659908389393
                    ],
                    [
                        122.09161162376,
                        0.54652666754554
                    ],
                    [
                        122.09116637707,
                        0.54628796179839
                    ],
                    [
                        122.09080830216,
                        0.54612033135232
                    ],
                    [
                        122.09031477571,
                        0.54594465463981
                    ],
                    [
                        122.09010154009,
                        0.54584407636698
                    ],
                    [
                        122.08998754621,
                        0.54579043462079
                    ],
                    [
                        122.0899271965,
                        0.54575288539817
                    ],
                    [
                        122.08987489343,
                        0.54567644590853
                    ],
                    [
                        122.08982393146,
                        0.54558927806829
                    ],
                    [
                        122.0897193253,
                        0.54530765888349
                    ],
                    [
                        122.08966434002,
                        0.54510918440248
                    ],
                    [
                        122.08959192038,
                        0.54486377337975
                    ],
                    [
                        122.08952486515,
                        0.54458349520497
                    ],
                    [
                        122.08946451545,
                        0.54433942520482
                    ],
                    [
                        122.08932369947,
                        0.54384189786625
                    ],
                    [
                        122.08927541971,
                        0.54363537707214
                    ],
                    [
                        122.08913862705,
                        0.54303727135588
                    ],
                    [
                        122.0890635252,
                        0.54266982521385
                    ],
                    [
                        122.0890045166,
                        0.54239088798166
                    ],
                    [
                        122.08893477917,
                        0.54203148806736
                    ],
                    [
                        122.08889856935,
                        0.54180485154328
                    ],
                    [
                        122.0888838172,
                        0.54163185679434
                    ],
                    [
                        122.08890527487,
                        0.54143070010331
                    ],
                    [
                        122.08897233009,
                        0.5410337508801
                    ],
                    [
                        122.08901524544,
                        0.54082186581114
                    ],
                    [
                        122.08903938532,
                        0.54065289416857
                    ],
                    [
                        122.08907291293,
                        0.54036725161925
                    ],
                    [
                        122.08913058043,
                        0.53993945829254
                    ],
                    [
                        122.0891225338,
                        0.53980535379522
                    ],
                    [
                        122.08911851048,
                        0.53959078659335
                    ],
                    [
                        122.08913594484,
                        0.53929307458821
                    ],
                    [
                        122.08918020129,
                        0.53919920143041
                    ],
                    [
                        122.08925262094,
                        0.5390999640906
                    ],
                    [
                        122.0893907547,
                        0.53900609092984
                    ],
                    [
                        122.08964020014,
                        0.5388800326831
                    ],
                    [
                        122.08998754621,
                        0.53868960426287
                    ],
                    [
                        122.09029197693,
                        0.53850051688197
                    ],
                    [
                        122.0904622972,
                        0.53835702503581
                    ],
                    [
                        122.0905521512,
                        0.53825242350096
                    ],
                    [
                        122.09068492055,
                        0.53804590251665
                    ],
                    [
                        122.09083512425,
                        0.53776964716306
                    ],
                    [
                        122.09097996354,
                        0.53745584252295
                    ],
                    [
                        122.09114223719,
                        0.53716081250471
                    ],
                    [
                        122.09132730961,
                        0.53686310038096
                    ],
                    [
                        122.09140911698,
                        0.53670753908532
                    ],
                    [
                        122.09151774645,
                        0.53653454419153
                    ],
                    [
                        122.09158882499,
                        0.53640043961935
                    ],
                    [
                        122.09161564708,
                        0.5361805081146
                    ],
                    [
                        122.09160625935,
                        0.53588279594315
                    ],
                    [
                        122.09160089493,
                        0.53569102638363
                    ],
                    [
                        122.09159955382,
                        0.53554351133375
                    ],
                    [
                        122.09163308144,
                        0.535405383602
                    ],
                    [
                        122.09169074893,
                        0.53529139469482
                    ],
                    [
                        122.0917417109,
                        0.5351720416015
                    ],
                    [
                        122.09175243974,
                        0.53503123176931
                    ],
                    [
                        122.09172695875,
                        0.53490919657881
                    ],
                    [
                        122.0915915072,
                        0.53427085861971
                    ],
                    [
                        122.09153115749,
                        0.53401471878975
                    ],
                    [
                        122.09148019552,
                        0.53375723790278
                    ],
                    [
                        122.09145873785,
                        0.5335922892039
                    ],
                    [
                        122.09142789245,
                        0.53331737469596
                    ],
                    [
                        122.09139704704,
                        0.5330759863374
                    ],
                    [
                        122.09136217833,
                        0.53287214727168
                    ],
                    [
                        122.09139838815,
                        0.53267367238543
                    ],
                    [
                        122.09111809731,
                        0.53219357770172
                    ],
                    [
                        122.09098130465,
                        0.5318234488139
                    ],
                    [
                        122.09087401628,
                        0.53159278877114
                    ],
                    [
                        122.09077745676,
                        0.53133262568929
                    ],
                    [
                        122.09070771933,
                        0.53117572320682
                    ],
                    [
                        122.09062725306,
                        0.53100943339199
                    ],
                    [
                        122.09050118923,
                        0.53086460032379
                    ],
                    [
                        122.09043681622,
                        0.53070367468849
                    ],
                    [
                        122.09038853645,
                        0.53060175511732
                    ],
                    [
                        122.09039255977,
                        0.53051726915571
                    ],
                    [
                        122.09041133523,
                        0.53041803167554
                    ],
                    [
                        122.09041669965,
                        0.53031611209965
                    ],
                    [
                        122.09034562111,
                        0.53015920959138
                    ],
                    [
                        122.09026917815,
                        0.52998487346643
                    ],
                    [
                        122.09017261863,
                        0.52985747398739
                    ],
                    [
                        122.09005326033,
                        0.52978103429871
                    ],
                    [
                        122.08983331919,
                        0.52971532298664
                    ],
                    [
                        122.08970189095,
                        0.52967777366513
                    ],
                    [
                        122.08956509829,
                        0.52962547282409
                    ],
                    [
                        122.08952486515,
                        0.52956512569928
                    ],
                    [
                        122.08941221237,
                        0.52940151793569
                    ],
                    [
                        122.0892727375,
                        0.52921377131643
                    ],
                    [
                        122.08911180496,
                        0.52909710020015
                    ],
                    [
                        122.0890326798,
                        0.52899383955519
                    ],
                    [
                        122.08885967731,
                        0.52879268244968
                    ],
                    [
                        122.0887671411,
                        0.52864248513997
                    ],
                    [
                        122.08872422576,
                        0.52851508563338
                    ],
                    [
                        122.08870410919,
                        0.52832465689231
                    ],
                    [
                        122.08871886134,
                        0.52818921109406
                    ],
                    [
                        122.08872556686,
                        0.52793709415478
                    ],
                    [
                        122.08866119385,
                        0.52765815625263
                    ],
                    [
                        122.08852171898,
                        0.52740067510108
                    ],
                    [
                        122.08839833736,
                        0.52706809526455
                    ],
                    [
                        122.0881408453,
                        0.52655313290198
                    ],
                    [
                        122.08817839622,
                        0.52612936175923
                    ],
                    [
                        122.08794772625,
                        0.52570022639547
                    ],
                    [
                        122.08775997162,
                        0.52549638708733
                    ],
                    [
                        122.08720207214,
                        0.5250136097521
                    ],
                    [
                        122.08591997623,
                        0.52425189432514
                    ],
                    [
                        122.08514213562,
                        0.52382275883253
                    ],
                    [
                        122.08448767662,
                        0.52338825911631
                    ],
                    [
                        122.08376348019,
                        0.52279819772511
                    ],
                    [
                        122.08261013031,
                        0.52195065490258
                    ],
                    [
                        122.08132266998,
                        0.52106019839637
                    ],
                    [
                        122.07924127579,
                        0.51952603809661
                    ],
                    [
                        122.07822203636,
                        0.51837809972651
                    ],
                    [
                        122.0766556263,
                        0.51665082758141
                    ],
                    [
                        122.07614064217,
                        0.51593202474904
                    ],
                    [
                        122.07580804825,
                        0.51537414786794
                    ],
                    [
                        122.0744562149,
                        0.51410819630273
                    ],
                    [
                        122.073828578,
                        0.51342426050096
                    ],
                    [
                        122.07339674234,
                        0.51309436202925
                    ],
                    [
                        122.07302391529,
                        0.51269472889844
                    ],
                    [
                        122.07281470299,
                        0.51245602184868
                    ],
                    [
                        122.07236410071,
                        0.51190077389218
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1610,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.015628164110210573,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46021962166,
                        0.59216488161314
                    ],
                    [
                        121.46097868681,
                        0.59162846843449
                    ],
                    [
                        121.46143734455,
                        0.59107596280626
                    ],
                    [
                        121.46180212498,
                        0.59071388384533
                    ],
                    [
                        121.46214544773,
                        0.59025256839426
                    ],
                    [
                        121.46207302809,
                        0.58975102190113
                    ],
                    [
                        121.4618101716,
                        0.58934066564587
                    ],
                    [
                        121.46146953106,
                        0.5891475568094
                    ],
                    [
                        121.46120667458,
                        0.58900808931224
                    ],
                    [
                        121.46088212729,
                        0.58883911907061
                    ],
                    [
                        121.46045297384,
                        0.58891958109107
                    ],
                    [
                        121.46012574434,
                        0.58915023887663
                    ],
                    [
                        121.45984143019,
                        0.58941576352491
                    ],
                    [
                        121.45961612463,
                        0.58960619028509
                    ],
                    [
                        121.45948201418,
                        0.58981270944016
                    ],
                    [
                        121.45935058594,
                        0.58982343770775
                    ],
                    [
                        121.45918428898,
                        0.58973492949954
                    ],
                    [
                        121.45897507668,
                        0.58960887235208
                    ],
                    [
                        121.45830184221,
                        0.58920924435512
                    ],
                    [
                        121.45804435015,
                        0.58894908383163
                    ],
                    [
                        121.45785927773,
                        0.58874256464454
                    ],
                    [
                        121.45772784948,
                        0.588501178572
                    ],
                    [
                        121.45771443844,
                        0.58826515662431
                    ],
                    [
                        121.45783245564,
                        0.58792989815873
                    ],
                    [
                        121.45810335875,
                        0.58754904451741
                    ],
                    [
                        121.45833671093,
                        0.58735325355086
                    ],
                    [
                        121.45863443613,
                        0.58719769359993
                    ],
                    [
                        121.45917356014,
                        0.58708772880443
                    ],
                    [
                        121.45942837,
                        0.58710382121367
                    ],
                    [
                        121.45978242159,
                        0.58716819085014
                    ],
                    [
                        121.45999163389,
                        0.58727547357594
                    ],
                    [
                        121.46018743515,
                        0.58733984321043
                    ],
                    [
                        121.46037250757,
                        0.58725133496281
                    ],
                    [
                        121.46066218615,
                        0.58709845707725
                    ],
                    [
                        121.46100014448,
                        0.58680611163535
                    ],
                    [
                        121.46137833595,
                        0.58637429861523
                    ],
                    [
                        121.46162778139,
                        0.58605781451723
                    ],
                    [
                        121.46187454462,
                        0.58591566487416
                    ],
                    [
                        121.46227553487,
                        0.58577887936516
                    ],
                    [
                        121.46256253123,
                        0.58572121488489
                    ],
                    [
                        121.46266579628,
                        0.58573194316033
                    ],
                    [
                        121.46277844906,
                        0.58571048660942
                    ],
                    [
                        121.46306008101,
                        0.58554419833706
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1611,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.006243059226595658,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46306544542,
                        0.58554017523364
                    ],
                    [
                        121.46322906017,
                        0.585407412819
                    ],
                    [
                        121.46342888474,
                        0.58518346005183
                    ],
                    [
                        121.46354824305,
                        0.58495950727573
                    ],
                    [
                        121.46367967129,
                        0.58462424861217
                    ],
                    [
                        121.46375879645,
                        0.58427289751127
                    ],
                    [
                        121.4638017118,
                        0.58388802051675
                    ],
                    [
                        121.46381914616,
                        0.58360506215207
                    ],
                    [
                        121.46381646395,
                        0.58327516754777
                    ],
                    [
                        121.4638017118,
                        0.58288090323923
                    ],
                    [
                        121.46376147866,
                        0.58251882374787
                    ],
                    [
                        121.46379500628,
                        0.58219965736214
                    ],
                    [
                        121.46379634738,
                        0.58190865270057
                    ],
                    [
                        121.46379098296,
                        0.58166592529857
                    ],
                    [
                        121.46383389831,
                        0.58149561380032
                    ],
                    [
                        121.46382048726,
                        0.58131591504856
                    ],
                    [
                        121.46390095353,
                        0.58103027448364
                    ],
                    [
                        121.46403640509,
                        0.5807929111863
                    ],
                    [
                        121.46401762962,
                        0.58054884270068
                    ],
                    [
                        121.46413296461,
                        0.58017737580948
                    ],
                    [
                        121.46419197321,
                        0.58001511048113
                    ],
                    [
                        121.46423891187,
                        0.57982066028813
                    ],
                    [
                        121.46426036954,
                        0.57961011765784
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1613,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.0014185875483699684,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4739793539,
                        0.51176940376834
                    ],
                    [
                        121.47394180298,
                        0.5116487091763
                    ],
                    [
                        121.47402897477,
                        0.51149582935647
                    ],
                    [
                        121.47412016988,
                        0.51137781686146
                    ],
                    [
                        121.47465661168,
                        0.51057318615596
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1614,
                "jenis_pipa": "Pipa 200",
                "keterangan": "PIPA TRANSMISI",
                "panjang": 0.0011467112149723257,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07236409187,
                        0.51190618815745
                    ],
                    [
                        122.07221522878,
                        0.51198396123909
                    ],
                    [
                        122.072134763,
                        0.51202554450613
                    ],
                    [
                        122.0720757544,
                        0.51192898883653
                    ],
                    [
                        122.07193761941,
                        0.51200007185023
                    ],
                    [
                        122.07183033228,
                        0.51206845813659
                    ],
                    [
                        122.07171231508,
                        0.51214087488735
                    ],
                    [
                        122.0716291666,
                        0.51219451692441
                    ],
                    [
                        122.07159429789,
                        0.5122347484519
                    ],
                    [
                        122.07164928317,
                        0.51232057570975
                    ],
                    [
                        122.07167208195,
                        0.51235141988025
                    ],
                    [
                        122.0716881752,
                        0.51235544303291
                    ],
                    [
                        122.07171902061,
                        0.51233800937135
                    ],
                    [
                        122.07172572613,
                        0.51233130411689
                    ],
                    [
                        122.07172572613,
                        0.51233130411689
                    ],
                    [
                        122.07172572613,
                        0.51233130411689
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1615,
                "jenis_pipa": "Pipa 250",
                "keterangan": "",
                "panjang": 0.0008650978227719121,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47466465831,
                        0.51056513984841
                    ],
                    [
                        121.47471562028,
                        0.51049406413115
                    ],
                    [
                        121.4752279222,
                        0.51085883006794
                    ],
                    [
                        121.4752869308,
                        0.51082396273665
                    ],
                    [
                        121.47531509399,
                        0.51074886386859
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1616,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.024088683675307903,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47395655513,
                        0.51160445449198
                    ],
                    [
                        121.47390156984,
                        0.51157495136894
                    ],
                    [
                        121.47386086443,
                        0.51157415203349
                    ],
                    [
                        121.47382465461,
                        0.51157817518664
                    ],
                    [
                        121.47377637485,
                        0.51156342362508
                    ],
                    [
                        121.47371870736,
                        0.51154196680819
                    ],
                    [
                        121.47359848022,
                        0.5114716904372
                    ],
                    [
                        121.47345364094,
                        0.51140463788324
                    ],
                    [
                        121.47318136069,
                        0.51124347156127
                    ],
                    [
                        121.4730351803,
                        0.51117239585154
                    ],
                    [
                        121.47280987474,
                        0.51103829073665
                    ],
                    [
                        121.47238340351,
                        0.51079019626676
                    ],
                    [
                        121.47217687341,
                        0.51067754796376
                    ],
                    [
                        121.47179331753,
                        0.51046297976208
                    ],
                    [
                        121.47143259645,
                        0.51024865174291
                    ],
                    [
                        121.4712998271,
                        0.51018428127886
                    ],
                    [
                        121.47111073136,
                        0.51006895086252
                    ],
                    [
                        121.47094041109,
                        0.50998178252321
                    ],
                    [
                        121.47070169449,
                        0.50984499528067
                    ],
                    [
                        121.47044822574,
                        0.50969077436651
                    ],
                    [
                        121.47023364902,
                        0.50957678499277
                    ],
                    [
                        121.47005930543,
                        0.50948291138938
                    ],
                    [
                        121.46970391273,
                        0.50929516417847
                    ],
                    [
                        121.46950811148,
                        0.5091878800555
                    ],
                    [
                        121.46935120225,
                        0.5090913243433
                    ],
                    [
                        121.46903336048,
                        0.50890894132741
                    ],
                    [
                        121.46882817149,
                        0.50877215406211
                    ],
                    [
                        121.46861493587,
                        0.50865145941385
                    ],
                    [
                        121.4684446156,
                        0.50853881107344
                    ],
                    [
                        121.46816432476,
                        0.50837386171428
                    ],
                    [
                        121.46787464619,
                        0.50820757129916
                    ],
                    [
                        121.46759301424,
                        0.50805469139762
                    ],
                    [
                        121.46741598845,
                        0.50795813566848
                    ],
                    [
                        121.46722555161,
                        0.50784146416049
                    ],
                    [
                        121.46701097488,
                        0.50771942844299
                    ],
                    [
                        121.46665155888,
                        0.507528999077
                    ],
                    [
                        121.46645575762,
                        0.50740428124977
                    ],
                    [
                        121.46619424224,
                        0.50726883500456
                    ],
                    [
                        121.46602794528,
                        0.50714948138019
                    ],
                    [
                        121.46572217345,
                        0.50699794250564
                    ],
                    [
                        121.46550625563,
                        0.50688127098033
                    ],
                    [
                        121.46531447768,
                        0.50677398681727
                    ],
                    [
                        121.46510392427,
                        0.50665865634001
                    ],
                    [
                        121.46484106779,
                        0.50650979955818
                    ],
                    [
                        121.46456211805,
                        0.50633546278233
                    ],
                    [
                        121.46436363459,
                        0.50622683755808
                    ],
                    [
                        121.46402165294,
                        0.50600824605192
                    ],
                    [
                        121.46386340261,
                        0.50591437239669
                    ],
                    [
                        121.46368503571,
                        0.50582318084461
                    ],
                    [
                        121.4633873105,
                        0.50563543352748
                    ],
                    [
                        121.46323040128,
                        0.50552546723919
                    ],
                    [
                        121.46301448345,
                        0.50539940832107
                    ],
                    [
                        121.46279856563,
                        0.50528407781937
                    ],
                    [
                        121.46259203553,
                        0.50515801889655
                    ],
                    [
                        121.46240562201,
                        0.50503330102371
                    ],
                    [
                        121.46206900477,
                        0.50485091789353
                    ],
                    [
                        121.46184504032,
                        0.50471278949006
                    ],
                    [
                        121.46169349551,
                        0.50464841897093
                    ],
                    [
                        121.46152853966,
                        0.50458270739866
                    ],
                    [
                        121.4613327384,
                        0.50451967793078
                    ],
                    [
                        121.46113693714,
                        0.50444726109455
                    ],
                    [
                        121.46081641316,
                        0.50433863583874
                    ],
                    [
                        121.46044358611,
                        0.50421794110793
                    ],
                    [
                        121.46018072963,
                        0.50414686532094
                    ],
                    [
                        121.45995542407,
                        0.50408517690144
                    ],
                    [
                        121.45984143019,
                        0.50404360427056
                    ],
                    [
                        121.45972877741,
                        0.50400471374468
                    ],
                    [
                        121.45959734917,
                        0.50394973058697
                    ],
                    [
                        121.45948603749,
                        0.50388401900765
                    ],
                    [
                        121.45937740803,
                        0.50381830742767
                    ],
                    [
                        121.45927682519,
                        0.50373516216226
                    ],
                    [
                        121.45916551352,
                        0.50363592426346
                    ],
                    [
                        121.45901665092,
                        0.50342672003937
                    ],
                    [
                        121.45894020796,
                        0.50324701896974
                    ],
                    [
                        121.45888924599,
                        0.50308877474015
                    ],
                    [
                        121.45884230733,
                        0.50289298102703
                    ],
                    [
                        121.45880073309,
                        0.50269450520227
                    ],
                    [
                        121.45877659321,
                        0.5025376020122
                    ],
                    [
                        121.45875379443,
                        0.50244104620106
                    ],
                    [
                        121.45870953798,
                        0.50236058302401
                    ],
                    [
                        121.45864918828,
                        0.50230694090543
                    ],
                    [
                        121.45854860544,
                        0.50225329878641
                    ],
                    [
                        121.45845606923,
                        0.50222647772674
                    ],
                    [
                        121.45824819803,
                        0.50219697456096
                    ],
                    [
                        121.45793572068,
                        0.50221172614386
                    ],
                    [
                        121.45748913288,
                        0.50225061668044
                    ],
                    [
                        121.45700901747,
                        0.50241556619509
                    ],
                    [
                        121.45676627755,
                        0.50254162517096
                    ],
                    [
                        121.45642697811,
                        0.50275485258206
                    ],
                    [
                        121.45609304309,
                        0.50299490104281
                    ],
                    [
                        121.45560890436,
                        0.5033328463469
                    ],
                    [
                        121.4552642405,
                        0.50359435162972
                    ],
                    [
                        121.45476803184,
                        0.50394436637644
                    ],
                    [
                        121.45424231887,
                        0.50436009267954
                    ],
                    [
                        121.45368307829,
                        0.50476509053638
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1617,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.005283883868928867,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45367637277,
                        0.5047677726413
                    ],
                    [
                        121.45356103778,
                        0.5048388484215
                    ],
                    [
                        121.45349666476,
                        0.50488444420461
                    ],
                    [
                        121.45344033837,
                        0.50489249051925
                    ],
                    [
                        121.45340144634,
                        0.50484823578863
                    ],
                    [
                        121.45334914327,
                        0.5047262000148
                    ],
                    [
                        121.453268677,
                        0.50450358530058
                    ],
                    [
                        121.45316943526,
                        0.50445530740973
                    ],
                    [
                        121.45307019353,
                        0.50416429900462
                    ],
                    [
                        121.45297497511,
                        0.50391084006052
                    ],
                    [
                        121.45286232233,
                        0.50365738110656
                    ],
                    [
                        121.45276173949,
                        0.50340928635372
                    ],
                    [
                        121.45266920328,
                        0.50315716843306
                    ],
                    [
                        121.4525860548,
                        0.50295601051066
                    ],
                    [
                        121.45252436399,
                        0.50281117680269
                    ],
                    [
                        121.45240232348,
                        0.50254698938265
                    ],
                    [
                        121.45231381059,
                        0.50232169248809
                    ],
                    [
                        121.45226955414,
                        0.50208700821465
                    ],
                    [
                        121.45222127438,
                        0.50178795338545
                    ],
                    [
                        121.45217433572,
                        0.50147146485174
                    ],
                    [
                        121.45212739706,
                        0.5010181888743
                    ],
                    [
                        121.45212739706,
                        0.50068828977041
                    ],
                    [
                        121.45208179951,
                        0.50035704959655
                    ],
                    [
                        121.45204693079,
                        0.5002537884863
                    ],
                    [
                        121.45196914673,
                        0.50022428531163
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1618,
                "jenis_pipa": "Pipa 250",
                "keterangan": "JDU",
                "panjang": 0.07621002634466018,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07183837891,
                        0.51209527915547
                    ],
                    [
                        122.07184106112,
                        0.51209527915547
                    ],
                    [
                        122.07193091512,
                        0.51204566027043
                    ],
                    [
                        122.07195773721,
                        0.51207382234037
                    ],
                    [
                        122.07203820348,
                        0.51200274663983
                    ],
                    [
                        122.07197785378,
                        0.51194105829531
                    ],
                    [
                        122.07194298506,
                        0.5118552310324
                    ],
                    [
                        122.07183301449,
                        0.5116178650024
                    ],
                    [
                        122.07176059484,
                        0.51144352836463
                    ],
                    [
                        122.07160100341,
                        0.51113508660924
                    ],
                    [
                        122.07154065371,
                        0.51098086572602
                    ],
                    [
                        122.07145616412,
                        0.51073947651002
                    ],
                    [
                        122.07139983773,
                        0.51057586825848
                    ],
                    [
                        122.07132071257,
                        0.51032777377074
                    ],
                    [
                        122.07127511501,
                        0.51018830443288
                    ],
                    [
                        122.07121744752,
                        0.51005419929748
                    ],
                    [
                        122.07110479474,
                        0.50983963107503
                    ],
                    [
                        122.07095861435,
                        0.50956069237516
                    ],
                    [
                        122.07084193826,
                        0.50932869046654
                    ],
                    [
                        122.07071185112,
                        0.50908864224016
                    ],
                    [
                        122.07061395049,
                        0.50891028237902
                    ],
                    [
                        122.07051873207,
                        0.50872655830637
                    ],
                    [
                        122.07038729966,
                        0.5085093399981
                    ],
                    [
                        122.07026392221,
                        0.50827328283469
                    ],
                    [
                        122.07013383508,
                        0.50799300301528
                    ],
                    [
                        122.07004263997,
                        0.50779720945001
                    ],
                    [
                        122.07000106573,
                        0.50768590214656
                    ],
                    [
                        122.0699621737,
                        0.50757191273744
                    ],
                    [
                        122.06992998719,
                        0.5074592643782
                    ],
                    [
                        122.06990987062,
                        0.50724737817337
                    ],
                    [
                        122.06989243627,
                        0.50698855514161
                    ],
                    [
                        122.06988304853,
                        0.5068008078582
                    ],
                    [
                        122.06985488534,
                        0.5066546331838
                    ],
                    [
                        122.06983879209,
                        0.50653125639182
                    ],
                    [
                        122.06981733441,
                        0.50645615747382
                    ],
                    [
                        122.06976905465,
                        0.50620135756695
                    ],
                    [
                        122.06971406937,
                        0.5059425344934
                    ],
                    [
                        122.06966981292,
                        0.50568102930498
                    ],
                    [
                        122.06963896751,
                        0.5053819746407
                    ],
                    [
                        122.06960007548,
                        0.50508291996266
                    ],
                    [
                        122.06956252456,
                        0.50467255791567
                    ],
                    [
                        122.06951960921,
                        0.50423403373882
                    ],
                    [
                        122.0694847405,
                        0.50394436637644
                    ],
                    [
                        122.06943109632,
                        0.50351791162504
                    ],
                    [
                        122.06938550073,
                        0.50328456394749
                    ],
                    [
                        122.06933320133,
                        0.50315983703896
                    ],
                    [
                        122.06924871028,
                        0.50297343969761
                    ],
                    [
                        122.06919506192,
                        0.50280044837975
                    ],
                    [
                        122.06906631589,
                        0.50247457252453
                    ],
                    [
                        122.06883698702,
                        0.50194351554046
                    ],
                    [
                        122.06875920418,
                        0.50179332659756
                    ],
                    [
                        122.06871762872,
                        0.50167798703226
                    ],
                    [
                        122.06867873669,
                        0.5015800901553
                    ],
                    [
                        122.06860229373,
                        0.50131187952599
                    ],
                    [
                        122.0685647428,
                        0.501169727888
                    ],
                    [
                        122.06852987409,
                        0.50100611939519
                    ],
                    [
                        122.06848159432,
                        0.50075534243515
                    ],
                    [
                        122.06845745444,
                        0.50056759497215
                    ],
                    [
                        122.06842258573,
                        0.50031279483521
                    ],
                    [
                        122.06837832928,
                        0.50004592520749
                    ],
                    [
                        122.06833943725,
                        0.49973211869668
                    ],
                    [
                        122.06828981638,
                        0.49935260054606
                    ],
                    [
                        122.06824958324,
                        0.49915412461406
                    ],
                    [
                        122.06817045808,
                        0.49874242114139
                    ],
                    [
                        122.06805512309,
                        0.49821538701666
                    ],
                    [
                        122.06801086664,
                        0.49798472575795
                    ],
                    [
                        122.06790626049,
                        0.49741477784575
                    ],
                    [
                        122.067848593,
                        0.4971519312626
                    ],
                    [
                        122.06779897213,
                        0.49679118772073
                    ],
                    [
                        122.06775069237,
                        0.49639155358815
                    ],
                    [
                        122.0677319169,
                        0.49615955121151
                    ],
                    [
                        122.0676715672,
                        0.49537503444414
                    ],
                    [
                        122.06765010953,
                        0.49492175804731
                    ],
                    [
                        122.06760317087,
                        0.49435851514421
                    ],
                    [
                        122.06757634878,
                        0.49393876504485
                    ],
                    [
                        122.06753209381,
                        0.49333394429749
                    ],
                    [
                        122.06749722558,
                        0.49301880147564
                    ],
                    [
                        122.06746906042,
                        0.49261916711588
                    ],
                    [
                        122.06744223833,
                        0.49224233066744
                    ],
                    [
                        122.06743150949,
                        0.49200496392562
                    ],
                    [
                        122.06743687391,
                        0.49166701804137
                    ],
                    [
                        122.06745296717,
                        0.49116278129338
                    ],
                    [
                        122.06746503711,
                        0.49085165647245
                    ],
                    [
                        122.06752002239,
                        0.49046811464742
                    ],
                    [
                        122.06755891442,
                        0.49019319829079
                    ],
                    [
                        122.06764340401,
                        0.48980697431702
                    ],
                    [
                        122.06768497825,
                        0.48958301804427
                    ],
                    [
                        122.06769034266,
                        0.48952132948877
                    ],
                    [
                        122.06762865186,
                        0.48950389576647
                    ],
                    [
                        122.06738188863,
                        0.48945427671043
                    ],
                    [
                        122.06687763333,
                        0.48934699226368
                    ],
                    [
                        122.06587851048,
                        0.48912974125376
                    ],
                    [
                        122.06544399261,
                        0.48903854946972
                    ],
                    [
                        122.06443548203,
                        0.48883336795111
                    ],
                    [
                        122.06392586231,
                        0.48873010666158
                    ],
                    [
                        122.06319361925,
                        0.48857186208495
                    ],
                    [
                        122.06308096647,
                        0.4885262661893
                    ],
                    [
                        122.06289455295,
                        0.48843775650862
                    ],
                    [
                        122.06254452467,
                        0.48820307174361
                    ],
                    [
                        122.06226155162,
                        0.4880153239257
                    ],
                    [
                        122.06164732575,
                        0.48753924907823
                    ],
                    [
                        122.06134557724,
                        0.48725896837762
                    ],
                    [
                        122.06076622009,
                        0.48675070813006
                    ],
                    [
                        122.05941842307,
                        0.48556519417269
                    ],
                    [
                        122.05877870321,
                        0.4849697853775
                    ],
                    [
                        122.05840452254,
                        0.48465599840674
                    ],
                    [
                        122.05820202827,
                        0.48447225341024
                    ],
                    [
                        122.05803707095,
                        0.48433010703781
                    ],
                    [
                        122.05789625571,
                        0.48424964476673
                    ],
                    [
                        122.0577326417,
                        0.48418258518609
                    ],
                    [
                        122.05757305026,
                        0.48415039982708
                    ],
                    [
                        122.0566705478,
                        0.48400286109676
                    ],
                    [
                        122.05534018318,
                        0.48376281532575
                    ],
                    [
                        122.05436512828,
                        0.48358179179279
                    ],
                    [
                        122.05296635628,
                        0.48332162678009
                    ],
                    [
                        122.05191627145,
                        0.48314192516756
                    ],
                    [
                        122.05080986023,
                        0.48294613480533
                    ],
                    [
                        122.05049335957,
                        0.4828763959105
                    ],
                    [
                        122.05015003681,
                        0.48278922721273
                    ],
                    [
                        122.04976782227,
                        0.48267390081851
                    ],
                    [
                        122.04693272734,
                        0.48185987753192
                    ],
                    [
                        122.04655721784,
                        0.48177538812288
                    ],
                    [
                        122.04615756869,
                        0.4816868783539
                    ],
                    [
                        122.04533010721,
                        0.48151790515538
                    ],
                    [
                        122.04442352155,
                        0.48135430349378
                    ],
                    [
                        122.04397961497,
                        0.48125103477778
                    ],
                    [
                        122.04366981983,
                        0.48116923028807
                    ],
                    [
                        122.04304486513,
                        0.48098684650424
                    ],
                    [
                        122.04219862819,
                        0.48075216148109
                    ],
                    [
                        122.04200550914,
                        0.48070388341819
                    ],
                    [
                        122.04181104898,
                        0.48066365169883
                    ],
                    [
                        122.0411914587,
                        0.48054027836213
                    ],
                    [
                        122.04099968076,
                        0.48050138376174
                    ],
                    [
                        122.04080253839,
                        0.48048529107353
                    ],
                    [
                        122.04016014934,
                        0.48044505147804
                    ],
                    [
                        122.03954324126,
                        0.48041555609095
                    ],
                    [
                        122.03882306814,
                        0.48037800648466
                    ],
                    [
                        122.03845694661,
                        0.48035386745192
                    ],
                    [
                        122.03810021281,
                        0.48031899996005
                    ],
                    [
                        122.03740552068,
                        0.48024658286097
                    ],
                    [
                        122.03456908464,
                        0.47997300714643
                    ],
                    [
                        122.03345328569,
                        0.47989522581381
                    ],
                    [
                        122.03262984753,
                        0.47986840466444
                    ],
                    [
                        122.0317903161,
                        0.47984694774486
                    ],
                    [
                        122.03122973442,
                        0.47983353717009
                    ],
                    [
                        122.03011661768,
                        0.47980939813543
                    ],
                    [
                        122.02960833883,
                        0.47979866630062
                    ],
                    [
                        122.02936828136,
                        0.47979196832556
                    ],
                    [
                        122.02916711569,
                        0.47977453064078
                    ],
                    [
                        122.02778577805,
                        0.47958678258961
                    ],
                    [
                        122.02648490667,
                        0.47940707525377
                    ],
                    [
                        122.02581971884,
                        0.47930382450803
                    ],
                    [
                        122.02484607697,
                        0.47914155147624
                    ],
                    [
                        122.0244705677,
                        0.47909863763247
                    ],
                    [
                        122.02401190996,
                        0.47904767744263
                    ],
                    [
                        122.02370882034,
                        0.47903426686629
                    ],
                    [
                        122.02288135886,
                        0.47910936609343
                    ],
                    [
                        122.02266678214,
                        0.47913618724578
                    ],
                    [
                        122.02248573303,
                        0.47913082301533
                    ],
                    [
                        122.02236771584,
                        0.47913350513056
                    ],
                    [
                        122.02213168144,
                        0.47905706484605
                    ],
                    [
                        122.02187016606,
                        0.47895648552302
                    ],
                    [
                        122.02131360769,
                        0.47868559187233
                    ],
                    [
                        122.02067658305,
                        0.47837848965144
                    ],
                    [
                        122.01871722937,
                        0.47743438492124
                    ],
                    [
                        122.01851338148,
                        0.47733380557444
                    ],
                    [
                        122.01840475202,
                        0.47728150431352
                    ],
                    [
                        122.01839402318,
                        0.47727882219757
                    ],
                    [
                        122.01802656054,
                        0.47711789523834
                    ],
                    [
                        122.01765775681,
                        0.47695562721731
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1619,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00028445809450375293,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45196646452,
                        0.50021892109805
                    ],
                    [
                        121.45183771849,
                        0.50028865587436
                    ],
                    [
                        121.45178407431,
                        0.50031011272845
                    ],
                    [
                        121.45174250007,
                        0.50032352326222
                    ],
                    [
                        121.45171299577,
                        0.50031547694195
                    ],
                    [
                        121.45170763135,
                        0.50031279483521
                    ],
                    [
                        121.45170763135,
                        0.50031279483521
                    ],
                    [
                        121.45170763135,
                        0.50031279483521
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1620,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00028445809450375293,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45196646452,
                        0.50021892109805
                    ],
                    [
                        121.45183771849,
                        0.50028865587436
                    ],
                    [
                        121.45178407431,
                        0.50031011272845
                    ],
                    [
                        121.45174250007,
                        0.50032352326222
                    ],
                    [
                        121.45171299577,
                        0.50031547694195
                    ],
                    [
                        121.45170763135,
                        0.50031279483521
                    ],
                    [
                        121.45170763135,
                        0.50031279483521
                    ],
                    [
                        121.45170763135,
                        0.50031279483521
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1621,
                "jenis_pipa": "Pipa 200",
                "keterangan": "JDU",
                "panjang": 0.0030278908476899296,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0176564157,
                        0.47695428615926
                    ],
                    [
                        122.01736407137,
                        0.47691001774401
                    ],
                    [
                        122.01712936212,
                        0.47691807084218
                    ],
                    [
                        122.01666131689,
                        0.47696499943636
                    ],
                    [
                        122.01615169816,
                        0.47701729901221
                    ],
                    [
                        122.01580703406,
                        0.47706557597611
                    ],
                    [
                        122.01542079449,
                        0.47710043448466
                    ],
                    [
                        122.01519414954,
                        0.47713397162222
                    ],
                    [
                        122.01498091221,
                        0.47712594439883
                    ],
                    [
                        122.01464698701,
                        0.47708571434596
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2161,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.008605943723498516,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.68865900398,
                        0.52297709443662
                    ],
                    [
                        121.68839472903,
                        0.52255708947113
                    ],
                    [
                        121.68826057931,
                        0.52224980147541
                    ],
                    [
                        121.68817606499,
                        0.52214245195371
                    ],
                    [
                        121.68818679696,
                        0.52199618822746
                    ],
                    [
                        121.68820895994,
                        0.52170897738799
                    ],
                    [
                        121.68824518037,
                        0.52142718486539
                    ],
                    [
                        121.6882773763,
                        0.52113734111469
                    ],
                    [
                        121.68831091373,
                        0.52087836034469
                    ],
                    [
                        121.68836189062,
                        0.52057643974449
                    ],
                    [
                        121.68840884303,
                        0.52018193013842
                    ],
                    [
                        121.68846518591,
                        0.51976192498647
                    ],
                    [
                        121.68852146635,
                        0.51939690611326
                    ],
                    [
                        121.68857646774,
                        0.51900508017291
                    ],
                    [
                        121.68863948394,
                        0.51860435570871
                    ],
                    [
                        121.68871219694,
                        0.5181276244612
                    ],
                    [
                        121.68877658881,
                        0.51772237974257
                    ],
                    [
                        121.68885439565,
                        0.51727419515605
                    ],
                    [
                        121.68891438798,
                        0.51696278286722
                    ],
                    [
                        121.68892109547,
                        0.51692386863325
                    ],
                    [
                        121.68892623172,
                        0.5168734271111
                    ],
                    [
                        121.68892891629,
                        0.51684122878907
                    ],
                    [
                        121.68895305617,
                        0.51665610483865
                    ],
                    [
                        121.68891414018,
                        0.51664815368358
                    ],
                    [
                        121.6889664409,
                        0.51634104420719
                    ],
                    [
                        121.68898280434,
                        0.51623951482451
                    ],
                    [
                        121.68904719621,
                        0.5159483289659
                    ],
                    [
                        121.6890941706,
                        0.51576544335393
                    ],
                    [
                        121.689143806,
                        0.51553329977303
                    ],
                    [
                        121.68917063594,
                        0.5152354045296
                    ],
                    [
                        121.68915856247,
                        0.51497239790675
                    ],
                    [
                        121.68912502504,
                        0.51476574983832
                    ],
                    [
                        121.6890941706,
                        0.51462485342417
                    ],
                    [
                        121.6890941706,
                        0.51462485342417
                    ],
                    [
                        121.6890941706,
                        0.51462485342417
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1622,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0009578594310859828,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45175243185,
                        0.49982511931394
                    ],
                    [
                        121.45187581347,
                        0.49974599715826
                    ],
                    [
                        121.45178595946,
                        0.49949387909652
                    ],
                    [
                        121.45173365639,
                        0.49936782006203
                    ],
                    [
                        121.45168885589,
                        0.4992573857416
                    ],
                    [
                        121.45161509514,
                        0.49907768455756
                    ],
                    [
                        121.45157620311,
                        0.4990200192512
                    ],
                    [
                        121.45156279206,
                        0.49899990344654
                    ],
                    [
                        121.45156279206,
                        0.49899990344654
                    ],
                    [
                        121.45156279206,
                        0.49899990344654
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1623,
                "jenis_pipa": "Pipa 75",
                "keterangan": "JDU",
                "panjang": 0.016274613542523925,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01445922256,
                        0.47704145493138
                    ],
                    [
                        122.0114068687,
                        0.47647955159635
                    ],
                    [
                        122.01064512134,
                        0.47634008154904
                    ],
                    [
                        122.00997054577,
                        0.47621938631351
                    ],
                    [
                        122.00971975923,
                        0.47619256514977
                    ],
                    [
                        122.00955882668,
                        0.47620195255709
                    ],
                    [
                        122.0093844831,
                        0.47619792938253
                    ],
                    [
                        122.0092651248,
                        0.47618585985884
                    ],
                    [
                        122.00857982039,
                        0.47622743266261
                    ],
                    [
                        122.00833171606,
                        0.47624486641898
                    ],
                    [
                        122.0081654191,
                        0.47624218430262
                    ],
                    [
                        122.00801923871,
                        0.47621536313896
                    ],
                    [
                        122.00787171721,
                        0.47615769763677
                    ],
                    [
                        122.00715824962,
                        0.47583852577869
                    ],
                    [
                        122.0070053637,
                        0.47575538016618
                    ],
                    [
                        122.00682833791,
                        0.47563334386213
                    ],
                    [
                        122.0064380765,
                        0.47535172161376
                    ],
                    [
                        122.00608670712,
                        0.47509557946362
                    ],
                    [
                        122.00536251068,
                        0.47453367597011
                    ],
                    [
                        122.00479388237,
                        0.47410990146747
                    ],
                    [
                        122.0040884614,
                        0.47359225283097
                    ],
                    [
                        122.00389802456,
                        0.47348228601721
                    ],
                    [
                        122.00378000736,
                        0.47342596155094
                    ],
                    [
                        122.00362443924,
                        0.47336159073179
                    ],
                    [
                        122.00351178646,
                        0.47334013379195
                    ],
                    [
                        122.00332671404,
                        0.47332404108701
                    ],
                    [
                        122.00310945511,
                        0.47335890861431
                    ],
                    [
                        122.00246840715,
                        0.47348228601721
                    ],
                    [
                        122.00196415186,
                        0.47355738530485
                    ],
                    [
                        122.00158059597,
                        0.47353861048301
                    ],
                    [
                        122.00121313334,
                        0.47353458730689
                    ],
                    [
                        122.00088456273,
                        0.47349837872176
                    ],
                    [
                        122.00063109398,
                        0.47344339531436
                    ],
                    [
                        122.00049966574,
                        0.47340182249383
                    ],
                    [
                        122.00031459332,
                        0.47331063049954
                    ],
                    [
                        122.00001686811,
                        0.47310947168438
                    ],
                    [
                        121.99982374907,
                        0.47301559756863
                    ],
                    [
                        121.99966683984,
                        0.47293111086337
                    ],
                    [
                        121.99950993061,
                        0.47287210427497
                    ],
                    [
                        121.99932083488,
                        0.47280773345068
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2099,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 5.1063651629628514e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08985880017,
                        0.54567912799591
                    ],
                    [
                        122.08984538913,
                        0.54569253843274
                    ],
                    [
                        122.08985611796,
                        0.54571131304428
                    ],
                    [
                        122.08986282349,
                        0.54571935930634
                    ],
                    [
                        122.08986282349,
                        0.54571935930634
                    ],
                    [
                        122.08986282349,
                        0.54571935930634
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2100,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 9.112472303247926e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0898655057,
                        0.54572338243736
                    ],
                    [
                        122.08988696337,
                        0.54577434209683
                    ],
                    [
                        122.08989232779,
                        0.54579848088275
                    ],
                    [
                        122.08988964558,
                        0.54580786818835
                    ],
                    [
                        122.08988964558,
                        0.54580920923201
                    ],
                    [
                        122.08988964558,
                        0.54580920923201
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1624,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.018194963827394543,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45177468657,
                        0.49983806192209
                    ],
                    [
                        121.45195439458,
                        0.49970127446618
                    ],
                    [
                        121.45187392831,
                        0.49944781534917
                    ],
                    [
                        121.45181491971,
                        0.49931907420663
                    ],
                    [
                        121.45174786448,
                        0.49911791616635
                    ],
                    [
                        121.45166069269,
                        0.49898649291005
                    ],
                    [
                        121.4515453577,
                        0.49884031806068
                    ],
                    [
                        121.45134419203,
                        0.49864586527436
                    ],
                    [
                        121.45108535886,
                        0.49840045243931
                    ],
                    [
                        121.45096868277,
                        0.49827171127626
                    ],
                    [
                        121.45075947046,
                        0.49805714266562
                    ],
                    [
                        121.45055428147,
                        0.49786000774843
                    ],
                    [
                        121.45038530231,
                        0.49773260762876
                    ],
                    [
                        121.45022571087,
                        0.49760788961446
                    ],
                    [
                        121.45001381636,
                        0.49745769157262
                    ],
                    [
                        121.44985288382,
                        0.49735979463279
                    ],
                    [
                        121.44957661629,
                        0.49717338812692
                    ],
                    [
                        121.44941031933,
                        0.49704464693993
                    ],
                    [
                        121.44908711314,
                        0.49682873723531
                    ],
                    [
                        121.44896373153,
                        0.4966919497169
                    ],
                    [
                        121.44875854254,
                        0.4964706757841
                    ],
                    [
                        121.44857212901,
                        0.49622660392236
                    ],
                    [
                        121.44841521978,
                        0.496010694191
                    ],
                    [
                        121.44828781486,
                        0.49584842662429
                    ],
                    [
                        121.44816711545,
                        0.49568884116224
                    ],
                    [
                        121.44802227616,
                        0.49549975250056
                    ],
                    [
                        121.44787207246,
                        0.4952972532895
                    ],
                    [
                        121.44774600863,
                        0.49512828043315
                    ],
                    [
                        121.44756764174,
                        0.49490968855704
                    ],
                    [
                        121.44744426012,
                        0.49474742096337
                    ],
                    [
                        121.44729137421,
                        0.49455162700208
                    ],
                    [
                        121.44718274474,
                        0.4944000878363
                    ],
                    [
                        121.44699364901,
                        0.49415601589831
                    ],
                    [
                        121.44681795472,
                        0.49390758201317
                    ],
                    [
                        121.44663690561,
                        0.49366216900237
                    ],
                    [
                        121.44643037551,
                        0.49342077914684
                    ],
                    [
                        121.4462171399,
                        0.49314988607629
                    ],
                    [
                        121.44595830673,
                        0.49287228772029
                    ],
                    [
                        121.44578396314,
                        0.49268319897845
                    ],
                    [
                        121.44552110666,
                        0.49237073317338
                    ],
                    [
                        121.4452072978,
                        0.49202776186165
                    ],
                    [
                        121.44501417875,
                        0.49181855726937
                    ],
                    [
                        121.44478619099,
                        0.4915758262919
                    ],
                    [
                        121.44460648298,
                        0.49139076067884
                    ],
                    [
                        121.44444286823,
                        0.49122446983374
                    ],
                    [
                        121.44425243139,
                        0.49107963586851
                    ],
                    [
                        121.44406333566,
                        0.49090529868399
                    ],
                    [
                        121.44397214055,
                        0.49082215325592
                    ],
                    [
                        121.44393593073,
                        0.49076851104372
                    ],
                    [
                        121.44390776753,
                        0.49066927294999
                    ],
                    [
                        121.44387423992,
                        0.49048554836722
                    ],
                    [
                        121.44378975034,
                        0.49028707216993
                    ],
                    [
                        121.44374415278,
                        0.49018112879193
                    ],
                    [
                        121.44371464849,
                        0.49006982119047
                    ],
                    [
                        121.44369550448,
                        0.48989889895094
                    ],
                    [
                        121.44370623331,
                        0.48963873418188
                    ],
                    [
                        121.44371733069,
                        0.48936040281961
                    ],
                    [
                        121.44372537732,
                        0.4889942946329
                    ],
                    [
                        121.44376695156,
                        0.48876363305446
                    ],
                    [
                        121.4437776804,
                        0.48859466003267
                    ],
                    [
                        121.44377097487,
                        0.4884390975644
                    ],
                    [
                        121.44374012947,
                        0.48828621720415
                    ],
                    [
                        121.44370123744,
                        0.48806762510406
                    ],
                    [
                        121.44367039204,
                        0.4878651256676
                    ],
                    [
                        121.44363552332,
                        0.48762239454696
                    ],
                    [
                        121.44359663129,
                        0.48737431704463
                    ],
                    [
                        121.44356846809,
                        0.48716375340014
                    ],
                    [
                        121.44353359938,
                        0.48696259945529
                    ],
                    [
                        121.44350141287,
                        0.48673190359278
                    ],
                    [
                        121.4434504509,
                        0.48642885168016
                    ],
                    [
                        121.44340753555,
                        0.48626928086908
                    ],
                    [
                        121.44335523248,
                        0.48603454768208
                    ],
                    [
                        121.44331768155,
                        0.48588843279581
                    ],
                    [
                        121.44324660301,
                        0.48563099089291
                    ],
                    [
                        121.4431835711,
                        0.48540298602318
                    ],
                    [
                        121.44312053919,
                        0.48503280684942
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1625,
                "jenis_pipa": "Pipa 150",
                "keterangan": "JDU",
                "panjang": 0.008595735052963516,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0684145391,
                        0.50010224945142
                    ],
                    [
                        122.06843599677,
                        0.50009420313089
                    ],
                    [
                        122.06842526793,
                        0.50003385572658
                    ],
                    [
                        122.06839308143,
                        0.49972943658968
                    ],
                    [
                        122.0683555305,
                        0.49951352697303
                    ],
                    [
                        122.06834614277,
                        0.49936735213538
                    ],
                    [
                        122.06836894155,
                        0.49932577947452
                    ],
                    [
                        122.06846415997,
                        0.49931773315305
                    ],
                    [
                        122.06873640418,
                        0.49930566367079
                    ],
                    [
                        122.06912264228,
                        0.49930029945646
                    ],
                    [
                        122.06959202886,
                        0.49927079627752
                    ],
                    [
                        122.06981599331,
                        0.49926274995597
                    ],
                    [
                        122.07008287311,
                        0.49926140890238
                    ],
                    [
                        122.07058042288,
                        0.49923592888406
                    ],
                    [
                        122.07089692354,
                        0.49921715413365
                    ],
                    [
                        122.07128047943,
                        0.49920374359763
                    ],
                    [
                        122.07148298621,
                        0.49919837938319
                    ],
                    [
                        122.07157149911,
                        0.49920508465122
                    ],
                    [
                        122.07178205252,
                        0.49919033306155
                    ],
                    [
                        122.07204893231,
                        0.49918630990074
                    ],
                    [
                        122.07248747349,
                        0.49917155831103
                    ],
                    [
                        122.07274898887,
                        0.49915680672129
                    ],
                    [
                        122.07307085395,
                        0.49915010145321
                    ],
                    [
                        122.07325592637,
                        0.49915278356045
                    ],
                    [
                        122.07345038652,
                        0.49914741934598
                    ],
                    [
                        122.07361534238,
                        0.49914876039959
                    ],
                    [
                        122.07381650805,
                        0.49915680672129
                    ],
                    [
                        122.07396939397,
                        0.49914339618512
                    ],
                    [
                        122.07406193018,
                        0.49912998564894
                    ],
                    [
                        122.07430064678,
                        0.49911523405911
                    ],
                    [
                        122.07456350327,
                        0.49910718773737
                    ],
                    [
                        122.07494437695,
                        0.4990937772011
                    ],
                    [
                        122.07529172301,
                        0.49907634350393
                    ],
                    [
                        122.07569003105,
                        0.49904818137763
                    ],
                    [
                        122.07593008876,
                        0.49902940662669
                    ],
                    [
                        122.07607358694,
                        0.49902270135847
                    ],
                    [
                        122.07613930106,
                        0.49905488664581
                    ],
                    [
                        122.07614332438,
                        0.49905756875307
                    ],
                    [
                        122.07614332438,
                        0.49905756875307
                    ],
                    [
                        122.07614332438,
                        0.49905756875307
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1626,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0040863276302918776,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4431232214,
                        0.48504086136983
                    ],
                    [
                        121.44304275513,
                        0.48502208657948
                    ],
                    [
                        121.44302934408,
                        0.48493894107871
                    ],
                    [
                        121.44299983978,
                        0.48475789845251
                    ],
                    [
                        121.44296228886,
                        0.48451516722019
                    ],
                    [
                        121.44294351339,
                        0.4842308632243
                    ],
                    [
                        121.44293278456,
                        0.48404043318266
                    ],
                    [
                        121.44290998578,
                        0.48383391045539
                    ],
                    [
                        121.4428845048,
                        0.48362738772183
                    ],
                    [
                        121.4428576827,
                        0.48343561660647
                    ],
                    [
                        121.44282013178,
                        0.48319020321318
                    ],
                    [
                        121.4427664876,
                        0.48295417720909
                    ],
                    [
                        121.44277051091,
                        0.48287907802425
                    ],
                    [
                        121.44276246428,
                        0.48282275363507
                    ],
                    [
                        121.4427383244,
                        0.48278654509894
                    ],
                    [
                        121.44270211458,
                        0.48275167761951
                    ],
                    [
                        121.44263908267,
                        0.4827476544488
                    ],
                    [
                        121.44254788756,
                        0.48277983981445
                    ],
                    [
                        121.44228234887,
                        0.48285091582972
                    ],
                    [
                        121.4420838654,
                        0.48290187599116
                    ],
                    [
                        121.44189208746,
                        0.48295820037969
                    ],
                    [
                        121.44185587764,
                        0.48295820037969
                    ],
                    [
                        121.44183039665,
                        0.48295551826595
                    ],
                    [
                        121.44179821014,
                        0.48294344875417
                    ],
                    [
                        121.44177943468,
                        0.48292333290114
                    ],
                    [
                        121.44175261259,
                        0.48290455810491
                    ],
                    [
                        121.44170567393,
                        0.48290187599116
                    ],
                    [
                        121.44159302115,
                        0.48294747192477
                    ],
                    [
                        121.44137978554,
                        0.48301452476774
                    ],
                    [
                        121.44126042724,
                        0.48306816704164
                    ],
                    [
                        121.44119739532,
                        0.4830869418374
                    ],
                    [
                        121.44113838673,
                        0.48310705768995
                    ],
                    [
                        121.44109815359,
                        0.48311912720145
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1628,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.002538857050278192,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44109413028,
                        0.48311912720145
                    ],
                    [
                        121.44099220634,
                        0.48312315037195
                    ],
                    [
                        121.44088625908,
                        0.48314728939488
                    ],
                    [
                        121.44069448113,
                        0.48319154427001
                    ],
                    [
                        121.44058316946,
                        0.4832183654063
                    ],
                    [
                        121.44056305289,
                        0.48319556744045
                    ],
                    [
                        121.44054964185,
                        0.48316069996311
                    ],
                    [
                        121.44054293633,
                        0.48311644508779
                    ],
                    [
                        121.44052952528,
                        0.48307084915531
                    ],
                    [
                        121.44052952528,
                        0.48300916054033
                    ],
                    [
                        121.44051074982,
                        0.48295015403849
                    ],
                    [
                        121.44043698907,
                        0.48251296948629
                    ],
                    [
                        121.44037529826,
                        0.48223000646358
                    ],
                    [
                        121.44024252892,
                        0.48170162998215
                    ],
                    [
                        121.44014060497,
                        0.48125774006378
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1627,
                "jenis_pipa": "Pipa 100",
                "keterangan": "JDU",
                "panjang": 0.002057750307603665,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07615271211,
                        0.49908036666482
                    ],
                    [
                        122.07617148757,
                        0.49916485304297
                    ],
                    [
                        122.07617551088,
                        0.49945049745628
                    ],
                    [
                        122.0761808753,
                        0.49961947020196
                    ],
                    [
                        122.07618623972,
                        0.49991986618358
                    ],
                    [
                        122.07619160414,
                        0.50014114000053
                    ],
                    [
                        122.07620635629,
                        0.50036241381002
                    ],
                    [
                        122.0762398839,
                        0.50062660131825
                    ],
                    [
                        122.07629352808,
                        0.50068560766381
                    ],
                    [
                        122.07635253668,
                        0.50073924979567
                    ],
                    [
                        122.07643300295,
                        0.50077009402129
                    ],
                    [
                        122.076536268,
                        0.50078752771397
                    ],
                    [
                        122.07663148642,
                        0.50079155087382
                    ],
                    [
                        122.07669049501,
                        0.50079020982054
                    ],
                    [
                        122.07668915391,
                        0.50078886876726
                    ],
                    [
                        122.07668915391,
                        0.50078886876726
                    ],
                    [
                        122.07668915391,
                        0.50078886876726
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1630,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.02683457091968244,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09163174033,
                        0.50211785243391
                    ],
                    [
                        122.09181547165,
                        0.50212589875197
                    ],
                    [
                        122.09212660789,
                        0.50212053453994
                    ],
                    [
                        122.09250614047,
                        0.50214333244104
                    ],
                    [
                        122.09267780185,
                        0.50215942507706
                    ],
                    [
                        122.09293395281,
                        0.50219697456096
                    ],
                    [
                        122.09344491363,
                        0.50227073247514
                    ],
                    [
                        122.09381774068,
                        0.50232303354104
                    ],
                    [
                        122.09416776896,
                        0.50237935776542
                    ],
                    [
                        122.0945982635,
                        0.50245043357165
                    ],
                    [
                        122.0949241519,
                        0.50250005253025
                    ],
                    [
                        122.09522590041,
                        0.50254430727681
                    ],
                    [
                        122.09574222565,
                        0.50260733676381
                    ],
                    [
                        122.096054703,
                        0.50264756835094
                    ],
                    [
                        122.09632962942,
                        0.50265829677413
                    ],
                    [
                        122.09665685892,
                        0.50266097887992
                    ],
                    [
                        122.0972442627,
                        0.5026274525574
                    ],
                    [
                        122.09736093879,
                        0.50261270097543
                    ],
                    [
                        122.09750980139,
                        0.50259794939343
                    ],
                    [
                        122.09771767259,
                        0.50259124412888
                    ],
                    [
                        122.09799259901,
                        0.50257783359975
                    ],
                    [
                        122.09836676717,
                        0.50257246938809
                    ],
                    [
                        122.09853708744,
                        0.50258319781141
                    ],
                    [
                        122.09898635745,
                        0.50263952203353
                    ],
                    [
                        122.0992398262,
                        0.50268243572625
                    ],
                    [
                        122.09969446063,
                        0.5027575346878
                    ],
                    [
                        122.09985941648,
                        0.5027937431154
                    ],
                    [
                        122.10013434291,
                        0.50282458733133
                    ],
                    [
                        122.10028722882,
                        0.50284202101854
                    ],
                    [
                        122.10042268038,
                        0.50284202101854
                    ],
                    [
                        122.10052192211,
                        0.50283799785995
                    ],
                    [
                        122.10061579943,
                        0.50282861048993
                    ],
                    [
                        122.10076466203,
                        0.50279642522114
                    ],
                    [
                        122.10089206696,
                        0.5027575346878
                    ],
                    [
                        122.10104227066,
                        0.50267170730308
                    ],
                    [
                        122.10115492344,
                        0.50259526728762
                    ],
                    [
                        122.10124880075,
                        0.50250407568904
                    ],
                    [
                        122.10136547685,
                        0.50240483777151
                    ],
                    [
                        122.10149422288,
                        0.50228548405788
                    ],
                    [
                        122.10162162781,
                        0.50220099771994
                    ],
                    [
                        122.10171952844,
                        0.50214065033503
                    ],
                    [
                        122.10197031498,
                        0.50201593240446
                    ],
                    [
                        122.10215270519,
                        0.50194351554046
                    ],
                    [
                        122.10229754448,
                        0.50191535342646
                    ],
                    [
                        122.10253089666,
                        0.50188719131235
                    ],
                    [
                        122.10270121694,
                        0.50188987341847
                    ],
                    [
                        122.10288763046,
                        0.50194753869959
                    ],
                    [
                        122.10310891271,
                        0.50201995556355
                    ],
                    [
                        122.10327923298,
                        0.5020923724267
                    ],
                    [
                        122.10349649191,
                        0.50216210718307
                    ],
                    [
                        122.10370972753,
                        0.50223586509763
                    ],
                    [
                        122.10392028093,
                        0.50231364617027
                    ],
                    [
                        122.10423007607,
                        0.50242495356572
                    ],
                    [
                        122.10464984179,
                        0.50254430727681
                    ],
                    [
                        122.10499182343,
                        0.50265293256253
                    ],
                    [
                        122.10523992777,
                        0.50273607784173
                    ],
                    [
                        122.10541829467,
                        0.50280044837975
                    ],
                    [
                        122.10562080145,
                        0.50289566313273
                    ],
                    [
                        122.105756253,
                        0.50304049683883
                    ],
                    [
                        122.10589438677,
                        0.50335430319102
                    ],
                    [
                        122.10595607758,
                        0.50358630531348
                    ],
                    [
                        122.10611432791,
                        0.50427024215821
                    ],
                    [
                        122.10624575615,
                        0.5046993789653
                    ],
                    [
                        122.10639864206,
                        0.50528675992407
                    ],
                    [
                        122.10648447275,
                        0.50556838091289
                    ],
                    [
                        122.10657298565,
                        0.50577222085907
                    ],
                    [
                        122.10667088628,
                        0.50593314712784
                    ],
                    [
                        122.10682108998,
                        0.50604311340921
                    ],
                    [
                        122.10693374276,
                        0.50613162285384
                    ],
                    [
                        122.10712820292,
                        0.5061906291496
                    ],
                    [
                        122.10728108883,
                        0.50624561228832
                    ],
                    [
                        122.10743799806,
                        0.50629120806155
                    ],
                    [
                        122.10767805576,
                        0.50633546278233
                    ],
                    [
                        122.10779204965,
                        0.50636228382508
                    ],
                    [
                        122.10797846317,
                        0.50637569434639
                    ],
                    [
                        122.10819035769,
                        0.50638374065918
                    ],
                    [
                        122.10844784975,
                        0.50636496592934
                    ],
                    [
                        122.10873350501,
                        0.50635423751226
                    ],
                    [
                        122.10895746946,
                        0.50634887330372
                    ],
                    [
                        122.10930079222,
                        0.50633278067804
                    ],
                    [
                        122.10954889655,
                        0.50633278067804
                    ],
                    [
                        122.10975006223,
                        0.50634485014731
                    ],
                    [
                        122.11006388068,
                        0.50644408800476
                    ],
                    [
                        122.11020201445,
                        0.50649773008924
                    ],
                    [
                        122.11086854339,
                        0.50680617206638
                    ],
                    [
                        122.11112603545,
                        0.50693625411322
                    ],
                    [
                        122.11137682199,
                        0.50705828984549
                    ],
                    [
                        122.11175769567,
                        0.50722592134211
                    ],
                    [
                        122.11204066873,
                        0.50731174866672
                    ],
                    [
                        122.11219623685,
                        0.50734393391314
                    ],
                    [
                        122.11243495345,
                        0.50741098650934
                    ],
                    [
                        122.11263746023,
                        0.50746462858582
                    ],
                    [
                        122.11281850934,
                        0.50750217803909
                    ],
                    [
                        122.11296737194,
                        0.50751290645426
                    ],
                    [
                        122.11311891675,
                        0.50752631697322
                    ],
                    [
                        122.11330801249,
                        0.50752631697322
                    ],
                    [
                        122.11355477571,
                        0.50751290645426
                    ],
                    [
                        122.1138176322,
                        0.50749681383149
                    ],
                    [
                        122.11396515369,
                        0.50750754224668
                    ],
                    [
                        122.11430579424,
                        0.50753168118078
                    ],
                    [
                        122.11484223604,
                        0.50759068746377
                    ],
                    [
                        122.11543768644,
                        0.50767115057608
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1629,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.015079066924112964,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07671061158,
                        0.50078216350085
                    ],
                    [
                        122.07678169012,
                        0.50077948139427
                    ],
                    [
                        122.07689836621,
                        0.50077948139427
                    ],
                    [
                        122.07705795765,
                        0.50077143507458
                    ],
                    [
                        122.07727119327,
                        0.50076472980816
                    ],
                    [
                        122.07759037614,
                        0.50074327295554
                    ],
                    [
                        122.07779556513,
                        0.50073790874238
                    ],
                    [
                        122.0780852437,
                        0.50072718031605
                    ],
                    [
                        122.07828506827,
                        0.5007097466232
                    ],
                    [
                        122.0786216855,
                        0.5006976771435
                    ],
                    [
                        122.07896500826,
                        0.50068426661049
                    ],
                    [
                        122.07965970039,
                        0.50064939922455
                    ],
                    [
                        122.08011031151,
                        0.50064135290469
                    ],
                    [
                        122.08069503307,
                        0.50063867079805
                    ],
                    [
                        122.08117246628,
                        0.50064403501131
                    ],
                    [
                        122.08182960749,
                        0.50063867079805
                    ],
                    [
                        122.08219841123,
                        0.50064269395799
                    ],
                    [
                        122.08252966404,
                        0.50066817397086
                    ],
                    [
                        122.08296149969,
                        0.5007057234633
                    ],
                    [
                        122.08342418075,
                        0.5007486371687
                    ],
                    [
                        122.08371654153,
                        0.50080496140661
                    ],
                    [
                        122.08401963115,
                        0.50085726248424
                    ],
                    [
                        122.08450242877,
                        0.50091760988097
                    ],
                    [
                        122.08491548896,
                        0.5009699109577
                    ],
                    [
                        122.08517432213,
                        0.50100611939519
                    ],
                    [
                        122.08600848913,
                        0.501130837345
                    ],
                    [
                        122.08676755428,
                        0.50123946265419
                    ],
                    [
                        122.08720073104,
                        0.50129578688788
                    ],
                    [
                        122.08760842681,
                        0.50135613428059
                    ],
                    [
                        122.08845064044,
                        0.50151035539274
                    ],
                    [
                        122.08885967731,
                        0.50161227543008
                    ],
                    [
                        122.08954900503,
                        0.50178661233237
                    ],
                    [
                        122.09012433887,
                        0.50192339974476
                    ],
                    [
                        122.0905521512,
                        0.50201593240446
                    ],
                    [
                        122.09069296718,
                        0.50205750504825
                    ],
                    [
                        122.09086999297,
                        0.50209371347972
                    ],
                    [
                        122.09106042981,
                        0.50212053453994
                    ],
                    [
                        122.09127902985,
                        0.50211919348693
                    ],
                    [
                        122.09163978696,
                        0.50211785243391
                    ],
                    [
                        122.09162905812,
                        0.50211382927489
                    ],
                    [
                        122.09162905812,
                        0.50211382927489
                    ],
                    [
                        122.09162905812,
                        0.50211382927489
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2141,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0024368330391719923,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.6518111527,
                        0.54912695032178
                    ],
                    [
                        121.65162608027,
                        0.54924764418288
                    ],
                    [
                        121.65140882134,
                        0.54940186411297
                    ],
                    [
                        121.65118083358,
                        0.54953865048242
                    ],
                    [
                        121.65098369122,
                        0.5496794599771
                    ],
                    [
                        121.65083348751,
                        0.5498014948698
                    ],
                    [
                        121.65064305067,
                        0.5499610789565
                    ],
                    [
                        121.65048748255,
                        0.55010322948392
                    ],
                    [
                        121.65029704571,
                        0.55029633962895
                    ],
                    [
                        121.65012270212,
                        0.55046262891549
                    ],
                    [
                        121.64997920394,
                        0.55060343838837
                    ],
                    [
                        121.6500261426,
                        0.55066244426174
                    ],
                    [
                        121.6500261426,
                        0.55066244426174
                    ],
                    [
                        121.6500261426,
                        0.55066244426174
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1631,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.006768682834579215,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47524535656,
                        0.51063889766736
                    ],
                    [
                        121.47513136268,
                        0.51074484071493
                    ],
                    [
                        121.475109905,
                        0.51073545335635
                    ],
                    [
                        121.47507637739,
                        0.51071801969039
                    ],
                    [
                        121.47503212094,
                        0.51068449340956
                    ],
                    [
                        121.47494226694,
                        0.51062012294989
                    ],
                    [
                        121.47469416261,
                        0.51042969366957
                    ],
                    [
                        121.47456139326,
                        0.51061475874489
                    ],
                    [
                        121.47445142269,
                        0.51079043645637
                    ],
                    [
                        121.47436693311,
                        0.51090979001335
                    ],
                    [
                        121.47427037358,
                        0.51105596459136
                    ],
                    [
                        121.47415101528,
                        0.511245052802
                    ],
                    [
                        121.47406920791,
                        0.51138049896364
                    ],
                    [
                        121.47395923734,
                        0.51153203773516
                    ],
                    [
                        121.4739485085,
                        0.51155081244997
                    ],
                    [
                        121.47392168641,
                        0.51157495136894
                    ],
                    [
                        121.47389620543,
                        0.51159372608362
                    ],
                    [
                        121.47384524345,
                        0.51159506713467
                    ],
                    [
                        121.47381171584,
                        0.51159506713467
                    ],
                    [
                        121.47375404835,
                        0.51158031557314
                    ],
                    [
                        121.47352606058,
                        0.51145693887539
                    ],
                    [
                        121.47328332067,
                        0.51131210535762
                    ],
                    [
                        121.47304326296,
                        0.51118470550133
                    ],
                    [
                        121.47264495492,
                        0.51094868049774
                    ],
                    [
                        121.47241294384,
                        0.51082128063424
                    ],
                    [
                        121.47222787142,
                        0.51071131443425
                    ],
                    [
                        121.47201597691,
                        0.51059598402734
                    ],
                    [
                        121.47182419896,
                        0.51049004097731
                    ],
                    [
                        121.47161096334,
                        0.51036398215603
                    ],
                    [
                        121.47137627006,
                        0.51023792333228
                    ],
                    [
                        121.47117108107,
                        0.51011320555741
                    ],
                    [
                        121.47092565894,
                        0.50998312357459
                    ],
                    [
                        121.47069498897,
                        0.50985304158913
                    ],
                    [
                        121.47054612637,
                        0.50975916798977
                    ],
                    [
                        121.47042945027,
                        0.50968272805783
                    ],
                    [
                        121.47026181221,
                        0.50960360602208
                    ],
                    [
                        121.47012904286,
                        0.50952582503681
                    ],
                    [
                        121.46982461214,
                        0.50936623990895
                    ],
                    [
                        121.46982595325,
                        0.50936489885745
                    ],
                    [
                        121.46982595325,
                        0.50936489885745
                    ],
                    [
                        121.46982595325,
                        0.50936489885745
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1632,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.00028177148665215753,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07229569554,
                        0.51114045081382
                    ],
                    [
                        122.07249283791,
                        0.51104389513092
                    ],
                    [
                        122.0724901557,
                        0.51104389513092
                    ],
                    [
                        122.0724901557,
                        0.51104389513092
                    ],
                    [
                        122.0725411216,
                        0.51101305320407
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1633,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.011053021601516414,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46983936429,
                        0.50936758393564
                    ],
                    [
                        121.46962076426,
                        0.50924420422028
                    ],
                    [
                        121.46944642067,
                        0.50914496640581
                    ],
                    [
                        121.46923050284,
                        0.50901354335185
                    ],
                    [
                        121.46897435188,
                        0.50886602767586
                    ],
                    [
                        121.46865919232,
                        0.50868230360196
                    ],
                    [
                        121.46843791008,
                        0.5085481984352
                    ],
                    [
                        121.46805611553,
                        0.50832035344608
                    ],
                    [
                        121.46764397621,
                        0.50808821769214
                    ],
                    [
                        121.46735697985,
                        0.50792863252871
                    ],
                    [
                        121.46699756384,
                        0.50772613370225
                    ],
                    [
                        121.46640479565,
                        0.50736539074401
                    ],
                    [
                        121.46617949009,
                        0.50723262660189
                    ],
                    [
                        121.46591797471,
                        0.50708242878127
                    ],
                    [
                        121.46557331085,
                        0.50690406886476
                    ],
                    [
                        121.46515086293,
                        0.50668011317315
                    ],
                    [
                        121.46494701505,
                        0.50656612374631
                    ],
                    [
                        121.46478071809,
                        0.5064642037865
                    ],
                    [
                        121.4645178616,
                        0.50630193647874
                    ],
                    [
                        121.46420001984,
                        0.50611687127983
                    ],
                    [
                        121.46387547255,
                        0.50591571344891
                    ],
                    [
                        121.46362066269,
                        0.50577490296358
                    ],
                    [
                        121.46327599883,
                        0.50554692407607
                    ],
                    [
                        121.46279320121,
                        0.50528944202879
                    ],
                    [
                        121.46241769195,
                        0.50503330102371
                    ],
                    [
                        121.46205022931,
                        0.50484957684109
                    ],
                    [
                        121.46166533232,
                        0.50463232634104
                    ],
                    [
                        121.46141856909,
                        0.50453174740339
                    ],
                    [
                        121.46122545004,
                        0.50447140004006
                    ],
                    [
                        121.46093845367,
                        0.50437618531009
                    ],
                    [
                        121.46014586091,
                        0.50412809058463
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1815,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.001836238163523471,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9293480562,
                        0.46149857506926
                    ],
                    [
                        121.92979858484,
                        0.46137251533379
                    ],
                    [
                        121.93016101273,
                        0.46128266424438
                    ],
                    [
                        121.9304171168,
                        0.46120890588654
                    ],
                    [
                        121.9304761146,
                        0.46119683633701
                    ],
                    [
                        121.93053108982,
                        0.46118476678746
                    ],
                    [
                        121.93054583927,
                        0.4612035416423
                    ],
                    [
                        121.9305646113,
                        0.46123572710766
                    ],
                    [
                        121.93058874676,
                        0.46130412122107
                    ],
                    [
                        121.93062092738,
                        0.4614060418594
                    ],
                    [
                        121.93065310799,
                        0.46153612477726
                    ],
                    [
                        121.93068528861,
                        0.4616595023879
                    ],
                    [
                        121.93071478751,
                        0.46175337665541
                    ],
                    [
                        121.93072417352,
                        0.46176008196019
                    ],
                    [
                        121.93072417352,
                        0.46176008196019
                    ],
                    [
                        121.93072417352,
                        0.46176008196019
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1638,
                "jenis_pipa": "Pipa 200",
                "keterangan": "PIPA Distribusi",
                "panjang": 0.0006208812753014805,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56944185495,
                        0.57106368953545
                    ],
                    [
                        121.56977578998,
                        0.57083034893691
                    ],
                    [
                        121.56979992986,
                        0.57062248805093
                    ],
                    [
                        121.56980395317,
                        0.57062114701294
                    ],
                    [
                        121.56980395317,
                        0.57062114701294
                    ],
                    [
                        121.56980395317,
                        0.57062114701294
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1639,
                "jenis_pipa": "Pipa 150",
                "keterangan": "PIPA Distribusi",
                "panjang": 0.007901487143403312,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56980529428,
                        0.57060237248093
                    ],
                    [
                        121.56981468201,
                        0.57041462715744
                    ],
                    [
                        121.56981602311,
                        0.57022956390402
                    ],
                    [
                        121.56979322433,
                        0.5701531247324
                    ],
                    [
                        121.56976640224,
                        0.57006193414035
                    ],
                    [
                        121.56971409917,
                        0.56995062797459
                    ],
                    [
                        121.569634974,
                        0.56982859350121
                    ],
                    [
                        121.56954646111,
                        0.56971058213986
                    ],
                    [
                        121.56943380833,
                        0.56954965755234
                    ],
                    [
                        121.56932920218,
                        0.56938873296033
                    ],
                    [
                        121.56924337149,
                        0.56926535743672
                    ],
                    [
                        121.56912535429,
                        0.56904006299554
                    ],
                    [
                        121.56904220581,
                        0.56882013269922
                    ],
                    [
                        121.56897783279,
                        0.56857069954813
                    ],
                    [
                        121.56892687082,
                        0.56831858430918
                    ],
                    [
                        121.56889736652,
                        0.56818716253133
                    ],
                    [
                        121.56886518002,
                        0.56807183321362
                    ],
                    [
                        121.56882494688,
                        0.56796186804807
                    ],
                    [
                        121.56875252724,
                        0.56783849249397
                    ],
                    [
                        121.56863987446,
                        0.56763733669363
                    ],
                    [
                        121.56843334436,
                        0.56732621570864
                    ],
                    [
                        121.56822949648,
                        0.56701509470693
                    ],
                    [
                        121.56807929277,
                        0.56678443602245
                    ],
                    [
                        121.56795859337,
                        0.56659669057481
                    ],
                    [
                        121.56787008047,
                        0.566459904602
                    ],
                    [
                        121.56779766083,
                        0.56634457524985
                    ],
                    [
                        121.567671597,
                        0.56614878355374
                    ],
                    [
                        121.56757235527,
                        0.56597981263262
                    ],
                    [
                        121.56749457121,
                        0.56579474923716
                    ],
                    [
                        121.56744897366,
                        0.56566869155861
                    ],
                    [
                        121.56742751598,
                        0.56555068011239
                    ],
                    [
                        121.56740605831,
                        0.56537634501698
                    ],
                    [
                        121.56739801168,
                        0.56522078446588
                    ],
                    [
                        121.5674033761,
                        0.56503303896764
                    ],
                    [
                        121.5674033761,
                        0.56484529346333
                    ],
                    [
                        121.56744360924,
                        0.56460658845624
                    ],
                    [
                        121.56746506691,
                        0.56436251928154
                    ],
                    [
                        121.56750798225,
                        0.56412113217562
                    ],
                    [
                        121.5675508976,
                        0.56386365258492
                    ],
                    [
                        121.56758844852,
                        0.56369199951816
                    ],
                    [
                        121.56766355038,
                        0.56336478584557
                    ],
                    [
                        121.567671597,
                        0.56335673960749
                    ],
                    [
                        121.567671597,
                        0.56335673960749
                    ],
                    [
                        121.567671597,
                        0.56335673960749
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1636,
                "jenis_pipa": "Pipa 150",
                "keterangan": "PIPA Distribusi",
                "panjang": 0.000548208017743193,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56759649515,
                        0.56369468159736
                    ],
                    [
                        121.56773597002,
                        0.56368395328052
                    ],
                    [
                        121.56782716513,
                        0.56369199951816
                    ],
                    [
                        121.56788885593,
                        0.5636276296168
                    ],
                    [
                        121.56794518232,
                        0.56348816149477
                    ],
                    [
                        121.5679679811,
                        0.5634144043135
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1640,
                "jenis_pipa": "Pipa 150",
                "keterangan": "PIPA Distribusi",
                "panjang": 0.021467204385536596,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56756699085,
                        0.56330443905969
                    ],
                    [
                        121.56812220812,
                        0.56345329446375
                    ],
                    [
                        121.56824022532,
                        0.56348413837581
                    ],
                    [
                        121.5682965517,
                        0.56348816149477
                    ],
                    [
                        121.56837835908,
                        0.56348011525686
                    ],
                    [
                        121.56843870878,
                        0.5634479303051
                    ],
                    [
                        121.56848028302,
                        0.56340769911516
                    ],
                    [
                        121.56855538487,
                        0.5633299188138
                    ],
                    [
                        121.56862780452,
                        0.56321593043926
                    ],
                    [
                        121.56878203154,
                        0.56301879759803
                    ],
                    [
                        121.56885713339,
                        0.56290480921741
                    ],
                    [
                        121.56893759966,
                        0.56279484395398
                    ],
                    [
                        121.56901538372,
                        0.56265001165266
                    ],
                    [
                        121.56907439232,
                        0.5625373643047
                    ],
                    [
                        121.56911328435,
                        0.56242337591466
                    ],
                    [
                        121.56916022301,
                        0.56229061296347
                    ],
                    [
                        121.56922996044,
                        0.56208006969123
                    ],
                    [
                        121.56929031014,
                        0.5618802547316
                    ],
                    [
                        121.56937479973,
                        0.56164691376335
                    ],
                    [
                        121.56947940588,
                        0.56132372309657
                    ],
                    [
                        121.56956255436,
                        0.56108501794529
                    ],
                    [
                        121.56966716051,
                        0.56077657869049
                    ],
                    [
                        121.56976237893,
                        0.56050166542794
                    ],
                    [
                        121.56988307834,
                        0.56014628972797
                    ],
                    [
                        121.56996622682,
                        0.55989015100255
                    ],
                    [
                        121.57006546855,
                        0.55959914521191
                    ],
                    [
                        121.57019287348,
                        0.55920219719771
                    ],
                    [
                        121.57032161951,
                        0.55883743413399
                    ],
                    [
                        121.57040208578,
                        0.55862420865611
                    ],
                    [
                        121.57046109438,
                        0.55842439357861
                    ],
                    [
                        121.57054960728,
                        0.55816557269631
                    ],
                    [
                        121.57063409686,
                        0.55789736451613
                    ],
                    [
                        121.57071858644,
                        0.55763183840568
                    ],
                    [
                        121.57080441713,
                        0.55735424291379
                    ],
                    [
                        121.57086744905,
                        0.55711956072445
                    ],
                    [
                        121.57096266747,
                        0.55676954898468
                    ],
                    [
                        121.5710324049,
                        0.55649329449341
                    ],
                    [
                        121.57110750675,
                        0.55620497061737
                    ],
                    [
                        121.57117053866,
                        0.55597565254777
                    ],
                    [
                        121.5712402761,
                        0.5557154905165
                    ],
                    [
                        121.5712992847,
                        0.55546605680566
                    ],
                    [
                        121.57137304544,
                        0.55520053058577
                    ],
                    [
                        121.57145485282,
                        0.55486929331495
                    ],
                    [
                        121.57153263688,
                        0.55452062248353
                    ],
                    [
                        121.57158628106,
                        0.55426180143001
                    ],
                    [
                        121.57162383199,
                        0.55404187057772
                    ],
                    [
                        121.57166808844,
                        0.5537776853358
                    ],
                    [
                        121.57169088721,
                        0.55360603197433
                    ],
                    [
                        121.57172307372,
                        0.5533673265103
                    ],
                    [
                        121.57176062465,
                        0.55311655165852
                    ],
                    [
                        121.5718062222,
                        0.55275312926092
                    ],
                    [
                        121.57184645534,
                        0.55248760291947
                    ],
                    [
                        121.57189071178,
                        0.55214697820145
                    ],
                    [
                        121.5719255805,
                        0.55191765997478
                    ],
                    [
                        121.57195240259,
                        0.55168968278161
                    ],
                    [
                        121.57200202346,
                        0.55133564759372
                    ],
                    [
                        121.57204896212,
                        0.55098697655478
                    ],
                    [
                        121.57208785415,
                        0.5507120628366
                    ],
                    [
                        121.57212004066,
                        0.55044653640408
                    ],
                    [
                        121.57214820385,
                        0.55024135687995
                    ],
                    [
                        121.57217368484,
                        0.55003081317792
                    ],
                    [
                        121.57220318913,
                        0.54983099781052
                    ],
                    [
                        121.57224208117,
                        0.5495319452683
                    ],
                    [
                        121.57227560878,
                        0.54928385234074
                    ],
                    [
                        121.57229840755,
                        0.54913633762217
                    ],
                    [
                        121.57232791185,
                        0.54893249909599
                    ],
                    [
                        121.57236546278,
                        0.5486227181646
                    ],
                    [
                        121.57240837812,
                        0.54829148052757
                    ],
                    [
                        121.57246470451,
                        0.5478985548858
                    ],
                    [
                        121.57250627875,
                        0.547548542603
                    ],
                    [
                        121.57254651189,
                        0.54726290038005
                    ],
                    [
                        121.57259479165,
                        0.54693300371126
                    ],
                    [
                        121.57261893153,
                        0.54671441363213
                    ],
                    [
                        121.57264575362,
                        0.54650923398007
                    ],
                    [
                        121.57267928123,
                        0.54627857449354
                    ],
                    [
                        121.57270342112,
                        0.54609485152411
                    ],
                    [
                        121.57274097204,
                        0.54580250401373
                    ],
                    [
                        121.57277047634,
                        0.54561341685493
                    ],
                    [
                        121.57278522849,
                        0.54547528935222
                    ],
                    [
                        121.57280936837,
                        0.54534520810889
                    ],
                    [
                        121.57282546163,
                        0.54518830598691
                    ],
                    [
                        121.57284423709,
                        0.54500458298418
                    ],
                    [
                        121.57286569476,
                        0.54477794657163
                    ],
                    [
                        121.57290324569,
                        0.54443732141485
                    ],
                    [
                        121.57292068005,
                        0.54426030360924
                    ],
                    [
                        121.57294616103,
                        0.54393845304027
                    ],
                    [
                        121.57298237085,
                        0.54357100695305
                    ],
                    [
                        121.57298505306,
                        0.54356296068812
                    ],
                    [
                        121.57298505306,
                        0.54356296068812
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1664,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0001304486738146777,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56756564975,
                        0.56330309802
                    ],
                    [
                        121.5674610436,
                        0.56327493618637
                    ],
                    [
                        121.5674610436,
                        0.56327493618637
                    ],
                    [
                        121.56748250127,
                        0.56328030034517
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1665,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.012028237520359157,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.5674610436,
                        0.56327627722607
                    ],
                    [
                        121.56707882881,
                        0.56316765300937
                    ],
                    [
                        121.5668682754,
                        0.56310596518171
                    ],
                    [
                        121.56666710973,
                        0.56305768775091
                    ],
                    [
                        121.56631842256,
                        0.5630027051209
                    ],
                    [
                        121.56608775258,
                        0.56296917912674
                    ],
                    [
                        121.56572967768,
                        0.5629343120926
                    ],
                    [
                        121.56534612179,
                        0.56290212713784
                    ],
                    [
                        121.56494513154,
                        0.56287798842163
                    ],
                    [
                        121.56472653151,
                        0.56285921386453
                    ],
                    [
                        121.56446233392,
                        0.56283909826756
                    ],
                    [
                        121.56402647495,
                        0.56280691331227
                    ],
                    [
                        121.56364560127,
                        0.56277204627717
                    ],
                    [
                        121.56322181225,
                        0.56275058964007
                    ],
                    [
                        121.5624332428,
                        0.56268085556898
                    ],
                    [
                        121.56182706356,
                        0.56263257813467
                    ],
                    [
                        121.56127989292,
                        0.56260039317823
                    ],
                    [
                        121.56060934067,
                        0.56254138742431
                    ],
                    [
                        121.55999779701,
                        0.56248774582931
                    ],
                    [
                        121.55913412571,
                        0.56243410423382
                    ],
                    [
                        121.55824899673,
                        0.56236973431858
                    ],
                    [
                        121.55674159527,
                        0.56224635864574
                    ],
                    [
                        121.55590474606,
                        0.56218735288823
                    ],
                    [
                        121.5555010736,
                        0.56215650748749
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1642,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.00023215720962608253,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56789287925,
                        0.56391327104861
                    ],
                    [
                        121.56787008047,
                        0.56383817283315
                    ],
                    [
                        121.56786471605,
                        0.56379660060633
                    ],
                    [
                        121.5678486228,
                        0.56374564110207
                    ],
                    [
                        121.56782850623,
                        0.56370004575575
                    ],
                    [
                        121.56783118844,
                        0.56370809199338
                    ],
                    [
                        121.56783118844,
                        0.56370809199338
                    ],
                    [
                        121.56783118844,
                        0.56370809199338
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1643,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.011842290370041492,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57303735614,
                        0.54315382751391
                    ],
                    [
                        121.57317280769,
                        0.54216022833761
                    ],
                    [
                        121.57320231199,
                        0.54178741796414
                    ],
                    [
                        121.57321572304,
                        0.54162381052681
                    ],
                    [
                        121.5732640028,
                        0.54130195981755
                    ],
                    [
                        121.57330423594,
                        0.54098279118066
                    ],
                    [
                        121.57334446907,
                        0.54069312551247
                    ],
                    [
                        121.57339274883,
                        0.54026667325359
                    ],
                    [
                        121.57343566418,
                        0.53985899559449
                    ],
                    [
                        121.57346516848,
                        0.53959346868341
                    ],
                    [
                        121.57352149487,
                        0.53926357159591
                    ],
                    [
                        121.57356709242,
                        0.53885052968881
                    ],
                    [
                        121.57359927893,
                        0.5385233146516
                    ],
                    [
                        121.57360464334,
                        0.5382846085888
                    ],
                    [
                        121.57358318567,
                        0.53819878168752
                    ],
                    [
                        121.5735322237,
                        0.53805394878889
                    ],
                    [
                        121.57344102859,
                        0.53778305761739
                    ],
                    [
                        121.57333910465,
                        0.53750680225191
                    ],
                    [
                        121.57326132059,
                        0.53731100960667
                    ],
                    [
                        121.57309502363,
                        0.53691137802363
                    ],
                    [
                        121.57296359539,
                        0.5365814807911
                    ],
                    [
                        121.57277047634,
                        0.53619257752667
                    ],
                    [
                        121.5725800395,
                        0.53584926979683
                    ],
                    [
                        121.57242563136,
                        0.53557721788424
                    ],
                    [
                        121.57230185649,
                        0.53535767455741
                    ],
                    [
                        121.57218038589,
                        0.53507528942799
                    ],
                    [
                        121.57206237316,
                        0.53477375092496
                    ],
                    [
                        121.57198190689,
                        0.53460746120725
                    ],
                    [
                        121.57189492061,
                        0.53444346852024
                    ],
                    [
                        121.57182097435,
                        0.53427488175831
                    ],
                    [
                        121.5717163682,
                        0.53410322784213
                    ],
                    [
                        121.57157957554,
                        0.53387524997731
                    ],
                    [
                        121.57146692276,
                        0.53371432442057
                    ],
                    [
                        121.57135158777,
                        0.53360972280643
                    ],
                    [
                        121.57125234604,
                        0.5335185316542
                    ],
                    [
                        121.5711504221,
                        0.53344343305723
                    ],
                    [
                        121.57105386257,
                        0.53340856585118
                    ],
                    [
                        121.57100021839,
                        0.5334058837584
                    ],
                    [
                        121.57093852758,
                        0.53343806887169
                    ],
                    [
                        121.57087951899,
                        0.53345952561379
                    ],
                    [
                        121.57082739919,
                        0.53345301247577
                    ],
                    [
                        121.57080479261,
                        0.53336566260541
                    ],
                    [
                        121.57079253045,
                        0.53327371062278
                    ],
                    [
                        121.57077223063,
                        0.53315644912463
                    ],
                    [
                        121.57067564877,
                        0.53258636176153
                    ],
                    [
                        121.57063542903,
                        0.53235220783738
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1644,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.008145800590992874,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57076954842,
                        0.53344611514999
                    ],
                    [
                        121.57081514597,
                        0.53400130832714
                    ],
                    [
                        121.5708553791,
                        0.5342695175735
                    ],
                    [
                        121.57095462084,
                        0.53509560197872
                    ],
                    [
                        121.57102435827,
                        0.5357822175036
                    ],
                    [
                        121.57108873129,
                        0.53633472837791
                    ],
                    [
                        121.57116651535,
                        0.53705084676699
                    ],
                    [
                        121.57122820616,
                        0.53763286052704
                    ],
                    [
                        121.57130867243,
                        0.53834897876396
                    ],
                    [
                        121.57137572765,
                        0.53886125805039
                    ],
                    [
                        121.57144010067,
                        0.53935744475272
                    ],
                    [
                        121.57150179148,
                        0.53976244035543
                    ],
                    [
                        121.57151788473,
                        0.53986972395429
                    ],
                    [
                        121.57149642706,
                        0.54006551651733
                    ],
                    [
                        121.57143741846,
                        0.54054829267319
                    ],
                    [
                        121.57134622335,
                        0.54125100012035
                    ],
                    [
                        121.57131135464,
                        0.54151652695896
                    ],
                    [
                        121.57131671906,
                        0.54150579860207
                    ],
                    [
                        121.57131403685,
                        0.54151116278052
                    ],
                    [
                        121.57131403685,
                        0.54151116278052
                    ],
                    [
                        121.57131403685,
                        0.54151116278052
                    ],
                    [
                        121.57131403685,
                        0.54151116278052
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1645,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0007178002000007477,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57245397568,
                        0.53683359737692
                    ],
                    [
                        121.57230645418,
                        0.53687382874603
                    ],
                    [
                        121.5721642971,
                        0.53693819893607
                    ],
                    [
                        121.5717753768,
                        0.53706425722292
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1667,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0001564911240495967,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01837524772,
                        0.47726541161776
                    ],
                    [
                        122.01842352748,
                        0.47711655418032
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1646,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.001307575829696272,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57299980521,
                        0.53666328457806
                    ],
                    [
                        121.57245397568,
                        0.53683359737692
                    ],
                    [
                        121.57230645418,
                        0.53687382874603
                    ],
                    [
                        121.5721642971,
                        0.53693819893607
                    ],
                    [
                        121.5717753768,
                        0.53706425722292
                    ],
                    [
                        121.57178342342,
                        0.53704816467581
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2004,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0029532104673568303,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09359645844,
                        0.56326420786876
                    ],
                    [
                        122.09360986948,
                        0.56333930609161
                    ],
                    [
                        122.09423214197,
                        0.56332187257568
                    ],
                    [
                        122.09420666099,
                        0.56321324835984
                    ],
                    [
                        122.09419190884,
                        0.56306171087016
                    ],
                    [
                        122.09417849779,
                        0.56295308664948
                    ],
                    [
                        122.09416106343,
                        0.5627961849938
                    ],
                    [
                        122.09414899349,
                        0.56268890180801
                    ],
                    [
                        122.09414899349,
                        0.5626513526925
                    ],
                    [
                        122.09417447448,
                        0.56263123709482
                    ],
                    [
                        122.09423884749,
                        0.56261648565647
                    ],
                    [
                        122.09439441562,
                        0.56260978045721
                    ],
                    [
                        122.09450438619,
                        0.56259905213838
                    ],
                    [
                        122.0945969224,
                        0.56259502901881
                    ],
                    [
                        122.09472835064,
                        0.5625829596601
                    ],
                    [
                        122.09494292736,
                        0.56256686718175
                    ],
                    [
                        122.09505960345,
                        0.56256150302229
                    ],
                    [
                        122.09507972002,
                        0.56256150302229
                    ],
                    [
                        122.0951333642,
                        0.56256150302229
                    ],
                    [
                        122.09518969059,
                        0.56256016198244
                    ],
                    [
                        122.09523260593,
                        0.56256150302229
                    ],
                    [
                        122.09530502558,
                        0.56256016198244
                    ],
                    [
                        122.09540426731,
                        0.56254809262364
                    ],
                    [
                        122.09545522928,
                        0.56254272846417
                    ],
                    [
                        122.09552228451,
                        0.56252395390599
                    ],
                    [
                        122.09557726979,
                        0.56250920246736
                    ],
                    [
                        122.09562554955,
                        0.56245958399174
                    ],
                    [
                        122.09566041827,
                        0.56240594239599
                    ],
                    [
                        122.09566041827,
                        0.56240594239599
                    ],
                    [
                        122.09566041827,
                        0.56240594239599
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2007,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.007265514801748788,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10402354598,
                        0.55947174635892
                    ],
                    [
                        122.10414424539,
                        0.55934032438138
                    ],
                    [
                        122.10421800613,
                        0.55924511049785
                    ],
                    [
                        122.10436820984,
                        0.55904663648213
                    ],
                    [
                        122.10445538163,
                        0.55894874051246
                    ],
                    [
                        122.10455328226,
                        0.55880659019742
                    ],
                    [
                        122.10462972522,
                        0.55868991965325
                    ],
                    [
                        122.10475444794,
                        0.55852765372018
                    ],
                    [
                        122.10483759642,
                        0.55841634733373
                    ],
                    [
                        122.10491269827,
                        0.55831711031272
                    ],
                    [
                        122.10498914123,
                        0.55817093685979
                    ],
                    [
                        122.10508838296,
                        0.55796843968507
                    ],
                    [
                        122.10519567132,
                        0.55780483269112
                    ],
                    [
                        122.10527211428,
                        0.55766268234842
                    ],
                    [
                        122.10533514619,
                        0.55756210427369
                    ],
                    [
                        122.10543304682,
                        0.55741458976096
                    ],
                    [
                        122.10549339652,
                        0.55732608105157
                    ],
                    [
                        122.10560873151,
                        0.55716783820417
                    ],
                    [
                        122.10569858551,
                        0.5570404392985
                    ],
                    [
                        122.10586488247,
                        0.55683794208488
                    ],
                    [
                        122.10596144199,
                        0.5567132252545
                    ],
                    [
                        122.10607275367,
                        0.55654425406074
                    ],
                    [
                        122.10615053773,
                        0.55643428867807
                    ],
                    [
                        122.10630476475,
                        0.55620497061737
                    ],
                    [
                        122.106410712,
                        0.55604940982259
                    ],
                    [
                        122.10650324821,
                        0.55591530568587
                    ],
                    [
                        122.10657969117,
                        0.5558107044571
                    ],
                    [
                        122.10666552186,
                        0.55569805697791
                    ],
                    [
                        122.10675269365,
                        0.55554651929418
                    ],
                    [
                        122.10680767894,
                        0.55546069263971
                    ],
                    [
                        122.10686668754,
                        0.55538291223304
                    ],
                    [
                        122.10695922375,
                        0.555286357244
                    ],
                    [
                        122.10704907775,
                        0.55521796412582
                    ],
                    [
                        122.10710808635,
                        0.55515225308996
                    ],
                    [
                        122.10715100169,
                        0.55508922413651
                    ],
                    [
                        122.10721805692,
                        0.55500071539223
                    ],
                    [
                        122.10726767778,
                        0.55492829914592
                    ],
                    [
                        122.10730656981,
                        0.55485051873226
                    ],
                    [
                        122.10736960173,
                        0.55474994060959
                    ],
                    [
                        122.10739642382,
                        0.55474859956794
                    ],
                    [
                        122.10825070739,
                        0.55589787214786
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1650,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.0011700794051395487,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57138645649,
                        0.53928502831759
                    ],
                    [
                        121.57108873129,
                        0.5392984387686
                    ],
                    [
                        121.57078295946,
                        0.53933598803129
                    ],
                    [
                        121.57057106495,
                        0.53933867012147
                    ],
                    [
                        121.57024383545,
                        0.53936012684289
                    ],
                    [
                        121.57024383545,
                        0.53936012684289
                    ],
                    [
                        121.57024651766,
                        0.53936012684289
                    ],
                    [
                        121.57022505999,
                        0.53936012684289
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1651,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.0011723310504087336,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57135024667,
                        0.53886259909557
                    ],
                    [
                        121.57114908099,
                        0.53887600954752
                    ],
                    [
                        121.57091170549,
                        0.53889478418019
                    ],
                    [
                        121.57072395086,
                        0.53891221776762
                    ],
                    [
                        121.57047316432,
                        0.53892428717428
                    ],
                    [
                        121.57018080354,
                        0.53894306180679
                    ],
                    [
                        121.57018080354,
                        0.53894306180679
                    ],
                    [
                        121.57018080354,
                        0.53894306180679
                    ],
                    [
                        121.57018080354,
                        0.53894306180679
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1652,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0014821394180590452,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57282412052,
                        0.54523122116637
                    ],
                    [
                        121.57407939434,
                        0.54530095366465
                    ],
                    [
                        121.57407671213,
                        0.54529558948956
                    ],
                    [
                        121.57407671213,
                        0.54529558948956
                    ],
                    [
                        121.57407671213,
                        0.54529558948956
                    ],
                    [
                        121.57429531217,
                        0.54530765621622
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1991,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.012076007560072842,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57429128885,
                        0.54530899399999
                    ],
                    [
                        121.57462656498,
                        0.54532374903777
                    ],
                    [
                        121.57504230738,
                        0.5453319580038
                    ],
                    [
                        121.57553315163,
                        0.5453400024882
                    ],
                    [
                        121.57632574439,
                        0.54537352117305
                    ],
                    [
                        121.57649740577,
                        0.54538692864695
                    ],
                    [
                        121.57699361444,
                        0.54539899537342
                    ],
                    [
                        121.57756090164,
                        0.54541910658416
                    ],
                    [
                        121.57790288329,
                        0.54544994377384
                    ],
                    [
                        121.57824084163,
                        0.5454740772265
                    ],
                    [
                        121.57851174474,
                        0.54553307011042
                    ],
                    [
                        121.57893151045,
                        0.54566848559176
                    ],
                    [
                        121.57945454121,
                        0.54587898291807
                    ],
                    [
                        121.57994136214,
                        0.54608411724809
                    ],
                    [
                        121.58053144813,
                        0.54630131829579
                    ],
                    [
                        121.58083721995,
                        0.54640053358655
                    ],
                    [
                        121.58148095012,
                        0.54660030491029
                    ],
                    [
                        121.58207774162,
                        0.54679471323913
                    ],
                    [
                        121.58250018954,
                        0.54692208420976
                    ],
                    [
                        121.58283948898,
                        0.54701995874327
                    ],
                    [
                        121.58357173204,
                        0.5471526926971
                    ],
                    [
                        121.5839163959,
                        0.54722375228734
                    ],
                    [
                        121.58426240087,
                        0.54730956009329
                    ],
                    [
                        121.58494904637,
                        0.54747313122
                    ],
                    [
                        121.58557534218,
                        0.54762597636717
                    ],
                    [
                        121.58602327108,
                        0.54773993985155
                    ],
                    [
                        121.58602327108,
                        0.54773993985155
                    ],
                    [
                        121.58602327108,
                        0.54773993985155
                    ],
                    [
                        121.58602327108,
                        0.54773993985155
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1654,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.005526039581649902,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57846882939,
                        0.54550747440168
                    ],
                    [
                        121.5785305202,
                        0.5453197282774
                    ],
                    [
                        121.5785895288,
                        0.54513734632249
                    ],
                    [
                        121.5786485374,
                        0.54499921880884
                    ],
                    [
                        121.57871425152,
                        0.54485438607267
                    ],
                    [
                        121.57882422209,
                        0.54463579591801
                    ],
                    [
                        121.57892078161,
                        0.54447084751381
                    ],
                    [
                        121.57900393009,
                        0.54431796850103
                    ],
                    [
                        121.57909244299,
                        0.54411547085534
                    ],
                    [
                        121.57920643687,
                        0.54390760902652
                    ],
                    [
                        121.57930165529,
                        0.54374802477889
                    ],
                    [
                        121.57941430807,
                        0.54351200100995
                    ],
                    [
                        121.57981395721,
                        0.54272078489913
                    ],
                    [
                        121.5800768137,
                        0.54215754624869
                    ],
                    [
                        121.58031284809,
                        0.54166940604259
                    ],
                    [
                        121.58052206039,
                        0.54110080311557
                    ],
                    [
                        121.58068701625,
                        0.54048124043161
                    ],
                    [
                        121.58068433404,
                        0.54049599192482
                    ],
                    [
                        121.58068433404,
                        0.54049599192482
                    ],
                    [
                        121.58068433404,
                        0.54049599192482
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1655,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0013719833701250467,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.58064544201,
                        0.54073201581131
                    ],
                    [
                        121.58082380891,
                        0.54079102178151
                    ],
                    [
                        121.58102229238,
                        0.54084600461683
                    ],
                    [
                        121.58133342862,
                        0.54093451357024
                    ],
                    [
                        121.58170759678,
                        0.54101497625404
                    ],
                    [
                        121.58197045326,
                        0.54108471057914
                    ],
                    [
                        121.58197045326,
                        0.54108471057914
                    ],
                    [
                        121.58197045326,
                        0.54108471057914
                    ],
                    [
                        121.58197045326,
                        0.54108471057914
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1656,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.006327891444091459,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57479017973,
                        0.54539214464031
                    ],
                    [
                        121.5749296546,
                        0.54539750881531
                    ],
                    [
                        121.57531321049,
                        0.54540287299031
                    ],
                    [
                        121.57553851604,
                        0.54541091925278
                    ],
                    [
                        121.57586574554,
                        0.54542701177771
                    ],
                    [
                        121.57620102167,
                        0.54544310430259
                    ],
                    [
                        121.57638341188,
                        0.5454471274338
                    ],
                    [
                        121.57670661807,
                        0.54545919682743
                    ],
                    [
                        121.57722428441,
                        0.54548735874579
                    ],
                    [
                        121.5777271986,
                        0.54551686170775
                    ],
                    [
                        121.57802626491,
                        0.54554100049468
                    ],
                    [
                        121.57836958766,
                        0.54556782136895
                    ],
                    [
                        121.5785305202,
                        0.54561878102975
                    ],
                    [
                        121.57871425152,
                        0.54566035338427
                    ],
                    [
                        121.57888054848,
                        0.54573008765575
                    ],
                    [
                        121.57938882709,
                        0.54593392629079
                    ],
                    [
                        121.57982736826,
                        0.54611094404719
                    ],
                    [
                        121.58028066158,
                        0.5462906438855
                    ],
                    [
                        121.58041879535,
                        0.54633489832245
                    ],
                    [
                        121.58060923219,
                        0.54640060945554
                    ],
                    [
                        121.58094584942,
                        0.54650118771905
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1990,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.005399426053487483,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.58095389605,
                        0.54650550098914
                    ],
                    [
                        121.58201336861,
                        0.54683934701724
                    ],
                    [
                        121.58248007298,
                        0.54698682919244
                    ],
                    [
                        121.58291056752,
                        0.547111518665
                    ],
                    [
                        121.58333972096,
                        0.54720671170145
                    ],
                    [
                        121.58385202289,
                        0.54729922324246
                    ],
                    [
                        121.58435896039,
                        0.54741318673305
                    ],
                    [
                        121.58474653959,
                        0.54750301677705
                    ],
                    [
                        121.5851958096,
                        0.5476250247451
                    ],
                    [
                        121.58566385508,
                        0.54773496598891
                    ],
                    [
                        121.5859991312,
                        0.54781541080017
                    ],
                    [
                        121.58603399992,
                        0.54781541080017
                    ],
                    [
                        121.5860876441,
                        0.54774569196381
                    ],
                    [
                        121.5860286355,
                        0.5477389882295
                    ],
                    [
                        121.5860286355,
                        0.5477389882295
                    ],
                    [
                        121.5860286355,
                        0.5477389882295
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1657,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0003347634388879455,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57843664289,
                        0.54561609894235
                    ],
                    [
                        121.57837226987,
                        0.54579445775177
                    ],
                    [
                        121.57831728458,
                        0.54592588002902
                    ],
                    [
                        121.57831996679,
                        0.54592588002902
                    ],
                    [
                        121.57831996679,
                        0.54592588002902
                    ],
                    [
                        121.57831996679,
                        0.54592588002902
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1658,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00511184228009666,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57831862569,
                        0.54591516294176
                    ],
                    [
                        121.578142941,
                        0.5463791527591
                    ],
                    [
                        121.57791227102,
                        0.54693702684149
                    ],
                    [
                        121.57782912254,
                        0.5471435475223
                    ],
                    [
                        121.57751530409,
                        0.54789989592899
                    ],
                    [
                        121.57704591751,
                        0.54907196756202
                    ],
                    [
                        121.5766274929,
                        0.55013407346584
                    ],
                    [
                        121.576359272,
                        0.55063294132512
                    ],
                    [
                        121.576359272,
                        0.55063294132512
                    ],
                    [
                        121.576359272,
                        0.55063294132512
                    ],
                    [
                        121.576359272,
                        0.55063294132512
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1660,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.00034758011951480496,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57644708509,
                        0.54549802630267
                    ],
                    [
                        121.57637734766,
                        0.54582255887563
                    ],
                    [
                        121.57638539429,
                        0.54580914843908
                    ],
                    [
                        121.57638539429,
                        0.54580914843908
                    ],
                    [
                        121.57638539429,
                        0.54580914843908
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1661,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00035884463963943705,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57645583153,
                        0.54547126622102
                    ],
                    [
                        121.57637670636,
                        0.5458212786249
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1662,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.002518506862834224,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57637536526,
                        0.54583737114874
                    ],
                    [
                        121.57634183764,
                        0.54599293221017
                    ],
                    [
                        121.57623454928,
                        0.54656689885031
                    ],
                    [
                        121.57617285848,
                        0.54684985901954
                    ],
                    [
                        121.57613664865,
                        0.54697591710011
                    ],
                    [
                        121.57608434558,
                        0.54716902734606
                    ],
                    [
                        121.57607629895,
                        0.54728301603001
                    ],
                    [
                        121.5760910511,
                        0.54733397567623
                    ],
                    [
                        121.57611653209,
                        0.54738761740864
                    ],
                    [
                        121.5761487186,
                        0.54741041514478
                    ],
                    [
                        121.57621309161,
                        0.5474372360107
                    ],
                    [
                        121.57641023397,
                        0.54749758295859
                    ],
                    [
                        121.57663419843,
                        0.54756329407893
                    ],
                    [
                        121.5768930316,
                        0.54764777980402
                    ],
                    [
                        121.57698959112,
                        0.54767862379861
                    ],
                    [
                        121.57698825002,
                        0.54767325962565
                    ],
                    [
                        121.57698825002,
                        0.54767325962565
                    ],
                    [
                        121.57698825002,
                        0.54767325962565
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1663,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.002518506862834224,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57637536526,
                        0.54583737114874
                    ],
                    [
                        121.57634183764,
                        0.54599293221017
                    ],
                    [
                        121.57623454928,
                        0.54656689885031
                    ],
                    [
                        121.57617285848,
                        0.54684985901954
                    ],
                    [
                        121.57613664865,
                        0.54697591710011
                    ],
                    [
                        121.57608434558,
                        0.54716902734606
                    ],
                    [
                        121.57607629895,
                        0.54728301603001
                    ],
                    [
                        121.5760910511,
                        0.54733397567623
                    ],
                    [
                        121.57611653209,
                        0.54738761740864
                    ],
                    [
                        121.5761487186,
                        0.54741041514478
                    ],
                    [
                        121.57621309161,
                        0.5474372360107
                    ],
                    [
                        121.57641023397,
                        0.54749758295859
                    ],
                    [
                        121.57663419843,
                        0.54756329407893
                    ],
                    [
                        121.5768930316,
                        0.54764777980402
                    ],
                    [
                        121.57698959112,
                        0.54767862379861
                    ],
                    [
                        121.57698825002,
                        0.54767325962565
                    ],
                    [
                        121.57698825002,
                        0.54767325962565
                    ],
                    [
                        121.57698825002,
                        0.54767325962565
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1973,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.00014828629432990135,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07556128502,
                        0.47912009455438
                    ],
                    [
                        122.07554787397,
                        0.47899805831005
                    ],
                    [
                        122.07554921508,
                        0.47897257821481
                    ],
                    [
                        122.07554921508,
                        0.47897257821481
                    ],
                    [
                        122.07554921508,
                        0.47897257821481
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1974,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0002834876412566705,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07555323839,
                        0.47909193234434
                    ],
                    [
                        122.07546204329,
                        0.47909595551722
                    ],
                    [
                        122.07536280155,
                        0.47907718071048
                    ],
                    [
                        122.07536146045,
                        0.47898598879126
                    ],
                    [
                        122.07536146045,
                        0.47898598879126
                    ],
                    [
                        122.07536146045,
                        0.47898598879126
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1680,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.011691047934116223,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57173286154,
                        0.55292804258612
                    ],
                    [
                        121.57166772188,
                        0.55341158719563
                    ],
                    [
                        121.57162901987,
                        0.55369435411854
                    ],
                    [
                        121.57156771574,
                        0.55405224697652
                    ],
                    [
                        121.57148686727,
                        0.55448481445967
                    ],
                    [
                        121.5714056255,
                        0.55483806745221
                    ],
                    [
                        121.57125542386,
                        0.55543770669742
                    ],
                    [
                        121.57114927996,
                        0.55582316046069
                    ],
                    [
                        121.5710373939,
                        0.55624577755316
                    ],
                    [
                        121.5709117122,
                        0.55673391478904
                    ],
                    [
                        121.57080709934,
                        0.55706457803872
                    ],
                    [
                        121.57071858644,
                        0.5573998383095
                    ],
                    [
                        121.57066306461,
                        0.55763015094249
                    ],
                    [
                        121.57053697405,
                        0.55803779588599
                    ],
                    [
                        121.57035305055,
                        0.55857612887647
                    ],
                    [
                        121.57022813334,
                        0.558942035309
                    ],
                    [
                        121.57004501672,
                        0.55948462832466
                    ],
                    [
                        121.5698553062,
                        0.56003709365414
                    ],
                    [
                        121.569581341,
                        0.56085896729379
                    ],
                    [
                        121.56924299826,
                        0.56187814988169
                    ],
                    [
                        121.56911159014,
                        0.56225174879633
                    ],
                    [
                        121.56902458817,
                        0.56252337841479
                    ],
                    [
                        121.56894259305,
                        0.56266476309092
                    ],
                    [
                        121.56887668222,
                        0.56277740649842
                    ],
                    [
                        121.56866133213,
                        0.56307512126763
                    ],
                    [
                        121.56850844622,
                        0.56328164138487
                    ],
                    [
                        121.56845480204,
                        0.56334601129003
                    ],
                    [
                        121.56841993332,
                        0.56338892455976
                    ],
                    [
                        121.56836092472,
                        0.56341574535316
                    ],
                    [
                        121.56828850508,
                        0.56342915574983
                    ],
                    [
                        121.56819462776,
                        0.56341038119449
                    ],
                    [
                        121.56800150871,
                        0.56336746792493
                    ],
                    [
                        121.56780034304,
                        0.56329907490091
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1749,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.019614361776773913,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.86257779598,
                        0.50686651940802
                    ],
                    [
                        121.86260864139,
                        0.50698184988159
                    ],
                    [
                        121.86270922422,
                        0.50720714661471
                    ],
                    [
                        121.86281517148,
                        0.50742976123618
                    ],
                    [
                        121.86285272241,
                        0.50749547277959
                    ],
                    [
                        121.86292782426,
                        0.50759068746377
                    ],
                    [
                        121.86321347952,
                        0.50786426204153
                    ],
                    [
                        121.86344280839,
                        0.50806407876011
                    ],
                    [
                        121.86368688941,
                        0.50831217333499
                    ],
                    [
                        121.8638022244,
                        0.50841811642082
                    ],
                    [
                        121.8639805913,
                        0.50858708893386
                    ],
                    [
                        121.86420589685,
                        0.50877751826864
                    ],
                    [
                        121.86435610056,
                        0.50891162343061
                    ],
                    [
                        121.86443790793,
                        0.50899610968123
                    ],
                    [
                        121.86453849077,
                        0.50911144011679
                    ],
                    [
                        121.86458006501,
                        0.50920129057097
                    ],
                    [
                        121.86460152268,
                        0.50930455153915
                    ],
                    [
                        121.86462432146,
                        0.50960092391915
                    ],
                    [
                        121.86461225152,
                        0.50989997838833
                    ],
                    [
                        121.86459615827,
                        0.51010381819791
                    ],
                    [
                        121.86455726624,
                        0.51056379879714
                    ],
                    [
                        121.8645465374,
                        0.51088162793831
                    ],
                    [
                        121.86453178525,
                        0.51113642766039
                    ],
                    [
                        121.8644861877,
                        0.51163932181904
                    ],
                    [
                        121.86445131898,
                        0.51200676979272
                    ],
                    [
                        121.86442047358,
                        0.51235141988025
                    ],
                    [
                        121.86439231038,
                        0.51268534154272
                    ],
                    [
                        121.86435878277,
                        0.51293880014237
                    ],
                    [
                        121.86432525516,
                        0.51307961047117
                    ],
                    [
                        121.86425551772,
                        0.51328076807836
                    ],
                    [
                        121.86417371035,
                        0.51345510466614
                    ],
                    [
                        121.86409726739,
                        0.51365894436276
                    ],
                    [
                        121.86407715082,
                        0.51373806634851
                    ],
                    [
                        121.86404630542,
                        0.51396336284494
                    ],
                    [
                        121.86403289437,
                        0.51413501731308
                    ],
                    [
                        121.8639819324,
                        0.51462315968161
                    ],
                    [
                        121.86394169927,
                        0.515040226346
                    ],
                    [
                        121.86391085386,
                        0.51540365097345
                    ],
                    [
                        121.86388269067,
                        0.51584887964004
                    ],
                    [
                        121.86384111643,
                        0.51623107892237
                    ],
                    [
                        121.86381295323,
                        0.51671519798034
                    ],
                    [
                        121.86377942562,
                        0.5172167506497
                    ],
                    [
                        121.86374992132,
                        0.51777999156803
                    ],
                    [
                        121.86373516917,
                        0.51815682653543
                    ],
                    [
                        121.86372041702,
                        0.51859266766199
                    ],
                    [
                        121.8637150526,
                        0.5189467047396
                    ],
                    [
                        121.86370030046,
                        0.51951128655344
                    ],
                    [
                        121.86369225383,
                        0.51986666462893
                    ],
                    [
                        121.86370030046,
                        0.52031993927732
                    ],
                    [
                        121.86370298266,
                        0.52080674012082
                    ],
                    [
                        121.86370164156,
                        0.52140350694381
                    ],
                    [
                        121.8637123704,
                        0.52191176448551
                    ],
                    [
                        121.86372578144,
                        0.52206062090816
                    ],
                    [
                        121.86375528574,
                        0.5222483677425
                    ],
                    [
                        121.86379149556,
                        0.52240527044976
                    ],
                    [
                        121.86385720968,
                        0.52264934131994
                    ],
                    [
                        121.86387732625,
                        0.52271237060905
                    ],
                    [
                        121.8638907373,
                        0.52279149248173
                    ],
                    [
                        121.86390146613,
                        0.52290145847259
                    ],
                    [
                        121.86391621828,
                        0.52318173763572
                    ],
                    [
                        121.86390683055,
                        0.52328633942543
                    ],
                    [
                        121.86386659741,
                        0.52349554299967
                    ],
                    [
                        121.86377942562,
                        0.52385628504396
                    ],
                    [
                        121.86372444034,
                        0.52411644843846
                    ],
                    [
                        121.86362788081,
                        0.52457776907022
                    ],
                    [
                        121.86355143785,
                        0.52496533201652
                    ],
                    [
                        121.86343610287,
                        0.52551247966453
                    ],
                    [
                        121.86342939734,
                        0.52553795957835
                    ],
                    [
                        121.86342939734,
                        0.52553795957835
                    ],
                    [
                        121.86342939734,
                        0.52553795957835
                    ],
                    [
                        121.86342939734,
                        0.52553795957835
                    ],
                    [
                        121.86342939734,
                        0.52553795957835
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1681,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.007647912218388201,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.5717320949,
                        0.55292229663511
                    ],
                    [
                        121.57177136913,
                        0.55265408589511
                    ],
                    [
                        121.57183173448,
                        0.55218859138411
                    ],
                    [
                        121.57188918074,
                        0.55177875699238
                    ],
                    [
                        121.57193919275,
                        0.55141324690477
                    ],
                    [
                        121.57196310619,
                        0.55117885921082
                    ],
                    [
                        121.5719966338,
                        0.55092942530926
                    ],
                    [
                        121.57201540926,
                        0.55079398001424
                    ],
                    [
                        121.57207307676,
                        0.55038227994018
                    ],
                    [
                        121.57210123995,
                        0.55017710041383
                    ],
                    [
                        121.57213744977,
                        0.54989950457285
                    ],
                    [
                        121.57215890744,
                        0.54971980484281
                    ],
                    [
                        121.57220182279,
                        0.54941136499508
                    ],
                    [
                        121.57228226382,
                        0.54878252944709
                    ],
                    [
                        121.57233056882,
                        0.54843508571992
                    ],
                    [
                        121.57238153079,
                        0.54805020634652
                    ],
                    [
                        121.57243115166,
                        0.54769617094286
                    ],
                    [
                        121.57248881915,
                        0.54728581169883
                    ],
                    [
                        121.57253441671,
                        0.54693043520665
                    ],
                    [
                        121.57260147193,
                        0.5464302259952
                    ],
                    [
                        121.57266048053,
                        0.54598097639982
                    ],
                    [
                        121.57270607808,
                        0.54562425878674
                    ],
                    [
                        121.5727396057,
                        0.54534129855983
                    ],
                    [
                        121.5727396057,
                        0.54534129855983
                    ],
                    [
                        121.5727396057,
                        0.54534129855983
                    ],
                    [
                        121.5727396057,
                        0.54534129855983
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1682,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00877866015973095,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57273963094,
                        0.54533313871504
                    ],
                    [
                        121.57276242971,
                        0.54509040978907
                    ],
                    [
                        121.5727879107,
                        0.54488657112546
                    ],
                    [
                        121.57280668616,
                        0.54467066305977
                    ],
                    [
                        121.57281070948,
                        0.54458215416105
                    ],
                    [
                        121.57283753157,
                        0.54439843113983
                    ],
                    [
                        121.57288581133,
                        0.54395320452506
                    ],
                    [
                        121.5729059279,
                        0.54379227923453
                    ],
                    [
                        121.5729354322,
                        0.5434704286406
                    ],
                    [
                        121.5729662776,
                        0.54322099441853
                    ],
                    [
                        121.57301723957,
                        0.54275162891894
                    ],
                    [
                        121.5730561316,
                        0.54244721184689
                    ],
                    [
                        121.5730842948,
                        0.54218034400461
                    ],
                    [
                        121.5731137991,
                        0.54191615823959
                    ],
                    [
                        121.57316476107,
                        0.54151116278052
                    ],
                    [
                        121.57324388623,
                        0.54092244416758
                    ],
                    [
                        121.57326802611,
                        0.54075079043825
                    ],
                    [
                        121.57330691814,
                        0.54043028072752
                    ],
                    [
                        121.57334581017,
                        0.54003064934904
                    ],
                    [
                        121.57337665558,
                        0.53973696050043
                    ],
                    [
                        121.57344102859,
                        0.53924882009972
                    ],
                    [
                        121.57349199057,
                        0.53885723491479
                    ],
                    [
                        121.57353758812,
                        0.53846699074998
                    ],
                    [
                        121.57353892922,
                        0.53833020412961
                    ],
                    [
                        121.57351210713,
                        0.53823633095698
                    ],
                    [
                        121.57348662615,
                        0.5381625734632
                    ],
                    [
                        121.57344773412,
                        0.53802846892674
                    ],
                    [
                        121.57337665558,
                        0.53781658375314
                    ],
                    [
                        121.57325729728,
                        0.53745718356845
                    ],
                    [
                        121.5731741488,
                        0.53723725210171
                    ],
                    [
                        121.57303333282,
                        0.53693953998169
                    ],
                    [
                        121.57298219875,
                        0.53681461800155
                    ],
                    [
                        121.57292929894,
                        0.53671635319229
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1669,
                "jenis_pipa": "Pipa 100",
                "keterangan": "TRANSMISI",
                "panjang": 0.0014260723579692354,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56941503286,
                        0.57118035983115
                    ],
                    [
                        121.56974226236,
                        0.57139492588605
                    ],
                    [
                        121.57001316547,
                        0.57151830136401
                    ],
                    [
                        121.570109725,
                        0.5717140928779
                    ],
                    [
                        121.57022085563,
                        0.57187349065718
                    ],
                    [
                        121.57041620314,
                        0.57192943382965
                    ],
                    [
                        121.57051203617,
                        0.57185511299795
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1670,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.005515540013929588,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56233802438,
                        0.56261246253691
                    ],
                    [
                        121.56257137656,
                        0.56262855501513
                    ],
                    [
                        121.56286776066,
                        0.56265403477219
                    ],
                    [
                        121.56309038401,
                        0.56266878621044
                    ],
                    [
                        121.56331434846,
                        0.56268085556898
                    ],
                    [
                        121.5635637939,
                        0.56269828908683
                    ],
                    [
                        121.56388297677,
                        0.56272510988342
                    ],
                    [
                        121.56420484185,
                        0.56275193067988
                    ],
                    [
                        121.56474933028,
                        0.56279350291417
                    ],
                    [
                        121.56499877572,
                        0.56280959539188
                    ],
                    [
                        121.5652911365,
                        0.56283239306855
                    ],
                    [
                        121.56569615006,
                        0.5628672601033
                    ],
                    [
                        121.56586378813,
                        0.56287664738186
                    ],
                    [
                        121.56607031822,
                        0.56290078609804
                    ],
                    [
                        121.5664216876,
                        0.56294504041081
                    ],
                    [
                        121.56659066677,
                        0.56297588432558
                    ],
                    [
                        121.56703054905,
                        0.56308048542662
                    ],
                    [
                        121.56735375524,
                        0.56316765300937
                    ],
                    [
                        121.56764611602,
                        0.56326286682905
                    ],
                    [
                        121.56769439578,
                        0.56327225410697
                    ],
                    [
                        121.56774267554,
                        0.56328700554364
                    ],
                    [
                        121.56779363751,
                        0.56329639282153
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1671,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.005502697132704131,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56233400106,
                        0.56261112149706
                    ],
                    [
                        121.56209528446,
                        0.56258832381953
                    ],
                    [
                        121.5618994832,
                        0.5625722313412
                    ],
                    [
                        121.56171038747,
                        0.56255479782297
                    ],
                    [
                        121.56146496534,
                        0.56253200014523
                    ],
                    [
                        121.56128793955,
                        0.56252395390599
                    ],
                    [
                        121.56108945608,
                        0.56250786142749
                    ],
                    [
                        121.5609177947,
                        0.56248506374954
                    ],
                    [
                        121.56064689159,
                        0.56247165335072
                    ],
                    [
                        121.56042024493,
                        0.56244751463274
                    ],
                    [
                        121.56014800072,
                        0.56242471695456
                    ],
                    [
                        121.5599347651,
                        0.5624072834359
                    ],
                    [
                        121.5597550571,
                        0.56239387303688
                    ],
                    [
                        121.55929908156,
                        0.56236571119885
                    ],
                    [
                        121.55904695392,
                        0.56234827768002
                    ],
                    [
                        121.55851319432,
                        0.56230938752241
                    ],
                    [
                        121.55831068754,
                        0.5622919540034
                    ],
                    [
                        121.55804514885,
                        0.56226245112494
                    ],
                    [
                        121.5577621758,
                        0.56224367656585
                    ],
                    [
                        121.55754357576,
                        0.56223160720641
                    ],
                    [
                        121.55730083585,
                        0.56221417368716
                    ],
                    [
                        121.55710637569,
                        0.56219942224776
                    ],
                    [
                        121.55692666769,
                        0.56217930664853
                    ],
                    [
                        121.55686095357,
                        0.56216991936884
                    ],
                    [
                        121.55687168241,
                        0.56216991936884
                    ],
                    [
                        121.55687168241,
                        0.56216991936884
                    ],
                    [
                        121.55687168241,
                        0.56216991936884
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1672,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.003908851712661429,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.5515434742,
                        0.56289005777976
                    ],
                    [
                        121.5515434742,
                        0.5628954219389
                    ],
                    [
                        121.55105531216,
                        0.56328968762304
                    ],
                    [
                        121.55082195997,
                        0.56345329446375
                    ],
                    [
                        121.55052423477,
                        0.56361690129984
                    ],
                    [
                        121.55028015375,
                        0.56370809199338
                    ],
                    [
                        121.55015408993,
                        0.56374564110207
                    ],
                    [
                        121.54982417822,
                        0.56381805723956
                    ],
                    [
                        121.54952645302,
                        0.56387438090144
                    ],
                    [
                        121.54900342226,
                        0.5639709357491
                    ],
                    [
                        121.54846429825,
                        0.56405139812094
                    ],
                    [
                        121.54806733131,
                        0.56408090099032
                    ],
                    [
                        121.54792517424,
                        0.56409967554349
                    ],
                    [
                        121.54792517424,
                        0.56409967554349
                    ],
                    [
                        121.54792517424,
                        0.56409967554349
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1975,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.005709578959571407,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.55686218731,
                        0.56218274243818
                    ],
                    [
                        121.55584037304,
                        0.56208056283831
                    ],
                    [
                        121.55516982079,
                        0.56203765904256
                    ],
                    [
                        121.55453681946,
                        0.56196257739926
                    ],
                    [
                        121.55390381813,
                        0.56190358467883
                    ],
                    [
                        121.55360877514,
                        0.56187676980572
                    ],
                    [
                        121.55334055424,
                        0.56186604385643
                    ],
                    [
                        121.55318498611,
                        0.56186604385643
                    ],
                    [
                        121.55298650265,
                        0.56187140683106
                    ],
                    [
                        121.55265924173,
                        0.56195668134815
                    ],
                    [
                        121.55244201814,
                        0.56209480891912
                    ],
                    [
                        121.55203432866,
                        0.56247432548011
                    ],
                    [
                        121.55176750266,
                        0.56272516008762
                    ],
                    [
                        121.55153274536,
                        0.56291182381865
                    ],
                    [
                        121.55153274536,
                        0.56291182381865
                    ],
                    [
                        121.55153274536,
                        0.56291182381865
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1977,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0015726405865019665,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.55261099339,
                        0.5619928843105
                    ],
                    [
                        121.5526740253,
                        0.5618078616863
                    ],
                    [
                        121.55277192593,
                        0.56166842434246
                    ],
                    [
                        121.55287250876,
                        0.56154105368895
                    ],
                    [
                        121.55302003026,
                        0.56136139402556
                    ],
                    [
                        121.55321717262,
                        0.56111335642153
                    ],
                    [
                        121.55333250761,
                        0.56097257831726
                    ],
                    [
                        121.55345186591,
                        0.56080364458768
                    ],
                    [
                        121.55348673463,
                        0.5607392888799
                    ],
                    [
                        121.553478688,
                        0.56070711102575
                    ],
                    [
                        121.553478688,
                        0.56070711102575
                    ],
                    [
                        121.553478688,
                        0.56070711102575
                    ],
                    [
                        121.553478688,
                        0.56070711102575
                    ],
                    [
                        121.553478688,
                        0.56070711102575
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1978,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0002437769698775578,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07765072584,
                        0.47822963223811
                    ],
                    [
                        122.07752332091,
                        0.47831143676295
                    ],
                    [
                        122.07744017243,
                        0.47835166849611
                    ],
                    [
                        122.07744017243,
                        0.47835166849611
                    ],
                    [
                        122.07744017243,
                        0.47835166849611
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1979,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.004681734512733684,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.55270621181,
                        0.56193115290513
                    ],
                    [
                        121.55271023512,
                        0.56188154538999
                    ],
                    [
                        121.5527330339,
                        0.56181316746305
                    ],
                    [
                        121.55277729034,
                        0.56173674507315
                    ],
                    [
                        121.55287116766,
                        0.56163216706433
                    ],
                    [
                        121.5530307591,
                        0.56142435178479
                    ],
                    [
                        121.55319437385,
                        0.56121787724171
                    ],
                    [
                        121.55342102051,
                        0.56092291359605
                    ],
                    [
                        121.55357658863,
                        0.56069498713242
                    ],
                    [
                        121.55368119478,
                        0.56050460149128
                    ],
                    [
                        121.55372813344,
                        0.56039063825244
                    ],
                    [
                        121.55380189419,
                        0.56018014144072
                    ],
                    [
                        121.55387029052,
                        0.55994819271588
                    ],
                    [
                        121.55390784144,
                        0.55976719225949
                    ],
                    [
                        121.55397355556,
                        0.55943334695861
                    ],
                    [
                        121.55400976539,
                        0.55917324257446
                    ],
                    [
                        121.55403792858,
                        0.55880185639776
                    ],
                    [
                        121.55408218503,
                        0.5585591816631
                    ],
                    [
                        121.5541639924,
                        0.55795450589948
                    ],
                    [
                        121.55418410897,
                        0.55784992782319
                    ],
                    [
                        121.55420154333,
                        0.55769306070528
                    ],
                    [
                        121.55415996909,
                        0.55767429028064
                    ],
                    [
                        121.55415996909,
                        0.55767429028064
                    ],
                    [
                        121.55414119363,
                        0.55765732203719
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1674,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.000715792562474909,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.5534773469,
                        0.56070684311405
                    ],
                    [
                        121.55339822173,
                        0.56059956137169
                    ],
                    [
                        121.55328154564,
                        0.56049496022625
                    ],
                    [
                        121.55308976769,
                        0.56034342266609
                    ],
                    [
                        121.55293956399,
                        0.56024954983923
                    ],
                    [
                        121.55294090509,
                        0.56025357296041
                    ],
                    [
                        121.55294090509,
                        0.56025357296041
                    ],
                    [
                        121.55294090509,
                        0.56025357296041
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1675,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.002558316386782821,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.55414119363,
                        0.55765597714349
                    ],
                    [
                        121.55396819115,
                        0.55758221988876
                    ],
                    [
                        121.55383273959,
                        0.55750175742802
                    ],
                    [
                        121.55364900827,
                        0.557415930802
                    ],
                    [
                        121.55341431499,
                        0.55728987294278
                    ],
                    [
                        121.55321314931,
                        0.55717722549183
                    ],
                    [
                        121.5528537333,
                        0.5569908207766
                    ],
                    [
                        121.55273169279,
                        0.55691304039009
                    ],
                    [
                        121.55263245106,
                        0.55685805770245
                    ],
                    [
                        121.55248224735,
                        0.55676420200897
                    ],
                    [
                        121.55231058598,
                        0.55668644117939
                    ],
                    [
                        121.55216172338,
                        0.55663148101321
                    ],
                    [
                        121.55201286078,
                        0.55692110590059
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1676,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0014357262195579005,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.5532694757,
                        0.55759150611611
                    ],
                    [
                        121.55229449272,
                        0.55707396532656
                    ],
                    [
                        121.55200347304,
                        0.55691439476756
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1981,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.0003055387771184209,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07538828254,
                        0.48416112828009
                    ],
                    [
                        122.07509189844,
                        0.48413296609089
                    ],
                    [
                        122.07508787513,
                        0.48412626080772
                    ],
                    [
                        122.07508787513,
                        0.48412626080772
                    ],
                    [
                        122.07508787513,
                        0.48412626080772
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1677,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0004909789252335968,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56773194671,
                        0.56385828842667
                    ],
                    [
                        121.56764343381,
                        0.56383012659573
                    ],
                    [
                        121.56761392951,
                        0.56399373342123
                    ],
                    [
                        121.56759783626,
                        0.56406346747662
                    ],
                    [
                        121.56757235527,
                        0.56422171013764
                    ],
                    [
                        121.56757235527,
                        0.56422171013764
                    ],
                    [
                        121.56757235527,
                        0.56422171013764
                    ],
                    [
                        121.56757235527,
                        0.56422171013764
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1678,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.006331761040255546,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56756967306,
                        0.56422305117712
                    ],
                    [
                        121.5675213933,
                        0.56454490064382
                    ],
                    [
                        121.56750798225,
                        0.5646857097799
                    ],
                    [
                        121.56746640801,
                        0.56487881944669
                    ],
                    [
                        121.56745031476,
                        0.5650410852034
                    ],
                    [
                        121.56744092703,
                        0.5651872584845
                    ],
                    [
                        121.56746372581,
                        0.5653428190365
                    ],
                    [
                        121.56748250127,
                        0.56545814840856
                    ],
                    [
                        121.56752809882,
                        0.56568076091093
                    ],
                    [
                        121.56756296754,
                        0.56582157001949
                    ],
                    [
                        121.56762734056,
                        0.56594360457745
                    ],
                    [
                        121.56774803996,
                        0.56616889913926
                    ],
                    [
                        121.56783923507,
                        0.56630166200194
                    ],
                    [
                        121.56801089644,
                        0.56658462122441
                    ],
                    [
                        121.56816914678,
                        0.56681662095572
                    ],
                    [
                        121.56835287809,
                        0.56711030846353
                    ],
                    [
                        121.56847894192,
                        0.5673034180496
                    ],
                    [
                        121.56863987446,
                        0.56753675879083
                    ],
                    [
                        121.56873106956,
                        0.5676654985061
                    ],
                    [
                        121.56879276037,
                        0.5678170358756
                    ],
                    [
                        121.56886652112,
                        0.56795516285498
                    ],
                    [
                        121.56892687082,
                        0.56812279267987
                    ],
                    [
                        121.5689510107,
                        0.56823275784235
                    ],
                    [
                        121.56897380948,
                        0.56836552065769
                    ],
                    [
                        121.56903147697,
                        0.56858008681745
                    ],
                    [
                        121.56905025244,
                        0.56867261847138
                    ],
                    [
                        121.56908914447,
                        0.56881476854554
                    ],
                    [
                        121.56913742423,
                        0.56894887238587
                    ],
                    [
                        121.56920984387,
                        0.56910711491347
                    ],
                    [
                        121.56926751137,
                        0.56921976213387
                    ],
                    [
                        121.56939759851,
                        0.56942494099392
                    ],
                    [
                        121.56943112612,
                        0.56947858252475
                    ],
                    [
                        121.56946867704,
                        0.56953892924635
                    ],
                    [
                        121.56955987215,
                        0.56949869809869
                    ],
                    [
                        121.56984418631,
                        0.56936593530942
                    ],
                    [
                        121.56992465258,
                        0.56938739192204
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1679,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0005585323471889058,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56764477452,
                        0.56383146446926
                    ],
                    [
                        121.56767427921,
                        0.5636799301617
                    ],
                    [
                        121.56770378351,
                        0.56354850827876
                    ],
                    [
                        121.56773597002,
                        0.56342781471017
                    ],
                    [
                        121.56779900193,
                        0.56329773386123
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1683,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.001691660018577081,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57292738557,
                        0.54352943458411
                    ],
                    [
                        121.57263100147,
                        0.54353077562828
                    ],
                    [
                        121.57233864069,
                        0.54353077562828
                    ],
                    [
                        121.57198727131,
                        0.54351200100995
                    ],
                    [
                        121.57176464796,
                        0.54351468309829
                    ],
                    [
                        121.57123625278,
                        0.54351200100995
                    ],
                    [
                        121.57123625278,
                        0.54351200100995
                    ],
                    [
                        121.57123625278,
                        0.54351200100995
                    ],
                    [
                        121.57123625278,
                        0.54351200100995
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1684,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0008975900876155553,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57223723085,
                        0.54167665131319
                    ],
                    [
                        121.57203863853,
                        0.54165104437977
                    ],
                    [
                        121.57196650097,
                        0.54160433188389
                    ],
                    [
                        121.5716704772,
                        0.54157319532994
                    ],
                    [
                        121.57149450622,
                        0.54156165762678
                    ],
                    [
                        121.57135834501,
                        0.54154319735078
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1962,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004125214555646264,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0794531703,
                        0.47917373685891
                    ],
                    [
                        122.07943037152,
                        0.47906242907657
                    ],
                    [
                        122.07941964269,
                        0.47895782658067
                    ],
                    [
                        122.07939684391,
                        0.47891357167807
                    ],
                    [
                        122.07938477397,
                        0.4788652936022
                    ],
                    [
                        122.07935929298,
                        0.4788156744683
                    ],
                    [
                        122.07934051752,
                        0.47878214802629
                    ],
                    [
                        122.07934051752,
                        0.47878214802629
                    ],
                    [
                        122.07934051752,
                        0.47878214802629
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1685,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.002980345567190339,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57325327396,
                        0.54080577327395
                    ],
                    [
                        121.57294213772,
                        0.54075749566214
                    ],
                    [
                        121.57264977694,
                        0.54071190013952
                    ],
                    [
                        121.57231718302,
                        0.54067166879575
                    ],
                    [
                        121.5721347928,
                        0.54064484789975
                    ],
                    [
                        121.57156866342,
                        0.54058469309972
                    ],
                    [
                        121.57086578385,
                        0.54049885827301
                    ],
                    [
                        121.57030016184,
                        0.54040843824737
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2005,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.010007457062770219,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09566175938,
                        0.5624072834359
                    ],
                    [
                        122.0956979692,
                        0.56233486728087
                    ],
                    [
                        122.09573820233,
                        0.56231206960225
                    ],
                    [
                        122.09579721093,
                        0.56231072856234
                    ],
                    [
                        122.09582537413,
                        0.56233218520104
                    ],
                    [
                        122.09585890174,
                        0.56234425456027
                    ],
                    [
                        122.09594741464,
                        0.56235364183966
                    ],
                    [
                        122.0959956944,
                        0.56233620832078
                    ],
                    [
                        122.09603860974,
                        0.5623147516821
                    ],
                    [
                        122.09607750177,
                        0.5622973181631
                    ],
                    [
                        122.09612175822,
                        0.5622825667239
                    ],
                    [
                        122.096144557,
                        0.5622450176058
                    ],
                    [
                        122.09618613124,
                        0.56221953784694
                    ],
                    [
                        122.09636047482,
                        0.56217394248871
                    ],
                    [
                        122.09668502212,
                        0.56208543385113
                    ],
                    [
                        122.09692507982,
                        0.56201704081208
                    ],
                    [
                        122.09707126021,
                        0.56197010441229
                    ],
                    [
                        122.09716379642,
                        0.56193389633217
                    ],
                    [
                        122.09722951055,
                        0.56189098305174
                    ],
                    [
                        122.09729656577,
                        0.56179174608955
                    ],
                    [
                        122.09735557437,
                        0.56169787328595
                    ],
                    [
                        122.09749504924,
                        0.56167105248464
                    ],
                    [
                        122.09764257073,
                        0.56166702936444
                    ],
                    [
                        122.0978705585,
                        0.5616442316832
                    ],
                    [
                        122.09803953767,
                        0.56162813920228
                    ],
                    [
                        122.09816157818,
                        0.56161875192174
                    ],
                    [
                        122.09830239415,
                        0.56160534152091
                    ],
                    [
                        122.09839224815,
                        0.56158924903989
                    ],
                    [
                        122.09843918681,
                        0.56155572303761
                    ],
                    [
                        122.0984646678,
                        0.56148867103247
                    ],
                    [
                        122.09846198559,
                        0.56138004678251
                    ],
                    [
                        122.09846869111,
                        0.56125130692811
                    ],
                    [
                        122.0984941721,
                        0.56117620867839
                    ],
                    [
                        122.09851965308,
                        0.56113731851299
                    ],
                    [
                        122.09855988622,
                        0.56111988499047
                    ],
                    [
                        122.09864571691,
                        0.56111317978951
                    ],
                    [
                        122.09875971079,
                        0.56112390811106
                    ],
                    [
                        122.0988509059,
                        0.56112256707086
                    ],
                    [
                        122.0990024507,
                        0.5611359774728
                    ],
                    [
                        122.09914594889,
                        0.56113865955318
                    ],
                    [
                        122.09927067161,
                        0.56115206995507
                    ],
                    [
                        122.0993578434,
                        0.56115743411581
                    ],
                    [
                        122.09948256612,
                        0.56115743411581
                    ],
                    [
                        122.09952145815,
                        0.56115072891487
                    ],
                    [
                        122.09959656,
                        0.56111720291008
                    ],
                    [
                        122.09971189499,
                        0.56107160754326
                    ],
                    [
                        122.0999130615,
                        0.56096030080467
                    ],
                    [
                        122.10002705538,
                        0.56090800023541
                    ],
                    [
                        122.1001236149,
                        0.56087715630972
                    ],
                    [
                        122.10021481001,
                        0.56084363030335
                    ],
                    [
                        122.1003314861,
                        0.56082619677996
                    ],
                    [
                        122.10043877446,
                        0.56080742221626
                    ],
                    [
                        122.10053533399,
                        0.56079132973304
                    ],
                    [
                        122.10068017328,
                        0.56076719100813
                    ],
                    [
                        122.10081026041,
                        0.56072561875944
                    ],
                    [
                        122.10090547883,
                        0.56069745691338
                    ],
                    [
                        122.10100740277,
                        0.56066124882537
                    ],
                    [
                        122.10108384573,
                        0.56062772281778
                    ],
                    [
                        122.1011938163,
                        0.56056737600362
                    ],
                    [
                        122.10123404944,
                        0.56046679797864
                    ],
                    [
                        122.10131451571,
                        0.56028173440816
                    ],
                    [
                        122.10136279547,
                        0.56015701765086
                    ],
                    [
                        122.10141912186,
                        0.56006985002321
                    ],
                    [
                        122.10146874273,
                        0.55997463615151
                    ],
                    [
                        122.10151031613,
                        0.55989417412396
                    ],
                    [
                        122.1015894413,
                        0.55980700649239
                    ],
                    [
                        122.10169807076,
                        0.55972922614314
                    ],
                    [
                        122.10178390145,
                        0.5596957001302
                    ],
                    [
                        122.10190191865,
                        0.55966083307656
                    ],
                    [
                        122.10211381316,
                        0.55959109896865
                    ],
                    [
                        122.10223183036,
                        0.55957366544154
                    ],
                    [
                        122.10235923529,
                        0.55954550358993
                    ],
                    [
                        122.10251748562,
                        0.55951063653539
                    ],
                    [
                        122.1026314795,
                        0.55949320300805
                    ],
                    [
                        122.10313439369,
                        0.55942883306046
                    ],
                    [
                        122.10319206119,
                        0.55942883306046
                    ],
                    [
                        122.10322022438,
                        0.55947174635892
                    ],
                    [
                        122.10323631763,
                        0.55954416254938
                    ],
                    [
                        122.10324838758,
                        0.55959244000919
                    ],
                    [
                        122.1032859385,
                        0.55965278683339
                    ],
                    [
                        122.10333555937,
                        0.55969972325177
                    ],
                    [
                        122.10338518023,
                        0.55972386198108
                    ],
                    [
                        122.1034629643,
                        0.55979359608742
                    ],
                    [
                        122.10355684161,
                        0.55985930707149
                    ],
                    [
                        122.10386663675,
                        0.55962060186055
                    ],
                    [
                        122.10402220488,
                        0.55947174635892
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1686,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00404928938439349,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57293140888,
                        0.53672094954198
                    ],
                    [
                        121.57287910581,
                        0.53656672928842
                    ],
                    [
                        121.57281607389,
                        0.5364058038023
                    ],
                    [
                        121.57273158431,
                        0.53623146785421
                    ],
                    [
                        121.57265782356,
                        0.53608127072574
                    ],
                    [
                        121.57253846526,
                        0.53586268025539
                    ],
                    [
                        121.57244458795,
                        0.53569370847541
                    ],
                    [
                        121.57233729959,
                        0.53552205459891
                    ],
                    [
                        121.57227158546,
                        0.53539197314244
                    ],
                    [
                        121.5721938014,
                        0.53523641180943
                    ],
                    [
                        121.57211199403,
                        0.53503257281536
                    ],
                    [
                        121.57205834985,
                        0.53488908088784
                    ],
                    [
                        121.57199665904,
                        0.53476972778669
                    ],
                    [
                        121.57189339399,
                        0.53452833948514
                    ],
                    [
                        121.57181829214,
                        0.53438752963819
                    ],
                    [
                        121.5717472136,
                        0.53423867351076
                    ],
                    [
                        121.57164528966,
                        0.53408713528724
                    ],
                    [
                        121.57152056694,
                        0.53386854474586
                    ],
                    [
                        121.57143473625,
                        0.53375723790278
                    ],
                    [
                        121.57135561109,
                        0.5336606825674
                    ],
                    [
                        121.57123625278,
                        0.5335668093232
                    ],
                    [
                        121.5710927546,
                        0.53346488979932
                    ],
                    [
                        121.57106727362,
                        0.53345013828914
                    ],
                    [
                        121.571033746,
                        0.53344075096446
                    ],
                    [
                        121.57100021839,
                        0.53344879724276
                    ],
                    [
                        121.57095730305,
                        0.53346354875294
                    ],
                    [
                        121.57090499997,
                        0.53349439281956
                    ],
                    [
                        121.57085806131,
                        0.53352255479329
                    ],
                    [
                        121.57086476684,
                        0.53352255479329
                    ],
                    [
                        121.57086476684,
                        0.53352255479329
                    ],
                    [
                        121.57086476684,
                        0.53352255479329
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1687,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0012747854382790921,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57230779529,
                        0.53547645903717
                    ],
                    [
                        121.57215490937,
                        0.5355408292419
                    ],
                    [
                        121.57200604677,
                        0.53561190467549
                    ],
                    [
                        121.5718062222,
                        0.53569370847541
                    ],
                    [
                        121.57160773873,
                        0.53576344286136
                    ],
                    [
                        121.57126709819,
                        0.53590693476842
                    ],
                    [
                        121.57112628222,
                        0.53595253032696
                    ],
                    [
                        121.57112628222,
                        0.53595253032696
                    ],
                    [
                        121.57112628222,
                        0.53595253032696
                    ],
                    [
                        121.57112628222,
                        0.53595253032696
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1688,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 8.269704069238411e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57077223063,
                        0.5334447741036
                    ],
                    [
                        121.57081380486,
                        0.53341124794396
                    ],
                    [
                        121.57080575824,
                        0.53343940991808
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1689,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.005174538916284497,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57247141004,
                        0.54737554801889
                    ],
                    [
                        121.57212942839,
                        0.54732861150297
                    ],
                    [
                        121.57164126635,
                        0.54728301603001
                    ],
                    [
                        121.57130867243,
                        0.54725887725006
                    ],
                    [
                        121.57068103552,
                        0.54720255342981
                    ],
                    [
                        121.57071322203,
                        0.5469397089283
                    ],
                    [
                        121.57075881958,
                        0.54672782406667
                    ],
                    [
                        121.5707936883,
                        0.54649448250154
                    ],
                    [
                        121.57085001469,
                        0.54607607691379
                    ],
                    [
                        121.5708848834,
                        0.54559866537423
                    ],
                    [
                        121.57091975212,
                        0.54515343884815
                    ],
                    [
                        121.57095730305,
                        0.54481281371259
                    ],
                    [
                        121.57103776932,
                        0.54412888129565
                    ],
                    [
                        121.57107800245,
                        0.543852626219
                    ],
                    [
                        121.57107800245,
                        0.543852626219
                    ],
                    [
                        121.57107800245,
                        0.543852626219
                    ],
                    [
                        121.57107800245,
                        0.543852626219
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1690,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0031857284478789003,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57107800245,
                        0.54384592099853
                    ],
                    [
                        121.57110616565,
                        0.54360185096853
                    ],
                    [
                        121.57114103436,
                        0.54337119137069
                    ],
                    [
                        121.5711812675,
                        0.54292328259159
                    ],
                    [
                        121.57122418284,
                        0.54266043790337
                    ],
                    [
                        121.57126843929,
                        0.54224605518293
                    ],
                    [
                        121.57128721476,
                        0.54205562686824
                    ],
                    [
                        121.57146960497,
                        0.5406850792437
                    ],
                    [
                        121.57146960497,
                        0.5406850792437
                    ],
                    [
                        121.57146960497,
                        0.5406850792437
                    ],
                    [
                        121.57146960497,
                        0.5406850792437
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1691,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.004070868707441545,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57199397683,
                        0.55090785504695
                    ],
                    [
                        121.5718665719,
                        0.55088773940919
                    ],
                    [
                        121.57169491053,
                        0.55087432898399
                    ],
                    [
                        121.57148972154,
                        0.5508528723036
                    ],
                    [
                        121.57133951783,
                        0.55084348500589
                    ],
                    [
                        121.57122015953,
                        0.55084482604843
                    ],
                    [
                        121.57109677792,
                        0.55085019021855
                    ],
                    [
                        121.57098948956,
                        0.55086762377137
                    ],
                    [
                        121.57084196806,
                        0.5508957856643
                    ],
                    [
                        121.57071724534,
                        0.55092126547208
                    ],
                    [
                        121.57050132751,
                        0.55096686091729
                    ],
                    [
                        121.57041281462,
                        0.5509708840448
                    ],
                    [
                        121.57034575939,
                        0.55098831759728
                    ],
                    [
                        121.5702585876,
                        0.55098697655478
                    ],
                    [
                        121.57021433115,
                        0.55097893029979
                    ],
                    [
                        121.57021030784,
                        0.55093601693969
                    ],
                    [
                        121.57020896673,
                        0.55089444462179
                    ],
                    [
                        121.5701687336,
                        0.55087432898399
                    ],
                    [
                        121.57016471028,
                        0.55085823647371
                    ],
                    [
                        121.57017543912,
                        0.55072949638984
                    ],
                    [
                        121.57018482685,
                        0.55061014360129
                    ],
                    [
                        121.5702009201,
                        0.55040496408277
                    ],
                    [
                        121.57022505999,
                        0.55018637413046
                    ],
                    [
                        121.57026126981,
                        0.54990341411893
                    ],
                    [
                        121.57027199864,
                        0.54978406131386
                    ],
                    [
                        121.57028406858,
                        0.54965532120681
                    ],
                    [
                        121.57030820847,
                        0.5494353901842
                    ],
                    [
                        121.57032430172,
                        0.54926239565464
                    ],
                    [
                        121.57036319375,
                        0.548962002041
                    ],
                    [
                        121.57038733363,
                        0.54874341203588
                    ],
                    [
                        121.57038733363,
                        0.54874341203588
                    ],
                    [
                        121.57038733363,
                        0.54874341203588
                    ],
                    [
                        121.57038733363,
                        0.54874341203588
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1692,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.008179854882212872,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57038733363,
                        0.54873938890687
                    ],
                    [
                        121.57041415572,
                        0.54854225558239
                    ],
                    [
                        121.57046377659,
                        0.54821235898402
                    ],
                    [
                        121.57059252262,
                        0.54735006819601
                    ],
                    [
                        121.57069292222,
                        0.54678529849843
                    ],
                    [
                        121.5707753129,
                        0.54636497221108
                    ],
                    [
                        121.57080710381,
                        0.5461722069506
                    ],
                    [
                        121.57088911007,
                        0.54505113761223
                    ],
                    [
                        121.57097417196,
                        0.54426644751317
                    ],
                    [
                        121.57102704048,
                        0.5437828919258
                    ],
                    [
                        121.57113357122,
                        0.54295374706703
                    ],
                    [
                        121.57120407522,
                        0.54244108704821
                    ],
                    [
                        121.57140581089,
                        0.54084830007446
                    ],
                    [
                        121.57140963523,
                        0.54062894998223
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2078,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.0010594788262164733,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95591024311,
                        0.47293551595014
                    ],
                    [
                        121.95557416062,
                        0.47280252279976
                    ],
                    [
                        121.9554238826,
                        0.47279892468854
                    ],
                    [
                        121.95501244067,
                        0.47283359705424
                    ],
                    [
                        121.95487835038,
                        0.47284758413418
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1694,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0038407541868327615,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57147094607,
                        0.54068775422057
                    ],
                    [
                        121.5715098381,
                        0.54040882400988
                    ],
                    [
                        121.57153244023,
                        0.54016321357346
                    ],
                    [
                        121.57156348228,
                        0.53990995530338
                    ],
                    [
                        121.57155159786,
                        0.53977547047424
                    ],
                    [
                        121.5715309024,
                        0.53960381285633
                    ],
                    [
                        121.57148415372,
                        0.5393306222757
                    ],
                    [
                        121.57144584729,
                        0.53903136435366
                    ],
                    [
                        121.57142974741,
                        0.53891106897982
                    ],
                    [
                        121.57151789367,
                        0.53889574158009
                    ],
                    [
                        121.57174513268,
                        0.5388727549504
                    ],
                    [
                        121.57207578421,
                        0.53886125805039
                    ],
                    [
                        121.5724298358,
                        0.53887735059271
                    ],
                    [
                        121.57274901867,
                        0.53891758194836
                    ],
                    [
                        121.57301992178,
                        0.53895244912304
                    ],
                    [
                        121.57326668501,
                        0.53898999838785
                    ],
                    [
                        121.57336592674,
                        0.5390034088395
                    ],
                    [
                        121.57336592674,
                        0.5390034088395
                    ],
                    [
                        121.57336592674,
                        0.5390034088395
                    ],
                    [
                        121.57346649117,
                        0.539016824916
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2000,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0012651979138776617,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.572997123,
                        0.54353805283036
                    ],
                    [
                        121.57313257456,
                        0.54351794161336
                    ],
                    [
                        121.57332167029,
                        0.5435085563787
                    ],
                    [
                        121.57353892922,
                        0.54351123787433
                    ],
                    [
                        121.5736502409,
                        0.5435085563787
                    ],
                    [
                        121.57371327281,
                        0.54352196385675
                    ],
                    [
                        121.57379508018,
                        0.54356218629069
                    ],
                    [
                        121.57390505075,
                        0.54360509021993
                    ],
                    [
                        121.57405793667,
                        0.5436064309677
                    ],
                    [
                        121.57424166799,
                        0.54361045321106
                    ],
                    [
                        121.57424166799,
                        0.54361045321106
                    ],
                    [
                        121.57424166799,
                        0.54361045321106
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1696,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.011724093860117874,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.56775608659,
                        0.563375514163
                    ],
                    [
                        121.5679089725,
                        0.56340635807548
                    ],
                    [
                        121.56801223755,
                        0.56343586094814
                    ],
                    [
                        121.568146348,
                        0.56347206901893
                    ],
                    [
                        121.56822279096,
                        0.56348816149477
                    ],
                    [
                        121.56828179955,
                        0.56349754877232
                    ],
                    [
                        121.56834617257,
                        0.56348682045512
                    ],
                    [
                        121.56838238239,
                        0.56346804589997
                    ],
                    [
                        121.56844139099,
                        0.56342513263083
                    ],
                    [
                        121.56848162413,
                        0.56340233495647
                    ],
                    [
                        121.56851515174,
                        0.56335808064717
                    ],
                    [
                        121.56856074929,
                        0.56331784945661
                    ],
                    [
                        121.56869888306,
                        0.56310864726119
                    ],
                    [
                        121.56876459718,
                        0.56302147967754
                    ],
                    [
                        121.56886786222,
                        0.56287932946142
                    ],
                    [
                        121.56893759966,
                        0.56277741043643
                    ],
                    [
                        121.56902343035,
                        0.56262319085573
                    ],
                    [
                        121.56908109784,
                        0.56249981518822
                    ],
                    [
                        121.56914949417,
                        0.5622973181631
                    ],
                    [
                        121.56918570399,
                        0.56219674016787
                    ],
                    [
                        121.56922593713,
                        0.56208409281117
                    ],
                    [
                        121.56926214695,
                        0.56196742233228
                    ],
                    [
                        121.56938418746,
                        0.56165093688358
                    ],
                    [
                        121.56942039728,
                        0.56152890223565
                    ],
                    [
                        121.56953573227,
                        0.56118559595966
                    ],
                    [
                        121.56959876418,
                        0.56099919137168
                    ],
                    [
                        121.56980127096,
                        0.56043327237037
                    ],
                    [
                        121.56995415688,
                        0.55999609319922
                    ],
                    [
                        121.57010436058,
                        0.55952941110324
                    ],
                    [
                        121.57030820847,
                        0.55890716825087
                    ],
                    [
                        121.57045304775,
                        0.55851290227148
                    ],
                    [
                        121.57062470913,
                        0.55797380384871
                    ],
                    [
                        121.57078564167,
                        0.55747225452547
                    ],
                    [
                        121.57096534967,
                        0.55683660104372
                    ],
                    [
                        121.5711209178,
                        0.55620094749343
                    ],
                    [
                        121.57124966383,
                        0.55573694717931
                    ],
                    [
                        121.5713596344,
                        0.5553104959914
                    ],
                    [
                        121.57152056694,
                        0.55462924686014
                    ],
                    [
                        121.57160639763,
                        0.55425107309593
                    ],
                    [
                        121.5717163682,
                        0.55356445967511
                    ],
                    [
                        121.57175928354,
                        0.55321847085089
                    ],
                    [
                        121.57178610563,
                        0.55302804288477
                    ],
                    [
                        121.57178610563,
                        0.55302804288477
                    ],
                    [
                        121.57178610563,
                        0.55302804288477
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1697,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.007928829745276167,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57178744674,
                        0.55302267871662
                    ],
                    [
                        121.5718048811,
                        0.55283761491254
                    ],
                    [
                        121.57182365656,
                        0.55269546445041
                    ],
                    [
                        121.57187730074,
                        0.55229583388772
                    ],
                    [
                        121.57190948725,
                        0.55206383358228
                    ],
                    [
                        121.57194972038,
                        0.55176075802513
                    ],
                    [
                        121.57197117805,
                        0.55158910460537
                    ],
                    [
                        121.57201141119,
                        0.55130748570287
                    ],
                    [
                        121.57203823328,
                        0.55113717331252
                    ],
                    [
                        121.57206505537,
                        0.55090785504695
                    ],
                    [
                        121.57208785415,
                        0.55074558890047
                    ],
                    [
                        121.57212272286,
                        0.55049024441254
                    ],
                    [
                        121.57214149833,
                        0.55035211702227
                    ],
                    [
                        121.57220184803,
                        0.54989348042191
                    ],
                    [
                        121.57224878669,
                        0.54951317066874
                    ],
                    [
                        121.57229036093,
                        0.54922216436796
                    ],
                    [
                        121.57232791185,
                        0.548962002041
                    ],
                    [
                        121.57236546278,
                        0.54867770092848
                    ],
                    [
                        121.57239496708,
                        0.54845911091297
                    ],
                    [
                        121.57244324684,
                        0.54809702927463
                    ],
                    [
                        121.5724915266,
                        0.5477711557814
                    ],
                    [
                        121.57252505422,
                        0.54749758295859
                    ],
                    [
                        121.57257333398,
                        0.54713550126215
                    ],
                    [
                        121.57261222601,
                        0.54684717693268
                    ],
                    [
                        121.57264441252,
                        0.54658165032865
                    ],
                    [
                        121.57270610332,
                        0.54610692091643
                    ],
                    [
                        121.57277315855,
                        0.54566169442796
                    ],
                    [
                        121.57281473279,
                        0.5453639827215
                    ],
                    [
                        121.57283753157,
                        0.54516416719856
                    ],
                    [
                        121.57283753157,
                        0.54516416719856
                    ],
                    [
                        121.57283753157,
                        0.54516416719856
                    ],
                    [
                        121.57283753157,
                        0.54516416719856
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1698,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.001811817776501437,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57463997602,
                        0.54527815888415
                    ],
                    [
                        121.57319426537,
                        0.54523658356335
                    ],
                    [
                        121.57292604446,
                        0.5451936701621
                    ],
                    [
                        121.57292604446,
                        0.5451936701621
                    ],
                    [
                        121.57292604446,
                        0.5451936701621
                    ],
                    [
                        121.57283216715,
                        0.5451936701621
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1699,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.004926782422248629,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57283484936,
                        0.54517220901591
                    ],
                    [
                        121.57284960151,
                        0.54499921880884
                    ],
                    [
                        121.57289654016,
                        0.54443732141485
                    ],
                    [
                        121.57293945551,
                        0.5439599097454
                    ],
                    [
                        121.57299444079,
                        0.54353479876077
                    ],
                    [
                        121.57303199172,
                        0.54321294815313
                    ],
                    [
                        121.57311111689,
                        0.54264702745979
                    ],
                    [
                        121.57316073775,
                        0.54218034400461
                    ],
                    [
                        121.57319828868,
                        0.54178205378594
                    ],
                    [
                        121.57326132059,
                        0.5412872083263
                    ],
                    [
                        121.57330825925,
                        0.54090501058592
                    ],
                    [
                        121.57335653901,
                        0.54051744864215
                    ],
                    [
                        121.57338738441,
                        0.54027740161268
                    ],
                    [
                        121.57338738441,
                        0.54027740161268
                    ],
                    [
                        121.57338738441,
                        0.54027740161268
                    ],
                    [
                        121.57338738441,
                        0.54027740161268
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1700,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.004111305197150973,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57285496593,
                        0.53632534105765
                    ],
                    [
                        121.57295420766,
                        0.53654661360289
                    ],
                    [
                        121.57309234142,
                        0.53688321606546
                    ],
                    [
                        121.57318621874,
                        0.53714069682113
                    ],
                    [
                        121.57332971692,
                        0.53751753061585
                    ],
                    [
                        121.57349064946,
                        0.53797750920211
                    ],
                    [
                        121.57359525561,
                        0.5382846085888
                    ],
                    [
                        121.57359391451,
                        0.53841871311962
                    ],
                    [
                        121.57354965806,
                        0.53893769762607
                    ],
                    [
                        121.57347052386,
                        0.5396926223412
                    ],
                    [
                        121.57346785069,
                        0.53973427841044
                    ],
                    [
                        121.57344639694,
                        0.53984296456644
                    ],
                    [
                        121.57338604331,
                        0.54027606056779
                    ],
                    [
                        121.57338604331,
                        0.54026399116381
                    ],
                    [
                        121.57338604331,
                        0.54026399116381
                    ],
                    [
                        121.57338604331,
                        0.54026399116381
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1992,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.007278929146420519,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57842189074,
                        0.54552086083347
                    ],
                    [
                        121.57847419381,
                        0.5453774008645
                    ],
                    [
                        121.57855063677,
                        0.54512936259228
                    ],
                    [
                        121.57860293984,
                        0.54499126560387
                    ],
                    [
                        121.57869011164,
                        0.54479015347917
                    ],
                    [
                        121.57877728343,
                        0.54460915256118
                    ],
                    [
                        121.57889664173,
                        0.54439597369527
                    ],
                    [
                        121.57905757427,
                        0.54409028323289
                    ],
                    [
                        121.57921180129,
                        0.54381811144849
                    ],
                    [
                        121.57938748598,
                        0.54349096899191
                    ],
                    [
                        121.57950416207,
                        0.54326438260791
                    ],
                    [
                        121.57965704799,
                        0.54293187712962
                    ],
                    [
                        121.57986491919,
                        0.54250954151592
                    ],
                    [
                        121.5800486505,
                        0.54213413205678
                    ],
                    [
                        121.58023104072,
                        0.54173190761042
                    ],
                    [
                        121.58039465547,
                        0.54133638687881
                    ],
                    [
                        121.5805247426,
                        0.54092477714089
                    ],
                    [
                        121.58062130213,
                        0.54047830791476
                    ],
                    [
                        121.58072456717,
                        0.54009083159283
                    ],
                    [
                        121.5807929635,
                        0.53984145235527
                    ],
                    [
                        121.58084392548,
                        0.53971542198401
                    ],
                    [
                        121.58090025187,
                        0.53959877685084
                    ],
                    [
                        121.58097535372,
                        0.53945933898757
                    ],
                    [
                        121.58112555742,
                        0.53925152293538
                    ],
                    [
                        121.58134415746,
                        0.53894046921824
                    ],
                    [
                        121.58136695623,
                        0.53891097274424
                    ],
                    [
                        121.58136695623,
                        0.53891097274424
                    ],
                    [
                        121.58136695623,
                        0.53891097274424
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1739,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.005855535246294081,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82080838639,
                        0.541063373485
                    ],
                    [
                        121.82106990176,
                        0.54129269212613
                    ],
                    [
                        121.82121474105,
                        0.54139595256403
                    ],
                    [
                        121.82130459505,
                        0.54143886599226
                    ],
                    [
                        121.82141188341,
                        0.54148982568789
                    ],
                    [
                        121.82149100858,
                        0.54150725926786
                    ],
                    [
                        121.8215553816,
                        0.54150994135709
                    ],
                    [
                        121.82159829694,
                        0.54149921300019
                    ],
                    [
                        121.82165998775,
                        0.5414831204648
                    ],
                    [
                        121.82174447733,
                        0.54144154808152
                    ],
                    [
                        121.82185042459,
                        0.5413530391355
                    ],
                    [
                        121.82196039516,
                        0.54125380183087
                    ],
                    [
                        121.8220314737,
                        0.54118809064177
                    ],
                    [
                        121.82211328107,
                        0.54111701527317
                    ],
                    [
                        121.82216290194,
                        0.54108348915562
                    ],
                    [
                        121.82223398048,
                        0.54103655259073
                    ],
                    [
                        121.82239357191,
                        0.54091451752033
                    ],
                    [
                        121.82251427132,
                        0.54079516453701
                    ],
                    [
                        121.82259205538,
                        0.54073749961164
                    ],
                    [
                        121.82267118055,
                        0.54068519886491
                    ],
                    [
                        121.82281404734,
                        0.54059388819703
                    ],
                    [
                        121.82291731238,
                        0.54054292849389
                    ],
                    [
                        121.82305678725,
                        0.54046380684867
                    ],
                    [
                        121.82329148054,
                        0.54034311281164
                    ],
                    [
                        121.82350739837,
                        0.54023180608645
                    ],
                    [
                        121.82359322906,
                        0.54019291578441
                    ],
                    [
                        121.82369247079,
                        0.54015000234738
                    ],
                    [
                        121.82378903031,
                        0.54012586353891
                    ],
                    [
                        121.82391241193,
                        0.54012452249399
                    ],
                    [
                        121.82401433587,
                        0.5401674359312
                    ],
                    [
                        121.82409882545,
                        0.54023582922113
                    ],
                    [
                        121.82420343161,
                        0.54035920535004
                    ],
                    [
                        121.82439118624,
                        0.54060193446592
                    ],
                    [
                        121.82452395558,
                        0.54076688297558
                    ],
                    [
                        121.82464063168,
                        0.54091439789913
                    ],
                    [
                        121.82480558753,
                        0.54111689565197
                    ],
                    [
                        121.82508051395,
                        0.54144411054958
                    ],
                    [
                        121.82486325502,
                        0.54166538290886
                    ],
                    [
                        121.82478815317,
                        0.5417337761819
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1703,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.03494585863870295,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.8217009306,
                        0.54138912771965
                    ],
                    [
                        121.82156950235,
                        0.54145349786196
                    ],
                    [
                        121.82143136859,
                        0.54143070010331
                    ],
                    [
                        121.82118996978,
                        0.54131000608549
                    ],
                    [
                        121.82020962238,
                        0.54040077774075
                    ],
                    [
                        121.81989178061,
                        0.54012988667365
                    ],
                    [
                        121.81972950697,
                        0.54001857994457
                    ],
                    [
                        121.81954711676,
                        0.53988313440402
                    ],
                    [
                        121.81933656335,
                        0.53974098363545
                    ],
                    [
                        121.81901603937,
                        0.53950495971047
                    ],
                    [
                        121.81874111295,
                        0.53933330594111
                    ],
                    [
                        121.81847020984,
                        0.53914019544477
                    ],
                    [
                        121.81811347604,
                        0.53891624090318
                    ],
                    [
                        121.81778088212,
                        0.5387030147152
                    ],
                    [
                        121.81749925017,
                        0.53851258628943
                    ],
                    [
                        121.81718811393,
                        0.538298019042
                    ],
                    [
                        121.81694000959,
                        0.53814916300968
                    ],
                    [
                        121.81680724025,
                        0.53803651519901
                    ],
                    [
                        121.81672006845,
                        0.53794130097647
                    ],
                    [
                        121.81660473347,
                        0.53778842179913
                    ],
                    [
                        121.81655108929,
                        0.53766772770906
                    ],
                    [
                        121.81650280952,
                        0.53748534552398
                    ],
                    [
                        121.81645587087,
                        0.53733380738077
                    ],
                    [
                        121.81642234325,
                        0.53712862741095
                    ],
                    [
                        121.8164075911,
                        0.5369958638974
                    ],
                    [
                        121.81636601686,
                        0.5366391457558
                    ],
                    [
                        121.81635126472,
                        0.53644067099132
                    ],
                    [
                        121.8163459003,
                        0.53601287738921
                    ],
                    [
                        121.8163472414,
                        0.53560117630821
                    ],
                    [
                        121.8163459003,
                        0.53513985649728
                    ],
                    [
                        121.81635260582,
                        0.53449481333141
                    ],
                    [
                        121.81634321809,
                        0.53407908900978
                    ],
                    [
                        121.81632041931,
                        0.53353998839602
                    ],
                    [
                        121.81626945734,
                        0.53284666738799
                    ],
                    [
                        121.81623056531,
                        0.53254493191524
                    ],
                    [
                        121.81618362665,
                        0.53218016723514
                    ],
                    [
                        121.81613266468,
                        0.53183015404756
                    ],
                    [
                        121.8160803616,
                        0.53155658050782
                    ],
                    [
                        121.81605085731,
                        0.53130982789294
                    ],
                    [
                        121.81599989533,
                        0.53098127140676
                    ],
                    [
                        121.81595161557,
                        0.5306741716549
                    ],
                    [
                        121.81590467691,
                        0.53047703774502
                    ],
                    [
                        121.81585371494,
                        0.53036170769959
                    ],
                    [
                        121.81580543518,
                        0.53027722173472
                    ],
                    [
                        121.81572362781,
                        0.53020480519249
                    ],
                    [
                        121.81561097503,
                        0.5301297065552
                    ],
                    [
                        121.81547820568,
                        0.53005997210547
                    ],
                    [
                        121.81538432837,
                        0.5299728040422
                    ],
                    [
                        121.81525424123,
                        0.52982126571392
                    ],
                    [
                        121.81508257985,
                        0.52961206235196
                    ],
                    [
                        121.81495383382,
                        0.52942833888083
                    ],
                    [
                        121.81474328041,
                        0.52914135476175
                    ],
                    [
                        121.81458368897,
                        0.52890130728747
                    ],
                    [
                        121.81443616748,
                        0.52871490170047
                    ],
                    [
                        121.81421890855,
                        0.52841584812115
                    ],
                    [
                        121.81406602263,
                        0.52821469099692
                    ],
                    [
                        121.8136703968,
                        0.52770106977685
                    ],
                    [
                        121.81338608265,
                        0.52735239738397
                    ],
                    [
                        121.813133955,
                        0.52708418783768
                    ],
                    [
                        121.81302934885,
                        0.52705200269136
                    ],
                    [
                        121.81249827147,
                        0.52690716953083
                    ],
                    [
                        121.81199938059,
                        0.52683207085366
                    ],
                    [
                        121.81144416332,
                        0.5268803485748
                    ],
                    [
                        121.81085675955,
                        0.52702518173596
                    ],
                    [
                        121.81013524532,
                        0.52720220003948
                    ],
                    [
                        121.80978655815,
                        0.5273309406207
                    ],
                    [
                        121.80946469307,
                        0.52744358862707
                    ],
                    [
                        121.80927693844,
                        0.52751332310618
                    ],
                    [
                        121.80897653103,
                        0.52756696501267
                    ],
                    [
                        121.80832207203,
                        0.52759110387044
                    ],
                    [
                        121.80780977011,
                        0.52761256063281
                    ],
                    [
                        121.80749595165,
                        0.52760183225163
                    ],
                    [
                        121.80701851845,
                        0.52747577377137
                    ],
                    [
                        121.80637478828,
                        0.52729875547563
                    ],
                    [
                        121.80594563484,
                        0.5271646507028
                    ],
                    [
                        121.80541455746,
                        0.52703591011814
                    ],
                    [
                        121.80517047644,
                        0.52700908916268
                    ],
                    [
                        121.804921031,
                        0.52704395640476
                    ],
                    [
                        121.80448114872,
                        0.52715124022535
                    ],
                    [
                        121.80384010077,
                        0.52734971528856
                    ],
                    [
                        121.80330365896,
                        0.5274945484388
                    ],
                    [
                        121.80309444666,
                        0.52750527682017
                    ],
                    [
                        121.80290400982,
                        0.52748650215277
                    ],
                    [
                        121.80266261101,
                        0.52742213186411
                    ],
                    [
                        121.80219054222,
                        0.52718610746664
                    ],
                    [
                        121.80144488811,
                        0.5268803485748
                    ],
                    [
                        121.80069386959,
                        0.52653167613597
                    ],
                    [
                        121.80037736893,
                        0.52640829972986
                    ],
                    [
                        121.8001896143,
                        0.52636538619672
                    ],
                    [
                        121.80005550385,
                        0.52636538619672
                    ],
                    [
                        121.79954051971,
                        0.5264512132627
                    ],
                    [
                        121.79932594299,
                        0.52647267002901
                    ],
                    [
                        121.79918110371,
                        0.52644048487952
                    ],
                    [
                        121.79903626442,
                        0.52634392943006
                    ],
                    [
                        121.79830670357,
                        0.52585042377613
                    ],
                    [
                        121.79811224341,
                        0.5257203421163
                    ],
                    [
                        121.79803848267,
                        0.52563317399221
                    ],
                    [
                        121.79792582989,
                        0.52538508009391
                    ],
                    [
                        121.79787218571,
                        0.52518258182368
                    ],
                    [
                        121.79752618074,
                        0.5249036437983
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1704,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.008158951619048893,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.79752618074,
                        0.52491169008767
                    ],
                    [
                        121.79732769728,
                        0.52524963423177
                    ],
                    [
                        121.79722979665,
                        0.52519733335351
                    ],
                    [
                        121.79704338312,
                        0.52508468530657
                    ],
                    [
                        121.79695084691,
                        0.52500556346286
                    ],
                    [
                        121.79686903954,
                        0.52491571323235
                    ],
                    [
                        121.79676443338,
                        0.52478026736004
                    ],
                    [
                        121.79662629962,
                        0.5246099542293
                    ],
                    [
                        121.79647743702,
                        0.52445707472217
                    ],
                    [
                        121.79638892412,
                        0.52437661182218
                    ],
                    [
                        121.79625347257,
                        0.52427201005064
                    ],
                    [
                        121.79618641734,
                        0.52422105021259
                    ],
                    [
                        121.79609522223,
                        0.52417813666444
                    ],
                    [
                        121.79597452283,
                        0.52412315368044
                    ],
                    [
                        121.79581224918,
                        0.5240721938412
                    ],
                    [
                        121.79565265775,
                        0.52405341916347
                    ],
                    [
                        121.7954595387,
                        0.52405878335712
                    ],
                    [
                        121.79529324174,
                        0.52406548859916
                    ],
                    [
                        121.79511621594,
                        0.52409096851887
                    ],
                    [
                        121.79483860731,
                        0.52416070303543
                    ],
                    [
                        121.79459318519,
                        0.52424653013166
                    ],
                    [
                        121.79436519742,
                        0.5243162646465
                    ],
                    [
                        121.79420426488,
                        0.52436856553213
                    ],
                    [
                        121.79410234094,
                        0.52438868125725
                    ],
                    [
                        121.79398566484,
                        0.52440611488563
                    ],
                    [
                        121.79380863905,
                        0.52442623061062
                    ],
                    [
                        121.79365709424,
                        0.52442623061062
                    ],
                    [
                        121.79349482059,
                        0.52441147907895
                    ],
                    [
                        121.79337412119,
                        0.52440745593397
                    ],
                    [
                        121.79326951504,
                        0.52437124762881
                    ],
                    [
                        121.79303616285,
                        0.52428542053427
                    ],
                    [
                        121.79277330637,
                        0.52417947771284
                    ],
                    [
                        121.79242998362,
                        0.52401184666259
                    ],
                    [
                        121.79217651486,
                        0.52390992698185
                    ],
                    [
                        121.79192706943,
                        0.52382678197791
                    ],
                    [
                        121.791652143,
                        0.5237731400393
                    ],
                    [
                        121.79154083133,
                        0.52376375269999
                    ],
                    [
                        121.79142147303,
                        0.52376375269999
                    ],
                    [
                        121.79129272699,
                        0.52376911689388
                    ],
                    [
                        121.79116666317,
                        0.52379861996019
                    ],
                    [
                        121.79088100791,
                        0.52389115230363
                    ],
                    [
                        121.79056316614,
                        0.52398904883942
                    ],
                    [
                        121.79021716118,
                        0.52409230956726
                    ],
                    [
                        121.79021716118,
                        0.52409230956726
                    ],
                    [
                        121.79021716118,
                        0.52409230956726
                    ],
                    [
                        121.79021716118,
                        0.52409230956726
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1705,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.018459103122483538,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.79020509124,
                        0.52409499166407
                    ],
                    [
                        121.78987115622,
                        0.52420629868045
                    ],
                    [
                        121.78958818316,
                        0.5243041952113
                    ],
                    [
                        121.78916305304,
                        0.52446377996379
                    ],
                    [
                        121.78886935115,
                        0.52457776907022
                    ],
                    [
                        121.7886453867,
                        0.5246595730159
                    ],
                    [
                        121.78845360875,
                        0.52473467171919
                    ],
                    [
                        121.78845360875,
                        0.52473467171919
                    ],
                    [
                        121.78827792406,
                        0.52481647566282
                    ],
                    [
                        121.78813576698,
                        0.52486475339955
                    ],
                    [
                        121.7877548933,
                        0.52496264992009
                    ],
                    [
                        121.78750813007,
                        0.5249948350772
                    ],
                    [
                        121.78741693497,
                        0.52500288136645
                    ],
                    [
                        121.78729087114,
                        0.52500288136645
                    ],
                    [
                        121.78655862808,
                        0.52498678878793
                    ],
                    [
                        121.78602218628,
                        0.52497606040223
                    ],
                    [
                        121.7856413126,
                        0.52497069620939
                    ],
                    [
                        121.78527653217,
                        0.52495996782366
                    ],
                    [
                        121.78496271372,
                        0.52489961395953
                    ],
                    [
                        121.7843914032,
                        0.52474003591224
                    ],
                    [
                        121.78395152092,
                        0.52462202366391
                    ],
                    [
                        121.78364574909,
                        0.52454156076604
                    ],
                    [
                        121.78328499198,
                        0.52443292023275
                    ],
                    [
                        121.78282499313,
                        0.52425188242455
                    ],
                    [
                        121.78252592683,
                        0.52407627723318
                    ],
                    [
                        121.7821598053,
                        0.52365646882124
                    ],
                    [
                        121.78188085556,
                        0.52323806167655
                    ],
                    [
                        121.78158581257,
                        0.52288938903465
                    ],
                    [
                        121.78143560886,
                        0.52277137675148
                    ],
                    [
                        121.78129076958,
                        0.52264800027123
                    ],
                    [
                        121.7809098959,
                        0.52240661149853
                    ],
                    [
                        121.78064703941,
                        0.5222725066208
                    ],
                    [
                        121.78045392036,
                        0.52213303754493
                    ],
                    [
                        121.78009450436,
                        0.52186482777494
                    ],
                    [
                        121.77979946136,
                        0.52154297603586
                    ],
                    [
                        121.77964925766,
                        0.52125867365263
                    ],
                    [
                        121.77955940366,
                        0.52111519405156
                    ],
                    [
                        121.77935421467,
                        0.52082953795556
                    ],
                    [
                        121.77910208702,
                        0.52055059973678
                    ],
                    [
                        121.7787386477,
                        0.52009996555137
                    ],
                    [
                        121.77860856056,
                        0.51989616771354
                    ],
                    [
                        121.77836313844,
                        0.51953141121955
                    ],
                    [
                        121.77813649178,
                        0.5191666368536
                    ],
                    [
                        121.77792191505,
                        0.51876432200512
                    ],
                    [
                        121.77776634693,
                        0.51842101331418
                    ],
                    [
                        121.7775785923,
                        0.51808306880337
                    ],
                    [
                        121.77731841803,
                        0.51767408954555
                    ],
                    [
                        121.77704617381,
                        0.51719934154642
                    ],
                    [
                        121.77681684494,
                        0.51680638937771
                    ],
                    [
                        121.77662909031,
                        0.51650599418142
                    ],
                    [
                        121.77648688532,
                        0.51634094742194
                    ],
                    [
                        121.77634871111,
                        0.51621346646471
                    ],
                    [
                        121.77607772867,
                        0.51602292088054
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1706,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0033758682029362106,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.77245289087,
                        0.51381451887652
                    ],
                    [
                        121.77217662334,
                        0.5136307822998
                    ],
                    [
                        121.77185207605,
                        0.51341353209564
                    ],
                    [
                        121.77167236805,
                        0.51328210912905
                    ],
                    [
                        121.77154630423,
                        0.51315068615977
                    ],
                    [
                        121.77148461342,
                        0.51301926318778
                    ],
                    [
                        121.7714202404,
                        0.51280201296285
                    ],
                    [
                        121.77139610052,
                        0.5127081394066
                    ],
                    [
                        121.77135586739,
                        0.51257403432384
                    ],
                    [
                        121.77130222321,
                        0.51249088917111
                    ],
                    [
                        121.77120834589,
                        0.51241847242431
                    ],
                    [
                        121.77110373974,
                        0.51237824089795
                    ],
                    [
                        121.77094683051,
                        0.51237288561989
                    ],
                    [
                        121.77071347833,
                        0.51237824833586
                    ],
                    [
                        121.77028030157,
                        0.51238360510148
                    ],
                    [
                        121.77028030157,
                        0.51238360510148
                    ],
                    [
                        121.77028030157,
                        0.51238360510148
                    ],
                    [
                        121.76979348063,
                        0.51239031407483
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2167,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0037774581817469786,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.78621667392,
                        0.5249844913714
                    ],
                    [
                        121.78621264943,
                        0.52505695226588
                    ],
                    [
                        121.78596849694,
                        0.52505292666068
                    ],
                    [
                        121.78577397984,
                        0.52504084984496
                    ],
                    [
                        121.78544397153,
                        0.52502072181876
                    ],
                    [
                        121.78518506256,
                        0.52500730313458
                    ],
                    [
                        121.78491139713,
                        0.52495094466068
                    ],
                    [
                        121.78470078207,
                        0.52489190244943
                    ],
                    [
                        121.78444723909,
                        0.52481944155301
                    ],
                    [
                        121.78418296414,
                        0.52474832252424
                    ],
                    [
                        121.78396832459,
                        0.52469464778501
                    ],
                    [
                        121.78374161156,
                        0.5246302380973
                    ],
                    [
                        121.78347062912,
                        0.52456582840897
                    ],
                    [
                        121.78330025897,
                        0.52451886301079
                    ],
                    [
                        121.78308830241,
                        0.52445311145275
                    ],
                    [
                        121.78291659077,
                        0.52437662494559
                    ],
                    [
                        121.78278109955,
                        0.52429745470034
                    ],
                    [
                        121.78263755935,
                        0.52422365192847
                    ],
                    [
                        121.78263755935,
                        0.52422365192847
                    ],
                    [
                        121.78263755935,
                        0.52422365192847
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1707,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.001126580718680919,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.78143177444,
                        0.52285348501986
                    ],
                    [
                        121.78124933632,
                        0.52272597794719
                    ],
                    [
                        121.78087909408,
                        0.52247236471845
                    ],
                    [
                        121.78048744798,
                        0.52224032144973
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1708,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0015139158022733628,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.77960902452,
                        0.52346743230178
                    ],
                    [
                        121.77986785769,
                        0.52312004939992
                    ],
                    [
                        121.78016021848,
                        0.52269627802467
                    ],
                    [
                        121.78034931421,
                        0.52244281981502
                    ],
                    [
                        121.78048342466,
                        0.52224300354732
                    ],
                    [
                        121.78047940135,
                        0.52225104984011
                    ],
                    [
                        121.78047940135,
                        0.52225104984011
                    ],
                    [
                        121.78047940135,
                        0.52225104984011
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1709,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.010648309153010443,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.8208090961,
                        0.54106057177438
                    ],
                    [
                        121.82041749358,
                        0.54070653596037
                    ],
                    [
                        121.8201559782,
                        0.54047587625224
                    ],
                    [
                        121.82002454996,
                        0.54036322848464
                    ],
                    [
                        121.81982338428,
                        0.5402157135477
                    ],
                    [
                        121.81966781616,
                        0.54008697323618
                    ],
                    [
                        121.81951761246,
                        0.53995823292192
                    ],
                    [
                        121.81939423084,
                        0.53988313440402
                    ],
                    [
                        121.81926548481,
                        0.53977585080541
                    ],
                    [
                        121.81890875101,
                        0.53952239329616
                    ],
                    [
                        121.81865125895,
                        0.53934537534691
                    ],
                    [
                        121.81844070554,
                        0.53920992979138
                    ],
                    [
                        121.8181926012,
                        0.53903693496854
                    ],
                    [
                        121.81785061955,
                        0.53882504982998
                    ],
                    [
                        121.81752204895,
                        0.53862389304605
                    ],
                    [
                        121.81727930903,
                        0.538457603433
                    ],
                    [
                        121.81708216667,
                        0.53832886308428
                    ],
                    [
                        121.81693866849,
                        0.53824705931964
                    ],
                    [
                        121.81680321693,
                        0.5381397756922
                    ],
                    [
                        121.8167321384,
                        0.53807540551483
                    ],
                    [
                        121.81657120585,
                        0.53784474570701
                    ],
                    [
                        121.81647598743,
                        0.53765163516353
                    ],
                    [
                        121.81644245982,
                        0.53754166943465
                    ],
                    [
                        121.81641161442,
                        0.53740085965698
                    ],
                    [
                        121.81635797024,
                        0.53713265054768
                    ],
                    [
                        121.81633383036,
                        0.53691808325176
                    ],
                    [
                        121.81630834937,
                        0.53669010549159
                    ],
                    [
                        121.81629091501,
                        0.53642055530537
                    ],
                    [
                        121.81628555059,
                        0.53605444980955
                    ],
                    [
                        121.8162868917,
                        0.53577685332011
                    ],
                    [
                        121.81628152728,
                        0.53538258582073
                    ],
                    [
                        121.81628286839,
                        0.53513583335925
                    ],
                    [
                        121.81628555059,
                        0.53493333540789
                    ],
                    [
                        121.81628420949,
                        0.53454174994659
                    ],
                    [
                        121.81627884507,
                        0.53430572582086
                    ],
                    [
                        121.81626811624,
                        0.53383233649592
                    ],
                    [
                        121.81618094444,
                        0.53258516331247
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1710,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.011782543326591486,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81618228555,
                        0.53257845807963
                    ],
                    [
                        121.81603878736,
                        0.53172152926117
                    ],
                    [
                        121.81600123644,
                        0.5313755391881
                    ],
                    [
                        121.8159288168,
                        0.53093299371752
                    ],
                    [
                        121.81589528918,
                        0.53071172097037
                    ],
                    [
                        121.81584969163,
                        0.53053872590798
                    ],
                    [
                        121.81577458978,
                        0.53037109502895
                    ],
                    [
                        121.8157222867,
                        0.53030001953487
                    ],
                    [
                        121.81558683515,
                        0.53019541786288
                    ],
                    [
                        121.81547284126,
                        0.530127024461
                    ],
                    [
                        121.81533873081,
                        0.53002242278606
                    ],
                    [
                        121.81486129761,
                        0.52943370306985
                    ],
                    [
                        121.81445896626,
                        0.52890264833484
                    ],
                    [
                        121.8139064312,
                        0.52816239014356
                    ],
                    [
                        121.81352555752,
                        0.52764742787152
                    ],
                    [
                        121.81315541267,
                        0.5272236568032
                    ],
                    [
                        121.8129837513,
                        0.52712173717486
                    ],
                    [
                        121.81242585182,
                        0.52698226820707
                    ],
                    [
                        121.81203424931,
                        0.52690716953083
                    ],
                    [
                        121.81154072285,
                        0.5269393546779
                    ],
                    [
                        121.81116521358,
                        0.52700372497156
                    ],
                    [
                        121.81081116199,
                        0.52712710136586
                    ],
                    [
                        121.81025326252,
                        0.52723974937594
                    ],
                    [
                        121.8098294735,
                        0.5273953109103
                    ],
                    [
                        121.80934667587,
                        0.52757769339391
                    ],
                    [
                        121.80897653103,
                        0.52764742787152
                    ],
                    [
                        121.80874317884,
                        0.52764876891918
                    ],
                    [
                        121.80854737759,
                        0.52764206368097
                    ],
                    [
                        121.80806592107,
                        0.52766620253845
                    ],
                    [
                        121.807898283,
                        0.52768497720529
                    ],
                    [
                        121.807898283,
                        0.52768497720529
                    ],
                    [
                        121.807898283,
                        0.52768497720529
                    ],
                    [
                        121.807898283,
                        0.52768497720529
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1711,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.005133677333061272,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80293083191,
                        0.52756964710798
                    ],
                    [
                        121.80307164788,
                        0.5275750112986
                    ],
                    [
                        121.80330768228,
                        0.52755355453609
                    ],
                    [
                        121.80355980992,
                        0.52749320739114
                    ],
                    [
                        121.8039111793,
                        0.52739396986261
                    ],
                    [
                        121.80419012904,
                        0.52731350700047
                    ],
                    [
                        121.80450126529,
                        0.52723170308956
                    ],
                    [
                        121.8046823144,
                        0.52717403803698
                    ],
                    [
                        121.80489957333,
                        0.52711637298386
                    ],
                    [
                        121.80506050587,
                        0.52708418783768
                    ],
                    [
                        121.80517449975,
                        0.52707882364665
                    ],
                    [
                        121.8052791059,
                        0.52708552888546
                    ],
                    [
                        121.8055178225,
                        0.52713112450912
                    ],
                    [
                        121.80575117469,
                        0.52720085899174
                    ],
                    [
                        121.80624604225,
                        0.52733496376382
                    ],
                    [
                        121.80662289262,
                        0.52745163491317
                    ],
                    [
                        121.80693939328,
                        0.52752941567817
                    ],
                    [
                        121.80734172463,
                        0.5276434047286
                    ],
                    [
                        121.80749058723,
                        0.52766486149081
                    ],
                    [
                        121.80769041181,
                        0.52768765930057
                    ],
                    [
                        121.80790498853,
                        0.52768363615768
                    ],
                    [
                        121.80788755417,
                        0.52768497720529
                    ],
                    [
                        121.80788755417,
                        0.52768497720529
                    ],
                    [
                        121.80788755417,
                        0.52768497720529
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1714,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0012821694200274942,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81423631525,
                        0.52862419430551
                    ],
                    [
                        121.81396541214,
                        0.52888703959589
                    ],
                    [
                        121.81372937774,
                        0.5291069713609
                    ],
                    [
                        121.81330695748,
                        0.52950746066834
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1715,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0013753836052390778,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81480228901,
                        0.52938274327402
                    ],
                    [
                        121.81445360184,
                        0.52971800508102
                    ],
                    [
                        121.81422829628,
                        0.52994330100512
                    ],
                    [
                        121.81408077478,
                        0.53009886247176
                    ],
                    [
                        121.81383937597,
                        0.53034829722906
                    ],
                    [
                        121.8138487637,
                        0.53034159199379
                    ],
                    [
                        121.8138487637,
                        0.53034159199379
                    ],
                    [
                        121.8138487637,
                        0.53034159199379
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1716,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.002242218148449257,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81512415409,
                        0.52976762382692
                    ],
                    [
                        121.81499540806,
                        0.52993257262798
                    ],
                    [
                        121.81486934423,
                        0.53013909388491
                    ],
                    [
                        121.81477412581,
                        0.53030672477021
                    ],
                    [
                        121.81457296014,
                        0.5306540559501
                    ],
                    [
                        121.81446030736,
                        0.53091153696663
                    ],
                    [
                        121.81437179446,
                        0.53113280970664
                    ],
                    [
                        121.81425511837,
                        0.53134067197034
                    ],
                    [
                        121.8141451478,
                        0.53151903119749
                    ],
                    [
                        121.81402310729,
                        0.53171348298062
                    ],
                    [
                        121.81402310729,
                        0.53171348298062
                    ],
                    [
                        121.81402310729,
                        0.53171348298062
                    ],
                    [
                        121.81402310729,
                        0.53171348298062
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1713,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0021424886560830222,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80435782994,
                        0.52726384722433
                    ],
                    [
                        121.80438197139,
                        0.52760455371712
                    ],
                    [
                        121.80437929154,
                        0.52798827377945
                    ],
                    [
                        121.80437929547,
                        0.52813850391347
                    ],
                    [
                        121.80438198474,
                        0.52836924282527
                    ],
                    [
                        121.80439003687,
                        0.52899183003471
                    ],
                    [
                        121.80438735073,
                        0.52930845171578
                    ],
                    [
                        121.80437931589,
                        0.52940505961279
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2172,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0022127114484544485,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81177210049,
                        0.49020189669616
                    ],
                    [
                        121.81151989901,
                        0.49019921294486
                    ],
                    [
                        121.81107988792,
                        0.49019652919358
                    ],
                    [
                        121.81061572988,
                        0.49017505918327
                    ],
                    [
                        121.81028035558,
                        0.49014553791898
                    ],
                    [
                        121.80996376224,
                        0.49014017041635
                    ],
                    [
                        121.80975717167,
                        0.49014285416768
                    ],
                    [
                        121.80962570494,
                        0.49014553791898
                    ],
                    [
                        121.80962570494,
                        0.49020994795
                    ],
                    [
                        121.80962570494,
                        0.49020994795
                    ],
                    [
                        121.80962570494,
                        0.49020994795
                    ],
                    [
                        121.80962570494,
                        0.49020994795
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1717,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.03797743906222255,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82170897722,
                        0.54135694264826
                    ],
                    [
                        121.82154670358,
                        0.54147093144204
                    ],
                    [
                        121.82127311826,
                        0.54135962473755
                    ],
                    [
                        121.82090967894,
                        0.54105788968496
                    ],
                    [
                        121.8202739954,
                        0.54043832699662
                    ],
                    [
                        121.82015061378,
                        0.54033104340779
                    ],
                    [
                        121.82002186775,
                        0.54022644190687
                    ],
                    [
                        121.81986764073,
                        0.54010574786511
                    ],
                    [
                        121.81965574622,
                        0.53994750456228
                    ],
                    [
                        121.81949347258,
                        0.5398335157399
                    ],
                    [
                        121.81931912899,
                        0.53971818587037
                    ],
                    [
                        121.8191434443,
                        0.53958542241319
                    ],
                    [
                        121.81900665164,
                        0.53948350298957
                    ],
                    [
                        121.81888863444,
                        0.53941242760102
                    ],
                    [
                        121.81874647737,
                        0.53932794176073
                    ],
                    [
                        121.81854665279,
                        0.53918713202431
                    ],
                    [
                        121.81833609939,
                        0.53904229914916
                    ],
                    [
                        121.81816846132,
                        0.53894306180679
                    ],
                    [
                        121.81795924902,
                        0.53880359310667
                    ],
                    [
                        121.81743621826,
                        0.53844553402542
                    ],
                    [
                        121.81699633598,
                        0.53814513987362
                    ],
                    [
                        121.81682467461,
                        0.53801639951831
                    ],
                    [
                        121.8167334795,
                        0.53793057261326
                    ],
                    [
                        121.81658327579,
                        0.53766236352722
                    ],
                    [
                        121.8164652586,
                        0.5372815066048
                    ],
                    [
                        121.81640088558,
                        0.53673972418128
                    ],
                    [
                        121.81670665741,
                        0.5364500583114
                    ],
                    [
                        121.81733429432,
                        0.53601019529759
                    ],
                    [
                        121.81777954102,
                        0.53574198612731
                    ],
                    [
                        121.81848227978,
                        0.53538258582073
                    ],
                    [
                        121.81883096695,
                        0.53516801846348
                    ],
                    [
                        121.81906700134,
                        0.5349910003881
                    ],
                    [
                        121.81945323944,
                        0.5346101432995
                    ],
                    [
                        121.81978583336,
                        0.53427756385071
                    ],
                    [
                        121.82005941868,
                        0.53375723790278
                    ],
                    [
                        121.82041883469,
                        0.53292042494576
                    ],
                    [
                        121.82069778442,
                        0.53228745096683
                    ],
                    [
                        121.82109475136,
                        0.53140772431199
                    ],
                    [
                        121.82138442993,
                        0.53077475017794
                    ],
                    [
                        121.8217331171,
                        0.52986820236467
                    ],
                    [
                        121.82200133801,
                        0.52912794428857
                    ],
                    [
                        121.82219445705,
                        0.52873635845896
                    ],
                    [
                        121.82241976261,
                        0.5285056983012
                    ],
                    [
                        121.82291865349,
                        0.5282321246146
                    ],
                    [
                        121.8235462904,
                        0.52808729148155
                    ],
                    [
                        121.82399153709,
                        0.52802828538932
                    ],
                    [
                        121.82432949543,
                        0.52799610024787
                    ],
                    [
                        121.82453870773,
                        0.52788881644185
                    ],
                    [
                        121.82475328445,
                        0.52773325491983
                    ],
                    [
                        121.82542920113,
                        0.52708955202873
                    ],
                    [
                        121.82594954968,
                        0.52656922547647
                    ],
                    [
                        121.8271458149,
                        0.52558757835758
                    ],
                    [
                        121.82766616344,
                        0.52517989972733
                    ],
                    [
                        121.82813286781,
                        0.52476149268444
                    ],
                    [
                        121.82879805565,
                        0.52404269077617
                    ],
                    [
                        121.82939887047,
                        0.52350090719379
                    ],
                    [
                        121.83056294918,
                        0.52238515471828
                    ],
                    [
                        121.83058440685,
                        0.52230469179172
                    ],
                    [
                        121.83049321175,
                        0.52203111783368
                    ],
                    [
                        121.8301820755,
                        0.52126940204469
                    ],
                    [
                        121.82989776134,
                        0.5205827849165
                    ],
                    [
                        121.82951152325,
                        0.51967087142756
                    ],
                    [
                        121.82904481888,
                        0.51860339605856
                    ],
                    [
                        121.82883024216,
                        0.51810988979695
                    ],
                    [
                        121.82837963104,
                        0.51701022896712
                    ],
                    [
                        121.82806313038,
                        0.51617341376897
                    ],
                    [
                        121.8277412653,
                        0.51532587005861
                    ],
                    [
                        121.82761788368,
                        0.5148484561468
                    ],
                    [
                        121.82754948735,
                        0.51452258089994
                    ],
                    [
                        121.82750925422,
                        0.51427582761552
                    ],
                    [
                        121.82737380266,
                        0.51344571731154
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1719,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.008620959769965622,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82766079903,
                        0.50538599779771
                    ],
                    [
                        121.82788074017,
                        0.50489249051925
                    ],
                    [
                        121.82823479176,
                        0.50412004426905
                    ],
                    [
                        121.82857811451,
                        0.50337441898231
                    ],
                    [
                        121.82881951332,
                        0.50288627576279
                    ],
                    [
                        121.82911455631,
                        0.50221038509088
                    ],
                    [
                        121.82944715023,
                        0.50131992584502
                    ],
                    [
                        121.82971000671,
                        0.50043483069151
                    ],
                    [
                        121.82984948158,
                        0.49973748291066
                    ],
                    [
                        121.82998359203,
                        0.49895967183703
                    ],
                    [
                        121.83004260063,
                        0.49849298514867
                    ],
                    [
                        121.83006942272,
                        0.49777418029965
                    ],
                    [
                        121.83008551598,
                        0.49723775871949
                    ],
                    [
                        121.83009088039,
                        0.49726457979952
                    ],
                    [
                        121.83009088039,
                        0.49726457979952
                    ],
                    [
                        121.83009088039,
                        0.49726457979952
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1718,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.008222634558234907,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82764470577,
                        0.50542891147232
                    ],
                    [
                        121.82733893394,
                        0.50635155540799
                    ],
                    [
                        121.82709217072,
                        0.50707572352134
                    ],
                    [
                        121.82700097561,
                        0.50742976123618
                    ],
                    [
                        121.82695269585,
                        0.50776770630952
                    ],
                    [
                        121.8269097805,
                        0.50810565136521
                    ],
                    [
                        121.8268507719,
                        0.50863670784557
                    ],
                    [
                        121.82686150074,
                        0.5090819369823
                    ],
                    [
                        121.8269097805,
                        0.50976319114406
                    ],
                    [
                        121.82698488235,
                        0.51072338389531
                    ],
                    [
                        121.82707607746,
                        0.51140463788324
                    ],
                    [
                        121.82721018791,
                        0.51231655255707
                    ],
                    [
                        121.82734429836,
                        0.51311045463802
                    ],
                    [
                        121.82737112045,
                        0.51345912781812
                    ],
                    [
                        121.82737112045,
                        0.51341084999431
                    ],
                    [
                        121.82737112045,
                        0.51341084999431
                    ],
                    [
                        121.82737112045,
                        0.51341084999431
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1720,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0081038110043718,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82764201807,
                        0.50542893771923
                    ],
                    [
                        121.82788074017,
                        0.50489249051925
                    ],
                    [
                        121.82823479176,
                        0.50412004426905
                    ],
                    [
                        121.82857811451,
                        0.50337441898231
                    ],
                    [
                        121.82881951332,
                        0.50288627576279
                    ],
                    [
                        121.82911455631,
                        0.50221038509088
                    ],
                    [
                        121.82944715023,
                        0.50131992584502
                    ],
                    [
                        121.82971000671,
                        0.50043483069151
                    ],
                    [
                        121.82984948158,
                        0.49973748291066
                    ],
                    [
                        121.82998359203,
                        0.49895967183703
                    ],
                    [
                        121.83004260063,
                        0.49849298514867
                    ],
                    [
                        121.83006942272,
                        0.49777418029965
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1721,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.011619476551469696,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83007210493,
                        0.49722703028743
                    ],
                    [
                        121.83003723621,
                        0.496907859426
                    ],
                    [
                        121.82998090982,
                        0.49665574125568
                    ],
                    [
                        121.82990580797,
                        0.49642239783414
                    ],
                    [
                        121.82976096869,
                        0.49592888988101
                    ],
                    [
                        121.82965368032,
                        0.49555875889201
                    ],
                    [
                        121.8294686079,
                        0.49500892658757
                    ],
                    [
                        121.82935059071,
                        0.49459319969298
                    ],
                    [
                        121.82926476002,
                        0.49421770441096
                    ],
                    [
                        121.82916283607,
                        0.49373492473145
                    ],
                    [
                        121.82907700539,
                        0.49330578720915
                    ],
                    [
                        121.82897239923,
                        0.49293565607391
                    ],
                    [
                        121.82880878448,
                        0.49242605520189
                    ],
                    [
                        121.82865321636,
                        0.49190304374012
                    ],
                    [
                        121.82857006788,
                        0.4915731441816
                    ],
                    [
                        121.8284279108,
                        0.4910876822
                    ],
                    [
                        121.82831525803,
                        0.49068000139264
                    ],
                    [
                        121.82722895945,
                        0.48597150445028
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1722,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0021892424853000186,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82990044355,
                        0.49639825885904
                    ],
                    [
                        121.830689013,
                        0.4964331262675
                    ],
                    [
                        121.83113962412,
                        0.49645994735081
                    ],
                    [
                        121.83158755302,
                        0.49653236427521
                    ],
                    [
                        121.83207571507,
                        0.49661282752359
                    ],
                    [
                        121.83207571507,
                        0.49661282752359
                    ],
                    [
                        121.83207571507,
                        0.49661282752359
                    ],
                    [
                        121.83207571507,
                        0.49661282752359
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2171,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0056739313780690545,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81177004897,
                        0.49020255122963
                    ],
                    [
                        121.81184781732,
                        0.49121262917737
                    ],
                    [
                        121.81187464727,
                        0.49165276430677
                    ],
                    [
                        121.81193367314,
                        0.49220024942721
                    ],
                    [
                        121.81199806501,
                        0.49279604200725
                    ],
                    [
                        121.81212148275,
                        0.49391248201365
                    ],
                    [
                        121.81215904468,
                        0.49427210447579
                    ],
                    [
                        121.81226636445,
                        0.4951470068024
                    ],
                    [
                        121.81235758626,
                        0.49584478158131
                    ],
                    [
                        121.81235758626,
                        0.49584478158131
                    ],
                    [
                        121.81235758626,
                        0.49584478158131
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1724,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.006082325735069985,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83056160808,
                        0.52239454205965
                    ],
                    [
                        121.83065548539,
                        0.52255680895819
                    ],
                    [
                        121.83078825474,
                        0.52286525015874
                    ],
                    [
                        121.83094382286,
                        0.52322062804491
                    ],
                    [
                        121.83117717505,
                        0.523735590682
                    ],
                    [
                        121.83128982782,
                        0.52396356891929
                    ],
                    [
                        121.83151379228,
                        0.52446243891545
                    ],
                    [
                        121.8321454525,
                        0.52585578796824
                    ],
                    [
                        121.8324136734,
                        0.52649949098677
                    ],
                    [
                        121.83274626732,
                        0.52725584194864
                    ],
                    [
                        121.83306276798,
                        0.52793709415478
                    ],
                    [
                        121.83306276798,
                        0.52793709415478
                    ],
                    [
                        121.83306276798,
                        0.52793709415478
                    ],
                    [
                        121.83306276798,
                        0.52793709415478
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1725,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.024917394503807432,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81649208069,
                        0.53663780471011
                    ],
                    [
                        121.81647598743,
                        0.53648224340874
                    ],
                    [
                        121.81704461575,
                        0.53610138641281
                    ],
                    [
                        121.81756496429,
                        0.53579026377883
                    ],
                    [
                        121.8179833889,
                        0.53553278296634
                    ],
                    [
                        121.818369627,
                        0.53536112908534
                    ],
                    [
                        121.81866466999,
                        0.53517338264751
                    ],
                    [
                        121.81913137436,
                        0.53479788975458
                    ],
                    [
                        121.81951224804,
                        0.53440094009994
                    ],
                    [
                        121.81971073151,
                        0.53414882341409
                    ],
                    [
                        121.81996822357,
                        0.53375723790278
                    ],
                    [
                        121.82029545307,
                        0.53300088773502
                    ],
                    [
                        121.82060658932,
                        0.5322981793399
                    ],
                    [
                        121.82106792927,
                        0.53125216287826
                    ],
                    [
                        121.82149171829,
                        0.53018468948616
                    ],
                    [
                        121.82173848152,
                        0.52954098684918
                    ],
                    [
                        121.82197988033,
                        0.52889191995588
                    ],
                    [
                        121.82215690613,
                        0.52860225371712
                    ],
                    [
                        121.82237148285,
                        0.52839841450398
                    ],
                    [
                        121.82262897491,
                        0.5282428529947
                    ],
                    [
                        121.82287573814,
                        0.52815166176333
                    ],
                    [
                        121.82327270508,
                        0.52804437795998
                    ],
                    [
                        121.82359993458,
                        0.52799073605761
                    ],
                    [
                        121.82407736778,
                        0.52793709415478
                    ],
                    [
                        121.82428121567,
                        0.52791563739353
                    ],
                    [
                        121.82443678379,
                        0.52782444615735
                    ],
                    [
                        121.82463526726,
                        0.52768497720529
                    ],
                    [
                        121.82487666607,
                        0.52747040958066
                    ],
                    [
                        121.82535946369,
                        0.52701445335376
                    ],
                    [
                        121.82584762573,
                        0.52654776871049
                    ],
                    [
                        121.82628750801,
                        0.52615081852665
                    ],
                    [
                        121.82684540749,
                        0.52569486220322
                    ],
                    [
                        121.82736575603,
                        0.52529254777256
                    ],
                    [
                        121.82781636715,
                        0.52490096170184
                    ],
                    [
                        121.82830989361,
                        0.52437527077384
                    ],
                    [
                        121.82866930962,
                        0.52401050561417
                    ],
                    [
                        121.82902872562,
                        0.5236671972092
                    ],
                    [
                        121.82933986187,
                        0.52339362331053
                    ],
                    [
                        121.8297368288,
                        0.52302885809374
                    ],
                    [
                        121.83006942272,
                        0.52271237060905
                    ],
                    [
                        121.83039665222,
                        0.5224280682787
                    ],
                    [
                        121.83046638966,
                        0.52231542018198
                    ],
                    [
                        121.83044493198,
                        0.52218667949754
                    ],
                    [
                        121.83011770248,
                        0.52132304400469
                    ],
                    [
                        121.82983875275,
                        0.5206900688477
                    ],
                    [
                        121.8295866251,
                        0.52009464300645
                    ],
                    [
                        121.82895898819,
                        0.5186194886534
                    ],
                    [
                        121.82896435261,
                        0.5186355812482
                    ],
                    [
                        121.82896435261,
                        0.5186355812482
                    ],
                    [
                        121.82896435261,
                        0.5186355812482
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1726,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0024151323144195186,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82103306055,
                        0.5313084868461
                    ],
                    [
                        121.82073801756,
                        0.53109928353441
                    ],
                    [
                        121.82035982609,
                        0.53085521299518
                    ],
                    [
                        121.82004868984,
                        0.53070501573548
                    ],
                    [
                        121.81949615479,
                        0.53045558099254
                    ],
                    [
                        121.81892216206,
                        0.5301471401675
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1728,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.001216640462662402,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81363150477,
                        0.52764876891918
                    ],
                    [
                        121.81376695633,
                        0.52751868729685
                    ],
                    [
                        121.81386619806,
                        0.52745163491317
                    ],
                    [
                        121.8139359355,
                        0.52745968119924
                    ],
                    [
                        121.81397885084,
                        0.52748918424812
                    ],
                    [
                        121.81405931711,
                        0.5275750112986
                    ],
                    [
                        121.81426852942,
                        0.52777080425309
                    ],
                    [
                        121.81452333927,
                        0.52798805396249
                    ],
                    [
                        121.81455284357,
                        0.5280256032942
                    ],
                    [
                        121.81455284357,
                        0.5280256032942
                    ],
                    [
                        121.81455284357,
                        0.5280256032942
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1727,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0024151323144195186,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82103306055,
                        0.5313084868461
                    ],
                    [
                        121.82073801756,
                        0.53109928353441
                    ],
                    [
                        121.82035982609,
                        0.53085521299518
                    ],
                    [
                        121.82004868984,
                        0.53070501573548
                    ],
                    [
                        121.81949615479,
                        0.53045558099254
                    ],
                    [
                        121.81892216206,
                        0.5301471401675
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1729,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0071124841300062745,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81313663721,
                        0.52720220003948
                    ],
                    [
                        121.81318759918,
                        0.52704663850029
                    ],
                    [
                        121.81320369244,
                        0.52690851057862
                    ],
                    [
                        121.81321576238,
                        0.52677574684519
                    ],
                    [
                        121.81324794888,
                        0.52643243859211
                    ],
                    [
                        121.81325733662,
                        0.52626480760229
                    ],
                    [
                        121.81326806545,
                        0.5260542630727
                    ],
                    [
                        121.81327477098,
                        0.52586249320836
                    ],
                    [
                        121.8132814765,
                        0.52560367093455
                    ],
                    [
                        121.81328549981,
                        0.52548431765441
                    ],
                    [
                        121.81329086423,
                        0.52523085955756
                    ],
                    [
                        121.81330561638,
                        0.5250618874873
                    ],
                    [
                        121.8133109808,
                        0.52483122719353
                    ],
                    [
                        121.81331634521,
                        0.52464348043651
                    ],
                    [
                        121.8133404851,
                        0.52431760569486
                    ],
                    [
                        121.81336194277,
                        0.52409499166407
                    ],
                    [
                        121.81339949369,
                        0.52366585616071
                    ],
                    [
                        121.81343570352,
                        0.52323806167655
                    ],
                    [
                        121.81346654892,
                        0.52286927330473
                    ],
                    [
                        121.81349605322,
                        0.52266409285575
                    ],
                    [
                        121.81360602379,
                        0.52193992651169
                    ],
                    [
                        121.81361541152,
                        0.52184739413949
                    ],
                    [
                        121.81367307901,
                        0.5214142353356
                    ],
                    [
                        121.81389570236,
                        0.52014292077946
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1730,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.00016684543352351553,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81389436126,
                        0.52014157973021
                    ],
                    [
                        121.81385681033,
                        0.52008793776018
                    ],
                    [
                        121.81376025081,
                        0.52005709362719
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2176,
                "jenis_pipa": "Pipa 40",
                "keterangan": "Distribusi",
                "panjang": 0.003883384748031619,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81369533781,
                        0.52004843873311
                    ],
                    [
                        121.81323922876,
                        0.5199491403909
                    ],
                    [
                        121.81257652913,
                        0.51982837213476
                    ],
                    [
                        121.81188699957,
                        0.51970760387631
                    ],
                    [
                        121.81125381288,
                        0.51961098926787
                    ],
                    [
                        121.81068233506,
                        0.51953584457141
                    ],
                    [
                        121.80986402176,
                        0.51942312752504
                    ],
                    [
                        121.80986402176,
                        0.51942312752504
                    ],
                    [
                        121.80986402176,
                        0.51942312752504
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1737,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.004055005999655297,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81178480387,
                        0.49155705151979
                    ],
                    [
                        121.81176066399,
                        0.49122446983374
                    ],
                    [
                        121.81174725294,
                        0.49103403998993
                    ],
                    [
                        121.81173115969,
                        0.49074168993745
                    ],
                    [
                        121.81172847748,
                        0.49036083021691
                    ],
                    [
                        121.81172579527,
                        0.49027232056042
                    ],
                    [
                        121.81170165539,
                        0.49026427422797
                    ],
                    [
                        121.81163460016,
                        0.49026427422797
                    ],
                    [
                        121.81091040373,
                        0.49024013523052
                    ],
                    [
                        121.81012988091,
                        0.4901945393462
                    ],
                    [
                        121.80972218513,
                        0.4902052677896
                    ],
                    [
                        121.80953711271,
                        0.4901891751245
                    ],
                    [
                        121.80937886238,
                        0.49011407602019
                    ],
                    [
                        121.80925548077,
                        0.48996655991999
                    ],
                    [
                        121.8091455102,
                        0.48978954059546
                    ],
                    [
                        121.8091455102,
                        0.48978954059546
                    ],
                    [
                        121.8091455102,
                        0.48978954059546
                    ],
                    [
                        121.8091455102,
                        0.48978954059546
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1732,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0020147899948714746,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81179821491,
                        0.49219002952166
                    ],
                    [
                        121.81069850922,
                        0.49215784420098
                    ],
                    [
                        121.80978655815,
                        0.49208810933898
                    ],
                    [
                        121.80978655815,
                        0.49208810933898
                    ],
                    [
                        121.80978655815,
                        0.49208810933898
                    ],
                    [
                        121.80978655815,
                        0.49208810933898
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1733,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0010609214031456148,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81177675724,
                        0.49172602446685
                    ],
                    [
                        121.81121885777,
                        0.49171261391565
                    ],
                    [
                        121.81073337793,
                        0.49168042859267
                    ],
                    [
                        121.81074947119,
                        0.4916777464824
                    ],
                    [
                        121.81074947119,
                        0.4916777464824
                    ],
                    [
                        121.81074947119,
                        0.4916777464824
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1734,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0019733782353436426,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80978119373,
                        0.49208542722889
                    ],
                    [
                        121.80972486734,
                        0.49208274511878
                    ],
                    [
                        121.80970877409,
                        0.49243410153177
                    ],
                    [
                        121.80967122316,
                        0.49282568957326
                    ],
                    [
                        121.80963367224,
                        0.4931099932054
                    ],
                    [
                        121.80964440107,
                        0.4931314500828
                    ],
                    [
                        121.80974364281,
                        0.49313681430214
                    ],
                    [
                        121.81000649929,
                        0.49314217852147
                    ],
                    [
                        121.81050270796,
                        0.49319313860495
                    ],
                    [
                        121.81050270796,
                        0.49319313860495
                    ],
                    [
                        121.81050270796,
                        0.49319313860495
                    ],
                    [
                        121.81050270796,
                        0.49319313860495
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1735,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0018567118304391869,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81174457073,
                        0.49122446983374
                    ],
                    [
                        121.81081652641,
                        0.49123519827549
                    ],
                    [
                        121.80989384651,
                        0.49120301295021
                    ],
                    [
                        121.80989921093,
                        0.49120301295021
                    ],
                    [
                        121.80989921093,
                        0.49120301295021
                    ],
                    [
                        121.80989921093,
                        0.49120301295021
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1736,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00188932296851424,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81170701981,
                        0.49071755094173
                    ],
                    [
                        121.8114066124,
                        0.49071486883107
                    ],
                    [
                        121.81089431047,
                        0.4907095046098
                    ],
                    [
                        121.81070119143,
                        0.49069609405656
                    ],
                    [
                        121.8100386858,
                        0.49066927294999
                    ],
                    [
                        121.80981874466,
                        0.49066927294999
                    ],
                    [
                        121.80981874466,
                        0.49066927294999
                    ],
                    [
                        121.80981874466,
                        0.49066927294999
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1738,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0007744457721839429,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81325867772,
                        0.52720085899174
                    ],
                    [
                        121.81325465441,
                        0.52708016469441
                    ],
                    [
                        121.81327208877,
                        0.52689510010062
                    ],
                    [
                        121.8132828176,
                        0.52662286739108
                    ],
                    [
                        121.81329488754,
                        0.526496808891
                    ],
                    [
                        121.81330159307,
                        0.52642841544841
                    ],
                    [
                        121.81330159307,
                        0.52642841544841
                    ],
                    [
                        121.81330159307,
                        0.52642841544841
                    ],
                    [
                        121.81330159307,
                        0.52642841544841
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1740,
                "jenis_pipa": "Pipa 150",
                "keterangan": "TRANSMISI",
                "panjang": 0.000463622390575393,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82464599609,
                        0.54168549857748
                    ],
                    [
                        121.82476937771,
                        0.54177400751862
                    ],
                    [
                        121.8248552084,
                        0.54168818066662
                    ],
                    [
                        121.82495713234,
                        0.54157016874312
                    ],
                    [
                        121.82498797774,
                        0.5415822381445
                    ],
                    [
                        121.82498797774,
                        0.54158089709991
                    ],
                    [
                        121.82498797774,
                        0.54158089709991
                    ],
                    [
                        121.82498797774,
                        0.54158089709991
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1741,
                "jenis_pipa": "Pipa 150",
                "keterangan": "TRANSMISI",
                "panjang": 0.000463622390575393,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82464599609,
                        0.54168549857748
                    ],
                    [
                        121.82476937771,
                        0.54177400751862
                    ],
                    [
                        121.8248552084,
                        0.54168818066662
                    ],
                    [
                        121.82495713234,
                        0.54157016874312
                    ],
                    [
                        121.82498797774,
                        0.5415822381445
                    ],
                    [
                        121.82498797774,
                        0.54158089709991
                    ],
                    [
                        121.82498797774,
                        0.54158089709991
                    ],
                    [
                        121.82498797774,
                        0.54158089709991
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1742,
                "jenis_pipa": "Pipa 100 Plan",
                "keterangan": "Distribusi",
                "panjang": 0.004895630278088603,
                "total_panjang_jenis": 0.01468689083426581
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82482436299,
                        0.54174852767207
                    ],
                    [
                        121.82511806488,
                        0.54144142846034
                    ],
                    [
                        121.82495445013,
                        0.54125368220968
                    ],
                    [
                        121.82475328445,
                        0.54099620162792
                    ],
                    [
                        121.82466208935,
                        0.5408929411832
                    ],
                    [
                        121.82460844517,
                        0.54077895237854
                    ],
                    [
                        121.82448238134,
                        0.54062205013806
                    ],
                    [
                        121.82439386845,
                        0.54051610759732
                    ],
                    [
                        121.82425707579,
                        0.54033908967702
                    ],
                    [
                        121.82413503528,
                        0.54018218742518
                    ],
                    [
                        121.82400628924,
                        0.54007892696661
                    ],
                    [
                        121.82392582297,
                        0.54003869561865
                    ],
                    [
                        121.82387620211,
                        0.54003735457372
                    ],
                    [
                        121.82382792234,
                        0.54003199039397
                    ],
                    [
                        121.82374879718,
                        0.54005478815786
                    ],
                    [
                        121.82365223765,
                        0.54008965532603
                    ],
                    [
                        121.82343497872,
                        0.54019425682932
                    ],
                    [
                        121.82326197624,
                        0.54027740161268
                    ],
                    [
                        121.82303532958,
                        0.54037663893327
                    ],
                    [
                        121.8228341639,
                        0.54047721729709
                    ],
                    [
                        121.82268664241,
                        0.54056036207659
                    ],
                    [
                        121.82250291109,
                        0.5407145822291
                    ],
                    [
                        121.82229101658,
                        0.54088221282521
                    ],
                    [
                        121.82213410735,
                        0.54100558894098
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1743,
                "jenis_pipa": "Pipa 100 Plan",
                "keterangan": "Distribusi",
                "panjang": 0.004895630278088603,
                "total_panjang_jenis": 0.01468689083426581
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82482436299,
                        0.54174852767207
                    ],
                    [
                        121.82511806488,
                        0.54144142846034
                    ],
                    [
                        121.82495445013,
                        0.54125368220968
                    ],
                    [
                        121.82475328445,
                        0.54099620162792
                    ],
                    [
                        121.82466208935,
                        0.5408929411832
                    ],
                    [
                        121.82460844517,
                        0.54077895237854
                    ],
                    [
                        121.82448238134,
                        0.54062205013806
                    ],
                    [
                        121.82439386845,
                        0.54051610759732
                    ],
                    [
                        121.82425707579,
                        0.54033908967702
                    ],
                    [
                        121.82413503528,
                        0.54018218742518
                    ],
                    [
                        121.82400628924,
                        0.54007892696661
                    ],
                    [
                        121.82392582297,
                        0.54003869561865
                    ],
                    [
                        121.82387620211,
                        0.54003735457372
                    ],
                    [
                        121.82382792234,
                        0.54003199039397
                    ],
                    [
                        121.82374879718,
                        0.54005478815786
                    ],
                    [
                        121.82365223765,
                        0.54008965532603
                    ],
                    [
                        121.82343497872,
                        0.54019425682932
                    ],
                    [
                        121.82326197624,
                        0.54027740161268
                    ],
                    [
                        121.82303532958,
                        0.54037663893327
                    ],
                    [
                        121.8228341639,
                        0.54047721729709
                    ],
                    [
                        121.82268664241,
                        0.54056036207659
                    ],
                    [
                        121.82250291109,
                        0.5407145822291
                    ],
                    [
                        121.82229101658,
                        0.54088221282521
                    ],
                    [
                        121.82213410735,
                        0.54100558894098
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1744,
                "jenis_pipa": "Pipa 100 Plan",
                "keterangan": "Distribusi",
                "panjang": 0.004895630278088603,
                "total_panjang_jenis": 0.01468689083426581
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82482436299,
                        0.54174852767207
                    ],
                    [
                        121.82511806488,
                        0.54144142846034
                    ],
                    [
                        121.82495445013,
                        0.54125368220968
                    ],
                    [
                        121.82475328445,
                        0.54099620162792
                    ],
                    [
                        121.82466208935,
                        0.5408929411832
                    ],
                    [
                        121.82460844517,
                        0.54077895237854
                    ],
                    [
                        121.82448238134,
                        0.54062205013806
                    ],
                    [
                        121.82439386845,
                        0.54051610759732
                    ],
                    [
                        121.82425707579,
                        0.54033908967702
                    ],
                    [
                        121.82413503528,
                        0.54018218742518
                    ],
                    [
                        121.82400628924,
                        0.54007892696661
                    ],
                    [
                        121.82392582297,
                        0.54003869561865
                    ],
                    [
                        121.82387620211,
                        0.54003735457372
                    ],
                    [
                        121.82382792234,
                        0.54003199039397
                    ],
                    [
                        121.82374879718,
                        0.54005478815786
                    ],
                    [
                        121.82365223765,
                        0.54008965532603
                    ],
                    [
                        121.82343497872,
                        0.54019425682932
                    ],
                    [
                        121.82326197624,
                        0.54027740161268
                    ],
                    [
                        121.82303532958,
                        0.54037663893327
                    ],
                    [
                        121.8228341639,
                        0.54047721729709
                    ],
                    [
                        121.82268664241,
                        0.54056036207659
                    ],
                    [
                        121.82250291109,
                        0.5407145822291
                    ],
                    [
                        121.82229101658,
                        0.54088221282521
                    ],
                    [
                        121.82213410735,
                        0.54100558894098
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ],
                    [
                        121.82171300054,
                        0.54135426055895
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1745,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.004911805876617401,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82171434164,
                        0.54135023742502
                    ],
                    [
                        121.82189941406,
                        0.5412000404227
                    ],
                    [
                        121.82212203741,
                        0.54102034043293
                    ],
                    [
                        121.82229906321,
                        0.54086746133294
                    ],
                    [
                        121.82250022888,
                        0.54071190013952
                    ],
                    [
                        121.82270407677,
                        0.5405670673007
                    ],
                    [
                        121.82306349277,
                        0.54034981803598
                    ],
                    [
                        121.82329952717,
                        0.54023717026602
                    ],
                    [
                        121.8235167861,
                        0.54014597921263
                    ],
                    [
                        121.82366967201,
                        0.5400735627869
                    ],
                    [
                        121.82380378246,
                        0.54002260307939
                    ],
                    [
                        121.82391107082,
                        0.54003064934904
                    ],
                    [
                        121.82402640581,
                        0.54006819860719
                    ],
                    [
                        121.82419270277,
                        0.54021839563749
                    ],
                    [
                        121.82435631752,
                        0.54044369117601
                    ],
                    [
                        121.82479888201,
                        0.54098547327011
                    ],
                    [
                        121.82511940598,
                        0.54136901205005
                    ],
                    [
                        121.82478278875,
                        0.54172304782539
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1746,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.00491174266353604,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82171836495,
                        0.54137169413934
                    ],
                    [
                        121.82182833552,
                        0.54128050310298
                    ],
                    [
                        121.82195574045,
                        0.54117053743969
                    ],
                    [
                        121.82205095887,
                        0.54109543893677
                    ],
                    [
                        121.82214215398,
                        0.54102034043293
                    ],
                    [
                        121.82225346565,
                        0.54093049043603
                    ],
                    [
                        121.82236611843,
                        0.54083795834829
                    ],
                    [
                        121.8225042522,
                        0.54072799267696
                    ],
                    [
                        121.8226531148,
                        0.54061400386921
                    ],
                    [
                        121.82286903262,
                        0.54047989938677
                    ],
                    [
                        121.82307556272,
                        0.54034981803598
                    ],
                    [
                        121.82324320078,
                        0.54027203743313
                    ],
                    [
                        121.82337999344,
                        0.54021437250281
                    ],
                    [
                        121.82367637753,
                        0.5400829501014
                    ],
                    [
                        121.82377025485,
                        0.54005210606801
                    ],
                    [
                        121.82381182909,
                        0.54003735457372
                    ],
                    [
                        121.82386279106,
                        0.54003735457372
                    ],
                    [
                        121.8239043653,
                        0.54004271875346
                    ],
                    [
                        121.82398214936,
                        0.54006283442746
                    ],
                    [
                        121.82404115796,
                        0.54009099637094
                    ],
                    [
                        121.82414576411,
                        0.54019023369459
                    ],
                    [
                        121.82449713349,
                        0.54063277849652
                    ],
                    [
                        121.82473182678,
                        0.5409264673018
                    ],
                    [
                        121.82494238019,
                        0.54117992475248
                    ],
                    [
                        121.8251247704,
                        0.54138644563039
                    ],
                    [
                        121.82486191392,
                        0.54165197246307
                    ],
                    [
                        121.82478681207,
                        0.54172841200365
                    ],
                    [
                        121.82478681207,
                        0.54172841200365
                    ],
                    [
                        121.82478681207,
                        0.54172841200365
                    ],
                    [
                        121.82478681207,
                        0.54172841200365
                    ],
                    [
                        121.82478681207,
                        0.54172841200365
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1747,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.051965120261039346,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82487800717,
                        0.54191079406151
                    ],
                    [
                        121.82518780231,
                        0.54216827460441
                    ],
                    [
                        121.82524010539,
                        0.54220984698272
                    ],
                    [
                        121.82538628578,
                        0.54207440149109
                    ],
                    [
                        121.8255391717,
                        0.54188531421552
                    ],
                    [
                        121.82556867599,
                        0.54184240079046
                    ],
                    [
                        121.8255713582,
                        0.54183301347868
                    ],
                    [
                        121.82568266988,
                        0.54189201943816
                    ],
                    [
                        121.82579800487,
                        0.54196845897571
                    ],
                    [
                        121.82597771287,
                        0.54207037835762
                    ],
                    [
                        121.82615339756,
                        0.54217229773781
                    ],
                    [
                        121.82642832398,
                        0.54232383576045
                    ],
                    [
                        121.82654902339,
                        0.54239222902607
                    ],
                    [
                        121.82665228844,
                        0.54244721184689
                    ],
                    [
                        121.82668447495,
                        0.54245123498009
                    ],
                    [
                        121.82671934366,
                        0.54244452975807
                    ],
                    [
                        121.82677298784,
                        0.54243111931402
                    ],
                    [
                        121.82681456208,
                        0.54239222902607
                    ],
                    [
                        121.82685479522,
                        0.54232517680488
                    ],
                    [
                        121.82689502835,
                        0.54225276040518
                    ],
                    [
                        121.82696074247,
                        0.54212938431478
                    ],
                    [
                        121.82704389095,
                        0.54196175375316
                    ],
                    [
                        121.82715252042,
                        0.54175523289485
                    ],
                    [
                        121.8272665143,
                        0.54155005307412
                    ],
                    [
                        121.82736843824,
                        0.54136096578219
                    ],
                    [
                        121.82744756341,
                        0.54119735833336
                    ],
                    [
                        121.82756692171,
                        0.5409331725255
                    ],
                    [
                        121.82762727141,
                        0.54079638596057
                    ],
                    [
                        121.82770907879,
                        0.54061936804845
                    ],
                    [
                        121.82780966163,
                        0.54041284714445
                    ],
                    [
                        121.82786464691,
                        0.54030288146542
                    ],
                    [
                        121.82797864079,
                        0.54006417547239
                    ],
                    [
                        121.82809531689,
                        0.53984558514473
                    ],
                    [
                        121.82823210955,
                        0.53957603509794
                    ],
                    [
                        121.82832866907,
                        0.53937353729373
                    ],
                    [
                        121.82844936848,
                        0.53909728200031
                    ],
                    [
                        121.82854056358,
                        0.53889612522539
                    ],
                    [
                        121.82866796851,
                        0.53861852886506
                    ],
                    [
                        121.8287524581,
                        0.53844016984427
                    ],
                    [
                        121.82884767652,
                        0.53824437722898
                    ],
                    [
                        121.82896971703,
                        0.53804322042589
                    ],
                    [
                        121.82909578085,
                        0.53783535838907
                    ],
                    [
                        121.82918027043,
                        0.53770930011812
                    ],
                    [
                        121.82923793793,
                        0.5376301784361
                    ],
                    [
                        121.82930499315,
                        0.53755373884402
                    ],
                    [
                        121.82939484715,
                        0.53745316043192
                    ],
                    [
                        121.82948336005,
                        0.53737806188315
                    ],
                    [
                        121.82967916131,
                        0.53723188791949
                    ],
                    [
                        121.82981729507,
                        0.53713667368441
                    ],
                    [
                        121.82997018099,
                        0.53704280049343
                    ],
                    [
                        121.83008953929,
                        0.5369677019396
                    ],
                    [
                        121.83040201664,
                        0.53676520404882
                    ],
                    [
                        121.83054685593,
                        0.5366726718978
                    ],
                    [
                        121.83069705963,
                        0.5365841628825
                    ],
                    [
                        121.83105647564,
                        0.53634009256091
                    ],
                    [
                        121.83129385114,
                        0.53617648497726
                    ],
                    [
                        121.83155938983,
                        0.53598203333525
                    ],
                    [
                        121.83183297515,
                        0.53578758168708
                    ],
                    [
                        121.83209717274,
                        0.53562933827229
                    ],
                    [
                        121.83230504394,
                        0.53550327995588
                    ],
                    [
                        121.83258131146,
                        0.53532760293616
                    ],
                    [
                        121.83280527592,
                        0.53518545206155
                    ],
                    [
                        121.83296084404,
                        0.53509426093269
                    ],
                    [
                        121.83310970664,
                        0.5350164802629
                    ],
                    [
                        121.83329343796,
                        0.53490517344061
                    ],
                    [
                        121.83346778154,
                        0.53481398230761
                    ],
                    [
                        121.83369711041,
                        0.53467853665166
                    ],
                    [
                        121.83383256197,
                        0.53459270969982
                    ],
                    [
                        121.83398813009,
                        0.53446933345443
                    ],
                    [
                        121.83418795466,
                        0.53431779523661
                    ],
                    [
                        121.83446422219,
                        0.53407640691731
                    ],
                    [
                        121.83469489217,
                        0.53388195520874
                    ],
                    [
                        121.8348222971,
                        0.53376260208804
                    ],
                    [
                        121.83493360877,
                        0.53367543407706
                    ],
                    [
                        121.83525547385,
                        0.53339917852644
                    ],
                    [
                        121.83541372418,
                        0.53325836865363
                    ],
                    [
                        121.83571279049,
                        0.53299820564207
                    ],
                    [
                        121.83595016599,
                        0.53277022773631
                    ],
                    [
                        121.83609500527,
                        0.53261868947662
                    ],
                    [
                        121.83634847403,
                        0.53230622561968
                    ],
                    [
                        121.83658853173,
                        0.53198035127992
                    ],
                    [
                        121.83693185449,
                        0.53153780585269
                    ],
                    [
                        121.83711960912,
                        0.53130312265871
                    ],
                    [
                        121.83722421527,
                        0.53120254414428
                    ],
                    [
                        121.83725908399,
                        0.5311770642537
                    ],
                    [
                        121.83730736375,
                        0.53114622017548
                    ],
                    [
                        121.83735698462,
                        0.53116901797245
                    ],
                    [
                        121.83742806315,
                        0.53120120309742
                    ],
                    [
                        121.83747768402,
                        0.53123204717535
                    ],
                    [
                        121.83762386441,
                        0.5313232383614
                    ],
                    [
                        121.83810263872,
                        0.531630338081
                    ],
                    [
                        121.83836147189,
                        0.53180065101936
                    ],
                    [
                        121.83879196644,
                        0.53209568129514
                    ],
                    [
                        121.83926403522,
                        0.53237864213729
                    ],
                    [
                        121.83945581317,
                        0.53248190272575
                    ],
                    [
                        121.83984071016,
                        0.53271926796797
                    ],
                    [
                        121.84021085501,
                        0.53293919959667
                    ],
                    [
                        121.84033557773,
                        0.53302100343218
                    ],
                    [
                        121.84049919248,
                        0.53311487668469
                    ],
                    [
                        121.84067085385,
                        0.53321411412151
                    ],
                    [
                        121.84103563428,
                        0.53341527108313
                    ],
                    [
                        121.84123814106,
                        0.53354803467419
                    ],
                    [
                        121.84142321348,
                        0.53365531838204
                    ],
                    [
                        121.84171557426,
                        0.53382965440332
                    ],
                    [
                        121.84186041355,
                        0.53389938881046
                    ],
                    [
                        121.84198647738,
                        0.53394632543019
                    ],
                    [
                        121.842084378,
                        0.53394632543019
                    ],
                    [
                        121.84215545654,
                        0.53393425601371
                    ],
                    [
                        121.84228822589,
                        0.53387793206989
                    ],
                    [
                        121.84250816703,
                        0.53378539987532
                    ],
                    [
                        121.84266507626,
                        0.53373041697643
                    ],
                    [
                        121.84276565909,
                        0.53368348035505
                    ],
                    [
                        121.84288904071,
                        0.53363520268697
                    ],
                    [
                        121.84302315116,
                        0.53359631234295
                    ],
                    [
                        121.84311300516,
                        0.53357619664769
                    ],
                    [
                        121.84322297573,
                        0.53358826606486
                    ],
                    [
                        121.84346571565,
                        0.53362849745527
                    ],
                    [
                        121.84361726046,
                        0.53365129524303
                    ],
                    [
                        121.84378758073,
                        0.53366738779907
                    ],
                    [
                        121.84392571449,
                        0.53367543407706
                    ],
                    [
                        121.84435352683,
                        0.5337103012816
                    ],
                    [
                        121.84475719929,
                        0.53374516848593
                    ],
                    [
                        121.84489265084,
                        0.53375455581015
                    ],
                    [
                        121.84503480792,
                        0.53379612824577
                    ],
                    [
                        121.84517294168,
                        0.53384842905147
                    ],
                    [
                        121.84525072575,
                        0.53388061416245
                    ],
                    [
                        121.84541165829,
                        0.53394900752273
                    ],
                    [
                        121.84553906322,
                        0.53399460309582
                    ],
                    [
                        121.84568122029,
                        0.53401874192851
                    ],
                    [
                        121.8458609283,
                        0.53403751657607
                    ],
                    [
                        121.8461304903,
                        0.53406165540859
                    ],
                    [
                        121.84628337622,
                        0.53406299645484
                    ],
                    [
                        121.84665620327,
                        0.53408445319476
                    ],
                    [
                        121.84682115912,
                        0.53408981737973
                    ],
                    [
                        121.84713631868,
                        0.53409786365718
                    ],
                    [
                        121.84745416045,
                        0.53412066144321
                    ],
                    [
                        121.84762582183,
                        0.53413675399802
                    ],
                    [
                        121.84775322676,
                        0.53413675399802
                    ],
                    [
                        121.84782966971,
                        0.53412200248945
                    ],
                    [
                        121.84784710407,
                        0.53410322784213
                    ],
                    [
                        121.84788331389,
                        0.53406836063982
                    ],
                    [
                        121.84794232249,
                        0.53394230229136
                    ],
                    [
                        121.84799328446,
                        0.53380149243099
                    ],
                    [
                        121.84813275933,
                        0.53341795317591
                    ],
                    [
                        121.84823468328,
                        0.53318327005348
                    ],
                    [
                        121.84844926,
                        0.53279838971334
                    ],
                    [
                        121.84852838516,
                        0.53266294401301
                    ],
                    [
                        121.84861287475,
                        0.53251408784388
                    ],
                    [
                        121.8487469852,
                        0.53228745096683
                    ],
                    [
                        121.84886500239,
                        0.53210775071522
                    ],
                    [
                        121.84895887971,
                        0.53201253640066
                    ],
                    [
                        121.84908494353,
                        0.53186368021582
                    ],
                    [
                        121.84916004539,
                        0.53177651217798
                    ],
                    [
                        121.84918418527,
                        0.53170141355978
                    ],
                    [
                        121.84923648834,
                        0.5314895281678
                    ],
                    [
                        121.84924989939,
                        0.53138626756274
                    ],
                    [
                        121.84927940369,
                        0.53123607031594
                    ],
                    [
                        121.84929147363,
                        0.53115158436301
                    ],
                    [
                        121.84933707118,
                        0.53092897057674
                    ],
                    [
                        121.84935584664,
                        0.53079888902322
                    ],
                    [
                        121.84938266873,
                        0.53071440306431
                    ],
                    [
                        121.84941619635,
                        0.53063662233922
                    ],
                    [
                        121.84944435954,
                        0.53060577825831
                    ],
                    [
                        121.84949398041,
                        0.53056018266016
                    ],
                    [
                        121.84954896569,
                        0.53054811323707
                    ],
                    [
                        121.84964686632,
                        0.53055750056615
                    ],
                    [
                        121.84970721602,
                        0.53058163941228
                    ],
                    [
                        121.84983327985,
                        0.53060309616431
                    ],
                    [
                        121.85029998422,
                        0.53072110829919
                    ],
                    [
                        121.85076534748,
                        0.53082168682147
                    ],
                    [
                        121.85093298554,
                        0.5308471667135
                    ],
                    [
                        121.85116365552,
                        0.53088605707485
                    ],
                    [
                        121.85141980648,
                        0.5309061727789
                    ],
                    [
                        121.85166120529,
                        0.53092226534209
                    ],
                    [
                        121.85194954276,
                        0.53094506313986
                    ],
                    [
                        121.85226067901,
                        0.53097724826601
                    ],
                    [
                        121.85252085328,
                        0.53100138711049
                    ],
                    [
                        121.85271799564,
                        0.53103491328325
                    ],
                    [
                        121.85286283493,
                        0.53104430061159
                    ],
                    [
                        121.85299560428,
                        0.53105100584611
                    ],
                    [
                        121.8531806767,
                        0.53104966479921
                    ],
                    [
                        121.85336440802,
                        0.53104027747087
                    ],
                    [
                        121.8536272645,
                        0.53101077443889
                    ],
                    [
                        121.85392230749,
                        0.53097456617217
                    ],
                    [
                        121.85439571738,
                        0.53091556010743
                    ],
                    [
                        121.85459285975,
                        0.5309021496381
                    ],
                    [
                        121.85481548309,
                        0.53088337498097
                    ],
                    [
                        121.85500055552,
                        0.53086862346462
                    ],
                    [
                        121.85522451997,
                        0.53084582566655
                    ],
                    [
                        121.85545518994,
                        0.53083241519708
                    ],
                    [
                        121.85571938753,
                        0.53083912043181
                    ],
                    [
                        121.85582533479,
                        0.53083912043181
                    ],
                    [
                        121.8559768796,
                        0.53085923613603
                    ],
                    [
                        121.85615926981,
                        0.53087398765239
                    ],
                    [
                        121.85637518764,
                        0.53088203393403
                    ],
                    [
                        121.85651600361,
                        0.53089544440342
                    ],
                    [
                        121.85667425394,
                        0.53090349068502
                    ],
                    [
                        121.85694783926,
                        0.53091690115436
                    ],
                    [
                        121.85705915093,
                        0.53092897057674
                    ],
                    [
                        121.85714900494,
                        0.53094506313986
                    ],
                    [
                        121.8572576344,
                        0.53098529454751
                    ],
                    [
                        121.8573756516,
                        0.53102686700181
                    ],
                    [
                        121.85749769211,
                        0.53107782678411
                    ],
                    [
                        121.85762107372,
                        0.531116717144
                    ],
                    [
                        121.85775518417,
                        0.53112744551911
                    ],
                    [
                        121.85783296824,
                        0.53114353808171
                    ],
                    [
                        121.85796976089,
                        0.53113817389418
                    ],
                    [
                        121.85812667012,
                        0.53113683284729
                    ],
                    [
                        121.8584766984,
                        0.53106978050272
                    ],
                    [
                        121.85871273279,
                        0.53101613862654
                    ],
                    [
                        121.85891389847,
                        0.5309839535006
                    ],
                    [
                        121.85914456844,
                        0.53091690115436
                    ],
                    [
                        121.85940742493,
                        0.53085253090128
                    ],
                    [
                        121.85972929001,
                        0.5308203457745
                    ],
                    [
                        121.86003237963,
                        0.53076402180223
                    ],
                    [
                        121.86039447784,
                        0.53073451876892
                    ],
                    [
                        121.86098456383,
                        0.53065137385612
                    ],
                    [
                        121.86114281416,
                        0.53062723501027
                    ],
                    [
                        121.86137616634,
                        0.53058432150628
                    ],
                    [
                        121.86211109161,
                        0.53027588068765
                    ],
                    [
                        121.86240613461,
                        0.53013909388491
                    ],
                    [
                        121.86290234327,
                        0.52991648006222
                    ],
                    [
                        121.86326980591,
                        0.52975823649665
                    ],
                    [
                        121.86332345009,
                        0.52967240947633
                    ],
                    [
                        121.86332345009,
                        0.52932641928866
                    ],
                    [
                        121.86331138015,
                        0.5289442208031
                    ],
                    [
                        121.86330735683,
                        0.52878195407054
                    ],
                    [
                        121.86330467463,
                        0.52839841450398
                    ],
                    [
                        121.8632671237,
                        0.5277252086341
                    ],
                    [
                        121.86325371265,
                        0.52724511356685
                    ],
                    [
                        121.86327785254,
                        0.52683475294928
                    ],
                    [
                        121.86331808567,
                        0.52629833380061
                    ],
                    [
                        121.86337172985,
                        0.525912111985
                    ],
                    [
                        121.86337172985,
                        0.525912111985
                    ],
                    [
                        121.86343207955,
                        0.52553661853026
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1748,
                "jenis_pipa": "Pipa 150",
                "keterangan": "TRANSMISI",
                "panjang": 0.0036596712419343803,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83400154114,
                        0.52918158618111
                    ],
                    [
                        121.83579325676,
                        0.53024369555787
                    ],
                    [
                        121.83665156364,
                        0.53030806581727
                    ],
                    [
                        121.83711826801,
                        0.53062723501027
                    ],
                    [
                        121.83724567294,
                        0.53070769782944
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1750,
                "jenis_pipa": "Pipa 200",
                "keterangan": "Distribusi",
                "panjang": 0.004264066915719668,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81385278702,
                        0.63584214627538
                    ],
                    [
                        121.81436240673,
                        0.63569731590532
                    ],
                    [
                        121.81431144476,
                        0.63554712144319
                    ],
                    [
                        121.81407004595,
                        0.63515554300354
                    ],
                    [
                        121.81389033794,
                        0.63489270266438
                    ],
                    [
                        121.81385546923,
                        0.63482028746656
                    ],
                    [
                        121.81383132935,
                        0.63472909795674
                    ],
                    [
                        121.81382596493,
                        0.63453330870963
                    ],
                    [
                        121.81382060051,
                        0.63423023766869
                    ],
                    [
                        121.81382328272,
                        0.63382793094976
                    ],
                    [
                        121.81383669376,
                        0.6334899932817
                    ],
                    [
                        121.81391716003,
                        0.63346585487599
                    ],
                    [
                        121.81419610977,
                        0.63343635237997
                    ],
                    [
                        121.81443214417,
                        0.63339880374844
                    ],
                    [
                        121.81464135647,
                        0.63338807556796
                    ],
                    [
                        121.8147687614,
                        0.63338941659052
                    ],
                    [
                        121.81513220072,
                        0.63338539352283
                    ],
                    [
                        121.81521132588,
                        0.63338807556796
                    ],
                    [
                        121.81521132588,
                        0.63338807556796
                    ],
                    [
                        121.81521132588,
                        0.63338807556796
                    ],
                    [
                        121.81521132588,
                        0.63338807556796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1751,
                "jenis_pipa": "Pipa 250",
                "keterangan": "TRANSMISI",
                "panjang": 0.03138831494568199,
                "total_panjang_jenis": 0.3437607545488887
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.39469996095,
                        0.55011932199624
                    ],
                    [
                        121.39480859041,
                        0.54989939099073
                    ],
                    [
                        121.39494404197,
                        0.54968750623384
                    ],
                    [
                        121.39520287514,
                        0.54946086999821
                    ],
                    [
                        121.39746665955,
                        0.54913633762217
                    ],
                    [
                        121.39901161194,
                        0.54885740068985
                    ],
                    [
                        121.3998913765,
                        0.54851409367836
                    ],
                    [
                        121.40053510666,
                        0.5480849598863
                    ],
                    [
                        121.40040636063,
                        0.547548542603
                    ],
                    [
                        121.40089988708,
                        0.54716232212929
                    ],
                    [
                        121.40152215958,
                        0.54611094404719
                    ],
                    [
                        121.40257358551,
                        0.54325720261269
                    ],
                    [
                        121.40330314636,
                        0.54151920904817
                    ],
                    [
                        121.40403270721,
                        0.5398884985839
                    ],
                    [
                        121.40506267548,
                        0.53857963855271
                    ],
                    [
                        121.40697240829,
                        0.53656270615132
                    ],
                    [
                        121.40832424164,
                        0.53360167652835
                    ],
                    [
                        121.41117811203,
                        0.53087666974628
                    ],
                    [
                        121.41309857368,
                        0.53174566810276
                    ],
                    [
                        121.41501903534,
                        0.53261466633693
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1752,
                "jenis_pipa": "Pipa 150",
                "keterangan": "TRANSMISI",
                "panjang": 0.0032521699417491882,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.41336143017,
                        0.531852951842
                    ],
                    [
                        121.41561985016,
                        0.53012568341388
                    ],
                    [
                        121.41558766365,
                        0.52971800508102
                    ],
                    [
                        121.41558766365,
                        0.52971800508102
                    ],
                    [
                        121.41558766365,
                        0.52971800508102
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1753,
                "jenis_pipa": "Pipa 100",
                "keterangan": "TRANSMISI",
                "panjang": 0.0017328771363059967,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.41559034586,
                        0.52970459460908
                    ],
                    [
                        121.41549646854,
                        0.52906357401691
                    ],
                    [
                        121.41542673111,
                        0.52853251925022
                    ],
                    [
                        121.415335536,
                        0.52799073605761
                    ],
                    [
                        121.415335536,
                        0.52799073605761
                    ],
                    [
                        121.415335536,
                        0.52799073605761
                    ],
                    [
                        121.415335536,
                        0.52799073605761
                    ],
                    [
                        121.415335536,
                        0.52799073605761
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1754,
                "jenis_pipa": "Pipa 75",
                "keterangan": "TRANSMISI",
                "panjang": 0.000779138863335667,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.41533285379,
                        0.52797732558194
                    ],
                    [
                        121.41523092985,
                        0.52720488213494
                    ],
                    [
                        121.41523092985,
                        0.52720488213494
                    ],
                    [
                        121.41523092985,
                        0.52720488213494
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2189,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0012456965841488232,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.96048513055,
                        0.46017092455173
                    ],
                    [
                        121.95986151695,
                        0.46032112341057
                    ],
                    [
                        121.95953562856,
                        0.46035733206356
                    ],
                    [
                        121.95950746536,
                        0.46063224960809
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1756,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Transmisi",
                "panjang": 0.0003267505934417482,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47555305621,
                        0.51079055499141
                    ],
                    [
                        121.47540341467,
                        0.51075978138617
                    ],
                    [
                        121.47533043182,
                        0.51073105152681
                    ],
                    [
                        121.47529948185,
                        0.51076910132238
                    ],
                    [
                        121.47527399024,
                        0.51080798609743
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1757,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0014640248357980705,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83008551598,
                        0.4973168809053
                    ],
                    [
                        121.83065414429,
                        0.49732895039119
                    ],
                    [
                        121.83075875044,
                        0.49733431460712
                    ],
                    [
                        121.83079361916,
                        0.49730212931139
                    ],
                    [
                        121.83079093695,
                        0.49724848715151
                    ],
                    [
                        121.83079093695,
                        0.49708487856114
                    ],
                    [
                        121.83078289032,
                        0.49655918535811
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1758,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0009003291379878794,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81389570236,
                        0.5202207016352
                    ],
                    [
                        121.81393861771,
                        0.52023411212746
                    ],
                    [
                        121.81394398212,
                        0.52015364917341
                    ],
                    [
                        121.81398153305,
                        0.52010000720347
                    ],
                    [
                        121.81424438953,
                        0.52017510596126
                    ],
                    [
                        121.81466817856,
                        0.52027702570254
                    ],
                    [
                        121.81466817856,
                        0.52027702570254
                    ],
                    [
                        121.81466817856,
                        0.52027702570254
                    ],
                    [
                        121.81466817856,
                        0.52027702570254
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1759,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.005215209948128949,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.84145539999,
                        0.53366604675274
                    ],
                    [
                        121.84049114585,
                        0.53310280726659
                    ],
                    [
                        121.84009954333,
                        0.53286007785311
                    ],
                    [
                        121.83974817395,
                        0.53265221564058
                    ],
                    [
                        121.83936461806,
                        0.53242557876863
                    ],
                    [
                        121.8389891088,
                        0.53220162398163
                    ],
                    [
                        121.83878928423,
                        0.53208763501507
                    ],
                    [
                        121.83848485351,
                        0.53188111382325
                    ],
                    [
                        121.83810934424,
                        0.53162765598744
                    ],
                    [
                        121.8374723196,
                        0.53122534194103
                    ],
                    [
                        121.83739319444,
                        0.53117840530057
                    ],
                    [
                        121.83738648891,
                        0.53116767692556
                    ],
                    [
                        121.83738648891,
                        0.53114756122236
                    ],
                    [
                        121.83739587665,
                        0.5311153760971
                    ],
                    [
                        121.83752194047,
                        0.53093701685831
                    ],
                    [
                        121.83739453554,
                        0.53083107415012
                    ],
                    [
                        121.83739453554,
                        0.53083107415012
                    ],
                    [
                        121.83739453554,
                        0.53083107415012
                    ],
                    [
                        121.83739453554,
                        0.53083107415012
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1760,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.0047479384536593125,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83742940426,
                        0.53120522623802
                    ],
                    [
                        121.83738380671,
                        0.53126423229999
                    ],
                    [
                        121.83761447668,
                        0.53139967803103
                    ],
                    [
                        121.83796584606,
                        0.53161826865999
                    ],
                    [
                        121.83814957738,
                        0.53175237333652
                    ],
                    [
                        121.83852240443,
                        0.53200449012049
                    ],
                    [
                        121.83900386095,
                        0.53229147410673
                    ],
                    [
                        121.83940216899,
                        0.53253286249603
                    ],
                    [
                        121.83988496661,
                        0.53282386959723
                    ],
                    [
                        121.84040129185,
                        0.53313096924212
                    ],
                    [
                        121.84094175696,
                        0.53344611514999
                    ],
                    [
                        121.8413682282,
                        0.53370359604997
                    ],
                    [
                        121.8413682282,
                        0.53370359604997
                    ],
                    [
                        121.8413682282,
                        0.53370359604997
                    ],
                    [
                        121.8413682282,
                        0.53370359604997
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1761,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0008097187204518326,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83729127049,
                        0.5311448791286
                    ],
                    [
                        121.83707669377,
                        0.53102150281417
                    ],
                    [
                        121.83682724833,
                        0.53086057718296
                    ],
                    [
                        121.83660060167,
                        0.53072781353406
                    ],
                    [
                        121.83660328388,
                        0.53072781353406
                    ],
                    [
                        121.83660328388,
                        0.53072781353406
                    ],
                    [
                        121.83660328388,
                        0.53072781353406
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1762,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.03059762800373467,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83757022023,
                        0.53137956232858
                    ],
                    [
                        121.83756887913,
                        0.53138760860956
                    ],
                    [
                        121.83772176504,
                        0.53147745874652
                    ],
                    [
                        121.83804228902,
                        0.53168532099861
                    ],
                    [
                        121.83827295899,
                        0.5318435645149
                    ],
                    [
                        121.838542521,
                        0.53202192372752
                    ],
                    [
                        121.8389301002,
                        0.53225526584753
                    ],
                    [
                        121.83938607574,
                        0.53253152144945
                    ],
                    [
                        121.83995202184,
                        0.53287617041121
                    ],
                    [
                        121.84031277895,
                        0.53308269156971
                    ],
                    [
                        121.8408036232,
                        0.53337235759853
                    ],
                    [
                        121.84128239751,
                        0.53365800047472
                    ],
                    [
                        121.84174910188,
                        0.53393157392116
                    ],
                    [
                        121.84189930558,
                        0.53399996728088
                    ],
                    [
                        121.84196233749,
                        0.53401203669722
                    ],
                    [
                        121.84205755591,
                        0.53402008297477
                    ],
                    [
                        121.84212997556,
                        0.53400801355844
                    ],
                    [
                        121.84227749705,
                        0.53396912321679
                    ],
                    [
                        121.84245720506,
                        0.5338953656716
                    ],
                    [
                        121.84276431799,
                        0.53376930731959
                    ],
                    [
                        121.84298560023,
                        0.53369689081834
                    ],
                    [
                        121.84308618307,
                        0.53366336466006
                    ],
                    [
                        121.84315592051,
                        0.53365934152106
                    ],
                    [
                        121.84329941869,
                        0.53368348035505
                    ],
                    [
                        121.84397801757,
                        0.53374919162488
                    ],
                    [
                        121.84453323483,
                        0.53380015138469
                    ],
                    [
                        121.84485778213,
                        0.53382831335703
                    ],
                    [
                        121.84507101774,
                        0.53389268357902
                    ],
                    [
                        121.84519842267,
                        0.5339597358929
                    ],
                    [
                        121.84540897608,
                        0.53402276506728
                    ],
                    [
                        121.8455940485,
                        0.53406836063982
                    ],
                    [
                        121.84596151114,
                        0.53411395621204
                    ],
                    [
                        121.8463678658,
                        0.53413675399802
                    ],
                    [
                        121.84664279222,
                        0.53413809504425
                    ],
                    [
                        121.84697538614,
                        0.53414882341409
                    ],
                    [
                        121.84713765979,
                        0.53416089283014
                    ],
                    [
                        121.84733346105,
                        0.53417698538482
                    ],
                    [
                        121.84751451015,
                        0.53418771375461
                    ],
                    [
                        121.84775993228,
                        0.5342105115403
                    ],
                    [
                        121.84783369303,
                        0.53419039584705
                    ],
                    [
                        121.84789806604,
                        0.53415552864523
                    ],
                    [
                        121.84795171022,
                        0.53409249947221
                    ],
                    [
                        121.84799060225,
                        0.53400399041966
                    ],
                    [
                        121.8480925262,
                        0.53373309906908
                    ],
                    [
                        121.8482118845,
                        0.53344075096446
                    ],
                    [
                        121.84835001826,
                        0.53314840284596
                    ],
                    [
                        121.84861555696,
                        0.53267501343198
                    ],
                    [
                        121.84878855944,
                        0.53237596004406
                    ],
                    [
                        121.84894680977,
                        0.53212116118193
                    ],
                    [
                        121.84902995825,
                        0.53203265210105
                    ],
                    [
                        121.84916272759,
                        0.53188379591669
                    ],
                    [
                        121.84922186165,
                        0.53178916990914
                    ],
                    [
                        121.84927282363,
                        0.5316295853447
                    ],
                    [
                        121.84936535984,
                        0.53114546743912
                    ],
                    [
                        121.84940022855,
                        0.5309174894649
                    ],
                    [
                        121.84945119052,
                        0.53072571975068
                    ],
                    [
                        121.84949812918,
                        0.53064525693174
                    ],
                    [
                        121.84954775005,
                        0.53062648227384
                    ],
                    [
                        121.84959737092,
                        0.53062514122685
                    ],
                    [
                        121.8499795857,
                        0.53071096823395
                    ],
                    [
                        121.85038459926,
                        0.53081154675638
                    ],
                    [
                        121.85083521038,
                        0.53091078423025
                    ],
                    [
                        121.85126436382,
                        0.53096979029502
                    ],
                    [
                        121.85174850255,
                        0.53100599856178
                    ],
                    [
                        121.85213205844,
                        0.53104086578141
                    ],
                    [
                        121.85260680943,
                        0.53108377928222
                    ],
                    [
                        121.85284284382,
                        0.53110255393873
                    ],
                    [
                        121.85307887822,
                        0.53110389498562
                    ],
                    [
                        121.85328943163,
                        0.53110523603252
                    ],
                    [
                        121.85364348322,
                        0.53107439195394
                    ],
                    [
                        121.85392511516,
                        0.53103952473451
                    ],
                    [
                        121.85420272379,
                        0.53100733960869
                    ],
                    [
                        121.85481426745,
                        0.53095235668504
                    ],
                    [
                        121.855244762,
                        0.53091614841796
                    ],
                    [
                        121.85544860988,
                        0.53091212527717
                    ],
                    [
                        121.8556618455,
                        0.53091346632411
                    ],
                    [
                        121.85634983211,
                        0.53095772087273
                    ],
                    [
                        121.85683933526,
                        0.53099392913955
                    ],
                    [
                        121.85708207517,
                        0.53102209112471
                    ],
                    [
                        121.85722825556,
                        0.53107305090704
                    ],
                    [
                        121.85741332799,
                        0.53115083162664
                    ],
                    [
                        121.85755146175,
                        0.53118838093922
                    ],
                    [
                        121.85777274399,
                        0.53122190711094
                    ],
                    [
                        121.85791490107,
                        0.53122458920467
                    ],
                    [
                        121.85815093546,
                        0.53121654292347
                    ],
                    [
                        121.85834539562,
                        0.53119910931419
                    ],
                    [
                        121.85851437479,
                        0.53116156000168
                    ],
                    [
                        121.85881880551,
                        0.53108512032912
                    ],
                    [
                        121.85909641414,
                        0.53101404484325
                    ],
                    [
                        121.85949606329,
                        0.53093358202806
                    ],
                    [
                        121.85994935661,
                        0.53086921177518
                    ],
                    [
                        121.86031145483,
                        0.53082629827286
                    ],
                    [
                        121.86081839233,
                        0.53076058697188
                    ],
                    [
                        121.86117780834,
                        0.5306948756702
                    ],
                    [
                        121.86138031512,
                        0.5306640315896
                    ],
                    [
                        121.86149699121,
                        0.53062648227384
                    ],
                    [
                        121.86162841945,
                        0.53058088667584
                    ],
                    [
                        121.86197442442,
                        0.53041325579796
                    ],
                    [
                        121.86238077908,
                        0.53023355549184
                    ],
                    [
                        121.86267045765,
                        0.53010079182949
                    ],
                    [
                        121.86313984423,
                        0.52988756533551
                    ],
                    [
                        121.86331955224,
                        0.52980844355285
                    ],
                    [
                        121.86339197188,
                        0.52970518291974
                    ],
                    [
                        121.86340270072,
                        0.52950804897902
                    ],
                    [
                        121.8633986774,
                        0.52928543513365
                    ],
                    [
                        121.86338392525,
                        0.52892737549814
                    ],
                    [
                        121.86338794857,
                        0.52864307345075
                    ],
                    [
                        121.86337575316,
                        0.52848960573174
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1763,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.00920158834798653,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.8625831604,
                        0.50686651940802
                    ],
                    [
                        121.862642169,
                        0.50672168578715
                    ],
                    [
                        121.86282992363,
                        0.50650711745398
                    ],
                    [
                        121.86324834824,
                        0.50590632608333
                    ],
                    [
                        121.86370968819,
                        0.50520897888691
                    ],
                    [
                        121.86409592628,
                        0.5046511010759
                    ],
                    [
                        121.864605546,
                        0.50391620427108
                    ],
                    [
                        121.86494350433,
                        0.5033851474043
                    ],
                    [
                        121.8652009964,
                        0.5029989242013
                    ],
                    [
                        121.86536729336,
                        0.50277899153381
                    ],
                    [
                        121.8655282259,
                        0.50263415782191
                    ],
                    [
                        121.86572670937,
                        0.50253223780051
                    ],
                    [
                        121.86598956585,
                        0.50243031777751
                    ],
                    [
                        121.86676204205,
                        0.50217283560705
                    ],
                    [
                        121.86730384827,
                        0.50197435976042
                    ],
                    [
                        121.86777055264,
                        0.50178661233237
                    ],
                    [
                        121.86808973551,
                        0.50166859966055
                    ],
                    [
                        121.86815947294,
                        0.50161763964251
                    ],
                    [
                        121.86823993921,
                        0.50154924593348
                    ],
                    [
                        121.86837136745,
                        0.50138563745014
                    ],
                    [
                        121.86846524477,
                        0.50129712794106
                    ],
                    [
                        121.86860740185,
                        0.5011657047284
                    ],
                    [
                        121.86866909266,
                        0.50110938049359
                    ],
                    [
                        121.86875358224,
                        0.50107719521633
                    ],
                    [
                        121.86879783869,
                        0.501081218376
                    ],
                    [
                        121.86895743012,
                        0.50112547313215
                    ],
                    [
                        121.86908349395,
                        0.50118045631361
                    ],
                    [
                        121.86912640929,
                        0.50120057211161
                    ],
                    [
                        121.86912640929,
                        0.50120057211161
                    ],
                    [
                        121.86912640929,
                        0.50120057211161
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1764,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.023262433436097497,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.8621084094,
                        0.50691479728093
                    ],
                    [
                        121.86240077019,
                        0.50686383730395
                    ],
                    [
                        121.86265826225,
                        0.50685310888771
                    ],
                    [
                        121.86277896166,
                        0.50667072580867
                    ],
                    [
                        121.86289697886,
                        0.50653393849601
                    ],
                    [
                        121.86303377151,
                        0.50636764803361
                    ],
                    [
                        121.86336636543,
                        0.50585268399396
                    ],
                    [
                        121.86376869678,
                        0.50526262098162
                    ],
                    [
                        121.86411738396,
                        0.50477716000854
                    ],
                    [
                        121.86453312635,
                        0.5041763684779
                    ],
                    [
                        121.86487108469,
                        0.50366408637003
                    ],
                    [
                        121.86517953873,
                        0.50322690317806
                    ],
                    [
                        121.86536192894,
                        0.50292650734819
                    ],
                    [
                        121.86553359032,
                        0.50273339573596
                    ],
                    [
                        121.86575621367,
                        0.50261538308125
                    ],
                    [
                        121.86622023582,
                        0.50241958935394
                    ],
                    [
                        121.8668076396,
                        0.50225061668044
                    ],
                    [
                        121.86717778444,
                        0.50212455769896
                    ],
                    [
                        121.86776787043,
                        0.50188048604706
                    ],
                    [
                        121.86803609133,
                        0.5017839302262
                    ],
                    [
                        121.86815947294,
                        0.50171955967818
                    ],
                    [
                        121.86831235886,
                        0.50159350068648
                    ],
                    [
                        121.86848670244,
                        0.50139234271593
                    ],
                    [
                        121.86870127916,
                        0.50116704578159
                    ],
                    [
                        121.86875224113,
                        0.50115899946237
                    ],
                    [
                        121.86884611845,
                        0.50116436367519
                    ],
                    [
                        121.86899900436,
                        0.50122873422867
                    ],
                    [
                        121.87001824379,
                        0.50167932808535
                    ],
                    [
                        121.870855093,
                        0.50195290291176
                    ],
                    [
                        121.87155246735,
                        0.50218624613701
                    ],
                    [
                        121.87245905399,
                        0.50247323147159
                    ],
                    [
                        121.87319934368,
                        0.50274948837054
                    ],
                    [
                        121.87345683575,
                        0.50282190522561
                    ],
                    [
                        121.8736821413,
                        0.5028299515428
                    ],
                    [
                        121.87396645546,
                        0.50279508416828
                    ],
                    [
                        121.8742749095,
                        0.50269584625515
                    ],
                    [
                        121.87467724085,
                        0.5025939262347
                    ],
                    [
                        121.87511175871,
                        0.50258051570559
                    ],
                    [
                        121.87572866678,
                        0.50261001886962
                    ],
                    [
                        121.87593787909,
                        0.50267438940887
                    ],
                    [
                        121.87619268894,
                        0.5028299515428
                    ],
                    [
                        121.87650382519,
                        0.50296137472201
                    ],
                    [
                        121.87690883875,
                        0.50310084421542
                    ],
                    [
                        121.87717705965,
                        0.50317594317217
                    ],
                    [
                        121.87744528055,
                        0.50322690317806
                    ],
                    [
                        121.87758475542,
                        0.50322153896692
                    ],
                    [
                        121.87784224749,
                        0.5031866715945
                    ],
                    [
                        121.87831431627,
                        0.50302306315215
                    ],
                    [
                        121.87881588936,
                        0.50280044837975
                    ],
                    [
                        121.87910825014,
                        0.50268511783203
                    ],
                    [
                        121.87927722931,
                        0.50259929044635
                    ],
                    [
                        121.87952935696,
                        0.50250541674197
                    ],
                    [
                        121.87972247601,
                        0.50245982094222
                    ],
                    [
                        121.87997460365,
                        0.50240349671855
                    ],
                    [
                        121.8801677227,
                        0.50238472197722
                    ],
                    [
                        121.88051104546,
                        0.50243568198928
                    ],
                    [
                        121.88091874123,
                        0.50250809884784
                    ],
                    [
                        121.88130229712,
                        0.50255637675309
                    ],
                    [
                        121.88153833151,
                        0.50255637675309
                    ],
                    [
                        121.88177704811,
                        0.50258856202306
                    ],
                    [
                        121.881980896,
                        0.50262342939868
                    ],
                    [
                        121.882160604,
                        0.50267170730308
                    ],
                    [
                        121.882160604,
                        0.50267170730308
                    ],
                    [
                        121.88215523958,
                        0.50267170730308
                    ],
                    [
                        121.88215523958,
                        0.50267170730308
                    ],
                    [
                        121.88215523958,
                        0.50267170730308
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1765,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.010878738156874214,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89168512821,
                        0.49912327591811
                    ],
                    [
                        121.89138203859,
                        0.49931102788512
                    ],
                    [
                        121.89111784101,
                        0.49946524904536
                    ],
                    [
                        121.89093947411,
                        0.49959533123856
                    ],
                    [
                        121.89081341028,
                        0.49973480080367
                    ],
                    [
                        121.890668571,
                        0.49987695247276
                    ],
                    [
                        121.89049556851,
                        0.50004190204718
                    ],
                    [
                        121.89024746418,
                        0.50033291063585
                    ],
                    [
                        121.88997387886,
                        0.50057966445208
                    ],
                    [
                        121.88983440399,
                        0.50068158450389
                    ],
                    [
                        121.88958227634,
                        0.50090688145492
                    ],
                    [
                        121.88938379288,
                        0.50105707941798
                    ],
                    [
                        121.88916921616,
                        0.50115363524955
                    ],
                    [
                        121.88894927502,
                        0.50130919741963
                    ],
                    [
                        121.88868641853,
                        0.50149694486138
                    ],
                    [
                        121.88848793507,
                        0.50172224178436
                    ],
                    [
                        121.88837528229,
                        0.50184025445522
                    ],
                    [
                        121.88827335835,
                        0.50192608185085
                    ],
                    [
                        121.88812315464,
                        0.50204945873012
                    ],
                    [
                        121.88799440861,
                        0.50215674297107
                    ],
                    [
                        121.88787102699,
                        0.50219429245497
                    ],
                    [
                        121.8876940012,
                        0.50228548405788
                    ],
                    [
                        121.88731312752,
                        0.50244641041282
                    ],
                    [
                        121.88698589802,
                        0.50257515149393
                    ],
                    [
                        121.88666939735,
                        0.50269852836093
                    ],
                    [
                        121.88612759113,
                        0.50288091155137
                    ],
                    [
                        121.88575744629,
                        0.50298819577866
                    ],
                    [
                        121.88520491123,
                        0.50310620842664
                    ],
                    [
                        121.88485085964,
                        0.50321349265023
                    ],
                    [
                        121.8847489357,
                        0.50320812843909
                    ],
                    [
                        121.88457593322,
                        0.50317728422496
                    ],
                    [
                        121.88435733318,
                        0.50315582738027
                    ],
                    [
                        121.88396573067,
                        0.50309011579295
                    ],
                    [
                        121.88365057111,
                        0.50301903999368
                    ],
                    [
                        121.88336893916,
                        0.50295064629931
                    ],
                    [
                        121.88288211823,
                        0.50284067996569
                    ],
                    [
                        121.88262730837,
                        0.50277630942807
                    ],
                    [
                        121.88216462731,
                        0.50267170730308
                    ],
                    [
                        121.88216462731,
                        0.50267170730308
                    ],
                    [
                        121.88216462731,
                        0.50267170730308
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1766,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.021945515391887563,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.89158052206,
                        0.49909109509385
                    ],
                    [
                        121.89130157232,
                        0.4992573857416
                    ],
                    [
                        121.89087241888,
                        0.49954705331149
                    ],
                    [
                        121.89062297344,
                        0.49979380715726
                    ],
                    [
                        121.8903413415,
                        0.5000834747035
                    ],
                    [
                        121.88987195492,
                        0.50050992967887
                    ],
                    [
                        121.88959032297,
                        0.50075936559501
                    ],
                    [
                        121.889359653,
                        0.50091760988097
                    ],
                    [
                        121.88912093639,
                        0.50103830467279
                    ],
                    [
                        121.88887685537,
                        0.50119386684562
                    ],
                    [
                        121.88859254122,
                        0.50141916377903
                    ],
                    [
                        121.88838064671,
                        0.50165250702333
                    ],
                    [
                        121.88817679882,
                        0.50185098287973
                    ],
                    [
                        121.88794612885,
                        0.50203604819987
                    ],
                    [
                        121.88777178526,
                        0.50212992191099
                    ],
                    [
                        121.88761621714,
                        0.50219161034898
                    ],
                    [
                        121.88712537289,
                        0.50241154303625
                    ],
                    [
                        121.88689738512,
                        0.50251614516539
                    ],
                    [
                        121.88669890165,
                        0.50259929044635
                    ],
                    [
                        121.88640117645,
                        0.50270121046672
                    ],
                    [
                        121.88613831997,
                        0.50277362732232
                    ],
                    [
                        121.88577353954,
                        0.50287018312853
                    ],
                    [
                        121.88514053822,
                        0.50302038104651
                    ],
                    [
                        121.88495010138,
                        0.50308743368734
                    ],
                    [
                        121.88477307558,
                        0.50311693684907
                    ],
                    [
                        121.88462555408,
                        0.50310620842664
                    ],
                    [
                        121.88416153193,
                        0.50303110946909
                    ],
                    [
                        121.88369750977,
                        0.50292650734819
                    ],
                    [
                        121.88301354647,
                        0.50276021679356
                    ],
                    [
                        121.8823376298,
                        0.50259929044635
                    ],
                    [
                        121.8820130825,
                        0.50254564832973
                    ],
                    [
                        121.88131839037,
                        0.5024625030481
                    ],
                    [
                        121.88100993633,
                        0.50244641041282
                    ],
                    [
                        121.88074976206,
                        0.50240349671855
                    ],
                    [
                        121.88045740128,
                        0.50233912617663
                    ],
                    [
                        121.88021868467,
                        0.50230425879949
                    ],
                    [
                        121.88000142574,
                        0.5023203514351
                    ],
                    [
                        121.87980830669,
                        0.50235521881217
                    ],
                    [
                        121.87954813242,
                        0.50241690724805
                    ],
                    [
                        121.87914848328,
                        0.50257783359975
                    ],
                    [
                        121.87877565622,
                        0.5027307136302
                    ],
                    [
                        121.8782043457,
                        0.50296673893334
                    ],
                    [
                        121.87787443399,
                        0.50308475158171
                    ],
                    [
                        121.87771081924,
                        0.50313571158831
                    ],
                    [
                        121.87753379345,
                        0.50314912211629
                    ],
                    [
                        121.87738090754,
                        0.50313571158831
                    ],
                    [
                        121.8769839406,
                        0.50304451999728
                    ],
                    [
                        121.87658429146,
                        0.50291846103111
                    ],
                    [
                        121.87622755766,
                        0.5027521704763
                    ],
                    [
                        121.87600493431,
                        0.50263415782191
                    ],
                    [
                        121.87584668398,
                        0.50257515149393
                    ],
                    [
                        121.87545239925,
                        0.50251614516539
                    ],
                    [
                        121.87520831823,
                        0.5025107809537
                    ],
                    [
                        121.87500581145,
                        0.50250675779491
                    ],
                    [
                        121.87480732799,
                        0.50252150937711
                    ],
                    [
                        121.87456592917,
                        0.50254430727681
                    ],
                    [
                        121.87439024448,
                        0.50258856202306
                    ],
                    [
                        121.87417834997,
                        0.50265829677413
                    ],
                    [
                        121.87402144074,
                        0.50270121046672
                    ],
                    [
                        121.87385782599,
                        0.50273875994751
                    ],
                    [
                        121.87369287014,
                        0.5027521704763
                    ],
                    [
                        121.87360972166,
                        0.50275485258206
                    ],
                    [
                        121.87345147133,
                        0.50274412415903
                    ],
                    [
                        121.87323018909,
                        0.50267841256756
                    ],
                    [
                        121.87303170562,
                        0.50260465465798
                    ],
                    [
                        121.87285467982,
                        0.50253223780051
                    ],
                    [
                        121.87255427241,
                        0.50242897672455
                    ],
                    [
                        121.87215864658,
                        0.50229621248166
                    ],
                    [
                        121.87187835574,
                        0.50220233877294
                    ],
                    [
                        121.87156185508,
                        0.5020923724267
                    ],
                    [
                        121.87138348818,
                        0.50203470714685
                    ],
                    [
                        121.87138348818,
                        0.50203470714685
                    ],
                    [
                        121.87138348818,
                        0.50203470714685
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1767,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0024069903950271134,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.87137946486,
                        0.50203604819987
                    ],
                    [
                        121.87114477158,
                        0.50196497238914
                    ],
                    [
                        121.87099054456,
                        0.50191803553255
                    ],
                    [
                        121.87073841691,
                        0.50183757234908
                    ],
                    [
                        121.87036156654,
                        0.50171419546583
                    ],
                    [
                        121.87003836036,
                        0.50160825227074
                    ],
                    [
                        121.86979562044,
                        0.50151169644587
                    ],
                    [
                        121.86948314309,
                        0.50136820375905
                    ],
                    [
                        121.86912640929,
                        0.50120057211161
                    ],
                    [
                        121.86912640929,
                        0.50120057211161
                    ],
                    [
                        121.86912640929,
                        0.50120057211161
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1768,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.86965346336,
                        0.50144732589516
                    ],
                    [
                        121.86965346336,
                        0.50144732589516
                    ],
                    [
                        121.86965346336,
                        0.50144732589516
                    ],
                    [
                        121.86965346336,
                        0.50144732589516
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1769,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.00010637646440327114,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.8916529417,
                        0.49917155831103
                    ],
                    [
                        121.89159393311,
                        0.49908304877208
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1770,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.022583296275450013,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.86265289783,
                        0.5068611551999
                    ],
                    [
                        121.8628808856,
                        0.50742707913234
                    ],
                    [
                        121.86296671629,
                        0.50752095276565
                    ],
                    [
                        121.86318933964,
                        0.5077408852726
                    ],
                    [
                        121.86365067959,
                        0.50818343236759
                    ],
                    [
                        121.86402618885,
                        0.50853747002175
                    ],
                    [
                        121.86429440975,
                        0.50874667408101
                    ],
                    [
                        121.86443120241,
                        0.50888077924361
                    ],
                    [
                        121.86456799507,
                        0.50903365912559
                    ],
                    [
                        121.86464846134,
                        0.50922140634411
                    ],
                    [
                        121.86469137669,
                        0.50957812604425
                    ],
                    [
                        121.8646672368,
                        0.51012527501959
                    ],
                    [
                        121.864605546,
                        0.51098354782837
                    ],
                    [
                        121.86452776194,
                        0.51189546256203
                    ],
                    [
                        121.86449021101,
                        0.5124667502556
                    ],
                    [
                        121.8644285202,
                        0.51295221065001
                    ],
                    [
                        121.86439096928,
                        0.51316946086983
                    ],
                    [
                        121.86431854963,
                        0.51333575115656
                    ],
                    [
                        121.86416298151,
                        0.5136629675146
                    ],
                    [
                        121.86414152384,
                        0.51383462199081
                    ],
                    [
                        121.86412006617,
                        0.51411624260585
                    ],
                    [
                        121.86405837536,
                        0.5147223974113
                    ],
                    [
                        121.86402618885,
                        0.51500133588649
                    ],
                    [
                        121.86393231153,
                        0.51611172546474
                    ],
                    [
                        121.86384916306,
                        0.51732939883735
                    ],
                    [
                        121.86380892992,
                        0.51823058426665
                    ],
                    [
                        121.86378479004,
                        0.51916127265578
                    ],
                    [
                        121.86377674341,
                        0.52048086518015
                    ],
                    [
                        121.86378479004,
                        0.52159125379777
                    ],
                    [
                        121.86381697655,
                        0.52214108383785
                    ],
                    [
                        121.86385989189,
                        0.52237979052321
                    ],
                    [
                        121.86391621828,
                        0.52258899412765
                    ],
                    [
                        121.86397522688,
                        0.52287329645072
                    ],
                    [
                        121.86397790909,
                        0.5231871018301
                    ],
                    [
                        121.86396718025,
                        0.52336680233943
                    ],
                    [
                        121.86387062073,
                        0.52377984528165
                    ],
                    [
                        121.86375796795,
                        0.52433772142015
                    ],
                    [
                        121.86358094215,
                        0.52520403859434
                    ],
                    [
                        121.86345219612,
                        0.5258933373128
                    ],
                    [
                        121.86336636543,
                        0.52659604643383
                    ],
                    [
                        121.86332881451,
                        0.52742749605485
                    ],
                    [
                        121.86335027218,
                        0.5280497421502
                    ],
                    [
                        121.86337441206,
                        0.52849765201649
                    ],
                    [
                        121.86337441206,
                        0.52849765201649
                    ],
                    [
                        121.86337441206,
                        0.52849765201649
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1771,
                "jenis_pipa": "Pipa 200",
                "keterangan": "TRANSMISI",
                "panjang": 0.022213361855967527,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.7982852459,
                        0.64840482429448
                    ],
                    [
                        121.80029153824,
                        0.64551895137977
                    ],
                    [
                        121.80245876312,
                        0.6440599220705
                    ],
                    [
                        121.80396080017,
                        0.64350205781241
                    ],
                    [
                        121.80485129356,
                        0.64326603830024
                    ],
                    [
                        121.80629968643,
                        0.64303001877714
                    ],
                    [
                        121.80724382401,
                        0.64283691188649
                    ],
                    [
                        121.80841326714,
                        0.64238632911326
                    ],
                    [
                        121.80975437164,
                        0.64215030954952
                    ],
                    [
                        121.81076288223,
                        0.64191428997488
                    ],
                    [
                        121.81183576584,
                        0.64122768751401
                    ],
                    [
                        121.81270480156,
                        0.64042307513799
                    ],
                    [
                        121.81283354759,
                        0.63926443309467
                    ],
                    [
                        121.81272625923,
                        0.63826671334787
                    ],
                    [
                        121.81304812431,
                        0.63750501319581
                    ],
                    [
                        121.81376695633,
                        0.63693642005112
                    ],
                    [
                        121.81365028024,
                        0.6358327591219
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1772,
                "jenis_pipa": "Pipa 200",
                "keterangan": "Distribusi",
                "panjang": 0.0060680122259082515,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82087749243,
                        0.63433886047744
                    ],
                    [
                        121.82071655989,
                        0.63397678443939
                    ],
                    [
                        121.82061329484,
                        0.6338239078824
                    ],
                    [
                        121.8205408752,
                        0.63376624391676
                    ],
                    [
                        121.82040140033,
                        0.6337179671078
                    ],
                    [
                        121.82011172175,
                        0.63363616473607
                    ],
                    [
                        121.81982070208,
                        0.63354497520538
                    ],
                    [
                        121.81948676705,
                        0.63342428317701
                    ],
                    [
                        121.81922256947,
                        0.63333577568775
                    ],
                    [
                        121.81911125779,
                        0.63331834239424
                    ],
                    [
                        121.81901469827,
                        0.63332370648456
                    ],
                    [
                        121.81878268719,
                        0.6333330936426
                    ],
                    [
                        121.81856811047,
                        0.63333711671033
                    ],
                    [
                        121.81820333004,
                        0.63333711671033
                    ],
                    [
                        121.81793242693,
                        0.63335723204892
                    ],
                    [
                        121.8175958097,
                        0.63336393716177
                    ],
                    [
                        121.81701779366,
                        0.63337332431975
                    ],
                    [
                        121.81661278009,
                        0.63338002943257
                    ],
                    [
                        121.81628152728,
                        0.63337734738744
                    ],
                    [
                        121.81570887566,
                        0.63339209863564
                    ],
                    [
                        121.81521803141,
                        0.63338673454539
                    ],
                    [
                        121.81521803141,
                        0.63338673454539
                    ],
                    [
                        121.81521803141,
                        0.63338673454539
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1773,
                "jenis_pipa": "Pipa 200",
                "keterangan": "Distribusi",
                "panjang": 0.0060680122259082515,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82087749243,
                        0.63433886047744
                    ],
                    [
                        121.82071655989,
                        0.63397678443939
                    ],
                    [
                        121.82061329484,
                        0.6338239078824
                    ],
                    [
                        121.8205408752,
                        0.63376624391676
                    ],
                    [
                        121.82040140033,
                        0.6337179671078
                    ],
                    [
                        121.82011172175,
                        0.63363616473607
                    ],
                    [
                        121.81982070208,
                        0.63354497520538
                    ],
                    [
                        121.81948676705,
                        0.63342428317701
                    ],
                    [
                        121.81922256947,
                        0.63333577568775
                    ],
                    [
                        121.81911125779,
                        0.63331834239424
                    ],
                    [
                        121.81901469827,
                        0.63332370648456
                    ],
                    [
                        121.81878268719,
                        0.6333330936426
                    ],
                    [
                        121.81856811047,
                        0.63333711671033
                    ],
                    [
                        121.81820333004,
                        0.63333711671033
                    ],
                    [
                        121.81793242693,
                        0.63335723204892
                    ],
                    [
                        121.8175958097,
                        0.63336393716177
                    ],
                    [
                        121.81701779366,
                        0.63337332431975
                    ],
                    [
                        121.81661278009,
                        0.63338002943257
                    ],
                    [
                        121.81628152728,
                        0.63337734738744
                    ],
                    [
                        121.81570887566,
                        0.63339209863564
                    ],
                    [
                        121.81521803141,
                        0.63338673454539
                    ],
                    [
                        121.81521803141,
                        0.63338673454539
                    ],
                    [
                        121.81521803141,
                        0.63338673454539
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1774,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0075166518520996956,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.34716853499,
                        0.476086621552
                    ],
                    [
                        121.34671792388,
                        0.47606784673703
                    ],
                    [
                        121.3464269042,
                        0.47606114144596
                    ],
                    [
                        121.34616136551,
                        0.47605577721311
                    ],
                    [
                        121.34581267834,
                        0.47602627393229
                    ],
                    [
                        121.34546667337,
                        0.47600615805893
                    ],
                    [
                        121.34544655681,
                        0.47600749911716
                    ],
                    [
                        121.3454452157,
                        0.47612148906537
                    ],
                    [
                        121.34546801448,
                        0.47644870725919
                    ],
                    [
                        121.34553104639,
                        0.47695562721731
                    ],
                    [
                        121.34557932615,
                        0.47747059348572
                    ],
                    [
                        121.3456222415,
                        0.47799897029396
                    ],
                    [
                        121.34565442801,
                        0.47841738032645
                    ],
                    [
                        121.34569063783,
                        0.47887065783287
                    ],
                    [
                        121.34575098753,
                        0.47940708087866
                    ],
                    [
                        121.34591728449,
                        0.47997032503151
                    ],
                    [
                        121.34615063667,
                        0.48042360243514
                    ],
                    [
                        121.34632766247,
                        0.48078568791347
                    ],
                    [
                        121.34662270546,
                        0.48140793846839
                    ],
                    [
                        121.34675145149,
                        0.48153131572686
                    ],
                    [
                        121.34675145149,
                        0.48153131572686
                    ],
                    [
                        121.34675145149,
                        0.48153131572686
                    ],
                    [
                        121.34674608707,
                        0.48154070312687
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1775,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.016347620679421613,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.34262084961,
                        0.48221257272247
                    ],
                    [
                        121.34313046932,
                        0.48208919547634
                    ],
                    [
                        121.34353548288,
                        0.4819845930268
                    ],
                    [
                        121.34424492717,
                        0.48185585154823
                    ],
                    [
                        121.34479209781,
                        0.48173783852406
                    ],
                    [
                        121.34525343776,
                        0.48162921289773
                    ],
                    [
                        121.34575903416,
                        0.48152461044112
                    ],
                    [
                        121.34624183178,
                        0.48143878278322
                    ],
                    [
                        121.34645774961,
                        0.48141866692574
                    ],
                    [
                        121.34658381343,
                        0.48144414701187
                    ],
                    [
                        121.34666025639,
                        0.48147901449799
                    ],
                    [
                        121.34674340487,
                        0.48154070312687
                    ],
                    [
                        121.34684532881,
                        0.48169358363948
                    ],
                    [
                        121.34700562331,
                        0.48193785725915
                    ],
                    [
                        121.34717326138,
                        0.48226373411815
                    ],
                    [
                        121.34778819031,
                        0.48326704591026
                    ],
                    [
                        121.34834072537,
                        0.48423260673973
                    ],
                    [
                        121.34876183218,
                        0.48494873093278
                    ],
                    [
                        121.34920707888,
                        0.48576409321764
                    ],
                    [
                        121.34969255871,
                        0.48656604484264
                    ],
                    [
                        121.35013244099,
                        0.48725534766823
                    ],
                    [
                        121.3507010693,
                        0.48809753079131
                    ],
                    [
                        121.35113022274,
                        0.488585675101
                    ],
                    [
                        121.35129383749,
                        0.48868491322556
                    ],
                    [
                        121.35152182526,
                        0.48874123756586
                    ],
                    [
                        121.35201535172,
                        0.48880024401713
                    ],
                    [
                        121.35263225979,
                        0.48886997891339
                    ],
                    [
                        121.35348520226,
                        0.48897994547909
                    ],
                    [
                        121.35432741589,
                        0.48908454782042
                    ],
                    [
                        121.3548665399,
                        0.4891650111588
                    ],
                    [
                        121.3548665399,
                        0.4891650111588
                    ],
                    [
                        121.3548665399,
                        0.4891650111588
                    ],
                    [
                        121.3548665399,
                        0.4891650111588
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1776,
                "jenis_pipa": "Pipa 200",
                "keterangan": "TRANSMISI",
                "panjang": 0.0002310174691331871,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.37287214398,
                        0.51232993926477
                    ],
                    [
                        121.37268304825,
                        0.51219722952158
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1779,
                "jenis_pipa": "Pipa 150",
                "keterangan": "TRANSMISI",
                "panjang": 0.0003682187627761643,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.37255162001,
                        0.51184583846892
                    ],
                    [
                        121.37257441878,
                        0.51199599452633
                    ],
                    [
                        121.37260124087,
                        0.51208051866964
                    ],
                    [
                        121.37262672186,
                        0.51211811495467
                    ],
                    [
                        121.37267231941,
                        0.51218656433624
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1780,
                "jenis_pipa": "Pipa 100",
                "keterangan": "TRANSMISI",
                "panjang": 0.0038900256917543076,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.3725502789,
                        0.5118457477267
                    ],
                    [
                        121.37248858809,
                        0.51160701684408
                    ],
                    [
                        121.37242019176,
                        0.51141926597623
                    ],
                    [
                        121.37233972549,
                        0.51125170971133
                    ],
                    [
                        121.37227669358,
                        0.51116058294428
                    ],
                    [
                        121.37217879295,
                        0.51110160495792
                    ],
                    [
                        121.37190118432,
                        0.51101737980481
                    ],
                    [
                        121.37129098177,
                        0.51081815151475
                    ],
                    [
                        121.37082025409,
                        0.51055206627212
                    ],
                    [
                        121.37067273259,
                        0.50967233286369
                    ],
                    [
                        121.3706164062,
                        0.50900680239206
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1782,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.001812032888861466,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.3706164062,
                        0.50901217106113
                    ],
                    [
                        121.37038707733,
                        0.50828803440379
                    ],
                    [
                        121.37002766132,
                        0.50788571887066
                    ],
                    [
                        121.36968702078,
                        0.50750217803909
                    ],
                    [
                        121.36968702078,
                        0.50750217803909
                    ],
                    [
                        121.36968702078,
                        0.50750217803909
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1783,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.0003476213247552952,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.36964142323,
                        0.50742171492469
                    ],
                    [
                        121.36950060215,
                        0.50710389420659
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1784,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.016347285661093815,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.36950597167,
                        0.50710791248787
                    ],
                    [
                        121.36955022812,
                        0.5067914204939
                    ],
                    [
                        121.36953681629,
                        0.50669217630963
                    ],
                    [
                        121.36948451675,
                        0.5066251228014
                    ],
                    [
                        121.36938661415,
                        0.50658891846579
                    ],
                    [
                        121.36914253313,
                        0.50659025816098
                    ],
                    [
                        121.36892527342,
                        0.50659025816098
                    ],
                    [
                        121.36852294207,
                        0.50663588820631
                    ],
                    [
                        121.36819168925,
                        0.50664391666783
                    ],
                    [
                        121.36810719967,
                        0.50664525995127
                    ],
                    [
                        121.36803075671,
                        0.50659964335443
                    ],
                    [
                        121.36801868677,
                        0.50655538194136
                    ],
                    [
                        121.36802136898,
                        0.50649636969861
                    ],
                    [
                        121.36801466346,
                        0.50637969890805
                    ],
                    [
                        121.36801734567,
                        0.50618122616482
                    ],
                    [
                        121.36801868677,
                        0.50568639351407
                    ],
                    [
                        121.36802405119,
                        0.50538867990238
                    ],
                    [
                        121.3679677248,
                        0.50489785472899
                    ],
                    [
                        121.36794894934,
                        0.50438288759766
                    ],
                    [
                        121.36794090271,
                        0.50391084006052
                    ],
                    [
                        121.36795029044,
                        0.50322424487376
                    ],
                    [
                        121.36794760823,
                        0.50286213681141
                    ],
                    [
                        121.36796370149,
                        0.50212053825889
                    ],
                    [
                        121.3679972291,
                        0.50100209251653
                    ],
                    [
                        121.36801868677,
                        0.50016527970572
                    ],
                    [
                        121.3679677248,
                        0.49934321317105
                    ],
                    [
                        121.36793285608,
                        0.49885775175848
                    ],
                    [
                        121.36790201068,
                        0.49831059588588
                    ],
                    [
                        121.36783629656,
                        0.49781835251736
                    ],
                    [
                        121.36775717139,
                        0.49731012803275
                    ],
                    [
                        121.36765524745,
                        0.49677505416308
                    ],
                    [
                        121.36742189527,
                        0.49569551965738
                    ],
                    [
                        121.36730253696,
                        0.4950692375921
                    ],
                    [
                        121.36720463634,
                        0.49455825640819
                    ],
                    [
                        121.3671040535,
                        0.49424849288277
                    ],
                    [
                        121.36702761054,
                        0.49379655225717
                    ],
                    [
                        121.36699944735,
                        0.49346261400849
                    ],
                    [
                        121.36700078845,
                        0.49317698346863
                    ],
                    [
                        121.36701017618,
                        0.49306177473424
                    ],
                    [
                        121.36703699827,
                        0.49276018837579
                    ],
                    [
                        121.3670450449,
                        0.49262198310812
                    ],
                    [
                        121.36705711484,
                        0.49243547308216
                    ],
                    [
                        121.36711478233,
                        0.49235228155811
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1785,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0021287999560185263,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44143611193,
                        0.4829944468483
                    ],
                    [
                        121.44135564566,
                        0.48275695407967
                    ],
                    [
                        121.44128188491,
                        0.48245131210548
                    ],
                    [
                        121.44117727876,
                        0.48207052927146
                    ],
                    [
                        121.44114777446,
                        0.48196223315032
                    ],
                    [
                        121.44106864929,
                        0.48167789185803
                    ],
                    [
                        121.44097074866,
                        0.48131023839924
                    ],
                    [
                        121.44092649221,
                        0.48111433545325
                    ],
                    [
                        121.44093587995,
                        0.48093453411433
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1786,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002363331665133916,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44099354744,
                        0.48311781812767
                    ],
                    [
                        121.44082054496,
                        0.48238421314186
                    ],
                    [
                        121.44036054611,
                        0.48253306377057
                    ],
                    [
                        121.43978655338,
                        0.48272217436754
                    ],
                    [
                        121.43928229809,
                        0.48285625923109
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1787,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0003200460739629875,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4513349831,
                        0.49874472614745
                    ],
                    [
                        121.45155072212,
                        0.49898112869546
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1788,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.02798765134668825,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45155608654,
                        0.49900526766111
                    ],
                    [
                        121.45144075155,
                        0.49885775175848
                    ],
                    [
                        121.45134419203,
                        0.49875046746358
                    ],
                    [
                        121.45096868277,
                        0.49837765452519
                    ],
                    [
                        121.45072460175,
                        0.49816040381037
                    ],
                    [
                        121.45012110472,
                        0.49764275701654
                    ],
                    [
                        121.44955247641,
                        0.4972431229355
                    ],
                    [
                        121.44906431437,
                        0.49689981310159
                    ],
                    [
                        121.44866734743,
                        0.49647335789243
                    ],
                    [
                        121.44846886396,
                        0.49622392181394
                    ],
                    [
                        121.44820064306,
                        0.49587256560141
                    ],
                    [
                        121.44803702831,
                        0.49565263269553
                    ],
                    [
                        121.4477661252,
                        0.49528518379991
                    ],
                    [
                        121.44743084908,
                        0.49486409270467
                    ],
                    [
                        121.44701510668,
                        0.49434912776208
                    ],
                    [
                        121.44659936428,
                        0.49377515637276
                    ],
                    [
                        121.44634455442,
                        0.4934693958928
                    ],
                    [
                        121.44590198994,
                        0.4929651592811
                    ],
                    [
                        121.44540846348,
                        0.49246092263123
                    ],
                    [
                        121.44512414932,
                        0.49213102310029
                    ],
                    [
                        121.44482374191,
                        0.49172870657708
                    ],
                    [
                        121.44454479218,
                        0.49142831022393
                    ],
                    [
                        121.44391179085,
                        0.49091334501569
                    ],
                    [
                        121.44382596016,
                        0.49084895799845
                    ],
                    [
                        121.44357249141,
                        0.49107021798635
                    ],
                    [
                        121.44328013062,
                        0.49133978124303
                    ],
                    [
                        121.44283622503,
                        0.4917582097896
                    ],
                    [
                        121.44239768386,
                        0.49213101714997
                    ],
                    [
                        121.4420811832,
                        0.49240325057312
                    ],
                    [
                        121.44168689847,
                        0.49294235167899
                    ],
                    [
                        121.44139051437,
                        0.49336747572969
                    ],
                    [
                        121.44125908613,
                        0.49350561106553
                    ],
                    [
                        121.44111290574,
                        0.49353512765842
                    ],
                    [
                        121.44104853272,
                        0.49351768130216
                    ],
                    [
                        121.44094660878,
                        0.49347477126873
                    ],
                    [
                        121.44083529711,
                        0.49340502526364
                    ],
                    [
                        121.44074544311,
                        0.49330847452528
                    ],
                    [
                        121.4406850934,
                        0.49319313860495
                    ],
                    [
                        121.4406260848,
                        0.49306440849753
                    ],
                    [
                        121.44057512283,
                        0.49289542442753
                    ],
                    [
                        121.44054293633,
                        0.4925789354676
                    ],
                    [
                        121.44048258662,
                        0.49204389989358
                    ],
                    [
                        121.44044369459,
                        0.4914470849964
                    ],
                    [
                        121.44038200378,
                        0.49103403998993
                    ],
                    [
                        121.44034445286,
                        0.4908033784817
                    ],
                    [
                        121.44026130438,
                        0.49021063201129
                    ],
                    [
                        121.44021034241,
                        0.4898458649265
                    ],
                    [
                        121.44009500742,
                        0.48943281982121
                    ],
                    [
                        121.43997967243,
                        0.48914187248914
                    ],
                    [
                        121.43989518285,
                        0.48881869815544
                    ],
                    [
                        121.43980666995,
                        0.4883600199006
                    ],
                    [
                        121.43966853619,
                        0.4876921160672
                    ],
                    [
                        121.43958538771,
                        0.487131562105
                    ],
                    [
                        121.43950760365,
                        0.48633228373408
                    ],
                    [
                        121.43944054842,
                        0.48566847352894
                    ],
                    [
                        121.43942177296,
                        0.48526216989524
                    ],
                    [
                        121.43937215209,
                        0.48479415829978
                    ],
                    [
                        121.43937081099,
                        0.48454606507391
                    ],
                    [
                        121.4393158257,
                        0.48408468805196
                    ],
                    [
                        121.43927693367,
                        0.4837359895149
                    ],
                    [
                        121.43924474716,
                        0.48338459992085
                    ],
                    [
                        121.43920585513,
                        0.48302252648134
                    ],
                    [
                        121.43914282322,
                        0.48268327999808
                    ],
                    [
                        121.43906906247,
                        0.48223937303645
                    ],
                    [
                        121.43904626369,
                        0.48212540624758
                    ],
                    [
                        121.43907308578,
                        0.48207710588063
                    ],
                    [
                        121.43910393119,
                        0.48204490266065
                    ],
                    [
                        121.43997699022,
                        0.4817268958551
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1789,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0016300003478424215,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4399689436,
                        0.48173379080761
                    ],
                    [
                        121.44009634852,
                        0.48168820527897
                    ],
                    [
                        121.44016474485,
                        0.48163059709481
                    ],
                    [
                        121.44011378288,
                        0.48143475961173
                    ],
                    [
                        121.44009768963,
                        0.48134893195269
                    ],
                    [
                        121.44005209208,
                        0.48120139929776
                    ],
                    [
                        121.44009500742,
                        0.48110618200382
                    ],
                    [
                        121.44017145038,
                        0.48105119493826
                    ],
                    [
                        121.44022375345,
                        0.48103244245066
                    ],
                    [
                        121.43993139267,
                        0.48038873494362
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2177,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0005350142348365505,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47526682915,
                        0.51053568285455
                    ],
                    [
                        121.47519842301,
                        0.51049004097731
                    ],
                    [
                        121.47488594055,
                        0.51027081144459
                    ],
                    [
                        121.47488728166,
                        0.51027081144459
                    ],
                    [
                        121.47488728166,
                        0.51027081144459
                    ],
                    [
                        121.47483764587,
                        0.51022184699889
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1790,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00042937674946172844,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94460242987,
                        0.46519319717264
                    ],
                    [
                        121.94458097219,
                        0.46514760112216
                    ],
                    [
                        121.94457426667,
                        0.46510871037297
                    ],
                    [
                        121.9445823133,
                        0.46504433947727
                    ],
                    [
                        121.94458767772,
                        0.46500678978787
                    ],
                    [
                        121.94458767772,
                        0.46499069706377
                    ],
                    [
                        121.94458767772,
                        0.46499069706377
                    ],
                    [
                        121.94460511208,
                        0.4647707631641
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1791,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0070994909397280835,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43991932273,
                        0.48037934754203
                    ],
                    [
                        121.43976911902,
                        0.48015673201475
                    ],
                    [
                        121.43964573741,
                        0.47996361974425
                    ],
                    [
                        121.4395545423,
                        0.47979330544563
                    ],
                    [
                        121.43931180239,
                        0.47940708087866
                    ],
                    [
                        121.43917500973,
                        0.47913618724578
                    ],
                    [
                        121.43894165754,
                        0.47885188302551
                    ],
                    [
                        121.43880218267,
                        0.47866145283363
                    ],
                    [
                        121.43840789795,
                        0.47801774510365
                    ],
                    [
                        121.43811821938,
                        0.47737403731333
                    ],
                    [
                        121.43697828054,
                        0.47397579560681
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1873,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.007966313201392494,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82088017464,
                        0.63434556558901
                    ],
                    [
                        121.82091102004,
                        0.63452392155377
                    ],
                    [
                        121.82094186544,
                        0.63466338786778
                    ],
                    [
                        121.82094722986,
                        0.63479883111144
                    ],
                    [
                        121.8209579587,
                        0.6349946203485
                    ],
                    [
                        121.82096600533,
                        0.63520650184325
                    ],
                    [
                        121.82098612189,
                        0.63534060405063
                    ],
                    [
                        121.82102903724,
                        0.63548275238666
                    ],
                    [
                        121.82107999921,
                        0.63559405721308
                    ],
                    [
                        121.82116448879,
                        0.63569731590532
                    ],
                    [
                        121.82130932808,
                        0.63580996174905
                    ],
                    [
                        121.82148769498,
                        0.63591322043699
                    ],
                    [
                        121.82163521647,
                        0.63597490744437
                    ],
                    [
                        121.82162851095,
                        0.63625249896848
                    ],
                    [
                        121.8216137588,
                        0.63644292406333
                    ],
                    [
                        121.82160168886,
                        0.636685648998
                    ],
                    [
                        121.82160839438,
                        0.63679561277681
                    ],
                    [
                        121.82168215513,
                        0.63706247608388
                    ],
                    [
                        121.82176530361,
                        0.63725826523508
                    ],
                    [
                        121.8218806386,
                        0.63751574136776
                    ],
                    [
                        121.82197988033,
                        0.63775712523046
                    ],
                    [
                        121.8220308423,
                        0.63818893411216
                    ],
                    [
                        121.8220603466,
                        0.6385107792178
                    ],
                    [
                        121.82208716869,
                        0.63887285493757
                    ],
                    [
                        121.82214617729,
                        0.63917860774772
                    ],
                    [
                        121.82205632329,
                        0.63932209699885
                    ],
                    [
                        121.82197183371,
                        0.6393958531544
                    ],
                    [
                        121.82188734412,
                        0.63946424522498
                    ],
                    [
                        121.82182163,
                        0.63957420894438
                    ],
                    [
                        121.82181894779,
                        0.63964796509632
                    ],
                    [
                        121.82184174657,
                        0.63970965205893
                    ],
                    [
                        121.8218819797,
                        0.63974049553997
                    ],
                    [
                        121.82192355394,
                        0.63977402106262
                    ],
                    [
                        121.82197719812,
                        0.63979681841789
                    ],
                    [
                        121.82206168771,
                        0.63981425168952
                    ],
                    [
                        121.82215690613,
                        0.6398276618984
                    ],
                    [
                        121.82232454419,
                        0.63984375414903
                    ],
                    [
                        121.82254046202,
                        0.63985984639962
                    ],
                    [
                        121.82272285223,
                        0.63984911823258
                    ],
                    [
                        121.82292670012,
                        0.6398276618984
                    ],
                    [
                        121.82321637869,
                        0.63980084148058
                    ],
                    [
                        121.82359725237,
                        0.63978340820892
                    ],
                    [
                        121.82387217879,
                        0.63978474922983
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1794,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 8.984787682439844e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94806625169,
                        0.45092296019173
                    ],
                    [
                        121.94797909585,
                        0.45092161912876
                    ],
                    [
                        121.94798177757,
                        0.45092161912876
                    ],
                    [
                        121.94798177757,
                        0.45092161912876
                    ],
                    [
                        121.94798177757,
                        0.45092161912876
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1795,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004807293847568632,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43698096275,
                        0.47397445454819
                    ],
                    [
                        121.43680661917,
                        0.47378938845617
                    ],
                    [
                        121.4369340241,
                        0.47367539846949
                    ],
                    [
                        121.4371137321,
                        0.47350240189791
                    ],
                    [
                        121.43719419837,
                        0.47342193837476
                    ],
                    [
                        121.43702656031,
                        0.47316579615321
                    ],
                    [
                        121.43687769771,
                        0.4729807300396
                    ],
                    [
                        121.43670603633,
                        0.47275945533208
                    ],
                    [
                        121.43650084734,
                        0.47244296543511
                    ],
                    [
                        121.4363412559,
                        0.47224985294853
                    ],
                    [
                        121.43622592092,
                        0.47209160799025
                    ],
                    [
                        121.43606498837,
                        0.47182473724735
                    ],
                    [
                        121.43594160676,
                        0.47159541614856
                    ],
                    [
                        121.43580883741,
                        0.47132988644578
                    ],
                    [
                        121.43568009138,
                        0.47105899249614
                    ],
                    [
                        121.43552184105,
                        0.47075591311426
                    ],
                    [
                        121.43543064594,
                        0.47056548269945
                    ],
                    [
                        121.43532603979,
                        0.4703415257965
                    ],
                    [
                        121.43513694406,
                        0.46998614506747
                    ],
                    [
                        121.43513694406,
                        0.46998614506747
                    ],
                    [
                        121.43513694406,
                        0.46998614506747
                    ],
                    [
                        121.43513694406,
                        0.46998614506747
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1796,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.00019873503836914745,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95244922301,
                        0.45112277857224
                    ],
                    [
                        121.95251301696,
                        0.45094307613633
                    ],
                    [
                        121.95252106211,
                        0.45094307613633
                    ],
                    [
                        121.95252106211,
                        0.45094307613633
                    ],
                    [
                        121.95252106211,
                        0.45094307613633
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1797,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00397130160611893,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43528982997,
                        0.47026240329612
                    ],
                    [
                        121.43560096622,
                        0.4701081814708
                    ],
                    [
                        121.43565058708,
                        0.47019266821031
                    ],
                    [
                        121.43569752574,
                        0.47025972117744
                    ],
                    [
                        121.43575116992,
                        0.4703240920253
                    ],
                    [
                        121.43580883741,
                        0.47040321452496
                    ],
                    [
                        121.4358356595,
                        0.47045819795641
                    ],
                    [
                        121.43596440554,
                        0.4705842575293
                    ],
                    [
                        121.43608778715,
                        0.47068215485562
                    ],
                    [
                        121.43615216017,
                        0.47074652569958
                    ],
                    [
                        121.43623799086,
                        0.47082564819445
                    ],
                    [
                        121.43630102277,
                        0.47091013492528
                    ],
                    [
                        121.43632248044,
                        0.4710455819043
                    ],
                    [
                        121.43633589149,
                        0.47114750240164
                    ],
                    [
                        121.43631979823,
                        0.47127356196207
                    ],
                    [
                        121.43628358841,
                        0.47137280033782
                    ],
                    [
                        121.43625676632,
                        0.47146131023933
                    ],
                    [
                        121.43628895283,
                        0.47155384331698
                    ],
                    [
                        121.43632516265,
                        0.4716705154566
                    ],
                    [
                        121.43638148904,
                        0.47179791606661
                    ],
                    [
                        121.43640965223,
                        0.47185424054607
                    ],
                    [
                        121.43645256758,
                        0.47189447231685
                    ],
                    [
                        121.43652096391,
                        0.47194006832344
                    ],
                    [
                        121.4365772903,
                        0.47198968750674
                    ],
                    [
                        121.43664970994,
                        0.47204601198466
                    ],
                    [
                        121.43673554063,
                        0.47212379340578
                    ],
                    [
                        121.43676236272,
                        0.47217609470572
                    ],
                    [
                        121.43677711487,
                        0.47220425694398
                    ],
                    [
                        121.43681868911,
                        0.4722297370642
                    ],
                    [
                        121.43688037992,
                        0.47226326353805
                    ],
                    [
                        121.43695682287,
                        0.47233031648526
                    ],
                    [
                        121.43699705601,
                        0.47235579660504
                    ],
                    [
                        121.43702924252,
                        0.47240407472644
                    ],
                    [
                        121.43707081676,
                        0.47250063096826
                    ],
                    [
                        121.43710300326,
                        0.47264546532848
                    ],
                    [
                        121.43713787198,
                        0.47278359439142
                    ],
                    [
                        121.43713787198,
                        0.47281041556837
                    ],
                    [
                        121.43710032105,
                        0.47284796521593
                    ],
                    [
                        121.43703326583,
                        0.47288551486329
                    ],
                    [
                        121.43698364496,
                        0.47291099498103
                    ],
                    [
                        121.43688708544,
                        0.47297134262791
                    ],
                    [
                        121.43688708544,
                        0.47297134262791
                    ],
                    [
                        121.43688708544,
                        0.47297134262791
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1798,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006167071448397201,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4357149601,
                        0.47113006863246
                    ],
                    [
                        121.43623128533,
                        0.47083503560905
                    ],
                    [
                        121.43622860312,
                        0.47083235349058
                    ],
                    [
                        121.43622860312,
                        0.47083235349058
                    ],
                    [
                        121.43624335527,
                        0.47082162501677
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1799,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43683075905,
                        0.47225253506644
                    ],
                    [
                        121.43683075905,
                        0.47225253506644
                    ],
                    [
                        121.43683075905,
                        0.47225253506644
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1800,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43683075905,
                        0.47225253506644
                    ],
                    [
                        121.43683075905,
                        0.47225253506644
                    ],
                    [
                        121.43683075905,
                        0.47225253506644
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1801,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004023197662487816,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43651157618,
                        0.47246174025991
                    ],
                    [
                        121.43679454923,
                        0.47228203836333
                    ],
                    [
                        121.43682539463,
                        0.47226058142015
                    ],
                    [
                        121.43682539463,
                        0.47226058142015
                    ],
                    [
                        121.43684417009,
                        0.47223778341794
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1802,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0002803967156778912,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95737235433,
                        0.4532523862056
                    ],
                    [
                        121.95765259386,
                        0.45324299876779
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1803,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0002277769213794545,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43630504608,
                        0.47220425694398
                    ],
                    [
                        121.43614679575,
                        0.47231690589587
                    ],
                    [
                        121.43611997366,
                        0.47233702177994
                    ],
                    [
                        121.43611997366,
                        0.47233702177994
                    ],
                    [
                        121.43611997366,
                        0.47233702177994
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1804,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00018838135879599728,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43591612577,
                        0.47155786649424
                    ],
                    [
                        121.43576994538,
                        0.47163430686175
                    ],
                    [
                        121.43574848771,
                        0.47164369427526
                    ],
                    [
                        121.43574848771,
                        0.47164369427526
                    ],
                    [
                        121.43574848771,
                        0.47164369427526
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1805,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003073823079018602,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43575385213,
                        0.47164101215712
                    ],
                    [
                        121.43563181162,
                        0.47136743610134
                    ],
                    [
                        121.43562778831,
                        0.47136073080571
                    ],
                    [
                        121.43562778831,
                        0.47136073080571
                    ],
                    [
                        121.43562778831,
                        0.47136073080571
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1806,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0012943340124433797,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43575251102,
                        0.47164905851153
                    ],
                    [
                        121.43580079079,
                        0.47175500217718
                    ],
                    [
                        121.43584907055,
                        0.47186362795927
                    ],
                    [
                        121.43586918712,
                        0.47194006832344
                    ],
                    [
                        121.43591478467,
                        0.47203394245371
                    ],
                    [
                        121.4359523356,
                        0.47209160799025
                    ],
                    [
                        121.43605828285,
                        0.47224046553585
                    ],
                    [
                        121.43610656261,
                        0.47231690589587
                    ],
                    [
                        121.43615350127,
                        0.47236652507649
                    ],
                    [
                        121.43618568778,
                        0.47244430649404
                    ],
                    [
                        121.43617495894,
                        0.4724872203792
                    ],
                    [
                        121.43618434668,
                        0.47250733626279
                    ],
                    [
                        121.43622323871,
                        0.47253281638191
                    ],
                    [
                        121.43628761172,
                        0.47259986932651
                    ],
                    [
                        121.43634393811,
                        0.47265619379949
                    ],
                    [
                        121.43639355898,
                        0.47273799839036
                    ],
                    [
                        121.43639355898,
                        0.47273799839036
                    ],
                    [
                        121.43639355898,
                        0.47273799839036
                    ],
                    [
                        121.43639355898,
                        0.47273799839036
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1807,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0015487180788057117,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43719822168,
                        0.47341657413986
                    ],
                    [
                        121.43742755055,
                        0.47321675638653
                    ],
                    [
                        121.43746241927,
                        0.47323016697417
                    ],
                    [
                        121.43749728799,
                        0.47327308085448
                    ],
                    [
                        121.43757373095,
                        0.47337500131916
                    ],
                    [
                        121.43767163157,
                        0.47345814696028
                    ],
                    [
                        121.43776550889,
                        0.47353190518949
                    ],
                    [
                        121.43781512976,
                        0.47358152436142
                    ],
                    [
                        121.43789023161,
                        0.47364723623722
                    ],
                    [
                        121.43800422549,
                        0.47373976928573
                    ],
                    [
                        121.43806993961,
                        0.47384571291948
                    ],
                    [
                        121.43812224269,
                        0.4739301996136
                    ],
                    [
                        121.43815174699,
                        0.47404553065468
                    ],
                    [
                        121.43818259239,
                        0.47415817957669
                    ],
                    [
                        121.43818259239,
                        0.47415817957669
                    ],
                    [
                        121.43818259239,
                        0.47415817957669
                    ],
                    [
                        121.43818259239,
                        0.47415817957669
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1808,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0016340896504337889,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44021973014,
                        0.48103513497823
                    ],
                    [
                        121.44049465656,
                        0.48093320421393
                    ],
                    [
                        121.44098013639,
                        0.48082055540296
                    ],
                    [
                        121.44132345915,
                        0.48073740985079
                    ],
                    [
                        121.441578269,
                        0.48068913178778
                    ],
                    [
                        121.4417847991,
                        0.48064621795371
                    ],
                    [
                        121.44180357456,
                        0.48064353583907
                    ],
                    [
                        121.44180357456,
                        0.48064353583907
                    ],
                    [
                        121.44180357456,
                        0.48064353583907
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1809,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0010033067173994448,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44086077809,
                        0.48085542289227
                    ],
                    [
                        121.44093185663,
                        0.48094125055752
                    ],
                    [
                        121.44135698676,
                        0.48080580377281
                    ],
                    [
                        121.44151255488,
                        0.48076288993946
                    ],
                    [
                        121.44179418683,
                        0.48072400150914
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1810,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.003041487600067795,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44179016352,
                        0.48072936350698
                    ],
                    [
                        121.44183844328,
                        0.48075886676758
                    ],
                    [
                        121.44191354513,
                        0.48076020782488
                    ],
                    [
                        121.44201546907,
                        0.48077630051242
                    ],
                    [
                        121.44206106663,
                        0.48079909848637
                    ],
                    [
                        121.44210532308,
                        0.48086615135048
                    ],
                    [
                        121.44215762615,
                        0.48092113469858
                    ],
                    [
                        121.44222065806,
                        0.48103914773687
                    ],
                    [
                        121.44226491451,
                        0.48107669733954
                    ],
                    [
                        121.44231185317,
                        0.48108608474017
                    ],
                    [
                        121.44238695502,
                        0.48111022377031
                    ],
                    [
                        121.44250229001,
                        0.48117995874581
                    ],
                    [
                        121.44253984094,
                        0.48124701160619
                    ],
                    [
                        121.44257739186,
                        0.48131808763747
                    ],
                    [
                        121.44263505936,
                        0.48143073644024
                    ],
                    [
                        121.44268870354,
                        0.4815071766982
                    ],
                    [
                        121.44272089005,
                        0.48160909704083
                    ],
                    [
                        121.44274368882,
                        0.48169894786792
                    ],
                    [
                        121.44274368882,
                        0.48174320275247
                    ],
                    [
                        121.44272893667,
                        0.48182768934946
                    ],
                    [
                        121.44228368998,
                        0.4819550897715
                    ],
                    [
                        121.44184246659,
                        0.48208785441932
                    ],
                    [
                        121.44135028124,
                        0.48224073491965
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1811,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.004004370235107806,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.44122689962,
                        0.48076692203686
                    ],
                    [
                        121.44117057323,
                        0.48056843662878
                    ],
                    [
                        121.44111424685,
                        0.48035118533716
                    ],
                    [
                        121.44105792046,
                        0.48013929826833
                    ],
                    [
                        121.44064486027,
                        0.4794067684859
                    ],
                    [
                        121.44034445286,
                        0.47903118012797
                    ],
                    [
                        121.43996357918,
                        0.47821539456295
                    ],
                    [
                        121.43974363804,
                        0.47764647066628
                    ],
                    [
                        121.43963098526,
                        0.47713658600189
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1812,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.010894463863250716,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43962562084,
                        0.47713801110845
                    ],
                    [
                        121.43945664167,
                        0.47649016179838
                    ],
                    [
                        121.43904224038,
                        0.47530743916765
                    ],
                    [
                        121.43885582685,
                        0.47461810687136
                    ],
                    [
                        121.43874317408,
                        0.47445987461159
                    ],
                    [
                        121.43855005503,
                        0.47453505496206
                    ],
                    [
                        121.4384239912,
                        0.47435665624431
                    ],
                    [
                        121.43836095929,
                        0.47423998414984
                    ],
                    [
                        121.4383944869,
                        0.47419036498263
                    ],
                    [
                        121.43839582801,
                        0.47416756698677
                    ],
                    [
                        121.43833816051,
                        0.47406564653375
                    ],
                    [
                        121.43836095929,
                        0.47401736842389
                    ],
                    [
                        121.43846824765,
                        0.47392215326183
                    ],
                    [
                        121.43852457404,
                        0.47385644138863
                    ],
                    [
                        121.43851518631,
                        0.47380011692541
                    ],
                    [
                        121.43846958876,
                        0.47366198788271
                    ],
                    [
                        121.4384521544,
                        0.47357347800923
                    ],
                    [
                        121.43844142556,
                        0.47344339531436
                    ],
                    [
                        121.43842667341,
                        0.47332270002827
                    ],
                    [
                        121.43841996789,
                        0.47302096180385
                    ],
                    [
                        121.43841996789,
                        0.47282650827449
                    ],
                    [
                        121.43840521574,
                        0.47248990249701
                    ],
                    [
                        121.43839985132,
                        0.47233970389781
                    ],
                    [
                        121.43838778138,
                        0.47205942257457
                    ],
                    [
                        121.43834888935,
                        0.4718689921954
                    ],
                    [
                        121.43825903535,
                        0.47168392604724
                    ],
                    [
                        121.43825098872,
                        0.4715994393258
                    ],
                    [
                        121.43820002675,
                        0.47142376058428
                    ],
                    [
                        121.43817856908,
                        0.4713660950422
                    ],
                    [
                        121.43812358379,
                        0.47127356196207
                    ],
                    [
                        121.4380967617,
                        0.4711998037089
                    ],
                    [
                        121.43805518746,
                        0.47108044944304
                    ],
                    [
                        121.43803909421,
                        0.47100400906944
                    ],
                    [
                        121.4380055666,
                        0.47089136009629
                    ],
                    [
                        121.43797338009,
                        0.47077737006209
                    ],
                    [
                        121.43793717027,
                        0.4706674032038
                    ],
                    [
                        121.43789827824,
                        0.47050915820955
                    ],
                    [
                        121.43784463406,
                        0.47039516816911
                    ],
                    [
                        121.43780842423,
                        0.47029861189809
                    ],
                    [
                        121.4377681911,
                        0.47023021787199
                    ],
                    [
                        121.43771186471,
                        0.47023960528738
                    ],
                    [
                        121.43758043647,
                        0.47028922448279
                    ],
                    [
                        121.43746376038,
                        0.47033213838124
                    ],
                    [
                        121.43733635545,
                        0.47039248605049
                    ],
                    [
                        121.43728405237,
                        0.47042467147388
                    ],
                    [
                        121.43727734685,
                        0.47045283371922
                    ],
                    [
                        121.43729612231,
                        0.47051854562457
                    ],
                    [
                        121.43732964993,
                        0.47060303235912
                    ],
                    [
                        121.43737256527,
                        0.47070361180368
                    ],
                    [
                        121.43745034933,
                        0.47087526738569
                    ],
                    [
                        121.43753349781,
                        0.47108983685727
                    ],
                    [
                        121.43758311868,
                        0.4712681977255
                    ],
                    [
                        121.4376783371,
                        0.47156859496693
                    ],
                    [
                        121.4377078414,
                        0.47170270087409
                    ],
                    [
                        121.43776148558,
                        0.47183278360158
                    ],
                    [
                        121.43779501319,
                        0.47200443915576
                    ],
                    [
                        121.43780305982,
                        0.47225789930225
                    ],
                    [
                        121.43780976534,
                        0.47237323037113
                    ],
                    [
                        121.43778830767,
                        0.47255427332425
                    ],
                    [
                        121.43777221441,
                        0.47268703815354
                    ],
                    [
                        121.43775075674,
                        0.47281980298029
                    ],
                    [
                        121.43771722913,
                        0.47294854462803
                    ],
                    [
                        121.43770650029,
                        0.47302632603906
                    ],
                    [
                        121.43768638372,
                        0.47306655780305
                    ],
                    [
                        121.43768638372,
                        0.47306655780305
                    ],
                    [
                        121.43768638372,
                        0.47306655780305
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1813,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001121032581781715,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43768370152,
                        0.47305985250906
                    ],
                    [
                        121.43765956163,
                        0.47309606109648
                    ],
                    [
                        121.43765822053,
                        0.47312288227223
                    ],
                    [
                        121.43767699599,
                        0.4731818888585
                    ],
                    [
                        121.43772795796,
                        0.47327442191324
                    ],
                    [
                        121.4377976954,
                        0.47335890861431
                    ],
                    [
                        121.43787547946,
                        0.47348228601721
                    ],
                    [
                        121.43795996904,
                        0.47356677271575
                    ],
                    [
                        121.43802702427,
                        0.47364455411984
                    ],
                    [
                        121.43808737397,
                        0.47373172293373
                    ],
                    [
                        121.43819600344,
                        0.47385375927135
                    ],
                    [
                        121.43825501204,
                        0.47392751749634
                    ],
                    [
                        121.43827781081,
                        0.47396238502061
                    ],
                    [
                        121.43827781081,
                        0.47396238502061
                    ],
                    [
                        121.43827781081,
                        0.47396238502061
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1814,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006645008728660385,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.43772661686,
                        0.47293781615749
                    ],
                    [
                        121.43806323409,
                        0.47295927309857
                    ],
                    [
                        121.43811151385,
                        0.47297268368672
                    ],
                    [
                        121.43829524517,
                        0.47299011745128
                    ],
                    [
                        121.43838778138,
                        0.47299011745128
                    ],
                    [
                        121.43838778138,
                        0.47299011745128
                    ],
                    [
                        121.43838778138,
                        0.47299011745128
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1816,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.009145943006858911,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46014988422,
                        0.50412004426905
                    ],
                    [
                        121.45995274186,
                        0.50405567374407
                    ],
                    [
                        121.45983070135,
                        0.50402885269181
                    ],
                    [
                        121.45956516266,
                        0.50391084006052
                    ],
                    [
                        121.45937472582,
                        0.50380087374308
                    ],
                    [
                        121.45924195647,
                        0.5036801790023
                    ],
                    [
                        121.45906358957,
                        0.50347097477963
                    ],
                    [
                        121.4589831233,
                        0.50332077687205
                    ],
                    [
                        121.45896434784,
                        0.50325104212806
                    ],
                    [
                        121.4588946104,
                        0.50305524841983
                    ],
                    [
                        121.45885705948,
                        0.50287957049851
                    ],
                    [
                        121.45881280303,
                        0.50271462099559
                    ],
                    [
                        121.45873904228,
                        0.50243165883045
                    ],
                    [
                        121.45860224962,
                        0.50228950721679
                    ],
                    [
                        121.45836889744,
                        0.50220502087891
                    ],
                    [
                        121.458209306,
                        0.50218356403102
                    ],
                    [
                        121.45801350474,
                        0.50219563350797
                    ],
                    [
                        121.45758971572,
                        0.50221440824985
                    ],
                    [
                        121.45737916231,
                        0.50228950721679
                    ],
                    [
                        121.45718738437,
                        0.50233376196477
                    ],
                    [
                        121.45699962974,
                        0.5023941093479
                    ],
                    [
                        121.45680651069,
                        0.5025107809537
                    ],
                    [
                        121.45664289594,
                        0.50260599571089
                    ],
                    [
                        121.45642831922,
                        0.50272937257732
                    ],
                    [
                        121.45627677441,
                        0.50284067996569
                    ],
                    [
                        121.45604476333,
                        0.50299624209564
                    ],
                    [
                        121.45577386022,
                        0.50318264843613
                    ],
                    [
                        121.45557671785,
                        0.50332077687205
                    ],
                    [
                        121.45537957549,
                        0.50349109057058
                    ],
                    [
                        121.45523071289,
                        0.50357960004993
                    ],
                    [
                        121.45503893495,
                        0.50373113900422
                    ],
                    [
                        121.45490884781,
                        0.50381562532235
                    ],
                    [
                        121.45467281342,
                        0.50398728006057
                    ],
                    [
                        121.45446226001,
                        0.50415222953131
                    ],
                    [
                        121.45424365997,
                        0.5043252253132
                    ],
                    [
                        121.45404651761,
                        0.50446469477742
                    ],
                    [
                        121.45393520594,
                        0.50455052213854
                    ],
                    [
                        121.45386680961,
                        0.50460952844865
                    ],
                    [
                        121.4538064599,
                        0.5046524421284
                    ],
                    [
                        121.45371392369,
                        0.50470072001778
                    ],
                    [
                        121.45358249545,
                        0.50478654737576
                    ],
                    [
                        121.45345240831,
                        0.50487505683751
                    ],
                    [
                        121.45341083407,
                        0.5048281200019
                    ],
                    [
                        121.45339608192,
                        0.50479459369052
                    ],
                    [
                        121.45339608192,
                        0.50479459369052
                    ],
                    [
                        121.45339608192,
                        0.50479459369052
                    ],
                    [
                        121.45339608192,
                        0.50479459369052
                    ],
                    [
                        121.45339608192,
                        0.50479459369052
                    ],
                    [
                        121.45336523652,
                        0.50470474317521
                    ],
                    [
                        121.45332500339,
                        0.50458538950367
                    ],
                    [
                        121.45327135921,
                        0.50448346951277
                    ],
                    [
                        121.45320832729,
                        0.50435875162699
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1817,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0012009370380772985,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93075392378,
                        0.46294826186648
                    ],
                    [
                        121.93075284362,
                        0.46287450129455
                    ],
                    [
                        121.93078905344,
                        0.46265321511145
                    ],
                    [
                        121.93080246449,
                        0.46245475001308
                    ],
                    [
                        121.93080246449,
                        0.46218521091454
                    ],
                    [
                        121.9307633098,
                        0.46193173776029
                    ],
                    [
                        121.93071637973,
                        0.46176142302115
                    ],
                    [
                        121.93071772059,
                        0.46176142302115
                    ],
                    [
                        121.93071772059,
                        0.46176142302115
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1818,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.004595623986400529,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45320564508,
                        0.50435204636425
                    ],
                    [
                        121.45316943526,
                        0.50424610321198
                    ],
                    [
                        121.45313322544,
                        0.50414820637353
                    ],
                    [
                        121.45304337144,
                        0.50388133690236
                    ],
                    [
                        121.45298972726,
                        0.5037767347951
                    ],
                    [
                        121.45292535424,
                        0.50360239794594
                    ],
                    [
                        121.45287975669,
                        0.50345890530505
                    ],
                    [
                        121.45280733705,
                        0.50332480003033
                    ],
                    [
                        121.45269334316,
                        0.50299490104281
                    ],
                    [
                        121.45254984498,
                        0.50274948837054
                    ],
                    [
                        121.45242512226,
                        0.50241288408919
                    ],
                    [
                        121.45237013698,
                        0.50220233877294
                    ],
                    [
                        121.45233124495,
                        0.50196363133609
                    ],
                    [
                        121.45228162408,
                        0.50167396387296
                    ],
                    [
                        121.45224273205,
                        0.50145671326717
                    ],
                    [
                        121.45221188664,
                        0.50118716157963
                    ],
                    [
                        121.45219445229,
                        0.5009310204135
                    ],
                    [
                        121.45219042897,
                        0.50066415081094
                    ],
                    [
                        121.4521676302,
                        0.50041605594453
                    ],
                    [
                        121.45212337375,
                        0.50025647059308
                    ],
                    [
                        121.4520201087,
                        0.50021892109805
                    ],
                    [
                        121.45192891359,
                        0.50021489793785
                    ],
                    [
                        121.45187795162,
                        0.50024976532612
                    ],
                    [
                        121.45182564855,
                        0.50025244743291
                    ],
                    [
                        121.45182564855,
                        0.50025244743291
                    ],
                    [
                        121.45182564855,
                        0.50025244743291
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1820,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.00047857721572531147,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93341627152,
                        0.46728390987712
                    ],
                    [
                        121.93386286497,
                        0.46727049927804
                    ],
                    [
                        121.93389464743,
                        0.46727049927804
                    ],
                    [
                        121.93389464743,
                        0.46727049927804
                    ],
                    [
                        121.93389464743,
                        0.46727049927804
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1821,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.01072887169205394,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45022571087,
                        0.5060605470878
                    ],
                    [
                        121.45012915134,
                        0.50604043130481
                    ],
                    [
                        121.44953906536,
                        0.50600824605192
                    ],
                    [
                        121.44908308983,
                        0.50591705450114
                    ],
                    [
                        121.44851982594,
                        0.50579904190415
                    ],
                    [
                        121.44798874855,
                        0.50578294927711
                    ],
                    [
                        121.44736647606,
                        0.50590632608333
                    ],
                    [
                        121.44664227962,
                        0.50607261655756
                    ],
                    [
                        121.44608438015,
                        0.50616380810614
                    ],
                    [
                        121.44554793835,
                        0.50638374065918
                    ],
                    [
                        121.44525289536,
                        0.50658758057976
                    ],
                    [
                        121.44493639469,
                        0.50676996366113
                    ],
                    [
                        121.44469499588,
                        0.50688261203236
                    ],
                    [
                        121.44444823265,
                        0.50694161832126
                    ],
                    [
                        121.44427120686,
                        0.50698453198561
                    ],
                    [
                        121.444196105,
                        0.50704487932557
                    ],
                    [
                        121.44396141171,
                        0.50708913404119
                    ],
                    [
                        121.44379645586,
                        0.50711997823675
                    ],
                    [
                        121.44358187914,
                        0.50715216348414
                    ],
                    [
                        121.44339948893,
                        0.50716020979596
                    ],
                    [
                        121.443272084,
                        0.50716020979596
                    ],
                    [
                        121.44307762384,
                        0.50714277612033
                    ],
                    [
                        121.44284829497,
                        0.50711461402884
                    ],
                    [
                        121.44261226058,
                        0.50706499510544
                    ],
                    [
                        121.44234538078,
                        0.50700732986966
                    ],
                    [
                        121.44216567278,
                        0.50695771094543
                    ],
                    [
                        121.44188001752,
                        0.50685981414787
                    ],
                    [
                        121.44168287516,
                        0.50679678470207
                    ],
                    [
                        121.4413677156,
                        0.50670022895416
                    ],
                    [
                        121.44106596708,
                        0.50661976582978
                    ],
                    [
                        121.44079774618,
                        0.50653125639182
                    ],
                    [
                        121.44054695964,
                        0.50650443534977
                    ],
                    [
                        121.44030824304,
                        0.50649102482871
                    ],
                    [
                        121.44009903073,
                        0.50649773008924
                    ],
                    [
                        121.4399112761,
                        0.50654734901699
                    ],
                    [
                        121.43987774849,
                        0.50655137217329
                    ],
                    [
                        121.43987774849,
                        0.50655137217329
                    ],
                    [
                        121.43987774849,
                        0.50655137217329
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1822,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0007870604143134573,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93389484945,
                        0.46727452245776
                    ],
                    [
                        121.93390423547,
                        0.46743276752513
                    ],
                    [
                        121.93393105265,
                        0.46753334701525
                    ],
                    [
                        121.93394714296,
                        0.46761246954645
                    ],
                    [
                        121.93384523767,
                        0.46763526756376
                    ],
                    [
                        121.93375405926,
                        0.46765270134164
                    ],
                    [
                        121.93373260551,
                        0.46767281723915
                    ],
                    [
                        121.93375405926,
                        0.46770634373487
                    ],
                    [
                        121.93377149042,
                        0.46781094640048
                    ],
                    [
                        121.933775513,
                        0.46788202256982
                    ],
                    [
                        121.933775513,
                        0.46788202256982
                    ],
                    [
                        121.933775513,
                        0.46788202256982
                    ],
                    [
                        121.933775513,
                        0.46788202256982
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1823,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.004600113936603371,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45341351628,
                        0.50482543789699
                    ],
                    [
                        121.4533598721,
                        0.50486835157531
                    ],
                    [
                        121.45349532366,
                        0.50498904629407
                    ],
                    [
                        121.45341217518,
                        0.50504939365259
                    ],
                    [
                        121.45329147577,
                        0.50514863152986
                    ],
                    [
                        121.45319491625,
                        0.50524384624852
                    ],
                    [
                        121.45310103893,
                        0.50530955781411
                    ],
                    [
                        121.4530031383,
                        0.5054007493734
                    ],
                    [
                        121.45291462541,
                        0.5054825535652
                    ],
                    [
                        121.45272955298,
                        0.50560458932484
                    ],
                    [
                        121.45263567567,
                        0.50570114508909
                    ],
                    [
                        121.45250827074,
                        0.50574405876162
                    ],
                    [
                        121.45237147808,
                        0.50581513453113
                    ],
                    [
                        121.4521984756,
                        0.50588352819539
                    ],
                    [
                        121.45201072097,
                        0.50594119344118
                    ],
                    [
                        121.45175725222,
                        0.50602031552177
                    ],
                    [
                        121.45158156753,
                        0.50604847761802
                    ],
                    [
                        121.45141258836,
                        0.50607798076633
                    ],
                    [
                        121.45110681653,
                        0.50611821233201
                    ],
                    [
                        121.45079702139,
                        0.50613698706257
                    ],
                    [
                        121.45057708025,
                        0.50616380810614
                    ],
                    [
                        121.45038932562,
                        0.50615978494961
                    ],
                    [
                        121.45024716854,
                        0.50617721862787
                    ],
                    [
                        121.45019888878,
                        0.5061946523061
                    ],
                    [
                        121.45017609,
                        0.50625365860127
                    ],
                    [
                        121.45015731454,
                        0.50631534700021
                    ],
                    [
                        121.45015463233,
                        0.50643470063993
                    ],
                    [
                        121.45016670227,
                        0.50658892163185
                    ],
                    [
                        121.45015597343,
                        0.50677666892139
                    ],
                    [
                        121.45016133785,
                        0.50690809202083
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1824,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.01021679074856368,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45016402006,
                        0.506920161489
                    ],
                    [
                        121.45016402006,
                        0.50707035931339
                    ],
                    [
                        121.45016133785,
                        0.50722592134211
                    ],
                    [
                        121.4501157403,
                        0.50749144962389
                    ],
                    [
                        121.45006477833,
                        0.50768187899099
                    ],
                    [
                        121.44996553659,
                        0.50796349987569
                    ],
                    [
                        121.44989848137,
                        0.50815124712534
                    ],
                    [
                        121.44981533289,
                        0.5083604511971
                    ],
                    [
                        121.44974559546,
                        0.50862866153559
                    ],
                    [
                        121.44967585802,
                        0.50888614345006
                    ],
                    [
                        121.44961953163,
                        0.50916240007603
                    ],
                    [
                        121.44954174757,
                        0.50937696832104
                    ],
                    [
                        121.4494612813,
                        0.50968272805783
                    ],
                    [
                        121.44935667515,
                        0.51005017614338
                    ],
                    [
                        121.44927889109,
                        0.51035861795082
                    ],
                    [
                        121.44921183586,
                        0.51059196087357
                    ],
                    [
                        121.44915282726,
                        0.51088162793831
                    ],
                    [
                        121.44903749228,
                        0.51123030123967
                    ],
                    [
                        121.44892215729,
                        0.51161384184929
                    ],
                    [
                        121.44884705544,
                        0.51184986682843
                    ],
                    [
                        121.44876658916,
                        0.51209393810454
                    ],
                    [
                        121.44871562719,
                        0.51221463268818
                    ],
                    [
                        121.44860029221,
                        0.51251502808653
                    ],
                    [
                        121.44839644432,
                        0.51302462739076
                    ],
                    [
                        121.44819259644,
                        0.51355031926209
                    ],
                    [
                        121.44805580378,
                        0.51378097996749
                    ],
                    [
                        121.44799143076,
                        0.51396336284494
                    ],
                    [
                        121.44790291786,
                        0.51409746789857
                    ],
                    [
                        121.44777417183,
                        0.51436567799735
                    ],
                    [
                        121.44766688347,
                        0.5145748818666
                    ],
                    [
                        121.44758373499,
                        0.51474117211673
                    ],
                    [
                        121.44750326872,
                        0.51499060748382
                    ],
                    [
                        121.4473772049,
                        0.5153151416565
                    ],
                    [
                        121.44731014967,
                        0.51550020659052
                    ],
                    [
                        121.4472591877,
                        0.51565845051537
                    ],
                    [
                        121.4471706748,
                        0.51590520374624
                    ],
                    [
                        121.44711434841,
                        0.5161600032681
                    ],
                    [
                        121.4470821619,
                        0.51640407437944
                    ],
                    [
                        121.44703388214,
                        0.51658913928181
                    ],
                    [
                        121.44703388214,
                        0.51658913928181
                    ],
                    [
                        121.44703388214,
                        0.51658913928181
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1825,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.026230809699208425,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45350605249,
                        0.50497563576988
                    ],
                    [
                        121.45358249545,
                        0.50491126525335
                    ],
                    [
                        121.45370855927,
                        0.50482946105434
                    ],
                    [
                        121.45385071635,
                        0.50473290527715
                    ],
                    [
                        121.45403578877,
                        0.50459880002868
                    ],
                    [
                        121.45412966609,
                        0.50454784003353
                    ],
                    [
                        121.45426779985,
                        0.50444323793697
                    ],
                    [
                        121.45448237658,
                        0.50428767584155
                    ],
                    [
                        121.45455211401,
                        0.50423671584397
                    ],
                    [
                        121.45481899381,
                        0.50403824006011
                    ],
                    [
                        121.45497590303,
                        0.50391218111317
                    ],
                    [
                        121.45513415337,
                        0.50380087374308
                    ],
                    [
                        121.45524278283,
                        0.50371236426673
                    ],
                    [
                        121.4555297792,
                        0.50350181899237
                    ],
                    [
                        121.45565450191,
                        0.5034119684592
                    ],
                    [
                        121.45575106144,
                        0.50334893897998
                    ],
                    [
                        121.45586907864,
                        0.50324433686418
                    ],
                    [
                        121.45609304309,
                        0.50309548000419
                    ],
                    [
                        121.45622581244,
                        0.50301099367673
                    ],
                    [
                        121.45628347993,
                        0.50297478525035
                    ],
                    [
                        121.45641490817,
                        0.50287018312853
                    ],
                    [
                        121.45661205053,
                        0.50273473678885
                    ],
                    [
                        121.45671129227,
                        0.50266500203861
                    ],
                    [
                        121.45681723952,
                        0.50260599571089
                    ],
                    [
                        121.45693123341,
                        0.50254162517096
                    ],
                    [
                        121.45709082484,
                        0.50247591357746
                    ],
                    [
                        121.45723029971,
                        0.50241154303625
                    ],
                    [
                        121.4573456347,
                        0.50238338092427
                    ],
                    [
                        121.45748108625,
                        0.50234314933551
                    ],
                    [
                        121.4576420188,
                        0.50233376196477
                    ],
                    [
                        121.45768493414,
                        0.50232571564698
                    ],
                    [
                        121.45786195993,
                        0.50231364617027
                    ],
                    [
                        121.45794779062,
                        0.50231364617027
                    ],
                    [
                        121.45808190107,
                        0.50230559985246
                    ],
                    [
                        121.45818650723,
                        0.50230559985246
                    ],
                    [
                        121.45827502012,
                        0.50230962301137
                    ],
                    [
                        121.45834878087,
                        0.50232437459401
                    ],
                    [
                        121.45843058825,
                        0.50233912617663
                    ],
                    [
                        121.4585056901,
                        0.50237801671245
                    ],
                    [
                        121.45855128765,
                        0.50243165883045
                    ],
                    [
                        121.45862102509,
                        0.50249871147732
                    ],
                    [
                        121.45865857601,
                        0.50261538308125
                    ],
                    [
                        121.45870015025,
                        0.5027226673129
                    ],
                    [
                        121.45874172449,
                        0.50287688839282
                    ],
                    [
                        121.45876184106,
                        0.50298149051452
                    ],
                    [
                        121.45879000425,
                        0.50309682105699
                    ],
                    [
                        121.45882084966,
                        0.50321885686136
                    ],
                    [
                        121.45885303617,
                        0.50332748213586
                    ],
                    [
                        121.45889595151,
                        0.50343342530307
                    ],
                    [
                        121.45892947912,
                        0.50350047793965
                    ],
                    [
                        121.45897909999,
                        0.5035916695243
                    ],
                    [
                        121.45905286074,
                        0.50367481479154
                    ],
                    [
                        121.45911723375,
                        0.5037727116371
                    ],
                    [
                        121.45921245217,
                        0.50384646953345
                    ],
                    [
                        121.45932510495,
                        0.50393363795536
                    ],
                    [
                        121.4593975246,
                        0.50398728006057
                    ],
                    [
                        121.45950481296,
                        0.50403287584966
                    ],
                    [
                        121.45962551236,
                        0.50408651795404
                    ],
                    [
                        121.45981863141,
                        0.5041374779528
                    ],
                    [
                        121.45993798971,
                        0.5041656400572
                    ],
                    [
                        121.46010160446,
                        0.5042246463708
                    ],
                    [
                        121.46026656032,
                        0.5042742653159
                    ],
                    [
                        121.46047309041,
                        0.50433193057597
                    ],
                    [
                        121.46066218615,
                        0.50439630109822
                    ],
                    [
                        121.46078690887,
                        0.50443250951672
                    ],
                    [
                        121.46095454693,
                        0.5044794463552
                    ],
                    [
                        121.46113559604,
                        0.50453577056092
                    ],
                    [
                        121.46142929792,
                        0.50462830318357
                    ],
                    [
                        121.46155267954,
                        0.50468865054546
                    ],
                    [
                        121.46176055074,
                        0.5047825242184
                    ],
                    [
                        121.46190002561,
                        0.50488176209974
                    ],
                    [
                        121.46206766367,
                        0.50497295366503
                    ],
                    [
                        121.46228760481,
                        0.50510705890579
                    ],
                    [
                        121.46246999502,
                        0.50522641256775
                    ],
                    [
                        121.46263360977,
                        0.50532162728526
                    ],
                    [
                        121.46287500858,
                        0.50547853040826
                    ],
                    [
                        121.46304801106,
                        0.50558447354045
                    ],
                    [
                        121.46324113011,
                        0.50569443982771
                    ],
                    [
                        121.46343827248,
                        0.50581647558337
                    ],
                    [
                        121.4638607204,
                        0.50604713656582
                    ],
                    [
                        121.464009583,
                        0.50614369232347
                    ],
                    [
                        121.46426036954,
                        0.50628986700941
                    ],
                    [
                        121.46441593766,
                        0.50639044591984
                    ],
                    [
                        121.46461039782,
                        0.50650443534977
                    ],
                    [
                        121.46487995982,
                        0.5066546331838
                    ],
                    [
                        121.46507978439,
                        0.50675655314062
                    ],
                    [
                        121.46520316601,
                        0.50685176783568
                    ],
                    [
                        121.4655290544,
                        0.50700867092166
                    ],
                    [
                        121.46564438939,
                        0.50708376983326
                    ],
                    [
                        121.46584689617,
                        0.50720178240687
                    ],
                    [
                        121.4661540091,
                        0.50736539074401
                    ],
                    [
                        121.46649867296,
                        0.50754240959591
                    ],
                    [
                        121.46666362882,
                        0.50763628322754
                    ],
                    [
                        121.46684065461,
                        0.50775563684292
                    ],
                    [
                        121.46711289883,
                        0.50788974202611
                    ],
                    [
                        121.46732211113,
                        0.50800104932606
                    ],
                    [
                        121.46764934063,
                        0.50818879657461
                    ],
                    [
                        121.46821126342,
                        0.50852137740154
                    ],
                    [
                        121.46852374077,
                        0.50872655830637
                    ],
                    [
                        121.46900519729,
                        0.50898538126852
                    ],
                    [
                        121.46932035685,
                        0.50915703586981
                    ],
                    [
                        121.46964222193,
                        0.50934880623929
                    ],
                    [
                        121.47002846003,
                        0.50956471552956
                    ],
                    [
                        121.47030472755,
                        0.50973234696112
                    ],
                    [
                        121.47057831287,
                        0.50988790892572
                    ],
                    [
                        121.47091761231,
                        0.51009176658661
                    ],
                    [
                        121.47110939026,
                        0.51019368425781
                    ],
                    [
                        121.47135481238,
                        0.51032240956549
                    ],
                    [
                        121.47163107991,
                        0.51045919679787
                    ],
                    [
                        121.47190198302,
                        0.51061073559113
                    ],
                    [
                        121.4721621573,
                        0.51074752281737
                    ],
                    [
                        121.47234991193,
                        0.51085747562855
                    ],
                    [
                        121.47257253528,
                        0.51098757098188
                    ],
                    [
                        121.47270530462,
                        0.51105328248904
                    ],
                    [
                        121.47289976478,
                        0.51116726291113
                    ],
                    [
                        121.47313177586,
                        0.51130405905099
                    ],
                    [
                        121.47325113416,
                        0.51138318106583
                    ],
                    [
                        121.47344693542,
                        0.51148241884577
                    ],
                    [
                        121.47355556488,
                        0.51154142509258
                    ],
                    [
                        121.47362932563,
                        0.51158299767524
                    ],
                    [
                        121.47371917963,
                        0.51163664120453
                    ],
                    [
                        121.47380501032,
                        0.51168491755415
                    ],
                    [
                        121.47389620543,
                        0.51173990808393
                    ],
                    [
                        121.47397533059,
                        0.51163127551281
                    ],
                    [
                        121.4740075171,
                        0.51157629241999
                    ],
                    [
                        121.4741268754,
                        0.51140061472998
                    ],
                    [
                        121.47421404719,
                        0.51127992013101
                    ],
                    [
                        121.47435083985,
                        0.51105060038672
                    ],
                    [
                        121.47440850735,
                        0.51096477311189
                    ],
                    [
                        121.47449299693,
                        0.51082932694148
                    ],
                    [
                        121.47456273437,
                        0.51072874810021
                    ],
                    [
                        121.47467002273,
                        0.51057050405344
                    ],
                    [
                        121.47485241294,
                        0.51070595022931
                    ],
                    [
                        121.47491410375,
                        0.51076629753447
                    ],
                    [
                        121.47501602769,
                        0.51084005535112
                    ],
                    [
                        121.4751380682,
                        0.51092185947405
                    ],
                    [
                        121.47514611483,
                        0.51091917737169
                    ],
                    [
                        121.47514611483,
                        0.51091917737169
                    ],
                    [
                        121.47514611483,
                        0.51091917737169
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1827,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.013677077575816512,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47120192647,
                        0.49624403762707
                    ],
                    [
                        121.47128239274,
                        0.49604019738452
                    ],
                    [
                        121.47139236331,
                        0.49583367502713
                    ],
                    [
                        121.47143930197,
                        0.49568615905361
                    ],
                    [
                        121.4715090394,
                        0.4955440072942
                    ],
                    [
                        121.47164046764,
                        0.49524629322217
                    ],
                    [
                        121.47175043821,
                        0.49502501924104
                    ],
                    [
                        121.47182554007,
                        0.49489896012122
                    ],
                    [
                        121.47187516093,
                        0.49477558310801
                    ],
                    [
                        121.47200524807,
                        0.49448591532885
                    ],
                    [
                        121.47212460637,
                        0.49426330026776
                    ],
                    [
                        121.47221446037,
                        0.49406482418292
                    ],
                    [
                        121.47229894996,
                        0.49386768914682
                    ],
                    [
                        121.47238209844,
                        0.49368128254269
                    ],
                    [
                        121.47252693772,
                        0.49338490944191
                    ],
                    [
                        121.47267580032,
                        0.49308987738276
                    ],
                    [
                        121.47277906537,
                        0.49290481181173
                    ],
                    [
                        121.47292658687,
                        0.49253199854429
                    ],
                    [
                        121.47305801511,
                        0.49226781071267
                    ],
                    [
                        121.47319614887,
                        0.49194595750263
                    ],
                    [
                        121.47338524461,
                        0.49154900518887
                    ],
                    [
                        121.47354617715,
                        0.49117216868
                    ],
                    [
                        121.4736802876,
                        0.49092541451321
                    ],
                    [
                        121.47386804223,
                        0.49051639264059
                    ],
                    [
                        121.47392839193,
                        0.49035278388454
                    ],
                    [
                        121.47404506803,
                        0.49012614551915
                    ],
                    [
                        121.47434413433,
                        0.48951060104428
                    ],
                    [
                        121.47453054786,
                        0.48907207586105
                    ],
                    [
                        121.47480815649,
                        0.48850480929713
                    ],
                    [
                        121.47496506572,
                        0.48816954534794
                    ],
                    [
                        121.47524535656,
                        0.48757948075677
                    ],
                    [
                        121.47539287806,
                        0.48723885253742
                    ],
                    [
                        121.47559806705,
                        0.48680300931826
                    ],
                    [
                        121.47577509284,
                        0.48645969894732
                    ],
                    [
                        121.47597625852,
                        0.48602385567781
                    ],
                    [
                        121.47624582052,
                        0.485448542519
                    ],
                    [
                        121.47639334202,
                        0.48512668898224
                    ],
                    [
                        121.47659450769,
                        0.4846546371006
                    ],
                    [
                        121.47668704391,
                        0.48447223779063
                    ],
                    [
                        121.47677823901,
                        0.48434619409199
                    ],
                    [
                        121.47677823901,
                        0.48434619409199
                    ],
                    [
                        121.47685870528,
                        0.48433545968894
                    ],
                    [
                        121.47729054093,
                        0.48444280371877
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1828,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0019412268085274372,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94809257048,
                        0.46662410837227
                    ],
                    [
                        121.94815100221,
                        0.46584361139031
                    ],
                    [
                        121.9483044262,
                        0.46555394238532
                    ],
                    [
                        121.94835752642,
                        0.46513553157933
                    ],
                    [
                        121.94839828634,
                        0.46496655797756
                    ],
                    [
                        121.94863159581,
                        0.46499606130515
                    ],
                    [
                        121.94863159581,
                        0.46499606130515
                    ],
                    [
                        121.94863159581,
                        0.46499606130515
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1829,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0028029181844467627,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4712703228,
                        0.51018025812484
                    ],
                    [
                        121.47137492895,
                        0.510048835092
                    ],
                    [
                        121.47147685289,
                        0.50992679941626
                    ],
                    [
                        121.47169008851,
                        0.50966797649191
                    ],
                    [
                        121.47179603577,
                        0.50952582503681
                    ],
                    [
                        121.47209778428,
                        0.5091878800555
                    ],
                    [
                        121.4722828567,
                        0.50895319603027
                    ],
                    [
                        121.47246927023,
                        0.508727899358
                    ],
                    [
                        121.47259131074,
                        0.50858708893386
                    ],
                    [
                        121.47265031934,
                        0.50850394372958
                    ],
                    [
                        121.47266104817,
                        0.50844359640322
                    ],
                    [
                        121.47261679173,
                        0.50838056697288
                    ],
                    [
                        121.47259399295,
                        0.5083604511971
                    ],
                    [
                        121.47251620889,
                        0.50832424280055
                    ],
                    [
                        121.47240757942,
                        0.50826925967947
                    ],
                    [
                        121.47233515978,
                        0.50823171023067
                    ],
                    [
                        121.47227481008,
                        0.5081981839369
                    ],
                    [
                        121.47227481008,
                        0.5081981839369
                    ],
                    [
                        121.47227481008,
                        0.5081981839369
                    ],
                    [
                        121.47218763828,
                        0.50814185976298
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1830,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0011963317362372996,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47266507149,
                        0.50844359640322
                    ],
                    [
                        121.47283539176,
                        0.50828267019686
                    ],
                    [
                        121.47291854024,
                        0.50818611447111
                    ],
                    [
                        121.47302851081,
                        0.50802518825833
                    ],
                    [
                        121.47319480777,
                        0.5078240304867
                    ],
                    [
                        121.4734429121,
                        0.50753972749214
                    ],
                    [
                        121.473441571,
                        0.50753972749214
                    ],
                    [
                        121.473441571,
                        0.50753972749214
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1831,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0020443576604991394,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4729078114,
                        0.50818075026408
                    ],
                    [
                        121.47284075618,
                        0.50814051871122
                    ],
                    [
                        121.47275358438,
                        0.50808151243325
                    ],
                    [
                        121.47266373038,
                        0.5080278703619
                    ],
                    [
                        121.4725510776,
                        0.5079728872383
                    ],
                    [
                        121.47245317698,
                        0.50789778833701
                    ],
                    [
                        121.47241160274,
                        0.50787767255975
                    ],
                    [
                        121.47235795856,
                        0.50783475890134
                    ],
                    [
                        121.47233515978,
                        0.5077864810353
                    ],
                    [
                        121.47231370211,
                        0.50773149790966
                    ],
                    [
                        121.47234991193,
                        0.50768053793911
                    ],
                    [
                        121.47238343954,
                        0.50764030638315
                    ],
                    [
                        121.47241294384,
                        0.50766712742049
                    ],
                    [
                        121.47248804569,
                        0.50772881580596
                    ],
                    [
                        121.47254705429,
                        0.50778916313899
                    ],
                    [
                        121.47264763713,
                        0.50785487467875
                    ],
                    [
                        121.47268652916,
                        0.50791924516606
                    ],
                    [
                        121.47270798683,
                        0.50792460937329
                    ],
                    [
                        121.47272273898,
                        0.5079138809588
                    ],
                    [
                        121.47274151444,
                        0.50789778833701
                    ],
                    [
                        121.47279515862,
                        0.50784012310866
                    ],
                    [
                        121.4728474617,
                        0.50775965999845
                    ],
                    [
                        121.47286757827,
                        0.50771540528741
                    ],
                    [
                        121.47281929851,
                        0.50766176321302
                    ],
                    [
                        121.47271737456,
                        0.5075960516713
                    ],
                    [
                        121.47258326411,
                        0.50746731068964
                    ],
                    [
                        121.4725202322,
                        0.50743110228808
                    ],
                    [
                        121.47251218557,
                        0.50743110228808
                    ],
                    [
                        121.47251218557,
                        0.50743110228808
                    ],
                    [
                        121.47251218557,
                        0.50743110228808
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1832,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0010179215992197424,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47296011448,
                        0.50810967452053
                    ],
                    [
                        121.47291317582,
                        0.5080841945368
                    ],
                    [
                        121.47289037704,
                        0.50806676086367
                    ],
                    [
                        121.47285416722,
                        0.50804262193157
                    ],
                    [
                        121.47278979421,
                        0.50798897985989
                    ],
                    [
                        121.47276967764,
                        0.5079661819793
                    ],
                    [
                        121.47277235985,
                        0.50793533778778
                    ],
                    [
                        121.47282063961,
                        0.50785889783422
                    ],
                    [
                        121.47288903594,
                        0.50778916313899
                    ],
                    [
                        121.47299095988,
                        0.50766444531677
                    ],
                    [
                        121.47308349609,
                        0.50756788958179
                    ],
                    [
                        121.47318407893,
                        0.50743512544383
                    ],
                    [
                        121.47325381637,
                        0.50736673179594
                    ],
                    [
                        121.47325381637,
                        0.50736673179594
                    ],
                    [
                        121.47325381637,
                        0.50736673179594
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1833,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005251286981379488,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47218897939,
                        0.50814588291828
                    ],
                    [
                        121.47208169103,
                        0.50808151243325
                    ],
                    [
                        121.47195965052,
                        0.50801982405114
                    ],
                    [
                        121.4717155695,
                        0.50788169571519
                    ],
                    [
                        121.47155463696,
                        0.5077931862945
                    ],
                    [
                        121.47138699889,
                        0.50768724319841
                    ],
                    [
                        121.47126361728,
                        0.50761080324194
                    ],
                    [
                        121.47107720375,
                        0.50749949593529
                    ],
                    [
                        121.47092029452,
                        0.50740294019785
                    ],
                    [
                        121.47079691291,
                        0.50734929812087
                    ],
                    [
                        121.47072449327,
                        0.50729833814731
                    ],
                    [
                        121.47060647607,
                        0.50728090447207
                    ],
                    [
                        121.47056490183,
                        0.50729833814731
                    ],
                    [
                        121.47051125765,
                        0.50733991075734
                    ],
                    [
                        121.47043883801,
                        0.50734125180929
                    ],
                    [
                        121.47035166621,
                        0.50733454654962
                    ],
                    [
                        121.47026047111,
                        0.50732918234188
                    ],
                    [
                        121.47017329931,
                        0.50731174866672
                    ],
                    [
                        121.47016659379,
                        0.5072701760565
                    ],
                    [
                        121.47014781833,
                        0.50713741191244
                    ],
                    [
                        121.47010087967,
                        0.50700464776565
                    ],
                    [
                        121.47004321218,
                        0.50681019522251
                    ],
                    [
                        121.47000029683,
                        0.50666536160039
                    ],
                    [
                        121.46992519498,
                        0.50649102482871
                    ],
                    [
                        121.46989703178,
                        0.50637167119002
                    ],
                    [
                        121.46985948086,
                        0.50624427123617
                    ],
                    [
                        121.46979376674,
                        0.50605786498341
                    ],
                    [
                        121.4697240293,
                        0.50587145872529
                    ],
                    [
                        121.46968781948,
                        0.50570516824589
                    ],
                    [
                        121.46959796548,
                        0.50550132829761
                    ],
                    [
                        121.46951347589,
                        0.50524652835325
                    ],
                    [
                        121.46944105625,
                        0.50506012207183
                    ],
                    [
                        121.46936863661,
                        0.5048308021068
                    ],
                    [
                        121.46929085255,
                        0.50460818739615
                    ],
                    [
                        121.46923720837,
                        0.50448481056529
                    ],
                    [
                        121.46923720837,
                        0.50448481056529
                    ],
                    [
                        121.46923720837,
                        0.50448481056529
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1834,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.022067492573219827,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46923586726,
                        0.50447005898753
                    ],
                    [
                        121.46923050284,
                        0.50441373478123
                    ],
                    [
                        121.46919965744,
                        0.50428365268386
                    ],
                    [
                        121.46915540099,
                        0.50413211374241
                    ],
                    [
                        121.46908566356,
                        0.5039591179554
                    ],
                    [
                        121.46902129054,
                        0.50377941690044
                    ],
                    [
                        121.46894350648,
                        0.50355948425927
                    ],
                    [
                        121.46885499358,
                        0.50328993265846
                    ],
                    [
                        121.46876111627,
                        0.50300697051826
                    ],
                    [
                        121.46867260337,
                        0.50276289889932
                    ],
                    [
                        121.46862700582,
                        0.50260331360508
                    ],
                    [
                        121.46858945489,
                        0.50243165883045
                    ],
                    [
                        121.46857336164,
                        0.50222781877972
                    ],
                    [
                        121.46856129169,
                        0.502042753465
                    ],
                    [
                        121.46856129169,
                        0.50197570081345
                    ],
                    [
                        121.46856129169,
                        0.50187243972871
                    ],
                    [
                        121.46857738495,
                        0.50172894704981
                    ],
                    [
                        121.46862968802,
                        0.50157472594281
                    ],
                    [
                        121.46867528558,
                        0.50145403116088
                    ],
                    [
                        121.46871954203,
                        0.50133199532357
                    ],
                    [
                        121.46877989173,
                        0.50121398264356
                    ],
                    [
                        121.46887645125,
                        0.50101148360812
                    ],
                    [
                        121.4689488709,
                        0.50086128564404
                    ],
                    [
                        121.46901994944,
                        0.5006976771435
                    ],
                    [
                        121.46913662553,
                        0.50045762859847
                    ],
                    [
                        121.46919026971,
                        0.50031011272845
                    ],
                    [
                        121.46924391389,
                        0.50018807686983
                    ],
                    [
                        121.46932572126,
                        0.50000837571125
                    ],
                    [
                        121.46941691637,
                        0.49983001560123
                    ],
                    [
                        121.46950274706,
                        0.49961544704141
                    ],
                    [
                        121.46959394217,
                        0.49945049745628
                    ],
                    [
                        121.469694525,
                        0.49925068047362
                    ],
                    [
                        121.46979108453,
                        0.49902538346576
                    ],
                    [
                        121.46989837289,
                        0.49884970543643
                    ],
                    [
                        121.47000968456,
                        0.4986485473818
                    ],
                    [
                        121.47008746862,
                        0.49845945880485
                    ],
                    [
                        121.47017598152,
                        0.49827171127626
                    ],
                    [
                        121.47024437785,
                        0.4981040795498
                    ],
                    [
                        121.47033154964,
                        0.49791633201109
                    ],
                    [
                        121.4704066515,
                        0.49774735922168
                    ],
                    [
                        121.47050186992,
                        0.49754217797158
                    ],
                    [
                        121.47058904171,
                        0.497345043039
                    ],
                    [
                        121.47069633007,
                        0.49712779229015
                    ],
                    [
                        121.47083714604,
                        0.49681800880259
                    ],
                    [
                        121.47096455097,
                        0.49655516219568
                    ],
                    [
                        121.47105440497,
                        0.49634729880018
                    ],
                    [
                        121.47111207247,
                        0.49622258075974
                    ],
                    [
                        121.47115767002,
                        0.49610590904235
                    ],
                    [
                        121.47120460868,
                        0.49601874051651
                    ],
                    [
                        121.4713011682,
                        0.49581624132133
                    ],
                    [
                        121.47140979767,
                        0.49556680521808
                    ],
                    [
                        121.47150501609,
                        0.49536698811784
                    ],
                    [
                        121.4715988934,
                        0.49513766781417
                    ],
                    [
                        121.4716874063,
                        0.49494857913675
                    ],
                    [
                        121.47177457809,
                        0.49478631154403
                    ],
                    [
                        121.47187516093,
                        0.49455296805664
                    ],
                    [
                        121.47202804685,
                        0.49424184339402
                    ],
                    [
                        121.47214606404,
                        0.49398436090358
                    ],
                    [
                        121.47229492664,
                        0.49371078574656
                    ],
                    [
                        121.47242501378,
                        0.49340770737319
                    ],
                    [
                        121.47252693772,
                        0.4931958207146
                    ],
                    [
                        121.47264093161,
                        0.4929651592811
                    ],
                    [
                        121.47277235985,
                        0.49266476298364
                    ],
                    [
                        121.47289037704,
                        0.49241800887203
                    ],
                    [
                        121.47302180529,
                        0.49215784420098
                    ],
                    [
                        121.47313714027,
                        0.4918869510791
                    ],
                    [
                        121.47328063846,
                        0.4915959421191
                    ],
                    [
                        121.47340670228,
                        0.49132773108481
                    ],
                    [
                        121.47350862622,
                        0.49112523174679
                    ],
                    [
                        121.47363603115,
                        0.49088518285472
                    ],
                    [
                        121.473711133,
                        0.49072157410769
                    ],
                    [
                        121.47378221154,
                        0.49055796535666
                    ],
                    [
                        121.47386267781,
                        0.49037021760464
                    ],
                    [
                        121.4739766717,
                        0.49012614551915
                    ],
                    [
                        121.47409066558,
                        0.48989146081317
                    ],
                    [
                        121.47416710854,
                        0.48970773620905
                    ],
                    [
                        121.47426500916,
                        0.48948243887741
                    ],
                    [
                        121.47435486317,
                        0.48931346587371
                    ],
                    [
                        121.4744541049,
                        0.48908414536189
                    ],
                    [
                        121.47455334663,
                        0.48890712601407
                    ],
                    [
                        121.47465929389,
                        0.4886456201508
                    ],
                    [
                        121.47484436631,
                        0.48826207819958
                    ],
                    [
                        121.47498518229,
                        0.48799789019948
                    ],
                    [
                        121.47518500686,
                        0.4875486364699
                    ],
                    [
                        121.47535532713,
                        0.48716911762425
                    ],
                    [
                        121.47547870874,
                        0.48690761169343
                    ],
                    [
                        121.47559136152,
                        0.4866943837731
                    ],
                    [
                        121.4757321775,
                        0.48641276198118
                    ],
                    [
                        121.47590652108,
                        0.48606006419665
                    ],
                    [
                        121.47601515055,
                        0.48582672040513
                    ],
                    [
                        121.47622838616,
                        0.4853479632904
                    ],
                    [
                        121.47630885243,
                        0.48516289750587
                    ],
                    [
                        121.47639602423,
                        0.48495369269987
                    ],
                    [
                        121.47647917271,
                        0.48475789845251
                    ],
                    [
                        121.47655293345,
                        0.48456210419948
                    ],
                    [
                        121.4766843617,
                        0.48431669084696
                    ],
                    [
                        121.4766843617,
                        0.48431669084696
                    ],
                    [
                        121.4766843617,
                        0.48431669084696
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1835,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.015474320431583678,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47133603692,
                        0.49595973412916
                    ],
                    [
                        121.47147417068,
                        0.49597716783458
                    ],
                    [
                        121.47185638547,
                        0.49601605840802
                    ],
                    [
                        121.47218227386,
                        0.49603885633028
                    ],
                    [
                        121.47243842483,
                        0.49606299530671
                    ],
                    [
                        121.4730258286,
                        0.49612334274737
                    ],
                    [
                        121.47325918078,
                        0.49614211750659
                    ],
                    [
                        121.47343486547,
                        0.49616357437418
                    ],
                    [
                        121.47382244468,
                        0.49620648810917
                    ],
                    [
                        121.47414699197,
                        0.49623196813919
                    ],
                    [
                        121.47471427917,
                        0.49629767979511
                    ],
                    [
                        121.47511929274,
                        0.49631243139124
                    ],
                    [
                        121.47563964128,
                        0.49636741461293
                    ],
                    [
                        121.47609829903,
                        0.49642373888831
                    ],
                    [
                        121.47647246718,
                        0.4964706757841
                    ],
                    [
                        121.47690162063,
                        0.49651493057126
                    ],
                    [
                        121.47743135691,
                        0.49654175165424
                    ],
                    [
                        121.47812873125,
                        0.49660209909054
                    ],
                    [
                        121.47836342454,
                        0.49662757911904
                    ],
                    [
                        121.47889450192,
                        0.49667451601338
                    ],
                    [
                        121.47917747498,
                        0.49671072447451
                    ],
                    [
                        121.47948592901,
                        0.49673218134025
                    ],
                    [
                        121.47990435362,
                        0.49677509507157
                    ],
                    [
                        121.4803160727,
                        0.49682069091076
                    ],
                    [
                        121.48065403104,
                        0.49683946566799
                    ],
                    [
                        121.48102283478,
                        0.49688774361491
                    ],
                    [
                        121.48141175509,
                        0.49694406788586
                    ],
                    [
                        121.48174971342,
                        0.49696150158868
                    ],
                    [
                        121.48201927543,
                        0.49698429950767
                    ],
                    [
                        121.48235991597,
                        0.49701380269685
                    ],
                    [
                        121.48257449269,
                        0.49702319007519
                    ],
                    [
                        121.48283734918,
                        0.49705537537227
                    ],
                    [
                        121.4829929173,
                        0.49707683223691
                    ],
                    [
                        121.4832021296,
                        0.4970835375071
                    ],
                    [
                        121.48353338242,
                        0.49710231226359
                    ],
                    [
                        121.48380562663,
                        0.49713181545224
                    ],
                    [
                        121.48406043649,
                        0.49715997758673
                    ],
                    [
                        121.48438498378,
                        0.49718143445103
                    ],
                    [
                        121.48461565375,
                        0.49720557342328
                    ],
                    [
                        121.48484364152,
                        0.49723641766546
                    ],
                    [
                        121.48512527347,
                        0.49725653347551
                    ],
                    [
                        121.4853720367,
                        0.49726994401551
                    ],
                    [
                        121.48568853736,
                        0.49731151668932
                    ],
                    [
                        121.4858481288,
                        0.49731956301327
                    ],
                    [
                        121.4859969914,
                        0.4973262682832
                    ],
                    [
                        121.48616865277,
                        0.49734772514696
                    ],
                    [
                        121.48633763194,
                        0.49735443041687
                    ],
                    [
                        121.48655757308,
                        0.49735443041687
                    ],
                    [
                        121.48673862219,
                        0.49736918201065
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1836,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.01827800417566252,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.48673728108,
                        0.49736247674075
                    ],
                    [
                        121.4868016541,
                        0.49736113568678
                    ],
                    [
                        121.48683518171,
                        0.49736381779473
                    ],
                    [
                        121.48694783449,
                        0.49736918201065
                    ],
                    [
                        121.48704171181,
                        0.49740002625209
                    ],
                    [
                        121.48705646396,
                        0.49742416522353
                    ],
                    [
                        121.48705780506,
                        0.49747646632803
                    ],
                    [
                        121.48703366518,
                        0.49758643275155
                    ],
                    [
                        121.48700684309,
                        0.49774333605998
                    ],
                    [
                        121.48695722222,
                        0.49796326889627
                    ],
                    [
                        121.48688748479,
                        0.49809871533447
                    ],
                    [
                        121.48685663939,
                        0.49818588383285
                    ],
                    [
                        121.48676812649,
                        0.49829450919074
                    ],
                    [
                        121.48665949702,
                        0.49843800194472
                    ],
                    [
                        121.48656964302,
                        0.49854260413723
                    ],
                    [
                        121.48647576571,
                        0.49866329897269
                    ],
                    [
                        121.48637384176,
                        0.49875717273207
                    ],
                    [
                        121.48632153869,
                        0.49880813277231
                    ],
                    [
                        121.48621827364,
                        0.49892614549556
                    ],
                    [
                        121.48607611656,
                        0.49906963823578
                    ],
                    [
                        121.48593530059,
                        0.49921715413365
                    ],
                    [
                        121.48573547602,
                        0.49942233533157
                    ],
                    [
                        121.48560002446,
                        0.49956851016801
                    ],
                    [
                        121.48549541831,
                        0.49968920498465
                    ],
                    [
                        121.48537874222,
                        0.49980185347816
                    ],
                    [
                        121.48521512747,
                        0.49998557780273
                    ],
                    [
                        121.48507162929,
                        0.50012907051979
                    ],
                    [
                        121.48478463292,
                        0.50042142015796
                    ],
                    [
                        121.48468673229,
                        0.50052736337224
                    ],
                    [
                        121.48452177644,
                        0.50069633609022
                    ],
                    [
                        121.4842119813,
                        0.50103159940664
                    ],
                    [
                        121.48389950395,
                        0.50133870058941
                    ],
                    [
                        121.48350521922,
                        0.50172090073127
                    ],
                    [
                        121.48328259587,
                        0.50189121447151
                    ],
                    [
                        121.48302912712,
                        0.50209505453274
                    ],
                    [
                        121.48271262646,
                        0.5023082819584
                    ],
                    [
                        121.48256108165,
                        0.50241690724805
                    ],
                    [
                        121.48223116994,
                        0.50263013466321
                    ],
                    [
                        121.48202195764,
                        0.50276692205794
                    ],
                    [
                        121.48167997599,
                        0.50296673893334
                    ],
                    [
                        121.48137152195,
                        0.50315180422189
                    ],
                    [
                        121.48102551699,
                        0.50338112424604
                    ],
                    [
                        121.4807613194,
                        0.50353802741584
                    ],
                    [
                        121.48040860891,
                        0.50374454953099
                    ],
                    [
                        121.4801967144,
                        0.5038974295341
                    ],
                    [
                        121.47999286652,
                        0.5040784716384
                    ],
                    [
                        121.47985607386,
                        0.50422732847595
                    ],
                    [
                        121.47965759039,
                        0.50443116846418
                    ],
                    [
                        121.47940814495,
                        0.50470474317521
                    ],
                    [
                        121.47920697927,
                        0.50493942735441
                    ],
                    [
                        121.47904336452,
                        0.50508023785786
                    ],
                    [
                        121.47882342339,
                        0.50532430938996
                    ],
                    [
                        121.47854983807,
                        0.50561397669088
                    ],
                    [
                        121.47827625275,
                        0.50591571344891
                    ],
                    [
                        121.47811129689,
                        0.50607932181852
                    ],
                    [
                        121.47794365883,
                        0.50624561228832
                    ],
                    [
                        121.47781893611,
                        0.50638508171132
                    ],
                    [
                        121.47777870297,
                        0.50642129011872
                    ],
                    [
                        121.4776660502,
                        0.5065460079649
                    ],
                    [
                        121.47755742073,
                        0.50666670265246
                    ],
                    [
                        121.47739514709,
                        0.50683969836736
                    ],
                    [
                        121.47726237774,
                        0.50699257829762
                    ],
                    [
                        121.47718727589,
                        0.50708242878127
                    ],
                    [
                        121.47711753845,
                        0.50717362031564
                    ],
                    [
                        121.4770437777,
                        0.50726481184871
                    ],
                    [
                        121.47698074579,
                        0.50734527496508
                    ],
                    [
                        121.47689759731,
                        0.50744451280721
                    ],
                    [
                        121.47681310773,
                        0.50754911485537
                    ],
                    [
                        121.47668972611,
                        0.50768590214656
                    ],
                    [
                        121.47659987211,
                        0.50780659681286
                    ],
                    [
                        121.47651135921,
                        0.5079138809588
                    ],
                    [
                        121.47643223405,
                        0.50803189351727
                    ],
                    [
                        121.47629007697,
                        0.50820757129916
                    ],
                    [
                        121.4761787653,
                        0.50837788486945
                    ],
                    [
                        121.47609964013,
                        0.50849053321265
                    ],
                    [
                        121.47600844502,
                        0.50861793312227
                    ],
                    [
                        121.47594004869,
                        0.50872521725472
                    ],
                    [
                        121.47583544254,
                        0.50887541503716
                    ],
                    [
                        121.4756731689,
                        0.50910741696209
                    ],
                    [
                        121.47552698851,
                        0.50932064415741
                    ],
                    [
                        121.47535800934,
                        0.50953521239716
                    ],
                    [
                        121.47518500686,
                        0.5097605090412
                    ],
                    [
                        121.47503748536,
                        0.50996166675243
                    ],
                    [
                        121.47487252951,
                        0.51017087076545
                    ],
                    [
                        121.47483499586,
                        0.51021382421016
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2191,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00023254617378419058,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47481888493,
                        0.51023122214627
                    ],
                    [
                        121.47477061538,
                        0.51029695310979
                    ],
                    [
                        121.47472098077,
                        0.5103586260921
                    ],
                    [
                        121.4747075658,
                        0.51038275687426
                    ],
                    [
                        121.47469683382,
                        0.51042565604228
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1837,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.01398130490449317,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45995944738,
                        0.50405030953362
                    ],
                    [
                        121.45999565721,
                        0.50388133690236
                    ],
                    [
                        121.46003991365,
                        0.50361849057837
                    ],
                    [
                        121.46004125476,
                        0.5033261410831
                    ],
                    [
                        121.46003991365,
                        0.50313302948271
                    ],
                    [
                        121.46006003022,
                        0.50289700418557
                    ],
                    [
                        121.46008148789,
                        0.50267975362046
                    ],
                    [
                        121.46007746458,
                        0.50247591357746
                    ],
                    [
                        121.46003589034,
                        0.50223854720361
                    ],
                    [
                        121.45999029279,
                        0.50202531977565
                    ],
                    [
                        121.45995140076,
                        0.50189389657763
                    ],
                    [
                        121.45986825228,
                        0.50156265646472
                    ],
                    [
                        121.4597864449,
                        0.50115229419634
                    ],
                    [
                        121.45971000195,
                        0.50086933196363
                    ],
                    [
                        121.45966976881,
                        0.50067219713077
                    ],
                    [
                        121.45962551236,
                        0.50052602231891
                    ],
                    [
                        121.45953029394,
                        0.50024708321933
                    ],
                    [
                        121.45948201418,
                        0.50009554418431
                    ],
                    [
                        121.4593988657,
                        0.49984342613599
                    ],
                    [
                        121.45935997367,
                        0.49970529762669
                    ],
                    [
                        121.45930767059,
                        0.4994344048136
                    ],
                    [
                        121.45925670862,
                        0.4992573857416
                    ],
                    [
                        121.45922452211,
                        0.49901867819755
                    ],
                    [
                        121.45921379328,
                        0.49896235394432
                    ],
                    [
                        121.45918428898,
                        0.49876521905424
                    ],
                    [
                        121.45916551352,
                        0.49852517043859
                    ],
                    [
                        121.45915344357,
                        0.49828109865283
                    ],
                    [
                        121.45915076137,
                        0.49812285430337
                    ],
                    [
                        121.4591306448,
                        0.49789621620306
                    ],
                    [
                        121.45912930369,
                        0.49764409807047
                    ],
                    [
                        121.45913332701,
                        0.49749658213735
                    ],
                    [
                        121.45911321044,
                        0.49728603666348
                    ],
                    [
                        121.45909577608,
                        0.49702587218329
                    ],
                    [
                        121.45908772945,
                        0.49672949923204
                    ],
                    [
                        121.45909443498,
                        0.49649883792141
                    ],
                    [
                        121.45911052823,
                        0.49615284594038
                    ],
                    [
                        121.45912662148,
                        0.49590877406692
                    ],
                    [
                        121.45913735032,
                        0.49564726847822
                    ],
                    [
                        121.45914673805,
                        0.49551048093541
                    ],
                    [
                        121.45915746689,
                        0.49533480281254
                    ],
                    [
                        121.45917490125,
                        0.49517521733811
                    ],
                    [
                        121.45916819572,
                        0.49500222131529
                    ],
                    [
                        121.45916819572,
                        0.49476619572649
                    ],
                    [
                        121.45917490125,
                        0.49468170929207
                    ],
                    [
                        121.45916551352,
                        0.49462002078375
                    ],
                    [
                        121.45915478468,
                        0.49457710703847
                    ],
                    [
                        121.45913332701,
                        0.49454358067479
                    ],
                    [
                        121.4590702951,
                        0.49451005431094
                    ],
                    [
                        121.45897105336,
                        0.4944912795471
                    ],
                    [
                        121.45836889744,
                        0.4944000878363
                    ],
                    [
                        121.45782843232,
                        0.49430889612426
                    ],
                    [
                        121.45740330219,
                        0.49422440968405
                    ],
                    [
                        121.45710021257,
                        0.49416003906219
                    ],
                    [
                        121.45687893033,
                        0.49410639687686
                    ],
                    [
                        121.45639613271,
                        0.49406214207362
                    ],
                    [
                        121.45624056458,
                        0.49404202625387
                    ],
                    [
                        121.45614400506,
                        0.49401654621543
                    ],
                    [
                        121.45604342222,
                        0.49400045355952
                    ],
                    [
                        121.45592138171,
                        0.49395351664625
                    ],
                    [
                        121.45586639643,
                        0.49390523867795
                    ],
                    [
                        121.45581677556,
                        0.49384623227179
                    ],
                    [
                        121.45578727126,
                        0.49376174582569
                    ],
                    [
                        121.45578727126,
                        0.49376174582569
                    ],
                    [
                        121.45578727126,
                        0.49376174582569
                    ],
                    [
                        121.45571485162,
                        0.49343586952351
                    ],
                    [
                        121.45559817553,
                        0.49296113611649
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1838,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0021109637178171534,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.45560085773,
                        0.49295711295189
                    ],
                    [
                        121.45559817553,
                        0.49296247717137
                    ],
                    [
                        121.45560622215,
                        0.49283105379284
                    ],
                    [
                        121.45557269454,
                        0.49259100496211
                    ],
                    [
                        121.4555297792,
                        0.49238850566242
                    ],
                    [
                        121.45544528961,
                        0.49218332424653
                    ],
                    [
                        121.45535543561,
                        0.49201166920094
                    ],
                    [
                        121.45527631044,
                        0.49186549419769
                    ],
                    [
                        121.45519852638,
                        0.49170590864004
                    ],
                    [
                        121.45515829325,
                        0.49162946849761
                    ],
                    [
                        121.45504832268,
                        0.49141624072731
                    ],
                    [
                        121.45498394966,
                        0.49127140676625
                    ],
                    [
                        121.45492091775,
                        0.49112523174679
                    ],
                    [
                        121.45487800241,
                        0.49101258310577
                    ],
                    [
                        121.45487800241,
                        0.49101258310577
                    ],
                    [
                        121.45487800241,
                        0.49101258310577
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1839,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003498281392686941,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47126361728,
                        0.49588195298137
                    ],
                    [
                        121.47089481354,
                        0.49584440346143
                    ],
                    [
                        121.47049382329,
                        0.49579880761549
                    ],
                    [
                        121.470169276,
                        0.49575455282354
                    ],
                    [
                        121.46985009313,
                        0.49574382438909
                    ],
                    [
                        121.46947860718,
                        0.49568884116224
                    ],
                    [
                        121.46917954087,
                        0.49565665585851
                    ],
                    [
                        121.46892741323,
                        0.49563385793494
                    ],
                    [
                        121.46852910519,
                        0.49559228525056
                    ],
                    [
                        121.46819114685,
                        0.49556680521808
                    ],
                    [
                        121.46778479218,
                        0.495527914642
                    ],
                    [
                        121.46778479218,
                        0.495527914642
                    ],
                    [
                        121.46778479218,
                        0.495527914642
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1840,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.010920107471708311,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46550223231,
                        0.50700464776565
                    ],
                    [
                        121.46534800529,
                        0.50722860344603
                    ],
                    [
                        121.4652018249,
                        0.50744987701483
                    ],
                    [
                        121.46512001753,
                        0.50759068746377
                    ],
                    [
                        121.46499663591,
                        0.5077610010503
                    ],
                    [
                        121.4649027586,
                        0.50788705992249
                    ],
                    [
                        121.46476730704,
                        0.5080841945368
                    ],
                    [
                        121.46463856101,
                        0.50826389547251
                    ],
                    [
                        121.46442398429,
                        0.50857367841711
                    ],
                    [
                        121.46428048611,
                        0.50879092878496
                    ],
                    [
                        121.46408736706,
                        0.50906182120872
                    ],
                    [
                        121.46394520998,
                        0.50925090947796
                    ],
                    [
                        121.46378293633,
                        0.50948559349235
                    ],
                    [
                        121.46360322833,
                        0.50974039326973
                    ],
                    [
                        121.46346375346,
                        0.50993752782741
                    ],
                    [
                        121.46334439516,
                        0.51010381819791
                    ],
                    [
                        121.46321833134,
                        0.51028083697468
                    ],
                    [
                        121.4630869031,
                        0.51048869992605
                    ],
                    [
                        121.46287366748,
                        0.51078641330273
                    ],
                    [
                        121.46269127727,
                        0.51104657723324
                    ],
                    [
                        121.4625826478,
                        0.51121152652392
                    ],
                    [
                        121.46237611771,
                        0.51147034938612
                    ],
                    [
                        121.46221116185,
                        0.51167016599282
                    ],
                    [
                        121.46202608943,
                        0.51191691937774
                    ],
                    [
                        121.46187856793,
                        0.51216769590594
                    ],
                    [
                        121.46173104644,
                        0.51237153564354
                    ],
                    [
                        121.46150305867,
                        0.51270277520333
                    ],
                    [
                        121.46127641201,
                        0.51305413050714
                    ],
                    [
                        121.46127104759,
                        0.51306083576085
                    ],
                    [
                        121.46127104759,
                        0.51306083576085
                    ],
                    [
                        121.46127104759,
                        0.51306083576085
                    ],
                    [
                        121.46099478006,
                        0.51341889629831
                    ],
                    [
                        121.46027594805,
                        0.51448100833638
                    ],
                    [
                        121.45928621292,
                        0.51597627940337
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1841,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005192018110085712,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46555989981,
                        0.50703683301361
                    ],
                    [
                        121.4654700458,
                        0.50716959715973
                    ],
                    [
                        121.46528497338,
                        0.50744048965147
                    ],
                    [
                        121.46508380771,
                        0.50774222632445
                    ],
                    [
                        121.46495103836,
                        0.50796081777208
                    ],
                    [
                        121.4647552371,
                        0.50825584916207
                    ],
                    [
                        121.46452456713,
                        0.50856429105537
                    ],
                    [
                        121.46428585052,
                        0.50892235184346
                    ],
                    [
                        121.46409809589,
                        0.5091905621586
                    ],
                    [
                        121.46384060383,
                        0.50958349025012
                    ],
                    [
                        121.46365553141,
                        0.50983292581797
                    ],
                    [
                        121.4634758234,
                        0.51007967927342
                    ],
                    [
                        121.46328404546,
                        0.51034923059168
                    ],
                    [
                        121.46317407489,
                        0.51049808728498
                    ],
                    [
                        121.46306008101,
                        0.51066035448725
                    ],
                    [
                        121.46292731166,
                        0.51084541955594
                    ],
                    [
                        121.46280661225,
                        0.51098891203306
                    ],
                    [
                        121.46273687482,
                        0.51110290138174
                    ],
                    [
                        121.4626121521,
                        0.5112691917221
                    ],
                    [
                        121.46259337664,
                        0.51129467169323
                    ],
                    [
                        121.46259337664,
                        0.51129467169323
                    ],
                    [
                        121.46259337664,
                        0.51129467169323
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1842,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.005737488365548436,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4626121521,
                        0.51128126118213
                    ],
                    [
                        121.46251693368,
                        0.51139256842345
                    ],
                    [
                        121.46237611771,
                        0.51154276614364
                    ],
                    [
                        121.46222189069,
                        0.5117653806153
                    ],
                    [
                        121.46208375692,
                        0.51197994877345
                    ],
                    [
                        121.46194159985,
                        0.51223743055375
                    ],
                    [
                        121.46173506975,
                        0.51251234598481
                    ],
                    [
                        121.4615419507,
                        0.51277787404852
                    ],
                    [
                        121.46127909422,
                        0.51319225873197
                    ],
                    [
                        121.46107122302,
                        0.51345108151418
                    ],
                    [
                        121.46083116531,
                        0.51377695681572
                    ],
                    [
                        121.46055623889,
                        0.51422084454541
                    ],
                    [
                        121.46036177874,
                        0.51454940190854
                    ],
                    [
                        121.46013781428,
                        0.51483370459276
                    ],
                    [
                        121.45998090506,
                        0.51505766000019
                    ],
                    [
                        121.45979449153,
                        0.5153835352197
                    ],
                    [
                        121.459608078,
                        0.51562492426044
                    ],
                    [
                        121.4593680203,
                        0.5160004183056
                    ],
                    [
                        121.4593680203,
                        0.5160004183056
                    ],
                    [
                        121.4593680203,
                        0.5160004183056
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1843,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.002547671613814196,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47131055593,
                        0.51029961169314
                    ],
                    [
                        121.47117644548,
                        0.51070729128054
                    ],
                    [
                        121.47110670805,
                        0.51093795208828
                    ],
                    [
                        121.47104769945,
                        0.51114983817181
                    ],
                    [
                        121.47095918655,
                        0.51141268418976
                    ],
                    [
                        121.47087335587,
                        0.51162993446177
                    ],
                    [
                        121.47069901228,
                        0.5120805275951
                    ],
                    [
                        121.4704361558,
                        0.51261426584895
                    ],
                    [
                        121.47040128708,
                        0.51267327208534
                    ],
                    [
                        121.47040128708,
                        0.51267327208534
                    ],
                    [
                        121.47040128708,
                        0.51267327208534
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1844,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0022917882351991773,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47528290749,
                        0.51065767238478
                    ],
                    [
                        121.4753459394,
                        0.51075959227837
                    ],
                    [
                        121.47539556026,
                        0.51077970804666
                    ],
                    [
                        121.47543042898,
                        0.51082262168545
                    ],
                    [
                        121.47543311119,
                        0.51091783632049
                    ],
                    [
                        121.47542774677,
                        0.51109217297254
                    ],
                    [
                        121.47535800934,
                        0.51121689072841
                    ],
                    [
                        121.47529229522,
                        0.51128528433547
                    ],
                    [
                        121.47519573569,
                        0.51138586316801
                    ],
                    [
                        121.47501736879,
                        0.51155885875631
                    ],
                    [
                        121.474840343,
                        0.51161384184929
                    ],
                    [
                        121.47468611598,
                        0.51172783118689
                    ],
                    [
                        121.4744527638,
                        0.51186059523635
                    ],
                    [
                        121.4743360877,
                        0.51186998259329
                    ],
                    [
                        121.47431060672,
                        0.51188473415416
                    ],
                    [
                        121.47464051843,
                        0.51206443498374
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1845,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.021364547309849893,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47464454174,
                        0.51206845813659
                    ],
                    [
                        121.47472903132,
                        0.51210868966488
                    ],
                    [
                        121.47484973073,
                        0.51216903695686
                    ],
                    [
                        121.47501602769,
                        0.51226559262282
                    ],
                    [
                        121.4751394093,
                        0.51233130411689
                    ],
                    [
                        121.47533923388,
                        0.51243724713653
                    ],
                    [
                        121.47549077868,
                        0.51252843859506
                    ],
                    [
                        121.47563695908,
                        0.51262097110312
                    ],
                    [
                        121.47573888302,
                        0.51267193103453
                    ],
                    [
                        121.47594407201,
                        0.5127899435057
                    ],
                    [
                        121.47614389658,
                        0.51290929702546
                    ],
                    [
                        121.47637590766,
                        0.51303535579673
                    ],
                    [
                        121.47649928927,
                        0.51310106728289
                    ],
                    [
                        121.4767460525,
                        0.51322980815181
                    ],
                    [
                        121.47695660591,
                        0.51335989006879
                    ],
                    [
                        121.47714436054,
                        0.51346717412205
                    ],
                    [
                        121.47733345628,
                        0.51358384552793
                    ],
                    [
                        121.47752925754,
                        0.513685765375
                    ],
                    [
                        121.47782564163,
                        0.51386948930573
                    ],
                    [
                        121.47819712758,
                        0.5140827163428
                    ],
                    [
                        121.47844791412,
                        0.51424230135331
                    ],
                    [
                        121.47869065404,
                        0.51438981690569
                    ],
                    [
                        121.47887706757,
                        0.51449978304253
                    ],
                    [
                        121.47910639644,
                        0.51465400384099
                    ],
                    [
                        121.47939607501,
                        0.51481895303871
                    ],
                    [
                        121.47962540388,
                        0.51497853803081
                    ],
                    [
                        121.47991776466,
                        0.51514751037103
                    ],
                    [
                        121.48016184568,
                        0.51529770800302
                    ],
                    [
                        121.48044481874,
                        0.5154532698324
                    ],
                    [
                        121.48065134883,
                        0.5156101727082
                    ],
                    [
                        121.48096248508,
                        0.51578987343301
                    ],
                    [
                        121.48124411702,
                        0.51596152785196
                    ],
                    [
                        121.48156866431,
                        0.51615732116792
                    ],
                    [
                        121.48181676865,
                        0.5163102008762
                    ],
                    [
                        121.48212522268,
                        0.5164966068313
                    ],
                    [
                        121.48244976997,
                        0.51668703593089
                    ],
                    [
                        121.48273408413,
                        0.51688014712463
                    ],
                    [
                        121.48298621178,
                        0.51703570891532
                    ],
                    [
                        121.4833201468,
                        0.51723552534776
                    ],
                    [
                        121.48363798857,
                        0.5174407059732
                    ],
                    [
                        121.48378551006,
                        0.51756810570461
                    ],
                    [
                        121.48400008678,
                        0.5177652400208
                    ],
                    [
                        121.4841529727,
                        0.51788057029817
                    ],
                    [
                        121.48435413837,
                        0.51805758885936
                    ],
                    [
                        121.4845392108,
                        0.51822253796875
                    ],
                    [
                        121.48472696543,
                        0.51839955652039
                    ],
                    [
                        121.48488789797,
                        0.51856316457129
                    ],
                    [
                        121.48507967591,
                        0.51873213681613
                    ],
                    [
                        121.48523122072,
                        0.51885953652157
                    ],
                    [
                        121.48540154099,
                        0.51900839301625
                    ],
                    [
                        121.48556917906,
                        0.51916529580414
                    ],
                    [
                        121.48575022817,
                        0.51930878809395
                    ],
                    [
                        121.4859674871,
                        0.51953006124473
                    ],
                    [
                        121.48615390062,
                        0.51971780815446
                    ],
                    [
                        121.48637920618,
                        0.51994176338948
                    ],
                    [
                        121.48652002215,
                        0.52009464300645
                    ],
                    [
                        121.48669436574,
                        0.52027032045645
                    ],
                    [
                        121.48687139153,
                        0.5204178358687
                    ],
                    [
                        121.48705914617,
                        0.52058680806394
                    ],
                    [
                        121.48718520999,
                        0.52072627717408
                    ],
                    [
                        121.48733139038,
                        0.52088049782112
                    ],
                    [
                        121.48746147752,
                        0.52101996692473
                    ],
                    [
                        121.48758888245,
                        0.52116748231945
                    ],
                    [
                        121.48772835732,
                        0.5213176798087
                    ],
                    [
                        121.48801803589,
                        0.52166501148886
                    ],
                    [
                        121.48816019297,
                        0.52179509323286
                    ],
                    [
                        121.48833990097,
                        0.52201770734524
                    ],
                    [
                        121.48858934641,
                        0.52225641403528
                    ],
                    [
                        121.4887958765,
                        0.52245757135131
                    ],
                    [
                        121.48909628391,
                        0.52270164221947
                    ],
                    [
                        121.48935109377,
                        0.52294571307812
                    ],
                    [
                        121.48962199688,
                        0.52317637344132
                    ],
                    [
                        121.489777565,
                        0.52335070975671
                    ],
                    [
                        121.48991167545,
                        0.52349822509673
                    ],
                    [
                        121.49006456137,
                        0.52371815705174
                    ],
                    [
                        121.49024695158,
                        0.524013187711
                    ],
                    [
                        121.490432024,
                        0.52432699303333
                    ],
                    [
                        121.49054735899,
                        0.524608613181
                    ],
                    [
                        121.4907297492,
                        0.52490096170184
                    ],
                    [
                        121.490996629,
                        0.52534350760187
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1846,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.01674167089329152,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.48805290461,
                        0.5216743988313
                    ],
                    [
                        121.48830771446,
                        0.52135791127842
                    ],
                    [
                        121.48858129978,
                        0.52096632496217
                    ],
                    [
                        121.48879051208,
                        0.52071152563373
                    ],
                    [
                        121.48913651705,
                        0.5202823898994
                    ],
                    [
                        121.4893296361,
                        0.51998467696655
                    ],
                    [
                        121.48946911097,
                        0.51973255969713
                    ],
                    [
                        121.48970514536,
                        0.51922027883146
                    ],
                    [
                        121.48980170488,
                        0.5189440226406
                    ],
                    [
                        121.48987680674,
                        0.51868654113146
                    ],
                    [
                        121.48998141289,
                        0.51813402869108
                    ],
                    [
                        121.49006456137,
                        0.51763784029335
                    ],
                    [
                        121.49013966322,
                        0.5171175129589
                    ],
                    [
                        121.490252316,
                        0.5165140404815
                    ],
                    [
                        121.4903435111,
                        0.51613854646665
                    ],
                    [
                        121.49042397738,
                        0.51559944430656
                    ],
                    [
                        121.49046957493,
                        0.51525881754506
                    ],
                    [
                        121.49050712585,
                        0.51491282656395
                    ],
                    [
                        121.49056345224,
                        0.51432544648326
                    ],
                    [
                        121.49061173201,
                        0.5138909461148
                    ],
                    [
                        121.49067610502,
                        0.51346449202073
                    ],
                    [
                        121.49074584246,
                        0.51302462739076
                    ],
                    [
                        121.49079412222,
                        0.51259012693391
                    ],
                    [
                        121.4908772707,
                        0.51183377421649
                    ],
                    [
                        121.49098187685,
                        0.51119811601264
                    ],
                    [
                        121.49101942778,
                        0.51065364923105
                    ],
                    [
                        121.49105966091,
                        0.51032106851419
                    ],
                    [
                        121.49113476276,
                        0.5099965340884
                    ],
                    [
                        121.49128496647,
                        0.5094520672051
                    ],
                    [
                        121.49139761925,
                        0.50911412221991
                    ],
                    [
                        121.49151295424,
                        0.50865548256883
                    ],
                    [
                        121.49164706469,
                        0.50815392922888
                    ],
                    [
                        121.49173557758,
                        0.5077435673763
                    ],
                    [
                        121.49179190397,
                        0.50731174866672
                    ],
                    [
                        121.49191260338,
                        0.50671632157891
                    ],
                    [
                        121.49201720953,
                        0.50626304596637
                    ],
                    [
                        121.49212449789,
                        0.50579904190415
                    ],
                    [
                        121.49214059114,
                        0.50569712193227
                    ],
                    [
                        121.49214059114,
                        0.50569712193227
                    ],
                    [
                        121.49214059114,
                        0.50569712193227
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1847,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.009969736331219031,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.49214059114,
                        0.50569309877546
                    ],
                    [
                        121.49217009544,
                        0.50555497038988
                    ],
                    [
                        121.49220496416,
                        0.50537526937903
                    ],
                    [
                        121.49223446846,
                        0.50526530308634
                    ],
                    [
                        121.49226665497,
                        0.50507487364826
                    ],
                    [
                        121.49234041572,
                        0.50480264000527
                    ],
                    [
                        121.4923645556,
                        0.50461355160613
                    ],
                    [
                        121.492395401,
                        0.50447140004006
                    ],
                    [
                        121.49243026972,
                        0.50432254320809
                    ],
                    [
                        121.49245172739,
                        0.50417234532014
                    ],
                    [
                        121.49246245623,
                        0.50406640216495
                    ],
                    [
                        121.49247989058,
                        0.50383037690159
                    ],
                    [
                        121.49250537157,
                        0.50362385478917
                    ],
                    [
                        121.4925147593,
                        0.50354741478485
                    ],
                    [
                        121.49252951145,
                        0.50345622319958
                    ],
                    [
                        121.49255767465,
                        0.50335296213825
                    ],
                    [
                        121.49256438017,
                        0.50320008212238
                    ],
                    [
                        121.49258717895,
                        0.50300026525413
                    ],
                    [
                        121.49257510901,
                        0.50280715364408
                    ],
                    [
                        121.49257510901,
                        0.50262611150449
                    ],
                    [
                        121.49256840348,
                        0.50247725463039
                    ],
                    [
                        121.49254158139,
                        0.50220233877294
                    ],
                    [
                        121.49250537157,
                        0.50191937658561
                    ],
                    [
                        121.49248257279,
                        0.50169944388179
                    ],
                    [
                        121.4924557507,
                        0.50146610063918
                    ],
                    [
                        121.49243429303,
                        0.50121532369674
                    ],
                    [
                        121.4924249053,
                        0.50100209623547
                    ],
                    [
                        121.49241015315,
                        0.50075668348843
                    ],
                    [
                        121.49239003658,
                        0.50040130435758
                    ],
                    [
                        121.49237796664,
                        0.50007408732951
                    ],
                    [
                        121.49234846234,
                        0.49976296292705
                    ],
                    [
                        121.49234578013,
                        0.49950548065178
                    ],
                    [
                        121.49234578013,
                        0.49920642570482
                    ],
                    [
                        121.4923645556,
                        0.49897442342719
                    ],
                    [
                        121.49238735437,
                        0.49880545066493
                    ],
                    [
                        121.49240344763,
                        0.49869146110063
                    ],
                    [
                        121.4924235642,
                        0.49856003783582
                    ],
                    [
                        121.49245038629,
                        0.49837631347142
                    ],
                    [
                        121.49247184396,
                        0.49818186067142
                    ],
                    [
                        121.49250268936,
                        0.49790560358014
                    ],
                    [
                        121.49253889918,
                        0.49771785603578
                    ],
                    [
                        121.49256035686,
                        0.49753547270187
                    ],
                    [
                        121.49258449674,
                        0.49746976105826
                    ],
                    [
                        121.49260863662,
                        0.49732224512124
                    ],
                    [
                        121.49265959859,
                        0.49709024277729
                    ],
                    [
                        121.4927212894,
                        0.49688640256083
                    ],
                    [
                        121.49284332991,
                        0.4965685727371
                    ],
                    [
                        121.49289697409,
                        0.49644653680916
                    ],
                    [
                        121.49297073483,
                        0.49633522931249
                    ],
                    [
                        121.49303242564,
                        0.49612736591007
                    ],
                    [
                        121.49306192994,
                        0.49606031319821
                    ],
                    [
                        121.49313166738,
                        0.49589804563271
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1848,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.015717255409960575,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.4909979701,
                        0.52535289493881
                    ],
                    [
                        121.49110123515,
                        0.52551650280882
                    ],
                    [
                        121.49115622044,
                        0.5256425613287
                    ],
                    [
                        121.4912058413,
                        0.5257645967019
                    ],
                    [
                        121.49124607444,
                        0.52593088665715
                    ],
                    [
                        121.49127021432,
                        0.52606096831261
                    ],
                    [
                        121.49127826095,
                        0.52641366392148
                    ],
                    [
                        121.49127155542,
                        0.52656654338072
                    ],
                    [
                        121.49122193456,
                        0.5267663595104
                    ],
                    [
                        121.49119243026,
                        0.52694471886907
                    ],
                    [
                        121.4911159873,
                        0.52715928651181
                    ],
                    [
                        121.49110794067,
                        0.52723438518504
                    ],
                    [
                        121.49098858237,
                        0.5272719345213
                    ],
                    [
                        121.49097785354,
                        0.52734166900234
                    ],
                    [
                        121.49095773697,
                        0.52751198205852
                    ],
                    [
                        121.49092018604,
                        0.52766083834789
                    ],
                    [
                        121.49091079831,
                        0.52778287368158
                    ],
                    [
                        121.49090409279,
                        0.52788211120391
                    ],
                    [
                        121.49090409279,
                        0.52791697844111
                    ],
                    [
                        121.49087995291,
                        0.52799744129543
                    ],
                    [
                        121.49085447192,
                        0.5280497421502
                    ],
                    [
                        121.49080216885,
                        0.52818652899901
                    ],
                    [
                        121.49077937007,
                        0.52825224032727
                    ],
                    [
                        121.49073109031,
                        0.52833672631974
                    ],
                    [
                        121.49069488049,
                        0.52842523545346
                    ],
                    [
                        121.49065196514,
                        0.52850703934866
                    ],
                    [
                        121.4906090498,
                        0.52858347905303
                    ],
                    [
                        121.49057820439,
                        0.52865187247195
                    ],
                    [
                        121.49051517248,
                        0.52880877501837
                    ],
                    [
                        121.49045884609,
                        0.52892946928214
                    ],
                    [
                        121.49039044976,
                        0.52902468364412
                    ],
                    [
                        121.4903408289,
                        0.52911185172071
                    ],
                    [
                        121.490252316,
                        0.52923656912049
                    ],
                    [
                        121.49018526077,
                        0.52932776033594
                    ],
                    [
                        121.49010881782,
                        0.52943370306985
                    ],
                    [
                        121.49006724358,
                        0.52950075543216
                    ],
                    [
                        121.4900162816,
                        0.52957987721873
                    ],
                    [
                        121.48993983865,
                        0.52970593565629
                    ],
                    [
                        121.48984730244,
                        0.52981590152525
                    ],
                    [
                        121.4898057282,
                        0.52990172854356
                    ],
                    [
                        121.48975208402,
                        0.52997146299507
                    ],
                    [
                        121.48968502879,
                        0.53010824980151
                    ],
                    [
                        121.48962333798,
                        0.53020480519249
                    ],
                    [
                        121.48951202631,
                        0.53037780026421
                    ],
                    [
                        121.48942217231,
                        0.53054811323707
                    ],
                    [
                        121.48934707046,
                        0.53067148956094
                    ],
                    [
                        121.48923441768,
                        0.53084180252571
                    ],
                    [
                        121.48912444711,
                        0.53105502898682
                    ],
                    [
                        121.48902118206,
                        0.53121461356609
                    ],
                    [
                        121.48889109492,
                        0.53146136618477
                    ],
                    [
                        121.48883745074,
                        0.53154048794629
                    ],
                    [
                        121.4887368679,
                        0.53173762182225
                    ],
                    [
                        121.48863762617,
                        0.53191866313136
                    ],
                    [
                        121.48857325315,
                        0.53201790058743
                    ],
                    [
                        121.48847937584,
                        0.53217346200186
                    ],
                    [
                        121.48839756846,
                        0.53232634131911
                    ],
                    [
                        121.48829162121,
                        0.53254493191524
                    ],
                    [
                        121.48823395371,
                        0.53263209994223
                    ],
                    [
                        121.488109231,
                        0.53284398529496
                    ],
                    [
                        121.48802474141,
                        0.53300356982798
                    ],
                    [
                        121.4879912138,
                        0.53306123482629
                    ],
                    [
                        121.48791074753,
                        0.5331980215643
                    ],
                    [
                        121.48782625794,
                        0.53332542097441
                    ],
                    [
                        121.48774310946,
                        0.53346220770656
                    ],
                    [
                        121.48767337203,
                        0.53359094815755
                    ],
                    [
                        121.48762643337,
                        0.5336807982624
                    ],
                    [
                        121.48756474257,
                        0.53379210510685
                    ],
                    [
                        121.4874869585,
                        0.53394498438392
                    ],
                    [
                        121.4874252677,
                        0.5340562912236
                    ],
                    [
                        121.48735418916,
                        0.53418369061593
                    ],
                    [
                        121.48726433516,
                        0.53434863929894
                    ],
                    [
                        121.48719593883,
                        0.53447872077753
                    ],
                    [
                        121.48707523942,
                        0.53466646723663
                    ],
                    [
                        121.48697599769,
                        0.53481398230761
                    ],
                    [
                        121.48693174124,
                        0.53487969356535
                    ],
                    [
                        121.48686870933,
                        0.53500709294061
                    ],
                    [
                        121.4868324995,
                        0.53507146315027
                    ],
                    [
                        121.48678690195,
                        0.53515192591139
                    ],
                    [
                        121.48675471544,
                        0.53522300134948
                    ],
                    [
                        121.48670777678,
                        0.53529407678678
                    ],
                    [
                        121.48667559028,
                        0.53533967234988
                    ],
                    [
                        121.48658975959,
                        0.53548182322093
                    ],
                    [
                        121.48650795221,
                        0.53564274873132
                    ],
                    [
                        121.48642212152,
                        0.53581037946684
                    ],
                    [
                        121.486325562,
                        0.53598605647273
                    ],
                    [
                        121.48623839021,
                        0.53617648497726
                    ],
                    [
                        121.48615926504,
                        0.53632131792038
                    ],
                    [
                        121.4861163497,
                        0.53638568811622
                    ],
                    [
                        121.48605465889,
                        0.53650772327734
                    ],
                    [
                        121.48598760366,
                        0.53661903007051
                    ],
                    [
                        121.48590713739,
                        0.53673167790731
                    ],
                    [
                        121.48584008217,
                        0.53685103097024
                    ],
                    [
                        121.48576363921,
                        0.53694490416415
                    ],
                    [
                        121.48567512631,
                        0.53712326322864
                    ],
                    [
                        121.48560136557,
                        0.5372345700106
                    ],
                    [
                        121.48550748825,
                        0.53738610815628
                    ],
                    [
                        121.48540824652,
                        0.53755910302595
                    ],
                    [
                        121.48531973362,
                        0.53771600534537
                    ],
                    [
                        121.48522853851,
                        0.53787827184241
                    ],
                    [
                        121.48516148329,
                        0.53802980997211
                    ],
                    [
                        121.48511052132,
                        0.53811966001185
                    ],
                    [
                        121.48504212499,
                        0.53826717499957
                    ],
                    [
                        121.48495897651,
                        0.53841737207432
                    ],
                    [
                        121.4849281311,
                        0.53846699074998
                    ],
                    [
                        121.48483961821,
                        0.53861584677455
                    ],
                    [
                        121.48471355438,
                        0.53880895728751
                    ],
                    [
                        121.4846304059,
                        0.53897256480065
                    ],
                    [
                        121.48449361324,
                        0.53916701634741
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1849,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.021126141957216734,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.47038787603,
                        0.51267863628863
                    ],
                    [
                        121.47022694349,
                        0.51309704413072
                    ],
                    [
                        121.47004723549,
                        0.51339743948765
                    ],
                    [
                        121.46980047226,
                        0.51393117763164
                    ],
                    [
                        121.46957248449,
                        0.51444614102481
                    ],
                    [
                        121.46931231022,
                        0.51495305807436
                    ],
                    [
                        121.4691272378,
                        0.51546802138499
                    ],
                    [
                        121.46888583899,
                        0.51599907725548
                    ],
                    [
                        121.46857202053,
                        0.51672592638009
                    ],
                    [
                        121.46831721067,
                        0.51728648524228
                    ],
                    [
                        121.46789073944,
                        0.51819303487632
                    ],
                    [
                        121.46762251854,
                        0.51895206893759
                    ],
                    [
                        121.46747231483,
                        0.51930878809395
                    ],
                    [
                        121.46740794182,
                        0.51988543931915
                    ],
                    [
                        121.46727114916,
                        0.520652519472
                    ],
                    [
                        121.46703779697,
                        0.52175486176593
                    ],
                    [
                        121.46694391966,
                        0.52261849719951
                    ],
                    [
                        121.46682053804,
                        0.52348749670847
                    ],
                    [
                        121.46667569876,
                        0.52435649609702
                    ],
                    [
                        121.46663278341,
                        0.52525231632808
                    ],
                    [
                        121.46659523249,
                        0.52612399756737
                    ],
                    [
                        121.46674275398,
                        0.52612667966331
                    ],
                    [
                        121.46697342396,
                        0.5260381704969
                    ],
                    [
                        121.46710216999,
                        0.52601134953713
                    ],
                    [
                        121.46739721298,
                        0.52596575390528
                    ],
                    [
                        121.46764665842,
                        0.52594966132925
                    ],
                    [
                        121.46794170141,
                        0.52592015827308
                    ],
                    [
                        121.46830648184,
                        0.52590138360089
                    ],
                    [
                        121.46847814322,
                        0.52587992683262
                    ],
                    [
                        121.46861761808,
                        0.52589870150488
                    ],
                    [
                        121.46865516901,
                        0.52605158097675
                    ],
                    [
                        121.4686524868,
                        0.52621518882845
                    ],
                    [
                        121.46864980459,
                        0.52634392943006
                    ],
                    [
                        121.46869540215,
                        0.52665505253962
                    ],
                    [
                        121.46878927946,
                        0.52702249964042
                    ],
                    [
                        121.46884560585,
                        0.52725047775774
                    ],
                    [
                        121.46890193224,
                        0.52748382005743
                    ],
                    [
                        121.46897435188,
                        0.52767424882425
                    ],
                    [
                        121.46899446845,
                        0.52770106977685
                    ],
                    [
                        121.46902933717,
                        0.52774934749124
                    ],
                    [
                        121.46908968687,
                        0.52778019158637
                    ],
                    [
                        121.46916344762,
                        0.52776678111025
                    ],
                    [
                        121.46924525499,
                        0.5277198444436
                    ],
                    [
                        121.46952420473,
                        0.52759512701339
                    ],
                    [
                        121.46964758635,
                        0.52754014405948
                    ],
                    [
                        121.46971866488,
                        0.5275039357725
                    ],
                    [
                        121.46980583668,
                        0.52746504538996
                    ],
                    [
                        121.46992251277,
                        0.52740469824415
                    ],
                    [
                        121.46999895573,
                        0.52737653624256
                    ],
                    [
                        121.47005930543,
                        0.52735105633626
                    ],
                    [
                        121.47009685636,
                        0.52735105633626
                    ],
                    [
                        121.4701384306,
                        0.52736848995638
                    ],
                    [
                        121.47016391158,
                        0.52738324148104
                    ],
                    [
                        121.47018805146,
                        0.52740469824415
                    ],
                    [
                        121.4702577889,
                        0.52741810872105
                    ],
                    [
                        121.47030875087,
                        0.52741542662566
                    ],
                    [
                        121.47035703063,
                        0.52741676767336
                    ],
                    [
                        121.47050991654,
                        0.52738726462414
                    ],
                    [
                        121.47060111165,
                        0.52734703319316
                    ],
                    [
                        121.47077545524,
                        0.52729473233249
                    ],
                    [
                        121.47095784545,
                        0.52722499785092
                    ],
                    [
                        121.47108256817,
                        0.52718610746664
                    ],
                    [
                        121.47118315101,
                        0.52715392232084
                    ],
                    [
                        121.47127434611,
                        0.52713380660463
                    ],
                    [
                        121.47134408355,
                        0.52712844241363
                    ],
                    [
                        121.47138029337,
                        0.52714185289112
                    ],
                    [
                        121.47142320871,
                        0.52716867384601
                    ],
                    [
                        121.47145539522,
                        0.52724779566229
                    ],
                    [
                        121.47151306272,
                        0.52736312576558
                    ],
                    [
                        121.47157475352,
                        0.52754819034545
                    ],
                    [
                        121.47157743573,
                        0.52759780910869
                    ],
                    [
                        121.47157743573,
                        0.52759780910869
                    ],
                    [
                        121.47157743573,
                        0.52759780910869
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1850,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.011383393659695188,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46908298135,
                        0.52777750949114
                    ],
                    [
                        121.46904677153,
                        0.52780567149091
                    ],
                    [
                        121.46901994944,
                        0.52782846930015
                    ],
                    [
                        121.46899849176,
                        0.52785797234727
                    ],
                    [
                        121.46900385618,
                        0.52790625006046
                    ],
                    [
                        121.46902129054,
                        0.52798939501005
                    ],
                    [
                        121.46903470159,
                        0.52807119891099
                    ],
                    [
                        121.46905079484,
                        0.52819189318909
                    ],
                    [
                        121.46907359362,
                        0.52834343155718
                    ],
                    [
                        121.46912589669,
                        0.52850033411138
                    ],
                    [
                        121.46916478872,
                        0.52864382618741
                    ],
                    [
                        121.46921440959,
                        0.52882084444485
                    ],
                    [
                        121.46926537156,
                        0.52900590898131
                    ],
                    [
                        121.46929219365,
                        0.52916549361341
                    ],
                    [
                        121.46932035685,
                        0.52930630357949
                    ],
                    [
                        121.46936193109,
                        0.52945381877862
                    ],
                    [
                        121.46940350533,
                        0.52963486015457
                    ],
                    [
                        121.46944507957,
                        0.52981992466675
                    ],
                    [
                        121.46952420473,
                        0.53007740571797
                    ],
                    [
                        121.46955370903,
                        0.5302208977575
                    ],
                    [
                        121.46960601211,
                        0.5303281815232
                    ],
                    [
                        121.46965026855,
                        0.53056956998922
                    ],
                    [
                        121.46967709064,
                        0.53069160526569
                    ],
                    [
                        121.46969720721,
                        0.53084448461961
                    ],
                    [
                        121.46970927715,
                        0.530993340829
                    ],
                    [
                        121.46970927715,
                        0.53115694855053
                    ],
                    [
                        121.46970927715,
                        0.53128032486225
                    ],
                    [
                        121.46971464157,
                        0.5313889496564
                    ],
                    [
                        121.46974414587,
                        0.53149086921461
                    ],
                    [
                        121.46979108453,
                        0.5315753551629
                    ],
                    [
                        121.46984875202,
                        0.53171884716766
                    ],
                    [
                        121.46998018026,
                        0.53200314907379
                    ],
                    [
                        121.47007137537,
                        0.53220162398163
                    ],
                    [
                        121.47016525269,
                        0.53242423772202
                    ],
                    [
                        121.47029668093,
                        0.53266294401301
                    ],
                    [
                        121.47044152021,
                        0.53295261006158
                    ],
                    [
                        121.47060245276,
                        0.53318327005348
                    ],
                    [
                        121.47069364786,
                        0.5334058837584
                    ],
                    [
                        121.47076070309,
                        0.53358826606486
                    ],
                    [
                        121.47087603807,
                        0.53380015138469
                    ],
                    [
                        121.47095382214,
                        0.53403617552982
                    ],
                    [
                        121.47103697062,
                        0.53422928618729
                    ],
                    [
                        121.47103428841,
                        0.53437411917641
                    ],
                    [
                        121.47102624178,
                        0.53446799240827
                    ],
                    [
                        121.47096991539,
                        0.53462087166853
                    ],
                    [
                        121.47096991539,
                        0.53473888372646
                    ],
                    [
                        121.47080361843,
                        0.53521629611951
                    ],
                    [
                        121.4706158638,
                        0.53565615919034
                    ],
                    [
                        121.47057697177,
                        0.53574198612731
                    ],
                    [
                        121.47049918771,
                        0.53593241463941
                    ],
                    [
                        121.47045359015,
                        0.53605579085536
                    ],
                    [
                        121.47040531039,
                        0.53623280889999
                    ],
                    [
                        121.47036507726,
                        0.53639105229919
                    ],
                    [
                        121.47034361959,
                        0.53655197778571
                    ],
                    [
                        121.4703194797,
                        0.53672094954198
                    ],
                    [
                        121.47030875087,
                        0.53685505410714
                    ],
                    [
                        121.4702872932,
                        0.53710582963611
                    ],
                    [
                        121.47024706006,
                        0.53734185365394
                    ],
                    [
                        121.47021085024,
                        0.53755105675306
                    ],
                    [
                        121.47019743919,
                        0.53771868743626
                    ],
                    [
                        121.47016525269,
                        0.53791582111385
                    ],
                    [
                        121.47013708949,
                        0.53811429583042
                    ],
                    [
                        121.47004455328,
                        0.53858634377899
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1851,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006141726172258798,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.46658718586,
                        0.52611997442346
                    ],
                    [
                        121.46645978093,
                        0.52616691110216
                    ],
                    [
                        121.46639809012,
                        0.52620848358869
                    ],
                    [
                        121.46631225944,
                        0.52622591721201
                    ],
                    [
                        121.46616339684,
                        0.52625810236261
                    ],
                    [
                        121.46605610847,
                        0.52628224122544
                    ],
                    [
                        121.46593004465,
                        0.52631308532783
                    ],
                    [
                        121.46572217345,
                        0.52635599886131
                    ],
                    [
                        121.46549552679,
                        0.52641366392148
                    ],
                    [
                        121.46531715989,
                        0.52645389535848
                    ],
                    [
                        121.46515756845,
                        0.52650485517833
                    ],
                    [
                        121.46497115493,
                        0.52654374556686
                    ],
                    [
                        121.46479144692,
                        0.52659738748169
                    ],
                    [
                        121.46468147635,
                        0.52662018529536
                    ],
                    [
                        121.46457150579,
                        0.52663761891751
                    ],
                    [
                        121.46449908614,
                        0.52666175777889
                    ],
                    [
                        121.46442398429,
                        0.52664030101323
                    ],
                    [
                        121.46434217691,
                        0.52661750319964
                    ],
                    [
                        121.46424695849,
                        0.5265893411945
                    ],
                    [
                        121.46408468485,
                        0.52657593071582
                    ],
                    [
                        121.46388888359,
                        0.52661616215179
                    ],
                    [
                        121.46364614367,
                        0.52665505253962
                    ],
                    [
                        121.46351337433,
                        0.52668455559232
                    ],
                    [
                        121.46333232522,
                        0.52671003550134
                    ],
                    [
                        121.4632062614,
                        0.52672746912326
                    ],
                    [
                        121.46307617426,
                        0.52677842894085
                    ],
                    [
                        121.46297559142,
                        0.52679720361038
                    ],
                    [
                        121.46287769079,
                        0.5267985446582
                    ],
                    [
                        121.46281063557,
                        0.52679452151474
                    ],
                    [
                        121.4627610147,
                        0.52679720361038
                    ],
                    [
                        121.46256387234,
                        0.52678781627562
                    ],
                    [
                        121.46245390177,
                        0.5267985446582
                    ],
                    [
                        121.46226346493,
                        0.5268360939971
                    ],
                    [
                        121.46211326122,
                        0.5268602328577
                    ],
                    [
                        121.46187722683,
                        0.52689375905282
                    ],
                    [
                        121.46159693599,
                        0.52693533153453
                    ],
                    [
                        121.46140381694,
                        0.5269728808726
                    ],
                    [
                        121.46132737398,
                        0.5269876323982
                    ],
                    [
                        121.46115034819,
                        0.52702384068818
                    ],
                    [
                        121.46099343896,
                        0.52706809526455
                    ],
                    [
                        121.46077483892,
                        0.52710028041079
                    ],
                    [
                        121.4605897665,
                        0.52712844241363
                    ],
                    [
                        121.4605897665,
                        0.52712978346137
                    ],
                    [
                        121.4605897665,
                        0.52712978346137
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1852,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0004992758739364432,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93933296103,
                        0.44624676361249
                    ],
                    [
                        121.93945770202,
                        0.44608588655865
                    ],
                    [
                        121.93964146024,
                        0.44585663675087
                    ],
                    [
                        121.93964280154,
                        0.44585529610869
                    ],
                    [
                        121.93964280154,
                        0.44585529610869
                    ],
                    [
                        121.93964280154,
                        0.44585529610869
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1857,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0018090053622195595,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94359123235,
                        0.45882583830062
                    ],
                    [
                        121.94402039051,
                        0.45891435004641
                    ],
                    [
                        121.94441735744,
                        0.45901760882827
                    ],
                    [
                        121.94459304194,
                        0.4590779544855
                    ],
                    [
                        121.94459035777,
                        0.45922410909652
                    ],
                    [
                        121.94461047649,
                        0.45932339906438
                    ],
                    [
                        121.94470207399,
                        0.45936720162268
                    ],
                    [
                        121.9449225581,
                        0.45938106892545
                    ],
                    [
                        121.9450440622,
                        0.45938843009707
                    ],
                    [
                        121.94503768545,
                        0.45947139778233
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1858,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 1.3413010009344362e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9476480562,
                        0.45861953369862
                    ],
                    [
                        121.94766146921,
                        0.45861953369862
                    ],
                    [
                        121.94766146921,
                        0.45861953369862
                    ],
                    [
                        121.94766146921,
                        0.45861953369862
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1859,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.00011256913158798777,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94765087139,
                        0.45863822084032
                    ],
                    [
                        121.94776341123,
                        0.45864078867958
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1863,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0007601459832126567,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94231938049,
                        0.47992371034724
                    ],
                    [
                        121.94232791662,
                        0.48007492751195
                    ],
                    [
                        121.94236814976,
                        0.48025999343492
                    ],
                    [
                        121.94241374731,
                        0.48046651627061
                    ],
                    [
                        121.94244325161,
                        0.48056307239943
                    ],
                    [
                        121.94252420011,
                        0.48054294193225
                    ],
                    [
                        121.94250811105,
                        0.48053623896413
                    ],
                    [
                        121.94251347407,
                        0.48053355777689
                    ],
                    [
                        121.94251347407,
                        0.48053355777689
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1864,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0006473731160919369,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94379985249,
                        0.47828742531294
                    ],
                    [
                        121.94411966584,
                        0.47821409956778
                    ],
                    [
                        121.94441597259,
                        0.47813366392255
                    ],
                    [
                        121.94440926882,
                        0.47813366392255
                    ],
                    [
                        121.94441060957,
                        0.47813902629894
                    ],
                    [
                        121.94441060957,
                        0.47813902629894
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1865,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0005526461382587506,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94411832467,
                        0.47765615984627
                    ],
                    [
                        121.94409396354,
                        0.47771598393009
                    ],
                    [
                        121.94407392748,
                        0.47783494308411
                    ],
                    [
                        121.94416409649,
                        0.47819112441385
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1866,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.00035544550086103767,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94410602004,
                        0.47766293798646
                    ],
                    [
                        121.94445002834,
                        0.47757349642112
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1867,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0004336679589976013,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94409828186,
                        0.47794243213306
                    ],
                    [
                        121.94452199968,
                        0.47785006813756
                    ],
                    [
                        121.94452199968,
                        0.47785006813756
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1868,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribus",
                "panjang": 0.006063866681863701,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94813847793,
                        0.46944121430967
                    ],
                    [
                        121.94837498452,
                        0.46944439323435
                    ],
                    [
                        121.9485654342,
                        0.46946717896381
                    ],
                    [
                        121.94878804868,
                        0.46948600798139
                    ],
                    [
                        121.94892350937,
                        0.46950343236266
                    ],
                    [
                        121.94908577036,
                        0.46954503193759
                    ],
                    [
                        121.94935254356,
                        0.46964625707731
                    ],
                    [
                        121.94946386274,
                        0.46969182853486
                    ],
                    [
                        121.94960082765,
                        0.46974897471483
                    ],
                    [
                        121.94987569384,
                        0.46984678620683
                    ],
                    [
                        121.95002416669,
                        0.46989261492264
                    ],
                    [
                        121.95013661833,
                        0.46990851924624
                    ],
                    [
                        121.95035898686,
                        0.46990315500863
                    ],
                    [
                        121.95054554794,
                        0.4699010599831
                    ],
                    [
                        121.9507203743,
                        0.4699016144745
                    ],
                    [
                        121.95094991512,
                        0.46991256097219
                    ],
                    [
                        121.95122767391,
                        0.46989047612797
                    ],
                    [
                        121.95148810297,
                        0.46987458280798
                    ],
                    [
                        121.95166719404,
                        0.46985903358278
                    ],
                    [
                        121.95189456484,
                        0.46984740668486
                    ],
                    [
                        121.9521542285,
                        0.46983074551119
                    ],
                    [
                        121.95243318068,
                        0.46982538416336
                    ],
                    [
                        121.9526665288,
                        0.46982002281552
                    ],
                    [
                        121.95295486771,
                        0.46981331173872
                    ],
                    [
                        121.95327941537,
                        0.46981464123871
                    ],
                    [
                        121.953503379,
                        0.4698280366612
                    ],
                    [
                        121.95352349693,
                        0.46985082238941
                    ],
                    [
                        121.95352886171,
                        0.47005857461381
                    ],
                    [
                        121.95352000595,
                        0.470274098714
                    ],
                    [
                        121.9535453014,
                        0.47031087904105
                    ],
                    [
                        121.95366183448,
                        0.47035378667939
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1870,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.000273449779029012,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95091845772,
                        0.46990874864249
                    ],
                    [
                        121.9509245037,
                        0.46963536571
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1871,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribus",
                "panjang": 0.0008799656946180459,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95092709881,
                        0.46962503819102
                    ],
                    [
                        121.95093480345,
                        0.46936483292329
                    ],
                    [
                        121.95094759759,
                        0.4691771473493
                    ],
                    [
                        121.95096198773,
                        0.46906211332949
                    ],
                    [
                        121.95078756968,
                        0.46906442699311
                    ],
                    [
                        121.95077684013,
                        0.46901349418305
                    ],
                    [
                        121.95078756968,
                        0.46892503193308
                    ],
                    [
                        121.95078756968,
                        0.46892503193308
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1872,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribus",
                "panjang": 0.0029502535698569922,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95114892417,
                        0.46727510135352
                    ],
                    [
                        121.9510332182,
                        0.46788163663936
                    ],
                    [
                        121.95097227392,
                        0.46787359745095
                    ],
                    [
                        121.95090562105,
                        0.46789409210795
                    ],
                    [
                        121.95081903487,
                        0.46786171859703
                    ],
                    [
                        121.95064199344,
                        0.467830301545
                    ],
                    [
                        121.95057877376,
                        0.46782991648399
                    ],
                    [
                        121.95051554294,
                        0.46789044690107
                    ],
                    [
                        121.95049795114,
                        0.46801078176346
                    ],
                    [
                        121.95045614761,
                        0.46831151839705
                    ],
                    [
                        121.95042359679,
                        0.46860983526
                    ],
                    [
                        121.95037818031,
                        0.46901024363265
                    ],
                    [
                        121.95037741143,
                        0.46910756059201
                    ],
                    [
                        121.95093035994,
                        0.46910756216724
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1874,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.019883908552979127,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82387754321,
                        0.63978609025072
                    ],
                    [
                        121.82411760092,
                        0.63981022862684
                    ],
                    [
                        121.82430133224,
                        0.63983302598195
                    ],
                    [
                        121.82442605495,
                        0.63985582333697
                    ],
                    [
                        121.82448640466,
                        0.63986521048313
                    ],
                    [
                        121.82455614209,
                        0.639866551504
                    ],
                    [
                        121.82465672493,
                        0.63985716435785
                    ],
                    [
                        121.82478144765,
                        0.63986521048313
                    ],
                    [
                        121.82488203049,
                        0.639866551504
                    ],
                    [
                        121.82496517897,
                        0.63988800783799
                    ],
                    [
                        121.82507112622,
                        0.63994030765174
                    ],
                    [
                        121.82517707348,
                        0.64001272277757
                    ],
                    [
                        121.82527765632,
                        0.64009452504812
                    ],
                    [
                        121.82534873486,
                        0.64014682485975
                    ],
                    [
                        121.82542920113,
                        0.64018303242134
                    ],
                    [
                        121.8255110085,
                        0.64020717079559
                    ],
                    [
                        121.82557940483,
                        0.64018839650451
                    ],
                    [
                        121.82564780116,
                        0.64016023506777
                    ],
                    [
                        121.82573363185,
                        0.6400998891314
                    ],
                    [
                        121.82585969567,
                        0.64003417911096
                    ],
                    [
                        121.82593077421,
                        0.63998053827732
                    ],
                    [
                        121.82600721717,
                        0.63995103581859
                    ],
                    [
                        121.82606890798,
                        0.63996981011054
                    ],
                    [
                        121.82613059878,
                        0.64002210992344
                    ],
                    [
                        121.82618558407,
                        0.64007038667334
                    ],
                    [
                        121.82623118162,
                        0.64010257117301
                    ],
                    [
                        121.8262848258,
                        0.64014682485975
                    ],
                    [
                        121.8263438344,
                        0.64025544754374
                    ],
                    [
                        121.82637736201,
                        0.64042978024164
                    ],
                    [
                        121.82638540864,
                        0.64055583618873
                    ],
                    [
                        121.82641357183,
                        0.64069932540133
                    ],
                    [
                        121.82641625404,
                        0.64083342746554
                    ],
                    [
                        121.82642161846,
                        0.64096484748507
                    ],
                    [
                        121.82644978166,
                        0.641090903419
                    ],
                    [
                        121.82650744915,
                        0.64116331852857
                    ],
                    [
                        121.82659059763,
                        0.64122500547297
                    ],
                    [
                        121.82666435838,
                        0.64127596425254
                    ],
                    [
                        121.82673811913,
                        0.64133362813409
                    ],
                    [
                        121.82678773999,
                        0.6414315226292
                    ],
                    [
                        121.82683065534,
                        0.64156964773553
                    ],
                    [
                        121.82686954737,
                        0.64172252406246
                    ],
                    [
                        121.82690039277,
                        0.64184321589629
                    ],
                    [
                        121.82692721486,
                        0.6420068203776
                    ],
                    [
                        121.82695135474,
                        0.64216774281312
                    ],
                    [
                        121.82695001364,
                        0.64224418096822
                    ],
                    [
                        121.82695135474,
                        0.64234207544588
                    ],
                    [
                        121.82695403695,
                        0.64240778543671
                    ],
                    [
                        121.82695940137,
                        0.64249092868917
                    ],
                    [
                        121.8269687891,
                        0.64264112294824
                    ],
                    [
                        121.82697415352,
                        0.64277522496157
                    ],
                    [
                        121.82697683573,
                        0.64294821655352
                    ],
                    [
                        121.82698488235,
                        0.64314668752003
                    ],
                    [
                        121.82699158788,
                        0.64331699705946
                    ],
                    [
                        121.8269969523,
                        0.64345914517465
                    ],
                    [
                        121.82700902224,
                        0.64370723385673
                    ],
                    [
                        121.82700634003,
                        0.64389229459551
                    ],
                    [
                        121.82702109218,
                        0.64408674246598
                    ],
                    [
                        121.82702109218,
                        0.64421145730315
                    ],
                    [
                        121.82703182101,
                        0.64437908476762
                    ],
                    [
                        121.82703316212,
                        0.64450916367626
                    ],
                    [
                        121.82704254985,
                        0.64470495254279
                    ],
                    [
                        121.82704657316,
                        0.64490610548003
                    ],
                    [
                        121.82704791427,
                        0.64503350233616
                    ],
                    [
                        121.82706534863,
                        0.64535132395283
                    ],
                    [
                        121.82707205415,
                        0.64563293802694
                    ],
                    [
                        121.82707875967,
                        0.64579117830936
                    ],
                    [
                        121.82708948851,
                        0.64602719770449
                    ],
                    [
                        121.82708948851,
                        0.64628333237658
                    ],
                    [
                        121.82709887624,
                        0.64643084448555
                    ],
                    [
                        121.82711362839,
                        0.64652069276799
                    ],
                    [
                        121.82714045048,
                        0.64664540754546
                    ],
                    [
                        121.82718738914,
                        0.64672452767152
                    ],
                    [
                        121.82725176215,
                        0.64688813199607
                    ],
                    [
                        121.82729870081,
                        0.64699943657451
                    ],
                    [
                        121.82733893394,
                        0.64716974598499
                    ],
                    [
                        121.8273845315,
                        0.64738028595697
                    ],
                    [
                        121.82741135359,
                        0.64752243395858
                    ],
                    [
                        121.82743147016,
                        0.64769274335149
                    ],
                    [
                        121.82745158672,
                        0.64789791922669
                    ],
                    [
                        121.82748243213,
                        0.64813125648643
                    ],
                    [
                        121.82751998305,
                        0.64833375030656
                    ],
                    [
                        121.82757094502,
                        0.6485362441186
                    ],
                    [
                        121.82761520147,
                        0.64870118940322
                    ],
                    [
                        121.82766884565,
                        0.64886479366396
                    ],
                    [
                        121.82769700885,
                        0.64901096467931
                    ],
                    [
                        121.827711761,
                        0.64917322791159
                    ],
                    [
                        121.827711761,
                        0.64929794262377
                    ],
                    [
                        121.82770907879,
                        0.64939851900232
                    ],
                    [
                        121.82771444321,
                        0.6495741924054
                    ],
                    [
                        121.82772919536,
                        0.64985714726316
                    ],
                    [
                        121.82773455977,
                        0.65005561795961
                    ],
                    [
                        121.82773321867,
                        0.65018703774082
                    ],
                    [
                        121.82772785425,
                        0.65023531439427
                    ],
                    [
                        121.82773590088,
                        0.6503841674062
                    ],
                    [
                        121.82774662971,
                        0.65067919138082
                    ],
                    [
                        121.82775467634,
                        0.6509259386918
                    ],
                    [
                        121.82776272297,
                        0.65108686084465
                    ],
                    [
                        121.82776540518,
                        0.6511954832949
                    ],
                    [
                        121.82776942849,
                        0.65141138717057
                    ],
                    [
                        121.8277707696,
                        0.651511963507
                    ],
                    [
                        121.82777747512,
                        0.65178150807876
                    ],
                    [
                        121.82778418064,
                        0.6519907068409
                    ],
                    [
                        121.82779625058,
                        0.65224952324616
                    ],
                    [
                        121.82780429721,
                        0.65255661626934
                    ],
                    [
                        121.82781368494,
                        0.65284225299459
                    ],
                    [
                        121.82781770825,
                        0.65300317508618
                    ],
                    [
                        121.82781770825,
                        0.65328612975139
                    ],
                    [
                        121.82781502604,
                        0.65357713050421
                    ],
                    [
                        121.82781234384,
                        0.65388154141193
                    ],
                    [
                        121.82782173157,
                        0.65401027905897
                    ],
                    [
                        121.82782977819,
                        0.65419533942083
                    ],
                    [
                        121.82783916593,
                        0.65434687434972
                    ],
                    [
                        121.82783782482,
                        0.65446488384869
                    ],
                    [
                        121.82783380151,
                        0.65462044182038
                    ],
                    [
                        121.82783380151,
                        0.65482829944743
                    ],
                    [
                        121.82783782482,
                        0.65502945198152
                    ],
                    [
                        121.82784855366,
                        0.65523328654117
                    ],
                    [
                        121.8278606236,
                        0.65544784922658
                    ],
                    [
                        121.8278606236,
                        0.65566241190279
                    ],
                    [
                        121.8278606236,
                        0.65577908035413
                    ],
                    [
                        121.82786598802,
                        0.65586490542003
                    ],
                    [
                        121.82788074017,
                        0.65593732031825
                    ],
                    [
                        121.82791694999,
                        0.65597889183342
                    ],
                    [
                        121.82798668742,
                        0.65600168911578
                    ],
                    [
                        121.82803764939,
                        0.65601644029844
                    ],
                    [
                        121.82810336351,
                        0.65601778131504
                    ],
                    [
                        121.82818517089,
                        0.65601778131504
                    ],
                    [
                        121.82829111815,
                        0.65601644029844
                    ],
                    [
                        121.82844132185,
                        0.65601375826524
                    ],
                    [
                        121.82854190469,
                        0.65600571216561
                    ],
                    [
                        121.82859018445,
                        0.65599900708256
                    ],
                    [
                        121.82861968875,
                        0.65601107623203
                    ],
                    [
                        121.82865321636,
                        0.65602582741465
                    ],
                    [
                        121.82867065072,
                        0.65606203486272
                    ],
                    [
                        121.82868137956,
                        0.6561424958575
                    ],
                    [
                        121.82868942618,
                        0.65627793852914
                    ],
                    [
                        121.8286947906,
                        0.65634767138836
                    ],
                    [
                        121.82869747281,
                        0.6563852198506
                    ],
                    [
                        121.82869747281,
                        0.6563852198506
                    ],
                    [
                        121.82869747281,
                        0.6563852198506
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1875,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 9.881480821784991e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82772248983,
                        0.65023799643055
                    ],
                    [
                        121.82782039046,
                        0.65022458624909
                    ],
                    [
                        121.82782039046,
                        0.65022458624909
                    ],
                    [
                        121.82782039046,
                        0.65022458624909
                    ],
                    [
                        121.82782039046,
                        0.65022458624909
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1876,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002465797741507281,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82782843709,
                        0.65022324523095
                    ],
                    [
                        121.82782039046,
                        0.65038550842431
                    ],
                    [
                        121.82782575488,
                        0.65050351801618
                    ],
                    [
                        121.82781636715,
                        0.65063896083983
                    ],
                    [
                        121.82781234384,
                        0.65076233449782
                    ],
                    [
                        121.82781368494,
                        0.65086291084721
                    ],
                    [
                        121.82782575488,
                        0.65102249198412
                    ],
                    [
                        121.8278324604,
                        0.65115659377594
                    ],
                    [
                        121.8278311193,
                        0.65130946981426
                    ],
                    [
                        121.82782575488,
                        0.65142077429538
                    ],
                    [
                        121.82782843709,
                        0.65159242457469
                    ],
                    [
                        121.82783916593,
                        0.65176005179496
                    ],
                    [
                        121.82783916593,
                        0.65187001524841
                    ],
                    [
                        121.82784855366,
                        0.65197997869947
                    ],
                    [
                        121.82785794139,
                        0.65210067028932
                    ],
                    [
                        121.82789549232,
                        0.65209128316578
                    ],
                    [
                        121.82797059417,
                        0.65208726011282
                    ],
                    [
                        121.8280684948,
                        0.65207519095393
                    ],
                    [
                        121.8281596899,
                        0.65207250891862
                    ],
                    [
                        121.82829111815,
                        0.65206312179502
                    ],
                    [
                        121.82844132185,
                        0.65206178077735
                    ],
                    [
                        121.82844132185,
                        0.65206178077735
                    ],
                    [
                        121.82844132185,
                        0.65206178077735
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1877,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0024431486636687584,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82785794139,
                        0.65210871639521
                    ],
                    [
                        121.82786464691,
                        0.65225086426378
                    ],
                    [
                        121.82786598802,
                        0.65232730226692
                    ],
                    [
                        121.82787001133,
                        0.65249090641007
                    ],
                    [
                        121.82787403464,
                        0.65259148272493
                    ],
                    [
                        121.82788342237,
                        0.65274435871969
                    ],
                    [
                        121.82788342237,
                        0.65285566316909
                    ],
                    [
                        121.82788878679,
                        0.65297233168569
                    ],
                    [
                        121.82789683342,
                        0.6530635208692
                    ],
                    [
                        121.8279799819,
                        0.65305413374744
                    ],
                    [
                        121.82810202241,
                        0.65305145171264
                    ],
                    [
                        121.82824417949,
                        0.65304608764307
                    ],
                    [
                        121.82836487889,
                        0.65305279273004
                    ],
                    [
                        121.82850301266,
                        0.65305279273004
                    ],
                    [
                        121.82861432433,
                        0.65305949781702
                    ],
                    [
                        121.82872027159,
                        0.65305547476484
                    ],
                    [
                        121.82886108756,
                        0.65305949781702
                    ],
                    [
                        121.82899653912,
                        0.65304876967785
                    ],
                    [
                        121.82911589742,
                        0.65305011069525
                    ],
                    [
                        121.82924866676,
                        0.65304206459087
                    ],
                    [
                        121.82930096984,
                        0.65308095409526
                    ],
                    [
                        121.82931169868,
                        0.65312252563412
                    ],
                    [
                        121.82931169868,
                        0.6531480049642
                    ],
                    [
                        121.82931169868,
                        0.6531480049642
                    ],
                    [
                        121.82931169868,
                        0.6531480049642
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1878,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.007995072644840954,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82782977819,
                        0.65021654014019
                    ],
                    [
                        121.82782173157,
                        0.65011864581428
                    ],
                    [
                        121.82781368494,
                        0.65002745657748
                    ],
                    [
                        121.82780429721,
                        0.64988933170096
                    ],
                    [
                        121.82779490948,
                        0.64979411940522
                    ],
                    [
                        121.82779356837,
                        0.64962246906471
                    ],
                    [
                        121.82779222727,
                        0.64945752381016
                    ],
                    [
                        121.82778686285,
                        0.64929794262377
                    ],
                    [
                        121.82777613401,
                        0.64917188689317
                    ],
                    [
                        121.82776674628,
                        0.64899889551305
                    ],
                    [
                        121.82772919536,
                        0.64884199634924
                    ],
                    [
                        121.82768762112,
                        0.64870789449597
                    ],
                    [
                        121.82762861252,
                        0.64848796744892
                    ],
                    [
                        121.82758703828,
                        0.64830827095215
                    ],
                    [
                        121.82755082846,
                        0.64809236694387
                    ],
                    [
                        121.82751864195,
                        0.64788719107656
                    ],
                    [
                        121.82749852538,
                        0.64764848973026
                    ],
                    [
                        121.82746499777,
                        0.64745135995827
                    ],
                    [
                        121.82742476463,
                        0.64725557119754
                    ],
                    [
                        121.82736441493,
                        0.64702089287851
                    ],
                    [
                        121.82730272412,
                        0.64685997059632
                    ],
                    [
                        121.8272356689,
                        0.64667759200367
                    ],
                    [
                        121.82718873024,
                        0.64659176678133
                    ],
                    [
                        121.82715922594,
                        0.64647778015567
                    ],
                    [
                        121.82714447379,
                        0.64632088091383
                    ],
                    [
                        121.82713910937,
                        0.64617336880168
                    ],
                    [
                        121.82713106275,
                        0.64598160304947
                    ],
                    [
                        121.82713910937,
                        0.64578715525139
                    ],
                    [
                        121.82712167501,
                        0.64552967953491
                    ],
                    [
                        121.8271163106,
                        0.64534193681674
                    ],
                    [
                        121.8271163106,
                        0.6451608991891
                    ],
                    [
                        121.82710692286,
                        0.64484173654098
                    ],
                    [
                        121.82708546519,
                        0.64459096587485
                    ],
                    [
                        121.82708546519,
                        0.64443004351573
                    ],
                    [
                        121.82707205415,
                        0.64421816240183
                    ],
                    [
                        121.82706668973,
                        0.64402103249679
                    ],
                    [
                        121.827057302,
                        0.64379037708804
                    ],
                    [
                        121.82705461979,
                        0.64363079572354
                    ],
                    [
                        121.82704389095,
                        0.64345244007496
                    ],
                    [
                        121.82703852654,
                        0.6432445819804
                    ],
                    [
                        121.82703047991,
                        0.64290530391111
                    ],
                    [
                        121.82702243328,
                        0.64259418724275
                    ],
                    [
                        121.82701706886,
                        0.64231123198053
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1879,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0019966729942289523,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82870015502,
                        0.65639326594962
                    ],
                    [
                        121.82871624827,
                        0.65651798048272
                    ],
                    [
                        121.82873904705,
                        0.65666281025921
                    ],
                    [
                        121.8287537992,
                        0.65685591662131
                    ],
                    [
                        121.82876586914,
                        0.65697929012653
                    ],
                    [
                        121.82878732681,
                        0.65713753005268
                    ],
                    [
                        121.82881146669,
                        0.65725956253468
                    ],
                    [
                        121.82884633541,
                        0.65731320318516
                    ],
                    [
                        121.82889863849,
                        0.65734941062391
                    ],
                    [
                        121.82899519801,
                        0.65737623094874
                    ],
                    [
                        121.82910919189,
                        0.65739232314357
                    ],
                    [
                        121.82916551828,
                        0.65740975635457
                    ],
                    [
                        121.82921111584,
                        0.65742853058175
                    ],
                    [
                        121.82924196124,
                        0.657479489198
                    ],
                    [
                        121.82926207781,
                        0.65761224980105
                    ],
                    [
                        121.82926878333,
                        0.6577731717394
                    ],
                    [
                        121.82927012444,
                        0.65791666046339
                    ],
                    [
                        121.82927012444,
                        0.65808965153636
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1880,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.009157390002113226,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82926744223,
                        0.65809635661658
                    ],
                    [
                        121.82927280664,
                        0.65836724185021
                    ],
                    [
                        121.82927951217,
                        0.65857107627373
                    ],
                    [
                        121.82927951217,
                        0.65876552357787
                    ],
                    [
                        121.82928755879,
                        0.65895460681117
                    ],
                    [
                        121.82928353548,
                        0.65915039511612
                    ],
                    [
                        121.82930365205,
                        0.65932606817769
                    ],
                    [
                        121.82930231094,
                        0.65954331271854
                    ],
                    [
                        121.82931169868,
                        0.65964522990728
                    ],
                    [
                        121.82931169868,
                        0.65979140060853
                    ],
                    [
                        121.82931706309,
                        0.65991343302557
                    ],
                    [
                        121.82932645082,
                        0.66000059903589
                    ],
                    [
                        121.82933449745,
                        0.6600488755948
                    ],
                    [
                        121.82935193181,
                        0.66007971895165
                    ],
                    [
                        121.82939350605,
                        0.66009983418426
                    ],
                    [
                        121.8294391036,
                        0.66010519824628
                    ],
                    [
                        121.82950213552,
                        0.66010519824628
                    ],
                    [
                        121.82961210608,
                        0.66010117519976
                    ],
                    [
                        121.82979181409,
                        0.66009312910674
                    ],
                    [
                        121.83001175523,
                        0.66009581113774
                    ],
                    [
                        121.83014050126,
                        0.66009178809122
                    ],
                    [
                        121.830419451,
                        0.66008240098267
                    ],
                    [
                        121.83058843017,
                        0.66008240098267
                    ],
                    [
                        121.83078423142,
                        0.66006899082755
                    ],
                    [
                        121.83089420199,
                        0.66006899082755
                    ],
                    [
                        121.83100283146,
                        0.6600743548896
                    ],
                    [
                        121.83105513453,
                        0.66008374199817
                    ],
                    [
                        121.83109268546,
                        0.66010385723078
                    ],
                    [
                        121.83112218976,
                        0.66014006464926
                    ],
                    [
                        121.83115035295,
                        0.66020845643898
                    ],
                    [
                        121.83115035295,
                        0.66035060407738
                    ],
                    [
                        121.83114632964,
                        0.66057723568113
                    ],
                    [
                        121.83115839958,
                        0.66077838798349
                    ],
                    [
                        121.83114901185,
                        0.66094601489591
                    ],
                    [
                        121.83113023639,
                        0.66108548048273
                    ],
                    [
                        121.83111950755,
                        0.66122360505043
                    ],
                    [
                        121.83111548424,
                        0.66129199682525
                    ],
                    [
                        121.83111682534,
                        0.66134161438679
                    ],
                    [
                        121.8311342597,
                        0.66137782179623
                    ],
                    [
                        121.83116108179,
                        0.66141000615997
                    ],
                    [
                        121.83122813702,
                        0.66142878037206
                    ],
                    [
                        121.83128848672,
                        0.66142609834176
                    ],
                    [
                        121.83148160577,
                        0.66141268819028
                    ],
                    [
                        121.83157280087,
                        0.66141134717512
                    ],
                    [
                        121.83175384998,
                        0.66140598311452
                    ],
                    [
                        121.83184236288,
                        0.66140330108422
                    ],
                    [
                        121.83201670647,
                        0.66141671123573
                    ],
                    [
                        121.83215081692,
                        0.66142073428118
                    ],
                    [
                        121.83231040835,
                        0.6614274393569
                    ],
                    [
                        121.83246865869,
                        0.66141805225087
                    ],
                    [
                        121.83268323541,
                        0.66140330108422
                    ],
                    [
                        121.83278113604,
                        0.66140196006906
                    ],
                    [
                        121.83292463422,
                        0.66140866514483
                    ],
                    [
                        121.83305606246,
                        0.66141268819028
                    ],
                    [
                        121.83319687843,
                        0.66143414443265
                    ],
                    [
                        121.83333232999,
                        0.66145425965978
                    ],
                    [
                        121.8334262073,
                        0.66147035184141
                    ],
                    [
                        121.83357641101,
                        0.6614998541743
                    ],
                    [
                        121.83371186256,
                        0.66150790026505
                    ],
                    [
                        121.83384999633,
                        0.66153069752213
                    ],
                    [
                        121.83397471905,
                        0.66153874361283
                    ],
                    [
                        121.83409810066,
                        0.66156422289999
                    ],
                    [
                        121.83419063687,
                        0.66158970218701
                    ],
                    [
                        121.83425635099,
                        0.66160847639841
                    ],
                    [
                        121.83429792523,
                        0.6616339556852
                    ],
                    [
                        121.83430328965,
                        0.66166748106235
                    ],
                    [
                        121.83430865407,
                        0.66174257790637
                    ],
                    [
                        121.83429524302,
                        0.66190215869612
                    ],
                    [
                        121.83429524302,
                        0.662095264855
                    ],
                    [
                        121.83429792523,
                        0.6622548456334
                    ],
                    [
                        121.83429792523,
                        0.66247611309076
                    ],
                    [
                        121.83429524302,
                        0.66254048180377
                    ],
                    [
                        121.83429524302,
                        0.66254048180377
                    ],
                    [
                        121.83429524302,
                        0.66254048180377
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1881,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0027753596146666277,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83430328965,
                        0.66163797873047
                    ],
                    [
                        121.83445081115,
                        0.66163663771539
                    ],
                    [
                        121.83459028602,
                        0.661646024821
                    ],
                    [
                        121.83469891548,
                        0.66165809395678
                    ],
                    [
                        121.83481559157,
                        0.66167016309253
                    ],
                    [
                        121.8349725008,
                        0.66168893730362
                    ],
                    [
                        121.83505028486,
                        0.66168357324331
                    ],
                    [
                        121.83513879776,
                        0.66166748106235
                    ],
                    [
                        121.83519244194,
                        0.66166479903219
                    ],
                    [
                        121.83525145054,
                        0.66166345801712
                    ],
                    [
                        121.83529302478,
                        0.66167418613775
                    ],
                    [
                        121.83530777693,
                        0.6616902783187
                    ],
                    [
                        121.83532118797,
                        0.6617184396352
                    ],
                    [
                        121.83533191681,
                        0.66178012632794
                    ],
                    [
                        121.83533459902,
                        0.66186461027546
                    ],
                    [
                        121.83531850576,
                        0.66198798365655
                    ],
                    [
                        121.83530107141,
                        0.66213549530382
                    ],
                    [
                        121.8352983892,
                        0.66224679954386
                    ],
                    [
                        121.83529570699,
                        0.66240906234715
                    ],
                    [
                        121.83527559042,
                        0.66249488729879
                    ],
                    [
                        121.8352688849,
                        0.66254316383345
                    ],
                    [
                        121.83526754379,
                        0.66274833910047
                    ],
                    [
                        121.83527156711,
                        0.66289182768086
                    ],
                    [
                        121.83527290821,
                        0.66300715494808
                    ],
                    [
                        121.83527290821,
                        0.66315198453564
                    ],
                    [
                        121.83527827263,
                        0.66327669889931
                    ],
                    [
                        121.83528229594,
                        0.66336252383593
                    ],
                    [
                        121.83528631926,
                        0.66343896166885
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1882,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0038161531235515215,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83530241251,
                        0.66220656909594
                    ],
                    [
                        121.83554247022,
                        0.66224277649909
                    ],
                    [
                        121.83564841747,
                        0.66225216360356
                    ],
                    [
                        121.83580800891,
                        0.66226691476769
                    ],
                    [
                        121.83590188622,
                        0.66227764288704
                    ],
                    [
                        121.8359823525,
                        0.66228837100636
                    ],
                    [
                        121.83608293533,
                        0.66228702999145
                    ],
                    [
                        121.83625862002,
                        0.6622548456334
                    ],
                    [
                        121.83634713292,
                        0.6622494815737
                    ],
                    [
                        121.83640748262,
                        0.66226289172294
                    ],
                    [
                        121.83646917343,
                        0.66227496085722
                    ],
                    [
                        121.83649867773,
                        0.66231519130457
                    ],
                    [
                        121.83652147651,
                        0.66237285494522
                    ],
                    [
                        121.83652415872,
                        0.66252438962558
                    ],
                    [
                        121.83652147651,
                        0.66271481373063
                    ],
                    [
                        121.83652281761,
                        0.66283818709055
                    ],
                    [
                        121.8365187943,
                        0.66295083232954
                    ],
                    [
                        121.83650940657,
                        0.66307956974239
                    ],
                    [
                        121.83650806546,
                        0.663154666565
                    ],
                    [
                        121.83650538325,
                        0.66333033948487
                    ],
                    [
                        121.83650404215,
                        0.66348992022349
                    ],
                    [
                        121.83649599552,
                        0.66362670370963
                    ],
                    [
                        121.83650538325,
                        0.66374471298873
                    ],
                    [
                        121.83650135994,
                        0.66389356559815
                    ],
                    [
                        121.83649733663,
                        0.66409069472264
                    ],
                    [
                        121.83650538325,
                        0.66423686529288
                    ],
                    [
                        121.83650672436,
                        0.66435353354307
                    ],
                    [
                        121.83650940657,
                        0.6644809299051
                    ],
                    [
                        121.83650940657,
                        0.66463246452089
                    ],
                    [
                        121.83651208878,
                        0.66478802217475
                    ],
                    [
                        121.83651342988,
                        0.6648979853409
                    ],
                    [
                        121.83651342988,
                        0.6648979853409
                    ],
                    [
                        121.83651342988,
                        0.6648979853409
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1883,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0019307086186701248,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83650806546,
                        0.66417115558753
                    ],
                    [
                        121.83659926057,
                        0.6641657915299
                    ],
                    [
                        121.83664485812,
                        0.66415506341465
                    ],
                    [
                        121.83674275875,
                        0.66414031225615
                    ],
                    [
                        121.83680981398,
                        0.66414165327056
                    ],
                    [
                        121.83692783117,
                        0.66415238138584
                    ],
                    [
                        121.83706730604,
                        0.66415238138584
                    ],
                    [
                        121.83722957969,
                        0.66415104037143
                    ],
                    [
                        121.83735564351,
                        0.66414299428497
                    ],
                    [
                        121.83749914169,
                        0.66414433529938
                    ],
                    [
                        121.83767080307,
                        0.66414433529938
                    ],
                    [
                        121.83781161904,
                        0.66414031225615
                    ],
                    [
                        121.83799400926,
                        0.66414701732819
                    ],
                    [
                        121.83811202645,
                        0.66414701732819
                    ],
                    [
                        121.83823406696,
                        0.66414835834261
                    ],
                    [
                        121.83833062649,
                        0.66414835834261
                    ],
                    [
                        121.83843523264,
                        0.66415238138584
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1884,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003356233523932063,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.83649599552,
                        0.66416981457313
                    ],
                    [
                        121.83642089367,
                        0.66418456573155
                    ],
                    [
                        121.83635115623,
                        0.66418992978915
                    ],
                    [
                        121.83626666665,
                        0.66419127080355
                    ],
                    [
                        121.83616876602,
                        0.66418858877475
                    ],
                    [
                        121.8361620605,
                        0.66418858877475
                    ],
                    [
                        121.8361620605,
                        0.66418858877475
                    ],
                    [
                        121.8361620605,
                        0.66418858877475
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1885,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.000622831571349703,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82781502604,
                        0.65397675363038
                    ],
                    [
                        121.82775065303,
                        0.6540075970247
                    ],
                    [
                        121.82770773768,
                        0.65401564312753
                    ],
                    [
                        121.82761386037,
                        0.65402771228177
                    ],
                    [
                        121.82753205299,
                        0.6540290532989
                    ],
                    [
                        121.82740196586,
                        0.65402503024748
                    ],
                    [
                        121.82720080018,
                        0.65402637126462
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1886,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0007754788764979391,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82719543576,
                        0.65402234821322
                    ],
                    [
                        121.82713642716,
                        0.65401564312753
                    ],
                    [
                        121.82704925537,
                        0.65400625600756
                    ],
                    [
                        121.82689234614,
                        0.65401162007612
                    ],
                    [
                        121.82682797313,
                        0.65401296109325
                    ],
                    [
                        121.82673275471,
                        0.65401430211039
                    ],
                    [
                        121.82660534978,
                        0.65402234821322
                    ],
                    [
                        121.82653829455,
                        0.65401698414467
                    ],
                    [
                        121.82649537921,
                        0.65401698414467
                    ],
                    [
                        121.82642161846,
                        0.65402234821322
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1887,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0037371064173464578,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82642295957,
                        0.65401966617894
                    ],
                    [
                        121.82637199759,
                        0.65403575838456
                    ],
                    [
                        121.82627409697,
                        0.65406123771001
                    ],
                    [
                        121.82612925768,
                        0.65407062482989
                    ],
                    [
                        121.82603538036,
                        0.65407196584702
                    ],
                    [
                        121.82590529323,
                        0.65408671703535
                    ],
                    [
                        121.82573094964,
                        0.65408001194975
                    ],
                    [
                        121.82558342814,
                        0.65407867093263
                    ],
                    [
                        121.82538226247,
                        0.65408135296687
                    ],
                    [
                        121.82525753975,
                        0.6540773299155
                    ],
                    [
                        121.82513281703,
                        0.65408671703535
                    ],
                    [
                        121.82493701577,
                        0.65409610415517
                    ],
                    [
                        121.82480290532,
                        0.65408939906959
                    ],
                    [
                        121.8247063458,
                        0.65409744517229
                    ],
                    [
                        121.82468622923,
                        0.65409878618941
                    ],
                    [
                        121.82466745377,
                        0.65408135296687
                    ],
                    [
                        121.82466745377,
                        0.65404112245309
                    ],
                    [
                        121.82466343045,
                        0.6539445692187
                    ],
                    [
                        121.82466208935,
                        0.65381985462155
                    ],
                    [
                        121.82465672493,
                        0.65368575290071
                    ],
                    [
                        121.82465940714,
                        0.65356908440068
                    ],
                    [
                        121.82465672493,
                        0.65338000096383
                    ],
                    [
                        121.82465270162,
                        0.65326467347402
                    ],
                    [
                        121.82465001941,
                        0.65316946124208
                    ],
                    [
                        121.8245869875,
                        0.65316946124208
                    ],
                    [
                        121.82451188564,
                        0.6531721432768
                    ],
                    [
                        121.82434290648,
                        0.65317348429417
                    ],
                    [
                        121.82422891259,
                        0.65317348429417
                    ],
                    [
                        121.82359591126,
                        0.65318555345042
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1891,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002088900720543447,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82465001941,
                        0.65316409717261
                    ],
                    [
                        121.82465136051,
                        0.65309704630389
                    ],
                    [
                        121.8246486783,
                        0.65301926729505
                    ],
                    [
                        121.82464465499,
                        0.65291600895387
                    ],
                    [
                        121.82462990284,
                        0.65279799941851
                    ],
                    [
                        121.82462587953,
                        0.6526598746179
                    ],
                    [
                        121.82461649179,
                        0.65251906777843
                    ],
                    [
                        121.82460844517,
                        0.65233668939002
                    ],
                    [
                        121.82460442185,
                        0.65229109479189
                    ],
                    [
                        121.82460173965,
                        0.65223477205244
                    ],
                    [
                        121.82459905744,
                        0.65219320050626
                    ],
                    [
                        121.82459637523,
                        0.65214760590683
                    ],
                    [
                        121.82463794947,
                        0.65214760590683
                    ],
                    [
                        121.82468891144,
                        0.65215699303028
                    ],
                    [
                        121.82474792004,
                        0.6521583340479
                    ],
                    [
                        121.82481631637,
                        0.6521583340479
                    ],
                    [
                        121.82493165135,
                        0.65216101608318
                    ],
                    [
                        121.82497322559,
                        0.65216772117134
                    ],
                    [
                        121.82507783175,
                        0.6521851544005
                    ],
                    [
                        121.82514488697,
                        0.65217576727711
                    ],
                    [
                        121.82519987226,
                        0.6521583340479
                    ],
                    [
                        121.82528033853,
                        0.65213151369517
                    ],
                    [
                        121.82534471154,
                        0.65210603435992
                    ],
                    [
                        121.82541444898,
                        0.65206043975969
                    ],
                    [
                        121.82549089193,
                        0.65202959635344
                    ],
                    [
                        121.82553380728,
                        0.65200814007069
                    ],
                    [
                        121.82562232018,
                        0.65197997869947
                    ],
                    [
                        121.82562232018,
                        0.65197997869947
                    ],
                    [
                        121.82562232018,
                        0.65197997869947
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1890,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0005641419750045363,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82465270162,
                        0.65310509240819
                    ],
                    [
                        121.82473316789,
                        0.65310509240819
                    ],
                    [
                        121.82480692863,
                        0.65310777444295
                    ],
                    [
                        121.82486191392,
                        0.65311179749509
                    ],
                    [
                        121.82493433356,
                        0.65311045647772
                    ],
                    [
                        121.8250349164,
                        0.65311179749509
                    ],
                    [
                        121.8250952661,
                        0.65310777444295
                    ],
                    [
                        121.8251529336,
                        0.65310911546032
                    ],
                    [
                        121.82521596551,
                        0.65310106935604
                    ],
                    [
                        121.82521596551,
                        0.65310106935604
                    ],
                    [
                        121.82521596551,
                        0.65310106935604
                    ],
                    [
                        121.82521596551,
                        0.65310106935604
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1892,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006344814480922306,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82459369302,
                        0.65213955980099
                    ],
                    [
                        121.82460710406,
                        0.65199204785858
                    ],
                    [
                        121.82459235191,
                        0.65182710268149
                    ],
                    [
                        121.82459235191,
                        0.65174395958206
                    ],
                    [
                        121.82458028197,
                        0.65153610182743
                    ],
                    [
                        121.82457089424,
                        0.65138322579599
                    ],
                    [
                        121.82456687093,
                        0.65129203658204
                    ],
                    [
                        121.8245588243,
                        0.65122900874203
                    ],
                    [
                        121.82453602552,
                        0.65118877820544
                    ],
                    [
                        121.82449579239,
                        0.65116732191912
                    ],
                    [
                        121.8244099617,
                        0.65115927581174
                    ],
                    [
                        121.82430535555,
                        0.65116195784754
                    ],
                    [
                        121.82408407331,
                        0.65117268599071
                    ],
                    [
                        121.82385608554,
                        0.65119146024122
                    ],
                    [
                        121.82375818491,
                        0.65120084736645
                    ],
                    [
                        121.82363346219,
                        0.651206211438
                    ],
                    [
                        121.82353824377,
                        0.65121693958109
                    ],
                    [
                        121.82339072227,
                        0.65121425754533
                    ],
                    [
                        121.823220402,
                        0.65122096263475
                    ],
                    [
                        121.82301655412,
                        0.65122498568839
                    ],
                    [
                        121.8228636682,
                        0.65122230365261
                    ],
                    [
                        121.82270541787,
                        0.65121157550955
                    ],
                    [
                        121.82257398963,
                        0.65120889347378
                    ],
                    [
                        121.8224452436,
                        0.65121693958109
                    ],
                    [
                        121.82232454419,
                        0.65121962161686
                    ],
                    [
                        121.8222373724,
                        0.65122632670627
                    ],
                    [
                        121.82213410735,
                        0.65122766772415
                    ],
                    [
                        121.82203754783,
                        0.65123571383144
                    ],
                    [
                        121.82191953063,
                        0.65123437281356
                    ],
                    [
                        121.82181224227,
                        0.65121828059897
                    ],
                    [
                        121.82168349624,
                        0.65121828059897
                    ],
                    [
                        121.82157352567,
                        0.65122632670627
                    ],
                    [
                        121.82139784098,
                        0.65122632670627
                    ],
                    [
                        121.82125031948,
                        0.65122632670627
                    ],
                    [
                        121.82105988264,
                        0.6512383958672
                    ],
                    [
                        121.82090699673,
                        0.65123973688508
                    ],
                    [
                        121.82071655989,
                        0.65123705484931
                    ],
                    [
                        121.82040676475,
                        0.65124241892083
                    ],
                    [
                        121.82016536593,
                        0.65124241892083
                    ],
                    [
                        121.81999772787,
                        0.65124375993871
                    ],
                    [
                        121.81986227632,
                        0.65124375993871
                    ],
                    [
                        121.81974157691,
                        0.65124912401021
                    ],
                    [
                        121.81962624192,
                        0.65124375993871
                    ],
                    [
                        121.81954041123,
                        0.65124510095658
                    ],
                    [
                        121.81936472654,
                        0.6512383958672
                    ],
                    [
                        121.81921720505,
                        0.65124778299233
                    ],
                    [
                        121.81917697191,
                        0.65125314706384
                    ],
                    [
                        121.81916356087,
                        0.65124912401021
                    ],
                    [
                        121.81916356087,
                        0.65124912401021
                    ],
                    [
                        121.81916356087,
                        0.65124912401021
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1893,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0050254709826002735,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82170763612,
                        0.65121693958109
                    ],
                    [
                        121.82171702385,
                        0.65136042849267
                    ],
                    [
                        121.821731776,
                        0.65159108355692
                    ],
                    [
                        121.82174921036,
                        0.65179089520288
                    ],
                    [
                        121.82174921036,
                        0.6519840017525
                    ],
                    [
                        121.82174652815,
                        0.65216503913606
                    ],
                    [
                        121.82176396251,
                        0.65234607651311
                    ],
                    [
                        121.82177200913,
                        0.65260221086507
                    ],
                    [
                        121.82178005576,
                        0.65276715601676
                    ],
                    [
                        121.8217921257,
                        0.65309570528651
                    ],
                    [
                        121.82179883122,
                        0.6534135263964
                    ],
                    [
                        121.82180553675,
                        0.65370452714185
                    ],
                    [
                        121.82180956006,
                        0.65388422344627
                    ],
                    [
                        121.8218202889,
                        0.6541336526343
                    ],
                    [
                        121.82182565331,
                        0.65431066688924
                    ],
                    [
                        121.82183504105,
                        0.65447695300185
                    ],
                    [
                        121.82183772326,
                        0.6547237001265
                    ],
                    [
                        121.82184174657,
                        0.65491278351272
                    ],
                    [
                        121.82184711099,
                        0.65510991299291
                    ],
                    [
                        121.82186052203,
                        0.6553231346668
                    ],
                    [
                        121.82186186314,
                        0.65553233328143
                    ],
                    [
                        121.82185918093,
                        0.65577505730411
                    ],
                    [
                        121.82187661529,
                        0.65599498403275
                    ],
                    [
                        121.82186454535,
                        0.65612238060893
                    ],
                    [
                        121.82185381651,
                        0.65623636701646
                    ],
                    [
                        121.82185381651,
                        0.65623636701646
                    ],
                    [
                        121.82185381651,
                        0.65623636701646
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1894,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003458901971517177,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82178810239,
                        0.65121559856321
                    ],
                    [
                        121.82179346681,
                        0.65105199437863
                    ],
                    [
                        121.82177871466,
                        0.65090582342233
                    ],
                    [
                        121.82177737355,
                        0.65072880904758
                    ],
                    [
                        121.8217626214,
                        0.65054643059436
                    ],
                    [
                        121.82175323367,
                        0.65039087249672
                    ],
                    [
                        121.82171031833,
                        0.65037209824323
                    ],
                    [
                        121.82171165943,
                        0.65034393686287
                    ],
                    [
                        121.8217009306,
                        0.65031175242796
                    ],
                    [
                        121.82167008519,
                        0.65029029613792
                    ],
                    [
                        121.82158827782,
                        0.65028225002912
                    ],
                    [
                        121.82150110602,
                        0.65028761410166
                    ],
                    [
                        121.82123824954,
                        0.65030102428297
                    ],
                    [
                        121.82109475136,
                        0.65031041140984
                    ],
                    [
                        121.82096198201,
                        0.6503130934461
                    ],
                    [
                        121.8207809329,
                        0.65030638835547
                    ],
                    [
                        121.82051405311,
                        0.65031577548234
                    ],
                    [
                        121.82027265429,
                        0.65031041140984
                    ],
                    [
                        121.82004868984,
                        0.6503130934461
                    ],
                    [
                        121.81975498796,
                        0.65031577548234
                    ],
                    [
                        121.819203794,
                        0.65034125482662
                    ],
                    [
                        121.81918635964,
                        0.65034125482662
                    ],
                    [
                        121.81918635964,
                        0.65034125482662
                    ],
                    [
                        121.81918635964,
                        0.65034125482662
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1895,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0026969425477377765,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82174384594,
                        0.65217576727711
                    ],
                    [
                        121.8216137588,
                        0.6521851544005
                    ],
                    [
                        121.82146221399,
                        0.65218917745339
                    ],
                    [
                        121.82128250599,
                        0.65219051847102
                    ],
                    [
                        121.82114303112,
                        0.65218917745339
                    ],
                    [
                        121.82103171945,
                        0.65218917745339
                    ],
                    [
                        121.8208989501,
                        0.65219051847102
                    ],
                    [
                        121.82079166174,
                        0.65219051847102
                    ],
                    [
                        121.82063341141,
                        0.65219990559438
                    ],
                    [
                        121.82046443224,
                        0.65220661068248
                    ],
                    [
                        121.82028740644,
                        0.65220661068248
                    ],
                    [
                        121.82013586164,
                        0.65220661068248
                    ],
                    [
                        121.8199762702,
                        0.65221331577059
                    ],
                    [
                        121.8197388947,
                        0.65221733882345
                    ],
                    [
                        121.819588691,
                        0.65221599780583
                    ],
                    [
                        121.81946128607,
                        0.65222270289391
                    ],
                    [
                        121.81930169463,
                        0.65222002085867
                    ],
                    [
                        121.81919977069,
                        0.65221599780583
                    ],
                    [
                        121.81907370687,
                        0.65221733882345
                    ],
                    [
                        121.81904822588,
                        0.65221867984106
                    ],
                    [
                        121.81904822588,
                        0.65221867984106
                    ],
                    [
                        121.81904822588,
                        0.65221867984106
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1896,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0022760758060296643,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82176396251,
                        0.65226025138702
                    ],
                    [
                        121.82206436992,
                        0.65224281815812
                    ],
                    [
                        121.82226017118,
                        0.65223745408767
                    ],
                    [
                        121.82245194912,
                        0.65223343103482
                    ],
                    [
                        121.82267591357,
                        0.6522307489996
                    ],
                    [
                        121.82285159826,
                        0.65222806696437
                    ],
                    [
                        121.82326734066,
                        0.6522146567882
                    ],
                    [
                        121.82355567813,
                        0.652201246612
                    ],
                    [
                        121.82384669781,
                        0.65219454152388
                    ],
                    [
                        121.82403847575,
                        0.65218381338288
                    ],
                    [
                        121.82403847575,
                        0.65218381338288
                    ],
                    [
                        121.82403847575,
                        0.65218381338288
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1897,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0033077526117258216,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82178810239,
                        0.65316007412052
                    ],
                    [
                        121.82161509991,
                        0.65317080225944
                    ],
                    [
                        121.82139381766,
                        0.65318153039832
                    ],
                    [
                        121.82127848268,
                        0.65318823548513
                    ],
                    [
                        121.82110548019,
                        0.65318689446777
                    ],
                    [
                        121.82093650103,
                        0.65319359955457
                    ],
                    [
                        121.82072326541,
                        0.65319225853721
                    ],
                    [
                        121.82037726045,
                        0.65318823548513
                    ],
                    [
                        121.82021632791,
                        0.653198963624
                    ],
                    [
                        121.81999906898,
                        0.653198963624
                    ],
                    [
                        121.81979387999,
                        0.65320835074547
                    ],
                    [
                        121.81959673762,
                        0.65321237379754
                    ],
                    [
                        121.81934326887,
                        0.65321237379754
                    ],
                    [
                        121.81915283203,
                        0.65320969176283
                    ],
                    [
                        121.81898251176,
                        0.65321773786695
                    ],
                    [
                        121.81878268719,
                        0.65322310193635
                    ],
                    [
                        121.81858956814,
                        0.65322310193635
                    ],
                    [
                        121.81848362088,
                        0.65324053516187
                    ],
                    [
                        121.81848362088,
                        0.65324053516187
                    ],
                    [
                        121.81848362088,
                        0.65324053516187
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1898,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004696841769538119,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82181358337,
                        0.65419936247209
                    ],
                    [
                        121.82148098946,
                        0.65420472654045
                    ],
                    [
                        121.82127580047,
                        0.65421143162588
                    ],
                    [
                        121.82079836726,
                        0.65422484179672
                    ],
                    [
                        121.82048588991,
                        0.65422618281381
                    ],
                    [
                        121.82019755244,
                        0.65423556993336
                    ],
                    [
                        121.81978046894,
                        0.65424495705291
                    ],
                    [
                        121.8194411695,
                        0.65425300315537
                    ],
                    [
                        121.81916624308,
                        0.65426104925781
                    ],
                    [
                        121.81882962584,
                        0.65426775434316
                    ],
                    [
                        121.81841388345,
                        0.65427848247972
                    ],
                    [
                        121.81802228093,
                        0.654283846548
                    ],
                    [
                        121.81764140725,
                        0.65429055163332
                    ],
                    [
                        121.81742548943,
                        0.65429055163332
                    ],
                    [
                        121.81717604399,
                        0.65430664383807
                    ],
                    [
                        121.81711837649,
                        0.65430664383807
                    ],
                    [
                        121.81711837649,
                        0.65430664383807
                    ],
                    [
                        121.81711837649,
                        0.65430664383807
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1899,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002784616217244143,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82466477156,
                        0.65407867093263
                    ],
                    [
                        121.82457223535,
                        0.654082693984
                    ],
                    [
                        121.82447433472,
                        0.654082693984
                    ],
                    [
                        121.82429730892,
                        0.654082693984
                    ],
                    [
                        121.82418599725,
                        0.65408537601823
                    ],
                    [
                        121.82403445244,
                        0.65408671703535
                    ],
                    [
                        121.82391643524,
                        0.65408671703535
                    ],
                    [
                        121.82377025485,
                        0.65408671703535
                    ],
                    [
                        121.82363212109,
                        0.6540907400867
                    ],
                    [
                        121.82336255908,
                        0.65409476313806
                    ],
                    [
                        121.82188868523,
                        0.65412292449744
                    ],
                    [
                        121.8218806386,
                        0.65412292449744
                    ],
                    [
                        121.8218806386,
                        0.65412292449744
                    ],
                    [
                        121.8218806386,
                        0.65412292449744
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1900,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002245352077220748,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82462185621,
                        0.65408805805247
                    ],
                    [
                        121.82462990284,
                        0.65420204450626
                    ],
                    [
                        121.82463794947,
                        0.65438308180992
                    ],
                    [
                        121.82464063168,
                        0.65455339097111
                    ],
                    [
                        121.82464197278,
                        0.65469151571964
                    ],
                    [
                        121.8246486783,
                        0.65486987097181
                    ],
                    [
                        121.82465538383,
                        0.65496910622214
                    ],
                    [
                        121.82465136051,
                        0.65501067774535
                    ],
                    [
                        121.82463929057,
                        0.65504152113331
                    ],
                    [
                        121.82461515069,
                        0.65506565943681
                    ],
                    [
                        121.82456016541,
                        0.65507236452108
                    ],
                    [
                        121.82441398501,
                        0.65507370553793
                    ],
                    [
                        121.8242919445,
                        0.6550777285885
                    ],
                    [
                        121.82397678494,
                        0.65508041062221
                    ],
                    [
                        121.82336121798,
                        0.65508443367278
                    ],
                    [
                        121.82336121798,
                        0.65508443367278
                    ],
                    [
                        121.82336121798,
                        0.65508443367278
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1901,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.001196368671466777,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82463526726,
                        0.65504956723449
                    ],
                    [
                        121.82493969798,
                        0.65503347503213
                    ],
                    [
                        121.82516500354,
                        0.65503079299839
                    ],
                    [
                        121.82539969683,
                        0.65501604181284
                    ],
                    [
                        121.82582885027,
                        0.65497581130655
                    ],
                    [
                        121.82582885027,
                        0.65497581130655
                    ],
                    [
                        121.82582885027,
                        0.65497581130655
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1902,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005849193861503334,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81383401155,
                        0.63454805995453
                    ],
                    [
                        121.81383132935,
                        0.63432410923194
                    ],
                    [
                        121.81382864714,
                        0.63414843530503
                    ],
                    [
                        121.81382864714,
                        0.63386816162305
                    ],
                    [
                        121.81382462382,
                        0.63366432620843
                    ],
                    [
                        121.81383267045,
                        0.63350206248451
                    ],
                    [
                        121.8136690557,
                        0.63348865225916
                    ],
                    [
                        121.81363284588,
                        0.63341623704168
                    ],
                    [
                        121.81352823973,
                        0.63339880374844
                    ],
                    [
                        121.81341022253,
                        0.63338807556796
                    ],
                    [
                        121.8132533133,
                        0.63339075761308
                    ],
                    [
                        121.81310981512,
                        0.63338405250027
                    ],
                    [
                        121.81293949485,
                        0.63339075761308
                    ],
                    [
                        121.8128362298,
                        0.63340282681612
                    ],
                    [
                        121.81268334389,
                        0.63340550886123
                    ],
                    [
                        121.81252777576,
                        0.63341087295147
                    ],
                    [
                        121.81240841746,
                        0.63342562419956
                    ],
                    [
                        121.81224614382,
                        0.63342964726721
                    ],
                    [
                        121.81205838919,
                        0.63344573953781
                    ],
                    [
                        121.8118827045,
                        0.63345780874074
                    ],
                    [
                        121.81169897318,
                        0.6334631728309
                    ],
                    [
                        121.81153669953,
                        0.63346585487599
                    ],
                    [
                        121.81134492159,
                        0.63346451385345
                    ],
                    [
                        121.81118667126,
                        0.63346719589854
                    ],
                    [
                        121.81081920862,
                        0.63345780874074
                    ],
                    [
                        121.81075751781,
                        0.63346585487599
                    ],
                    [
                        121.81064486504,
                        0.63346853692107
                    ],
                    [
                        121.81051209569,
                        0.6334792651014
                    ],
                    [
                        121.81029215455,
                        0.6334899932817
                    ],
                    [
                        121.81011244655,
                        0.63349133430423
                    ],
                    [
                        121.80991128087,
                        0.63349938043945
                    ],
                    [
                        121.80975303054,
                        0.63351144964223
                    ],
                    [
                        121.80962026119,
                        0.63351413168728
                    ],
                    [
                        121.80947676301,
                        0.63352083679993
                    ],
                    [
                        121.80930241942,
                        0.63351681373234
                    ],
                    [
                        121.80909186602,
                        0.63352888293509
                    ],
                    [
                        121.80908381939,
                        0.63352485986751
                    ],
                    [
                        121.80908381939,
                        0.63352485986751
                    ],
                    [
                        121.80908381939,
                        0.63352485986751
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1903,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0010289577200687863,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80907845497,
                        0.63352217782247
                    ],
                    [
                        121.80894836783,
                        0.63352620089004
                    ],
                    [
                        121.80868417025,
                        0.63354363418286
                    ],
                    [
                        121.80856212974,
                        0.63355436236303
                    ],
                    [
                        121.80842936039,
                        0.63356106747562
                    ],
                    [
                        121.80823758245,
                        0.63356911361071
                    ],
                    [
                        121.80806860328,
                        0.63357179565575
                    ],
                    [
                        121.80805116892,
                        0.63356911361071
                    ],
                    [
                        121.80805116892,
                        0.63356911361071
                    ],
                    [
                        121.80805116892,
                        0.63356911361071
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1904,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0010950673908384585,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80901944637,
                        0.63353022395761
                    ],
                    [
                        121.80901676416,
                        0.63364018780355
                    ],
                    [
                        121.80902212858,
                        0.63379574641089
                    ],
                    [
                        121.80904090405,
                        0.63398885364107
                    ],
                    [
                        121.80907040834,
                        0.63421414540053
                    ],
                    [
                        121.80908918381,
                        0.63438043216908
                    ],
                    [
                        121.80909991264,
                        0.6344877139524
                    ],
                    [
                        121.809117347,
                        0.6345038062197
                    ],
                    [
                        121.80914148688,
                        0.63450782928653
                    ],
                    [
                        121.809207201,
                        0.63456147017714
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1905,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0042010222048330026,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80920854211,
                        0.63456147017714
                    ],
                    [
                        121.80937752128,
                        0.63454269586549
                    ],
                    [
                        121.80945664644,
                        0.63453062666511
                    ],
                    [
                        121.80958807468,
                        0.63452526257604
                    ],
                    [
                        121.80974364281,
                        0.63451989848697
                    ],
                    [
                        121.80984690785,
                        0.63451989848697
                    ],
                    [
                        121.80999308825,
                        0.63451185235334
                    ],
                    [
                        121.81013390422,
                        0.6345091703088
                    ],
                    [
                        121.81029483676,
                        0.63450648826426
                    ],
                    [
                        121.81044235826,
                        0.63450514724197
                    ],
                    [
                        121.81066766381,
                        0.6345038062197
                    ],
                    [
                        121.81090503931,
                        0.63451051133107
                    ],
                    [
                        121.81104719639,
                        0.6345091703088
                    ],
                    [
                        121.81119337678,
                        0.6345091703088
                    ],
                    [
                        121.81127786636,
                        0.63450112417515
                    ],
                    [
                        121.81142941117,
                        0.6345091703088
                    ],
                    [
                        121.81157559156,
                        0.6345091703088
                    ],
                    [
                        121.81194707751,
                        0.63450112417515
                    ],
                    [
                        121.8120932579,
                        0.63449710110834
                    ],
                    [
                        121.81249290705,
                        0.63448905497468
                    ],
                    [
                        121.81340619922,
                        0.63448503190783
                    ],
                    [
                        121.81340619922,
                        0.63448503190783
                    ],
                    [
                        121.81340619922,
                        0.63448503190783
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1906,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0010035375272518423,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81082725525,
                        0.63344976260546
                    ],
                    [
                        121.81082189083,
                        0.63324726819699
                    ],
                    [
                        121.81081786752,
                        0.63307159423357
                    ],
                    [
                        121.81081116199,
                        0.63286641776494
                    ],
                    [
                        121.81080713868,
                        0.63269208481136
                    ],
                    [
                        121.81079775095,
                        0.63244667764369
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1907,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDU",
                "panjang": 0.0006796884494869812,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11415693164,
                        0.50752229381753
                    ],
                    [
                        122.11416631937,
                        0.50744987701483
                    ],
                    [
                        122.1144144237,
                        0.50747535700106
                    ],
                    [
                        122.11458474398,
                        0.50749279067579
                    ],
                    [
                        122.1147403121,
                        0.50751022435048
                    ],
                    [
                        122.1147698164,
                        0.50751022435048
                    ],
                    [
                        122.1147698164,
                        0.50751022435048
                    ],
                    [
                        122.1147698164,
                        0.50751022435048
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1908,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0003611519638051191,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81383535266,
                        0.63350072146197
                    ],
                    [
                        121.81387558579,
                        0.63347255998869
                    ],
                    [
                        121.81392386556,
                        0.63345780874074
                    ],
                    [
                        121.81404992938,
                        0.63344976260546
                    ],
                    [
                        121.81418403983,
                        0.63343232931232
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1909,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDU",
                "panjang": 0.001958311273339714,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.1141462028,
                        0.50743914859955
                    ],
                    [
                        122.11406573653,
                        0.50743512544383
                    ],
                    [
                        122.11394637823,
                        0.50742842018425
                    ],
                    [
                        122.11381629109,
                        0.50741903282086
                    ],
                    [
                        122.11363524199,
                        0.50742976123618
                    ],
                    [
                        122.11349308491,
                        0.50743244334
                    ],
                    [
                        122.11337640882,
                        0.50743914859955
                    ],
                    [
                        122.11325839162,
                        0.50744317175529
                    ],
                    [
                        122.11313769221,
                        0.50743780754764
                    ],
                    [
                        122.1129566431,
                        0.50743512544383
                    ],
                    [
                        122.11284533143,
                        0.5074230559766
                    ],
                    [
                        122.11274072528,
                        0.50740964545744
                    ],
                    [
                        122.11261600256,
                        0.50739221178249
                    ],
                    [
                        122.11243495345,
                        0.50733320549768
                    ],
                    [
                        122.11220964789,
                        0.50727151710845
                    ],
                    [
                        122.11220964789,
                        0.50727151710845
                    ],
                    [
                        122.11220964789,
                        0.50727151710845
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1910,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.008870592635413276,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81418672204,
                        0.63342964726721
                    ],
                    [
                        121.8145313859,
                        0.63340014477101
                    ],
                    [
                        121.81485056877,
                        0.63339880374844
                    ],
                    [
                        121.81510806084,
                        0.63339209863564
                    ],
                    [
                        121.81526228786,
                        0.63339478068076
                    ],
                    [
                        121.81547820568,
                        0.63339612170332
                    ],
                    [
                        121.81562438607,
                        0.63339343965819
                    ],
                    [
                        121.81580141187,
                        0.63339075761308
                    ],
                    [
                        121.81593418121,
                        0.63338941659052
                    ],
                    [
                        121.81610718369,
                        0.63337332431975
                    ],
                    [
                        121.81626006961,
                        0.6333827114777
                    ],
                    [
                        121.81638747454,
                        0.63337734738744
                    ],
                    [
                        121.81657388806,
                        0.63337868841002
                    ],
                    [
                        121.81665837765,
                        0.63337734738744
                    ],
                    [
                        121.8168219924,
                        0.63337064227461
                    ],
                    [
                        121.81698426604,
                        0.63337198329719
                    ],
                    [
                        121.81710764766,
                        0.63337064227461
                    ],
                    [
                        121.81722968817,
                        0.63336125511664
                    ],
                    [
                        121.8173584342,
                        0.63336125511664
                    ],
                    [
                        121.81742146611,
                        0.63335589102636
                    ],
                    [
                        121.81776747108,
                        0.63335991409406
                    ],
                    [
                        121.81805983186,
                        0.63335186795865
                    ],
                    [
                        121.81826099753,
                        0.63333711671033
                    ],
                    [
                        121.81841254234,
                        0.63332772955229
                    ],
                    [
                        121.81853994727,
                        0.63333041159745
                    ],
                    [
                        121.81863516569,
                        0.63333175262003
                    ],
                    [
                        121.81879743934,
                        0.63333041159745
                    ],
                    [
                        121.81891411543,
                        0.63332370648456
                    ],
                    [
                        121.8190830946,
                        0.63332236546198
                    ],
                    [
                        121.81919306517,
                        0.63333577568775
                    ],
                    [
                        121.81928694248,
                        0.63336125511664
                    ],
                    [
                        121.81943848729,
                        0.63341221397402
                    ],
                    [
                        121.81954711676,
                        0.63344842158291
                    ],
                    [
                        121.8197697401,
                        0.6335194957774
                    ],
                    [
                        121.81995481253,
                        0.63357313667826
                    ],
                    [
                        121.82007551193,
                        0.63361873144355
                    ],
                    [
                        121.82028204203,
                        0.63368578256826
                    ],
                    [
                        121.82043492794,
                        0.63372064915276
                    ],
                    [
                        121.82054892182,
                        0.63377160800661
                    ],
                    [
                        121.82066425681,
                        0.63378099516384
                    ],
                    [
                        121.82073131204,
                        0.63388291286985
                    ],
                    [
                        121.82079836726,
                        0.63402506124594
                    ],
                    [
                        121.82086139917,
                        0.63414843530503
                    ],
                    [
                        121.82090833783,
                        0.6342758324282
                    ],
                    [
                        121.82094052434,
                        0.634411275682
                    ],
                    [
                        121.82097405195,
                        0.63457890346646
                    ],
                    [
                        121.8209888041,
                        0.63472775693451
                    ],
                    [
                        121.82100087404,
                        0.63489538470873
                    ],
                    [
                        121.82100489736,
                        0.63506033043325
                    ],
                    [
                        121.82102099061,
                        0.63520918388743
                    ],
                    [
                        121.82103574276,
                        0.63531780667563
                    ],
                    [
                        121.82106256485,
                        0.6354036320869
                    ],
                    [
                        121.82109877467,
                        0.63551895998107
                    ],
                    [
                        121.82114169002,
                        0.63558601108113
                    ],
                    [
                        121.82118594646,
                        0.63565038013637
                    ],
                    [
                        121.82125970721,
                        0.63571609021279
                    ],
                    [
                        121.82130798697,
                        0.63575766189334
                    ],
                    [
                        121.82145282626,
                        0.6358287360561
                    ],
                    [
                        121.82146891952,
                        0.63583141809996
                    ],
                    [
                        121.82147026062,
                        0.6358287360561
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1911,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013062805765380989,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.82066962123,
                        0.63377965414138
                    ],
                    [
                        121.8206897378,
                        0.63375953880443
                    ],
                    [
                        121.82071655989,
                        0.63375015164715
                    ],
                    [
                        121.82079970837,
                        0.63374076448987
                    ],
                    [
                        121.82085067034,
                        0.63373137733257
                    ],
                    [
                        121.82094454765,
                        0.63371930813028
                    ],
                    [
                        121.82103976607,
                        0.63370187483805
                    ],
                    [
                        121.82117655873,
                        0.63367639541085
                    ],
                    [
                        121.82123690844,
                        0.6336710313209
                    ],
                    [
                        121.82130128145,
                        0.63365896211848
                    ],
                    [
                        121.82137906551,
                        0.63364555189353
                    ],
                    [
                        121.82144880295,
                        0.63363080064606
                    ],
                    [
                        121.82152658701,
                        0.63360934428603
                    ],
                    [
                        121.82159364223,
                        0.6335892289484
                    ],
                    [
                        121.82167679071,
                        0.63355704440805
                    ],
                    [
                        121.8217921257,
                        0.63347121896616
                    ],
                    [
                        121.82188332081,
                        0.63338807556796
                    ],
                    [
                        121.82188332081,
                        0.63338807556796
                    ],
                    [
                        121.82188332081,
                        0.63338807556796
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1912,
                "jenis_pipa": "Pipa 100",
                "keterangan": "JDU",
                "panjang": 7.408344895060487e-5,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07354024053,
                        0.49914607829237
                    ],
                    [
                        122.07354024053,
                        0.49907768455756
                    ],
                    [
                        122.07354426384,
                        0.49907366139667
                    ],
                    [
                        122.07354426384,
                        0.49907366139667
                    ],
                    [
                        122.07354426384,
                        0.49907366139667
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1913,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.007104696924959189,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81475937366,
                        0.63339880374844
                    ],
                    [
                        121.81475937366,
                        0.63330225012325
                    ],
                    [
                        121.81469729173,
                        0.6332409434088
                    ],
                    [
                        121.81466414407,
                        0.63317351116595
                    ],
                    [
                        121.8146497764,
                        0.63307197306504
                    ],
                    [
                        121.81465935633,
                        0.63290434751273
                    ],
                    [
                        121.81466376408,
                        0.63269591665852
                    ],
                    [
                        121.81466951966,
                        0.63248690832771
                    ],
                    [
                        121.81466013193,
                        0.63228039081311
                    ],
                    [
                        121.8146520853,
                        0.63206314510707
                    ],
                    [
                        121.8146494031,
                        0.63191160951661
                    ],
                    [
                        121.81464269757,
                        0.63171313811709
                    ],
                    [
                        121.81463062763,
                        0.63150125647954
                    ],
                    [
                        121.81462526321,
                        0.63117806991448
                    ],
                    [
                        121.81461453438,
                        0.63098362155652
                    ],
                    [
                        121.81461721659,
                        0.63081599365591
                    ],
                    [
                        121.81460782886,
                        0.63057729151608
                    ],
                    [
                        121.81459710002,
                        0.63040698155571
                    ],
                    [
                        121.81458905339,
                        0.63014279995263
                    ],
                    [
                        121.81456893682,
                        0.62973915189361
                    ],
                    [
                        121.81457296014,
                        0.6294374215965
                    ],
                    [
                        121.81473389268,
                        0.62943608057292
                    ],
                    [
                        121.81483715773,
                        0.62943339852578
                    ],
                    [
                        121.81496992707,
                        0.62943205750218
                    ],
                    [
                        121.81513488293,
                        0.62943339852578
                    ],
                    [
                        121.81527838111,
                        0.62942937545502
                    ],
                    [
                        121.81539237499,
                        0.62942803443144
                    ],
                    [
                        121.81556805968,
                        0.62942937545502
                    ],
                    [
                        121.81566864252,
                        0.62942535238427
                    ],
                    [
                        121.81580141187,
                        0.6294213293135
                    ],
                    [
                        121.81591674685,
                        0.62941864726635
                    ],
                    [
                        121.81599318981,
                        0.62941730624274
                    ],
                    [
                        121.81615144014,
                        0.62940657805405
                    ],
                    [
                        121.81624129415,
                        0.62941060112482
                    ],
                    [
                        121.81638211012,
                        0.62940389600686
                    ],
                    [
                        121.81644916534,
                        0.62940523703047
                    ],
                    [
                        121.81651219726,
                        0.62940255498328
                    ],
                    [
                        121.81660339236,
                        0.62940523703047
                    ],
                    [
                        121.81666508317,
                        0.62940657805405
                    ],
                    [
                        121.81674286723,
                        0.62940121395969
                    ],
                    [
                        121.81689843535,
                        0.62939450884172
                    ],
                    [
                        121.81689843535,
                        0.62957152395293
                    ],
                    [
                        121.81690648198,
                        0.62976731338712
                    ],
                    [
                        121.81690514088,
                        0.62986520810144
                    ],
                    [
                        121.81691989303,
                        0.63004624626693
                    ],
                    [
                        121.81692928076,
                        0.6301602332568
                    ],
                    [
                        121.81693062186,
                        0.63017230246735
                    ],
                    [
                        121.81693062186,
                        0.63017230246735
                    ],
                    [
                        121.81693062186,
                        0.63017230246735
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1914,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDB",
                "panjang": 0.0009237739355271008,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07352146506,
                        0.49907902561119
                    ],
                    [
                        122.07343563437,
                        0.49907097928941
                    ],
                    [
                        122.07343161106,
                        0.49895430762239
                    ],
                    [
                        122.07341820002,
                        0.49880142750388
                    ],
                    [
                        122.07340747118,
                        0.49868475583208
                    ],
                    [
                        122.07337662578,
                        0.49861904419994
                    ],
                    [
                        122.07333773375,
                        0.49856406099702
                    ],
                    [
                        122.0732948184,
                        0.49852785254608
                    ],
                    [
                        122.07319959998,
                        0.49848359777243
                    ],
                    [
                        122.07310169935,
                        0.49844068405223
                    ],
                    [
                        122.07306683064,
                        0.49843397878342
                    ],
                    [
                        122.07307219505,
                        0.49842995562214
                    ],
                    [
                        122.07307219505,
                        0.49842995562214
                    ],
                    [
                        122.07307219505,
                        0.49842995562214
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1915,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002263941633955887,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81466549635,
                        0.63236353422907
                    ],
                    [
                        121.81516438723,
                        0.63234744195511
                    ],
                    [
                        121.81544870138,
                        0.63234610093228
                    ],
                    [
                        121.81555867195,
                        0.63235280604645
                    ],
                    [
                        121.81570485234,
                        0.63235280604645
                    ],
                    [
                        121.81584566832,
                        0.63234878297794
                    ],
                    [
                        121.81600794196,
                        0.63234073684096
                    ],
                    [
                        121.81692257524,
                        0.63232464456694
                    ],
                    [
                        121.81692793965,
                        0.63232732661261
                    ],
                    [
                        121.81692793965,
                        0.63232732661261
                    ],
                    [
                        121.81692793965,
                        0.63232732661261
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1918,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0030597757834257256,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81466683745,
                        0.632409129005
                    ],
                    [
                        121.81510135531,
                        0.63240242389091
                    ],
                    [
                        121.81519791484,
                        0.63240510593655
                    ],
                    [
                        121.81534409523,
                        0.63240376491373
                    ],
                    [
                        121.81553587317,
                        0.63240376491373
                    ],
                    [
                        121.81573569775,
                        0.632409129005
                    ],
                    [
                        121.81594491005,
                        0.63241181105063
                    ],
                    [
                        121.81620374322,
                        0.632409129005
                    ],
                    [
                        121.81633517146,
                        0.632409129005
                    ],
                    [
                        121.81656718254,
                        0.63240644695936
                    ],
                    [
                        121.8168823421,
                        0.63240778798218
                    ],
                    [
                        121.81716933846,
                        0.63239974184528
                    ],
                    [
                        121.8172994256,
                        0.63239705979964
                    ],
                    [
                        121.81750863791,
                        0.6323876726399
                    ],
                    [
                        121.81772589684,
                        0.63237962650297
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1920,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001834522399901155,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81462928653,
                        0.63137922338056
                    ],
                    [
                        121.81485727429,
                        0.63136983621899
                    ],
                    [
                        121.81499138474,
                        0.63136983621899
                    ],
                    [
                        121.81519120932,
                        0.63136715417282
                    ],
                    [
                        121.81530252099,
                        0.63137251826516
                    ],
                    [
                        121.81552514434,
                        0.63137117724207
                    ],
                    [
                        121.81566730142,
                        0.63136447212665
                    ],
                    [
                        121.8158711493,
                        0.63137251826516
                    ],
                    [
                        121.81606695056,
                        0.63135910803431
                    ],
                    [
                        121.81621715426,
                        0.63135508496506
                    ],
                    [
                        121.8163472414,
                        0.63135240291888
                    ],
                    [
                        121.81646257639,
                        0.63135508496506
                    ],
                    [
                        121.81646257639,
                        0.63135508496506
                    ],
                    [
                        121.81646257639,
                        0.63135508496506
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1919,
                "jenis_pipa": "Pipa 150",
                "keterangan": "JDU",
                "panjang": 0.0032878455855436415,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07253978074,
                        0.51101842134616
                    ],
                    [
                        122.0724914968,
                        0.51088565784175
                    ],
                    [
                        122.07245394588,
                        0.51079043645637
                    ],
                    [
                        122.07242175937,
                        0.51068315235832
                    ],
                    [
                        122.07236543298,
                        0.51051015674644
                    ],
                    [
                        122.07229569554,
                        0.51027949592336
                    ],
                    [
                        122.0722232759,
                        0.51003810668105
                    ],
                    [
                        122.07211866975,
                        0.50972295960107
                    ],
                    [
                        122.07204222679,
                        0.50943463353566
                    ],
                    [
                        122.07195907831,
                        0.50912485063242
                    ],
                    [
                        122.07187995315,
                        0.50884457084998
                    ],
                    [
                        122.07181692123,
                        0.50862866153559
                    ],
                    [
                        122.07176461816,
                        0.50845030166174
                    ],
                    [
                        122.07170560956,
                        0.50823707443765
                    ],
                    [
                        122.0716077163,
                        0.50786687439672
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1917,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001515260286480036,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81466415524,
                        0.63236219320624
                    ],
                    [
                        121.81452199817,
                        0.63235951116058
                    ],
                    [
                        121.81436777115,
                        0.63236353422907
                    ],
                    [
                        121.81418001652,
                        0.63237962650297
                    ],
                    [
                        121.81394398212,
                        0.63238499059426
                    ],
                    [
                        121.81376695633,
                        0.63239571877683
                    ],
                    [
                        121.81315004826,
                        0.63239437775401
                    ],
                    [
                        121.81315004826,
                        0.63239437775401
                    ],
                    [
                        121.81315004826,
                        0.63239437775401
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1921,
                "jenis_pipa": "Pipa 150",
                "keterangan": "JDU",
                "panjang": 0.008047248713822756,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07161575556,
                        0.5078884009743
                    ],
                    [
                        122.07157552242,
                        0.50771942844299
                    ],
                    [
                        122.07154065371,
                        0.50755179695915
                    ],
                    [
                        122.07151383162,
                        0.50747133384535
                    ],
                    [
                        122.07147225738,
                        0.50723128554993
                    ],
                    [
                        122.07141458988,
                        0.50699526040164
                    ],
                    [
                        122.0713609457,
                        0.5067297320995
                    ],
                    [
                        122.07133412361,
                        0.50660635530896
                    ],
                    [
                        122.07131534815,
                        0.50650711745398
                    ],
                    [
                        122.0712724328,
                        0.50627377438359
                    ],
                    [
                        122.07125097513,
                        0.5061275996973
                    ],
                    [
                        122.07122415304,
                        0.50592375976227
                    ],
                    [
                        122.07122817636,
                        0.50571991982085
                    ],
                    [
                        122.07122683525,
                        0.50527871360993
                    ],
                    [
                        122.07122817636,
                        0.50500111576581
                    ],
                    [
                        122.07124561071,
                        0.50458673055617
                    ],
                    [
                        122.07125902176,
                        0.50428097057874
                    ],
                    [
                        122.07127779722,
                        0.50381696637502
                    ],
                    [
                        122.07129925489,
                        0.50334491582172
                    ],
                    [
                        122.07133814693,
                        0.5027642399522
                    ],
                    [
                        122.07134619355,
                        0.50247993673628
                    ],
                    [
                        122.07136496902,
                        0.50201593240446
                    ],
                    [
                        122.07138776779,
                        0.50170614914727
                    ],
                    [
                        122.07140788436,
                        0.50137625007802
                    ],
                    [
                        122.07143738866,
                        0.50111608575967
                    ],
                    [
                        122.07148969173,
                        0.50067756134398
                    ],
                    [
                        122.07153126597,
                        0.50030474851493
                    ],
                    [
                        122.07157418132,
                        0.49989572722128
                    ],
                    [
                        122.07157418132,
                        0.49989572722128
                    ],
                    [
                        122.07157418132,
                        0.49989572722128
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1922,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006303409041149019,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81463196874,
                        0.6314261591882
                    ],
                    [
                        121.81485325098,
                        0.63142481816513
                    ],
                    [
                        121.8149779737,
                        0.6314301822574
                    ],
                    [
                        121.8150678277,
                        0.63142347714207
                    ],
                    [
                        121.81517645717,
                        0.63142481816513
                    ],
                    [
                        121.81530117989,
                        0.63142213611899
                    ],
                    [
                        121.81539908051,
                        0.63141677202671
                    ],
                    [
                        121.81550502777,
                        0.63141543100364
                    ],
                    [
                        121.81561365724,
                        0.63142213611899
                    ],
                    [
                        121.81571558118,
                        0.63142884123434
                    ],
                    [
                        121.81586176157,
                        0.63142884123434
                    ],
                    [
                        121.81601732969,
                        0.63143152328047
                    ],
                    [
                        121.81615680456,
                        0.6314301822574
                    ],
                    [
                        121.81630969048,
                        0.63144493351114
                    ],
                    [
                        121.81646257639,
                        0.63143956941888
                    ],
                    [
                        121.81660607457,
                        0.63143688737275
                    ],
                    [
                        121.81673884392,
                        0.63142347714207
                    ],
                    [
                        121.81686088443,
                        0.63142750021127
                    ],
                    [
                        121.81703522801,
                        0.6314127489575
                    ],
                    [
                        121.8172082305,
                        0.63140872588828
                    ],
                    [
                        121.81735038757,
                        0.63140067974983
                    ],
                    [
                        121.81748315692,
                        0.6313966566806
                    ],
                    [
                        121.81763872504,
                        0.63138995156521
                    ],
                    [
                        121.81776612997,
                        0.63138592849597
                    ],
                    [
                        121.81787610054,
                        0.63139129258829
                    ],
                    [
                        121.81859090924,
                        0.63137654133441
                    ],
                    [
                        121.81929633021,
                        0.63137251826516
                    ],
                    [
                        121.81932717562,
                        0.63300722514624
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1923,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0031215596569498785,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81460112333,
                        0.63045123532549
                    ],
                    [
                        121.81487604976,
                        0.63045794044209
                    ],
                    [
                        121.8149793148,
                        0.63046330453536
                    ],
                    [
                        121.81513085961,
                        0.6304525763488
                    ],
                    [
                        121.81524217129,
                        0.63045794044209
                    ],
                    [
                        121.81541919708,
                        0.63045659941877
                    ],
                    [
                        121.81559085846,
                        0.63045525839544
                    ],
                    [
                        121.81575581431,
                        0.63045525839544
                    ],
                    [
                        121.81590333581,
                        0.63045391737213
                    ],
                    [
                        121.81609645486,
                        0.63044855327885
                    ],
                    [
                        121.81627750397,
                        0.63044721225552
                    ],
                    [
                        121.81646257639,
                        0.63043514304561
                    ],
                    [
                        121.81658193469,
                        0.63042843792898
                    ],
                    [
                        121.81674554944,
                        0.63043111997564
                    ],
                    [
                        121.81683674455,
                        0.63043782509227
                    ],
                    [
                        121.81693464518,
                        0.63043380202229
                    ],
                    [
                        121.81715324521,
                        0.63044318918557
                    ],
                    [
                        121.81772053242,
                        0.63042843792898
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1924,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0022566515712470333,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81459844112,
                        0.63039893541573
                    ],
                    [
                        121.81467354298,
                        0.63040027643906
                    ],
                    [
                        121.81478083134,
                        0.63039893541573
                    ],
                    [
                        121.81487604976,
                        0.63039893541573
                    ],
                    [
                        121.8149766326,
                        0.63039357132239
                    ],
                    [
                        121.81503295898,
                        0.63039357132239
                    ],
                    [
                        121.81510537863,
                        0.63039491234573
                    ],
                    [
                        121.81523278356,
                        0.63038418415903
                    ],
                    [
                        121.81539237499,
                        0.630376138019
                    ],
                    [
                        121.81550502777,
                        0.63037211494897
                    ],
                    [
                        121.81558012962,
                        0.63037077392564
                    ],
                    [
                        121.81685417891,
                        0.63037211494897
                    ],
                    [
                        121.81685417891,
                        0.63037211494897
                    ],
                    [
                        121.81685417891,
                        0.63037211494897
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2023,
                "jenis_pipa": "Pipa 75",
                "keterangan": "JDU",
                "panjang": 0.006220622654681166,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07181826234,
                        0.49792974254974
                    ],
                    [
                        122.07183033228,
                        0.4977889318925
                    ],
                    [
                        122.07188665867,
                        0.49746305578846
                    ],
                    [
                        122.07195103168,
                        0.49703525956162
                    ],
                    [
                        122.07199662924,
                        0.49664501282268
                    ],
                    [
                        122.07202076912,
                        0.4964840863257
                    ],
                    [
                        122.07206100225,
                        0.49632450087897
                    ],
                    [
                        122.07216024399,
                        0.49596107518343
                    ],
                    [
                        122.07227557898,
                        0.49551584515282
                    ],
                    [
                        122.07238554955,
                        0.49521142580745
                    ],
                    [
                        122.07247674465,
                        0.49492578121074
                    ],
                    [
                        122.07247674465,
                        0.49491907593837
                    ],
                    [
                        122.07247674465,
                        0.49491907593837
                    ],
                    [
                        122.07347586751,
                        0.49195400383308
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2024,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.011319594783556264,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08245187998,
                        0.48411285024138
                    ],
                    [
                        122.08236470819,
                        0.4844038595251
                    ],
                    [
                        122.08222389221,
                        0.48488932198904
                    ],
                    [
                        122.08207637072,
                        0.48538283075649
                    ],
                    [
                        122.08184972405,
                        0.48631218276694
                    ],
                    [
                        122.08172902465,
                        0.4867453439056
                    ],
                    [
                        122.08164989948,
                        0.48703501201997
                    ],
                    [
                        122.08147421479,
                        0.48750706373521
                    ],
                    [
                        122.08136558533,
                        0.48780746026404
                    ],
                    [
                        122.08121538162,
                        0.48818027379456
                    ],
                    [
                        122.08113893867,
                        0.48836668055209
                    ],
                    [
                        122.08106786013,
                        0.48851687879899
                    ],
                    [
                        122.08102628589,
                        0.48861075270159
                    ],
                    [
                        122.08097800612,
                        0.48866305387533
                    ],
                    [
                        122.08090558648,
                        0.4887166961044
                    ],
                    [
                        122.080822438,
                        0.48874485827447
                    ],
                    [
                        122.08060652018,
                        0.48874217616303
                    ],
                    [
                        122.0801961422,
                        0.48875960988733
                    ],
                    [
                        122.07976028323,
                        0.48877167938871
                    ],
                    [
                        122.07925200462,
                        0.48879581839145
                    ],
                    [
                        122.07899451256,
                        0.48880654683709
                    ],
                    [
                        122.07877188921,
                        0.48880252366999
                    ],
                    [
                        122.07857742906,
                        0.48878508994581
                    ],
                    [
                        122.0783816278,
                        0.48873681194018
                    ],
                    [
                        122.07825288177,
                        0.48869926237999
                    ],
                    [
                        122.07784384489,
                        0.48853163041234
                    ],
                    [
                        122.07746833563,
                        0.48838411427735
                    ],
                    [
                        122.07727789879,
                        0.48829962776221
                    ],
                    [
                        122.07690238953,
                        0.48814942951045
                    ],
                    [
                        122.07675755024,
                        0.48809310516518
                    ],
                    [
                        122.07636862993,
                        0.4879683869704
                    ],
                    [
                        122.07623720169,
                        0.4879321784618
                    ],
                    [
                        122.07597434521,
                        0.48784232771742
                    ],
                    [
                        122.0754955709,
                        0.48765592094537
                    ],
                    [
                        122.07489073277,
                        0.48746951416815
                    ],
                    [
                        122.07475796342,
                        0.48743330565689
                    ],
                    [
                        122.0747217536,
                        0.48741453087317
                    ],
                    [
                        122.0747217536,
                        0.48741453087317
                    ],
                    [
                        122.0747217536,
                        0.48741453087317
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2025,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.022132022504346437,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08963215351,
                        0.52603280630495
                    ],
                    [
                        122.08953693509,
                        0.52591881722506
                    ],
                    [
                        122.08943903446,
                        0.52577934823038
                    ],
                    [
                        122.08934515715,
                        0.52564926656906
                    ],
                    [
                        122.0892713964,
                        0.52555539320354
                    ],
                    [
                        122.08914399147,
                        0.52538373904579
                    ],
                    [
                        122.0890326798,
                        0.52522549536493
                    ],
                    [
                        122.08893612027,
                        0.52507529796923
                    ],
                    [
                        122.08884358406,
                        0.52497069620939
                    ],
                    [
                        122.08872690797,
                        0.52480977042158
                    ],
                    [
                        122.08866521716,
                        0.52471992018825
                    ],
                    [
                        122.08858340979,
                        0.52459922584295
                    ],
                    [
                        122.08851635456,
                        0.52449596512346
                    ],
                    [
                        122.08843722939,
                        0.52440209174061
                    ],
                    [
                        122.08835676312,
                        0.52427335109901
                    ],
                    [
                        122.08826422691,
                        0.52414058730958
                    ],
                    [
                        122.08821326494,
                        0.52407755803481
                    ],
                    [
                        122.0881716907,
                        0.52400648246891
                    ],
                    [
                        122.08815291524,
                        0.523959545774
                    ],
                    [
                        122.08809658885,
                        0.52390456278808
                    ],
                    [
                        122.08800807595,
                        0.52379996100866
                    ],
                    [
                        122.08792224526,
                        0.52372352124568
                    ],
                    [
                        122.08782836795,
                        0.52365110462726
                    ],
                    [
                        122.0877532661,
                        0.52358137010502
                    ],
                    [
                        122.08762586117,
                        0.52345531154362
                    ],
                    [
                        122.08753600717,
                        0.52338021282498
                    ],
                    [
                        122.08735898137,
                        0.52327158789109
                    ],
                    [
                        122.0871900022,
                        0.52314687037207
                    ],
                    [
                        122.08687752485,
                        0.52297655719694
                    ],
                    [
                        122.08657979965,
                        0.52278746933567
                    ],
                    [
                        122.08623245358,
                        0.52257290154294
                    ],
                    [
                        122.08588778973,
                        0.52234492325513
                    ],
                    [
                        122.08554849029,
                        0.52212365020318
                    ],
                    [
                        122.08523601294,
                        0.52193053916964
                    ],
                    [
                        122.08503082395,
                        0.52177631854833
                    ],
                    [
                        122.08483234048,
                        0.5216341673636
                    ],
                    [
                        122.08452388644,
                        0.52142764582534
                    ],
                    [
                        122.0843334496,
                        0.52129219987774
                    ],
                    [
                        122.08397939801,
                        0.52106958573971
                    ],
                    [
                        122.0837084949,
                        0.52090597775373
                    ],
                    [
                        122.08338260651,
                        0.52071688983022
                    ],
                    [
                        122.08318009973,
                        0.52059753645715
                    ],
                    [
                        122.08300307393,
                        0.52049427567187
                    ],
                    [
                        122.08277642727,
                        0.52039369698329
                    ],
                    [
                        122.08256855607,
                        0.52026763835802
                    ],
                    [
                        122.08223059773,
                        0.52007720936611
                    ],
                    [
                        122.08196371794,
                        0.51991896555156
                    ],
                    [
                        122.08167403936,
                        0.51973792389447
                    ],
                    [
                        122.08151981235,
                        0.51964673253929
                    ],
                    [
                        122.08129450679,
                        0.51949653501025
                    ],
                    [
                        122.08107322454,
                        0.51930878809395
                    ],
                    [
                        122.08075135946,
                        0.51907946863859
                    ],
                    [
                        122.08059847355,
                        0.51897218468003
                    ],
                    [
                        122.08036512136,
                        0.51882869238258
                    ],
                    [
                        122.08026856184,
                        0.51876163990604
                    ],
                    [
                        122.08017066121,
                        0.51871202107295
                    ],
                    [
                        122.08003252745,
                        0.51864362754558
                    ],
                    [
                        122.07997351885,
                        0.51860205500899
                    ],
                    [
                        122.0799306035,
                        0.51857255191834
                    ],
                    [
                        122.0798689127,
                        0.51853232043086
                    ],
                    [
                        122.07984611392,
                        0.51848940684395
                    ],
                    [
                        122.07981795073,
                        0.51844381115752
                    ],
                    [
                        122.07977503538,
                        0.51839955652039
                    ],
                    [
                        122.07968249917,
                        0.51831104724517
                    ],
                    [
                        122.07943707705,
                        0.51807502250528
                    ],
                    [
                        122.07922920585,
                        0.51786045455226
                    ],
                    [
                        122.07905083895,
                        0.51769148228417
                    ],
                    [
                        122.07880273461,
                        0.51746752696951
                    ],
                    [
                        122.0785009861,
                        0.5171818833531
                    ],
                    [
                        122.07830384374,
                        0.51698340796887
                    ],
                    [
                        122.07798331976,
                        0.51664948653142
                    ],
                    [
                        122.07770973444,
                        0.51637993547875
                    ],
                    [
                        122.07739189267,
                        0.51604601400959
                    ],
                    [
                        122.07711830735,
                        0.51574427772719
                    ],
                    [
                        122.07681924105,
                        0.51545192878218
                    ],
                    [
                        122.07652822137,
                        0.51517701347758
                    ],
                    [
                        122.07621708512,
                        0.51488198240581
                    ],
                    [
                        122.07599312067,
                        0.51466205014342
                    ],
                    [
                        122.07583218813,
                        0.5144984419921
                    ],
                    [
                        122.07572221756,
                        0.51439518110754
                    ],
                    [
                        122.07552806156,
                        0.51421846658815
                    ],
                    [
                        122.07533762472,
                        0.51404949422332
                    ],
                    [
                        122.07517803329,
                        0.51388052185402
                    ],
                    [
                        122.0749728443,
                        0.51367131796203
                    ],
                    [
                        122.07482129949,
                        0.51350636873467
                    ],
                    [
                        122.07465902584,
                        0.51337226366865
                    ],
                    [
                        122.07453430312,
                        0.51325156910681
                    ],
                    [
                        122.0744095804,
                        0.5131362387456
                    ],
                    [
                        122.07429960983,
                        0.51303163678829
                    ],
                    [
                        122.07414776087,
                        0.51287979390842
                    ],
                    [
                        122.07396939397,
                        0.51271886781309
                    ],
                    [
                        122.0738299191,
                        0.51257001117131
                    ],
                    [
                        122.07368642092,
                        0.5124292008313
                    ],
                    [
                        122.07352280617,
                        0.51227766208097
                    ],
                    [
                        122.07342088223,
                        0.51218378851702
                    ],
                    [
                        122.07334175706,
                        0.51210734861395
                    ],
                    [
                        122.07327604294,
                        0.51203493186281
                    ],
                    [
                        122.07319423556,
                        0.51196385616183
                    ],
                    [
                        122.07308292389,
                        0.51190082676597
                    ],
                    [
                        122.07301452756,
                        0.51187266469527
                    ],
                    [
                        122.07301452756,
                        0.51187266469527
                    ],
                    [
                        122.07301452756,
                        0.51187266469527
                    ],
                    [
                        122.07301452756,
                        0.51187266469527
                    ],
                    [
                        122.07294613123,
                        0.51184450262445
                    ],
                    [
                        122.07294613123,
                        0.51184450262445
                    ],
                    [
                        122.07294613123,
                        0.51184450262445
                    ],
                    [
                        122.07294613123,
                        0.51184450262445
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1926,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007248588511239057,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81931376457,
                        0.63230452922434
                    ],
                    [
                        121.81955114007,
                        0.6322884369502
                    ],
                    [
                        121.81963160634,
                        0.63227770876742
                    ],
                    [
                        121.81977644563,
                        0.63227368569885
                    ],
                    [
                        121.81992530823,
                        0.63226429853889
                    ],
                    [
                        121.8200366199,
                        0.63225491137893
                    ],
                    [
                        121.8200366199,
                        0.63225491137893
                    ],
                    [
                        121.8200366199,
                        0.63225491137893
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1927,
                "jenis_pipa": "Pipa 75",
                "keterangan": "JDU",
                "panjang": 0.031155974155106802,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08240091801,
                        0.48430328028099
                    ],
                    [
                        122.08249881864,
                        0.48432741929972
                    ],
                    [
                        122.08269193769,
                        0.48439581318563
                    ],
                    [
                        122.08291992545,
                        0.48446957129713
                    ],
                    [
                        122.08320558071,
                        0.48459428955655
                    ],
                    [
                        122.08341613412,
                        0.48467743506155
                    ],
                    [
                        122.08360925317,
                        0.48473510049184
                    ],
                    [
                        122.08390563726,
                        0.48481422282563
                    ],
                    [
                        122.08411484957,
                        0.48486384191584
                    ],
                    [
                        122.08448901773,
                        0.48495235164342
                    ],
                    [
                        122.08471432328,
                        0.48500062967615
                    ],
                    [
                        122.08494499326,
                        0.48504086136983
                    ],
                    [
                        122.08522796631,
                        0.48509986785347
                    ],
                    [
                        122.08554714918,
                        0.48516826173158
                    ],
                    [
                        122.08573490381,
                        0.48520983448069
                    ],
                    [
                        122.08591595292,
                        0.48523263243977
                    ],
                    [
                        122.08614259958,
                        0.48527018201927
                    ],
                    [
                        122.08660528064,
                        0.48534125800844
                    ],
                    [
                        122.08695262671,
                        0.48539490026393
                    ],
                    [
                        122.0871604979,
                        0.48540831082774
                    ],
                    [
                        122.08744883537,
                        0.48543781406801
                    ],
                    [
                        122.0876070857,
                        0.4854659762518
                    ],
                    [
                        122.08778008819,
                        0.48549145632275
                    ],
                    [
                        122.08793029189,
                        0.48552364167537
                    ],
                    [
                        122.08813682199,
                        0.48559605871823
                    ],
                    [
                        122.0882602036,
                        0.48564299569004
                    ],
                    [
                        122.08868265152,
                        0.48578380660351
                    ],
                    [
                        122.08883821964,
                        0.48590718378243
                    ],
                    [
                        122.08896964788,
                        0.48600642194645
                    ],
                    [
                        122.08905950189,
                        0.4860721337029
                    ],
                    [
                        122.08920702338,
                        0.48613650440247
                    ],
                    [
                        122.08949938416,
                        0.48623574256312
                    ],
                    [
                        122.08991378546,
                        0.48638459980135
                    ],
                    [
                        122.09029734135,
                        0.48652272858705
                    ],
                    [
                        122.09056288004,
                        0.4866112382929
                    ],
                    [
                        122.09073454142,
                        0.48664342364018
                    ],
                    [
                        122.09091827273,
                        0.48664610575245
                    ],
                    [
                        122.09104433656,
                        0.48665415208925
                    ],
                    [
                        122.09114357829,
                        0.48668231426797
                    ],
                    [
                        122.09124952555,
                        0.48671584067103
                    ],
                    [
                        122.09139302373,
                        0.48680837354266
                    ],
                    [
                        122.0916223526,
                        0.48698807505784
                    ],
                    [
                        122.09167197347,
                        0.48704842258052
                    ],
                    [
                        122.0917698741,
                        0.48710206482244
                    ],
                    [
                        122.09189996123,
                        0.48720666719297
                    ],
                    [
                        122.09201797843,
                        0.48724287570547
                    ],
                    [
                        122.09211051464,
                        0.48723617042539
                    ],
                    [
                        122.09226205945,
                        0.48718923346466
                    ],
                    [
                        122.09254637361,
                        0.48707926686967
                    ],
                    [
                        122.09270194173,
                        0.48705110469263
                    ],
                    [
                        122.09286689758,
                        0.48699612139423
                    ],
                    [
                        122.09300100803,
                        0.48699612139423
                    ],
                    [
                        122.09320083261,
                        0.48697868766538
                    ],
                    [
                        122.09336712956,
                        0.48700550878666
                    ],
                    [
                        122.09360048175,
                        0.48702026040333
                    ],
                    [
                        122.09377080202,
                        0.48703769413207
                    ],
                    [
                        122.09392234683,
                        0.48704171730024
                    ],
                    [
                        122.09407120943,
                        0.48704171730024
                    ],
                    [
                        122.09431394935,
                        0.48703903518813
                    ],
                    [
                        122.09468275309,
                        0.48700684984272
                    ],
                    [
                        122.09495902061,
                        0.48695991288041
                    ],
                    [
                        122.09516823292,
                        0.4869089527495
                    ],
                    [
                        122.09533184767,
                        0.48687006212304
                    ],
                    [
                        122.09550619125,
                        0.48685262839386
                    ],
                    [
                        122.09579989314,
                        0.4868633568426
                    ],
                    [
                        122.09606945515,
                        0.48696259499254
                    ],
                    [
                        122.09636718035,
                        0.48707658475758
                    ],
                    [
                        122.09695726633,
                        0.48733540856985
                    ],
                    [
                        122.09732338786,
                        0.48748828895171
                    ],
                    [
                        122.09756478667,
                        0.4875486364699
                    ],
                    [
                        122.09774985909,
                        0.48759020920435
                    ],
                    [
                        122.09805965424,
                        0.4876451924979
                    ],
                    [
                        122.0985545218,
                        0.48777929809004
                    ],
                    [
                        122.09880262613,
                        0.4878637846117
                    ],
                    [
                        122.09898099303,
                        0.48793083740593
                    ],
                    [
                        122.09912180901,
                        0.48793754268532
                    ],
                    [
                        122.09929212928,
                        0.48791876790301
                    ],
                    [
                        122.10034221411,
                        0.48774040746859
                    ],
                    [
                        122.10079416633,
                        0.48767737784025
                    ],
                    [
                        122.10101544857,
                        0.48765055672164
                    ],
                    [
                        122.10113346577,
                        0.48764653355382
                    ],
                    [
                        122.10129573941,
                        0.48765189777757
                    ],
                    [
                        122.1014995873,
                        0.4876572620013
                    ],
                    [
                        122.10172489285,
                        0.48768274206397
                    ],
                    [
                        122.10232704878,
                        0.48776320541912
                    ],
                    [
                        122.10269719362,
                        0.48783428138202
                    ],
                    [
                        122.10304990411,
                        0.48788524150593
                    ],
                    [
                        122.10339322686,
                        0.4878973110089
                    ],
                    [
                        122.10366949439,
                        0.48787048989115
                    ],
                    [
                        122.10386797786,
                        0.48783964560562
                    ],
                    [
                        122.10459083319,
                        0.4876840831199
                    ],
                    [
                        122.10506021976,
                        0.48752986168653
                    ],
                    [
                        122.10554167628,
                        0.48731529272987
                    ],
                    [
                        122.10586354136,
                        0.48718923346466
                    ],
                    [
                        122.10610091686,
                        0.4871382733355
                    ],
                    [
                        122.10683718324,
                        0.48695454865611
                    ],
                    [
                        122.10734680295,
                        0.48683787677682
                    ],
                    [
                        122.10805088282,
                        0.48669572482921
                    ],
                    [
                        122.10869729519,
                        0.48654954971015
                    ],
                    [
                        122.10903525352,
                        0.48645299366646
                    ],
                    [
                        122.10939735174,
                        0.48634839128425
                    ],
                    [
                        122.10959583521,
                        0.48626792791219
                    ],
                    [
                        122.10978358984,
                        0.48617941820186
                    ],
                    [
                        122.10991233587,
                        0.4860506768029
                    ],
                    [
                        122.11005985737,
                        0.48597289553985
                    ],
                    [
                        122.11028784513,
                        0.48588975005077
                    ],
                    [
                        122.11053729057,
                        0.48584951836213
                    ],
                    [
                        122.11070895195,
                        0.48586829315019
                    ],
                    [
                        122.1108725667,
                        0.48595680286462
                    ],
                    [
                        122.11121320724,
                        0.48618746453919
                    ],
                    [
                        122.11144924164,
                        0.48632559332893
                    ],
                    [
                        122.11171746254,
                        0.48641946726209
                    ],
                    [
                        122.11185693741,
                        0.48647981478985
                    ],
                    [
                        122.11200714111,
                        0.48656296027166
                    ],
                    [
                        122.11205005646,
                        0.4865535728786
                    ],
                    [
                        122.11216807365,
                        0.48658978139461
                    ],
                    [
                        122.11216807365,
                        0.48658978139461
                    ],
                    [
                        122.11216807365,
                        0.48658978139461
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1928,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0026975057727147266,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81459575891,
                        0.63236219320624
                    ],
                    [
                        121.81460380554,
                        0.63215835773244
                    ],
                    [
                        121.81459710002,
                        0.63198804782386
                    ],
                    [
                        121.81459441781,
                        0.63185260450674
                    ],
                    [
                        121.81459441781,
                        0.63167827151911
                    ],
                    [
                        121.81458100677,
                        0.63146236681095
                    ],
                    [
                        121.81456625462,
                        0.63144091044194
                    ],
                    [
                        121.81453406811,
                        0.63142481816513
                    ],
                    [
                        121.81447774172,
                        0.63142079509593
                    ],
                    [
                        121.81428328156,
                        0.6314261591882
                    ],
                    [
                        121.81374415755,
                        0.63145834374177
                    ],
                    [
                        121.81280136108,
                        0.63150259750259
                    ],
                    [
                        121.81280136108,
                        0.63150259750259
                    ],
                    [
                        121.81280136108,
                        0.63150259750259
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1929,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009628228450689773,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81459575891,
                        0.63039759439239
                    ],
                    [
                        121.81454345584,
                        0.6304016174624
                    ],
                    [
                        121.81450456381,
                        0.63041636871905
                    ],
                    [
                        121.81446969509,
                        0.63042843792898
                    ],
                    [
                        121.81438788772,
                        0.63042977895231
                    ],
                    [
                        121.81423231959,
                        0.63044050713892
                    ],
                    [
                        121.8136382103,
                        0.63044318918557
                    ],
                    [
                        121.8136382103,
                        0.63044318918557
                    ],
                    [
                        121.8136382103,
                        0.63044318918557
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1930,
                "jenis_pipa": "Pipa 75",
                "keterangan": "JDU",
                "panjang": 0.0008428655780038435,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11179122329,
                        0.48648517901452
                    ],
                    [
                        122.111736238,
                        0.48667024476281
                    ],
                    [
                        122.11167991161,
                        0.48688213162782
                    ],
                    [
                        122.11169868708,
                        0.48697600555323
                    ],
                    [
                        122.11189180613,
                        0.48722410092124
                    ],
                    [
                        122.11191058159,
                        0.48723214725734
                    ],
                    [
                        122.11191058159,
                        0.48723214725734
                    ],
                    [
                        122.11191058159,
                        0.48723214725734
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1931,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDB",
                "panjang": 0.002627730959534569,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11192935705,
                        0.48725226309756
                    ],
                    [
                        122.11199775338,
                        0.48732468012189
                    ],
                    [
                        122.11232632399,
                        0.48767871889618
                    ],
                    [
                        122.11252748966,
                        0.4879120626236
                    ],
                    [
                        122.11278766394,
                        0.48813601895209
                    ],
                    [
                        122.11286142468,
                        0.4880823767184
                    ],
                    [
                        122.11321413517,
                        0.48776588753095
                    ],
                    [
                        122.11336165667,
                        0.48763580510636
                    ],
                    [
                        122.11349576712,
                        0.48750840479117
                    ],
                    [
                        122.11380019784,
                        0.48779807287272
                    ],
                    [
                        122.11382293371,
                        0.48781218530279
                    ],
                    [
                        122.11382293371,
                        0.48781218530279
                    ],
                    [
                        122.11382293371,
                        0.48781218530279
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1932,
                "jenis_pipa": "Pipa 40",
                "keterangan": "JDB",
                "panjang": 0.0038548709743410053,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11058154702,
                        0.48586426998132
                    ],
                    [
                        122.11058288813,
                        0.4858870679382
                    ],
                    [
                        122.11058288813,
                        0.4858951142759
                    ],
                    [
                        122.11049437523,
                        0.48590584272615
                    ],
                    [
                        122.11041122675,
                        0.48590316061359
                    ],
                    [
                        122.11033344269,
                        0.48590852483872
                    ],
                    [
                        122.11025699973,
                        0.48593400490799
                    ],
                    [
                        122.11016848683,
                        0.48595948497716
                    ],
                    [
                        122.10998207331,
                        0.48604665363414
                    ],
                    [
                        122.10988149047,
                        0.48611102433396
                    ],
                    [
                        122.10985600948,
                        0.48617673608938
                    ],
                    [
                        122.1097125113,
                        0.48627061002462
                    ],
                    [
                        122.10959047079,
                        0.48632157016033
                    ],
                    [
                        122.10945501924,
                        0.48638057663279
                    ],
                    [
                        122.10919082165,
                        0.48646640422816
                    ],
                    [
                        122.10903525352,
                        0.48651334119394
                    ],
                    [
                        122.10883006454,
                        0.48658039400159
                    ],
                    [
                        122.10856586695,
                        0.48664476469633
                    ],
                    [
                        122.10794895887,
                        0.48678021136447
                    ],
                    [
                        122.10698068142,
                        0.48700550878666
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1933,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 8.725967646217394e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08101019263,
                        0.48863891487212
                    ],
                    [
                        122.08108395338,
                        0.48864964331801
                    ],
                    [
                        122.08109602332,
                        0.4886456201508
                    ],
                    [
                        122.08109602332,
                        0.4886456201508
                    ],
                    [
                        122.08109602332,
                        0.4886456201508
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1934,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.001425572545616494,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08109736443,
                        0.48862550431475
                    ],
                    [
                        122.08114564419,
                        0.48848469346064
                    ],
                    [
                        122.08129048347,
                        0.48812126733787
                    ],
                    [
                        122.08137094975,
                        0.48792279107066
                    ],
                    [
                        122.0814755559,
                        0.48763848721822
                    ],
                    [
                        122.08161905408,
                        0.48729920005786
                    ],
                    [
                        122.08161905408,
                        0.48729920005786
                    ],
                    [
                        122.08161905408,
                        0.48729920005786
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1935,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.012212958822029966,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08162844181,
                        0.48727103788172
                    ],
                    [
                        122.08165928721,
                        0.4871811871285
                    ],
                    [
                        122.08175584674,
                        0.48690358852517
                    ],
                    [
                        122.08180680871,
                        0.48669974799759
                    ],
                    [
                        122.08188727498,
                        0.48639532825083
                    ],
                    [
                        122.08196774125,
                        0.48602251462155
                    ],
                    [
                        122.08206698298,
                        0.48567920421093
                    ],
                    [
                        122.08211392164,
                        0.48547670470273
                    ],
                    [
                        122.0821903646,
                        0.48518301335225
                    ],
                    [
                        122.08231508732,
                        0.48476460373506
                    ],
                    [
                        122.08241701126,
                        0.48443738593948
                    ],
                    [
                        122.08244249225,
                        0.48438508473299
                    ],
                    [
                        122.08250284195,
                        0.48438508473299
                    ],
                    [
                        122.08262488246,
                        0.48442933960004
                    ],
                    [
                        122.08282470703,
                        0.48450309771117
                    ],
                    [
                        122.08308890462,
                        0.48462111068731
                    ],
                    [
                        122.08321228623,
                        0.48467609400502
                    ],
                    [
                        122.08343222737,
                        0.4847552163395
                    ],
                    [
                        122.0836186409,
                        0.48481154071263
                    ],
                    [
                        122.08390429616,
                        0.48487993459367
                    ],
                    [
                        122.08413496614,
                        0.48493357685281
                    ],
                    [
                        122.084569484,
                        0.48503281503111
                    ],
                    [
                        122.08490610123,
                        0.48509986785347
                    ],
                    [
                        122.08519041538,
                        0.48513607637727
                    ],
                    [
                        122.08561956882,
                        0.48523933772184
                    ],
                    [
                        122.0858515799,
                        0.48527554624489
                    ],
                    [
                        122.08632364869,
                        0.48535332751597
                    ],
                    [
                        122.0867715776,
                        0.48541233399687
                    ],
                    [
                        122.08719536662,
                        0.48545792991359
                    ],
                    [
                        122.08739385009,
                        0.48549011526638
                    ],
                    [
                        122.08804696798,
                        0.48561349245066
                    ],
                    [
                        122.0884090662,
                        0.48575564442105
                    ],
                    [
                        122.08866119385,
                        0.48585890575616
                    ],
                    [
                        122.08883017302,
                        0.48597289553985
                    ],
                    [
                        122.08890795708,
                        0.48603190201536
                    ],
                    [
                        122.08907693624,
                        0.4861418686274
                    ],
                    [
                        122.08919361234,
                        0.48618746453919
                    ],
                    [
                        122.08955034614,
                        0.48631620593554
                    ],
                    [
                        122.08996340632,
                        0.48645835789115
                    ],
                    [
                        122.0903415978,
                        0.48658441717002
                    ],
                    [
                        122.09060579538,
                        0.48666756265056
                    ],
                    [
                        122.09074124694,
                        0.48668901954859
                    ],
                    [
                        122.09086060524,
                        0.48669170166083
                    ],
                    [
                        122.09101751447,
                        0.4867064532782
                    ],
                    [
                        122.09119856358,
                        0.48676143657895
                    ],
                    [
                        122.09125757217,
                        0.48679093981332
                    ],
                    [
                        122.09125757217,
                        0.48679093981332
                    ],
                    [
                        122.09125757217,
                        0.48679093981332
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1936,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.007234076612989284,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08107993007,
                        0.48865903070813
                    ],
                    [
                        122.08101153374,
                        0.48886153012069
                    ],
                    [
                        122.08092972636,
                        0.48909621486271
                    ],
                    [
                        122.08077549934,
                        0.48957363065542
                    ],
                    [
                        122.08069100976,
                        0.48984988809298
                    ],
                    [
                        122.08053678274,
                        0.49030987011181
                    ],
                    [
                        122.08041474223,
                        0.49064647500935
                    ],
                    [
                        122.08024173975,
                        0.49111048013915
                    ],
                    [
                        122.08012506366,
                        0.49137332696141
                    ],
                    [
                        122.0800486207,
                        0.49154364096826
                    ],
                    [
                        122.08011031151,
                        0.49157984945735
                    ],
                    [
                        122.08030879498,
                        0.49162946849761
                    ],
                    [
                        122.08044290543,
                        0.4916723822619
                    ],
                    [
                        122.08065882325,
                        0.49171127286052
                    ],
                    [
                        122.08094850183,
                        0.4917582097896
                    ],
                    [
                        122.08117380738,
                        0.49178368983668
                    ],
                    [
                        122.08139240742,
                        0.49182526254486
                    ],
                    [
                        122.08170622587,
                        0.49188292791385
                    ],
                    [
                        122.08220914006,
                        0.49198216598953
                    ],
                    [
                        122.08261951804,
                        0.49206665245821
                    ],
                    [
                        122.08290919662,
                        0.49212297677006
                    ],
                    [
                        122.08324447274,
                        0.49216723158619
                    ],
                    [
                        122.08350330591,
                        0.492210145347
                    ],
                    [
                        122.08371385932,
                        0.49224233066744
                    ],
                    [
                        122.08413898945,
                        0.49230804236282
                    ],
                    [
                        122.08413898945,
                        0.49230804236282
                    ],
                    [
                        122.08413898945,
                        0.49230804236282
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1937,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.010378009818729668,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08415776491,
                        0.49230804236282
                    ],
                    [
                        122.08436831832,
                        0.49234827401274
                    ],
                    [
                        122.0845708251,
                        0.49240459832223
                    ],
                    [
                        122.08474382758,
                        0.49245153524643
                    ],
                    [
                        122.08491683006,
                        0.49249444900541
                    ],
                    [
                        122.08514347672,
                        0.49254809120375
                    ],
                    [
                        122.0854331553,
                        0.49260709762142
                    ],
                    [
                        122.08587169647,
                        0.4926821966977
                    ],
                    [
                        122.08610370755,
                        0.49272913361995
                    ],
                    [
                        122.08633974195,
                        0.49278009370659
                    ],
                    [
                        122.08661869168,
                        0.49282166640856
                    ],
                    [
                        122.08670988679,
                        0.49287262649448
                    ],
                    [
                        122.0868010819,
                        0.49299600354302
                    ],
                    [
                        122.08688825369,
                        0.49312608586345
                    ],
                    [
                        122.08704650402,
                        0.49330444615435
                    ],
                    [
                        122.08722621202,
                        0.49346000850941
                    ],
                    [
                        122.08729863167,
                        0.49351230964522
                    ],
                    [
                        122.08742469549,
                        0.49355120023311
                    ],
                    [
                        122.08762317896,
                        0.49359009082077
                    ],
                    [
                        122.08810195327,
                        0.49365177933868
                    ],
                    [
                        122.08843454719,
                        0.49368396465214
                    ],
                    [
                        122.08874434233,
                        0.49371480891073
                    ],
                    [
                        122.08904340863,
                        0.4937201731296
                    ],
                    [
                        122.08918690681,
                        0.49368798781631
                    ],
                    [
                        122.0893599093,
                        0.49368798781631
                    ],
                    [
                        122.08945915103,
                        0.49368262359741
                    ],
                    [
                        122.08991110325,
                        0.4936075245324
                    ],
                    [
                        122.09009885788,
                        0.49357802132808
                    ],
                    [
                        122.09052935243,
                        0.49350828648093
                    ],
                    [
                        122.09123075008,
                        0.49339563788017
                    ],
                    [
                        122.09175646305,
                        0.4932816482227
                    ],
                    [
                        122.09256246686,
                        0.49310731109572
                    ],
                    [
                        122.09294199944,
                        0.49303489413394
                    ],
                    [
                        122.09326118231,
                        0.49300673198191
                    ],
                    [
                        122.09352403879,
                        0.49301209620136
                    ],
                    [
                        122.09390357137,
                        0.49302952991451
                    ],
                    [
                        122.09409803152,
                        0.49302952991451
                    ],
                    [
                        122.09409803152,
                        0.49302952991451
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1938,
                "jenis_pipa": "Pipa 75",
                "keterangan": "JDU",
                "panjang": 0.021574563733665966,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07474052906,
                        0.48742391826504
                    ],
                    [
                        122.07466676831,
                        0.48736491180171
                    ],
                    [
                        122.07466945052,
                        0.48729115372183
                    ],
                    [
                        122.07472443581,
                        0.4871007237664
                    ],
                    [
                        122.07485988736,
                        0.48653882126092
                    ],
                    [
                        122.07491353154,
                        0.48635509656521
                    ],
                    [
                        122.07498863339,
                        0.48606006419665
                    ],
                    [
                        122.07511201501,
                        0.48558130709846
                    ],
                    [
                        122.07521662116,
                        0.4851374174337
                    ],
                    [
                        122.07535743713,
                        0.48460770012193
                    ],
                    [
                        122.07552105188,
                        0.48394924132983
                    ],
                    [
                        122.07563906908,
                        0.48345036823093
                    ],
                    [
                        122.07574501634,
                        0.4830668259848
                    ],
                    [
                        122.07590728998,
                        0.48246066826497
                    ],
                    [
                        122.07610577345,
                        0.48166542144004
                    ],
                    [
                        122.07626268268,
                        0.48106730993889
                    ],
                    [
                        122.07634314895,
                        0.48075216148109
                    ],
                    [
                        122.07648396492,
                        0.48020903325374
                    ],
                    [
                        122.07657650113,
                        0.47984024245747
                    ],
                    [
                        122.07663550973,
                        0.47958812364714
                    ],
                    [
                        122.07661807537,
                        0.47925688243007
                    ],
                    [
                        122.07657918334,
                        0.47880092283384
                    ],
                    [
                        122.07657918334,
                        0.47861183369825
                    ],
                    [
                        122.07661002874,
                        0.47851393648418
                    ],
                    [
                        122.07672804594,
                        0.47844420148151
                    ],
                    [
                        122.07707807422,
                        0.47821622166017
                    ],
                    [
                        122.07726314664,
                        0.47810223174665
                    ],
                    [
                        122.07739189267,
                        0.47803249673981
                    ],
                    [
                        122.07752466202,
                        0.47803786097112
                    ],
                    [
                        122.0775783062,
                        0.47806334106984
                    ],
                    [
                        122.07762524486,
                        0.47813709924981
                    ],
                    [
                        122.07778483629,
                        0.47836373801602
                    ],
                    [
                        122.078114748,
                        0.47874459841102
                    ],
                    [
                        122.078114748,
                        0.47874459841102
                    ],
                    [
                        122.078114748,
                        0.47874459841102
                    ],
                    [
                        122.078114748,
                        0.47874459841102
                    ],
                    [
                        122.0784728229,
                        0.47910534292058
                    ],
                    [
                        122.07866460085,
                        0.47928236252427
                    ],
                    [
                        122.07878395915,
                        0.47930650156078
                    ],
                    [
                        122.07888990641,
                        0.47930784261836
                    ],
                    [
                        122.07905352116,
                        0.47929040886978
                    ],
                    [
                        122.07932308316,
                        0.4792676108908
                    ],
                    [
                        122.07946792245,
                        0.47923542550857
                    ],
                    [
                        122.0799587667,
                        0.47910936609343
                    ],
                    [
                        122.08019345999,
                        0.47905170061552
                    ],
                    [
                        122.0805850625,
                        0.4789403928312
                    ],
                    [
                        122.08074733615,
                        0.4788572472562
                    ],
                    [
                        122.08102494478,
                        0.47870570773786
                    ],
                    [
                        122.08115369082,
                        0.47860110523651
                    ],
                    [
                        122.08127304912,
                        0.47851259542644
                    ],
                    [
                        122.08141922951,
                        0.47844420148151
                    ],
                    [
                        122.08149164915,
                        0.47848309215617
                    ],
                    [
                        122.08158418536,
                        0.47857696619752
                    ],
                    [
                        122.08173573017,
                        0.47873923418024
                    ],
                    [
                        122.08196774125,
                        0.4789779424454
                    ],
                    [
                        122.08244115114,
                        0.47946876952624
                    ],
                    [
                        122.0830231905,
                        0.48007626856937
                    ],
                    [
                        122.08320021629,
                        0.48025060603316
                    ],
                    [
                        122.08335578442,
                        0.48040482763203
                    ],
                    [
                        122.08344429731,
                        0.48050943010581
                    ],
                    [
                        122.08350464702,
                        0.48061269152066
                    ],
                    [
                        122.08351805806,
                        0.48069583707434
                    ],
                    [
                        122.08349794149,
                        0.48081385011653
                    ],
                    [
                        122.08346709609,
                        0.48094125055752
                    ],
                    [
                        122.08333969116,
                        0.48133954455242
                    ],
                    [
                        122.08315327764,
                        0.48191083488833
                    ],
                    [
                        122.08304062486,
                        0.48224207597665
                    ],
                    [
                        122.08289846778,
                        0.48266584997706
                    ],
                    [
                        122.08277508616,
                        0.48306816704164
                    ],
                    [
                        122.08268254995,
                        0.48336856376766
                    ],
                    [
                        122.08245187998,
                        0.48410480390156
                    ],
                    [
                        122.08245053887,
                        0.48411553235463
                    ],
                    [
                        122.08245053887,
                        0.48411553235463
                    ],
                    [
                        122.08245053887,
                        0.48411553235463
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1939,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0008378304384070194,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08290919662,
                        0.47998641772091
                    ],
                    [
                        122.08303928375,
                        0.47984828880233
                    ],
                    [
                        122.08330214024,
                        0.47961494479761
                    ],
                    [
                        122.08352610469,
                        0.47942049145428
                    ],
                    [
                        122.08352610469,
                        0.47942049145428
                    ],
                    [
                        122.08352610469,
                        0.47942049145428
                    ],
                    [
                        122.08352610469,
                        0.47942049145428
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1940,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0023609020245811997,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08354353905,
                        0.47944060731764
                    ],
                    [
                        122.08363875747,
                        0.47952107077048
                    ],
                    [
                        122.08376213908,
                        0.47963506066041
                    ],
                    [
                        122.08385333419,
                        0.47973832208847
                    ],
                    [
                        122.08395794034,
                        0.4798442656299
                    ],
                    [
                        122.08406925201,
                        0.47993411648023
                    ],
                    [
                        122.08416581154,
                        0.4800092156975
                    ],
                    [
                        122.0842140913,
                        0.48000653358262
                    ],
                    [
                        122.08426773548,
                        0.48000653358262
                    ],
                    [
                        122.08431065083,
                        0.4800346957889
                    ],
                    [
                        122.08450376987,
                        0.48017416576112
                    ],
                    [
                        122.0846606791,
                        0.48031229467313
                    ],
                    [
                        122.08479478955,
                        0.48040482763203
                    ],
                    [
                        122.08492621779,
                        0.48045578781177
                    ],
                    [
                        122.08503618836,
                        0.48053222808064
                    ],
                    [
                        122.08524674177,
                        0.48073606879349
                    ],
                    [
                        122.08538889885,
                        0.480854081835
                    ],
                    [
                        122.08538889885,
                        0.480854081835
                    ],
                    [
                        122.08538889885,
                        0.480854081835
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1941,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0030730923864273774,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08062261343,
                        0.47895246235007
                    ],
                    [
                        122.08072453737,
                        0.47911875349677
                    ],
                    [
                        122.08084121346,
                        0.47928370358186
                    ],
                    [
                        122.08101153374,
                        0.47943792520251
                    ],
                    [
                        122.08121404052,
                        0.47964042489048
                    ],
                    [
                        122.08134144545,
                        0.47977855381325
                    ],
                    [
                        122.08148494363,
                        0.47994082176751
                    ],
                    [
                        122.08174109459,
                        0.48022110277037
                    ],
                    [
                        122.08186045289,
                        0.48033375159124
                    ],
                    [
                        122.08197176456,
                        0.48046517521325
                    ],
                    [
                        122.08217963576,
                        0.48058989354608
                    ],
                    [
                        122.08238080144,
                        0.48071729399125
                    ],
                    [
                        122.08252161741,
                        0.48080446271552
                    ],
                    [
                        122.08263158798,
                        0.48084469443404
                    ],
                    [
                        122.08269327879,
                        0.4808259196321
                    ],
                    [
                        122.08285689354,
                        0.48069181390241
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1942,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007381375198419025,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08286896348,
                        0.48068242650123
                    ],
                    [
                        122.0829628408,
                        0.48058989354608
                    ],
                    [
                        122.08303257823,
                        0.4806529232403
                    ],
                    [
                        122.08317875862,
                        0.48076557205406
                    ],
                    [
                        122.0832900703,
                        0.48083933020491
                    ],
                    [
                        122.08343625069,
                        0.48091174729771
                    ],
                    [
                        122.08346709609,
                        0.4809157704695
                    ],
                    [
                        122.08346709609,
                        0.4809157704695
                    ],
                    [
                        122.08346709609,
                        0.4809157704695
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1943,
                "jenis_pipa": "Pipa 150",
                "keterangan": "JDU",
                "panjang": 0.00022451978966229785,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07229033113,
                        0.51113106345582
                    ],
                    [
                        122.07248210907,
                        0.51103182567044
                    ],
                    [
                        122.07248881459,
                        0.51102646146579
                    ],
                    [
                        122.07248881459,
                        0.51102646146579
                    ],
                    [
                        122.07248881459,
                        0.51102646146579
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1944,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.005622651542038731,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07248345017,
                        0.51102243831231
                    ],
                    [
                        122.07244187593,
                        0.5109057668598
                    ],
                    [
                        122.07235872746,
                        0.51066974184594
                    ],
                    [
                        122.07227155566,
                        0.51039080318205
                    ],
                    [
                        122.07217097282,
                        0.51006895086252
                    ],
                    [
                        122.07206100225,
                        0.50969613857228
                    ],
                    [
                        122.07197517157,
                        0.50939306093912
                    ],
                    [
                        122.07183301449,
                        0.50889687186294
                    ],
                    [
                        122.07173109055,
                        0.50853747002175
                    ],
                    [
                        122.07162111998,
                        0.50811369767584
                    ],
                    [
                        122.0715379715,
                        0.50777843472426
                    ],
                    [
                        122.07148969173,
                        0.5075960516713
                    ],
                    [
                        122.07142263651,
                        0.50732784128995
                    ],
                    [
                        122.07134485245,
                        0.50697514462154
                    ],
                    [
                        122.0712724328,
                        0.50660233215271
                    ],
                    [
                        122.07124829292,
                        0.50643604169204
                    ],
                    [
                        122.07120403647,
                        0.50616112600179
                    ],
                    [
                        122.07117184997,
                        0.5059251008145
                    ],
                    [
                        122.07116246223,
                        0.50578697243387
                    ],
                    [
                        122.07116112113,
                        0.50557374512208
                    ],
                    [
                        122.07116112113,
                        0.50557374512208
                    ],
                    [
                        122.07116112113,
                        0.50557374512208
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1945,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.010739773195411794,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07115978003,
                        0.50554692407607
                    ],
                    [
                        122.07116246223,
                        0.50535917675094
                    ],
                    [
                        122.07117319107,
                        0.50497831787472
                    ],
                    [
                        122.0711812377,
                        0.50472888211974
                    ],
                    [
                        122.07120135427,
                        0.50420721268729
                    ],
                    [
                        122.07128316164,
                        0.50243031777751
                    ],
                    [
                        122.07134753466,
                        0.50131724373868
                    ],
                    [
                        122.0714199543,
                        0.50063062447818
                    ],
                    [
                        122.0715379715,
                        0.49963556284419
                    ],
                    [
                        122.07160502672,
                        0.49906695612852
                    ],
                    [
                        122.07168012857,
                        0.49840715770814
                    ],
                    [
                        122.07173913717,
                        0.49806116582714
                    ],
                    [
                        122.07177937031,
                        0.4977205381436
                    ],
                    [
                        122.07184910774,
                        0.4972431229355
                    ],
                    [
                        122.0718973875,
                        0.49689713099344
                    ],
                    [
                        122.07194030285,
                        0.49661014541534
                    ],
                    [
                        122.0720154047,
                        0.49623465024761
                    ],
                    [
                        122.07209855318,
                        0.49596643940047
                    ],
                    [
                        122.0721937716,
                        0.49559630841359
                    ],
                    [
                        122.0722822845,
                        0.49530529961589
                    ],
                    [
                        122.07240968943,
                        0.49491505277495
                    ],
                    [
                        122.07240968943,
                        0.49491505277495
                    ],
                    [
                        122.07240968943,
                        0.49491505277495
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1946,
                "jenis_pipa": "Pipa 75",
                "keterangan": "PIPA LAMA",
                "panjang": 0.007976406070270302,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07242578268,
                        0.4949177348839
                    ],
                    [
                        122.07247942686,
                        0.49493248648311
                    ],
                    [
                        122.07253172994,
                        0.49478497048953
                    ],
                    [
                        122.07257196307,
                        0.49466561663779
                    ],
                    [
                        122.07265108824,
                        0.4944000878363
                    ],
                    [
                        122.0726685226,
                        0.49433839932536
                    ],
                    [
                        122.07273557782,
                        0.49414394640664
                    ],
                    [
                        122.07281604409,
                        0.49392937766215
                    ],
                    [
                        122.07294747233,
                        0.49354985917836
                    ],
                    [
                        122.0730265975,
                        0.4933312672503
                    ],
                    [
                        122.0731164515,
                        0.49306305628583
                    ],
                    [
                        122.07320094109,
                        0.49279484531055
                    ],
                    [
                        122.07331627607,
                        0.49243276047679
                    ],
                    [
                        122.07339137793,
                        0.49218734741161
                    ],
                    [
                        122.0735040307,
                        0.49183867309584
                    ],
                    [
                        122.0735630393,
                        0.49162142216678
                    ],
                    [
                        122.07366898656,
                        0.49120703611588
                    ],
                    [
                        122.07373604178,
                        0.49092139134737
                    ],
                    [
                        122.07378566265,
                        0.49076180576716
                    ],
                    [
                        122.07387417555,
                        0.49042520087542
                    ],
                    [
                        122.07394123077,
                        0.4901744235148
                    ],
                    [
                        122.07403376698,
                        0.48976808370732
                    ],
                    [
                        122.0741263032,
                        0.4894059987096
                    ],
                    [
                        122.07421883941,
                        0.48905464213759
                    ],
                    [
                        122.07434222102,
                        0.48860404742288
                    ],
                    [
                        122.07440122962,
                        0.48837740899839
                    ],
                    [
                        122.07451254129,
                        0.48794558902057
                    ],
                    [
                        122.07459971309,
                        0.48761166609945
                    ],
                    [
                        122.0746332407,
                        0.48754461330204
                    ],
                    [
                        122.07466945052,
                        0.48749901739942
                    ],
                    [
                        122.07469493151,
                        0.48748426578381
                    ],
                    [
                        122.07474321127,
                        0.48748426578381
                    ],
                    [
                        122.07480624318,
                        0.48750169951136
                    ],
                    [
                        122.07482367754,
                        0.48750304056732
                    ],
                    [
                        122.07482367754,
                        0.48750304056732
                    ],
                    [
                        122.07482367754,
                        0.48750304056732
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1947,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA LAMA 50MM",
                "panjang": 0.008839076731007738,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07482904196,
                        0.48750438162328
                    ],
                    [
                        122.07511737943,
                        0.48759423237218
                    ],
                    [
                        122.07535877824,
                        0.48767335467247
                    ],
                    [
                        122.07578390837,
                        0.48782087082305
                    ],
                    [
                        122.07598105073,
                        0.48788926467359
                    ],
                    [
                        122.07612320781,
                        0.48794693007644
                    ],
                    [
                        122.07627743483,
                        0.48798984386429
                    ],
                    [
                        122.07670524716,
                        0.48813870106378
                    ],
                    [
                        122.07717999816,
                        0.48833181310142
                    ],
                    [
                        122.07740664482,
                        0.48842568700663
                    ],
                    [
                        122.07788944244,
                        0.48861209375734
                    ],
                    [
                        122.07816302776,
                        0.48872742455015
                    ],
                    [
                        122.07838967443,
                        0.48880252366999
                    ],
                    [
                        122.07874104381,
                        0.48886421223207
                    ],
                    [
                        122.07899183035,
                        0.48886287117638
                    ],
                    [
                        122.07938209176,
                        0.48884811956376
                    ],
                    [
                        122.08024308085,
                        0.4888119110599
                    ],
                    [
                        122.08062931895,
                        0.48880386472568
                    ],
                    [
                        122.08075940609,
                        0.48882263950551
                    ],
                    [
                        122.08083584905,
                        0.48886957645484
                    ],
                    [
                        122.08087742329,
                        0.48894199346174
                    ],
                    [
                        122.08087876439,
                        0.48904659580365
                    ],
                    [
                        122.08083316684,
                        0.48918874770159
                    ],
                    [
                        122.08065882325,
                        0.48972785204187
                    ],
                    [
                        122.08040803671,
                        0.4904734788689
                    ],
                    [
                        122.0801371336,
                        0.49117753290091
                    ],
                    [
                        122.08008348942,
                        0.4913009099808
                    ],
                    [
                        122.08008348942,
                        0.4913009099808
                    ],
                    [
                        122.08008348942,
                        0.4913009099808
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1948,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.01945400428460173,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07242041826,
                        0.49489225484883
                    ],
                    [
                        122.07251697779,
                        0.49460526918384
                    ],
                    [
                        122.07261890173,
                        0.49429146241446
                    ],
                    [
                        122.072789222,
                        0.49383416277956
                    ],
                    [
                        122.0729072392,
                        0.4934734190571
                    ],
                    [
                        122.07301720977,
                        0.49318643333083
                    ],
                    [
                        122.07312852144,
                        0.49285116961625
                    ],
                    [
                        122.07324653864,
                        0.49246092263123
                    ],
                    [
                        122.07335919142,
                        0.49210688410959
                    ],
                    [
                        122.07349061966,
                        0.4916549485452
                    ],
                    [
                        122.07358852029,
                        0.49125933726935
                    ],
                    [
                        122.07362607121,
                        0.49109170536574
                    ],
                    [
                        122.07367300987,
                        0.49089054707587
                    ],
                    [
                        122.07377225161,
                        0.49052041580668
                    ],
                    [
                        122.07385808229,
                        0.49018112879193
                    ],
                    [
                        122.07407802343,
                        0.48932553537412
                    ],
                    [
                        122.0742470026,
                        0.48867378232118
                    ],
                    [
                        122.0745742321,
                        0.48743732882481
                    ],
                    [
                        122.07470834255,
                        0.48688481373999
                    ],
                    [
                        122.07494705915,
                        0.48600239877765
                    ],
                    [
                        122.0751106739,
                        0.48531309582414
                    ],
                    [
                        122.07525283098,
                        0.4847739911306
                    ],
                    [
                        122.07538962364,
                        0.48419197258243
                    ],
                    [
                        122.07552909851,
                        0.48366896048039
                    ],
                    [
                        122.07574099302,
                        0.48283214103331
                    ],
                    [
                        122.07588851452,
                        0.48223671174863
                    ],
                    [
                        122.07609772682,
                        0.48140525635406
                    ],
                    [
                        122.07626402378,
                        0.48084737654859
                    ],
                    [
                        122.07644641399,
                        0.48008029174166
                    ],
                    [
                        122.07652688026,
                        0.47975307372092
                    ],
                    [
                        122.07657516003,
                        0.47958946470466
                    ],
                    [
                        122.07655906677,
                        0.47943121991473
                    ],
                    [
                        122.07654029131,
                        0.47914155147624
                    ],
                    [
                        122.07652419806,
                        0.47881165129526
                    ],
                    [
                        122.07652151585,
                        0.47863731379485
                    ],
                    [
                        122.07654833794,
                        0.47851661859965
                    ],
                    [
                        122.07664489746,
                        0.47842006244197
                    ],
                    [
                        122.07696676254,
                        0.47822158589135
                    ],
                    [
                        122.07728996873,
                        0.47802310933498
                    ],
                    [
                        122.07767888904,
                        0.47779512949965
                    ],
                    [
                        122.0779068768,
                        0.47767577534756
                    ],
                    [
                        122.07799941301,
                        0.47763554361043
                    ],
                    [
                        122.07818448544,
                        0.47757117283051
                    ],
                    [
                        122.07836285233,
                        0.47749875570241
                    ],
                    [
                        122.07846477628,
                        0.47745450079041
                    ],
                    [
                        122.07860425115,
                        0.47739817635655
                    ],
                    [
                        122.07874506712,
                        0.47732710028459
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1949,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013517010779714456,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07828909159,
                        0.47755373907752
                    ],
                    [
                        122.07833603024,
                        0.47765565947902
                    ],
                    [
                        122.07838699222,
                        0.47777233151571
                    ],
                    [
                        122.07840710878,
                        0.477854136046
                    ],
                    [
                        122.0784124732,
                        0.4779050962447
                    ],
                    [
                        122.07848355174,
                        0.47799897029396
                    ],
                    [
                        122.07855194807,
                        0.47796276173225
                    ],
                    [
                        122.07857877016,
                        0.47793728163316
                    ],
                    [
                        122.07868471742,
                        0.47783938440946
                    ],
                    [
                        122.0787678659,
                        0.47777367257358
                    ],
                    [
                        122.07891404629,
                        0.47763420255251
                    ],
                    [
                        122.07898646593,
                        0.4775832423518
                    ],
                    [
                        122.0790964365,
                        0.47748936829686
                    ],
                    [
                        122.07914605737,
                        0.4774571829063
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1982,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.0004204179035380149,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07525148988,
                        0.48412357869446
                    ],
                    [
                        122.07524076104,
                        0.48400556570967
                    ],
                    [
                        122.07522198558,
                        0.48394119498981
                    ],
                    [
                        122.07512408495,
                        0.48392107913974
                    ],
                    [
                        122.0749899745,
                        0.4839063275163
                    ],
                    [
                        122.0749899745,
                        0.4839063275163
                    ],
                    [
                        122.0749899745,
                        0.4839063275163
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1950,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0015924083260103782,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0766556263,
                        0.47838251282472
                    ],
                    [
                        122.07662478089,
                        0.47833423474511
                    ],
                    [
                        122.07657650113,
                        0.47830741358962
                    ],
                    [
                        122.07654029131,
                        0.4782054931978
                    ],
                    [
                        122.07650408149,
                        0.47815319194352
                    ],
                    [
                        122.07640618086,
                        0.47811296020919
                    ],
                    [
                        122.07629486918,
                        0.47812771184513
                    ],
                    [
                        122.07626268268,
                        0.47802579145065
                    ],
                    [
                        122.07611918449,
                        0.47803517885546
                    ],
                    [
                        122.07612454891,
                        0.47809284434192
                    ],
                    [
                        122.07602262497,
                        0.4781062549201
                    ],
                    [
                        122.07598239183,
                        0.47813441713418
                    ],
                    [
                        122.07593411207,
                        0.47809418539974
                    ],
                    [
                        122.07591667771,
                        0.47800567558313
                    ],
                    [
                        122.0757932961,
                        0.47804724837592
                    ],
                    [
                        122.07566723228,
                        0.47807675164808
                    ],
                    [
                        122.07569137216,
                        0.47821085742897
                    ],
                    [
                        122.07570612431,
                        0.47828997983849
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1951,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0007692042371210412,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07652419806,
                        0.47851393648418
                    ],
                    [
                        122.07647457719,
                        0.47846699946323
                    ],
                    [
                        122.07643032074,
                        0.47840396974889
                    ],
                    [
                        122.07637667656,
                        0.47833423474511
                    ],
                    [
                        122.07630693913,
                        0.47831143676295
                    ],
                    [
                        122.07623720169,
                        0.47824572493158
                    ],
                    [
                        122.0762090385,
                        0.47821756271796
                    ],
                    [
                        122.07614734769,
                        0.47822158589135
                    ],
                    [
                        122.07605883479,
                        0.47823633752706
                    ],
                    [
                        122.07602664828,
                        0.47824304281601
                    ],
                    [
                        122.07599177957,
                        0.47823231435369
                    ],
                    [
                        122.07596495748,
                        0.47817062569499
                    ],
                    [
                        122.07597434521,
                        0.47813307607637
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1952,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0013470583327133726,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07726180553,
                        0.4780606589542
                    ],
                    [
                        122.07730203867,
                        0.47811832444043
                    ],
                    [
                        122.0773395896,
                        0.47818001309961
                    ],
                    [
                        122.07738652825,
                        0.47826449974061
                    ],
                    [
                        122.07742810249,
                        0.47834228109174
                    ],
                    [
                        122.07743212581,
                        0.47838519494024
                    ],
                    [
                        122.0774307847,
                        0.47844017830827
                    ],
                    [
                        122.07744553685,
                        0.4785112543687
                    ],
                    [
                        122.07747235894,
                        0.47855819138935
                    ],
                    [
                        122.07755282521,
                        0.47864938331425
                    ],
                    [
                        122.07761317492,
                        0.47873923418024
                    ],
                    [
                        122.07766011357,
                        0.47883981350646
                    ],
                    [
                        122.07770973444,
                        0.47894709811947
                    ],
                    [
                        122.0777580142,
                        0.47906779330709
                    ],
                    [
                        122.07784250379,
                        0.47925554137248
                    ],
                    [
                        122.07784250379,
                        0.47925554137248
                    ],
                    [
                        122.07784250379,
                        0.47925554137248
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1953,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0011074214809160532,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07867264748,
                        0.47930381944561
                    ],
                    [
                        122.07884699106,
                        0.47955325615136
                    ],
                    [
                        122.07905352116,
                        0.4798201265953
                    ],
                    [
                        122.07925066352,
                        0.48003737790378
                    ],
                    [
                        122.07935258746,
                        0.48015941412958
                    ],
                    [
                        122.07936197519,
                        0.48016880153148
                    ],
                    [
                        122.07936197519,
                        0.48016880153148
                    ],
                    [
                        122.07936197519,
                        0.48016880153148
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1954,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003420918328182123,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07874640822,
                        0.47932125319416
                    ],
                    [
                        122.07877993584,
                        0.4793869650152
                    ],
                    [
                        122.07885637879,
                        0.4795090012526
                    ],
                    [
                        122.07914873958,
                        0.47986840466444
                    ],
                    [
                        122.07938343287,
                        0.48014466249801
                    ],
                    [
                        122.07950010896,
                        0.48027876823843
                    ],
                    [
                        122.07962214947,
                        0.48045310569705
                    ],
                    [
                        122.07964092493,
                        0.48049870164703
                    ],
                    [
                        122.07962483168,
                        0.4805241817366
                    ],
                    [
                        122.07946658134,
                        0.48061939680727
                    ],
                    [
                        122.07931101322,
                        0.48067438015735
                    ],
                    [
                        122.07915276289,
                        0.48069851918894
                    ],
                    [
                        122.0790964365,
                        0.48069583707434
                    ],
                    [
                        122.07898378372,
                        0.48069449601704
                    ],
                    [
                        122.07884430885,
                        0.48071327081934
                    ],
                    [
                        122.07871824503,
                        0.48079105214262
                    ],
                    [
                        122.07865387201,
                        0.48085274077772
                    ],
                    [
                        122.078589499,
                        0.48087151557958
                    ],
                    [
                        122.07846879959,
                        0.48089297249594
                    ],
                    [
                        122.07834541798,
                        0.48087151557958
                    ],
                    [
                        122.07813352346,
                        0.48086078712138
                    ],
                    [
                        122.07788139582,
                        0.48082994280394
                    ],
                    [
                        122.07781299949,
                        0.48081787328839
                    ],
                    [
                        122.07781299949,
                        0.48081787328839
                    ],
                    [
                        122.07781299949,
                        0.48081787328839
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1955,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006044331249098067,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07746699452,
                        0.47794398692239
                    ],
                    [
                        122.07751125097,
                        0.47800701664098
                    ],
                    [
                        122.0775783062,
                        0.47808211587937
                    ],
                    [
                        122.07768827677,
                        0.47823499646927
                    ],
                    [
                        122.0777875185,
                        0.47837178436261
                    ],
                    [
                        122.07782641053,
                        0.47842408561522
                    ],
                    [
                        122.07783043385,
                        0.47842542667299
                    ],
                    [
                        122.07783043385,
                        0.47842542667299
                    ],
                    [
                        122.07783043385,
                        0.47842542667299
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1956,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.007939640189122158,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08348855376,
                        0.4809345452712
                    ],
                    [
                        122.08351671696,
                        0.48093052209942
                    ],
                    [
                        122.08353683352,
                        0.48086481029321
                    ],
                    [
                        122.08356231451,
                        0.48068510861586
                    ],
                    [
                        122.08353415132,
                        0.48056843662878
                    ],
                    [
                        122.08349660039,
                        0.48050272481907
                    ],
                    [
                        122.08330884576,
                        0.48028949669755
                    ],
                    [
                        122.08311975002,
                        0.48011650029218
                    ],
                    [
                        122.08290919662,
                        0.47989120264142
                    ],
                    [
                        122.08254039288,
                        0.47951302442525
                    ],
                    [
                        122.08236604929,
                        0.47933466376994
                    ],
                    [
                        122.08199322224,
                        0.47895112129241
                    ],
                    [
                        122.08183631301,
                        0.47877410168017
                    ],
                    [
                        122.08170220256,
                        0.47864938331425
                    ],
                    [
                        122.08159089088,
                        0.47853539340794
                    ],
                    [
                        122.08149969578,
                        0.47843481407726
                    ],
                    [
                        122.0814473927,
                        0.47840396974889
                    ],
                    [
                        122.08138033748,
                        0.4784066518644
                    ],
                    [
                        122.0811791718,
                        0.47852064177285
                    ],
                    [
                        122.08089351654,
                        0.4787258236033
                    ],
                    [
                        122.08063468337,
                        0.47887468100587
                    ],
                    [
                        122.08045497537,
                        0.47893771071589
                    ],
                    [
                        122.0802283287,
                        0.47901415100173
                    ],
                    [
                        122.07967579365,
                        0.47915362099476
                    ],
                    [
                        122.07932844758,
                        0.479227379163
                    ],
                    [
                        122.07906022668,
                        0.47925420031489
                    ],
                    [
                        122.07880809903,
                        0.47926626983322
                    ],
                    [
                        122.07866728306,
                        0.47920458118382
                    ],
                    [
                        122.07862035103,
                        0.47917105699364
                    ],
                    [
                        122.07851172279,
                        0.47905438104331
                    ],
                    [
                        122.07842723075,
                        0.47895380565768
                    ],
                    [
                        122.07841247983,
                        0.47892833399961
                    ],
                    [
                        122.07848221064,
                        0.47886395254453
                    ],
                    [
                        122.07861766219,
                        0.47874996264178
                    ],
                    [
                        122.07869410515,
                        0.47868022764151
                    ],
                    [
                        122.07873299718,
                        0.47859842312107
                    ],
                    [
                        122.07875445485,
                        0.47853941658113
                    ],
                    [
                        122.07873567939,
                        0.47848577427165
                    ],
                    [
                        122.07880407572,
                        0.47842006244197
                    ],
                    [
                        122.07908838987,
                        0.47819744685102
                    ],
                    [
                        122.07919165492,
                        0.47811832444043
                    ],
                    [
                        122.07919165492,
                        0.47811832444043
                    ],
                    [
                        122.07919165492,
                        0.47811832444043
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1957,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0015138344045135515,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08158686757,
                        0.47848979744487
                    ],
                    [
                        122.0816861093,
                        0.4783932412868
                    ],
                    [
                        122.08178803325,
                        0.4782953440696
                    ],
                    [
                        122.08187654614,
                        0.47820147002441
                    ],
                    [
                        122.08187922835,
                        0.47817196675279
                    ],
                    [
                        122.08191007376,
                        0.47812100655607
                    ],
                    [
                        122.08184033632,
                        0.47805261260724
                    ],
                    [
                        122.08178669214,
                        0.4780003113518
                    ],
                    [
                        122.08174243569,
                        0.47796544384793
                    ],
                    [
                        122.08171695471,
                        0.47794264586455
                    ],
                    [
                        122.0816244185,
                        0.47787156979823
                    ],
                    [
                        122.08153858781,
                        0.47780451690479
                    ],
                    [
                        122.08142995834,
                        0.47772137131602
                    ],
                    [
                        122.08136826754,
                        0.47768248063706
                    ],
                    [
                        122.08130121231,
                        0.47766370582643
                    ],
                    [
                        122.08124220371,
                        0.47763688466832
                    ],
                    [
                        122.08109602332,
                        0.47752691791899
                    ],
                    [
                        122.08109602332,
                        0.47752691791899
                    ],
                    [
                        122.08109602332,
                        0.47752691791899
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1958,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009043009559266602,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08181351423,
                        0.47830607253184
                    ],
                    [
                        122.08190605044,
                        0.47839190022904
                    ],
                    [
                        122.08197712898,
                        0.47846834052098
                    ],
                    [
                        122.08199724555,
                        0.47850589013776
                    ],
                    [
                        122.08199992776,
                        0.47853941658113
                    ],
                    [
                        122.08201870322,
                        0.47858098937068
                    ],
                    [
                        122.08209782839,
                        0.47865072437195
                    ],
                    [
                        122.08217158914,
                        0.47873789312255
                    ],
                    [
                        122.08223462105,
                        0.47880494600688
                    ],
                    [
                        122.0822802186,
                        0.47886797571754
                    ],
                    [
                        122.08238884807,
                        0.47898867090655
                    ],
                    [
                        122.08238884807,
                        0.47898867090655
                    ],
                    [
                        122.08238884807,
                        0.47898867090655
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1959,
                "jenis_pipa": "Pipa 75",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.0016307494272870691,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08201870322,
                        0.4784938206181
                    ],
                    [
                        122.08208039403,
                        0.47842542667299
                    ],
                    [
                        122.08220109344,
                        0.47830204935851
                    ],
                    [
                        122.08221450448,
                        0.47823901964264
                    ],
                    [
                        122.08220914006,
                        0.4781746488684
                    ],
                    [
                        122.0822198689,
                        0.47808748011065
                    ],
                    [
                        122.08223596215,
                        0.47804188414462
                    ],
                    [
                        122.08214879036,
                        0.47794801009594
                    ],
                    [
                        122.08205088973,
                        0.47785145393026
                    ],
                    [
                        122.08203077316,
                        0.47778440103662
                    ],
                    [
                        122.08203479648,
                        0.47774953353167
                    ],
                    [
                        122.08196505904,
                        0.47766236476853
                    ],
                    [
                        122.08188593388,
                        0.47757251388843
                    ],
                    [
                        122.08180680871,
                        0.47756714965674
                    ],
                    [
                        122.08174780011,
                        0.47758994764139
                    ],
                    [
                        122.08167269826,
                        0.47761676879967
                    ],
                    [
                        122.08157345653,
                        0.47756849071468
                    ],
                    [
                        122.08145141602,
                        0.47745584184836
                    ],
                    [
                        122.08145141602,
                        0.47745584184836
                    ],
                    [
                        122.08145141602,
                        0.47745584184836
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1960,
                "jenis_pipa": "Pipa 75",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.0013926932135192292,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08223462105,
                        0.4781518508857
                    ],
                    [
                        122.08233386278,
                        0.47821488060237
                    ],
                    [
                        122.08244115065,
                        0.47834498345691
                    ],
                    [
                        122.08253502109,
                        0.4784227659321
                    ],
                    [
                        122.08258330822,
                        0.47848713445404
                    ],
                    [
                        122.08262488246,
                        0.47847638686744
                    ],
                    [
                        122.08274154971,
                        0.47840931148032
                    ],
                    [
                        122.08300167784,
                        0.47863470030319
                    ],
                    [
                        122.08308750951,
                        0.47863198668833
                    ],
                    [
                        122.08314383541,
                        0.47868294913122
                    ],
                    [
                        122.08321357137,
                        0.47889221375371
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2117,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.001549345760824506,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94730877876,
                        0.47873328198379
                    ],
                    [
                        121.94744018295,
                        0.47867022583489
                    ],
                    [
                        121.94754208823,
                        0.47861521940662
                    ],
                    [
                        121.94765472039,
                        0.47853606381397
                    ],
                    [
                        121.94777942028,
                        0.47842873419536
                    ],
                    [
                        121.9478638944,
                        0.47832542943584
                    ],
                    [
                        121.94794434594,
                        0.47821675819364
                    ],
                    [
                        121.94805965982,
                        0.47811479505125
                    ],
                    [
                        121.94815351995,
                        0.47804637241536
                    ],
                    [
                        121.94819374573,
                        0.47801551514799
                    ],
                    [
                        121.9482795607,
                        0.47796721681615
                    ],
                    [
                        121.94824469837,
                        0.47789611093811
                    ],
                    [
                        121.94820983603,
                        0.47780353913352
                    ],
                    [
                        121.94821385861,
                        0.47777268186504
                    ],
                    [
                        121.94824201665,
                        0.47776597376318
                    ],
                    [
                        121.94829967359,
                        0.47775121593907
                    ],
                    [
                        121.94829967359,
                        0.47775121593907
                    ],
                    [
                        121.94829967359,
                        0.47775121593907
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1961,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0034270273885645955,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0824867487,
                        0.48419599575229
                    ],
                    [
                        122.08256855607,
                        0.48391169174301
                    ],
                    [
                        122.08269193769,
                        0.48350401050139
                    ],
                    [
                        122.08280593157,
                        0.4831392430539
                    ],
                    [
                        122.08291858435,
                        0.4827476544488
                    ],
                    [
                        122.08304464817,
                        0.48235606582112
                    ],
                    [
                        122.0832028985,
                        0.48187999057563
                    ],
                    [
                        122.08330616355,
                        0.48157288849822
                    ],
                    [
                        122.08345234394,
                        0.4811303396287
                    ],
                    [
                        122.0835006237,
                        0.48096941275993
                    ],
                    [
                        122.08351537585,
                        0.48093320421393
                    ],
                    [
                        122.08351537585,
                        0.48093856844298
                    ],
                    [
                        122.08351537585,
                        0.48093856844298
                    ],
                    [
                        122.08351537585,
                        0.48093856844298
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1963,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008909439614671247,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08346843719,
                        0.48109815425525
                    ],
                    [
                        122.08366155624,
                        0.48113838597203
                    ],
                    [
                        122.0837366581,
                        0.48114240914371
                    ],
                    [
                        122.08377689123,
                        0.48112765751425
                    ],
                    [
                        122.08383992314,
                        0.48114777337258
                    ],
                    [
                        122.08402097225,
                        0.48123225997694
                    ],
                    [
                        122.08412960147,
                        0.48126445266215
                    ],
                    [
                        122.08422481572,
                        0.48127383893755
                    ],
                    [
                        122.08427443659,
                        0.48124566773652
                    ],
                    [
                        122.08430528641,
                        0.48127651486453
                    ],
                    [
                        122.08430528641,
                        0.48127651486453
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1964,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.000294402973098152,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0842730999,
                        0.48124164737738
                    ],
                    [
                        122.08431601524,
                        0.48120543883282
                    ],
                    [
                        122.08434954286,
                        0.48116520711643
                    ],
                    [
                        122.0844206214,
                        0.48106865099613
                    ],
                    [
                        122.08446085453,
                        0.48101634976371
                    ],
                    [
                        122.08446085453,
                        0.48101634976371
                    ],
                    [
                        122.08446085453,
                        0.48101634976371
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1965,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0018811051565359904,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10374593735,
                        0.48788390045005
                    ],
                    [
                        122.10378080606,
                        0.48800727759053
                    ],
                    [
                        122.10381031036,
                        0.48818966118536
                    ],
                    [
                        122.10383981466,
                        0.48844043862018
                    ],
                    [
                        122.10384383798,
                        0.48854504096991
                    ],
                    [
                        122.1038223803,
                        0.48861879903605
                    ],
                    [
                        122.10380896926,
                        0.48882666267261
                    ],
                    [
                        122.10391625762,
                        0.48917131397842
                    ],
                    [
                        122.10409328341,
                        0.48970773620905
                    ],
                    [
                        122.10409328341,
                        0.48970773620905
                    ],
                    [
                        122.10409328341,
                        0.48970773620905
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1966,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0006308089912900156,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08921909332,
                        0.48611772961516
                    ],
                    [
                        122.08925798535,
                        0.4860211735653
                    ],
                    [
                        122.08942696452,
                        0.48552230061902
                    ],
                    [
                        122.08942696452,
                        0.48552230061902
                    ],
                    [
                        122.08942696452,
                        0.48552230061902
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1967,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0017603969411172078,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08934783936,
                        0.48582403829254
                    ],
                    [
                        122.08948999643,
                        0.48586292892503
                    ],
                    [
                        122.08976358175,
                        0.48593936913308
                    ],
                    [
                        122.09003448486,
                        0.48601044511522
                    ],
                    [
                        122.09023430943,
                        0.4860640873654
                    ],
                    [
                        122.09040731192,
                        0.48612041172765
                    ],
                    [
                        122.09104165435,
                        0.48630279537354
                    ],
                    [
                        122.09104165435,
                        0.48630279537354
                    ],
                    [
                        122.09104165435,
                        0.48630279537354
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1968,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0017293982690833167,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08943232894,
                        0.48557460181673
                    ],
                    [
                        122.08952486515,
                        0.4856081282253
                    ],
                    [
                        122.08966970444,
                        0.48565104202804
                    ],
                    [
                        122.08988696337,
                        0.48570870745002
                    ],
                    [
                        122.09005594254,
                        0.48576771392784
                    ],
                    [
                        122.09014311433,
                        0.48579051188504
                    ],
                    [
                        122.09051862359,
                        0.48589243216334
                    ],
                    [
                        122.090729177,
                        0.48594741547073
                    ],
                    [
                        122.09092229605,
                        0.48600642194645
                    ],
                    [
                        122.09109261632,
                        0.48605604102791
                    ],
                    [
                        122.09109261632,
                        0.48605604102791
                    ],
                    [
                        122.09109261632,
                        0.48605604102791
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1969,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0017852080085890613,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08929151297,
                        0.48615930235842
                    ],
                    [
                        122.08931162953,
                        0.4860962727153
                    ],
                    [
                        122.08949401975,
                        0.48614455073988
                    ],
                    [
                        122.08979308605,
                        0.48622501411339
                    ],
                    [
                        122.09017664194,
                        0.48633498072231
                    ],
                    [
                        122.09053739905,
                        0.4864409241609
                    ],
                    [
                        122.09065541625,
                        0.48646774528434
                    ],
                    [
                        122.0909692347,
                        0.4865508907663
                    ],
                    [
                        122.0909692347,
                        0.4865508907663
                    ],
                    [
                        122.0909692347,
                        0.4865508907663
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1970,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0009174618598589779,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07655236125,
                        0.47959616999229
                    ],
                    [
                        122.07613125443,
                        0.47946742846869
                    ],
                    [
                        122.07589656115,
                        0.47935746174869
                    ],
                    [
                        122.07568466663,
                        0.47930650156078
                    ],
                    [
                        122.07568466663,
                        0.47930650156078
                    ],
                    [
                        122.07568466663,
                        0.47930650156078
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1971,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0015152172129134528,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07572758198,
                        0.47931454790626
                    ],
                    [
                        122.07572087646,
                        0.47924749502693
                    ],
                    [
                        122.07568600774,
                        0.47916569051326
                    ],
                    [
                        122.0756444335,
                        0.47912814090009
                    ],
                    [
                        122.07554921508,
                        0.47912411772724
                    ],
                    [
                        122.07553312182,
                        0.48010845394765
                    ],
                    [
                        122.07531049848,
                        0.4801232055793
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1972,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004387532179525115,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07555189729,
                        0.47985097091729
                    ],
                    [
                        122.07564041018,
                        0.47986169937709
                    ],
                    [
                        122.07590594888,
                        0.47987645100927
                    ],
                    [
                        122.07598775625,
                        0.47985901726213
                    ],
                    [
                        122.07598775625,
                        0.47985901726213
                    ],
                    [
                        122.07598775625,
                        0.47985901726213
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1976,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0008331143521548399,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07639142871,
                        0.4806529232403
                    ],
                    [
                        122.07649335265,
                        0.48067706227198
                    ],
                    [
                        122.07663819194,
                        0.48071729399125
                    ],
                    [
                        122.0767749846,
                        0.48077764156971
                    ],
                    [
                        122.07687556744,
                        0.48077898262701
                    ],
                    [
                        122.07691982388,
                        0.48076557205406
                    ],
                    [
                        122.07697346807,
                        0.48073338667889
                    ],
                    [
                        122.07700833678,
                        0.48065158218299
                    ],
                    [
                        122.07707807422,
                        0.48054161548202
                    ],
                    [
                        122.07707807422,
                        0.48054161548202
                    ],
                    [
                        122.07707807422,
                        0.48054161548202
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1980,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003565866759264203,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07649603486,
                        0.47813173501856
                    ],
                    [
                        122.07648396492,
                        0.47807406953243
                    ],
                    [
                        122.07645580173,
                        0.47798287759987
                    ],
                    [
                        122.07642495632,
                        0.47788900355041
                    ],
                    [
                        122.07641020417,
                        0.47780719902054
                    ],
                    [
                        122.07641288638,
                        0.47778708315238
                    ],
                    [
                        122.07641288638,
                        0.47778708315238
                    ],
                    [
                        122.07641288638,
                        0.47778708315238
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1983,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.0011336821815667749,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07474991679,
                        0.48709938271036
                    ],
                    [
                        122.07481831312,
                        0.48711011115869
                    ],
                    [
                        122.07487598062,
                        0.48708463109386
                    ],
                    [
                        122.07494571805,
                        0.48706049208497
                    ],
                    [
                        122.07503288984,
                        0.48705915102894
                    ],
                    [
                        122.07510262728,
                        0.48707926686967
                    ],
                    [
                        122.07517236471,
                        0.48710608799057
                    ],
                    [
                        122.07524344325,
                        0.48711815749493
                    ],
                    [
                        122.07533732057,
                        0.48715570706394
                    ],
                    [
                        122.075407058,
                        0.48715838917601
                    ],
                    [
                        122.07545399666,
                        0.48704037624418
                    ],
                    [
                        122.07548081875,
                        0.48690358852517
                    ],
                    [
                        122.07551300526,
                        0.48688213162782
                    ],
                    [
                        122.07555189729,
                        0.48690627063734
                    ],
                    [
                        122.07563102245,
                        0.48693443281499
                    ],
                    [
                        122.07564309239,
                        0.48694382020753
                    ],
                    [
                        122.07564309239,
                        0.48694382020753
                    ],
                    [
                        122.07564309239,
                        0.48694382020753
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1984,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.007117062177347597,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57199665904,
                        0.55084187723668
                    ],
                    [
                        121.57174989581,
                        0.55081238082095
                    ],
                    [
                        121.5715393424,
                        0.55080031410538
                    ],
                    [
                        121.57132342458,
                        0.55079226962831
                    ],
                    [
                        121.57119199634,
                        0.55078690664361
                    ],
                    [
                        121.57097473741,
                        0.5508096993286
                    ],
                    [
                        121.57085135579,
                        0.55084321798284
                    ],
                    [
                        121.57071456313,
                        0.5508700329061
                    ],
                    [
                        121.57060727477,
                        0.55089282559078
                    ],
                    [
                        121.57048255205,
                        0.55091427752921
                    ],
                    [
                        121.57034441829,
                        0.55092232200611
                    ],
                    [
                        121.57026126981,
                        0.55092232200611
                    ],
                    [
                        121.57023981214,
                        0.55090757379847
                    ],
                    [
                        121.5702304244,
                        0.55089282559078
                    ],
                    [
                        121.57021969557,
                        0.5508700329061
                    ],
                    [
                        121.57022371888,
                        0.55082310679031
                    ],
                    [
                        121.57023176551,
                        0.55065953575525
                    ],
                    [
                        121.57025724649,
                        0.55032971217912
                    ],
                    [
                        121.57029479742,
                        0.55006022217043
                    ],
                    [
                        121.57033100724,
                        0.54976257647506
                    ],
                    [
                        121.57035782933,
                        0.54950247166604
                    ],
                    [
                        121.57038599253,
                        0.54919812221019
                    ],
                    [
                        121.57042488456,
                        0.54892729140386
                    ],
                    [
                        121.57045572996,
                        0.54868059402504
                    ],
                    [
                        121.57048121095,
                        0.5484781412772
                    ],
                    [
                        121.57052144408,
                        0.54817245102246
                    ],
                    [
                        121.57057777047,
                        0.54784799029641
                    ],
                    [
                        121.57063677907,
                        0.54745246996612
                    ],
                    [
                        121.57065823674,
                        0.54733984722323
                    ],
                    [
                        121.57068103552,
                        0.54727280987528
                    ],
                    [
                        121.57070249319,
                        0.54727280987528
                    ],
                    [
                        121.57074809074,
                        0.54726610614044
                    ],
                    [
                        121.57102033496,
                        0.54728487659795
                    ],
                    [
                        121.57129660249,
                        0.54731035079021
                    ],
                    [
                        121.57150179148,
                        0.54732107676589
                    ],
                    [
                        121.57180890441,
                        0.54735325469273
                    ],
                    [
                        121.57208517194,
                        0.54737470664389
                    ],
                    [
                        121.57228901982,
                        0.54739347710107
                    ],
                    [
                        121.572342664,
                        0.54739884008882
                    ],
                    [
                        121.572342664,
                        0.54739884008882
                    ],
                    [
                        121.572342664,
                        0.54739884008882
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1985,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.0044508150314327265,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07452595234,
                        0.48752986168653
                    ],
                    [
                        122.07438513637,
                        0.48749901739942
                    ],
                    [
                        122.07439720631,
                        0.48742123615308
                    ],
                    [
                        122.07441329956,
                        0.48736222968972
                    ],
                    [
                        122.07376822829,
                        0.48721337247307
                    ],
                    [
                        122.07321301103,
                        0.48707122053338
                    ],
                    [
                        122.07277178764,
                        0.48695454865611
                    ],
                    [
                        122.07244187593,
                        0.48687944951565
                    ],
                    [
                        122.07216158509,
                        0.48684055888901
                    ],
                    [
                        122.07172572613,
                        0.48682312515977
                    ],
                    [
                        122.0714494586,
                        0.48683117149633
                    ],
                    [
                        122.07082718611,
                        0.48682848938416
                    ],
                    [
                        122.07030817866,
                        0.48682178410367
                    ],
                    [
                        122.07030817866,
                        0.48682178410367
                    ],
                    [
                        122.07030817866,
                        0.48682178410367
                    ],
                    [
                        122.07030817866,
                        0.48682178410367
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1986,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.007493507223587294,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07437574863,
                        0.48741721298514
                    ],
                    [
                        122.07409277558,
                        0.48733943173785
                    ],
                    [
                        122.07374542952,
                        0.48724287570547
                    ],
                    [
                        122.07313388586,
                        0.48709670059826
                    ],
                    [
                        122.07277044654,
                        0.48699880350636
                    ],
                    [
                        122.07236409187,
                        0.4869022474691
                    ],
                    [
                        122.07217499614,
                        0.48688213162782
                    ],
                    [
                        122.07187190652,
                        0.48686469789868
                    ],
                    [
                        122.06944584846,
                        0.48689554218868
                    ],
                    [
                        122.06942975521,
                        0.48719862085684
                    ],
                    [
                        122.06945389509,
                        0.48749901739942
                    ],
                    [
                        122.06951826811,
                        0.48811590311452
                    ],
                    [
                        122.06954240799,
                        0.48835997527313
                    ],
                    [
                        122.06957325339,
                        0.48851419668746
                    ],
                    [
                        122.06952631474,
                        0.48875826883161
                    ],
                    [
                        122.06941366196,
                        0.48936844915316
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1987,
                "jenis_pipa": "Pipa 50",
                "keterangan": "PIPA PAMSIMAS",
                "panjang": 0.00033498385134905783,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07276374102,
                        0.48701623723516
                    ],
                    [
                        122.07275032997,
                        0.48709535954223
                    ],
                    [
                        122.07272350788,
                        0.48719727980081
                    ],
                    [
                        122.07268595695,
                        0.48725628626561
                    ],
                    [
                        122.07266047597,
                        0.48729785900185
                    ],
                    [
                        122.07263231277,
                        0.48730992850587
                    ],
                    [
                        122.07263231277,
                        0.48730992850587
                    ],
                    [
                        122.07263231277,
                        0.48730992850587
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1988,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.000368410192290581,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57478615642,
                        0.54539676138716
                    ],
                    [
                        121.57447233796,
                        0.5453940798924
                    ],
                    [
                        121.57448574901,
                        0.54534313149152
                    ],
                    [
                        121.57448709011,
                        0.54534179074413
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1989,
                "jenis_pipa": "Pipa 150",
                "keterangan": "JDU",
                "panjang": 0.019095642163075438,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07157954574,
                        0.49918228673991
                    ],
                    [
                        122.07158625126,
                        0.49909780036198
                    ],
                    [
                        122.07166135311,
                        0.49851175990115
                    ],
                    [
                        122.07171365619,
                        0.49818320172523
                    ],
                    [
                        122.07176864147,
                        0.49773663079047
                    ],
                    [
                        122.07181423903,
                        0.49741343679178
                    ],
                    [
                        122.07189872861,
                        0.49684751199251
                    ],
                    [
                        122.0719845593,
                        0.49634193458343
                    ],
                    [
                        122.07208648324,
                        0.49596241623768
                    ],
                    [
                        122.0721924305,
                        0.49558960314189
                    ],
                    [
                        122.07242578268,
                        0.49488152641296
                    ],
                    [
                        122.07264438272,
                        0.49422575073866
                    ],
                    [
                        122.07293003798,
                        0.49341977686621
                    ],
                    [
                        122.07315266132,
                        0.4927425441691
                    ],
                    [
                        122.07332566381,
                        0.49219673479678
                    ],
                    [
                        122.0734423399,
                        0.4917863719469
                    ],
                    [
                        122.07351744175,
                        0.49148463454118
                    ],
                    [
                        122.07360863686,
                        0.49112657280204
                    ],
                    [
                        122.07369580865,
                        0.49079130898396
                    ],
                    [
                        122.07378566265,
                        0.49046677359206
                    ],
                    [
                        122.07390770316,
                        0.49000276841761
                    ],
                    [
                        122.07403510809,
                        0.48950791893315
                    ],
                    [
                        122.07415178418,
                        0.489076099028
                    ],
                    [
                        122.07421079278,
                        0.48882934478401
                    ],
                    [
                        122.07434892654,
                        0.48831706148765
                    ],
                    [
                        122.07450181246,
                        0.48772967902125
                    ],
                    [
                        122.07458630204,
                        0.48740916664925
                    ],
                    [
                        122.07464531064,
                        0.48710877010265
                    ],
                    [
                        122.07477137446,
                        0.48662062568588
                    ],
                    [
                        122.07486525178,
                        0.48626390474358
                    ],
                    [
                        122.07495108247,
                        0.48592864068288
                    ],
                    [
                        122.07506105304,
                        0.48547536364637
                    ],
                    [
                        122.07519248128,
                        0.48497783171629
                    ],
                    [
                        122.07531452179,
                        0.48447895869308
                    ],
                    [
                        122.07543924451,
                        0.48402836367278
                    ],
                    [
                        122.07553714514,
                        0.48360593081409
                    ],
                    [
                        122.07563236356,
                        0.48320629589499
                    ],
                    [
                        122.07575306296,
                        0.4828012967248
                    ],
                    [
                        122.07585096359,
                        0.48237752273282
                    ],
                    [
                        122.07593947649,
                        0.48201677839607
                    ],
                    [
                        122.07600519061,
                        0.48173917958117
                    ],
                    [
                        122.07611113787,
                        0.48133418032368
                    ],
                    [
                        122.07628816366,
                        0.48071461187664
                    ],
                    [
                        122.07628816366,
                        0.4807065655328
                    ],
                    [
                        122.07628816366,
                        0.4807065655328
                    ],
                    [
                        122.07628816366,
                        0.4807065655328
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1993,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0004839738002581647,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.58056497574,
                        0.54071323525704
                    ],
                    [
                        121.58009693027,
                        0.54061401987283
                    ],
                    [
                        121.58009558916,
                        0.54061938286661
                    ],
                    [
                        121.58009558916,
                        0.54061938286661
                    ],
                    [
                        121.58009558916,
                        0.54061938286661
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1994,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0004249737929746067,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.58008754253,
                        0.54060747675963
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1995,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0004249737929746067,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.58008754253,
                        0.54060747675963
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ],
                    [
                        121.57968252897,
                        0.54047876490729
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1996,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0012642184105926383,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07364618778,
                        0.49097369250309
                    ],
                    [
                        122.07345709205,
                        0.4909441892871
                    ],
                    [
                        122.07321569324,
                        0.49088518285472
                    ],
                    [
                        122.07277446985,
                        0.49076448787779
                    ],
                    [
                        122.07242444158,
                        0.49065452134134
                    ],
                    [
                        122.07242444158,
                        0.49065452134134
                    ],
                    [
                        122.07242444158,
                        0.49065452134134
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1997,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDB",
                "panjang": 0.003099436088807553,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0724016428,
                        0.49065318028601
                    ],
                    [
                        122.07211598754,
                        0.49057271696553
                    ],
                    [
                        122.07151517272,
                        0.49041715454314
                    ],
                    [
                        122.07043021917,
                        0.49011944024195
                    ],
                    [
                        122.07005336881,
                        0.49000947369494
                    ],
                    [
                        122.0694257319,
                        0.48982709014953
                    ],
                    [
                        122.06943511963,
                        0.48982172592754
                    ],
                    [
                        122.06943511963,
                        0.48982172592754
                    ],
                    [
                        122.06943511963,
                        0.48982172592754
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1998,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDB",
                "panjang": 0.005853130382716121,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07360729575,
                        0.49107158953702
                    ],
                    [
                        122.07354158163,
                        0.49104342737671
                    ],
                    [
                        122.07336992025,
                        0.49099514938734
                    ],
                    [
                        122.07305878401,
                        0.49090932184985
                    ],
                    [
                        122.07259610295,
                        0.49078996792865
                    ],
                    [
                        122.07193493843,
                        0.49061697179192
                    ],
                    [
                        122.07151249051,
                        0.49049493575477
                    ],
                    [
                        122.07082182169,
                        0.49030048272399
                    ],
                    [
                        122.07043290138,
                        0.49019185723535
                    ],
                    [
                        122.07010567188,
                        0.49010334757665
                    ],
                    [
                        122.06955313683,
                        0.48994778514336
                    ],
                    [
                        122.06890538335,
                        0.48977210687385
                    ],
                    [
                        122.0684453845,
                        0.48967823298748
                    ],
                    [
                        122.06797197461,
                        0.48958435909981
                    ],
                    [
                        122.06795454025,
                        0.48957094854432
                    ],
                    [
                        122.06795454025,
                        0.48957094854432
                    ],
                    [
                        122.06795454025,
                        0.48957094854432
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 1999,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 4.2123623108507544e-5,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57464802265,
                        0.545275091228
                    ],
                    [
                        121.57464265823,
                        0.54531129140802
                    ],
                    [
                        121.57464399934,
                        0.54531665439762
                    ],
                    [
                        121.57464399934,
                        0.54531665439762
                    ],
                    [
                        121.57464399934,
                        0.54531665439762
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2001,
                "jenis_pipa": "Pipa 150",
                "keterangan": "Distribusi",
                "panjang": 0.00043953078016701036,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57297566533,
                        0.5435725065516
                    ],
                    [
                        121.5729957819,
                        0.54348133570111
                    ],
                    [
                        121.57303467393,
                        0.54315397036104
                    ],
                    [
                        121.57303467393,
                        0.54316357846148
                    ],
                    [
                        121.57303467393,
                        0.54316357846148
                    ],
                    [
                        121.57303467393,
                        0.54316357846148
                    ],
                    [
                        121.57302796841,
                        0.54316198876838
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2080,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0022605726575218553,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09373995662,
                        0.56334198817098
                    ],
                    [
                        122.09373190999,
                        0.56339026559943
                    ],
                    [
                        122.09415704012,
                        0.56337685520268
                    ],
                    [
                        122.09417849779,
                        0.563375514163
                    ],
                    [
                        122.09418654442,
                        0.56352034644631
                    ],
                    [
                        122.09420934319,
                        0.56381537516041
                    ],
                    [
                        122.09422141314,
                        0.56411174489907
                    ],
                    [
                        122.09421873093,
                        0.56427401067721
                    ],
                    [
                        122.09419459105,
                        0.56453685440737
                    ],
                    [
                        122.09417447448,
                        0.56489893503661
                    ],
                    [
                        122.09415301681,
                        0.56513629899243
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2003,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0004971081138881847,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.570854038,
                        0.53352486020759
                    ],
                    [
                        121.57082721591,
                        0.53357446795743
                    ],
                    [
                        121.5708231926,
                        0.53361737195697
                    ],
                    [
                        121.57084330916,
                        0.53379435095191
                    ],
                    [
                        121.57085135579,
                        0.53395524094289
                    ],
                    [
                        121.57086074352,
                        0.53401289318865
                    ],
                    [
                        121.57086074352,
                        0.53401289318865
                    ],
                    [
                        121.57086074352,
                        0.53401289318865
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2079,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.013397754914729708,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08572283387,
                        0.57170202353819
                    ],
                    [
                        122.08563566208,
                        0.57131312257858
                    ],
                    [
                        122.08577379584,
                        0.57114549284648
                    ],
                    [
                        122.08604201674,
                        0.57084241827845
                    ],
                    [
                        122.08632230759,
                        0.57057018756876
                    ],
                    [
                        122.08669111133,
                        0.57026308985617
                    ],
                    [
                        122.08695799112,
                        0.57012764500829
                    ],
                    [
                        122.08853781223,
                        0.56946651318036
                    ],
                    [
                        122.09007203579,
                        0.56901592430489
                    ],
                    [
                        122.09047973156,
                        0.56891400538769
                    ],
                    [
                        122.09168672562,
                        0.56866725431757
                    ],
                    [
                        122.09200322628,
                        0.56864043354844
                    ],
                    [
                        122.09249675274,
                        0.56835076923392
                    ],
                    [
                        122.0924860239,
                        0.56807719736798
                    ],
                    [
                        122.09245383739,
                        0.56663423966482
                    ],
                    [
                        122.09255576134,
                        0.56595299185103
                    ],
                    [
                        122.09281861782,
                        0.56493380205898
                    ],
                    [
                        122.09329336882,
                        0.56382878555616
                    ],
                    [
                        122.09335505962,
                        0.56365579144873
                    ],
                    [
                        122.09342211485,
                        0.56348011525686
                    ],
                    [
                        122.09343552589,
                        0.56315960677102
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2006,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.001671916851400627,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57030150294,
                        0.54039956324311
                    ],
                    [
                        121.5697234869,
                        0.54032984432105
                    ],
                    [
                        121.56917363405,
                        0.5402507401585
                    ],
                    [
                        121.56864255667,
                        0.54019308797162
                    ],
                    [
                        121.56864255667,
                        0.54019308797162
                    ],
                    [
                        121.56864255667,
                        0.54019308797162
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2009,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0007374398378743484,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10824936628,
                        0.55590055423063
                    ],
                    [
                        122.10835933685,
                        0.55603599940906
                    ],
                    [
                        122.10843041539,
                        0.5561124387658
                    ],
                    [
                        122.10849478841,
                        0.55615937521242
                    ],
                    [
                        122.10854575038,
                        0.55617546770833
                    ],
                    [
                        122.10863828659,
                        0.55620228853474
                    ],
                    [
                        122.10875228047,
                        0.5561794908323
                    ],
                    [
                        122.10884615779,
                        0.55615803417111
                    ],
                    [
                        122.10886225104,
                        0.55615401104711
                    ],
                    [
                        122.10886225104,
                        0.55615401104711
                    ],
                    [
                        122.10886225104,
                        0.55615401104711
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2008,
                "jenis_pipa": "Pipa 25",
                "keterangan": "Distribusi",
                "panjang": 0.00159966036224092,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.57018750906,
                        0.53895027974167
                    ],
                    [
                        121.57026529312,
                        0.53977349945712
                    ],
                    [
                        121.56949281693,
                        0.53979495143518
                    ],
                    [
                        121.56949281693,
                        0.53979495143518
                    ],
                    [
                        121.56949281693,
                        0.53979495143518
                    ],
                    [
                        121.56949281693,
                        0.53979495143518
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2010,
                "jenis_pipa": "Pipa 100",
                "keterangan": "JDU",
                "panjang": 0.00046130942120284097,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0184288919,
                        0.47708839196208
                    ],
                    [
                        122.01847985387,
                        0.4768952796052
                    ],
                    [
                        122.01851740479,
                        0.47669277983628
                    ],
                    [
                        122.01853215694,
                        0.47663913751239
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2011,
                "jenis_pipa": "Pipa 75",
                "keterangan": "JDU",
                "panjang": 0.0006799672200926267,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01853215694,
                        0.47663779645428
                    ],
                    [
                        122.01857641339,
                        0.47648089265449
                    ],
                    [
                        122.01862871647,
                        0.4762958266296
                    ],
                    [
                        122.01869174838,
                        0.47599945276781
                    ],
                    [
                        122.01869443059,
                        0.47597799583613
                    ],
                    [
                        122.01869443059,
                        0.47597799583613
                    ],
                    [
                        122.01869443059,
                        0.47597799583613
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2012,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.011518205385973977,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10886895657,
                        0.5561486468818
                    ],
                    [
                        122.10895612836,
                        0.5561486468818
                    ],
                    [
                        122.10901781917,
                        0.55615401104711
                    ],
                    [
                        122.10905268788,
                        0.55617278562569
                    ],
                    [
                        122.10911974311,
                        0.55622240415446
                    ],
                    [
                        122.10918813944,
                        0.55626129435241
                    ],
                    [
                        122.10930347443,
                        0.5563189591282
                    ],
                    [
                        122.10945233703,
                        0.5563779649447
                    ],
                    [
                        122.10954889655,
                        0.55643831180186
                    ],
                    [
                        122.10966825485,
                        0.55654023093701
                    ],
                    [
                        122.10976079106,
                        0.55665690152378
                    ],
                    [
                        122.10986942053,
                        0.55676418481993
                    ],
                    [
                        122.11000487208,
                        0.55690097101968
                    ],
                    [
                        122.11011350155,
                        0.55699350285888
                    ],
                    [
                        122.11022883654,
                        0.55711821968334
                    ],
                    [
                        122.11036428809,
                        0.55726171108025
                    ],
                    [
                        122.11045950651,
                        0.55737435852958
                    ],
                    [
                        122.11058288813,
                        0.55751919096128
                    ],
                    [
                        122.11071699858,
                        0.55768816212708
                    ],
                    [
                        122.11083233356,
                        0.55782494830537
                    ],
                    [
                        122.11130440235,
                        0.55842707566022
                    ],
                    [
                        122.11153641343,
                        0.55870601214224
                    ],
                    [
                        122.11170136929,
                        0.55890985033226
                    ],
                    [
                        122.11177378893,
                        0.55899567693648
                    ],
                    [
                        122.11185827851,
                        0.55908418562077
                    ],
                    [
                        122.11193472147,
                        0.55915660181599
                    ],
                    [
                        122.11207821965,
                        0.55928131859458
                    ],
                    [
                        122.11216270924,
                        0.55935641686857
                    ],
                    [
                        122.1122418344,
                        0.55942883306046
                    ],
                    [
                        122.1123316884,
                        0.5595173417382
                    ],
                    [
                        122.11240410805,
                        0.55957232440097
                    ],
                    [
                        122.11252614856,
                        0.55965010475233
                    ],
                    [
                        122.11269244552,
                        0.55973995446724
                    ],
                    [
                        122.11286947131,
                        0.55986467123343
                    ],
                    [
                        122.11295261979,
                        0.55993842845949
                    ],
                    [
                        122.11301699281,
                        0.56002291400821
                    ],
                    [
                        122.11316853762,
                        0.56028844001054
                    ],
                    [
                        122.11337372661,
                        0.5606773417094
                    ],
                    [
                        122.11354002357,
                        0.56099919137168
                    ],
                    [
                        122.11367949843,
                        0.56124594276745
                    ],
                    [
                        122.11380422115,
                        0.56152085599503
                    ],
                    [
                        122.11389139295,
                        0.56173408136752
                    ],
                    [
                        122.11394503713,
                        0.56182795417055
                    ],
                    [
                        122.11406439543,
                        0.5620773876113
                    ],
                    [
                        122.11413145065,
                        0.56221551472711
                    ],
                    [
                        122.11420789361,
                        0.56240996551569
                    ],
                    [
                        122.11430311203,
                        0.5626607399714
                    ],
                    [
                        122.11435005069,
                        0.56281361851131
                    ],
                    [
                        122.11438760161,
                        0.56292626585392
                    ],
                    [
                        122.11441576481,
                        0.56299063576303
                    ],
                    [
                        122.11446270347,
                        0.56305902879066
                    ],
                    [
                        122.11448282003,
                        0.56308987270483
                    ],
                    [
                        122.11452171206,
                        0.56310864726119
                    ],
                    [
                        122.11455792189,
                        0.56310730622145
                    ],
                    [
                        122.11460888386,
                        0.56309255478431
                    ],
                    [
                        122.11464643478,
                        0.56307378022789
                    ],
                    [
                        122.11470812559,
                        0.56305634671116
                    ],
                    [
                        122.11475506425,
                        0.56305902879066
                    ],
                    [
                        122.11483821273,
                        0.56307243918815
                    ],
                    [
                        122.11486637592,
                        0.56308182646637
                    ],
                    [
                        122.11492672563,
                        0.56309389582405
                    ],
                    [
                        122.11496561766,
                        0.56309791894327
                    ],
                    [
                        122.11500182748,
                        0.56308987270483
                    ],
                    [
                        122.11510643363,
                        0.56305232359191
                    ],
                    [
                        122.1152472496,
                        0.5630067282402
                    ],
                    [
                        122.1153639257,
                        0.56297454328582
                    ],
                    [
                        122.11551949382,
                        0.56293163001305
                    ],
                    [
                        122.11564958096,
                        0.56290883233676
                    ],
                    [
                        122.11591511965,
                        0.56283105202875
                    ],
                    [
                        122.11608678102,
                        0.56279886707341
                    ],
                    [
                        122.11626648903,
                        0.5627747283568
                    ],
                    [
                        122.11646229029,
                        0.56276936419753
                    ],
                    [
                        122.11671978235,
                        0.56275327171971
                    ],
                    [
                        122.11676001549,
                        0.56274522548079
                    ],
                    [
                        122.11676001549,
                        0.56274522548079
                    ],
                    [
                        122.11676001549,
                        0.56274522548079
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2013,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0011978365683120809,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11447477341,
                        0.56308450854586
                    ],
                    [
                        122.11445197463,
                        0.56319045068465
                    ],
                    [
                        122.11442649364,
                        0.56330443905969
                    ],
                    [
                        122.11438089609,
                        0.56346134070169
                    ],
                    [
                        122.11435809731,
                        0.56354850827876
                    ],
                    [
                        122.11431384087,
                        0.56378989540842
                    ],
                    [
                        122.11420118809,
                        0.56423646157191
                    ],
                    [
                        122.11419582367,
                        0.56424853092721
                    ],
                    [
                        122.11419582367,
                        0.56424853092721
                    ],
                    [
                        122.11419582367,
                        0.56424853092721
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2014,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDB",
                "panjang": 0.007611515110273857,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01869174838,
                        0.47597933689436
                    ],
                    [
                        122.01875478029,
                        0.47570039677669
                    ],
                    [
                        122.01882585883,
                        0.47535708584719
                    ],
                    [
                        122.01889425516,
                        0.47503791395207
                    ],
                    [
                        122.01897472143,
                        0.47467582817088
                    ],
                    [
                        122.01904043555,
                        0.47429630860949
                    ],
                    [
                        122.01913163066,
                        0.47379743480811
                    ],
                    [
                        122.01917722821,
                        0.47341657413986
                    ],
                    [
                        122.01922014356,
                        0.47300486909819
                    ],
                    [
                        122.01924294233,
                        0.47263071368082
                    ],
                    [
                        122.0192335546,
                        0.47221498541567
                    ],
                    [
                        122.01921209693,
                        0.47167319757473
                    ],
                    [
                        122.01921612024,
                        0.47134061491881
                    ],
                    [
                        122.0192322135,
                        0.47019400926966
                    ],
                    [
                        122.01921075583,
                        0.46988288349377
                    ],
                    [
                        122.01922684908,
                        0.46972195636287
                    ],
                    [
                        122.01921612024,
                        0.46942155904193
                    ],
                    [
                        122.01921343803,
                        0.46900046634712
                    ],
                    [
                        122.01919332147,
                        0.46870811535302
                    ],
                    [
                        122.01918393373,
                        0.4684305160033
                    ],
                    [
                        122.01918259263,
                        0.46842112858549
                    ],
                    [
                        122.01918259263,
                        0.46842112858549
                    ],
                    [
                        122.01918259263,
                        0.46842112858549
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2015,
                "jenis_pipa": "Pipa 50",
                "keterangan": "JDB",
                "panjang": 0.00928118144463925,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01919198036,
                        0.46985606230554
                    ],
                    [
                        122.01907530427,
                        0.46984667488963
                    ],
                    [
                        122.01883926988,
                        0.46988288349377
                    ],
                    [
                        122.01849326491,
                        0.46994189010751
                    ],
                    [
                        122.01812446117,
                        0.46999955566136
                    ],
                    [
                        122.01787501574,
                        0.47006660863035
                    ],
                    [
                        122.01763361692,
                        0.47009745299587
                    ],
                    [
                        122.0174176991,
                        0.47012829736125
                    ],
                    [
                        122.01705694199,
                        0.47014170795485
                    ],
                    [
                        122.0167927444,
                        0.47016450596393
                    ],
                    [
                        122.01643064618,
                        0.47016450596393
                    ],
                    [
                        122.0161677897,
                        0.47013634371742
                    ],
                    [
                        122.01587542892,
                        0.4700827013428
                    ],
                    [
                        122.01549991965,
                        0.47002905896779
                    ],
                    [
                        122.01506942511,
                        0.46997675765175
                    ],
                    [
                        122.0147690177,
                        0.46993518481051
                    ],
                    [
                        122.01429829001,
                        0.46989897620666
                    ],
                    [
                        122.01377660036,
                        0.46984801594905
                    ],
                    [
                        122.01346948743,
                        0.4698091252259
                    ],
                    [
                        122.01322138309,
                        0.4697447543733
                    ],
                    [
                        122.0127761364,
                        0.46963612855821
                    ],
                    [
                        122.01253607869,
                        0.46957309876349
                    ],
                    [
                        122.01210156083,
                        0.46941217162545
                    ],
                    [
                        122.01167374849,
                        0.46924185706699
                    ],
                    [
                        122.01129555702,
                        0.46907690674266
                    ],
                    [
                        122.01104074717,
                        0.46893877760627
                    ],
                    [
                        122.01071485877,
                        0.46880601270562
                    ],
                    [
                        122.01017439365,
                        0.46863033389383
                    ],
                    [
                        122.01017439365,
                        0.46863033389383
                    ],
                    [
                        122.01017439365,
                        0.46863033389383
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2016,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 5.2370790839476725e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01017305255,
                        0.46862228753594
                    ],
                    [
                        122.01019182801,
                        0.46857937362699
                    ],
                    [
                        122.01019048691,
                        0.46857400938836
                    ],
                    [
                        122.01019048691,
                        0.46857400938836
                    ],
                    [
                        122.01019048691,
                        0.46857400938836
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2017,
                "jenis_pipa": "Pipa 40",
                "keterangan": "JDB",
                "panjang": 0.01678565277344848,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01019451022,
                        0.46857803256732
                    ],
                    [
                        122.01052442193,
                        0.46869470475668
                    ],
                    [
                        122.01079666615,
                        0.46879394316908
                    ],
                    [
                        122.01103135943,
                        0.46887708886487
                    ],
                    [
                        122.01129958034,
                        0.46900583058544
                    ],
                    [
                        122.01162546873,
                        0.46915871137553
                    ],
                    [
                        122.0118239522,
                        0.46924453918606
                    ],
                    [
                        122.01195940375,
                        0.46929952262662
                    ],
                    [
                        122.01216727495,
                        0.46938132725689
                    ],
                    [
                        122.01249852777,
                        0.46951543320611
                    ],
                    [
                        122.01264604926,
                        0.46955968816879
                    ],
                    [
                        122.01310202479,
                        0.4696803835201
                    ],
                    [
                        122.0133729279,
                        0.46974743649218
                    ],
                    [
                        122.01361700892,
                        0.46978096297796
                    ],
                    [
                        122.01387584209,
                        0.4698091252259
                    ],
                    [
                        122.01434522867,
                        0.46985874442436
                    ],
                    [
                        122.01460674405,
                        0.46988288349377
                    ],
                    [
                        122.01489642262,
                        0.46990836362249
                    ],
                    [
                        122.01520755887,
                        0.46995127752327
                    ],
                    [
                        122.01563671231,
                        0.47000760201767
                    ],
                    [
                        122.01594382524,
                        0.47005185697722
                    ],
                    [
                        122.01615303755,
                        0.47009879405524
                    ],
                    [
                        122.01652318239,
                        0.47012695630189
                    ],
                    [
                        122.01676860452,
                        0.47010952253016
                    ],
                    [
                        122.01703414321,
                        0.47009745299587
                    ],
                    [
                        122.01740697026,
                        0.4700786781647
                    ],
                    [
                        122.01767519116,
                        0.47004515168033
                    ],
                    [
                        122.01792195439,
                        0.47000491989889
                    ],
                    [
                        122.01823174953,
                        0.46993116163231
                    ],
                    [
                        122.01852142811,
                        0.46989227090962
                    ],
                    [
                        122.01870918274,
                        0.46985874442436
                    ],
                    [
                        122.01900959015,
                        0.46981180734474
                    ],
                    [
                        122.01912492514,
                        0.46981180734474
                    ],
                    [
                        122.01919868588,
                        0.46981851264186
                    ],
                    [
                        122.0192322135,
                        0.46984399277081
                    ],
                    [
                        122.01924964786,
                        0.4698748371373
                    ],
                    [
                        122.0192617178,
                        0.46996066493904
                    ],
                    [
                        122.01927378774,
                        0.47057218799584
                    ],
                    [
                        122.01927244663,
                        0.47097718788552
                    ],
                    [
                        122.01926976442,
                        0.47124942289748
                    ],
                    [
                        122.01928183436,
                        0.47175232005908
                    ],
                    [
                        122.01929524541,
                        0.47234238601569
                    ],
                    [
                        122.01929792762,
                        0.47262803156305
                    ],
                    [
                        122.01927378774,
                        0.47307192203822
                    ],
                    [
                        122.01922282577,
                        0.47351715354372
                    ],
                    [
                        122.0191450417,
                        0.47410721935029
                    ],
                    [
                        122.01904177666,
                        0.4746637586445
                    ],
                    [
                        122.01893314719,
                        0.47514788074113
                    ],
                    [
                        122.01887816191,
                        0.47545498310617
                    ],
                    [
                        122.01876685023,
                        0.47595385678793
                    ],
                    [
                        122.01869979501,
                        0.47625961805892
                    ],
                    [
                        122.01860994101,
                        0.47660292894352
                    ],
                    [
                        122.01853752136,
                        0.47688991537299
                    ],
                    [
                        122.01849728823,
                        0.47707900455596
                    ],
                    [
                        122.01848119497,
                        0.47723188516816
                    ],
                    [
                        122.01848119497,
                        0.47723188516816
                    ],
                    [
                        122.01848119497,
                        0.47723188516816
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2018,
                "jenis_pipa": "Pipa 200",
                "keterangan": "",
                "panjang": 0.011734888037951268,
                "total_panjang_jenis": 0.24221867768992125
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09360182285,
                        0.56327895930547
                    ],
                    [
                        122.09363132715,
                        0.56332187257568
                    ],
                    [
                        122.09422141314,
                        0.56330175698031
                    ],
                    [
                        122.09419459105,
                        0.56314083221482
                    ],
                    [
                        122.09417313337,
                        0.56292224273458
                    ],
                    [
                        122.09414228797,
                        0.56268219660882
                    ],
                    [
                        122.0941221714,
                        0.56252261286611
                    ],
                    [
                        122.09411546588,
                        0.56243276319392
                    ],
                    [
                        122.09409400821,
                        0.5622973181631
                    ],
                    [
                        122.09406852722,
                        0.56209482113094
                    ],
                    [
                        122.09404438734,
                        0.56194194257221
                    ],
                    [
                        122.09404170513,
                        0.56185611601118
                    ],
                    [
                        122.09404170513,
                        0.56173139928741
                    ],
                    [
                        122.09406048059,
                        0.56159461320023
                    ],
                    [
                        122.09408730268,
                        0.56149537623302
                    ],
                    [
                        122.09411948919,
                        0.5613907751036
                    ],
                    [
                        122.09416240454,
                        0.56125801212892
                    ],
                    [
                        122.09420800209,
                        0.56112927227183
                    ],
                    [
                        122.09427773952,
                        0.56097907576831
                    ],
                    [
                        122.09434881806,
                        0.56073500644187
                    ],
                    [
                        122.09439709783,
                        0.56060626657326
                    ],
                    [
                        122.09445208311,
                        0.56047216254045
                    ],
                    [
                        122.09448829293,
                        0.56033939954496
                    ],
                    [
                        122.09449231625,
                        0.56023613943528
                    ],
                    [
                        122.09448695183,
                        0.56004705273619
                    ],
                    [
                        122.09443733096,
                        0.55977750360142
                    ],
                    [
                        122.09438636899,
                        0.55943419722279
                    ],
                    [
                        122.09436491132,
                        0.55926522610717
                    ],
                    [
                        122.09433808923,
                        0.55910564227129
                    ],
                    [
                        122.0943287015,
                        0.55898092548896
                    ],
                    [
                        122.0943287015,
                        0.55885754974472
                    ],
                    [
                        122.09437295794,
                        0.55875831273115
                    ],
                    [
                        122.09440246224,
                        0.55870064797926
                    ],
                    [
                        122.09446951747,
                        0.55860677512612
                    ],
                    [
                        122.09455668926,
                        0.55850217394516
                    ],
                    [
                        122.09472298622,
                        0.5582889484551
                    ],
                    [
                        122.09483027458,
                        0.55816691373719
                    ],
                    [
                        122.09496036172,
                        0.55803415068954
                    ],
                    [
                        122.09508374333,
                        0.5578732257793
                    ],
                    [
                        122.09520712495,
                        0.55772571127438
                    ],
                    [
                        122.09529563785,
                        0.55759563029879
                    ],
                    [
                        122.09536939859,
                        0.55743872849966
                    ],
                    [
                        122.0954297483,
                        0.55725902899809
                    ],
                    [
                        122.09548473358,
                        0.55710883239557
                    ],
                    [
                        122.09555983543,
                        0.55697472828292
                    ],
                    [
                        122.09563493729,
                        0.55682050854962
                    ],
                    [
                        122.09571540356,
                        0.55665153735893
                    ],
                    [
                        122.09577307105,
                        0.55650536386465
                    ],
                    [
                        122.09582537413,
                        0.55633236954109
                    ],
                    [
                        122.09585353732,
                        0.55615401104711
                    ],
                    [
                        122.09584549069,
                        0.55598638087871
                    ],
                    [
                        122.09580793977,
                        0.55580131716726
                    ],
                    [
                        122.09575295448,
                        0.55564575636184
                    ],
                    [
                        122.09570869803,
                        0.55555188346003
                    ],
                    [
                        122.09562554955,
                        0.55537620702551
                    ],
                    [
                        122.09553569555,
                        0.55516700454706
                    ],
                    [
                        122.09550350904,
                        0.5550409466398
                    ],
                    [
                        122.09546998143,
                        0.55490281935536
                    ],
                    [
                        122.09543377161,
                        0.55474859956794
                    ],
                    [
                        122.09538146853,
                        0.55453269185881
                    ],
                    [
                        122.09535866976,
                        0.55436372060269
                    ],
                    [
                        122.09533452988,
                        0.55418133892401
                    ],
                    [
                        122.0953130722,
                        0.55400298036517
                    ],
                    [
                        122.09530770779,
                        0.55390240222811
                    ],
                    [
                        122.0952822268,
                        0.55371867949334
                    ],
                    [
                        122.09523931146,
                        0.55357518801043
                    ],
                    [
                        122.09488660097,
                        0.55293685202559
                    ],
                    [
                        122.09488660097,
                        0.55293685202559
                    ],
                    [
                        122.09488660097,
                        0.55293685202559
                    ],
                    [
                        122.09488660097,
                        0.55293685202559
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2019,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.028057559558193144,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09488794208,
                        0.55293416994147
                    ],
                    [
                        122.09479540586,
                        0.5527638575977
                    ],
                    [
                        122.09466531873,
                        0.55255867815346
                    ],
                    [
                        122.09453657269,
                        0.55234008828021
                    ],
                    [
                        122.09442660213,
                        0.552179163215
                    ],
                    [
                        122.09431126714,
                        0.5519672785392
                    ],
                    [
                        122.0941503346,
                        0.55168700069694
                    ],
                    [
                        122.09395855665,
                        0.55137990199337
                    ],
                    [
                        122.09381639957,
                        0.55118410979854
                    ],
                    [
                        122.09365010262,
                        0.55094406319473
                    ],
                    [
                        122.09357902408,
                        0.55078850226196
                    ],
                    [
                        122.09348917007,
                        0.55058734587735
                    ],
                    [
                        122.09343418479,
                        0.55039155365648
                    ],
                    [
                        122.09334969521,
                        0.55015687119149
                    ],
                    [
                        122.09326520562,
                        0.54994230435829
                    ],
                    [
                        122.09315657616,
                        0.54964325182163
                    ],
                    [
                        122.0930506289,
                        0.54936297387011
                    ],
                    [
                        122.09299430251,
                        0.54916047639455
                    ],
                    [
                        122.09287360311,
                        0.54879839479865
                    ],
                    [
                        122.09279179573,
                        0.54853823245324
                    ],
                    [
                        122.09271132946,
                        0.54829550365688
                    ],
                    [
                        122.09265366197,
                        0.54812250909434
                    ],
                    [
                        122.09255039692,
                        0.54781809229386
                    ],
                    [
                        122.09249272943,
                        0.54765448502027
                    ],
                    [
                        122.09241092205,
                        0.54744394122717
                    ],
                    [
                        122.0923653245,
                        0.54732190628637
                    ],
                    [
                        122.09232509136,
                        0.54724948994672
                    ],
                    [
                        122.09190398455,
                        0.54664199728514
                    ],
                    [
                        122.09183827043,
                        0.54658969658954
                    ],
                    [
                        122.09171354771,
                        0.54650789293656
                    ],
                    [
                        122.09147751331,
                        0.54638719902028
                    ],
                    [
                        122.09125488997,
                        0.54628930284195
                    ],
                    [
                        122.090998739,
                        0.54616324474695
                    ],
                    [
                        122.0908203721,
                        0.54608412317535
                    ],
                    [
                        122.09070637822,
                        0.54603986873654
                    ],
                    [
                        122.09064200521,
                        0.5460157299516
                    ],
                    [
                        122.09048375487,
                        0.54596342925056
                    ],
                    [
                        122.09038719535,
                        0.54592453898539
                    ],
                    [
                        122.09029197693,
                        0.54588967185088
                    ],
                    [
                        122.09015518427,
                        0.54582530175587
                    ],
                    [
                        122.09006130695,
                        0.54578507044614
                    ],
                    [
                        122.08998218179,
                        0.54571801826266
                    ],
                    [
                        122.08991780877,
                        0.54565498920951
                    ],
                    [
                        122.08986282349,
                        0.54557184450009
                    ],
                    [
                        122.08980917931,
                        0.54541226029652
                    ],
                    [
                        122.08970859647,
                        0.5451011381396
                    ],
                    [
                        122.08963751793,
                        0.54481415475646
                    ],
                    [
                        122.08956375718,
                        0.54454460493089
                    ],
                    [
                        122.08950072527,
                        0.54432065058902
                    ],
                    [
                        122.08933308721,
                        0.54371852180828
                    ],
                    [
                        122.08927676082,
                        0.54340874060816
                    ],
                    [
                        122.08920568228,
                        0.54313248549854
                    ],
                    [
                        122.08914935589,
                        0.54288707439542
                    ],
                    [
                        122.08912119269,
                        0.5427610162293
                    ],
                    [
                        122.08905547857,
                        0.54244855289129
                    ],
                    [
                        122.08899646997,
                        0.54212133804793
                    ],
                    [
                        122.08895489573,
                        0.54189470152721
                    ],
                    [
                        122.08893477917,
                        0.54173109409277
                    ],
                    [
                        122.08892270923,
                        0.54162246948223
                    ],
                    [
                        122.08893075585,
                        0.54148702397747
                    ],
                    [
                        122.08894684911,
                        0.54139851503213
                    ],
                    [
                        122.08899244666,
                        0.54113969341181
                    ],
                    [
                        122.08905413747,
                        0.54080845536348
                    ],
                    [
                        122.0890930295,
                        0.54053354118011
                    ],
                    [
                        122.08910509944,
                        0.54041821132386
                    ],
                    [
                        122.08913728595,
                        0.54019425682932
                    ],
                    [
                        122.08915740252,
                        0.53999444113559
                    ],
                    [
                        122.08917215467,
                        0.53984826723468
                    ],
                    [
                        122.08916813135,
                        0.53971282169032
                    ],
                    [
                        122.08915874362,
                        0.53958274032313
                    ],
                    [
                        122.08916813135,
                        0.53944193059259
                    ],
                    [
                        122.08919629455,
                        0.53927027682144
                    ],
                    [
                        122.08924725652,
                        0.53918176784381
                    ],
                    [
                        122.08930492401,
                        0.53911203349688
                    ],
                    [
                        122.08936259151,
                        0.53907314318767
                    ],
                    [
                        122.08948731422,
                        0.53901145511048
                    ],
                    [
                        122.08964824677,
                        0.53893233344536
                    ],
                    [
                        122.0899271965,
                        0.5387821363833
                    ],
                    [
                        122.09013640881,
                        0.5386614423129
                    ],
                    [
                        122.09026917815,
                        0.5385662281001
                    ],
                    [
                        122.09035769105,
                        0.53850856315361
                    ],
                    [
                        122.09050521255,
                        0.53838518698718
                    ],
                    [
                        122.09062457085,
                        0.53823767200231
                    ],
                    [
                        122.09070906043,
                        0.5380968622407
                    ],
                    [
                        122.09080964327,
                        0.53793593679486
                    ],
                    [
                        122.09091290832,
                        0.53772405161805
                    ],
                    [
                        122.09099069238,
                        0.53758726498101
                    ],
                    [
                        122.09109127522,
                        0.53736599247344
                    ],
                    [
                        122.09121599793,
                        0.53716617668698
                    ],
                    [
                        122.09133401513,
                        0.53696233775715
                    ],
                    [
                        122.09143191576,
                        0.53680945855532
                    ],
                    [
                        122.09149092436,
                        0.53669546967427
                    ],
                    [
                        122.09157139063,
                        0.53656672928842
                    ],
                    [
                        122.09160491824,
                        0.53653454419153
                    ],
                    [
                        122.09165453911,
                        0.5364353068084
                    ],
                    [
                        122.09168538451,
                        0.53621805739647
                    ],
                    [
                        122.09167331457,
                        0.53603701621397
                    ],
                    [
                        122.09166795015,
                        0.53585731607196
                    ],
                    [
                        122.09166392684,
                        0.53574466821906
                    ],
                    [
                        122.09165990353,
                        0.53557569643584
                    ],
                    [
                        122.09169879556,
                        0.53546170753183
                    ],
                    [
                        122.09173232317,
                        0.53535442385552
                    ],
                    [
                        122.09175780416,
                        0.53531016933849
                    ],
                    [
                        122.0917725563,
                        0.53527396109705
                    ],
                    [
                        122.09178999066,
                        0.53524043494739
                    ],
                    [
                        122.0918020606,
                        0.5351720416015
                    ],
                    [
                        122.0918007195,
                        0.53512108185309
                    ],
                    [
                        122.09180474281,
                        0.53501245712478
                    ],
                    [
                        122.09175646305,
                        0.5347831382476
                    ],
                    [
                        122.09171891212,
                        0.53461148434564
                    ],
                    [
                        122.09167063236,
                        0.53438484754584
                    ],
                    [
                        122.09161832929,
                        0.53417028015371
                    ],
                    [
                        122.09159821272,
                        0.53407506587105
                    ],
                    [
                        122.09157004952,
                        0.53394632543019
                    ],
                    [
                        122.09153115749,
                        0.53377467150484
                    ],
                    [
                        122.09151372314,
                        0.53364056687233
                    ],
                    [
                        122.0915029943,
                        0.53349036968044
                    ],
                    [
                        122.09148555994,
                        0.53333883143848
                    ],
                    [
                        122.09146946669,
                        0.53319936261073
                    ],
                    [
                        122.09145203233,
                        0.53310146622013
                    ],
                    [
                        122.09142923355,
                        0.53297674889835
                    ],
                    [
                        122.09142386913,
                        0.53289628610876
                    ],
                    [
                        122.09143057466,
                        0.53279302552725
                    ],
                    [
                        122.0914439857,
                        0.53271792692143
                    ],
                    [
                        122.09148824215,
                        0.5326455104078
                    ],
                    [
                        122.09154725075,
                        0.53260259691785
                    ],
                    [
                        122.09160760045,
                        0.53257041180019
                    ],
                    [
                        122.09173098207,
                        0.53249665423824
                    ],
                    [
                        122.09184229374,
                        0.53243228400164
                    ],
                    [
                        122.09190264344,
                        0.53238400632375
                    ],
                    [
                        122.09193885326,
                        0.53233170550561
                    ],
                    [
                        122.09195762873,
                        0.53227538154711
                    ],
                    [
                        122.09196969867,
                        0.53218419037513
                    ],
                    [
                        122.09194153547,
                        0.53208092978169
                    ],
                    [
                        122.09189191461,
                        0.53195353034584
                    ],
                    [
                        122.09176450968,
                        0.53165984111003
                    ],
                    [
                        122.09168806672,
                        0.53147879979332
                    ],
                    [
                        122.0916210115,
                        0.53127630172169
                    ],
                    [
                        122.09157004952,
                        0.53111269400333
                    ],
                    [
                        122.0915029943,
                        0.53089678545036
                    ],
                    [
                        122.09145739675,
                        0.53074256505074
                    ],
                    [
                        122.09136754274,
                        0.53048106088611
                    ],
                    [
                        122.0912642777,
                        0.5302477186991
                    ],
                    [
                        122.09116101265,
                        0.53002644592744
                    ],
                    [
                        122.09106311202,
                        0.52982797094977
                    ],
                    [
                        122.09104701877,
                        0.52979712686481
                    ],
                    [
                        122.09102287889,
                        0.52973409764729
                    ],
                    [
                        122.09101885557,
                        0.52966034005151
                    ],
                    [
                        122.09103628993,
                        0.52958792350205
                    ],
                    [
                        122.09106981754,
                        0.52950343752663
                    ],
                    [
                        122.09111005068,
                        0.52947125239283
                    ],
                    [
                        122.0913554728,
                        0.52930496253219
                    ],
                    [
                        122.09147349,
                        0.52923656912049
                    ],
                    [
                        122.09159553051,
                        0.52915074209296
                    ],
                    [
                        122.09167331457,
                        0.52910648753143
                    ],
                    [
                        122.0916813612,
                        0.52900322688662
                    ],
                    [
                        122.09168672562,
                        0.52887850948216
                    ],
                    [
                        122.09168940783,
                        0.52887985052953
                    ],
                    [
                        122.09168940783,
                        0.52887985052953
                    ],
                    [
                        122.09168940783,
                        0.52887985052953
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2020,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.0004964489346077261,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09169209003,
                        0.52887850948216
                    ],
                    [
                        122.09178060293,
                        0.52897506489228
                    ],
                    [
                        122.09182888269,
                        0.52899920374458
                    ],
                    [
                        122.09189862013,
                        0.5290407762122
                    ],
                    [
                        122.09195896983,
                        0.52905955087491
                    ],
                    [
                        122.09201931953,
                        0.52906893820624
                    ],
                    [
                        122.09207430482,
                        0.52906893820624
                    ],
                    [
                        122.09212526679,
                        0.5290716203009
                    ],
                    [
                        122.09212526679,
                        0.5290716203009
                    ],
                    [
                        122.09212526679,
                        0.5290716203009
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2021,
                "jenis_pipa": "Pipa 150",
                "keterangan": "",
                "panjang": 0.003510222488670537,
                "total_panjang_jenis": 0.4264948752808349
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09169343114,
                        0.52887985052953
                    ],
                    [
                        122.09161430597,
                        0.52877256673876
                    ],
                    [
                        122.09154456854,
                        0.52866528294616
                    ],
                    [
                        122.09146410227,
                        0.52856604543633
                    ],
                    [
                        122.09136754274,
                        0.52842657650093
                    ],
                    [
                        122.09128439426,
                        0.52831929270234
                    ],
                    [
                        122.09117174149,
                        0.52815166176333
                    ],
                    [
                        122.09103226662,
                        0.5279572098684
                    ],
                    [
                        122.09093168378,
                        0.52781371777653
                    ],
                    [
                        122.09083914757,
                        0.52767961301478
                    ],
                    [
                        122.09078148007,
                        0.5276031732993
                    ],
                    [
                        122.0906688273,
                        0.52746370434228
                    ],
                    [
                        122.0905803144,
                        0.52734435109775
                    ],
                    [
                        122.09044083953,
                        0.5271472170821
                    ],
                    [
                        122.09034830332,
                        0.52704529745252
                    ],
                    [
                        122.09025979042,
                        0.52690046429182
                    ],
                    [
                        122.09016054869,
                        0.52675965427124
                    ],
                    [
                        122.08963483572,
                        0.52603951154489
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2022,
                "jenis_pipa": "Pipa 100",
                "keterangan": "JDU",
                "panjang": 0.001940098895336531,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07158222795,
                        0.49987292931235
                    ],
                    [
                        122.07161039114,
                        0.49968652287763
                    ],
                    [
                        122.07163318992,
                        0.49939283215318
                    ],
                    [
                        122.07167342305,
                        0.49907366139667
                    ],
                    [
                        122.07171902061,
                        0.4986753684561
                    ],
                    [
                        122.07175254822,
                        0.49842190929956
                    ],
                    [
                        122.07181155682,
                        0.49796192784241
                    ],
                    [
                        122.07181826234,
                        0.49794851730382
                    ],
                    [
                        122.07181826234,
                        0.49794851730382
                    ],
                    [
                        122.07181826234,
                        0.49794851730382
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2026,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0015620683012600772,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09213465452,
                        0.52907027925357
                    ],
                    [
                        122.09227278829,
                        0.5290206605021
                    ],
                    [
                        122.09231168032,
                        0.52899652164989
                    ],
                    [
                        122.09244981408,
                        0.52891874090323
                    ],
                    [
                        122.0926335454,
                        0.5288329138713
                    ],
                    [
                        122.09271535277,
                        0.52877122569136
                    ],
                    [
                        122.09279581904,
                        0.52872294798491
                    ],
                    [
                        122.09291115403,
                        0.52863712095028
                    ],
                    [
                        122.09351062775,
                        0.52834209050969
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2027,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00010011426856025376,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09290981293,
                        0.52864248513997
                    ],
                    [
                        122.09297284484,
                        0.5287202658901
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2028,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.0006834617681537642,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09297016263,
                        0.52871892484269
                    ],
                    [
                        122.09275692701,
                        0.52883961910822
                    ],
                    [
                        122.09265097976,
                        0.52888923786114
                    ],
                    [
                        122.09251016378,
                        0.52898177012904
                    ],
                    [
                        122.09243103862,
                        0.52903675307018
                    ],
                    [
                        122.09237605333,
                        0.52905016354356
                    ],
                    [
                        122.09237605333,
                        0.52905016354356
                    ],
                    [
                        122.09237605333,
                        0.52905016354356
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2029,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.005929578566471368,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09297686815,
                        0.52871892484269
                    ],
                    [
                        122.09301844239,
                        0.52867869342033
                    ],
                    [
                        122.09311231971,
                        0.52863041571315
                    ],
                    [
                        122.09315523505,
                        0.52860225371712
                    ],
                    [
                        122.09325447679,
                        0.52854190658234
                    ],
                    [
                        122.0933483541,
                        0.52849094677919
                    ],
                    [
                        122.09339663386,
                        0.52846814897239
                    ],
                    [
                        122.09345027804,
                        0.5284453511655
                    ],
                    [
                        122.09347575903,
                        0.52844266907056
                    ],
                    [
                        122.09350928664,
                        0.52843328173828
                    ],
                    [
                        122.09353074431,
                        0.5284493743079
                    ],
                    [
                        122.09356427193,
                        0.52848960573174
                    ],
                    [
                        122.09365546703,
                        0.52862236942859
                    ],
                    [
                        122.09384188056,
                        0.52891069461904
                    ],
                    [
                        122.09405243397,
                        0.52924059226237
                    ],
                    [
                        122.09423616529,
                        0.52950880171558
                    ],
                    [
                        122.09442660213,
                        0.52981724257241
                    ],
                    [
                        122.09460765123,
                        0.53008813409488
                    ],
                    [
                        122.09472700953,
                        0.53029331429954
                    ],
                    [
                        122.09487453103,
                        0.5305320206729
                    ],
                    [
                        122.09500327706,
                        0.53072110829919
                    ],
                    [
                        122.09518969059,
                        0.53102284386108
                    ],
                    [
                        122.0953117311,
                        0.53124009345651
                    ],
                    [
                        122.09544315934,
                        0.53143990943571
                    ],
                    [
                        122.09557056427,
                        0.53162899703423
                    ],
                    [
                        122.09568858147,
                        0.53183149509431
                    ],
                    [
                        122.09580525756,
                        0.53200717221388
                    ],
                    [
                        122.0959071815,
                        0.53219894188833
                    ],
                    [
                        122.09606140852,
                        0.53244033028125
                    ],
                    [
                        122.09611773491,
                        0.53254627296183
                    ],
                    [
                        122.0962049067,
                        0.53267635447853
                    ],
                    [
                        122.09634438157,
                        0.53292847122473
                    ],
                    [
                        122.09634438157,
                        0.53292847122473
                    ],
                    [
                        122.09634438157,
                        0.53292847122473
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2030,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.004746464133649493,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07347720861,
                        0.49195132172291
                    ],
                    [
                        122.07355633378,
                        0.49165763065545
                    ],
                    [
                        122.07367569208,
                        0.49119496661887
                    ],
                    [
                        122.07378298044,
                        0.49078594476273
                    ],
                    [
                        122.07389563322,
                        0.49032730383202
                    ],
                    [
                        122.07400560379,
                        0.48987805025831
                    ],
                    [
                        122.07416251302,
                        0.48929469109527
                    ],
                    [
                        122.07424297929,
                        0.48896747351954
                    ],
                    [
                        122.07430332899,
                        0.48875424116456
                    ],
                    [
                        122.07446292043,
                        0.48812797261708
                    ],
                    [
                        122.07460105419,
                        0.48762507665884
                    ],
                    [
                        122.07463860512,
                        0.48752047429482
                    ],
                    [
                        122.0747230947,
                        0.48742525932101
                    ],
                    [
                        122.07476064563,
                        0.48743062354492
                    ],
                    [
                        122.07476064563,
                        0.48743062354492
                    ],
                    [
                        122.07476064563,
                        0.48743062354492
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2031,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.009648104876362208,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09352001548,
                        0.52833672631974
                    ],
                    [
                        122.09358170629,
                        0.52837963983927
                    ],
                    [
                        122.09361255169,
                        0.52843462278576
                    ],
                    [
                        122.09369704127,
                        0.52855129391446
                    ],
                    [
                        122.09379896522,
                        0.52870015017896
                    ],
                    [
                        122.0938834548,
                        0.52882084444485
                    ],
                    [
                        122.09400817752,
                        0.52902870678615
                    ],
                    [
                        122.09409937263,
                        0.52916012942415
                    ],
                    [
                        122.09422007203,
                        0.5293639686123
                    ],
                    [
                        122.09433540702,
                        0.52953964580196
                    ],
                    [
                        122.09445342422,
                        0.52973007450573
                    ],
                    [
                        122.09456339478,
                        0.52988429493056
                    ],
                    [
                        122.09473371506,
                        0.53015652749719
                    ],
                    [
                        122.09495231509,
                        0.53050117659147
                    ],
                    [
                        122.09508240223,
                        0.53071842620524
                    ],
                    [
                        122.09520444274,
                        0.53089812649728
                    ],
                    [
                        122.09534659982,
                        0.53111939923777
                    ],
                    [
                        122.0954887569,
                        0.53135676453241
                    ],
                    [
                        122.095579952,
                        0.53150159758905
                    ],
                    [
                        122.09577709436,
                        0.53181272044
                    ],
                    [
                        122.09585621953,
                        0.53195084825243
                    ],
                    [
                        122.09595948458,
                        0.53211177385523
                    ],
                    [
                        122.0960855484,
                        0.53232768236574
                    ],
                    [
                        122.09618210793,
                        0.53248726691212
                    ],
                    [
                        122.09627732635,
                        0.53262673575599
                    ],
                    [
                        122.09642484784,
                        0.53288019355073
                    ],
                    [
                        122.09654822946,
                        0.53308537366262
                    ],
                    [
                        122.09668770432,
                        0.53330530527826
                    ],
                    [
                        122.09678694606,
                        0.53347830026307
                    ],
                    [
                        122.09686741233,
                        0.53367006989174
                    ],
                    [
                        122.0970068872,
                        0.53387927311616
                    ],
                    [
                        122.09715843201,
                        0.53414345922916
                    ],
                    [
                        122.09722951055,
                        0.53428695117412
                    ],
                    [
                        122.09737569094,
                        0.53450822379292
                    ],
                    [
                        122.09741324186,
                        0.53457661714621
                    ],
                    [
                        122.09747359157,
                        0.53466646723663
                    ],
                    [
                        122.09751516581,
                        0.53472681431155
                    ],
                    [
                        122.09759563208,
                        0.53479654870849
                    ],
                    [
                        122.09769353271,
                        0.53487164728894
                    ],
                    [
                        122.09779545665,
                        0.53497088469739
                    ],
                    [
                        122.09794834256,
                        0.53517606473952
                    ],
                    [
                        122.09802880883,
                        0.53524848122334
                    ],
                    [
                        122.09812402725,
                        0.53536381117728
                    ],
                    [
                        122.09821790457,
                        0.53544829707238
                    ],
                    [
                        122.09827557206,
                        0.53548316426686
                    ],
                    [
                        122.09831312299,
                        0.53550730309368
                    ],
                    [
                        122.09835737944,
                        0.53550998518555
                    ],
                    [
                        122.09839358926,
                        0.53550596204776
                    ],
                    [
                        122.09842979908,
                        0.53549389263435
                    ],
                    [
                        122.09849953651,
                        0.53546707171559
                    ],
                    [
                        122.09858000278,
                        0.53541879406152
                    ],
                    [
                        122.09882676601,
                        0.53530078201666
                    ],
                    [
                        122.09901183844,
                        0.53520020356754
                    ],
                    [
                        122.0991794765,
                        0.53509828407076
                    ],
                    [
                        122.09918618202,
                        0.53509560197872
                    ],
                    [
                        122.09918618202,
                        0.53509560197872
                    ],
                    [
                        122.09918618202,
                        0.53509560197872
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2032,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002404717181272669,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0935870707,
                        0.52838366298171
                    ],
                    [
                        122.09376812057,
                        0.52826699400757
                    ],
                    [
                        122.09390223102,
                        0.52820262372698
                    ],
                    [
                        122.09408596233,
                        0.52812081982778
                    ],
                    [
                        122.09422946052,
                        0.52805376745057
                    ],
                    [
                        122.0944494009,
                        0.52794245834509
                    ],
                    [
                        122.09457948804,
                        0.52787138282319
                    ],
                    [
                        122.09473371506,
                        0.52779896625288
                    ],
                    [
                        122.09493085742,
                        0.52770777501499
                    ],
                    [
                        122.09514945745,
                        0.52762060691869
                    ],
                    [
                        122.09544584155,
                        0.52752673358286
                    ],
                    [
                        122.09578245878,
                        0.52742213186411
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2033,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0016452673011618374,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09578111768,
                        0.52742481395949
                    ],
                    [
                        122.09586426616,
                        0.52739799300569
                    ],
                    [
                        122.09587499499,
                        0.52743554234097
                    ],
                    [
                        122.09590449929,
                        0.52751466415385
                    ],
                    [
                        122.09595412016,
                        0.52759378596574
                    ],
                    [
                        122.09599032998,
                        0.52761926587104
                    ],
                    [
                        122.09603458643,
                        0.52773593701507
                    ],
                    [
                        122.09607079625,
                        0.52782578720495
                    ],
                    [
                        122.09608957171,
                        0.52787942910872
                    ],
                    [
                        122.09612309933,
                        0.52795452777326
                    ],
                    [
                        122.096144557,
                        0.52799744129543
                    ],
                    [
                        122.09618479013,
                        0.52808192729135
                    ],
                    [
                        122.09621697664,
                        0.52814495652567
                    ],
                    [
                        122.09624379873,
                        0.52819993947422
                    ],
                    [
                        122.0963524282,
                        0.52843059964334
                    ],
                    [
                        122.09640339017,
                        0.52853251925022
                    ],
                    [
                        122.09643423557,
                        0.52861968733373
                    ],
                    [
                        122.09646373987,
                        0.52872294798491
                    ],
                    [
                        122.09651604295,
                        0.52880072873403
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2034,
                "jenis_pipa": "Pipa 100",
                "keterangan": "JDU",
                "panjang": 0.026332603439310362,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.07162380219,
                        0.49930700472439
                    ],
                    [
                        122.07158222795,
                        0.49929761734929
                    ],
                    [
                        122.07159027457,
                        0.49913534986343
                    ],
                    [
                        122.0714186132,
                        0.49914741934598
                    ],
                    [
                        122.07095593214,
                        0.49917155831103
                    ],
                    [
                        122.07074806094,
                        0.49918630990074
                    ],
                    [
                        122.07017809153,
                        0.49921313097285
                    ],
                    [
                        122.06956788898,
                        0.49923995204485
                    ],
                    [
                        122.06919103861,
                        0.4992573857416
                    ],
                    [
                        122.06877663732,
                        0.49927079627752
                    ],
                    [
                        122.0684748888,
                        0.499285547867
                    ],
                    [
                        122.06836089492,
                        0.49926945522393
                    ],
                    [
                        122.06826835871,
                        0.49927884259906
                    ],
                    [
                        122.06825494766,
                        0.49919837938319
                    ],
                    [
                        122.068118155,
                        0.49852517043859
                    ],
                    [
                        122.0680578053,
                        0.49827171127626
                    ],
                    [
                        122.06799209118,
                        0.49791499095723
                    ],
                    [
                        122.06789687276,
                        0.49741075468384
                    ],
                    [
                        122.06782177091,
                        0.49704464693993
                    ],
                    [
                        122.06775605679,
                        0.49650688424633
                    ],
                    [
                        122.06771984696,
                        0.4960965216627
                    ],
                    [
                        122.06766352057,
                        0.49533882597571
                    ],
                    [
                        122.06764340401,
                        0.49499819815191
                    ],
                    [
                        122.06763669848,
                        0.49485604637775
                    ],
                    [
                        122.0676125586,
                        0.49458649442026
                    ],
                    [
                        122.0675830543,
                        0.49417479066309
                    ],
                    [
                        122.06755489111,
                        0.49379393113861
                    ],
                    [
                        122.06753745675,
                        0.49345598534511
                    ],
                    [
                        122.06750661135,
                        0.49316363539877
                    ],
                    [
                        122.06747978926,
                        0.49277472948697
                    ],
                    [
                        122.06743821502,
                        0.49233084029781
                    ],
                    [
                        122.06742882729,
                        0.49208810933898
                    ],
                    [
                        122.06742480397,
                        0.49183196782034
                    ],
                    [
                        122.06743150949,
                        0.49135723429911
                    ],
                    [
                        122.06745162606,
                        0.49100185466368
                    ],
                    [
                        122.06747978926,
                        0.49069475300124
                    ],
                    [
                        122.06753209233,
                        0.49028573111453
                    ],
                    [
                        122.06758841872,
                        0.48997326519734
                    ],
                    [
                        122.06767961383,
                        0.48955217376659
                    ],
                    [
                        122.06770375371,
                        0.48945829987715
                    ],
                    [
                        122.06748515368,
                        0.4894059987096
                    ],
                    [
                        122.06652089953,
                        0.48921288670283
                    ],
                    [
                        122.06611320376,
                        0.48913242336503
                    ],
                    [
                        122.06556603312,
                        0.48900099991123
                    ],
                    [
                        122.06509932876,
                        0.48890578495839
                    ],
                    [
                        122.0646648109,
                        0.48881325211561
                    ],
                    [
                        122.06428661942,
                        0.48873815299589
                    ],
                    [
                        122.06389635801,
                        0.48865098437374
                    ],
                    [
                        122.06331968307,
                        0.48853028935658
                    ],
                    [
                        122.06318825483,
                        0.48848603451641
                    ],
                    [
                        122.06294417381,
                        0.48838143216577
                    ],
                    [
                        122.06272020936,
                        0.4882647603112
                    ],
                    [
                        122.06222802401,
                        0.48790401628831
                    ],
                    [
                        122.06137239933,
                        0.48719862085684
                    ],
                    [
                        122.06086143851,
                        0.4867547312984
                    ],
                    [
                        122.06019759178,
                        0.48614455073988
                    ],
                    [
                        122.05833882093,
                        0.48451650827674
                    ],
                    [
                        122.0580893755,
                        0.48428584654519
                    ],
                    [
                        122.05784663558,
                        0.48415576405358
                    ],
                    [
                        122.0573477447,
                        0.48405116163585
                    ],
                    [
                        122.05649748445,
                        0.48390096328961
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2035,
                "jenis_pipa": "Pipa 75",
                "keterangan": "JDU",
                "panjang": 0.01718893044996874,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.05647736788,
                        0.48389157589286
                    ],
                    [
                        122.05613002181,
                        0.4838298872853
                    ],
                    [
                        122.05581218004,
                        0.48376819867721
                    ],
                    [
                        122.05549031496,
                        0.4837212616924
                    ],
                    [
                        122.05513492227,
                        0.48365957308332
                    ],
                    [
                        122.05409154296,
                        0.48346243774181
                    ],
                    [
                        122.05306693912,
                        0.4832773719058
                    ],
                    [
                        122.05286040902,
                        0.4832438454857
                    ],
                    [
                        122.05236956477,
                        0.48315533573582
                    ],
                    [
                        122.05155014992,
                        0.48300513736977
                    ],
                    [
                        122.0511585474,
                        0.48293942558356
                    ],
                    [
                        122.05056577921,
                        0.48282543574886
                    ],
                    [
                        122.05043435097,
                        0.48279593249723
                    ],
                    [
                        122.05027475953,
                        0.48275972396092
                    ],
                    [
                        122.04934671521,
                        0.48247541989153
                    ],
                    [
                        122.04835161567,
                        0.48216831784096
                    ],
                    [
                        122.04719424248,
                        0.48184244097739
                    ],
                    [
                        122.04643785954,
                        0.48166810355427
                    ],
                    [
                        122.04607307911,
                        0.4815876401267
                    ],
                    [
                        122.04494923353,
                        0.48135161406705
                    ],
                    [
                        122.04441010952,
                        0.48123896526297
                    ],
                    [
                        122.04363226891,
                        0.48107803839677
                    ],
                    [
                        122.04337745905,
                        0.48101098553473
                    ],
                    [
                        122.04276591539,
                        0.48082860174666
                    ],
                    [
                        122.04224288464,
                        0.48068644967315
                    ],
                    [
                        122.04197466373,
                        0.48060866834868
                    ],
                    [
                        122.04158574343,
                        0.48052820490862
                    ],
                    [
                        122.0411029458,
                        0.48044237723819
                    ],
                    [
                        122.04058259726,
                        0.48038873494362
                    ],
                    [
                        122.04029291868,
                        0.48036459591092
                    ],
                    [
                        122.03981280327,
                        0.48034045687815
                    ],
                    [
                        122.03969210386,
                        0.48034045687815
                    ],
                    [
                        122.03969210386,
                        0.48034045687815
                    ],
                    [
                        122.03969210386,
                        0.48034045687815
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2036,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.027260211056749105,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09634840488,
                        0.53293249436421
                    ],
                    [
                        122.09639534354,
                        0.5329888183167
                    ],
                    [
                        122.09645703435,
                        0.53307330424448
                    ],
                    [
                        122.09651470184,
                        0.53318461109992
                    ],
                    [
                        122.09660857916,
                        0.53335224190253
                    ],
                    [
                        122.09672525525,
                        0.53355473990598
                    ],
                    [
                        122.09680840373,
                        0.53369286767936
                    ],
                    [
                        122.09693312645,
                        0.53391145822699
                    ],
                    [
                        122.09700018167,
                        0.53401337774347
                    ],
                    [
                        122.09709271789,
                        0.53417832643105
                    ],
                    [
                        122.09718391299,
                        0.53433522883708
                    ],
                    [
                        122.09724023938,
                        0.53442507893102
                    ],
                    [
                        122.09728583694,
                        0.53451895216212
                    ],
                    [
                        122.09732741117,
                        0.53459807388434
                    ],
                    [
                        122.09739178419,
                        0.53469194711279
                    ],
                    [
                        122.09741994739,
                        0.53471474489662
                    ],
                    [
                        122.0975446701,
                        0.53486091892036
                    ],
                    [
                        122.09767207503,
                        0.53498697724997
                    ],
                    [
                        122.09774047136,
                        0.53505671164395
                    ],
                    [
                        122.09784910083,
                        0.53516935950949
                    ],
                    [
                        122.09791749716,
                        0.53523909390141
                    ],
                    [
                        122.09803149104,
                        0.53535710594745
                    ],
                    [
                        122.09813073277,
                        0.53545768439399
                    ],
                    [
                        122.09819242358,
                        0.53550193890996
                    ],
                    [
                        122.09823802114,
                        0.53553278296634
                    ],
                    [
                        122.09829971194,
                        0.53556362702257
                    ],
                    [
                        122.09836140275,
                        0.53557435538992
                    ],
                    [
                        122.0984365046,
                        0.53556899120625
                    ],
                    [
                        122.09851965308,
                        0.53553948819597
                    ],
                    [
                        122.09859207273,
                        0.53551132623148
                    ],
                    [
                        122.09867924452,
                        0.53545634334805
                    ],
                    [
                        122.09874361753,
                        0.53542013510748
                    ],
                    [
                        122.09880396724,
                        0.53538795000457
                    ],
                    [
                        122.09889113903,
                        0.53534369548778
                    ],
                    [
                        122.09894478321,
                        0.5353155335224
                    ],
                    [
                        122.09901049733,
                        0.53527396109705
                    ],
                    [
                        122.09911644459,
                        0.53522836553346
                    ],
                    [
                        122.0991513133,
                        0.53520690879754
                    ],
                    [
                        122.09918752313,
                        0.53520690879754
                    ],
                    [
                        122.09923312068,
                        0.53523104762545
                    ],
                    [
                        122.09929078817,
                        0.53533162607408
                    ],
                    [
                        122.09939137101,
                        0.53553680610412
                    ],
                    [
                        122.09953218699,
                        0.53580635632924
                    ],
                    [
                        122.09962874651,
                        0.53598069228943
                    ],
                    [
                        122.0997749269,
                        0.53621805739647
                    ],
                    [
                        122.10011288524,
                        0.53677727345972
                    ],
                    [
                        122.10033148527,
                        0.53713667368441
                    ],
                    [
                        122.10062250495,
                        0.5376301784361
                    ],
                    [
                        122.10082367063,
                        0.53793727784026
                    ],
                    [
                        122.10087329149,
                        0.53803651519901
                    ],
                    [
                        122.10095375776,
                        0.53818805332479
                    ],
                    [
                        122.10101142526,
                        0.53831679367645
                    ],
                    [
                        122.10106506944,
                        0.53846564970471
                    ],
                    [
                        122.10114687681,
                        0.53867619381052
                    ],
                    [
                        122.10121795535,
                        0.53886796327637
                    ],
                    [
                        122.10126757622,
                        0.53901011406532
                    ],
                    [
                        122.1013212204,
                        0.53911069245175
                    ],
                    [
                        122.10136681795,
                        0.53927161786656
                    ],
                    [
                        122.10141912103,
                        0.53938828878963
                    ],
                    [
                        122.10144728422,
                        0.53950227762036
                    ],
                    [
                        122.10145264864,
                        0.53950898284564
                    ],
                    [
                        122.10149556398,
                        0.53952775747635
                    ],
                    [
                        122.10153177381,
                        0.53958676345823
                    ],
                    [
                        122.10155323148,
                        0.53962699480919
                    ],
                    [
                        122.10157468915,
                        0.53967527242997
                    ],
                    [
                        122.10159882903,
                        0.53973293736542
                    ],
                    [
                        122.10165917873,
                        0.53978657916534
                    ],
                    [
                        122.10173428059,
                        0.53986033663946
                    ],
                    [
                        122.1018885076,
                        0.54001857994457
                    ],
                    [
                        122.10201725364,
                        0.54016073070665
                    ],
                    [
                        122.10213258862,
                        0.54026935534336
                    ],
                    [
                        122.10223585367,
                        0.54036188743979
                    ],
                    [
                        122.10232838988,
                        0.5404584426693
                    ],
                    [
                        122.10241556168,
                        0.54053890535941
                    ],
                    [
                        122.10251882672,
                        0.54060863968998
                    ],
                    [
                        122.10259392858,
                        0.54067837401973
                    ],
                    [
                        122.10268378258,
                        0.54078297551287
                    ],
                    [
                        122.10280448198,
                        0.54090366954117
                    ],
                    [
                        122.10291579366,
                        0.54103106879066
                    ],
                    [
                        122.10299357772,
                        0.54112091878607
                    ],
                    [
                        122.10309684277,
                        0.54123356653962
                    ],
                    [
                        122.10318937898,
                        0.54133012175528
                    ],
                    [
                        122.1032845974,
                        0.54142801801404
                    ],
                    [
                        122.10342541337,
                        0.54156882769853
                    ],
                    [
                        122.10354208946,
                        0.54169890902319
                    ],
                    [
                        122.10371375084,
                        0.54186251645848
                    ],
                    [
                        122.10384383798,
                        0.54198857464332
                    ],
                    [
                        122.10396051407,
                        0.54211865595898
                    ],
                    [
                        122.10406646132,
                        0.54222862160509
                    ],
                    [
                        122.10422337055,
                        0.54239222902607
                    ],
                    [
                        122.10438966751,
                        0.5425759521083
                    ],
                    [
                        122.10449159145,
                        0.54268055356869
                    ],
                    [
                        122.10457742214,
                        0.54277442667263
                    ],
                    [
                        122.10469275713,
                        0.54288573335112
                    ],
                    [
                        122.10474640131,
                        0.54297558331901
                    ],
                    [
                        122.10481479764,
                        0.5430681153741
                    ],
                    [
                        122.10485637188,
                        0.54311505192322
                    ],
                    [
                        122.10487246513,
                        0.54316869369322
                    ],
                    [
                        122.10483759642,
                        0.54323172277238
                    ],
                    [
                        122.10481211543,
                        0.54325452052424
                    ],
                    [
                        122.10475847125,
                        0.54328938767399
                    ],
                    [
                        122.10465252399,
                        0.54335509884028
                    ],
                    [
                        122.1045935154,
                        0.54338862494526
                    ],
                    [
                        122.104447335,
                        0.5434704286406
                    ],
                    [
                        122.10434541106,
                        0.54353345771661
                    ],
                    [
                        122.10424214602,
                        0.54359782783609
                    ],
                    [
                        122.10414424539,
                        0.54365415169007
                    ],
                    [
                        122.10404366255,
                        0.54371449867591
                    ],
                    [
                        122.10388675332,
                        0.54379898445507
                    ],
                    [
                        122.10374459624,
                        0.54387542396851
                    ],
                    [
                        122.10360914469,
                        0.54393845304027
                    ],
                    [
                        122.10352867842,
                        0.54397332018609
                    ],
                    [
                        122.10339590907,
                        0.54403098508061
                    ],
                    [
                        122.10330069065,
                        0.54408462684248
                    ],
                    [
                        122.10317865014,
                        0.54412485816356
                    ],
                    [
                        122.10308209062,
                        0.54417984096861
                    ],
                    [
                        122.10295200348,
                        0.54424421108121
                    ],
                    [
                        122.10292249918,
                        0.54427907822524
                    ],
                    [
                        122.10288092494,
                        0.54433137894091
                    ],
                    [
                        122.10285007954,
                        0.54442122888729
                    ],
                    [
                        122.10285946727,
                        0.5444829169094
                    ],
                    [
                        122.10290908813,
                        0.54459154146855
                    ],
                    [
                        122.10297614336,
                        0.54470553020132
                    ],
                    [
                        122.10311830044,
                        0.54494021287971
                    ],
                    [
                        122.10324972868,
                        0.54516148511095
                    ],
                    [
                        122.10342273116,
                        0.54544980952126
                    ],
                    [
                        122.1034951508,
                        0.5455745265875
                    ],
                    [
                        122.1035823226,
                        0.54573008765575
                    ],
                    [
                        122.10367619991,
                        0.54591783376722
                    ],
                    [
                        122.10377544165,
                        0.54607473587018
                    ],
                    [
                        122.10383042693,
                        0.54616324474695
                    ],
                    [
                        122.10388273001,
                        0.54625175362243
                    ],
                    [
                        122.10391893983,
                        0.5463295341483
                    ],
                    [
                        122.10395649076,
                        0.54639658632497
                    ],
                    [
                        122.10398599505,
                        0.54649984667555
                    ],
                    [
                        122.10399404168,
                        0.54657494511123
                    ],
                    [
                        122.10399404168,
                        0.54662724580694
                    ],
                    [
                        122.10399404168,
                        0.54676403223975
                    ],
                    [
                        122.10401013494,
                        0.54696787083972
                    ],
                    [
                        122.10402086377,
                        0.54704565135631
                    ],
                    [
                        122.10403427482,
                        0.54723473847001
                    ],
                    [
                        122.1040584147,
                        0.5474372360107
                    ],
                    [
                        122.104087919,
                        0.54755658886261
                    ],
                    [
                        122.10410267115,
                        0.54771483196597
                    ],
                    [
                        122.1041482687,
                        0.54791867053361
                    ],
                    [
                        122.10417374969,
                        0.54795621974269
                    ],
                    [
                        122.10422337055,
                        0.54814396578453
                    ],
                    [
                        122.10426494479,
                        0.54834780433759
                    ],
                    [
                        122.10429444909,
                        0.54852348097972
                    ],
                    [
                        122.10433200002,
                        0.54863881068091
                    ],
                    [
                        122.10439100862,
                        0.54888288050632
                    ],
                    [
                        122.10443124175,
                        0.54902234897352
                    ],
                    [
                        122.10446745157,
                        0.54914438387965
                    ],
                    [
                        122.10449695587,
                        0.5492154591535
                    ],
                    [
                        122.10453853011,
                        0.54935492761293
                    ],
                    [
                        122.10458144546,
                        0.54948634981212
                    ],
                    [
                        122.1046230197,
                        0.54964459286443
                    ],
                    [
                        122.1046833694,
                        0.54978540235662
                    ],
                    [
                        122.10473433137,
                        0.5499154835036
                    ],
                    [
                        122.10481211543,
                        0.55008579592886
                    ],
                    [
                        122.10488319397,
                        0.55024135687995
                    ],
                    [
                        122.10494890809,
                        0.55038216635806
                    ],
                    [
                        122.10497036576,
                        0.55040496408277
                    ],
                    [
                        122.10499987006,
                        0.55044921848932
                    ],
                    [
                        122.10504680872,
                        0.55053370417365
                    ],
                    [
                        122.10510447621,
                        0.55062623611224
                    ],
                    [
                        122.10515409708,
                        0.55069462928332
                    ],
                    [
                        122.10520505905,
                        0.55076302245361
                    ],
                    [
                        122.10524663329,
                        0.55079118434704
                    ],
                    [
                        122.10531368852,
                        0.55080995894258
                    ],
                    [
                        122.10541695356,
                        0.5508180051978
                    ],
                    [
                        122.10557922721,
                        0.55082471041045
                    ],
                    [
                        122.1058434248,
                        0.55082068728286
                    ],
                    [
                        122.10596144199,
                        0.55081666415526
                    ],
                    [
                        122.10609152913,
                        0.55081398207019
                    ],
                    [
                        122.10621491075,
                        0.55081934624033
                    ],
                    [
                        122.10631281137,
                        0.55080459477243
                    ],
                    [
                        122.10642814636,
                        0.55083677979325
                    ],
                    [
                        122.1065287292,
                        0.55093333485467
                    ],
                    [
                        122.10659310222,
                        0.55109962412344
                    ],
                    [
                        122.1067084372,
                        0.55143890785905
                    ],
                    [
                        122.10678219795,
                        0.55169102382394
                    ],
                    [
                        122.1068559587,
                        0.55189888538274
                    ],
                    [
                        122.1069444716,
                        0.55212954465237
                    ],
                    [
                        122.10702225566,
                        0.5523213136895
                    ],
                    [
                        122.1070638299,
                        0.55246748728706
                    ],
                    [
                        122.10712552071,
                        0.55259086316478
                    ],
                    [
                        122.10716575384,
                        0.55268071298717
                    ],
                    [
                        122.10722342134,
                        0.55277458593446
                    ],
                    [
                        122.10725694895,
                        0.55284968429124
                    ],
                    [
                        122.10729047656,
                        0.55290466701613
                    ],
                    [
                        122.10732668638,
                        0.55295428557229
                    ],
                    [
                        122.10737764835,
                        0.55299853995989
                    ],
                    [
                        122.10746347904,
                        0.55307900248193
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2037,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.03385009936153251,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.03966125846,
                        0.4803431389929
                    ],
                    [
                        122.03938633204,
                        0.48033509264863
                    ],
                    [
                        122.03908324242,
                        0.48031765890265
                    ],
                    [
                        122.03866750002,
                        0.48029620198449
                    ],
                    [
                        122.03820884228,
                        0.48025731132014
                    ],
                    [
                        122.03773275018,
                        0.48021707959817
                    ],
                    [
                        122.03675106168,
                        0.48010443077536
                    ],
                    [
                        122.03611671925,
                        0.48004676530583
                    ],
                    [
                        122.03511625528,
                        0.4799595965719
                    ],
                    [
                        122.03453689814,
                        0.47990863638846
                    ],
                    [
                        122.03382477164,
                        0.47984694774486
                    ],
                    [
                        122.03350156546,
                        0.47984024245747
                    ],
                    [
                        122.03217789531,
                        0.47979196438813
                    ],
                    [
                        122.03059002757,
                        0.47973966314596
                    ],
                    [
                        122.02949166298,
                        0.47971150093847
                    ],
                    [
                        122.02920868993,
                        0.47970747776596
                    ],
                    [
                        122.02864274383,
                        0.47963237854537
                    ],
                    [
                        122.02708974481,
                        0.47941915039671
                    ],
                    [
                        122.02633738518,
                        0.47932661742448
                    ],
                    [
                        122.02597260475,
                        0.47927163406356
                    ],
                    [
                        122.0249171555,
                        0.47909863763247
                    ],
                    [
                        122.02441692352,
                        0.47902622052048
                    ],
                    [
                        122.02420368791,
                        0.47899403513713
                    ],
                    [
                        122.02399179339,
                        0.47896989609952
                    ],
                    [
                        122.02375173569,
                        0.47897928350303
                    ],
                    [
                        122.02312543988,
                        0.47902622052048
                    ],
                    [
                        122.02267482877,
                        0.4790637701342
                    ],
                    [
                        122.02242136002,
                        0.47905706484605
                    ],
                    [
                        122.02227786183,
                        0.47903024369338
                    ],
                    [
                        122.02200159431,
                        0.47893636965824
                    ],
                    [
                        122.02099442482,
                        0.47844822465476
                    ],
                    [
                        122.01989203691,
                        0.47792521211251
                    ],
                    [
                        122.01854154468,
                        0.47727614008162
                    ],
                    [
                        122.01817005873,
                        0.47711118994829
                    ],
                    [
                        122.0177167654,
                        0.47690734912767
                    ],
                    [
                        122.01757058501,
                        0.4768617531538
                    ],
                    [
                        122.01733320951,
                        0.47684163728289
                    ],
                    [
                        122.01701134443,
                        0.47685236574739
                    ],
                    [
                        122.01569035649,
                        0.47699854107448
                    ],
                    [
                        122.01511636376,
                        0.47706291185973
                    ],
                    [
                        122.01495677233,
                        0.47705486551161
                    ],
                    [
                        122.01473146677,
                        0.47701597482888
                    ],
                    [
                        122.01390936971,
                        0.47685638892157
                    ],
                    [
                        122.01253473759,
                        0.47660829317597
                    ],
                    [
                        122.01139077544,
                        0.47641115763119
                    ],
                    [
                        122.01079800725,
                        0.47630655509494
                    ],
                    [
                        122.01022803783,
                        0.47621536313896
                    ],
                    [
                        122.00986593962,
                        0.47615367446218
                    ],
                    [
                        122.0094743371,
                        0.47614562811299
                    ],
                    [
                        122.0092061162,
                        0.4761335585892
                    ],
                    [
                        122.00874611735,
                        0.47616037975316
                    ],
                    [
                        122.00847253203,
                        0.47617781350967
                    ],
                    [
                        122.00820162892,
                        0.47619390620797
                    ],
                    [
                        122.00807824731,
                        0.47616574398595
                    ],
                    [
                        122.00790390372,
                        0.47612283012358
                    ],
                    [
                        122.0076289773,
                        0.47600481700071
                    ],
                    [
                        122.00726956129,
                        0.47583718472043
                    ],
                    [
                        122.00686991215,
                        0.47559177105475
                    ],
                    [
                        122.00668886304,
                        0.47544425463949
                    ],
                    [
                        122.0066781342,
                        0.47542816193945
                    ],
                    [
                        122.0066781342,
                        0.47542816193945
                    ],
                    [
                        122.00667142868,
                        0.47543620828948
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2038,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 8.356159617227911e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00667545199,
                        0.47543352617282
                    ],
                    [
                        122.00663521886,
                        0.47550057908933
                    ],
                    [
                        122.00662985444,
                        0.47550057908933
                    ],
                    [
                        122.00662985444,
                        0.47550057908933
                    ],
                    [
                        122.00662985444,
                        0.47550057908933
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2039,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.01316309049999373,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10128635168,
                        0.53904229914916
                    ],
                    [
                        122.10135608912,
                        0.53898597525234
                    ],
                    [
                        122.10141375661,
                        0.53916299321201
                    ],
                    [
                        122.10145264864,
                        0.53927027682144
                    ],
                    [
                        122.10148617625,
                        0.53936817311339
                    ],
                    [
                        122.10151031613,
                        0.53943120223204
                    ],
                    [
                        122.10153177381,
                        0.5394821619445
                    ],
                    [
                        122.10156798363,
                        0.53956664778266
                    ],
                    [
                        122.1015907824,
                        0.53961626644896
                    ],
                    [
                        122.10161089897,
                        0.53967124929493
                    ],
                    [
                        122.10163101554,
                        0.53970209333026
                    ],
                    [
                        122.10165247321,
                        0.53972489109539
                    ],
                    [
                        122.1016779542,
                        0.5397289142304
                    ],
                    [
                        122.10173428059,
                        0.53969807019522
                    ],
                    [
                        122.10184156895,
                        0.53963235898928
                    ],
                    [
                        122.10192337632,
                        0.5395894455483
                    ],
                    [
                        122.10201859474,
                        0.53953178061149
                    ],
                    [
                        122.10218623281,
                        0.53942583805175
                    ],
                    [
                        122.10229754448,
                        0.53935342161745
                    ],
                    [
                        122.10245579481,
                        0.53925954846059
                    ],
                    [
                        122.10258722305,
                        0.53917774470844
                    ],
                    [
                        122.10278704762,
                        0.53903157078789
                    ],
                    [
                        122.10285946727,
                        0.53896988271029
                    ],
                    [
                        122.10297614336,
                        0.53890283045133
                    ],
                    [
                        122.1031062305,
                        0.5388076162423
                    ],
                    [
                        122.10324436426,
                        0.53871776621272
                    ],
                    [
                        122.10335701704,
                        0.53865205499621
                    ],
                    [
                        122.10350319743,
                        0.53855013555695
                    ],
                    [
                        122.10365608335,
                        0.53844821611599
                    ],
                    [
                        122.10378482938,
                        0.53833288622023
                    ],
                    [
                        122.10395514965,
                        0.53821353318627
                    ],
                    [
                        122.10404768586,
                        0.5381397756922
                    ],
                    [
                        122.10412815213,
                        0.53807540551483
                    ],
                    [
                        122.10422605276,
                        0.5380177405637
                    ],
                    [
                        122.10434809327,
                        0.5379614166574
                    ],
                    [
                        122.10444867611,
                        0.53794800620345
                    ],
                    [
                        122.10454255342,
                        0.53791850320466
                    ],
                    [
                        122.10460826755,
                        0.53790911588681
                    ],
                    [
                        122.10476115346,
                        0.53786754347911
                    ],
                    [
                        122.10484564304,
                        0.53782999420738
                    ],
                    [
                        122.10494086146,
                        0.53777903448109
                    ],
                    [
                        122.10500121117,
                        0.53774953148149
                    ],
                    [
                        122.105101794,
                        0.53769052548182
                    ],
                    [
                        122.10518494248,
                        0.53765834039084
                    ],
                    [
                        122.10531905293,
                        0.53759665229935
                    ],
                    [
                        122.10541963577,
                        0.53754837466209
                    ],
                    [
                        122.1055456996,
                        0.53749205075147
                    ],
                    [
                        122.10563421249,
                        0.53744243206787
                    ],
                    [
                        122.10570529103,
                        0.53739951861146
                    ],
                    [
                        122.10583537817,
                        0.53733246633522
                    ],
                    [
                        122.10602447391,
                        0.53724663942058
                    ],
                    [
                        122.10614651442,
                        0.53718897446161
                    ],
                    [
                        122.10631281137,
                        0.53710582963611
                    ],
                    [
                        122.10637316108,
                        0.53706828035969
                    ],
                    [
                        122.10643753409,
                        0.53703341317425
                    ],
                    [
                        122.10650995374,
                        0.53699720494301
                    ],
                    [
                        122.10657700896,
                        0.53697172507644
                    ],
                    [
                        122.10666149855,
                        0.53693417579921
                    ],
                    [
                        122.10670441389,
                        0.53692881161672
                    ],
                    [
                        122.10674867034,
                        0.53695160939224
                    ],
                    [
                        122.10679024458,
                        0.53697306612205
                    ],
                    [
                        122.10688009858,
                        0.53709510127144
                    ],
                    [
                        122.10696861148,
                        0.53717556400596
                    ],
                    [
                        122.10704907775,
                        0.53727614242261
                    ],
                    [
                        122.1070946753,
                        0.53732710215309
                    ],
                    [
                        122.10716709495,
                        0.53738879024732
                    ],
                    [
                        122.10722342134,
                        0.53743840893136
                    ],
                    [
                        122.1072435379,
                        0.53745718356845
                    ],
                    [
                        122.10728913546,
                        0.53749070970597
                    ],
                    [
                        122.10735484958,
                        0.53753362316174
                    ],
                    [
                        122.10738569498,
                        0.53754971570757
                    ],
                    [
                        122.10747823119,
                        0.53760738066313
                    ],
                    [
                        122.10757881403,
                        0.53762347320877
                    ],
                    [
                        122.1076606214,
                        0.53764627098168
                    ],
                    [
                        122.10774376988,
                        0.53766906875452
                    ],
                    [
                        122.1078081429,
                        0.53768650234545
                    ],
                    [
                        122.10797041655,
                        0.53772002848172
                    ],
                    [
                        122.10801467299,
                        0.53773477998161
                    ],
                    [
                        122.10811659694,
                        0.53775891879956
                    ],
                    [
                        122.10820645094,
                        0.53778708075369
                    ],
                    [
                        122.10833787918,
                        0.53780049120802
                    ],
                    [
                        122.10852965713,
                        0.53783938152533
                    ],
                    [
                        122.10869193077,
                        0.53787424870618
                    ],
                    [
                        122.1088193357,
                        0.53789570543274
                    ],
                    [
                        122.10897624493,
                        0.53791313902303
                    ],
                    [
                        122.10904464126,
                        0.53793727784026
                    ],
                    [
                        122.10916534066,
                        0.53798019129289
                    ],
                    [
                        122.10933163762,
                        0.53800298906449
                    ],
                    [
                        122.10942819715,
                        0.53803383310826
                    ],
                    [
                        122.1095623076,
                        0.53806735924262
                    ],
                    [
                        122.10962131619,
                        0.53809552119532
                    ],
                    [
                        122.10966154933,
                        0.53809820328606
                    ],
                    [
                        122.10974603891,
                        0.53811295478504
                    ],
                    [
                        122.10977017879,
                        0.53805126669814
                    ],
                    [
                        122.10979029536,
                        0.53792520843166
                    ],
                    [
                        122.10980638862,
                        0.53778708075369
                    ],
                    [
                        122.10984259844,
                        0.53765834039084
                    ],
                    [
                        122.10986539721,
                        0.53755373884402
                    ],
                    [
                        122.10989758372,
                        0.53740220070249
                    ],
                    [
                        122.10994452238,
                        0.53722786478284
                    ],
                    [
                        122.10998609662,
                        0.53706023408614
                    ],
                    [
                        122.11001962423,
                        0.53690333174988
                    ],
                    [
                        122.11006656289,
                        0.53676386300316
                    ],
                    [
                        122.1101886034,
                        0.53641921425964
                    ],
                    [
                        122.11022883654,
                        0.5362891328222
                    ],
                    [
                        122.11026906967,
                        0.53619123648088
                    ],
                    [
                        122.11038038135,
                        0.53584524665924
                    ],
                    [
                        122.11040720344,
                        0.53574332717318
                    ],
                    [
                        122.1104259789,
                        0.53558910689499
                    ],
                    [
                        122.11043402553,
                        0.53552875982857
                    ],
                    [
                        122.1104259789,
                        0.53548316426686
                    ],
                    [
                        122.11039245129,
                        0.53538795000457
                    ],
                    [
                        122.11035355926,
                        0.53527262005108
                    ],
                    [
                        122.11031869054,
                        0.53516667741747
                    ],
                    [
                        122.11031466722,
                        0.53515192591139
                    ],
                    [
                        122.11031466722,
                        0.53515192591139
                    ],
                    [
                        122.11031466722,
                        0.53515192591139
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2040,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0024877270184660034,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10974738002,
                        0.53811697792113
                    ],
                    [
                        122.1097433567,
                        0.53820548691423
                    ],
                    [
                        122.10971787572,
                        0.53826046977293
                    ],
                    [
                        122.10969239473,
                        0.53833690935616
                    ],
                    [
                        122.10967227817,
                        0.53839189221369
                    ],
                    [
                        122.1096535027,
                        0.53848978851975
                    ],
                    [
                        122.1096226573,
                        0.5386279161818
                    ],
                    [
                        122.10958912969,
                        0.53877274906681
                    ],
                    [
                        122.10955157876,
                        0.53894172076161
                    ],
                    [
                        122.10952743888,
                        0.53905839169102
                    ],
                    [
                        122.10950195789,
                        0.5392367506937
                    ],
                    [
                        122.10949257016,
                        0.53928368727249
                    ],
                    [
                        122.10946440697,
                        0.53939767610518
                    ],
                    [
                        122.10943758488,
                        0.53950361866541
                    ],
                    [
                        122.10941210389,
                        0.5395894455483
                    ],
                    [
                        122.10939198732,
                        0.53967929556502
                    ],
                    [
                        122.10937321186,
                        0.53976646349044
                    ],
                    [
                        122.10937723517,
                        0.53980267170523
                    ],
                    [
                        122.10940405726,
                        0.53983619782986
                    ],
                    [
                        122.10945904255,
                        0.53987508813419
                    ],
                    [
                        122.10955157876,
                        0.53990325007854
                    ],
                    [
                        122.10969373584,
                        0.53994616351732
                    ],
                    [
                        122.10980772972,
                        0.53999578218053
                    ],
                    [
                        122.11007595062,
                        0.54005881129267
                    ],
                    [
                        122.11007595062,
                        0.54005881129267
                    ],
                    [
                        122.11007595062,
                        0.54005881129267
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2041,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00010216890771672496,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00393691659,
                        0.47347826284106
                    ],
                    [
                        122.00390741229,
                        0.47341255096367
                    ],
                    [
                        122.0038819313,
                        0.4733964582589
                    ],
                    [
                        122.0038819313,
                        0.4733964582589
                    ],
                    [
                        122.0038819313,
                        0.4733964582589
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2042,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.008272367260857559,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11014837027,
                        0.54008563219126
                    ],
                    [
                        122.11023956537,
                        0.54010842995496
                    ],
                    [
                        122.11035355926,
                        0.54014866130246
                    ],
                    [
                        122.11042329669,
                        0.54017280011083
                    ],
                    [
                        122.1104849875,
                        0.54018755160479
                    ],
                    [
                        122.11057081819,
                        0.54022510086198
                    ],
                    [
                        122.11063653231,
                        0.54024655758027
                    ],
                    [
                        122.11068749428,
                        0.54026265011894
                    ],
                    [
                        122.11075857282,
                        0.54029349415126
                    ],
                    [
                        122.11081087589,
                        0.54033640758729
                    ],
                    [
                        122.11084976792,
                        0.54039541356132
                    ],
                    [
                        122.11086854339,
                        0.5404919687903
                    ],
                    [
                        122.11086586118,
                        0.54058584192814
                    ],
                    [
                        122.11086183786,
                        0.54066496357176
                    ],
                    [
                        122.11086183786,
                        0.54075213148304
                    ],
                    [
                        122.11088731885,
                        0.54080845536348
                    ],
                    [
                        122.11091682315,
                        0.54087684864619
                    ],
                    [
                        122.11096644402,
                        0.54092914939129
                    ],
                    [
                        122.11102545261,
                        0.54098413222538
                    ],
                    [
                        122.11108848453,
                        0.54100692998572
                    ],
                    [
                        122.11114346981,
                        0.5410337508801
                    ],
                    [
                        122.11124807596,
                        0.54107130013207
                    ],
                    [
                        122.11137145758,
                        0.54110482624968
                    ],
                    [
                        122.11153239012,
                        0.54112494192017
                    ],
                    [
                        122.11174428463,
                        0.54116785535031
                    ],
                    [
                        122.11195617914,
                        0.54121076878015
                    ],
                    [
                        122.11212918162,
                        0.54124965907568
                    ],
                    [
                        122.11229413748,
                        0.54128050310298
                    ],
                    [
                        122.11257174611,
                        0.54131000608549
                    ],
                    [
                        122.11266294122,
                        0.54129927772822
                    ],
                    [
                        122.11276754737,
                        0.54130061877289
                    ],
                    [
                        122.11286813021,
                        0.54130464190686
                    ],
                    [
                        122.11293250322,
                        0.54130598295152
                    ],
                    [
                        122.11296468973,
                        0.54132609862134
                    ],
                    [
                        122.11298078299,
                        0.54137303518397
                    ],
                    [
                        122.11299285293,
                        0.54147361353129
                    ],
                    [
                        122.11301967502,
                        0.54165331350765
                    ],
                    [
                        122.11301699281,
                        0.54170293215689
                    ],
                    [
                        122.11302101612,
                        0.54185715228035
                    ],
                    [
                        122.11303174496,
                        0.54199393882136
                    ],
                    [
                        122.11304917932,
                        0.54216559251548
                    ],
                    [
                        122.113045156,
                        0.54222459847173
                    ],
                    [
                        122.1130438149,
                        0.54228494547183
                    ],
                    [
                        122.113045156,
                        0.54236138500443
                    ],
                    [
                        122.113045156,
                        0.54241100364788
                    ],
                    [
                        122.11303174496,
                        0.54247000960171
                    ],
                    [
                        122.11302638054,
                        0.54255449539826
                    ],
                    [
                        122.11302369833,
                        0.54261350135071
                    ],
                    [
                        122.11300358176,
                        0.5427650393623
                    ],
                    [
                        122.11299687624,
                        0.54288036917388
                    ],
                    [
                        122.11299285293,
                        0.5429501034775
                    ],
                    [
                        122.11297944188,
                        0.54306141015276
                    ],
                    [
                        122.11299017072,
                        0.5431646705605
                    ],
                    [
                        122.11299687624,
                        0.54327061305493
                    ],
                    [
                        122.11300358176,
                        0.54337923763588
                    ],
                    [
                        122.11301162839,
                        0.54340471747557
                    ],
                    [
                        122.11300760508,
                        0.54346640550808
                    ],
                    [
                        122.11301162839,
                        0.54352943458411
                    ],
                    [
                        122.11300089955,
                        0.54359514574779
                    ],
                    [
                        122.11296871305,
                        0.54366219795489
                    ],
                    [
                        122.11294725537,
                        0.54369170092577
                    ],
                    [
                        122.11288958788,
                        0.54376679939648
                    ],
                    [
                        122.11278766394,
                        0.54386871874806
                    ],
                    [
                        122.11266830564,
                        0.54402696194845
                    ],
                    [
                        122.11260661483,
                        0.54411681189937
                    ],
                    [
                        122.11257979274,
                        0.54415838426426
                    ],
                    [
                        122.11251810193,
                        0.54427237300525
                    ],
                    [
                        122.11243361235,
                        0.54443061619504
                    ],
                    [
                        122.11235582829,
                        0.54459824668818
                    ],
                    [
                        122.11232766509,
                        0.5446626167963
                    ],
                    [
                        122.1122418344,
                        0.54482085997585
                    ],
                    [
                        122.11218550801,
                        0.54489193530091
                    ],
                    [
                        122.11213856936,
                        0.54494155392356
                    ],
                    [
                        122.11205810308,
                        0.54498983150198
                    ],
                    [
                        122.11195483804,
                        0.54506358891267
                    ],
                    [
                        122.11188644171,
                        0.5451225948406
                    ],
                    [
                        122.11181133986,
                        0.54520037538105
                    ],
                    [
                        122.11181536317,
                        0.54524462982605
                    ],
                    [
                        122.11181670427,
                        0.54525804026386
                    ],
                    [
                        122.11183145642,
                        0.54529156635824
                    ],
                    [
                        122.11183950305,
                        0.54535325437144
                    ],
                    [
                        122.11187303066,
                        0.54553429527611
                    ],
                    [
                        122.11194008589,
                        0.54572472348105
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2043,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0005378983247795921,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0038819313,
                        0.47339511720018
                    ],
                    [
                        122.00375720859,
                        0.47334415696816
                    ],
                    [
                        122.00360566378,
                        0.47329185567704
                    ],
                    [
                        122.00349569321,
                        0.47327173979573
                    ],
                    [
                        122.00338304043,
                        0.47326101132567
                    ],
                    [
                        122.00336560607,
                        0.47325698814939
                    ],
                    [
                        122.00336560607,
                        0.47325698814939
                    ],
                    [
                        122.00336560607,
                        0.47325698814939
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2044,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.0181394125832545,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00333878398,
                        0.47325832920816
                    ],
                    [
                        122.00321674347,
                        0.47326503450195
                    ],
                    [
                        122.00285196304,
                        0.47333476955697
                    ],
                    [
                        122.00260654092,
                        0.47339109402397
                    ],
                    [
                        122.00235709548,
                        0.47344205425563
                    ],
                    [
                        122.00219482183,
                        0.47347558072363
                    ],
                    [
                        122.00208216906,
                        0.47348630919334
                    ],
                    [
                        122.0019172132,
                        0.47349703766305
                    ],
                    [
                        122.00148671865,
                        0.47349569660435
                    ],
                    [
                        122.00123459101,
                        0.4734742396649
                    ],
                    [
                        122.00093954802,
                        0.47344205425563
                    ],
                    [
                        122.00075179338,
                        0.47340986884621
                    ],
                    [
                        122.00053855777,
                        0.47333208743948
                    ],
                    [
                        122.00009196997,
                        0.47309203792012
                    ],
                    [
                        122.00000479817,
                        0.47302900815667
                    ],
                    [
                        122.00003698468,
                        0.47290965392221
                    ],
                    [
                        122.00016438961,
                        0.47260791567982
                    ],
                    [
                        122.00026363134,
                        0.47234640919249
                    ],
                    [
                        122.00047686696,
                        0.47187837960857
                    ],
                    [
                        122.00071558356,
                        0.47134061491881
                    ],
                    [
                        122.00095161796,
                        0.47079480383215
                    ],
                    [
                        122.00118899345,
                        0.47022485363462
                    ],
                    [
                        122.00139552355,
                        0.46974877755161
                    ],
                    [
                        122.00192257762,
                        0.46856998620937
                    ],
                    [
                        122.00221762061,
                        0.46791286694497
                    ],
                    [
                        122.00247511268,
                        0.46732011849449
                    ],
                    [
                        122.00251668692,
                        0.46721417476166
                    ],
                    [
                        122.00247779489,
                        0.46714175752561
                    ],
                    [
                        122.002363801,
                        0.46710018466755
                    ],
                    [
                        122.00222969055,
                        0.46704386014979
                    ],
                    [
                        122.00180992484,
                        0.46677430709427
                    ],
                    [
                        122.00155779719,
                        0.46658119445111
                    ],
                    [
                        122.00148537755,
                        0.46652352886915
                    ],
                    [
                        122.00141429901,
                        0.46647122752696
                    ],
                    [
                        122.00136199594,
                        0.46638271756236
                    ],
                    [
                        122.00131639838,
                        0.46625665791388
                    ],
                    [
                        122.00127080083,
                        0.46609036645925
                    ],
                    [
                        122.00120642781,
                        0.46592273394054
                    ],
                    [
                        122.00108572841,
                        0.46561831327635
                    ],
                    [
                        122.00104147196,
                        0.46546677346946
                    ],
                    [
                        122.00096234679,
                        0.46513955476026
                    ],
                    [
                        122.00092881918,
                        0.46488207117517
                    ],
                    [
                        122.00089260936,
                        0.46450791532382
                    ],
                    [
                        122.00089931488,
                        0.46428932246959
                    ],
                    [
                        122.00093016028,
                        0.4640693885481
                    ],
                    [
                        122.00094625354,
                        0.46394466991885
                    ],
                    [
                        122.00095161796,
                        0.46379715325776
                    ],
                    [
                        122.00095027685,
                        0.46368182204785
                    ],
                    [
                        122.00092345476,
                        0.46355039810869
                    ],
                    [
                        122.00085907762,
                        0.46335459489739
                    ],
                    [
                        122.00057476347,
                        0.46307565427603
                    ],
                    [
                        122.00014695319,
                        0.46258214809841
                    ],
                    [
                        121.99963196906,
                        0.462024266784
                    ],
                    [
                        121.99926852768,
                        0.46157903037037
                    ],
                    [
                        121.99901908224,
                        0.4612705863363
                    ],
                    [
                        121.99889033621,
                        0.46098896351091
                    ],
                    [
                        121.99910759514,
                        0.46051154574337
                    ],
                    [
                        121.99916392153,
                        0.46035330052124
                    ],
                    [
                        121.99916392153,
                        0.46035330052124
                    ],
                    [
                        121.99916392153,
                        0.46035330052124
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2045,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0016704533266769799,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.99890509248,
                        0.46113514752795
                    ],
                    [
                        121.99878975543,
                        0.46081462974514
                    ],
                    [
                        121.99867173823,
                        0.46055312281948
                    ],
                    [
                        121.99844777584,
                        0.46042036194056
                    ],
                    [
                        121.9977208972,
                        0.46035599100234
                    ],
                    [
                        121.99767261744,
                        0.46033453402281
                    ],
                    [
                        121.99767261744,
                        0.46033453402281
                    ],
                    [
                        121.99767261744,
                        0.46033453402281
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2046,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.005378306522408743,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11193740368,
                        0.54572204139369
                    ],
                    [
                        122.11194813251,
                        0.54576361374751
                    ],
                    [
                        122.11197763681,
                        0.54581055027567
                    ],
                    [
                        122.11199909449,
                        0.54583200697413
                    ],
                    [
                        122.11203530431,
                        0.54586821515262
                    ],
                    [
                        122.11211040616,
                        0.5459124695927
                    ],
                    [
                        122.11216807365,
                        0.54595672403243
                    ],
                    [
                        122.11220294237,
                        0.54597415759953
                    ],
                    [
                        122.11228609085,
                        0.54601036577715
                    ],
                    [
                        122.11240947247,
                        0.54608412317535
                    ],
                    [
                        122.112480551,
                        0.54610557987284
                    ],
                    [
                        122.11257845163,
                        0.54615117535476
                    ],
                    [
                        122.11266830564,
                        0.54620481709774
                    ],
                    [
                        122.11272999644,
                        0.54625175362243
                    ],
                    [
                        122.11279839277,
                        0.54632685206122
                    ],
                    [
                        122.11286142468,
                        0.54638585797675
                    ],
                    [
                        122.11295798421,
                        0.54647973102298
                    ],
                    [
                        122.11302101612,
                        0.54655348841542
                    ],
                    [
                        122.11308807135,
                        0.54662456372
                    ],
                    [
                        122.11318999529,
                        0.54671977780595
                    ],
                    [
                        122.11326107383,
                        0.54677341954386
                    ],
                    [
                        122.11332544684,
                        0.54683108441156
                    ],
                    [
                        122.11339920759,
                        0.54688472614847
                    ],
                    [
                        122.11345687509,
                        0.54695177831893
                    ],
                    [
                        122.11352929473,
                        0.54701748944524
                    ],
                    [
                        122.11359769106,
                        0.54708454161423
                    ],
                    [
                        122.11369425058,
                        0.54716366317266
                    ],
                    [
                        122.11379349232,
                        0.54728301603001
                    ],
                    [
                        122.11388871074,
                        0.54739566366847
                    ],
                    [
                        122.11395174265,
                        0.54745601061678
                    ],
                    [
                        122.11403220892,
                        0.54754183738665
                    ],
                    [
                        122.11410999298,
                        0.54761157163627
                    ],
                    [
                        122.11414352059,
                        0.5476410745878
                    ],
                    [
                        122.11418911815,
                        0.54770142153364
                    ],
                    [
                        122.11421191692,
                        0.54773897074407
                    ],
                    [
                        122.11421996355,
                        0.54778456621357
                    ],
                    [
                        122.11422532797,
                        0.54784491315796
                    ],
                    [
                        122.11422398686,
                        0.54793878618136
                    ],
                    [
                        122.11422666907,
                        0.54797767643348
                    ],
                    [
                        122.11423873901,
                        0.54808093675686
                    ],
                    [
                        122.11426153779,
                        0.54813860161199
                    ],
                    [
                        122.11429774761,
                        0.54821101794091
                    ],
                    [
                        122.11433663964,
                        0.54826734175168
                    ],
                    [
                        122.11438626051,
                        0.54832902973431
                    ],
                    [
                        122.11442247033,
                        0.54838803563013
                    ],
                    [
                        122.11446136236,
                        0.54845911091297
                    ],
                    [
                        122.11451232433,
                        0.54852213993667
                    ],
                    [
                        122.11455792189,
                        0.54859992043307
                    ],
                    [
                        122.11460888386,
                        0.54870318074572
                    ],
                    [
                        122.11463302374,
                        0.54875011725087
                    ],
                    [
                        122.11465850472,
                        0.54882119252941
                    ],
                    [
                        122.11466521025,
                        0.54888690363523
                    ],
                    [
                        122.11467325687,
                        0.54893249909599
                    ],
                    [
                        122.11468935013,
                        0.54898479977113
                    ],
                    [
                        122.11470544338,
                        0.54902905418821
                    ],
                    [
                        122.11472824216,
                        0.5490706265191
                    ],
                    [
                        122.11475506425,
                        0.54910281154927
                    ],
                    [
                        122.11480736732,
                        0.54913365553636
                    ],
                    [
                        122.11485162377,
                        0.54915377118001
                    ],
                    [
                        122.11490392685,
                        0.54918997933844
                    ],
                    [
                        122.1149481833,
                        0.5492154591535
                    ],
                    [
                        122.11498707533,
                        0.54924764418288
                    ],
                    [
                        122.11504206061,
                        0.54927714712635
                    ],
                    [
                        122.1150970459,
                        0.54929726276951
                    ],
                    [
                        122.11515337229,
                        0.5493093321554
                    ],
                    [
                        122.11519494653,
                        0.54931067319828
                    ],
                    [
                        122.1152472496,
                        0.54930530902678
                    ],
                    [
                        122.11530759931,
                        0.54927312399769
                    ],
                    [
                        122.11536929011,
                        0.54924630314
                    ],
                    [
                        122.11541086435,
                        0.54922752853954
                    ],
                    [
                        122.11547255516,
                        0.5492154591535
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2047,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0066707007671922515,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.99890777469,
                        0.46113648858902
                    ],
                    [
                        121.99894934893,
                        0.46123036286345
                    ],
                    [
                        121.99905663729,
                        0.46138458488304
                    ],
                    [
                        121.99913039804,
                        0.46153210159428
                    ],
                    [
                        121.99928328395,
                        0.46168900572924
                    ],
                    [
                        121.99952468276,
                        0.46195453579594
                    ],
                    [
                        121.99974328279,
                        0.46221604267009
                    ],
                    [
                        121.99998602271,
                        0.46247352635216
                    ],
                    [
                        122.00034141541,
                        0.46287450352594
                    ],
                    [
                        122.00059354305,
                        0.46315344415521
                    ],
                    [
                        122.00074642897,
                        0.46332241780029
                    ],
                    [
                        122.00084835291,
                        0.46349273250197
                    ],
                    [
                        122.00088590384,
                        0.46360135841192
                    ],
                    [
                        122.0009046793,
                        0.46369389159317
                    ],
                    [
                        122.00089931488,
                        0.46378240159149
                    ],
                    [
                        122.00088322163,
                        0.46400769976401
                    ],
                    [
                        122.0008470118,
                        0.46451462062598
                    ],
                    [
                        122.00086444616,
                        0.46468225317817
                    ],
                    [
                        122.00090333819,
                        0.46506043220125
                    ],
                    [
                        122.00093954802,
                        0.46530182305648
                    ],
                    [
                        122.00106695294,
                        0.46567597886573
                    ],
                    [
                        122.0011715591,
                        0.4659120054592
                    ],
                    [
                        122.0012332499,
                        0.46612925720303
                    ],
                    [
                        122.0013231039,
                        0.46642160830452
                    ],
                    [
                        122.00136601925,
                        0.46649804872812
                    ],
                    [
                        122.00157925487,
                        0.46664958851284
                    ],
                    [
                        122.00177505612,
                        0.46679710511428
                    ],
                    [
                        122.00177505612,
                        0.46679710511428
                    ],
                    [
                        122.00177505612,
                        0.46679710511428
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2048,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.007185601934166495,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00177773833,
                        0.46679710511428
                    ],
                    [
                        122.00204461813,
                        0.46698619457162
                    ],
                    [
                        122.00216799974,
                        0.46706129392916
                    ],
                    [
                        122.00233563781,
                        0.46712432374646
                    ],
                    [
                        122.002453655,
                        0.46717796614373
                    ],
                    [
                        122.00246036053,
                        0.46723965490007
                    ],
                    [
                        122.00237587094,
                        0.46745154236339
                    ],
                    [
                        122.00222700834,
                        0.46778814838376
                    ],
                    [
                        122.00197085738,
                        0.4683446881828
                    ],
                    [
                        122.00179114938,
                        0.46876041667856
                    ],
                    [
                        122.00154975057,
                        0.46930488686471
                    ],
                    [
                        122.00145721436,
                        0.46951275108716
                    ],
                    [
                        122.00131773949,
                        0.46983862853314
                    ],
                    [
                        122.00117692351,
                        0.4701591417265
                    ],
                    [
                        122.00094759464,
                        0.47070897604068
                    ],
                    [
                        122.00083628297,
                        0.47093293293183
                    ],
                    [
                        122.00062170625,
                        0.4714532638847
                    ],
                    [
                        122.0002797246,
                        0.4722297370642
                    ],
                    [
                        122.00004905462,
                        0.47272592886062
                    ],
                    [
                        121.99999675155,
                        0.4728814916868
                    ],
                    [
                        121.99996858835,
                        0.47294452145158
                    ],
                    [
                        121.99990555644,
                        0.47304241874468
                    ],
                    [
                        121.99990555644,
                        0.47304241874468
                    ],
                    [
                        121.99990555644,
                        0.47304241874468
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2049,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.007185601934166495,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00177773833,
                        0.46679710511428
                    ],
                    [
                        122.00204461813,
                        0.46698619457162
                    ],
                    [
                        122.00216799974,
                        0.46706129392916
                    ],
                    [
                        122.00233563781,
                        0.46712432374646
                    ],
                    [
                        122.002453655,
                        0.46717796614373
                    ],
                    [
                        122.00246036053,
                        0.46723965490007
                    ],
                    [
                        122.00237587094,
                        0.46745154236339
                    ],
                    [
                        122.00222700834,
                        0.46778814838376
                    ],
                    [
                        122.00197085738,
                        0.4683446881828
                    ],
                    [
                        122.00179114938,
                        0.46876041667856
                    ],
                    [
                        122.00154975057,
                        0.46930488686471
                    ],
                    [
                        122.00145721436,
                        0.46951275108716
                    ],
                    [
                        122.00131773949,
                        0.46983862853314
                    ],
                    [
                        122.00117692351,
                        0.4701591417265
                    ],
                    [
                        122.00094759464,
                        0.47070897604068
                    ],
                    [
                        122.00083628297,
                        0.47093293293183
                    ],
                    [
                        122.00062170625,
                        0.4714532638847
                    ],
                    [
                        122.0002797246,
                        0.4722297370642
                    ],
                    [
                        122.00004905462,
                        0.47272592886062
                    ],
                    [
                        121.99999675155,
                        0.4728814916868
                    ],
                    [
                        121.99996858835,
                        0.47294452145158
                    ],
                    [
                        121.99990555644,
                        0.47304241874468
                    ],
                    [
                        121.99990555644,
                        0.47304241874468
                    ],
                    [
                        121.99990555644,
                        0.47304241874468
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2050,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.011783782659984284,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11547791958,
                        0.5492141181106
                    ],
                    [
                        122.11550742388,
                        0.5492328927111
                    ],
                    [
                        122.1155449748,
                        0.54926239565464
                    ],
                    [
                        122.11557850242,
                        0.54929055755514
                    ],
                    [
                        122.11562141776,
                        0.54933749405569
                    ],
                    [
                        122.11567774415,
                        0.54941527454149
                    ],
                    [
                        122.11574748158,
                        0.54948634981212
                    ],
                    [
                        122.11579173803,
                        0.54955876612471
                    ],
                    [
                        122.11585745215,
                        0.54961911305121
                    ],
                    [
                        122.11591780186,
                        0.5497009166617
                    ],
                    [
                        122.11596876383,
                        0.549759922544
                    ],
                    [
                        122.11600095034,
                        0.54980685904085
                    ],
                    [
                        122.11588427424,
                        0.54988732160604
                    ],
                    [
                        122.11577698588,
                        0.54995303270013
                    ],
                    [
                        122.11567908525,
                        0.55001874379351
                    ],
                    [
                        122.11562007666,
                        0.55006970341644
                    ],
                    [
                        122.11554095149,
                        0.55013273242315
                    ],
                    [
                        122.11543768644,
                        0.55021319498394
                    ],
                    [
                        122.11535856128,
                        0.55028963441568
                    ],
                    [
                        122.11525261402,
                        0.55037546114489
                    ],
                    [
                        122.11521103978,
                        0.55041166929592
                    ],
                    [
                        122.11513459682,
                        0.55046665204333
                    ],
                    [
                        122.11504608393,
                        0.55055516085518
                    ],
                    [
                        122.11497634649,
                        0.55061014360129
                    ],
                    [
                        122.11493343115,
                        0.55067853677255
                    ],
                    [
                        122.11485028267,
                        0.55079520747466
                    ],
                    [
                        122.11476579309,
                        0.55096820195979
                    ],
                    [
                        122.11470007896,
                        0.55109291891108
                    ],
                    [
                        122.11464375257,
                        0.55117069937399
                    ],
                    [
                        122.11461022496,
                        0.55121629481731
                    ],
                    [
                        122.11455792189,
                        0.55127798276945
                    ],
                    [
                        122.11452707648,
                        0.5513034625756
                    ],
                    [
                        122.11448013783,
                        0.55133967072099
                    ],
                    [
                        122.11443185806,
                        0.55136783261168
                    ],
                    [
                        122.11434334517,
                        0.55139063033261
                    ],
                    [
                        122.11427628994,
                        0.55139465345984
                    ],
                    [
                        122.11424142122,
                        0.55139331241743
                    ],
                    [
                        122.11420655251,
                        0.55141074596868
                    ],
                    [
                        122.1141448617,
                        0.55143354368945
                    ],
                    [
                        122.11408853531,
                        0.55148986746983
                    ],
                    [
                        122.11397454143,
                        0.55159312773247
                    ],
                    [
                        122.11392357945,
                        0.55163604108783
                    ],
                    [
                        122.11383238435,
                        0.55173930134792
                    ],
                    [
                        122.11375460029,
                        0.55182378701394
                    ],
                    [
                        122.11362585425,
                        0.55189620329815
                    ],
                    [
                        122.11359500885,
                        0.55191765997478
                    ],
                    [
                        122.113519907,
                        0.55192972935536
                    ],
                    [
                        122.11345151067,
                        0.55193777560906
                    ],
                    [
                        122.11338445544,
                        0.55191497789021
                    ],
                    [
                        122.11328923702,
                        0.55187474662144
                    ],
                    [
                        122.11318194866,
                        0.55180501242161
                    ],
                    [
                        122.11310684681,
                        0.5517486886442
                    ],
                    [
                        122.11303308606,
                        0.55172320883998
                    ],
                    [
                        122.11291372776,
                        0.5517004111203
                    ],
                    [
                        122.11281582713,
                        0.55171113945898
                    ],
                    [
                        122.11264550686,
                        0.55176209906745
                    ],
                    [
                        122.11259588599,
                        0.55179830721003
                    ],
                    [
                        122.11249932647,
                        0.55185731307157
                    ],
                    [
                        122.11240008473,
                        0.55190424955189
                    ],
                    [
                        122.11234107614,
                        0.55194045769363
                    ],
                    [
                        122.11223646998,
                        0.55198068896194
                    ],
                    [
                        122.11202859879,
                        0.55203567169488
                    ],
                    [
                        122.11190789938,
                        0.55205042315973
                    ],
                    [
                        122.11177781224,
                        0.5520665156668
                    ],
                    [
                        122.11145058274,
                        0.55209870068079
                    ],
                    [
                        122.11124002934,
                        0.55213222673684
                    ],
                    [
                        122.11104288697,
                        0.55215234237039
                    ],
                    [
                        122.11072638631,
                        0.55218050425724
                    ],
                    [
                        122.11049571633,
                        0.55216977591941
                    ],
                    [
                        122.11021140218,
                        0.55212418048341
                    ],
                    [
                        122.10991233587,
                        0.5520745619203
                    ],
                    [
                        122.10962936282,
                        0.55200750980733
                    ],
                    [
                        122.10948184133,
                        0.55196996062376
                    ],
                    [
                        122.10930615664,
                        0.55192704727078
                    ],
                    [
                        122.10912376642,
                        0.5518868160021
                    ],
                    [
                        122.10901379585,
                        0.55186267724076
                    ],
                    [
                        122.10895344615,
                        0.55187340557914
                    ],
                    [
                        122.10886761546,
                        0.5518854749598
                    ],
                    [
                        122.10874289274,
                        0.55192034205936
                    ],
                    [
                        122.10860207677,
                        0.5519967814692
                    ],
                    [
                        122.10844919086,
                        0.55208126713156
                    ],
                    [
                        122.10830301046,
                        0.55214966028593
                    ],
                    [
                        122.10815414786,
                        0.55223012281946
                    ],
                    [
                        122.10803881288,
                        0.55229985701432
                    ],
                    [
                        122.10792213678,
                        0.55237227329273
                    ],
                    [
                        122.10781484842,
                        0.55246212311841
                    ],
                    [
                        122.10764184594,
                        0.55264048172358
                    ],
                    [
                        122.10761234164,
                        0.55268875923985
                    ],
                    [
                        122.10758954287,
                        0.55276922176609
                    ],
                    [
                        122.10753321648,
                        0.55287918721685
                    ],
                    [
                        122.10749298334,
                        0.55300792725418
                    ],
                    [
                        122.10746482015,
                        0.55308034352396
                    ],
                    [
                        122.10755735636,
                        0.55319835522095
                    ],
                    [
                        122.10758283734,
                        0.55337134963616
                    ],
                    [
                        122.10758820176,
                        0.55355507238169
                    ],
                    [
                        122.1076002717,
                        0.55364089906379
                    ],
                    [
                        122.10764184594,
                        0.55390910743731
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2051,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.002195302220313118,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.11305722594,
                        0.54208915298043
                    ],
                    [
                        122.11312294006,
                        0.54209183506938
                    ],
                    [
                        122.11323827505,
                        0.5421052455142
                    ],
                    [
                        122.11335629225,
                        0.54210926864764
                    ],
                    [
                        122.11350247264,
                        0.54214547684845
                    ],
                    [
                        122.11360037327,
                        0.54217095669334
                    ],
                    [
                        122.11368888617,
                        0.54219911862705
                    ],
                    [
                        122.11376801133,
                        0.54220850593826
                    ],
                    [
                        122.11385518312,
                        0.54224471413849
                    ],
                    [
                        122.11388871074,
                        0.54224873727184
                    ],
                    [
                        122.11396381259,
                        0.5422809223385
                    ],
                    [
                        122.11405098438,
                        0.54231713053829
                    ],
                    [
                        122.11415424943,
                        0.54236809022654
                    ],
                    [
                        122.11424142122,
                        0.54239222902607
                    ],
                    [
                        122.11433395743,
                        0.5424150267811
                    ],
                    [
                        122.11446806788,
                        0.5424284372252
                    ],
                    [
                        122.11459815502,
                        0.5424284372252
                    ],
                    [
                        122.11469873786,
                        0.54242039095875
                    ],
                    [
                        122.11498975754,
                        0.54238552380398
                    ],
                    [
                        122.11505949497,
                        0.54237747753748
                    ],
                    [
                        122.11512252688,
                        0.54238284171515
                    ],
                    [
                        122.11517482996,
                        0.54239357007049
                    ],
                    [
                        122.11519092321,
                        0.54240563947022
                    ],
                    [
                        122.11519092321,
                        0.54240563947022
                    ],
                    [
                        122.11519092321,
                        0.54240563947022
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2052,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.004323566835632091,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10135608912,
                        0.53898061107167
                    ],
                    [
                        122.10132390261,
                        0.53890685358688
                    ],
                    [
                        122.10127025843,
                        0.53878750056415
                    ],
                    [
                        122.10122466087,
                        0.53865205499621
                    ],
                    [
                        122.10118308663,
                        0.53855013555695
                    ],
                    [
                        122.10112541914,
                        0.53841200789314
                    ],
                    [
                        122.10107043386,
                        0.53825644663695
                    ],
                    [
                        122.10102215409,
                        0.5381625734632
                    ],
                    [
                        122.10095107555,
                        0.53800969429139
                    ],
                    [
                        122.10088402033,
                        0.53789168229652
                    ],
                    [
                        122.10081294179,
                        0.53778171657197
                    ],
                    [
                        122.10068151355,
                        0.53758726498101
                    ],
                    [
                        122.10049241781,
                        0.53727614242261
                    ],
                    [
                        122.10037171841,
                        0.53706962140528
                    ],
                    [
                        122.10023358464,
                        0.53685103097024
                    ],
                    [
                        122.10008472204,
                        0.5365814807911
                    ],
                    [
                        122.0998942852,
                        0.53628376863916
                    ],
                    [
                        122.09976688027,
                        0.53604238039723
                    ],
                    [
                        122.09961801767,
                        0.53579831005404
                    ],
                    [
                        122.09927067161,
                        0.53520556775154
                    ],
                    [
                        122.09927067161,
                        0.53520556775154
                    ],
                    [
                        122.09927067161,
                        0.53520556775154
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2053,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.007036732306254034,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00618863106,
                        0.4751773840257
                    ],
                    [
                        122.00589358807,
                        0.47496281468049
                    ],
                    [
                        122.00560256839,
                        0.47473751686087
                    ],
                    [
                        122.00532898307,
                        0.47451758326796
                    ],
                    [
                        122.00486630201,
                        0.47417963651401
                    ],
                    [
                        122.00442105532,
                        0.47384571291948
                    ],
                    [
                        122.00410991907,
                        0.47361102765267
                    ],
                    [
                        122.00390070677,
                        0.47349301448692
                    ],
                    [
                        122.00374379754,
                        0.47341523308112
                    ],
                    [
                        122.00359627604,
                        0.47336024967306
                    ],
                    [
                        122.00342461467,
                        0.4733361106157
                    ],
                    [
                        122.00320869684,
                        0.47334683908565
                    ],
                    [
                        122.00294584036,
                        0.47339914037636
                    ],
                    [
                        122.00261861086,
                        0.47345948801901
                    ],
                    [
                        122.00231954455,
                        0.47351178930888
                    ],
                    [
                        122.00225883623,
                        0.47351930782907
                    ],
                    [
                        122.00209522148,
                        0.47354344688577
                    ],
                    [
                        122.00193965335,
                        0.47356088064889
                    ],
                    [
                        122.00177201529,
                        0.47354881112059
                    ],
                    [
                        122.00152659316,
                        0.47354344688577
                    ],
                    [
                        122.00116217136,
                        0.47353592836561
                    ],
                    [
                        122.00085639954,
                        0.47349703766305
                    ],
                    [
                        122.00061231852,
                        0.47344205425563
                    ],
                    [
                        122.00039103627,
                        0.47336024967306
                    ],
                    [
                        122.00020596385,
                        0.47324894179685
                    ],
                    [
                        121.99990421534,
                        0.47304644192108
                    ],
                    [
                        121.99989750981,
                        0.47302900815667
                    ],
                    [
                        121.99989750981,
                        0.47302900815667
                    ],
                    [
                        121.99991092086,
                        0.47302900815667
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2054,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.013429696320558945,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09919020534,
                        0.53509291988667
                    ],
                    [
                        122.09924384952,
                        0.5350272086312
                    ],
                    [
                        122.0992679894,
                        0.53500843398665
                    ],
                    [
                        122.09934577346,
                        0.53495076900662
                    ],
                    [
                        122.0993873477,
                        0.53489980925635
                    ],
                    [
                        122.09943294525,
                        0.53487030624286
                    ],
                    [
                        122.09948256612,
                        0.53483543904491
                    ],
                    [
                        122.09953889251,
                        0.53480995916935
                    ],
                    [
                        122.09960192442,
                        0.53478984347806
                    ],
                    [
                        122.09963545203,
                        0.53478716138588
                    ],
                    [
                        122.09969580173,
                        0.5347831382476
                    ],
                    [
                        122.09973067045,
                        0.5347831382476
                    ],
                    [
                        122.09982588887,
                        0.53478850243196
                    ],
                    [
                        122.09988221526,
                        0.53479788975458
                    ],
                    [
                        122.09993183613,
                        0.53479118452415
                    ],
                    [
                        122.09997743368,
                        0.53478179720152
                    ],
                    [
                        122.10001900792,
                        0.53476034046403
                    ],
                    [
                        122.10007801652,
                        0.53472815535766
                    ],
                    [
                        122.10015445948,
                        0.53468255979001
                    ],
                    [
                        122.10035696626,
                        0.53453638576201
                    ],
                    [
                        122.10048034787,
                        0.53445189985435
                    ],
                    [
                        122.10057422519,
                        0.53438752963819
                    ],
                    [
                        122.10068687797,
                        0.53431779523661
                    ],
                    [
                        122.10079148412,
                        0.53424806083422
                    ],
                    [
                        122.10097789764,
                        0.53412870772062
                    ],
                    [
                        122.10124611855,
                        0.53396241798544
                    ],
                    [
                        122.10138693452,
                        0.53388866044018
                    ],
                    [
                        122.10151031613,
                        0.53382160812553
                    ],
                    [
                        122.10176244378,
                        0.53366202361373
                    ],
                    [
                        122.10185095668,
                        0.53360167652835
                    ],
                    [
                        122.10189521313,
                        0.53357083246226
                    ],
                    [
                        122.10195690393,
                        0.53353462421058
                    ],
                    [
                        122.10201457143,
                        0.53351182642237
                    ],
                    [
                        122.10208833218,
                        0.5334769592167
                    ],
                    [
                        122.10213527083,
                        0.5334769592167
                    ],
                    [
                        122.10218757391,
                        0.53348098235583
                    ],
                    [
                        122.10226804018,
                        0.5334823234022
                    ],
                    [
                        122.10231497884,
                        0.53347561817032
                    ],
                    [
                        122.10238873959,
                        0.5334367278253
                    ],
                    [
                        122.10245847702,
                        0.53339113224808
                    ],
                    [
                        122.10253491998,
                        0.53335358294893
                    ],
                    [
                        122.10258185863,
                        0.53333078516005
                    ],
                    [
                        122.1027508378,
                        0.53328787167488
                    ],
                    [
                        122.10285812616,
                        0.53325836865363
                    ],
                    [
                        122.10308074951,
                        0.53319399842499
                    ],
                    [
                        122.10317328572,
                        0.53315644912463
                    ],
                    [
                        122.10325375199,
                        0.53311219459178
                    ],
                    [
                        122.10329532623,
                        0.53307062215154
                    ],
                    [
                        122.10335433483,
                        0.53299954668854
                    ],
                    [
                        122.10338383913,
                        0.53296065634052
                    ],
                    [
                        122.10340127349,
                        0.53287617041121
                    ],
                    [
                        122.10339188576,
                        0.53281314122508
                    ],
                    [
                        122.1033462882,
                        0.53272999634029
                    ],
                    [
                        122.10325911641,
                        0.53258918645217
                    ],
                    [
                        122.1031974256,
                        0.53249665423824
                    ],
                    [
                        122.1030767262,
                        0.5323022024798
                    ],
                    [
                        122.10297077894,
                        0.53208227082836
                    ],
                    [
                        122.10295066237,
                        0.5320018080271
                    ],
                    [
                        122.10288226604,
                        0.53188379591669
                    ],
                    [
                        122.1028406918,
                        0.53179662787913
                    ],
                    [
                        122.10280045867,
                        0.53168397995185
                    ],
                    [
                        122.10276693106,
                        0.53154451108667
                    ],
                    [
                        122.10274547338,
                        0.5314466146698
                    ],
                    [
                        122.10269853473,
                        0.53132055626771
                    ],
                    [
                        122.10266232491,
                        0.53115158436301
                    ],
                    [
                        122.10262075067,
                        0.53096517884373
                    ],
                    [
                        122.10262075067,
                        0.53090751382584
                    ],
                    [
                        122.10261672735,
                        0.53084046147877
                    ],
                    [
                        122.10261538625,
                        0.53074122400378
                    ],
                    [
                        122.10261672735,
                        0.53065271490312
                    ],
                    [
                        122.1026314795,
                        0.53058163941228
                    ],
                    [
                        122.10264354944,
                        0.53051726915571
                    ],
                    [
                        122.10265830159,
                        0.53043948842814
                    ],
                    [
                        122.10265427828,
                        0.5303643897937
                    ],
                    [
                        122.10263684392,
                        0.53028660906422
                    ],
                    [
                        122.1026019752,
                        0.5301337296965
                    ],
                    [
                        122.10259526968,
                        0.53007204152952
                    ],
                    [
                        122.10257649422,
                        0.52999023765496
                    ],
                    [
                        122.10255503654,
                        0.5297931037233
                    ],
                    [
                        122.1025402844,
                        0.52970459460908
                    ],
                    [
                        122.1025402844,
                        0.52960803921032
                    ],
                    [
                        122.10254564881,
                        0.52948332181802
                    ],
                    [
                        122.10252687335,
                        0.52932641928866
                    ],
                    [
                        122.10253089666,
                        0.52920304293801
                    ],
                    [
                        122.10253626108,
                        0.52910648753143
                    ],
                    [
                        122.10252016783,
                        0.52902736573881
                    ],
                    [
                        122.10246652365,
                        0.52889728414536
                    ],
                    [
                        122.10240885615,
                        0.52876720254919
                    ],
                    [
                        122.10233777761,
                        0.52860895895428
                    ],
                    [
                        122.10228949785,
                        0.52850435725375
                    ],
                    [
                        122.10223048925,
                        0.52838232193423
                    ],
                    [
                        122.10218086839,
                        0.52831661060735
                    ],
                    [
                        122.1021540463,
                        0.52826565080234
                    ],
                    [
                        122.10211247206,
                        0.52823346566211
                    ],
                    [
                        122.10207089782,
                        0.52822944251959
                    ],
                    [
                        122.10201323032,
                        0.52824553508973
                    ],
                    [
                        122.10189923644,
                        0.52828442546739
                    ],
                    [
                        122.10178256035,
                        0.52829649489489
                    ],
                    [
                        122.10170343518,
                        0.52830722327488
                    ],
                    [
                        122.10166051984,
                        0.52830722327488
                    ],
                    [
                        122.10160687566,
                        0.52829649489489
                    ],
                    [
                        122.10156530142,
                        0.52827101499236
                    ],
                    [
                        122.10153982043,
                        0.52819323423662
                    ],
                    [
                        122.10151031613,
                        0.52805644738794
                    ],
                    [
                        122.10149154067,
                        0.52793843520236
                    ],
                    [
                        122.10147544742,
                        0.52781103568132
                    ],
                    [
                        122.10144862533,
                        0.52769436453871
                    ],
                    [
                        122.10143119097,
                        0.52759780910869
                    ],
                    [
                        122.10139229894,
                        0.52752405148752
                    ],
                    [
                        122.10134133697,
                        0.52737921833795
                    ],
                    [
                        122.10130915046,
                        0.52731082490505
                    ],
                    [
                        122.10125416517,
                        0.52721024632587
                    ],
                    [
                        122.10120588541,
                        0.52711100879284
                    ],
                    [
                        122.10111737251,
                        0.52695410620359
                    ],
                    [
                        122.10103690624,
                        0.52680793199295
                    ],
                    [
                        122.10098594427,
                        0.52670333026214
                    ],
                    [
                        122.10092827678,
                        0.5266121390082
                    ],
                    [
                        122.10090011358,
                        0.52654910975837
                    ],
                    [
                        122.10084781051,
                        0.52648876260368
                    ],
                    [
                        122.10085451603,
                        0.52645389535848
                    ],
                    [
                        122.1008746326,
                        0.52643243859211
                    ],
                    [
                        122.10092023015,
                        0.52631979056745
                    ],
                    [
                        122.10115626454,
                        0.52618836786944
                    ],
                    [
                        122.10128501058,
                        0.52612131547143
                    ],
                    [
                        122.10135474801,
                        0.52609583555999
                    ],
                    [
                        122.10142984986,
                        0.52606096831261
                    ],
                    [
                        122.10149824619,
                        0.52600464429718
                    ],
                    [
                        122.10169807076,
                        0.52591479408104
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2095,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.005171309693967442,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09634572268,
                        0.53292847122473
                    ],
                    [
                        122.09622502327,
                        0.53299284145615
                    ],
                    [
                        122.09601849318,
                        0.53311219459178
                    ],
                    [
                        122.09582269192,
                        0.53322081935367
                    ],
                    [
                        122.0956081152,
                        0.53336028818095
                    ],
                    [
                        122.09517762065,
                        0.53361374594547
                    ],
                    [
                        122.09494695067,
                        0.53375455581015
                    ],
                    [
                        122.09450438619,
                        0.53401740088225
                    ],
                    [
                        122.09421873093,
                        0.53419173689326
                    ],
                    [
                        122.09379896522,
                        0.53445324090051
                    ],
                    [
                        122.0935562253,
                        0.53461282539176
                    ],
                    [
                        122.09330275655,
                        0.53479788975458
                    ],
                    [
                        122.09303990006,
                        0.53498027201973
                    ],
                    [
                        122.09291115403,
                        0.53504061909156
                    ],
                    [
                        122.09277033806,
                        0.53507414524232
                    ],
                    [
                        122.09267646074,
                        0.53509023779462
                    ],
                    [
                        122.09256246686,
                        0.535114376623
                    ],
                    [
                        122.09179267287,
                        0.53523641180943
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2055,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.001344929697898392,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9996842742,
                        0.46205645642496
                    ],
                    [
                        122.00059890747,
                        0.46112307797829
                    ],
                    [
                        122.00062841177,
                        0.46109893887892
                    ],
                    [
                        122.00062841177,
                        0.46109893887892
                    ],
                    [
                        122.00062841177,
                        0.46109893887892
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2056,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.000832468532868441,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00022742152,
                        0.46268139077618
                    ],
                    [
                        122.00082153082,
                        0.46212350946956
                    ],
                    [
                        122.00083091855,
                        0.46210875779981
                    ],
                    [
                        122.00083091855,
                        0.46210875779981
                    ],
                    [
                        122.00083091855,
                        0.46210875779981
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2057,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.003113377950705671,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10170477629,
                        0.52590942988899
                    ],
                    [
                        122.10177451372,
                        0.52588260892866
                    ],
                    [
                        122.10187375546,
                        0.52584774168009
                    ],
                    [
                        122.10200786591,
                        0.52577398403821
                    ],
                    [
                        122.10213258862,
                        0.52572704735656
                    ],
                    [
                        122.10235521197,
                        0.52562110455954
                    ],
                    [
                        122.10242629051,
                        0.52557684997291
                    ],
                    [
                        122.1025724709,
                        0.52549906918355
                    ],
                    [
                        122.10269451141,
                        0.52543603992247
                    ],
                    [
                        122.10279241204,
                        0.525364964372
                    ],
                    [
                        122.10287824273,
                        0.52529925301329
                    ],
                    [
                        122.10299625993,
                        0.52520672069067
                    ],
                    [
                        122.1030767262,
                        0.52511687046304
                    ],
                    [
                        122.10317730904,
                        0.5250162918485
                    ],
                    [
                        122.10326582193,
                        0.52493717000393
                    ],
                    [
                        122.10338652134,
                        0.52482049880755
                    ],
                    [
                        122.10347235203,
                        0.52474808220182
                    ],
                    [
                        122.10359975696,
                        0.52461263632588
                    ],
                    [
                        122.10368022323,
                        0.52449060093018
                    ],
                    [
                        122.10382506251,
                        0.52435649609702
                    ],
                    [
                        122.10400745273,
                        0.52414729255153
                    ],
                    [
                        122.10412010551,
                        0.52402525714677
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2089,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006673061479760869,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10392296314,
                        0.52423446069633
                    ],
                    [
                        122.10344016552,
                        0.52379191471787
                    ],
                    [
                        122.10343346,
                        0.52378386842706
                    ],
                    [
                        122.1034348011,
                        0.52378520947553
                    ],
                    [
                        122.1034348011,
                        0.52378520947553
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2058,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0019949228488883013,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00203925371,
                        0.47357213695054
                    ],
                    [
                        122.00204864144,
                        0.47383900762626
                    ],
                    [
                        122.00203925371,
                        0.47399457042746
                    ],
                    [
                        122.00205534697,
                        0.47436336153704
                    ],
                    [
                        122.00204193592,
                        0.47487698694055
                    ],
                    [
                        122.00205534697,
                        0.47535574478884
                    ],
                    [
                        122.002094239,
                        0.47556226777196
                    ],
                    [
                        122.002094239,
                        0.47556226777196
                    ],
                    [
                        122.002094239,
                        0.47556226777196
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2059,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0014980478192553126,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93730069703,
                        0.46878263824117
                    ],
                    [
                        121.93717444314,
                        0.46849985580672
                    ],
                    [
                        121.93703877698,
                        0.46818510365149
                    ],
                    [
                        121.93696328402,
                        0.46799775058621
                    ],
                    [
                        121.93683802045,
                        0.46770978030617
                    ],
                    [
                        121.93676100299,
                        0.46753199571641
                    ],
                    [
                        121.93670019345,
                        0.46741052666172
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2061,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0007672068141226112,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.9496261991,
                        0.46004486343587
                    ],
                    [
                        121.95039337272,
                        0.46005200013008
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2062,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.0003211133169498609,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.95062436464,
                        0.45564997335607
                    ],
                    [
                        121.95059402883,
                        0.45596965053848
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2188,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 6.843325581209529e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.93980127652,
                        0.44795251052548
                    ],
                    [
                        121.93974018813,
                        0.44793481888985
                    ],
                    [
                        121.93973750513,
                        0.44793079705617
                    ],
                    [
                        121.93973750513,
                        0.44793079705617
                    ],
                    [
                        121.93973750513,
                        0.44793079705617
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2065,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribus",
                "panjang": 0.0029065685427214854,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94738169463,
                        0.46252155037553
                    ],
                    [
                        121.94740756452,
                        0.46220379557283
                    ],
                    [
                        121.94743666649,
                        0.4617807741693
                    ],
                    [
                        121.94748605936,
                        0.46116134852164
                    ],
                    [
                        121.94751467854,
                        0.46077382579546
                    ],
                    [
                        121.94753978401,
                        0.46035127772813
                    ],
                    [
                        121.94757190346,
                        0.45991027217532
                    ],
                    [
                        121.94759315997,
                        0.45962275252497
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2066,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribus",
                "panjang": 0.00021503171740328678,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.94759368301,
                        0.45962091196927
                    ],
                    [
                        121.94759759902,
                        0.45952975060068
                    ],
                    [
                        121.94760712086,
                        0.4594063310839
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2090,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.006500683387787726,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00402140617,
                        0.47339511720018
                    ],
                    [
                        122.00405627489,
                        0.47314031603641
                    ],
                    [
                        122.00410321355,
                        0.47265887591724
                    ],
                    [
                        122.00414344668,
                        0.47236652507649
                    ],
                    [
                        122.00421318412,
                        0.47182876042447
                    ],
                    [
                        122.00431108475,
                        0.47096914153033
                    ],
                    [
                        122.00439691544,
                        0.47001430731458
                    ],
                    [
                        122.00445055962,
                        0.46934914182871
                    ],
                    [
                        122.00446128845,
                        0.46897900939385
                    ],
                    [
                        122.00442373753,
                        0.46849086368897
                    ],
                    [
                        122.0044451952,
                        0.46821728750981
                    ],
                    [
                        122.00456321239,
                        0.46762722120472
                    ],
                    [
                        122.00465977192,
                        0.46717796614373
                    ],
                    [
                        122.00470134616,
                        0.46697680715188
                    ],
                    [
                        122.00470805168,
                        0.4669473038326
                    ],
                    [
                        122.00470805168,
                        0.4669473038326
                    ],
                    [
                        122.00470805168,
                        0.4669473038326
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2091,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005665313463227104,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10379555821,
                        0.52438197601554
                    ],
                    [
                        122.10339322686,
                        0.52398502569414
                    ],
                    [
                        122.10339322686,
                        0.52398636674256
                    ],
                    [
                        122.10339322686,
                        0.52398636674256
                    ],
                    [
                        122.10339322686,
                        0.52398636674256
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2092,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004610835903945557,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10249602795,
                        0.52553930062645
                    ],
                    [
                        122.10222914815,
                        0.5251812407755
                    ],
                    [
                        122.10222110152,
                        0.52516917134198
                    ],
                    [
                        122.10222110152,
                        0.52516917134198
                    ],
                    [
                        122.10222110152,
                        0.52516917134198
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2093,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0006628847048499629,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.10249334574,
                        0.52554064167454
                    ],
                    [
                        122.1026314795,
                        0.52580080499899
                    ],
                    [
                        122.10282862186,
                        0.52611192813566
                    ],
                    [
                        122.10282862186,
                        0.52611192813566
                    ],
                    [
                        122.10282862186,
                        0.52611192813566
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2094,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0001622177174204772,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.00401872396,
                        0.47340986884621
                    ],
                    [
                        122.00397312641,
                        0.47354129260042
                    ],
                    [
                        122.00398117304,
                        0.47352251777854
                    ],
                    [
                        122.00398117304,
                        0.47352519989596
                    ],
                    [
                        122.00398117304,
                        0.47352519989596
                    ],
                    [
                        122.00398117304,
                        0.47352519989596
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2096,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.004116728650427992,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.01627239585,
                        0.47010952253016
                    ],
                    [
                        122.01636090875,
                        0.46941083056594
                    ],
                    [
                        122.01646149158,
                        0.46876443985742
                    ],
                    [
                        122.01649233699,
                        0.46859814846217
                    ],
                    [
                        122.01656475663,
                        0.46828702261531
                    ],
                    [
                        122.01659291983,
                        0.46827629413758
                    ],
                    [
                        122.01701402664,
                        0.46834737030221
                    ],
                    [
                        122.01748609543,
                        0.46837821467531
                    ],
                    [
                        122.01800107956,
                        0.46841308222734
                    ],
                    [
                        122.01827466488,
                        0.46842649282424
                    ],
                    [
                        122.01861530542,
                        0.46844526765985
                    ],
                    [
                        122.01862871647,
                        0.46848549945026
                    ],
                    [
                        122.01865553856,
                        0.46864910872888
                    ],
                    [
                        122.01865553856,
                        0.46864910872888
                    ],
                    [
                        122.01865553856,
                        0.46864910872888
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2097,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.0016220362727984144,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09133937955,
                        0.52930898567405
                    ],
                    [
                        122.09131255746,
                        0.52927814158653
                    ],
                    [
                        122.09112480283,
                        0.52939883584116
                    ],
                    [
                        122.09103226662,
                        0.52948063972353
                    ],
                    [
                        122.09098801017,
                        0.5295664667465
                    ],
                    [
                        122.0909678936,
                        0.52966168109871
                    ],
                    [
                        122.09095984697,
                        0.52971532298664
                    ],
                    [
                        122.09089815617,
                        0.52976360068536
                    ],
                    [
                        122.09064736962,
                        0.52991379796791
                    ],
                    [
                        122.09048777819,
                        0.53000096603202
                    ],
                    [
                        122.09038048983,
                        0.53008679304776
                    ],
                    [
                        122.09035500884,
                        0.53014579912041
                    ],
                    [
                        122.09036037326,
                        0.53021553356916
                    ],
                    [
                        122.09040060639,
                        0.53028929115836
                    ],
                    [
                        122.09043011069,
                        0.53036170769959
                    ],
                    [
                        122.09043011069,
                        0.53036170769959
                    ],
                    [
                        122.09043011069,
                        0.53036170769959
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2098,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.008771002292202018,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0906688273,
                        0.54602109412604
                    ],
                    [
                        122.090639323,
                        0.54606937169578
                    ],
                    [
                        122.09050118923,
                        0.54602109412604
                    ],
                    [
                        122.0902825892,
                        0.5459433135962
                    ],
                    [
                        122.09013104439,
                        0.5458708972399
                    ],
                    [
                        122.0899862051,
                        0.54580920923201
                    ],
                    [
                        122.08993390203,
                        0.54577300105318
                    ],
                    [
                        122.08987623453,
                        0.5457032667822
                    ],
                    [
                        122.08985745907,
                        0.54567644590853
                    ],
                    [
                        122.08976894617,
                        0.54547394830849
                    ],
                    [
                        122.0897166431,
                        0.54532911558374
                    ],
                    [
                        122.08964154124,
                        0.54505688369355
                    ],
                    [
                        122.08956375718,
                        0.54479135701049
                    ],
                    [
                        122.08949670196,
                        0.54451376092023
                    ],
                    [
                        122.08940953016,
                        0.54420666184895
                    ],
                    [
                        122.08924859762,
                        0.54363537707214
                    ],
                    [
                        122.08914399147,
                        0.54317405787022
                    ],
                    [
                        122.08898305893,
                        0.54238820589282
                    ],
                    [
                        122.08887040615,
                        0.54169890902319
                    ],
                    [
                        122.08889186382,
                        0.54138510458574
                    ],
                    [
                        122.08897769451,
                        0.54090232849642
                    ],
                    [
                        122.08908230066,
                        0.54027740161268
                    ],
                    [
                        122.08910107613,
                        0.53991531948323
                    ],
                    [
                        122.08909571171,
                        0.53966588511486
                    ],
                    [
                        122.08910912275,
                        0.53945399999819
                    ],
                    [
                        122.08912521601,
                        0.53927429995677
                    ],
                    [
                        122.08914399147,
                        0.53920992979138
                    ],
                    [
                        122.08919629455,
                        0.53913617230937
                    ],
                    [
                        122.089330405,
                        0.53901413720082
                    ],
                    [
                        122.09012299776,
                        0.53856488705484
                    ],
                    [
                        122.09014043212,
                        0.53854745346642
                    ],
                    [
                        122.09014043212,
                        0.53854745346642
                    ],
                    [
                        122.09014043212,
                        0.53854745346642
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2101,
                "jenis_pipa": "Pipa 75",
                "keterangan": "",
                "panjang": 0.00016233311931366444,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08963081241,
                        0.54479672118602
                    ],
                    [
                        122.08976626396,
                        0.54473235107933
                    ],
                    [
                        122.0897783339,
                        0.54472966899152
                    ],
                    [
                        122.0897783339,
                        0.54472966899152
                    ],
                    [
                        122.0897783339,
                        0.54472966899152
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2102,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002299095402520439,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08978101611,
                        0.54473101003544
                    ],
                    [
                        122.09014713764,
                        0.54457678998531
                    ],
                    [
                        122.09026247263,
                        0.54452314822782
                    ],
                    [
                        122.09045559168,
                        0.54445207289843
                    ],
                    [
                        122.09061384201,
                        0.54439306696394
                    ],
                    [
                        122.09068760276,
                        0.54435417668862
                    ],
                    [
                        122.09081500769,
                        0.54431528641305
                    ],
                    [
                        122.09084585309,
                        0.54431930954502
                    ],
                    [
                        122.09085658193,
                        0.54434478938075
                    ],
                    [
                        122.0908793807,
                        0.54439977218379
                    ],
                    [
                        122.09095045924,
                        0.54464116009366
                    ],
                    [
                        122.09101885557,
                        0.54490802782722
                    ],
                    [
                        122.09117442369,
                        0.54542298864647
                    ],
                    [
                        122.09117442369,
                        0.54542298864647
                    ],
                    [
                        122.09117442369,
                        0.54542298864647
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2103,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.002299095402520439,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.08978101611,
                        0.54473101003544
                    ],
                    [
                        122.09014713764,
                        0.54457678998531
                    ],
                    [
                        122.09026247263,
                        0.54452314822782
                    ],
                    [
                        122.09045559168,
                        0.54445207289843
                    ],
                    [
                        122.09061384201,
                        0.54439306696394
                    ],
                    [
                        122.09068760276,
                        0.54435417668862
                    ],
                    [
                        122.09081500769,
                        0.54431528641305
                    ],
                    [
                        122.09084585309,
                        0.54431930954502
                    ],
                    [
                        122.09085658193,
                        0.54434478938075
                    ],
                    [
                        122.0908793807,
                        0.54439977218379
                    ],
                    [
                        122.09095045924,
                        0.54464116009366
                    ],
                    [
                        122.09101885557,
                        0.54490802782722
                    ],
                    [
                        122.09117442369,
                        0.54542298864647
                    ],
                    [
                        122.09117442369,
                        0.54542298864647
                    ],
                    [
                        122.09117442369,
                        0.54542298864647
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2104,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0005246683279822279,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09071308374,
                        0.54461165712742
                    ],
                    [
                        122.09092766047,
                        0.54455667432631
                    ],
                    [
                        122.09120258689,
                        0.54448694004125
                    ],
                    [
                        122.09122136235,
                        0.54448157586544
                    ],
                    [
                        122.09122136235,
                        0.54448157586544
                    ],
                    [
                        122.09122136235,
                        0.54448157586544
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2105,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0004518590384274701,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09124147892,
                        0.54477660552775
                    ],
                    [
                        122.09080561996,
                        0.54489059425704
                    ],
                    [
                        122.09080561996,
                        0.54489193530091
                    ],
                    [
                        122.09080561996,
                        0.54489193530091
                    ],
                    [
                        122.09080561996,
                        0.54489193530091
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2106,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0003051896392955021,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.0910872519,
                        0.54512795901583
                    ],
                    [
                        122.09137693048,
                        0.54503810907999
                    ],
                    [
                        122.09137827158,
                        0.54503676803615
                    ],
                    [
                        122.09137827158,
                        0.54503676803615
                    ],
                    [
                        122.09137827158,
                        0.54503676803615
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2107,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00022088855904128798,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09108322859,
                        0.54512795901583
                    ],
                    [
                        122.09108322859,
                        0.54512661797202
                    ],
                    [
                        122.09087669849,
                        0.54516550824235
                    ],
                    [
                        122.09086731076,
                        0.54516550824235
                    ],
                    [
                        122.09086731076,
                        0.54516550824235
                    ],
                    [
                        122.09086731076,
                        0.54516550824235
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2108,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00037432775775070944,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09084719419,
                        0.54432065058902
                    ],
                    [
                        122.09118112922,
                        0.54421470811301
                    ],
                    [
                        122.09120258689,
                        0.54420397976092
                    ],
                    [
                        122.09120258689,
                        0.54420397976092
                    ],
                    [
                        122.09120258689,
                        0.54420397976092
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2109,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0023809706432119707,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09437295794,
                        0.55934702958439
                    ],
                    [
                        122.09431797266,
                        0.55935775790918
                    ],
                    [
                        122.09429651499,
                        0.55924242841659
                    ],
                    [
                        122.09428712726,
                        0.55911771163719
                    ],
                    [
                        122.09427505732,
                        0.55900506422124
                    ],
                    [
                        122.09427505732,
                        0.55883743413399
                    ],
                    [
                        122.0943582058,
                        0.55862152657458
                    ],
                    [
                        122.09443733096,
                        0.55850619706754
                    ],
                    [
                        122.09453120828,
                        0.55841366525211
                    ],
                    [
                        122.09453389049,
                        0.55837611610921
                    ],
                    [
                        122.09452316165,
                        0.55833052072106
                    ],
                    [
                        122.09446415305,
                        0.55819239351366
                    ],
                    [
                        122.09446951747,
                        0.55808779232533
                    ],
                    [
                        122.09447622299,
                        0.5579416188667
                    ],
                    [
                        122.09448561072,
                        0.55776996562625
                    ],
                    [
                        122.09452584386,
                        0.5571302890533
                    ],
                    [
                        122.09452584386,
                        0.5571302890533
                    ],
                    [
                        122.09452584386,
                        0.5571302890533
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2110,
                "jenis_pipa": "Pipa 25",
                "keterangan": "",
                "panjang": 0.0015785937592366706,
                "total_panjang_jenis": 0.03653229443776634
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09419459105,
                        0.55762245111873
                    ],
                    [
                        122.09445208311,
                        0.55759026613479
                    ],
                    [
                        122.09481418133,
                        0.55760635862678
                    ],
                    [
                        122.09484905005,
                        0.55758490197077
                    ],
                    [
                        122.09486916661,
                        0.55756344531469
                    ],
                    [
                        122.09487989545,
                        0.5575138267972
                    ],
                    [
                        122.09491074085,
                        0.55720672839587
                    ],
                    [
                        122.09491074085,
                        0.55717186132744
                    ],
                    [
                        122.09494024515,
                        0.55714772258766
                    ],
                    [
                        122.0949831605,
                        0.55715308675206
                    ],
                    [
                        122.09539353848,
                        0.55716783820417
                    ],
                    [
                        122.09539353848,
                        0.55716783820417
                    ],
                    [
                        122.09539353848,
                        0.55716783820417
                    ],
                    [
                        122.09539353848,
                        0.55716783820417
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2111,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.00597700542831692,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09242165089,
                        0.5474747852228
                    ],
                    [
                        122.09243506193,
                        0.5474640568765
                    ],
                    [
                        122.09250748158,
                        0.54766119023647
                    ],
                    [
                        122.09262683988,
                        0.54800717938321
                    ],
                    [
                        122.09271535277,
                        0.54826197757925
                    ],
                    [
                        122.09288969636,
                        0.54879705375565
                    ],
                    [
                        122.09310427308,
                        0.54947159834092
                    ],
                    [
                        122.09319546819,
                        0.54972639647459
                    ],
                    [
                        122.0932303369,
                        0.5498631828366
                    ],
                    [
                        122.09331080318,
                        0.55009116009964
                    ],
                    [
                        122.09344357252,
                        0.55045190057455
                    ],
                    [
                        122.09354415536,
                        0.55072949638984
                    ],
                    [
                        122.09364205599,
                        0.55094138110972
                    ],
                    [
                        122.09381505847,
                        0.55120556647774
                    ],
                    [
                        122.09396526217,
                        0.55143890785905
                    ],
                    [
                        122.09421604872,
                        0.55183719743701
                    ],
                    [
                        122.09433406591,
                        0.55203701273715
                    ],
                    [
                        122.09443062544,
                        0.55220464301729
                    ],
                    [
                        122.0946854353,
                        0.55263511755509
                    ],
                    [
                        122.09484502673,
                        0.55287382304857
                    ],
                    [
                        122.09484502673,
                        0.55287382304857
                    ],
                    [
                        122.09484502673,
                        0.55287382304857
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2112,
                "jenis_pipa": "Pipa 50",
                "keterangan": "",
                "panjang": 0.0001904405976938144,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09322363138,
                        0.54984440823808
                    ],
                    [
                        122.09304392338,
                        0.54990743724715
                    ],
                    [
                        122.09304392338,
                        0.54990743724715
                    ],
                    [
                        122.09304392338,
                        0.54990743724715
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2113,
                "jenis_pipa": "Pipa 40",
                "keterangan": "",
                "panjang": 0.00013330911095533714,
                "total_panjang_jenis": 0.10090846422908124
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09303990006,
                        0.54990609620443
                    ],
                    [
                        122.09291785955,
                        0.54995973791377
                    ],
                    [
                        122.09291785955,
                        0.54995973791377
                    ],
                    [
                        122.09291785955,
                        0.54995973791377
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2114,
                "jenis_pipa": "Pipa 100",
                "keterangan": "",
                "panjang": 0.00080224978590293,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        122.09291517735,
                        0.54995839687104
                    ],
                    [
                        122.0921869576,
                        0.55029499858629
                    ],
                    [
                        122.0921869576,
                        0.55029499858629
                    ],
                    [
                        122.0921869576,
                        0.55029499858629
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2162,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.001755746593447316,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.68890923209,
                        0.51665377871158
                    ],
                    [
                        121.68887435317,
                        0.51669135107702
                    ],
                    [
                        121.68880191232,
                        0.51668598359626
                    ],
                    [
                        121.68865837211,
                        0.51667122302413
                    ],
                    [
                        121.68840348764,
                        0.51664572749039
                    ],
                    [
                        121.68806140585,
                        0.51661754821614
                    ],
                    [
                        121.68756102739,
                        0.51656521527789
                    ],
                    [
                        121.68717870068,
                        0.51651959169035
                    ],
                    [
                        121.68717870068,
                        0.51651959169035
                    ],
                    [
                        121.68717870068,
                        0.51651959169035
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2163,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0018356595040014186,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.6881753585,
                        0.52201308462273
                    ],
                    [
                        121.68758509972,
                        0.5219808797652
                    ],
                    [
                        121.68747777995,
                        0.52322076666095
                    ],
                    [
                        121.68747777995,
                        0.52322076666095
                    ],
                    [
                        121.68747777995,
                        0.52322076666095
                    ],
                    [
                        121.68747777995,
                        0.52322076666095
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2164,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0012069664743471018,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.68747916818,
                        0.52321928043462
                    ],
                    [
                        121.68736247795,
                        0.52362558369509
                    ],
                    [
                        121.68721366326,
                        0.52378792192036
                    ],
                    [
                        121.68709026004,
                        0.52391535679265
                    ],
                    [
                        121.68681533087,
                        0.52389786820861
                    ],
                    [
                        121.68670511918,
                        0.52388356943337
                    ],
                    [
                        121.68670511918,
                        0.52388356943337
                    ],
                    [
                        121.68670511918,
                        0.52388356943337
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2165,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0052987463853093695,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.69332944461,
                        0.52936858804851
                    ],
                    [
                        121.6933361521,
                        0.52937395551841
                    ],
                    [
                        121.69360311004,
                        0.52939810913298
                    ],
                    [
                        121.69365542843,
                        0.52939810913298
                    ],
                    [
                        121.69383116457,
                        0.52967319195893
                    ],
                    [
                        121.69409007353,
                        0.53010124764913
                    ],
                    [
                        121.69422556475,
                        0.53036156990393
                    ],
                    [
                        121.69442410634,
                        0.53077083940612
                    ],
                    [
                        121.69458508601,
                        0.53107946884887
                    ],
                    [
                        121.69480911604,
                        0.53150618257476
                    ],
                    [
                        121.69490972833,
                        0.53171014635787
                    ],
                    [
                        121.69510961142,
                        0.53207110856275
                    ],
                    [
                        121.69530144552,
                        0.53241328461109
                    ],
                    [
                        121.69546376668,
                        0.53266287183435
                    ],
                    [
                        121.69556437897,
                        0.53277022117461
                    ],
                    [
                        121.69570255319,
                        0.53289635664699
                    ],
                    [
                        121.69590646077,
                        0.53304798758379
                    ],
                    [
                        121.69644440115,
                        0.53340626597712
                    ],
                    [
                        121.69644440115,
                        0.53340626597712
                    ],
                    [
                        121.69644440115,
                        0.53340626597712
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2166,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.004229392860106755,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.77606450848,
                        0.51600875086108
                    ],
                    [
                        121.77576937909,
                        0.51586382886333
                    ],
                    [
                        121.77536692993,
                        0.51561155722975
                    ],
                    [
                        121.77458349555,
                        0.51517142371747
                    ],
                    [
                        121.7738376231,
                        0.51472592269239
                    ],
                    [
                        121.77307565268,
                        0.51421064435949
                    ],
                    [
                        121.77245319797,
                        0.51381345061617
                    ],
                    [
                        121.77245319797,
                        0.51381345061617
                    ],
                    [
                        121.77245319797,
                        0.51381345061617
                    ],
                    [
                        121.77245319797,
                        0.51381345061617
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2168,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 0.0018142348921132757,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.7814304357,
                        0.52285544368911
                    ],
                    [
                        121.78159007386,
                        0.52298157936259
                    ],
                    [
                        121.78171080861,
                        0.52312918493474
                    ],
                    [
                        121.78187178828,
                        0.52334925141767
                    ],
                    [
                        121.78208911083,
                        0.52366861617795
                    ],
                    [
                        121.78223265103,
                        0.52386989648067
                    ],
                    [
                        121.78231448236,
                        0.52397456223554
                    ],
                    [
                        121.78240436268,
                        0.5240671511711
                    ],
                    [
                        121.782488877,
                        0.52412887712736
                    ],
                    [
                        121.78261229474,
                        0.52420938924332
                    ],
                    [
                        121.78261229474,
                        0.52420938924332
                    ],
                    [
                        121.78261229474,
                        0.52420938924332
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2169,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0003709920228478859,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80293083937,
                        0.52756830934119
                    ],
                    [
                        121.80266660094,
                        0.52750148907819
                    ],
                    [
                        121.80257269614,
                        0.5274719679847
                    ],
                    [
                        121.80257269614,
                        0.5274719679847
                    ],
                    [
                        121.80257269614,
                        0.5274719679847
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2170,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.0015920210523706017,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.80255461655,
                        0.52745776928356
                    ],
                    [
                        121.80230778107,
                        0.52734907798333
                    ],
                    [
                        121.80201935916,
                        0.52722294239796
                    ],
                    [
                        121.80170276582,
                        0.52708875560219
                    ],
                    [
                        121.80139153847,
                        0.52695725253956
                    ],
                    [
                        121.80109909207,
                        0.52681367266187
                    ],
                    [
                        121.80109909207,
                        0.52681367266187
                    ],
                    [
                        121.80109909207,
                        0.52681367266187
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2173,
                "jenis_pipa": "Pipa 50",
                "keterangan": "Distribusi",
                "panjang": 6.044978545638435e-5,
                "total_panjang_jenis": 1.8796675423065135
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81169961997,
                        0.49026262313038
                    ],
                    [
                        121.81170230297,
                        0.49020760622936
                    ],
                    [
                        121.81170230297,
                        0.49021297373194
                    ],
                    [
                        121.81170230297,
                        0.49021297373194
                    ],
                    [
                        121.81170230297,
                        0.49021297373194
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2174,
                "jenis_pipa": "Pipa 100",
                "keterangan": "Distribusi",
                "panjang": 0.0006109203978770942,
                "total_panjang_jenis": 1.0325872895257715
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81235701998,
                        0.49586202417655
                    ],
                    [
                        121.81240438904,
                        0.49641028159426
                    ],
                    [
                        121.81240975268,
                        0.49647066430109
                    ]
                ]
            }
        },
        {
            "type": "Feature",
            "properties": {
                "id": 2175,
                "jenis_pipa": "Pipa 75",
                "keterangan": "Distribusi",
                "panjang": 0.03380829458500467,
                "total_panjang_jenis": 0.9951924316443062
            },
            "geometry": {
                "type": "LineString",
                "coordinates": [
                    [
                        121.81241290064,
                        0.49648302660583
                    ],
                    [
                        121.81245180406,
                        0.49681715331671
                    ],
                    [
                        121.8124799755,
                        0.4970976050409
                    ],
                    [
                        121.81253363539,
                        0.49768802968446
                    ],
                    [
                        121.81254302587,
                        0.49788125955635
                    ],
                    [
                        121.81255107485,
                        0.49830529175533
                    ],
                    [
                        121.81253900138,
                        0.49856964092886
                    ],
                    [
                        121.81251753742,
                        0.49893597250713
                    ],
                    [
                        121.81250143946,
                        0.49935463714302
                    ],
                    [
                        121.812481317,
                        0.49987796790041
                    ],
                    [
                        121.81245314556,
                        0.50036238428225
                    ],
                    [
                        121.81242497412,
                        0.50093804802466
                    ],
                    [
                        121.81239277818,
                        0.50127083263591
                    ],
                    [
                        121.81235521626,
                        0.50165997590991
                    ],
                    [
                        121.81230558086,
                        0.50209742659714
                    ],
                    [
                        121.81226131145,
                        0.50248656982193
                    ],
                    [
                        121.81220094408,
                        0.50290120861181
                    ],
                    [
                        121.81211240526,
                        0.50341648784796
                    ],
                    [
                        121.81205603293,
                        0.5038006129145
                    ],
                    [
                        121.81198627507,
                        0.50430784084291
                    ],
                    [
                        121.81197017711,
                        0.50466477899106
                    ],
                    [
                        121.81195810363,
                        0.50502842648276
                    ],
                    [
                        121.81193798117,
                        0.50551955184515
                    ],
                    [
                        121.81193932267,
                        0.50593553231431
                    ],
                    [
                        121.81191920021,
                        0.50648301624596
                    ],
                    [
                        121.81189907775,
                        0.50703720949242
                    ],
                    [
                        121.81188700428,
                        0.50739414749044
                    ],
                    [
                        121.81189237027,
                        0.50774840172467
                    ],
                    [
                        121.81188834577,
                        0.50827307367984
                    ],
                    [
                        121.81188834577,
                        0.50876688253987
                    ],
                    [
                        121.81188432128,
                        0.50927142633609
                    ],
                    [
                        121.81189371176,
                        0.50955858688333
                    ],
                    [
                        121.81185480834,
                        0.50994772966058
                    ],
                    [
                        121.81177315648,
                        0.51029133408464
                    ],
                    [
                        121.81165514086,
                        0.51074729315723
                    ],
                    [
                        121.81154916258,
                        0.51112570089167
                    ],
                    [
                        121.81142306184,
                        0.51160877456284
                    ],
                    [
                        121.81131842506,
                        0.51197913101943
                    ],
                    [
                        121.81120981287,
                        0.5123579061374
                    ],
                    [
                        121.81105825157,
                        0.51295338273658
                    ],
                    [
                        121.81088653992,
                        0.51362431818974
                    ],
                    [
                        121.81080474551,
                        0.51393363171316
                    ],
                    [
                        121.81074303663,
                        0.51416845909377
                    ],
                    [
                        121.81057266649,
                        0.51475083096039
                    ],
                    [
                        121.81047876168,
                        0.51512387097604
                    ],
                    [
                        121.81041571131,
                        0.51540834752005
                    ],
                    [
                        121.81032985549,
                        0.51581493425667
                    ],
                    [
                        121.81023997518,
                        0.51628593074088
                    ],
                    [
                        121.81015832371,
                        0.51675252100034
                    ],
                    [
                        121.81008454136,
                        0.51714837269026
                    ],
                    [
                        121.81003356447,
                        0.51747444711461
                    ],
                    [
                        121.80994100116,
                        0.51807292111733
                    ],
                    [
                        121.80988063379,
                        0.51850634507951
                    ],
                    [
                        121.80979746096,
                        0.51907932346077
                    ],
                    [
                        121.809775997,
                        0.51928731325845
                    ],
                    [
                        121.80980148545,
                        0.51933830430459
                    ],
                    [
                        121.80985380384,
                        0.51938124413257
                    ],
                    [
                        121.80998661207,
                        0.51939734656802
                    ],
                    [
                        121.81024954552,
                        0.51943089330834
                    ],
                    [
                        121.81056479737,
                        0.51946444004849
                    ],
                    [
                        121.81093773359,
                        0.51951811483241
                    ],
                    [
                        121.81140457462,
                        0.51957715709413
                    ],
                    [
                        121.81169567952,
                        0.51962278065965
                    ],
                    [
                        121.8120444688,
                        0.51968853226821
                    ],
                    [
                        121.8123798431,
                        0.51973952331109
                    ],
                    [
                        121.81290168552,
                        0.51983613791755
                    ],
                    [
                        121.81310827609,
                        0.51988444522023
                    ],
                    [
                        121.81345169938,
                        0.51995019682604
                    ],
                    [
                        121.81378841518,
                        0.52002802525656
                    ],
                    [
                        121.81393463838,
                        0.52004949516825
                    ],
                    [
                        121.81398024928,
                        0.52006828134091
                    ],
                    [
                        121.81395744383,
                        0.5201380585532
                    ],
                    [
                        121.8139225649,
                        0.52030713410284
                    ],
                    [
                        121.81390378394,
                        0.520398381223
                    ],
                    [
                        121.81380317165,
                        0.52095391513194
                    ],
                    [
                        121.81372402331,
                        0.52141417628024
                    ],
                    [
                        121.81365694845,
                        0.5218596768349
                    ],
                    [
                        121.81355410007,
                        0.52254578857241
                    ],
                    [
                        121.81350312318,
                        0.523042280063
                    ],
                    [
                        121.81346421976,
                        0.52340190090195
                    ],
                    [
                        121.81342799933,
                        0.52382324767955
                    ],
                    [
                        121.81338372992,
                        0.52441501173655
                    ],
                    [
                        121.81335555848,
                        0.52489405878935
                    ],
                    [
                        121.81333148811,
                        0.52549083670661
                    ],
                    [
                        121.81331404865,
                        0.52600879785499
                    ],
                    [
                        121.81329795068,
                        0.52642880258883
                    ],
                    [
                        121.81329795068,
                        0.52642880258883
                    ],
                    [
                        121.81329795068,
                        0.52642880258883
                    ],
                    [
                        121.81329795068,
                        0.52642880258883
                    ]
                ]
            }
        }
    ]
}